// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28126.75, 132.75, 225.75%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%233ac47d%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23d92550%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23d92550%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2873, 80, 87, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23495057%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%2833.6, 36.8, 86.4%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28152.4, 157.2, 231.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./utils/images/logo-inverse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./utils/images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./components/icons/linearicons/Linearicons-Free.eot?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./components/icons/linearicons/Linearicons-Free.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./components/icons/linearicons/Linearicons-Free.woff2?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./components/icons/linearicons/Linearicons-Free.woff?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./components/icons/linearicons/Linearicons-Free.ttf?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./components/icons/linearicons/Linearicons-Free.svg?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefixw118d" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#Linearicons-Free" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___, { hash: "?#iefixd7yf1v" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___, { hash: "#Pe-icon-7-stroke" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* NOTE: bootstrap/ is loaded from node_modules/ using sass-loader */
.border-primary {
  border-color: #545cd8;
}

.border-secondary {
  border-color: #6c757d;
}

.border-success {
  border-color: #3ac47d;
}

.border-info {
  border-color: #30b1ff;
}

.border-warning {
  border-color: #f7b924;
}

.border-danger {
  border-color: #d92550;
}

.border-light {
  border-color: #eeeeee;
}

.border-dark {
  border-color: #343a40;
}

.border-focus {
  border-color: #444054;
}

.border-alternate {
  border-color: #83588a;
}

:root,
[data-bs-theme=light] {
  --bs-blue: #86c6fb;
  --bs-indigo: #444054;
  --bs-purple: #83588a;
  --bs-pink: #f65ca2;
  --bs-red: #d92550;
  --bs-orange: #fd7e14;
  --bs-yellow: #f7b924;
  --bs-green: #3ac47d;
  --bs-teal: #16E0BD;
  --bs-cyan: #30b1ff;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #545cd8;
  --bs-secondary: #6c757d;
  --bs-success: #3ac47d;
  --bs-info: #30b1ff;
  --bs-warning: #f7b924;
  --bs-danger: #d92550;
  --bs-light: #eeeeee;
  --bs-dark: #343a40;
  --bs-focus: #444054;
  --bs-alternate: #83588a;
  --bs-primary-rgb: 84, 92, 216;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 58, 196, 125;
  --bs-info-rgb: 48, 177, 255;
  --bs-warning-rgb: 247, 185, 36;
  --bs-danger-rgb: 217, 37, 80;
  --bs-light-rgb: 238, 238, 238;
  --bs-dark-rgb: 52, 58, 64;
  --bs-focus-rgb: 68, 64, 84;
  --bs-alternate-rgb: 131, 88, 138;
  --bs-primary-text-emphasis: rgb(33.6, 36.8, 86.4);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(23.2, 78.4, 50);
  --bs-info-text-emphasis: rgb(19.2, 70.8, 102);
  --bs-warning-text-emphasis: rgb(98.8, 74, 14.4);
  --bs-danger-text-emphasis: rgb(86.8, 14.8, 32);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(220.8, 222.4, 247.2);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(215.6, 243.2, 229);
  --bs-info-bg-subtle: rgb(213.6, 239.4, 255);
  --bs-warning-bg-subtle: rgb(253.4, 241, 211.2);
  --bs-danger-bg-subtle: rgb(247.4, 211.4, 220);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(186.6, 189.8, 239.4);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(176.2, 231.4, 203);
  --bs-info-border-subtle: rgb(172.2, 223.8, 255);
  --bs-warning-border-subtle: rgb(251.8, 227, 167.4);
  --bs-danger-border-subtle: rgb(239.8, 167.8, 185);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.88rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #495057;
  --bs-body-color-rgb: 73, 80, 87;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(73, 80, 87, 0.75);
  --bs-secondary-color-rgb: 73, 80, 87;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(73, 80, 87, 0.5);
  --bs-tertiary-color-rgb: 73, 80, 87;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #545cd8;
  --bs-link-color-rgb: 84, 92, 216;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(67.2, 73.6, 172.8);
  --bs-link-hover-color-rgb: 67, 74, 173;
  --bs-code-color: #f65ca2;
  --bs-highlight-color: #495057;
  --bs-highlight-bg: rgb(253.4, 241, 211.2);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(84, 92, 216, 0.25);
  --bs-form-valid-color: #3ac47d;
  --bs-form-valid-border-color: #3ac47d;
  --bs-form-invalid-color: #d92550;
  --bs-form-invalid-border-color: #d92550;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(152.4, 157.2, 231.6);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(136.8, 219.6, 177);
  --bs-info-text-emphasis: rgb(130.8, 208.2, 255);
  --bs-warning-text-emphasis: rgb(250.2, 213, 123.6);
  --bs-danger-text-emphasis: rgb(232.2, 124.2, 150);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(16.8, 18.4, 43.2);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(11.6, 39.2, 25);
  --bs-info-bg-subtle: rgb(9.6, 35.4, 51);
  --bs-warning-bg-subtle: rgb(49.4, 37, 7.2);
  --bs-danger-bg-subtle: rgb(43.4, 7.4, 16);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(50.4, 55.2, 129.6);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(34.8, 117.6, 75);
  --bs-info-border-subtle: rgb(28.8, 106.2, 153);
  --bs-warning-border-subtle: rgb(148.2, 111, 21.6);
  --bs-danger-border-subtle: rgb(130.2, 22.2, 48);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(152.4, 157.2, 231.6);
  --bs-link-hover-color: rgb(172.92, 176.76, 236.28);
  --bs-link-color-rgb: 152, 157, 232;
  --bs-link-hover-color-rgb: 173, 177, 236;
  --bs-code-color: rgb(249.6, 157.2, 199.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(98.8, 74, 14.4);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(136.8, 219.6, 177);
  --bs-form-valid-border-color: rgb(136.8, 219.6, 177);
  --bs-form-invalid-color: rgb(232.2, 124.2, 150);
  --bs-form-invalid-border-color: rgb(232.2, 124.2, 150);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-body-font-family);
  font-size: 0.88rem;
  font-size: var(--bs-body-font-size);
  font-weight: 400;
  font-weight: var(--bs-body-font-weight);
  line-height: 1.5;
  line-height: var(--bs-body-line-height);
  color: #495057;
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 400;
  line-height: 1.2;
  color: inherit;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.345rem + 1.14vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.2rem;
  }
}

h2, .h2 {
  font-size: calc(1.301rem + 0.612vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.76rem;
  }
}

h3, .h3 {
  font-size: calc(1.279rem + 0.348vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.54rem;
  }
}

h4, .h4 {
  font-size: calc(1.257rem + 0.084vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.32rem;
  }
}

h5, .h5 {
  font-size: 1.1rem;
}

h6, .h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: #495057;
  color: var(--bs-highlight-color);
  background-color: rgb(253.4, 241, 211.2);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(84, 92, 216, 1);
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #f65ca2;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: #fff;
  color: var(--bs-body-bg);
  background-color: #495057;
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
}

.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: #e9ecef;
  --bs-table-accent-bg: rgba(0, 0, 0, 0.03);
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: #e0f3ff;
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: #e0f3ff;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color);
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(220.8, 222.4, 247.2);
  --bs-table-border-color: rgb(176.64, 177.92, 197.76);
  --bs-table-striped-bg: rgb(209.76, 211.28, 234.84);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198.72, 200.16, 222.48);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(204.24, 205.72, 228.66);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(215.6, 243.2, 229);
  --bs-table-border-color: rgb(172.48, 194.56, 183.2);
  --bs-table-striped-bg: rgb(204.82, 231.04, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(194.04, 218.88, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(199.43, 224.96, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(213.6, 239.4, 255);
  --bs-table-border-color: rgb(170.88, 191.52, 204);
  --bs-table-striped-bg: rgb(202.92, 227.43, 242.25);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(192.24, 215.46, 229.5);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(197.58, 221.445, 235.875);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(253.4, 241, 211.2);
  --bs-table-border-color: rgb(202.72, 192.8, 168.96);
  --bs-table-striped-bg: rgb(240.73, 228.95, 200.64);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(228.06, 216.9, 190.08);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(234.395, 222.925, 195.36);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(247.4, 211.4, 220);
  --bs-table-border-color: rgb(197.92, 169.12, 176);
  --bs-table-striped-bg: rgb(235.03, 200.83, 209);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(222.66, 190.26, 198);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(228.845, 195.545, 203.5);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #eeeeee;
  --bs-table-border-color: rgb(190.4, 190.4, 190.4);
  --bs-table-striped-bg: rgb(226.1, 226.1, 226.1);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(214.2, 214.2, 214.2);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(220.15, 220.15, 220.15);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #343a40;
  --bs-table-border-color: rgb(92.6, 97.4, 102.2);
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.968rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  color: var(--bs-body-color);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border-color: rgb(126.75, 132.75, 225.75);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  color: var(--bs-body-color);
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  -webkit-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  color: var(--bs-body-color);
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(1px * 2));
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(1px * 2));
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(1px * 2));
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(1px * 2));
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), none;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(126.75, 132.75, 225.75);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.1rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(126.75, 132.75, 225.75);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-check-input:checked {
  background-color: #545cd8;
  border-color: #545cd8;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #545cd8;
  border-color: #545cd8;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  -webkit-appearance: none;
          appearance: none;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: rgba(73, 80, 87, 0.75);
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: rgba(73, 80, 87, 0.75);
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(1px * 2));
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(1px * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(73, 80, 87, 0.65);
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: rgb(224.93, 243.36, 255);
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #3ac47d;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #fff;
  background-color: #3ac47d;
  background-color: var(--bs-success);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #3ac47d;
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #3ac47d;
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #3ac47d;
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #3ac47d;
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #3ac47d;
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #3ac47d;
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #3ac47d;
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #d92550;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #fff;
  background-color: #d92550;
  background-color: var(--bs-danger);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #d92550;
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #d92550;
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #d92550;
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #d92550;
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #d92550;
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #d92550;
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #d92550;
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.88rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0 rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #545cd8;
  --bs-btn-border-color: #545cd8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(71.4, 78.2, 183.6);
  --bs-btn-hover-border-color: rgb(67.2, 73.6, 172.8);
  --bs-btn-focus-shadow-rgb: 110, 116, 222;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(67.2, 73.6, 172.8);
  --bs-btn-active-border-color: #3f45a2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #545cd8;
  --bs-btn-disabled-border-color: #545cd8;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #3ac47d;
  --bs-btn-border-color: #3ac47d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(87.55, 204.85, 144.5);
  --bs-btn-hover-border-color: rgb(77.7, 201.9, 138);
  --bs-btn-focus-shadow-rgb: 49, 167, 106;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(97.4, 207.8, 151);
  --bs-btn-active-border-color: rgb(77.7, 201.9, 138);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #3ac47d;
  --bs-btn-disabled-border-color: #3ac47d;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #30b1ff;
  --bs-btn-border-color: #30b1ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(79.05, 188.7, 255);
  --bs-btn-hover-border-color: rgb(68.7, 184.8, 255);
  --bs-btn-focus-shadow-rgb: 41, 150, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(89.4, 192.6, 255);
  --bs-btn-active-border-color: rgb(68.7, 184.8, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #30b1ff;
  --bs-btn-disabled-border-color: #30b1ff;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #f7b924;
  --bs-btn-border-color: #f7b924;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(248.2, 195.5, 68.85);
  --bs-btn-hover-border-color: rgb(247.8, 192, 57.9);
  --bs-btn-focus-shadow-rgb: 210, 157, 31;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(248.6, 199, 79.8);
  --bs-btn-active-border-color: rgb(247.8, 192, 57.9);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f7b924;
  --bs-btn-disabled-border-color: #f7b924;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #d92550;
  --bs-btn-border-color: #d92550;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(184.45, 31.45, 68);
  --bs-btn-hover-border-color: rgb(173.6, 29.6, 64);
  --bs-btn-focus-shadow-rgb: 223, 70, 106;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(173.6, 29.6, 64);
  --bs-btn-active-border-color: rgb(162.75, 27.75, 60);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d92550;
  --bs-btn-disabled-border-color: #d92550;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eeeeee;
  --bs-btn-border-color: #eeeeee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(202.3, 202.3, 202.3);
  --bs-btn-hover-border-color: rgb(190.4, 190.4, 190.4);
  --bs-btn-focus-shadow-rgb: 202, 202, 202;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(190.4, 190.4, 190.4);
  --bs-btn-active-border-color: rgb(178.5, 178.5, 178.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eeeeee;
  --bs-btn-disabled-border-color: #eeeeee;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);
  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);
  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-focus {
  --bs-btn-color: #fff;
  --bs-btn-bg: #444054;
  --bs-btn-border-color: #444054;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(57.8, 54.4, 71.4);
  --bs-btn-hover-border-color: rgb(54.4, 51.2, 67.2);
  --bs-btn-focus-shadow-rgb: 96, 93, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(54.4, 51.2, 67.2);
  --bs-btn-active-border-color: #33303f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #444054;
  --bs-btn-disabled-border-color: #444054;
}

.btn-alternate {
  --bs-btn-color: #fff;
  --bs-btn-bg: #83588a;
  --bs-btn-border-color: #83588a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(111.35, 74.8, 117.3);
  --bs-btn-hover-border-color: rgb(104.8, 70.4, 110.4);
  --bs-btn-focus-shadow-rgb: 150, 113, 156;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(104.8, 70.4, 110.4);
  --bs-btn-active-border-color: rgb(98.25, 66, 103.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #83588a;
  --bs-btn-disabled-border-color: #83588a;
}

.btn-outline-primary {
  --bs-btn-color: #545cd8;
  --bs-btn-border-color: #545cd8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #545cd8;
  --bs-btn-hover-border-color: #545cd8;
  --bs-btn-focus-shadow-rgb: 84, 92, 216;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #545cd8;
  --bs-btn-active-border-color: #545cd8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #545cd8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #545cd8;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #3ac47d;
  --bs-btn-border-color: #3ac47d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3ac47d;
  --bs-btn-hover-border-color: #3ac47d;
  --bs-btn-focus-shadow-rgb: 58, 196, 125;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3ac47d;
  --bs-btn-active-border-color: #3ac47d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3ac47d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3ac47d;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #30b1ff;
  --bs-btn-border-color: #30b1ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #30b1ff;
  --bs-btn-hover-border-color: #30b1ff;
  --bs-btn-focus-shadow-rgb: 48, 177, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #30b1ff;
  --bs-btn-active-border-color: #30b1ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #30b1ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #30b1ff;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #f7b924;
  --bs-btn-border-color: #f7b924;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f7b924;
  --bs-btn-hover-border-color: #f7b924;
  --bs-btn-focus-shadow-rgb: 247, 185, 36;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f7b924;
  --bs-btn-active-border-color: #f7b924;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f7b924;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f7b924;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #d92550;
  --bs-btn-border-color: #d92550;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d92550;
  --bs-btn-hover-border-color: #d92550;
  --bs-btn-focus-shadow-rgb: 217, 37, 80;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #d92550;
  --bs-btn-active-border-color: #d92550;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d92550;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d92550;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eeeeee;
  --bs-btn-border-color: #eeeeee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eeeeee;
  --bs-btn-hover-border-color: #eeeeee;
  --bs-btn-focus-shadow-rgb: 238, 238, 238;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eeeeee;
  --bs-btn-active-border-color: #eeeeee;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eeeeee;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eeeeee;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-outline-focus {
  --bs-btn-color: #444054;
  --bs-btn-border-color: #444054;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #444054;
  --bs-btn-hover-border-color: #444054;
  --bs-btn-focus-shadow-rgb: 68, 64, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #444054;
  --bs-btn-active-border-color: #444054;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #444054;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #444054;
  --bs-gradient: none;
}

.btn-outline-alternate {
  --bs-btn-color: #83588a;
  --bs-btn-border-color: #83588a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #83588a;
  --bs-btn-hover-border-color: #83588a;
  --bs-btn-focus-shadow-rgb: 131, 88, 138;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #83588a;
  --bs-btn-active-border-color: #83588a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #83588a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #83588a;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 110, 116, 222;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.968rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 15rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.65rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.88rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: #e0f3ff;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #545cd8;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.4rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.65rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.968rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #545cd8;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * 1px);
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #545cd8;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.335rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.1rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.1rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: 1px solid var(--bs-navbar-toggler-border-color);
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: rgba(63, 69, 162, 0.125);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: #fff;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: #495057;
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.88rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: "/" /* rtl: var(--bs-breadcrumb-divider, "/") */;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.88rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #545cd8;
  --bs-pagination-active-border-color: #545cd8;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link, .pagination .page-number:not(:first-child) .page-link {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.1rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.968rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-focus {
  --bs-alert-color: var(--bs-focus-text-emphasis);
  --bs-alert-bg: var(--bs-focus-bg-subtle);
  --bs-alert-border-color: var(--bs-focus-border-subtle);
  --bs-alert-link-color: var(--bs-focus-text-emphasis);
}

.alert-alternate {
  --bs-alert-color: var(--bs-alternate-text-emphasis);
  --bs-alert-bg: var(--bs-alternate-bg-subtle);
  --bs-alert-border-color: var(--bs-alternate-border-subtle);
  --bs-alert-link-color: var(--bs-alternate-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.66rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #545cd8;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: rgba(84, 92, 216, 0.08);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #545cd8;
  --bs-list-group-active-border-color: #545cd8;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-focus {
  --bs-list-group-color: var(--bs-focus-text-emphasis);
  --bs-list-group-bg: var(--bs-focus-bg-subtle);
  --bs-list-group-border-color: var(--bs-focus-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-focus-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-focus-border-subtle);
  --bs-list-group-active-color: var(--bs-focus-bg-subtle);
  --bs-list-group-active-bg: var(--bs-focus-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-focus-text-emphasis);
}

.list-group-item-alternate {
  --bs-list-group-color: var(--bs-alternate-text-emphasis);
  --bs-list-group-bg: var(--bs-alternate-bg-subtle);
  --bs-list-group-border-color: var(--bs-alternate-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-alternate-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-alternate-border-subtle);
  --bs-list-group-active-color: var(--bs-alternate-bg-subtle);
  --bs-list-group-active-bg: var(--bs-alternate-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-alternate-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter:  ;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.968rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 320px;
  --bs-popover-font-size: 0.968rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: rgba(63, 69, 162, 0.125);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.88rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: #fff;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter:  ;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(84, 92, 216, 1) !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, 1) !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000 !important;
  background-color: RGBA(58, 196, 125, 1) !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(48, 177, 255, 1) !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(247, 185, 36, 1) !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(217, 37, 80, 1) !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(238, 238, 238, 1) !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(52, 58, 64, 1) !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-focus {
  color: #fff !important;
  background-color: RGBA(68, 64, 84, 1) !important;
  background-color: RGBA(var(--bs-focus-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-alternate {
  color: #fff !important;
  background-color: RGBA(131, 88, 138, 1) !important;
  background-color: RGBA(var(--bs-alternate-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(84, 92, 216, 1) !important;
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(84, 92, 216, 1) !important;
          text-decoration-color: RGBA(84, 92, 216, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(67, 74, 173, 1) !important;
  color: RGBA(67, 74, 173, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(67, 74, 173, 1) !important;
          text-decoration-color: RGBA(67, 74, 173, 1) !important;
  -webkit-text-decoration-color: RGBA(67, 74, 173, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(67, 74, 173, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(108, 117, 125, 1) !important;
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(108, 117, 125, 1) !important;
          text-decoration-color: RGBA(108, 117, 125, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, 1) !important;
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, 1) !important;
          text-decoration-color: RGBA(86, 94, 100, 1) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(58, 196, 125, 1) !important;
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(58, 196, 125, 1) !important;
          text-decoration-color: RGBA(58, 196, 125, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(97, 208, 151, 1) !important;
  color: RGBA(97, 208, 151, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(97, 208, 151, 1) !important;
          text-decoration-color: RGBA(97, 208, 151, 1) !important;
  -webkit-text-decoration-color: RGBA(97, 208, 151, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(97, 208, 151, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(48, 177, 255, 1) !important;
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(48, 177, 255, 1) !important;
          text-decoration-color: RGBA(48, 177, 255, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(89, 193, 255, 1) !important;
  color: RGBA(89, 193, 255, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(89, 193, 255, 1) !important;
          text-decoration-color: RGBA(89, 193, 255, 1) !important;
  -webkit-text-decoration-color: RGBA(89, 193, 255, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(89, 193, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(247, 185, 36, 1) !important;
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(247, 185, 36, 1) !important;
          text-decoration-color: RGBA(247, 185, 36, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(249, 199, 80, 1) !important;
  color: RGBA(249, 199, 80, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(249, 199, 80, 1) !important;
          text-decoration-color: RGBA(249, 199, 80, 1) !important;
  -webkit-text-decoration-color: RGBA(249, 199, 80, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(249, 199, 80, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(217, 37, 80, 1) !important;
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(217, 37, 80, 1) !important;
          text-decoration-color: RGBA(217, 37, 80, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(174, 30, 64, 1) !important;
  color: RGBA(174, 30, 64, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(174, 30, 64, 1) !important;
          text-decoration-color: RGBA(174, 30, 64, 1) !important;
  -webkit-text-decoration-color: RGBA(174, 30, 64, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(174, 30, 64, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(238, 238, 238, 1) !important;
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(238, 238, 238, 1) !important;
          text-decoration-color: RGBA(238, 238, 238, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(241, 241, 241, 1) !important;
  color: RGBA(241, 241, 241, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(241, 241, 241, 1) !important;
          text-decoration-color: RGBA(241, 241, 241, 1) !important;
  -webkit-text-decoration-color: RGBA(241, 241, 241, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(241, 241, 241, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(52, 58, 64, 1) !important;
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(52, 58, 64, 1) !important;
          text-decoration-color: RGBA(52, 58, 64, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 46, 51, 1) !important;
  color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(42, 46, 51, 1) !important;
          text-decoration-color: RGBA(42, 46, 51, 1) !important;
  -webkit-text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-focus {
  color: RGBA(68, 64, 84, 1) !important;
  color: RGBA(var(--bs-focus-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(68, 64, 84, 1) !important;
          text-decoration-color: RGBA(68, 64, 84, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-focus-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-focus-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-focus:hover, .link-focus:focus {
  color: RGBA(54, 51, 67, 1) !important;
  color: RGBA(54, 51, 67, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(54, 51, 67, 1) !important;
          text-decoration-color: RGBA(54, 51, 67, 1) !important;
  -webkit-text-decoration-color: RGBA(54, 51, 67, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(54, 51, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-alternate {
  color: RGBA(131, 88, 138, 1) !important;
  color: RGBA(var(--bs-alternate-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(131, 88, 138, 1) !important;
          text-decoration-color: RGBA(131, 88, 138, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-alternate-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-alternate-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-alternate:hover, .link-alternate:focus {
  color: RGBA(105, 70, 110, 1) !important;
  color: RGBA(105, 70, 110, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(105, 70, 110, 1) !important;
          text-decoration-color: RGBA(105, 70, 110, 1) !important;
  -webkit-text-decoration-color: RGBA(105, 70, 110, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(105, 70, 110, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(0, 0, 0, 1) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 1) !important;
          text-decoration-color: RGBA(0, 0, 0, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(0, 0, 0, 0.75) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
          text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  -webkit-text-decoration-color: rgba(84, 92, 216, 0.5);
          text-decoration-color: rgba(84, 92, 216, 0.5);
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: translate3d(0.25em, 0, 0);
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-focus {
  --bs-focus-ring-color: rgba(var(--bs-focus-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-alternate {
  --bs-focus-ring-color: rgba(var(--bs-alternate-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(84, 92, 216, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(108, 117, 125, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(58, 196, 125, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(48, 177, 255, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(247, 185, 36, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(217, 37, 80, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(238, 238, 238, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(52, 58, 64, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-focus {
  --bs-border-opacity: 1;
  border-color: rgba(68, 64, 84, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-focus-rgb), var(--bs-border-opacity)) !important;
}

.border-alternate {
  --bs-border-opacity: 1;
  border-color: rgba(131, 88, 138, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-alternate-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: rgb(186.6, 189.8, 239.4) !important;
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: rgb(196.2, 199.8, 203) !important;
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: rgb(176.2, 231.4, 203) !important;
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: rgb(172.2, 223.8, 255) !important;
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: rgb(251.8, 227, 167.4) !important;
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: rgb(239.8, 167.8, 185) !important;
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: #e9ecef !important;
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: #adb5bd !important;
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.345rem + 1.14vw) !important;
}

.fs-2 {
  font-size: calc(1.301rem + 0.612vw) !important;
}

.fs-3 {
  font-size: calc(1.279rem + 0.348vw) !important;
}

.fs-4 {
  font-size: calc(1.257rem + 0.084vw) !important;
}

.fs-5 {
  font-size: 1.1rem !important;
}

.fs-6 {
  font-size: 0.88rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(84, 92, 216, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(108, 117, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(58, 196, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(48, 177, 255, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(247, 185, 36, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(217, 37, 80, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(238, 238, 238, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(52, 58, 64, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-focus {
  --bs-text-opacity: 1;
  color: rgba(68, 64, 84, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-focus-rgb), var(--bs-text-opacity)) !important;
}

.text-alternate {
  --bs-text-opacity: 1;
  color: rgba(131, 88, 138, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-alternate-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(73, 80, 87, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: rgba(73, 80, 87, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: rgba(73, 80, 87, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: rgba(73, 80, 87, 0.5) !important;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: #000 !important;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: rgb(33.6, 36.8, 86.4) !important;
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: rgb(43.2, 46.8, 50) !important;
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: rgb(23.2, 78.4, 50) !important;
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: rgb(19.2, 70.8, 102) !important;
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: rgb(98.8, 74, 14.4) !important;
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: rgb(86.8, 14.8, 32) !important;
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: #495057 !important;
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: #495057 !important;
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(84, 92, 216, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(84, 92, 216, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(58, 196, 125, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(58, 196, 125, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(48, 177, 255, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(48, 177, 255, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(247, 185, 36, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(247, 185, 36, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(217, 37, 80, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(217, 37, 80, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(238, 238, 238, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(238, 238, 238, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(52, 58, 64, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(52, 58, 64, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-focus {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(68, 64, 84, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(68, 64, 84, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-focus-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-focus-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-alternate {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(131, 88, 138, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(131, 88, 138, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-alternate-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-alternate-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(84, 92, 216, 1) !important;
          text-decoration-color: rgba(84, 92, 216, 1) !important;
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 92, 216, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(108, 117, 125, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 196, 125, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 177, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(247, 185, 36, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(217, 37, 80, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(238, 238, 238, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(52, 58, 64, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-focus {
  --bs-bg-opacity: 1;
  background-color: rgba(68, 64, 84, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-focus-rgb), var(--bs-bg-opacity)) !important;
}

.bg-alternate {
  --bs-bg-opacity: 1;
  background-color: rgba(131, 88, 138, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-alternate-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 239, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: rgb(220.8, 222.4, 247.2) !important;
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: rgb(225.6, 227.4, 229) !important;
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: rgb(215.6, 243.2, 229) !important;
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: rgb(213.6, 239.4, 255) !important;
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: rgb(253.4, 241, 211.2) !important;
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: rgb(247.4, 211.4, 220) !important;
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: rgb(251.5, 252, 252.5) !important;
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: #ced4da !important;
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.25rem !important;
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: 0.5rem !important;
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: 2rem !important;
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.2rem !important;
  }
  .fs-2 {
    font-size: 1.76rem !important;
  }
  .fs-3 {
    font-size: 1.54rem !important;
  }
  .fs-4 {
    font-size: 1.32rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
a,
button,
.btn {
  outline: none !important;
}

.app-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

.SidebarAnimation-appear {
  transform: translateX(-30px);
  opacity: 0;
}
.SidebarAnimation-appear.SidebarAnimation-appear-active {
  opacity: 1;
  transform: translateX(0);
  transition: all 0.4s linear;
}

.HeaderAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.HeaderAnimation-appear.HeaderAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.MainAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.MainAnimation-appear.MainAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.app-header {
  height: 60px;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 10;
  transition: all 0.2s;
}
.app-header.header-shadow {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}
.app-header .app-header__content {
  display: flex;
  align-items: center;
  align-content: center;
  flex: 1 1;
  padding: 0 1.5rem;
  height: 60px;
}
.app-header .app-header__content .app-header-left {
  display: flex;
  align-items: center;
}
.app-header .app-header__content .app-header-right {
  align-items: center;
  display: flex;
  margin-left: auto;
}
.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {
  white-space: nowrap;
}
.app-header .header-user-info > .widget-subheading {
  font-size: 0.8rem;
}

.app-header__logo {
  padding: 0 1.5rem;
  height: 60px;
  width: 280px;
  display: flex;
  align-items: center;
  transition: width 0.2s;
}
.app-header__logo .logo-src {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.app-header__logo .Burger {
  padding: 0 8px;
  margin-left: auto;
}

.app-header__menu,
.app-header__mobile-menu {
  display: none;
  padding: 0 1.5rem;
  height: 60px;
  align-items: center;
}

.fixed-header .app-header {
  position: fixed;
  width: 100%;
  top: 0;
}
.fixed-header .app-header .app-header__logo {
  visibility: visible;
}
.fixed-header .app-main {
  padding-top: 60px;
}
.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}

.header-dots {
  margin-left: auto;
  display: flex;
}
.header-dots > .dropdown {
  display: flex;
  align-content: center;
}
.header-dots .icon-wrapper-alt {
  margin: 0;
  height: 44px;
  width: 44px;
  text-align: center;
  overflow: visible;
}
.header-dots .icon-wrapper-alt .language-icon {
  border-radius: 30px;
  position: relative;
  z-index: 4;
  width: 28px;
  height: 28px;
  overflow: hidden;
  margin: 0 auto;
}
.header-dots .icon-wrapper-alt .language-icon img {
  position: relative;
  top: 50%;
  left: 50%;
  margin: -22px 0 0 -20px;
}
.header-dots .icon-wrapper-alt .icon-wrapper-bg {
  opacity: 0.1;
  transition: opacity 0.2s;
  border-radius: 40px;
}
.header-dots .icon-wrapper-alt svg {
  margin: 0 auto;
}
@-moz-document url-prefix() {
  .header-dots .icon-wrapper-alt svg {
    width: 50%;
  }
}
.header-dots .icon-wrapper-alt i {
  font-size: 1.3rem;
}
.header-dots .icon-wrapper-alt:hover {
  cursor: pointer;
}
.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {
  opacity: 0.2;
}
.header-dots .icon-wrapper-alt .badge-dot {
  top: 1px;
  right: 1px;
  border: 0;
}

.header-megamenu.nav > li > .nav-link {
  color: #6c757d;
  padding-left: 0.6666666667rem;
  padding-right: 0.6666666667rem;
}
.header-megamenu.nav > li > .nav-link .rounded-pill {
  padding: 5px 7px;
}
.header-megamenu.nav > li > .nav-link:hover {
  color: #343a40;
}
.header-megamenu.nav > li > .nav-link svg {
  margin-top: 1px;
}

.header-btn-lg {
  padding: 0 0 0 1.5rem;
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
}
.header-btn-lg::before {
  position: absolute;
  left: -1px;
  top: 50%;
  background: #dee2e6;
  width: 1px;
  height: 30px;
  margin-top: -15px;
  content: "";
}
.header-btn-lg .hamburger-inner,
.header-btn-lg .hamburger-inner::before,
.header-btn-lg .hamburger-inner::after {
  background: #6c757d;
}

.app-header.header-text-light .app-header-left > .nav > li > .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(255, 255, 255);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {
  fill: rgba(255, 255, 255, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(255, 255, 255, 0.95);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.15) !important;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.app-header.header-text-light .search-wrapper.active .input-holder {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-input {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .header-btn-lg::before {
  background: rgba(255, 255, 255, 0.2);
}
.app-header.header-text-light .header-btn-lg .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger-inner::before,
.app-header.header-text-light .header-btn-lg .hamburger-inner::after,
.app-header.header-text-light .header__pane .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger-inner::before,
.app-header.header-text-light .header__pane .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper .close::before,
.app-header.header-text-light .search-wrapper .close::after,
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {
  background: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {
  background: rgba(255, 255, 255, 0.9);
}

.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(0, 0, 0);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {
  fill: rgba(0, 0, 0, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(0, 0, 0, 0.95);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.15) !important;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .header-btn-lg::before {
  background: rgba(0, 0, 0, 0.2);
}
.app-header.header-text-dark .header-btn-lg .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,
.app-header.header-text-dark .header__pane .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger-inner::before,
.app-header.header-text-dark .header__pane .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .close::before,
.app-header.header-text-dark .search-wrapper .close::after,
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {
  background: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.app-sidebar {
  width: 280px;
  display: flex;
  z-index: 11;
  overflow: hidden;
  min-width: 280px;
  position: relative;
  flex: 0 0 280px;
  margin-top: -60px;
  padding-top: 60px;
  transition: all 0.2s;
}
.app-sidebar .app-sidebar__inner {
  padding: 2px 1.5rem 1.5rem;
  width: 100%;
}
.app-sidebar .scrollbar-container {
  z-index: 15;
  width: 100%;
}
.app-sidebar .app-sidebar-bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.05;
  background-size: cover;
  z-index: 10;
}
.app-sidebar .app-header__logo {
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  z-index: 11;
}
.app-sidebar.sidebar-shadow {
  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);
}

.app-sidebar__heading {
  text-transform: uppercase;
  font-size: 0.8rem;
  margin: 0.75rem 0;
  font-weight: bold;
  color: #545cd8;
  white-space: nowrap;
  position: relative;
  width: 100%;
  text-align: left;
  padding: 0;
  display: flex;
  align-items: center;
}

.sidebar-mobile-overlay {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #333;
  opacity: 0.6;
  left: 0;
  top: 0;
  z-index: 12;
}

.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
  text-align: left;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: flex;
  align-items: center;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.375rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 5px;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
  padding-left: 35px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 35px;
}

.app-sidebar.sidebar-text-light {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-light .app-sidebar__heading {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .app-sidebar__heading::before {
  background: rgba(255, 255, 255, 0.2) !important;
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {
  color: rgb(255, 255, 255);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-light .ps__thumb-y {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {
  background: rgba(255, 255, 255, 0.2);
}
.app-sidebar.sidebar-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8);
}

.app-sidebar.sidebar-text-dark {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {
  background: rgba(0, 0, 0, 0.5) !important;
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-dark .ps__thumb-y {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {
  background: rgba(0, 0, 0, 0.2);
}
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8);
}

.fixed-sidebar .app-sidebar {
  position: fixed;
  height: 100vh;
}
.fixed-sidebar .app-main .app-main__outer {
  z-index: 9;
  padding-left: 280px;
}
.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {
  display: none;
}
.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  display: flex;
}
.fixed-sidebar:not(.fixed-header) .app-header {
  margin-left: 280px;
}
.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {
  margin-left: 80px;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  width: 80px;
  padding: 0;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {
  margin-right: auto;
}

.closed-sidebar .app-sidebar {
  transition: all 0.3s ease;
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px;
  z-index: 13;
}
.closed-sidebar .app-sidebar .app-sidebar__inner {
  padding: 2px 1.5rem;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {
  text-indent: -999em;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0.75rem 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 5px;
  width: calc(100% - 10px);
  height: 1px;
  background: #e0f3ff;
  text-indent: 1px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {
  text-indent: -99rem;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  position: relative;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  position: static;
  transform: none;
  margin: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {
  visibility: hidden;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-item {
  width: 100%;
  display: flex;
  justify-content: center;
}
.closed-sidebar .app-sidebar:hover {
  flex: 0 0 280px !important;
  width: 280px !important;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner {
  padding: 2px 1.5rem 1.5rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {
  text-indent: 0;
  text-indent: initial;
  justify-content: flex-start;
  padding: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {
  display: none;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {
  text-indent: 0;
  text-indent: initial;
  padding: 0 1.5rem 0 45px;
  justify-content: flex-start;
  margin: 0;
  width: 100%;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {
  visibility: visible;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container {
  display: block;
  padding: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  padding-left: 35px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 35px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-item {
  width: 100%;
  display: block;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {
  position: static;
  height: auto;
  overflow: visible !important;
  overflow: initial !important;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {
  position: absolute;
  height: 100%;
  overflow: hidden !important;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {
  width: 80px;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {
  display: none;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {
  margin-right: auto;
}
.closed-sidebar.fixed-sidebar .app-main__outer {
  padding-left: 80px;
}
.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {
  width: auto;
  display: flex;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {
  display: flex;
  width: 80px;
  padding: 0 1.5rem !important;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {
  display: block !important;
  margin: 0 auto;
  width: 21px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {
  width: 280px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {
  width: 97px;
  margin: 0;
}
.closed-sidebar.closed-sidebar-mobile .app-header {
  margin-left: 0 !important;
}
.closed-sidebar.fixed-footer .app-footer__inner {
  margin-left: 0 !important;
}

.app-main {
  z-index: 8;
  position: relative;
  display: flex;
}
.app-main .app-main__outer {
  flex: 1 1;
  flex-direction: column;
  display: flex;
  z-index: 12;
  width: 1px;
}
.app-main .app-main__inner {
  padding: 1rem 1rem 0;
  flex: 1 1;
}
.app-main .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 1rem;
}
.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {
  margin-top: -0.5rem;
}

.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 0.6666666667rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {
  border: 0;
  background: transparent;
  position: relative;
  z-index: 7;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {
  margin-top: -13px;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {
  margin-top: 0.5rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {
  color: #fff;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.1rem;
  z-index: 5;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.375rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.app-theme-white.app-container {
  background: #f1f4f6;
}
.app-theme-white .app-sidebar {
  background: #ffffff;
}
.app-theme-white .app-page-title {
  background: rgba(255, 255, 255, 0.55);
}
.app-theme-white .app-footer .app-footer__inner,
.app-theme-white .app-header {
  background: #fafbfc;
}
.app-theme-white.fixed-header .app-header__logo {
  background: rgba(250, 251, 252, 0.1);
}

.app-theme-gray.app-container {
  background: #ffffff;
}
.app-theme-gray .app-sidebar {
  background: #ffffff;
  border-right: #dee2e6 solid 1px;
}
.app-theme-gray .app-page-title {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .app-footer,
.app-theme-gray .app-header {
  background: #f8f9fa;
}
.app-theme-gray .app-footer {
  border-top: #dee2e6 solid 1px;
}
.app-theme-gray .app-header .app-header__logo {
  border-right: rgba(0, 0, 0, 0.1) solid 1px;
}
.app-theme-gray.fixed-header .app-header__logo {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .card {
  border-width: 1px;
}
.app-theme-gray .main-card {
  box-shadow: 0 0 0 0 transparent !important;
}
.app-theme-gray .main-card > .card-body > .card-title {
  text-transform: none;
  font-size: 1.1rem;
  font-weight: normal;
  border-bottom: #dee2e6 solid 1px;
  position: relative;
  padding: 0 0 1.5rem;
  margin: 0 0 1.5rem;
}
.app-theme-gray .main-card > .card-body > .card-title::before {
  position: absolute;
  width: 40px;
  background: #545cd8;
  border-radius: 30px;
  height: 5px;
  left: 0;
  bottom: -2px;
  content: "";
}
.app-theme-gray .app-inner-layout__sidebar {
  border-left: 0 !important;
}

.app-footer {
  height: 60px;
}
.app-footer .app-footer__inner {
  padding: 0 1.5rem 0 0.75rem;
  height: 60px;
  transition: all 0.2s;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-left {
  display: flex;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-right {
  margin-left: auto;
  display: flex;
}

.footer-dots {
  display: flex;
  align-items: center;
  align-content: center;
}
.footer-dots .dots-separator {
  height: 40px;
  margin: 0 0.6rem;
  width: 1px;
  background: #e9ecef;
}

.dot-btn-wrapper {
  padding: 0.5rem;
  position: relative;
  display: flex;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.dot-btn-wrapper .badge-abs {
  right: 50%;
}
.dot-btn-wrapper .badge-abs.badge-dot-sm {
  top: -2px;
  margin-right: -3px;
}
.dot-btn-wrapper .dot-btn-icon {
  font-size: 1.8rem;
}
.dot-btn-wrapper:hover {
  text-decoration: none;
  opacity: 1;
}

.fixed-footer .app-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 7;
}
.fixed-footer .app-footer .app-footer__inner {
  margin-left: 280px;
  box-shadow: 0 -2px 15px rgba(42, 46, 108, 0.05);
}
.fixed-footer .app-main .app-main__outer {
  padding-bottom: 60px;
}
.fixed-footer.closed-sidebar .app-footer .app-footer__inner {
  margin-left: 80px !important;
}

.app-page-title {
  padding: 1rem;
  margin: -1rem -1rem 1rem;
  position: relative;
}
.app-page-title .page-title-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.app-page-title .page-title-heading,
.app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}
.app-page-title .page-title-heading {
  font-size: 1.1rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}
.app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: transparent;
}
.app-page-title .page-title-actions {
  margin-left: auto;
}
.app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-page-title .page-title-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.8333333333rem;
  margin: 0 1rem 0 0;
  background: #fff;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  border-radius: 0.375rem;
  width: 60px;
  height: 60px;
}
.app-page-title .page-title-icon i {
  margin: auto;
}
.app-page-title .page-title-icon.rounded-circle {
  margin: 0 0.6666666667rem 0 0;
}
.app-page-title + .RRT__container {
  margin-top: -0.7692307692rem;
}
.app-page-title + .rc-tabs {
  max-width: calc(100vw - 322px);
  margin: -1rem -0.5rem 1.3rem;
}
@media only screen and (max-width: 812px) and (min-width: 360px) {
  .app-page-title + .rc-tabs {
    max-width: calc(100vw - 0px);
    margin: -1rem -0.5rem 1.3rem;
  }
}
.app-page-title.app-page-title-simple {
  margin: 0;
  background: none !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.page-title-icon-rounded .page-title-icon {
  border-radius: 50px;
}

.closed-sidebar .rc-tabs {
  max-width: calc(100vw - 110px);
}

@media only screen and (max-width: 812px) and (min-width: 360px) {
  .closed-sidebar .rc-tabs {
    max-width: calc(100vw - 0px);
  }
}
.body-tabs.body-tabs-layout {
  margin-left: -1rem;
  margin-right: -1rem;
  padding: 0 1rem;
  border-top: 0;
  border-bottom: #dee2e6 solid 1px;
}

.search-wrapper {
  position: relative;
  margin-right: 0.6666666667rem;
}
.search-wrapper .input-holder {
  height: 42px;
  width: 42px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.search-wrapper .input-holder .search-input {
  width: 100%;
  padding: 0 70px 0 20px;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  box-sizing: border-box;
  border: none;
  outline: none;
  transform: translate(0, 60px);
  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.3s;
  font-size: 0.88rem;
}
.search-wrapper .input-holder .search-icon {
  width: 42px;
  height: 42px;
  border: none;
  padding: 0;
  outline: none;
  position: relative;
  z-index: 2;
  float: right;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 30px;
}
.search-wrapper .input-holder .search-icon span {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  transform: rotate(45deg);
  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);
}
.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
  position: absolute;
  content: "";
}
.search-wrapper .input-holder .search-icon span::before {
  width: 4px;
  height: 11px;
  left: 9px;
  top: 13px;
  border-radius: 2px;
  background: #545cd8;
}
.search-wrapper .input-holder .search-icon span::after {
  width: 14px;
  height: 14px;
  left: 4px;
  top: 0;
  border-radius: 16px;
  border: 2px solid #545cd8;
}
.search-wrapper .btn-close {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  cursor: pointer;
  padding: 0px;
  opacity: 0 !important;
  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);
  transition-delay: 0.1s;
}
.search-wrapper .btn-close::before, .search-wrapper .btn-close::after {
  position: absolute;
  background: #545cd8;
  border-radius: 2px;
}
.search-wrapper .btn-close::before {
  width: 2px;
  height: 20px;
  left: 9px;
  top: 0;
}
.search-wrapper .btn-close::after {
  width: 20px;
  height: 2px;
  left: 0;
  top: 9px;
}
.search-wrapper.active {
  width: 330px;
}
.search-wrapper.active .input-holder {
  width: 290px;
  border-radius: 50px;
  background: rgba(0, 0, 0, 0.05);
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
}
.search-wrapper.active .input-holder .search-input {
  opacity: 1;
  transform: translate(0, 11px);
}
.search-wrapper.active .input-holder .search-icon {
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 30px;
}
.search-wrapper.active .input-holder .search-icon span {
  transform: rotate(-45deg);
}
.search-wrapper.active .btn-close {
  left: 300px;
  opacity: 0.6 !important;
  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.5s;
}
.search-wrapper.active .btn-close:hover {
  opacity: 1 !important;
}
.search-wrapper.active + .header-megamenu {
  opacity: 0;
}

.opacity-01 {
  opacity: 0.01 !important;
}

.opacity-02 {
  opacity: 0.02 !important;
}

.opacity-03 {
  opacity: 0.03 !important;
}

.opacity-04 {
  opacity: 0.04 !important;
}

.opacity-05 {
  opacity: 0.05 !important;
}

.opacity-06 {
  opacity: 0.06 !important;
}

.opacity-07 {
  opacity: 0.07 !important;
}

.opacity-08 {
  opacity: 0.08 !important;
}

.opacity-09 {
  opacity: 0.09 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.filter-grayscale-5 {
  filter: grayscale(5%) !important;
}

.filter-grayscale-10 {
  filter: grayscale(10%) !important;
}

.filter-grayscale-20 {
  filter: grayscale(20%) !important;
}

.filter-grayscale-30 {
  filter: grayscale(30%) !important;
}

.filter-grayscale-40 {
  filter: grayscale(40%) !important;
}

.filter-grayscale-50 {
  filter: grayscale(50%) !important;
}

.filter-grayscale-80 {
  filter: grayscale(80%) !important;
}

.filter-grayscale-100 {
  filter: grayscale(100%) !important;
}

.br-tl {
  border-top-left-radius: 0.375rem !important;
}

.br-tr {
  border-top-right-radius: 0.375rem !important;
}

.br-bl {
  border-bottom-left-radius: 0.375rem !important;
}

.br-br {
  border-bottom-right-radius: 0.375rem !important;
}

.b-radius-0 {
  border-radius: 0 !important;
}

.rm-border {
  border-width: 0 !important;
}

.br-a {
  border-radius: 0.375rem;
}

.margin-h-center {
  margin-left: auto !important;
  margin-right: auto !important;
}

.center-svg {
  margin: 0 auto;
}
.center-svg svg {
  margin: 0 auto;
}

.apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-donut {
  display: flex;
  align-items: center;
  align-content: center;
}

.alert-dismissible .close {
  top: 0;
  right: 5px;
  padding: 5px;
}

.icon-gradient {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.font-size-xlg {
  font-size: 1.3rem !important;
}

.font-size-md {
  font-size: 0.9rem !important;
}

.font-size-lg {
  font-size: 1.1rem !important;
}

.no-shadow {
  box-shadow: 0 0 0 transparent !important;
}

.h-100 {
  height: 100vh !important;
}

.he-auto {
  height: auto !important;
}

.he-100 {
  height: 100%;
}

.h-sm {
  height: 150px;
}

.text-nowrap {
  white-space: nowrap;
}

.fsize-1 {
  font-size: 0.95rem !important;
}

.fsize-2 {
  font-size: 1.3rem !important;
}

.fsize-3 {
  font-size: 1.6rem !important;
}

.fsize-4 {
  font-size: 2rem !important;
}

.z-index-6 {
  z-index: 6;
}

.line-height-1 {
  line-height: 1;
}

.center-elem {
  display: flex;
  align-items: center;
  align-content: center;
}

.flex2 {
  flex: 2 1;
}

.divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  overflow: hidden;
  background: #e9ecef;
}

.list-group-item:hover {
  z-index: auto;
  z-index: initial;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
}
.no-results .results-title {
  color: #495057;
  font-size: 1.1rem;
}
.no-results .results-subtitle {
  color: #adb5bd;
  font-size: 1.1rem;
}

.bg-animation {
  animation: bg-pan-left 8s both;
}
@keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.w-100 {
  width: 100%;
}

.mb--2 {
  margin-bottom: -1.5rem;
}

.mbg-3 {
  margin-bottom: 1rem;
}

.loader-container {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
  text-align: center;
  line-height: 1.6rem;
}
.loader-container .loader-container-inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 1.5rem;
}
.loader-container small, .loader-container .small {
  margin: 10px 0 0;
  display: block;
  color: #6c757d;
  font-weight: normal;
}
.loader-container h3, .loader-container .h3 {
  text-align: center;
  display: block;
}

.btn-info, .btn-success {
  color: #fff !important;
}

.bg-warning {
  color: #212529;
}

.list-group-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.btn-link, a {
  text-decoration: none !important;
}

.bg-light {
  color: #212529;
}

.table {
  --bs-table-accent-bg: none;
}

.form-check-input-custom {
  width: 1rem;
  height: 1rem;
}

.bg-warm-flame {
  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;
}

.bg-night-fade {
  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;
}

.bg-sunny-morning {
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;
}

.bg-tempting-azure {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;
}

.bg-amy-crisp {
  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;
}

.bg-heavy-rain {
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;
}

.bg-mean-fruit {
  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;
}

.bg-malibu-beach {
  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;
}

.bg-deep-blue {
  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;
}

.bg-ripe-malin {
  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;
}

.bg-arielle-smile {
  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;
}

.bg-plum-plate {
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.bg-happy-fisher {
  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;
}

.bg-happy-itmeo {
  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;
}

.bg-mixed-hopes {
  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;
}

.bg-strong-bliss {
  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;
}

.bg-grow-early {
  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;
}

.bg-love-kiss {
  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;
}

.bg-premium-dark {
  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;
}

.bg-happy-green {
  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;
}

.bg-vicious-stance {
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;
}

.bg-midnight-bloom {
  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;
}

.bg-night-sky {
  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;
}

.bg-slick-carbon {
  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;
  background-blend-mode: multiply;
}

.bg-royal {
  background-image: linear-gradient(to right, #141e30, #243b55) !important;
}

.bg-asteroid {
  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;
}

.bg-transparent {
  background: transparent !important;
}

/* NOTE: animate-sass/ is loaded from node_modules/ using sass-loader */
/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT
Copyright (c) 2015 Daniel Eden
*/
body {
  -webkit-backface-visibility: hidden;
}

.animated, .TabsAnimation-appear {
  animation-duration: calc(1s);
  animation-fill-mode: both;
}
.animated.infinite, .infinite.TabsAnimation-appear {
  animation-iteration-count: infinite;
}
.animated.hinge, .hinge.TabsAnimation-appear {
  animation-duration: calc(1s * 2);
}
.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInUp, .TabsAnimation-appear {
  animation-name: fadeInUp;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
}
.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
}
.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in;
}

.dropdown-menu.show {
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.popover.show {
  display: block;
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.dropdown-menu[data-placement^=top].show {
  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  bottom: auto !important;
  top: auto !important;
}

@keyframes fade-in2 {
  0% {
    margin-top: -50px;
    visibility: hidden;
    opacity: 0;
  }
  100% {
    margin-top: 0px;
    visibility: visible;
    opacity: 1;
  }
}
.form-control {
  transition: all 0.2s;
}

.btn-outline-2x {
  border-width: 2px;
}

.btn-group .btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn-group .btn-outline-2x + .btn-outline-2x {
  margin-left: -2px;
}
.btn-group .btn-square {
  border-radius: 0;
}

.btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn.btn-pill.btn-wide, .btn.btn-pill {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-dashed {
  border-style: dashed;
}

.btn-icon {
  vertical-align: bottom;
}
.btn-icon.btn-icon-right .btn-icon-wrapper {
  margin-left: 0.5rem;
  margin-right: 0;
}
.btn-icon .btn-icon-wrapper {
  margin-right: 0.5rem;
  margin-left: 0;
  margin-top: 0;
  font-size: 17px;
  vertical-align: middle;
  transition: color 0.1s;
  display: inline-block;
}
.btn-icon.btn-link {
  text-decoration: none;
}
.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}

.btn-icon-only .btn-icon-wrapper {
  margin-left: 0;
  margin-right: 0;
}

.btn-hover-shine {
  position: relative;
}
.btn-hover-shine:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  transition: none;
}
.btn-hover-shine:hover:after {
  width: 120%;
  background-color: rgba(255, 255, 255, 0);
  transition: all 0.4s ease-in-out;
}
.btn-hover-shine.btn-pill::after {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-icon-vertical {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.btn-icon-vertical .btn-icon-wrapper {
  display: block;
  font-size: 200%;
  margin: 5px 0;
  opacity: 0.6;
}
.btn-icon-vertical.btn-link {
  text-decoration: none;
}
.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}
.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {
  opacity: 1;
}
.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {
  margin: 0.2rem 0 5px;
}
.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {
  transition: all 0.2s !important;
}
.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {
  transform: scale(1.3);
}
.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {
  color: #fff !important;
}

.btn-icon-lg {
  font-size: 2.2rem !important;
}

.btn-transition {
  color: #6c757d;
  border-color: #e9ecef;
  background-color: none;
}
.btn-transition.btn-outline-link {
  border-color: transparent;
  background-color: transparent;
}
.btn-transition.btn-outline-link:hover {
  color: #545cd8;
  background: #f8f9fa;
}
.btn-transition.disabled, .btn-transition:disabled {
  color: #6c757d;
  border-color: #e9ecef;
}
.btn-transition:hover .btn-icon-wrapper {
  transition: none;
}

.btn-transition-alt:hover .icon-gradient {
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  background-clip: border-box;
  background-clip: initial;
  text-fill-color: initial;
  background: none !important;
  color: #fff;
}

.btn-square {
  border-radius: 0 !important;
}

.btn.btn-wide {
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-font-size: 0.8rem;
  --bs-btn-border-radius: var(--bs-border-radius);
}

.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 2rem;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 0.8rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 1px;
}

.btn-gradient-primary {
  background-image: linear-gradient(140deg, rgb(71.4, 78.2, 183.6) -30%, #545cd8 90%);
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(71.4, 78.2, 183.6);
  color: #fff;
}
.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(69.258, 75.854, 178.092) 0%, rgb(81.48, 89.24, 209.52) 100%);
  color: #fff;
  border-color: rgb(64.26, 70.38, 165.24);
}
.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {
  color: #fff !important;
  border-color: rgb(67.2, 73.6, 172.8) !important;
}
.btn-gradient-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-gradient-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-gradient-secondary {
  background-image: linear-gradient(140deg, rgb(91.8, 99.45, 106.25) -30%, #6c757d 90%);
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(91.8, 99.45, 106.25);
  color: #fff;
}
.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(89.046, 96.4665, 103.0625) 0%, rgb(104.76, 113.49, 121.25) 100%);
  color: #fff;
  border-color: rgb(82.62, 89.505, 95.625);
}
.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {
  color: #fff !important;
  border-color: rgb(86.4, 93.6, 100) !important;
}
.btn-gradient-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-gradient-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-gradient-success {
  background-image: linear-gradient(140deg, rgb(49.3, 166.6, 106.25) -30%, #3ac47d 90%);
  background-color: rgb(49.3, 166.6, 106.25);
  border-color: rgb(49.3, 166.6, 106.25);
  color: #000;
}
.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(47.821, 161.602, 103.0625) 0%, rgb(56.26, 190.12, 121.25) 100%);
  color: #000;
  border-color: rgb(44.37, 149.94, 95.625);
}
.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {
  color: #000 !important;
  border-color: rgb(46.4, 156.8, 100) !important;
}
.btn-gradient-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-gradient-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-gradient-info {
  background-image: linear-gradient(140deg, rgb(40.8, 150.45, 216.75) -30%, #30b1ff 90%);
  background-color: rgb(40.8, 150.45, 216.75);
  border-color: rgb(40.8, 150.45, 216.75);
  color: #000;
}
.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(39.576, 145.9365, 210.2475) 0%, rgb(46.56, 171.69, 247.35) 100%);
  color: #000;
  border-color: rgb(36.72, 135.405, 195.075);
}
.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {
  color: #000 !important;
  border-color: rgb(38.4, 141.6, 204) !important;
}
.btn-gradient-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-gradient-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-gradient-warning {
  background-image: linear-gradient(140deg, rgb(209.95, 157.25, 30.6) -30%, #f7b924 90%);
  background-color: rgb(209.95, 157.25, 30.6);
  border-color: rgb(209.95, 157.25, 30.6);
  color: #000;
}
.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(203.6515, 152.5325, 29.682) 0%, rgb(239.59, 179.45, 34.92) 100%);
  color: #000;
  border-color: rgb(188.955, 141.525, 27.54);
}
.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {
  color: #000 !important;
  border-color: rgb(197.6, 148, 28.8) !important;
}
.btn-gradient-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-gradient-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-gradient-danger {
  background-image: linear-gradient(140deg, rgb(184.45, 31.45, 68) -30%, #d92550 90%);
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(184.45, 31.45, 68);
  color: #fff;
}
.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(178.9165, 30.5065, 65.96) 0%, rgb(210.49, 35.89, 77.6) 100%);
  color: #fff;
  border-color: rgb(166.005, 28.305, 61.2);
}
.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {
  color: #fff !important;
  border-color: rgb(173.6, 29.6, 64) !important;
}
.btn-gradient-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-gradient-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-gradient-focus {
  background-image: linear-gradient(140deg, rgb(57.8, 54.4, 71.4) -30%, #444054 90%);
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(57.8, 54.4, 71.4);
  color: #fff;
}
.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(56.066, 52.768, 69.258) 0%, rgb(65.96, 62.08, 81.48) 100%);
  color: #fff;
  border-color: rgb(52.02, 48.96, 64.26);
}
.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {
  color: #fff !important;
  border-color: rgb(54.4, 51.2, 67.2) !important;
}
.btn-gradient-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-gradient-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-gradient-alternate {
  background-image: linear-gradient(140deg, rgb(111.35, 74.8, 117.3) -30%, #83588a 90%);
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(111.35, 74.8, 117.3);
  color: #fff;
}
.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(108.0095, 72.556, 113.781) 0%, rgb(127.07, 85.36, 133.86) 100%);
  color: #fff;
  border-color: rgb(100.215, 67.32, 105.57);
}
.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {
  color: #fff !important;
  border-color: rgb(104.8, 70.4, 110.4) !important;
}
.btn-gradient-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-gradient-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-gradient-light {
  background-image: linear-gradient(140deg, rgb(202.3, 202.3, 202.3) -30%, #eeeeee 90%);
  background-color: rgb(202.3, 202.3, 202.3);
  border-color: rgb(202.3, 202.3, 202.3);
  color: #000;
}
.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(196.231, 196.231, 196.231) 0%, rgb(230.86, 230.86, 230.86) 100%);
  color: #000;
  border-color: rgb(182.07, 182.07, 182.07);
}
.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {
  color: #000 !important;
  border-color: rgb(190.4, 190.4, 190.4) !important;
}
.btn-gradient-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-gradient-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-gradient-dark {
  background-image: linear-gradient(140deg, rgb(44.2, 49.3, 54.4) -30%, #343a40 90%);
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(44.2, 49.3, 54.4);
  color: #fff;
}
.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(42.874, 47.821, 52.768) 0%, rgb(50.44, 56.26, 62.08) 100%);
  color: #fff;
  border-color: rgb(39.78, 44.37, 48.96);
}
.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {
  color: #fff !important;
  border-color: rgb(41.6, 46.4, 51.2) !important;
}
.btn-gradient-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-gradient-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-shadow.active {
  box-shadow: 0 0 0 0 transparent !important;
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #545cd8;
  --bs-btn-border-color: #545cd8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(71.4, 78.2, 183.6);
  --bs-btn-hover-border-color: rgb(67.2, 73.6, 172.8);
  --bs-btn-focus-shadow-rgb: 110, 116, 222;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(67.2, 73.6, 172.8);
  --bs-btn-active-border-color: #3f45a2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #545cd8;
  --bs-btn-disabled-border-color: #545cd8;
}
.btn-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}
.btn-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #3ac47d;
  --bs-btn-border-color: #3ac47d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(87.55, 204.85, 144.5);
  --bs-btn-hover-border-color: rgb(77.7, 201.9, 138);
  --bs-btn-focus-shadow-rgb: 49, 167, 106;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(97.4, 207.8, 151);
  --bs-btn-active-border-color: rgb(77.7, 201.9, 138);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #3ac47d;
  --bs-btn-disabled-border-color: #3ac47d;
}
.btn-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #30b1ff;
  --bs-btn-border-color: #30b1ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(79.05, 188.7, 255);
  --bs-btn-hover-border-color: rgb(68.7, 184.8, 255);
  --bs-btn-focus-shadow-rgb: 41, 150, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(89.4, 192.6, 255);
  --bs-btn-active-border-color: rgb(68.7, 184.8, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #30b1ff;
  --bs-btn-disabled-border-color: #30b1ff;
}
.btn-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #f7b924;
  --bs-btn-border-color: #f7b924;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(248.2, 195.5, 68.85);
  --bs-btn-hover-border-color: rgb(247.8, 192, 57.9);
  --bs-btn-focus-shadow-rgb: 210, 157, 31;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(248.6, 199, 79.8);
  --bs-btn-active-border-color: rgb(247.8, 192, 57.9);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f7b924;
  --bs-btn-disabled-border-color: #f7b924;
}
.btn-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #d92550;
  --bs-btn-border-color: #d92550;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(184.45, 31.45, 68);
  --bs-btn-hover-border-color: rgb(173.6, 29.6, 64);
  --bs-btn-focus-shadow-rgb: 223, 70, 106;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(173.6, 29.6, 64);
  --bs-btn-active-border-color: rgb(162.75, 27.75, 60);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d92550;
  --bs-btn-disabled-border-color: #d92550;
}
.btn-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eeeeee;
  --bs-btn-border-color: #eeeeee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(240.55, 240.55, 240.55);
  --bs-btn-hover-border-color: rgb(239.7, 239.7, 239.7);
  --bs-btn-focus-shadow-rgb: 202, 202, 202;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(241.4, 241.4, 241.4);
  --bs-btn-active-border-color: rgb(239.7, 239.7, 239.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eeeeee;
  --bs-btn-disabled-border-color: #eeeeee;
}
.btn-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(44.2, 49.3, 54.4);
  --bs-btn-hover-border-color: rgb(41.6, 46.4, 51.2);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(41.6, 46.4, 51.2);
  --bs-btn-active-border-color: rgb(39, 43.5, 48);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}
.btn-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-focus {
  --bs-btn-color: #fff;
  --bs-btn-bg: #444054;
  --bs-btn-border-color: #444054;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(57.8, 54.4, 71.4);
  --bs-btn-hover-border-color: rgb(54.4, 51.2, 67.2);
  --bs-btn-focus-shadow-rgb: 96, 93, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(54.4, 51.2, 67.2);
  --bs-btn-active-border-color: #33303f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #444054;
  --bs-btn-disabled-border-color: #444054;
}
.btn-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-alternate {
  --bs-btn-color: #fff;
  --bs-btn-bg: #83588a;
  --bs-btn-border-color: #83588a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(111.35, 74.8, 117.3);
  --bs-btn-hover-border-color: rgb(104.8, 70.4, 110.4);
  --bs-btn-focus-shadow-rgb: 150, 113, 156;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(104.8, 70.4, 110.4);
  --bs-btn-active-border-color: rgb(98.25, 66, 103.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #83588a;
  --bs-btn-disabled-border-color: #83588a;
}
.btn-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-shadow-primary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}

.btn-shadow-secondary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}

.btn-shadow-success:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}

.btn-shadow-info:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}

.btn-shadow-warning:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}

.btn-shadow-danger:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}

.btn-shadow-light:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}

.btn-shadow-dark:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}

.btn-shadow-focus:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}

.btn-shadow-alternate:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}

.btn-outline-primary {
  --bs-btn-color: #545cd8;
  --bs-btn-border-color: #545cd8;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #545cd8;
  --bs-btn-hover-border-color: #545cd8;
  --bs-btn-focus-shadow-rgb: 84, 92, 216;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #545cd8;
  --bs-btn-active-border-color: #545cd8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #545cd8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #545cd8;
  --bs-gradient: none;
}
.btn-outline-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}
.btn-outline-primary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}
.btn-outline-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}
.btn-outline-secondary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);
}

.btn-outline-success {
  --bs-btn-color: #3ac47d;
  --bs-btn-border-color: #3ac47d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3ac47d;
  --bs-btn-hover-border-color: #3ac47d;
  --bs-btn-focus-shadow-rgb: 58, 196, 125;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3ac47d;
  --bs-btn-active-border-color: #3ac47d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3ac47d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3ac47d;
  --bs-gradient: none;
}
.btn-outline-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}
.btn-outline-success.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);
}

.btn-outline-info {
  --bs-btn-color: #30b1ff;
  --bs-btn-border-color: #30b1ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #30b1ff;
  --bs-btn-hover-border-color: #30b1ff;
  --bs-btn-focus-shadow-rgb: 48, 177, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #30b1ff;
  --bs-btn-active-border-color: #30b1ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #30b1ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #30b1ff;
  --bs-gradient: none;
}
.btn-outline-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}
.btn-outline-info.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);
}

.btn-outline-warning {
  --bs-btn-color: #f7b924;
  --bs-btn-border-color: #f7b924;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f7b924;
  --bs-btn-hover-border-color: #f7b924;
  --bs-btn-focus-shadow-rgb: 247, 185, 36;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f7b924;
  --bs-btn-active-border-color: #f7b924;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f7b924;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f7b924;
  --bs-gradient: none;
}
.btn-outline-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}
.btn-outline-warning.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);
}

.btn-outline-danger {
  --bs-btn-color: #d92550;
  --bs-btn-border-color: #d92550;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d92550;
  --bs-btn-hover-border-color: #d92550;
  --bs-btn-focus-shadow-rgb: 217, 37, 80;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #d92550;
  --bs-btn-active-border-color: #d92550;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d92550;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d92550;
  --bs-gradient: none;
}
.btn-outline-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}
.btn-outline-danger.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);
}

.btn-outline-light {
  --bs-btn-color: #eeeeee;
  --bs-btn-border-color: #eeeeee;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eeeeee;
  --bs-btn-hover-border-color: #eeeeee;
  --bs-btn-focus-shadow-rgb: 238, 238, 238;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eeeeee;
  --bs-btn-active-border-color: #eeeeee;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eeeeee;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eeeeee;
  --bs-gradient: none;
}
.btn-outline-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}
.btn-outline-light.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}
.btn-outline-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}
.btn-outline-dark.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);
}

.btn-outline-focus {
  --bs-btn-color: #444054;
  --bs-btn-border-color: #444054;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #444054;
  --bs-btn-hover-border-color: #444054;
  --bs-btn-focus-shadow-rgb: 68, 64, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #444054;
  --bs-btn-active-border-color: #444054;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #444054;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #444054;
  --bs-gradient: none;
}
.btn-outline-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}
.btn-outline-focus.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);
}

.btn-outline-alternate {
  --bs-btn-color: #83588a;
  --bs-btn-border-color: #83588a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #83588a;
  --bs-btn-hover-border-color: #83588a;
  --bs-btn-focus-shadow-rgb: 131, 88, 138;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #83588a;
  --bs-btn-active-border-color: #83588a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #83588a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #83588a;
  --bs-gradient: none;
}
.btn-outline-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}
.btn-outline-alternate.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);
}

.btn {
  position: relative;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn-light {
  border-color: rgb(220.5, 220.5, 220.5);
}

.btn-outline-light {
  color: #939393;
}

.dropdown-menu {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  font-size: 0.88rem;
  margin: 0.125rem;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
}
.dropdown-menu .dropdown-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #545cd8;
  font-weight: bold;
}
.dropdown-menu .dropdown-item {
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  z-index: 6;
  position: relative;
}
.dropdown-menu .dropdown-item .dropdown-icon {
  font-size: 1rem;
  margin-right: 0.325rem;
  width: 30px;
  text-align: center;
  opacity: 0.3;
  margin-left: -10px;
}
.dropdown-menu .dropdown-item:hover .dropdown-icon {
  opacity: 0.7;
}
.dropdown-menu.dropdown-menu-shadow {
  box-shadow: 0 0.66875rem 2.3875rem rgba(42, 46, 108, 0.03), 0 1.1375rem 1.60625rem rgba(42, 46, 108, 0.03), 0 0.45rem 0.73125rem rgba(42, 46, 108, 0.05), 0 0.325rem 0.3875rem rgba(42, 46, 108, 0.03);
}

.dropdown-menu-rounded {
  border-radius: 10px;
  padding: 0.65rem;
}
.dropdown-menu-rounded .dropdown-item {
  border-radius: 30px;
}
.dropdown-menu-rounded .dropdown-divider {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
}
.dropdown-menu-rounded .dropdown-menu-header {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu-rounded .menu-header-image,
.dropdown-menu-rounded .dropdown-menu-header-inner {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dropdown-menu-hover-link .dropdown-item:hover {
  background: none;
  color: #545cd8;
}

.dropdown-menu-hover-primary .dropdown-item:hover {
  background: #545cd8;
  color: #fff;
}

.dropdown-menu.dropdown-menu-lg {
  min-width: 22rem;
}
.dropdown-menu.dropdown-menu-xl {
  min-width: 25rem;
}

.dropdown-menu .dropdown-menu-header,
.dropdown-menu .menu-header-image,
.dropdown-menu .dropdown-menu-header-inner {
  border-top-left-radius: 0.375rem;
  border-top-left-radius: var(--bs-border-radius);
  border-top-right-radius: 0.375rem;
  border-top-right-radius: var(--bs-border-radius);
}

.dropdown-menu-header {
  color: #fff;
  margin-top: -0.65rem;
  margin-bottom: 0.65rem;
  position: relative;
  z-index: 6;
}
.dropdown-menu-header .dropdown-menu-header-inner {
  margin: -1px -1px 0;
  padding: 1.5rem 0.5rem;
  position: relative;
}
.dropdown-menu-header .menu-header-image {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 8;
  opacity: 0.25;
  filter: grayscale(80%);
  background-size: cover;
}
.dropdown-menu-header .menu-header-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.dropdown-menu-header .menu-header-content.text-start {
  padding-left: 0.5rem;
}
.dropdown-menu-header .menu-header-content.btn-pane-right {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
}
.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
  margin: 0 0 0 auto;
}
.dropdown-menu-header .menu-header-content .menu-header-btn-pane {
  margin-top: 10px;
  margin-bottom: 3px;
}
.dropdown-menu-header + .grid-menu {
  margin-top: -0.65rem;
}

.menu-header-title {
  font-weight: 500;
  font-size: 1.1rem;
  margin: 0;
}

.menu-header-subtitle {
  font-size: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: var(--bs-font-sans-serif);
  margin: 5px 0 0;
  opacity: 0.8;
}

.dropdown-menu .grid-menu {
  margin-bottom: -0.65rem;
  padding: 1px;
}
.dropdown-menu .grid-menu [class*=col-] {
  padding: 0.65rem;
}
.dropdown-menu .grid-menu-xl {
  margin-bottom: -0.4814814815rem;
}
.dropdown-menu .grid-menu-xl [class*=col-] {
  padding: 0;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
  margin-left: 5px;
}

.dropdown-toggle-split::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 2px;
}

.dropdown-menu::before, .dropdown-menu::after {
  position: absolute;
  width: 14px;
  height: 14px;
  left: 5px;
  top: -5px;
  transform: rotate(45deg);
  border-radius: 4px;
  content: "";
  display: block;
  z-index: 5;
}
.dropdown-menu::before {
  background: #fff;
  background: var(--bs-body-bg);
  z-index: 5;
}
.dropdown-menu::after {
  top: -6px;
  background: rgba(0, 0, 0, 0.175);
  background: var(--bs-border-color-translucent);
  z-index: 4;
}
.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {
  top: auto;
  bottom: -5px;
}
.dropdown-menu[data-placement=top-start]::after {
  bottom: -6px;
}
.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {
  left: auto;
  right: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=left-start]::after {
  top: 5px;
  right: -6px;
}
.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {
  right: auto;
  left: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=right-start]::after {
  top: 5px;
  left: -6px;
}
.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {
  left: auto;
  right: 6px;
}
.dropdown-menu.dropdown-menu-right::after {
  right: 6px;
}
.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {
  display: none;
}

.dropdown-mega-menu {
  width: 56rem;
  padding: 1rem;
}
.dropdown-mega-menu .nav-item.nav-item-header {
  text-transform: none;
  font-size: 0.88rem;
  padding-top: 0;
  font-weight: normal;
}
.dropdown-mega-menu .grid-menu {
  margin-bottom: 0;
}

.dropdown-mega-menu-sm {
  width: 40rem;
}

body .dropdown-menu.dropdown-menu-inline {
  border: 0;
  position: static !important;
  box-shadow: 0 0 0 transparent;
  background: transparent;
  border-radius: 0;
  display: inline-block;
  float: none;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  transform: translateY(0) !important;
}
body .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {
  display: none;
}

.nav-item .nav-link {
  font-weight: normal;
}

.nav-link {
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.nav-link .nav-link-icon {
  color: #545cd8;
  font-size: 1rem;
  width: 30px;
  text-align: center;
  opacity: 0.45;
  margin-left: -10px;
}
.nav-link:hover {
  color: #495057;
}
.nav-link:hover .nav-link-icon {
  opacity: 0.9;
  color: #545cd8;
}
.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {
  opacity: 0.3;
}

.nav-item.nav-item-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #6c757d;
  font-weight: bold;
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-btn {
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-divider {
  margin: 0.5rem 0;
  height: 1px;
  overflow: hidden;
  background: #dee2e6;
}

.nav .badge {
  margin-left: 8px;
}

.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {
  color: #fff;
}
.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {
  color: #fff;
  opacity: 0.8;
}
.nav-pills .nav-link:hover {
  color: #495057 !important;
}

.grid-menu [class*=col-] {
  border-right: #dee2e6 solid 0;
  border-bottom: #dee2e6 solid 1px;
}
.grid-menu [class*=col-]:hover {
  z-index: 5;
}
.grid-menu [class*=col-]:nth-last-child(-n+2) {
  border-bottom-width: 0;
}
.grid-menu [class*=col-]:nth-child(1n) {
  border-right-width: 1px;
}
.grid-menu [class*=col-]:nth-child(2n) {
  border-right-width: 0;
}
.grid-menu [class*=col-]:nth-last-child(-n+1) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {
  border-right-width: 1px;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {
  border-right-width: 0;
}
.grid-menu .btn {
  display: block;
  border: 0;
  min-width: 100%;
}

.badge {
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 10px;
  min-width: 19px;
}

.badge-light {
  background: #fff;
}

.badge-dot {
  text-indent: -999em;
  padding: 0;
  width: 8px;
  height: 8px;
  border: transparent solid 1px;
  border-radius: 30px;
  min-width: 2px;
}

.badge-dot-lg {
  width: 10px;
  height: 10px;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.375rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.badge-dot-sm {
  width: 6px;
  height: 6px;
}

.btn .badge {
  margin-left: 8px;
}
.btn .badge-dot {
  position: absolute;
  border: #fff solid 2px;
  top: -5px;
  right: -5px;
  width: 11px;
  height: 11px;
}
.btn .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
}
.btn .badge-dot.badge-dot-sm {
  width: 8px;
  height: 8px;
  border-width: 1px;
}
.btn .badge-dot-inside {
  top: 10px;
  right: 10px;
}

.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {
  top: 1px;
  right: 4px;
}
.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {
  top: 0px;
  right: 2px;
}
.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {
  top: -3px;
  right: -2px;
}
.btn-sm .rounded-pill, .btn-group-sm > .btn .rounded-pill {
  position: absolute;
  top: -4px;
  right: -4px;
}

.badge-abs {
  position: absolute;
  right: -3px;
  top: -3px;
}

.avatar-icon-wrapper {
  display: inline-block;
  margin-right: 0.1rem;
  position: relative;
}
.avatar-icon-wrapper .badge {
  position: absolute;
  right: -2px;
  top: -2px;
}
.avatar-icon-wrapper .badge:empty {
  display: block;
}
.avatar-icon-wrapper .badge.badge-bottom {
  top: auto;
  right: -2px;
  bottom: -2px;
}
.avatar-icon-wrapper .badge-dot {
  width: 10px;
  height: 10px;
  border: #fff solid 2px;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
  border: #fff solid 2px;
  top: 0;
  right: 0;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {
  top: auto;
  right: 0;
  bottom: 0;
}

.avatar-icon-add .avatar-icon {
  background: #e0f3ff;
  border: rgb(109.65, 116.45, 221.85) dashed 1px;
  color: #545cd8;
  text-align: center;
  opacity: 0.6;
}
.avatar-icon-add .avatar-icon i {
  font-style: normal;
  vertical-align: middle;
  font-size: 1.32rem;
  display: block;
  height: 100%;
}
.avatar-icon-add:hover {
  cursor: pointer;
}
.avatar-icon-add:hover .avatar-icon {
  opacity: 1;
}

a.avatar-icon-wrapper:hover .avatar-icon {
  opacity: 0.8;
}

.avatar-icon {
  display: block;
  width: 44px;
  height: 44px;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
}
.avatar-icon.rounded {
  border-radius: 0.65rem !important;
}

.avatar-icon-xl .avatar-icon {
  width: 64px;
  height: 64px;
}
.avatar-icon-xl.avatar-icon-add i {
  font-size: 1.76rem;
}

.avatar-icon-lg .avatar-icon {
  width: 54px;
  height: 54px;
}
.avatar-icon-lg.avatar-icon-add i {
  font-size: 1.54rem;
}

.avatar-icon-sm .avatar-icon {
  width: 34px;
  height: 34px;
}
.avatar-icon-sm.avatar-icon-add i {
  font-size: 1.1rem;
}

.avatar-icon-xs .avatar-icon {
  width: 26px;
  height: 26px;
  transition: transform 0.2s;
}
.avatar-icon-xs.avatar-icon-add i {
  line-height: 26px;
  font-size: 0.88rem;
}
.avatar-icon-xs:hover .avatar-icon {
  transform: scale(2);
}

.avatar-icon {
  border: #fff solid 3px;
  overflow: hidden;
}
.avatar-icon img {
  width: 100%;
  height: 100%;
}

.avatar-wrapper-overlap .avatar-icon-wrapper {
  z-index: 5;
  margin-left: -18px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper:hover {
  z-index: 7;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {
  margin-left: -30px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {
  margin-left: -24px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -14px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {
  margin-left: -10px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {
  margin-left: 0 !important;
}
.badge-pulse {
  -webkit-animation: pulse 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  position: relative;
}
.badge-pulse::before, .badge-pulse::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-animation-iteration-count: infinite;
}
.badge-pulse::after {
  -webkit-animation-delay: 0.33s;
  -webkit-animation-duration: 2.2s;
}

.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
.card > .dropdown-menu-header {
  margin: 0;
}
.card > .dropdown-menu-header .dropdown-menu-header-inner {
  border-top-left-radius: 0.375rem;
  border-top-left-radius: var(--bs-border-radius);
  border-top-right-radius: 0.375rem;
  border-top-right-radius: var(--bs-border-radius);
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header, .card.text-white .card-footer,
.card.text-white .card-header {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header {
  color: rgba(0, 0, 0, 0.9);
}
.card .card-footer {
  display: flex;
  align-items: center;
}

.btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
}

.btn-actions-pane-left {
  margin-right: auto;
}

.actions-icon-btn .btn-icon-only {
  padding-left: 0;
  padding-right: 0;
  color: #495057;
}
.actions-icon-btn .btn-icon-only .btn-icon-wrapper {
  font-size: 1.3rem;
  width: 30px;
  text-align: center;
}
.actions-icon-btn .btn-icon-only:hover {
  color: #545cd8;
}

.card-header,
.card-title {
  text-transform: uppercase;
  color: rgba(50.4, 55.2, 129.6, 0.7);
  font-weight: bold;
  font-size: 0.88rem;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0.5rem;
  height: 3.5rem;
}
.card-header.no-border {
  border: 0;
  padding: 0;
  height: auto;
}
.card-header .menu-header-subtitle {
  display: block;
}
.card-header.card-header-tab .nav {
  width: auto;
  margin-left: auto;
}
.card-header.card-header-tab .card-header-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.card-header .header-icon {
  font-size: 1.65rem;
  margin-right: 0.5rem;
}
.card-header > .nav {
  margin-left: -0.5rem;
  height: 100%;
  width: 100%;
}
.card-header > .nav .nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.card-header > .nav .nav-link {
  text-transform: none;
  width: 100%;
  display: block;
  color: #495057;
}
.card-header > .nav .nav-link::before {
  content: "";
  border-radius: 15px;
  background: #545cd8;
  transition: all 0.2s;
  height: 4px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -2px;
  opacity: 0;
}
.card-header > .nav .nav-link:hover {
  color: #545cd8;
}
.card-header > .nav .nav-link.active {
  color: #545cd8;
}
.card-header > .nav .nav-link.active::before {
  opacity: 1;
}
.card-header.card-header-tab-animation .nav .nav-link::before {
  transform: scale(0);
  opacity: 1;
  width: 90%;
  left: 5%;
}
.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {
  transform: scale(1);
}

.card-border {
  box-shadow: 0 0 0 transparent;
  border-width: 1px;
}

.card-hover-shadow:hover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}

.card-hover-shadow-2x:hover {
  box-shadow: 0 0.66875rem 2.3875rem rgba(42, 46, 108, 0.03), 0 1.1375rem 1.60625rem rgba(42, 46, 108, 0.03), 0 0.45rem 0.73125rem rgba(42, 46, 108, 0.05), 0 0.325rem 0.3875rem rgba(42, 46, 108, 0.03);
}

.card-subtitle {
  margin-bottom: 1rem;
  font-size: 0.968rem;
  color: rgba(50.4, 55.2, 129.6, 0.55);
}

.card-shadow-primary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);
}

.card-shadow-secondary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);
}

.card-shadow-success {
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);
}

.card-shadow-info {
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);
}

.card-shadow-warning {
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);
}

.card-shadow-danger {
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);
}

.card-shadow-light {
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);
}

.card-shadow-dark {
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);
}

.card-shadow-focus {
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);
}

.card-shadow-alternate {
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);
}

.card-header-lg {
  padding: 2rem 2rem;
  height: auto;
}

.sticky-active-class .sticky-inner-wrapper > div {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}

.nav-pills,
.nav-tabs {
  margin-bottom: 1rem;
}

.nav-link {
  font-weight: bold;
}
.nav-link:hover {
  cursor: pointer;
}

.nav-tabs .nav-link:hover {
  color: #545cd8 !important;
}
.nav-tabs .nav-link.active {
  color: #545cd8;
}

.nav-pills .nav-link:hover {
  color: #545cd8 !important;
}
.nav-pills .nav-link.active {
  background: #545cd8;
}
.nav-pills .nav-link.active:hover {
  color: #fff !important;
}

.RRT__container {
  position: relative;
}

.RRT__tabs {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.RRT__accordion {
  flex-direction: column;
}

.RRT__tab {
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  padding: 0.5rem 1rem;
  transition: all 0.2s;
}
.RRT__tab:hover {
  color: #545cd8;
}
.RRT__tab:focus {
  outline: 0;
}

.RRT__tab--selected {
  color: #545cd8;
}

.RRT__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RRT__tab:focus {
  z-index: 2;
}

.RRT__tab--selected .RRT__removable {
  position: relative;
}

.RRT__tab--selected .RRT__removable-text {
  margin-right: 10px;
}

.RRT__tab--selected .RRT__removable-icon {
  position: absolute;
  font-size: 18px;
  right: 0.5em;
  top: 0.2em;
}

.body-tabs.body-tabs-layout.body-tabs-big {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 auto;
  padding: 10px;
  border-radius: 50px;
  border: #e9ecef solid 1px;
  z-index: 7;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
  margin: 0;
  font-size: 1rem;
  font-weight: 300;
  padding: 0;
  height: 50px;
  line-height: 50px;
  flex: 1 1;
  text-align: center;
  position: relative;
  color: #545cd8;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {
  color: #212529;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {
  height: 70px !important;
  top: -70px !important;
  margin: 0 auto -3.4rem;
  position: relative;
  padding: 0 10px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {
  position: absolute;
  content: "";
  background: #fff;
  width: 100%;
  height: 100%;
  left: 0;
  top: -11px;
  border-radius: 50px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 50px !important;
  margin-top: 10px;
  border-radius: 50px;
  box-shadow: 0 0 0 transparent;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {
  margin-top: -1rem;
}

.RRT__panel {
  margin-top: 1rem;
}

.RRT__showmore {
  border-radius: 0.375rem;
  background: #545cd8;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  font-weight: bold;
  width: 36px;
  text-align: center;
  height: 36px;
  display: block;
  margin-left: 15px;
  position: absolute;
  right: 1rem;
  top: 50%;
  margin-top: -18px;
  font-size: 1.4rem;
}
.RRT__showmore:focus {
  outline: none;
}

.RRT__showmore-label {
  position: relative;
  z-index: 1;
  color: #fff;
  width: 36px;
  text-align: center;
  height: 36px;
  line-height: 24px;
}

.RRT__showmore--selected {
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.RRT__showmore-list {
  position: absolute;
  right: -1px;
  top: 100%;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.175);
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}
.RRT__showmore-list .RRT__tab {
  display: block;
  width: 100%;
  padding: 0.4rem 1rem;
  clear: both;
  font-weight: 400;
  color: #495057;
  color: var(--bs-body-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  margin: 0;
}
.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {
  color: #495057 !important;
  color: var(--bs-body-color) !important;
  text-decoration: none;
  background: #e0f3ff;
}

.RRT__showmore-list--opened {
  display: block;
}
.RRT__showmore-list--opened .RRT__tab--selected {
  color: #545cd8;
}

.RRT__inkbar-wrapper {
  width: 100%;
}

.RRT__inkbar {
  position: relative;
  bottom: 0;
  height: 3px;
  margin-top: -3px;
  background-color: #545cd8;
  border-radius: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
  z-index: 2;
}

.card-tabs .card-header {
  padding: 0 1.25rem;
}
.card-tabs .card-header.RRT__tabs {
  cursor: pointer;
  font-weight: normal;
}
.card-tabs .card-header.RRT__tabs .RRT__tab {
  text-transform: none;
  line-height: 1.3;
}
.card-tabs .RRT__inkbar-wrapper {
  width: calc(100% - 1.5rem) !important;
  margin-left: 1.25rem;
}
.card-tabs .RRT__panel {
  padding: 1rem;
  margin: 0;
}
.card-tabs.text-white .RRT__tab {
  color: rgba(255, 255, 255, 0.6);
}
.card-tabs.text-white .RRT__tab:hover {
  color: #fff;
}
.card-tabs.text-white .RRT__tab--selected {
  color: #fff;
}
.card-tabs.text-white .RRT__inkbar {
  background: rgb(152.4, 157.2, 231.6);
}

.card-tabs-animated .RRT__container > .RRT__tabs {
  background: transparent;
  position: relative;
  z-index: 7;
}
.card-tabs-animated .RRT__container > .RRT__tabs.card-header {
  border-bottom: 0;
  height: auto;
  padding: 1.5rem 1.5rem 0.5rem;
}
.card-tabs-animated .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.5rem;
  z-index: 5;
}
.card-tabs-animated .RRT__tab {
  padding: 0.5rem 1.2rem;
}
.card-tabs-animated .RRT__tab--selected {
  color: #fff;
}
.card-tabs-animated .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.375rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.card-tabs-animated-inner .RRT__tabs {
  padding: 0 5%;
}
.card-tabs-animated-inner .RRT__inkbar-wrapper {
  left: 5%;
  width: 90%;
  height: 36px;
  top: 14px;
}
.card-tabs-animated-inner .RRT__inkbar {
  height: 36px;
}

.body-tabs {
  border-bottom: #dee2e6 solid 2px;
}
.body-tabs > .RRT__tab {
  padding: 1rem 1.25rem;
  font-weight: normal;
  font-size: 0.88rem;
}
.body-tabs.body-tabs-alt > .RRT__tab {
  padding: 1.3636363636rem 0.5rem;
  font-weight: normal;
  font-size: 0.86rem;
  width: 33%;
  text-align: center;
}
.body-tabs.body-tabs-alt .RRT__inkbar {
  height: 2px;
  margin-top: -2px;
}

.popover .RRT__panel,
.dropdown-menu .RRT__panel {
  margin: 0;
  padding: 0;
  position: relative;
}
.popover .RRT__panel::after, .popover .RRT__panel::before,
.dropdown-menu .RRT__panel::after,
.dropdown-menu .RRT__panel::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 20px;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.popover .RRT__panel::after,
.dropdown-menu .RRT__panel::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.tabs-lg-alternate.card-header {
  padding: 0;
  height: auto;
}
.tabs-lg-alternate.card-header .widget-number {
  font-size: 1.76rem;
  font-weight: 300;
}
.tabs-lg-alternate.card-header .tab-subheading {
  padding: 5px 0 0;
  opacity: 0.6;
  transition: all 0.2s;
}
.tabs-lg-alternate.card-header > .nav {
  margin: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link {
  padding: 1.5rem 0;
  border-right: #e9ecef solid 1px;
  background: #f8f9fa;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-link::before {
  background: #fff;
  border-radius: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {
  border-right: 0;
}

.accordion-wrapper {
  border-radius: 0.375rem;
  border: #e9ecef solid 1px;
}
.accordion-wrapper > .card {
  box-shadow: 0 0 0 0 transparent;
}
.accordion-wrapper > .card > .card-header {
  padding: 1rem;
  height: auto;
}
.accordion-wrapper > .card > .card-header .btn:active,
.accordion-wrapper > .card > .card-header .btn:focus,
.accordion-wrapper > .card > .card-header .btn:hover {
  text-decoration: none;
}
.accordion-wrapper > .card > .card-header .form-heading p {
  margin: 0;
}
.accordion-wrapper > .card .collapse {
  border-bottom: transparent solid 1px;
}
.accordion-wrapper > .card .collapse.show {
  border-bottom-color: #e9ecef;
}

.modal-header,
.modal-footer {
  background: #f8f9fa;
}

.modal-footer {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.modal-dialog {
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(26, 29, 32, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.375rem;
}

/* NOTE: loaders.css/ is loaded from node_modules/ using sass-loader */
/**
 * Dots
 */
@keyframes scale {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }
  80% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-pulse > div:nth-child(0) {
  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(1) {
  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(2) {
  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(3) {
  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-pulse-sync {
  33% {
    transform: translateY(10px);
  }
  66% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.ball-pulse-sync > div:nth-child(0) {
  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(1) {
  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(2) {
  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(3) {
  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;
}
.ball-pulse-sync > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-scale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  height: 60px;
  width: 60px;
  animation: ball-scale 1s 0s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ball-rotate {
  position: relative;
}
.ball-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: relative;
}
.ball-rotate > div:first-child {
  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;
}
.ball-rotate > div:before, .ball-rotate > div:after {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  content: "";
  position: absolute;
  opacity: 0.8;
}
.ball-rotate > div:before {
  top: 0px;
  left: -28px;
}
.ball-rotate > div:after {
  top: 0px;
  left: 25px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  height: 25px;
  width: 25px;
  background: transparent !important;
  display: inline-block;
  animation: rotate 0.75s 0s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
@keyframes scale {
  30% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.ball-clip-rotate-pulse {
  position: relative;
  transform: translateY(-15px);
}
.ball-clip-rotate-pulse > div {
  animation-fill-mode: both;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 100%;
}
.ball-clip-rotate-pulse > div:first-child {
  background: #545cd8;
  height: 16px;
  width: 16px;
  top: 7px;
  left: -7px;
  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}
.ball-clip-rotate-pulse > div:last-child {
  position: absolute;
  border: 2px solid #545cd8;
  width: 30px;
  height: 30px;
  left: -16px;
  top: -2px;
  background: transparent;
  border: 2px solid;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
  animation-duration: 1s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate-multiple {
  position: relative;
}
.ball-clip-rotate-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  left: -20px;
  top: -20px;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  border-top-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  animation: rotate 1s 0s ease-in-out infinite;
}
.ball-clip-rotate-multiple > div:last-child {
  display: inline-block;
  top: -10px;
  left: -10px;
  width: 15px;
  height: 15px;
  animation-duration: 0.5s;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation-direction: reverse;
}

@keyframes ball-scale-ripple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple > div {
  animation-fill-mode: both;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-scale-ripple-multiple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple-multiple {
  position: relative;
  transform: translateY(-25px);
}
.ball-scale-ripple-multiple > div:nth-child(0) {
  animation-delay: -0.8s;
}
.ball-scale-ripple-multiple > div:nth-child(1) {
  animation-delay: -0.6s;
}
.ball-scale-ripple-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-ripple-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-ripple-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  top: -2px;
  left: -26px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    transform: scale(0.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: ball-beat 0.7s 0s infinite linear;
}
.ball-beat > div:nth-child(2n-1) {
  animation-delay: -0.35s !important;
}

@keyframes ball-scale-multiple {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale-multiple {
  position: relative;
  transform: translateY(-30px);
}
.ball-scale-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-multiple > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  left: -30px;
  top: 0px;
  opacity: 0;
  margin: 0;
  width: 60px;
  height: 60px;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

@keyframes ball-triangle-path-1 {
  33% {
    transform: translate(25px, -50px);
  }
  66% {
    transform: translate(50px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-2 {
  33% {
    transform: translate(25px, 50px);
  }
  66% {
    transform: translate(-25px, 50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-3 {
  33% {
    transform: translate(-50px, 0px);
  }
  66% {
    transform: translate(-25px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.ball-triangle-path {
  position: relative;
  transform: translate(-29.9940011998px, -37.5093773443px);
}
.ball-triangle-path > div:nth-child(1) {
  animation-name: ball-triangle-path-1;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(2) {
  animation-name: ball-triangle-path-2;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(3) {
  animation-name: ball-triangle-path-3;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div {
  animation-fill-mode: both;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid #545cd8;
}
.ball-triangle-path > div:nth-of-type(1) {
  top: 50px;
}
.ball-triangle-path > div:nth-of-type(2) {
  left: 25px;
}
.ball-triangle-path > div:nth-of-type(3) {
  top: 50px;
  left: 50px;
}

@keyframes ball-pulse-rise-even {
  0% {
    transform: scale(1.1);
  }
  25% {
    transform: translateY(-30px);
  }
  50% {
    transform: scale(0.4);
  }
  75% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(1);
  }
}
@keyframes ball-pulse-rise-odd {
  0% {
    transform: scale(0.4);
  }
  25% {
    transform: translateY(30px);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(0.75);
  }
}
.ball-pulse-rise > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);
  animation-iteration-count: infinite;
  animation-delay: 0;
}
.ball-pulse-rise > div:nth-child(2n) {
  animation-name: ball-pulse-rise-even;
}
.ball-pulse-rise > div:nth-child(2n-1) {
  animation-name: ball-pulse-rise-odd;
}

@keyframes ball-grid-beat {
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.ball-grid-beat {
  width: 57px;
}
.ball-grid-beat > div:nth-child(1) {
  animation-delay: 0.26s;
  animation-duration: 1.27s;
}
.ball-grid-beat > div:nth-child(2) {
  animation-delay: 0.61s;
  animation-duration: 1.04s;
}
.ball-grid-beat > div:nth-child(3) {
  animation-delay: 0.12s;
  animation-duration: 0.97s;
}
.ball-grid-beat > div:nth-child(4) {
  animation-delay: 0.29s;
  animation-duration: 0.88s;
}
.ball-grid-beat > div:nth-child(5) {
  animation-delay: 0.48s;
  animation-duration: 1.15s;
}
.ball-grid-beat > div:nth-child(6) {
  animation-delay: 0.78s;
  animation-duration: 1.07s;
}
.ball-grid-beat > div:nth-child(7) {
  animation-delay: 0.07s;
  animation-duration: 0.85s;
}
.ball-grid-beat > div:nth-child(8) {
  animation-delay: 0.49s;
  animation-duration: 1.38s;
}
.ball-grid-beat > div:nth-child(9) {
  animation-delay: 0.31s;
  animation-duration: 1.49s;
}
.ball-grid-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-beat;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-grid-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-grid-pulse {
  width: 57px;
}
.ball-grid-pulse > div:nth-child(1) {
  animation-delay: 0.37s;
  animation-duration: 0.96s;
}
.ball-grid-pulse > div:nth-child(2) {
  animation-delay: -0.06s;
  animation-duration: 1.49s;
}
.ball-grid-pulse > div:nth-child(3) {
  animation-delay: 0.08s;
  animation-duration: 1.1s;
}
.ball-grid-pulse > div:nth-child(4) {
  animation-delay: 0.67s;
  animation-duration: 0.64s;
}
.ball-grid-pulse > div:nth-child(5) {
  animation-delay: -0.04s;
  animation-duration: 1.14s;
}
.ball-grid-pulse > div:nth-child(6) {
  animation-delay: -0.05s;
  animation-duration: 0.75s;
}
.ball-grid-pulse > div:nth-child(7) {
  animation-delay: 0.54s;
  animation-duration: 0.7s;
}
.ball-grid-pulse > div:nth-child(8) {
  animation-delay: 0.09s;
  animation-duration: 0.87s;
}
.ball-grid-pulse > div:nth-child(9) {
  animation-delay: -0.04s;
  animation-duration: 1.15s;
}
.ball-grid-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-pulse;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-spin-fade-loader {
  50% {
    opacity: 0.3;
    transform: scale(0.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -10px;
}
.ball-spin-fade-loader > div:nth-child(1) {
  top: 25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.96s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(2) {
  top: 17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.84s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 25px;
  animation: ball-spin-fade-loader 1s -0.72s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(4) {
  top: -17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.6s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(5) {
  top: -25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.48s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(6) {
  top: -17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.36s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -25px;
  animation: ball-spin-fade-loader 1s -0.24s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(8) {
  top: 17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.12s infinite linear;
}
.ball-spin-fade-loader > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
}

@keyframes ball-spin-loader {
  75% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}
.ball-spin-loader {
  position: relative;
}
.ball-spin-loader > span:nth-child(1) {
  top: 45px;
  left: 0;
  animation: ball-spin-loader 2s 0.9s infinite linear;
}
.ball-spin-loader > span:nth-child(2) {
  top: 30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 1.8s infinite linear;
}
.ball-spin-loader > span:nth-child(3) {
  top: 0;
  left: 45px;
  animation: ball-spin-loader 2s 2.7s infinite linear;
}
.ball-spin-loader > span:nth-child(4) {
  top: -30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 3.6s infinite linear;
}
.ball-spin-loader > span:nth-child(5) {
  top: -45px;
  left: 0;
  animation: ball-spin-loader 2s 4.5s infinite linear;
}
.ball-spin-loader > span:nth-child(6) {
  top: -30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 5.4s infinite linear;
}
.ball-spin-loader > span:nth-child(7) {
  top: 0;
  left: -45px;
  animation: ball-spin-loader 2s 6.3s infinite linear;
}
.ball-spin-loader > span:nth-child(8) {
  top: 30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 7.2s infinite linear;
}
.ball-spin-loader > div {
  animation-fill-mode: both;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: green;
}

@keyframes ball-zig {
  33% {
    transform: translate(-15px, -30px);
  }
  66% {
    transform: translate(15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag {
  33% {
    transform: translate(15px, 30px);
  }
  66% {
    transform: translate(-15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag > div:first-child {
  animation: ball-zig 0.7s 0s infinite linear;
}
.ball-zig-zag > div:last-child {
  animation: ball-zag 0.7s 0s infinite linear;
}

@keyframes ball-zig-deflect {
  17% {
    transform: translate(-15px, -30px);
  }
  34% {
    transform: translate(15px, -30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(15px, -30px);
  }
  84% {
    transform: translate(-15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag-deflect {
  17% {
    transform: translate(15px, 30px);
  }
  34% {
    transform: translate(-15px, 30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(-15px, 30px);
  }
  84% {
    transform: translate(15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag-deflect {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag-deflect > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag-deflect > div:first-child {
  animation: ball-zig-deflect 1.5s 0s infinite linear;
}
.ball-zig-zag-deflect > div:last-child {
  animation: ball-zag-deflect 1.5s 0s infinite linear;
}

/**
 * Lines
 */
@keyframes line-scale {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale > div:nth-child(1) {
  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(2) {
  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(3) {
  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(4) {
  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(5) {
  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes line-scale-party {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
.line-scale-party > div:nth-child(1) {
  animation-delay: 0.4s;
  animation-duration: 0.87s;
}
.line-scale-party > div:nth-child(2) {
  animation-delay: 0.1s;
  animation-duration: 0.54s;
}
.line-scale-party > div:nth-child(3) {
  animation-delay: 0.14s;
  animation-duration: 1.21s;
}
.line-scale-party > div:nth-child(4) {
  animation-delay: -0.09s;
  animation-duration: 0.76s;
}
.line-scale-party > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-name: line-scale-party;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes line-scale-pulse-out {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);
}
.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {
  animation-delay: -0.4s !important;
}
.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {
  animation-delay: -0.2s !important;
}

@keyframes line-scale-pulse-out-rapid {
  0% {
    transform: scaley(1);
  }
  80% {
    transform: scaley(0.3);
  }
  90% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out-rapid > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  vertical-align: middle;
  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);
}
.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {
  animation-delay: -0.25s !important;
}
.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {
  animation-delay: 0s !important;
}

@keyframes line-spin-fade-loader {
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.line-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -4px;
}
.line-spin-fade-loader > div:nth-child(1) {
  top: 20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(2) {
  top: 13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(4) {
  top: -13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(5) {
  top: -20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(6) {
  top: -13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(8) {
  top: 13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;
}
.line-spin-fade-loader > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  width: 5px;
  height: 15px;
}

/**
 * Misc
 */
@keyframes triangle-skew-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.triangle-skew-spin > div {
  animation-fill-mode: both;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #545cd8;
  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes square-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.square-spin > div {
  animation-fill-mode: both;
  width: 50px;
  height: 50px;
  background: #545cd8;
  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes rotate_pacman_half_up {
  0% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
@keyframes rotate_pacman_half_down {
  0% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translate(-100px, -6.25px);
  }
}
.pacman {
  position: relative;
}
.pacman > div:nth-child(2) {
  animation: pacman-balls 1s -0.99s infinite linear;
}
.pacman > div:nth-child(3) {
  animation: pacman-balls 1s -0.66s infinite linear;
}
.pacman > div:nth-child(4) {
  animation: pacman-balls 1s -0.33s infinite linear;
}
.pacman > div:nth-child(5) {
  animation: pacman-balls 1s 0s infinite linear;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_up 0.5s 0s infinite;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_down 0.5s 0s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}

@keyframes cube-transition {
  25% {
    transform: translateX(50px) scale(0.5) rotate(-90deg);
  }
  50% {
    transform: translate(50px, 50px) rotate(-180deg);
  }
  75% {
    transform: translateY(50px) scale(0.5) rotate(-270deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.cube-transition {
  position: relative;
  transform: translate(-25px, -25px);
}
.cube-transition > div {
  animation-fill-mode: both;
  width: 10px;
  height: 10px;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: #545cd8;
  animation: cube-transition 1.6s 0s infinite ease-in-out;
}
.cube-transition > div:last-child {
  animation-delay: -0.8s;
}

@keyframes spin-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.semi-circle-spin {
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
}
.semi-circle-spin > div {
  position: absolute;
  border-width: 0px;
  border-radius: 100%;
  animation: spin-rotate 0.6s 0s infinite linear;
  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);
  width: 100%;
  height: 100%;
}

.progress .progress-bar:last-child {
  border-top-right-radius: 0.375rem;
  border-top-right-radius: var(--bs-border-radius);
  border-bottom-right-radius: 0.375rem;
  border-bottom-right-radius: var(--bs-border-radius);
}
.progress.progress-bar-sm {
  height: 0.5rem;
}
.progress.progress-bar-xs {
  height: 0.3rem;
}
.progress.progress-bar-rounded {
  border-radius: 30px;
}

.progress-bar-animated-alt.progress-bar,
.progress-bar-animated-alt .progress-bar {
  position: relative;
}
.progress-bar-animated-alt.progress-bar::after,
.progress-bar-animated-alt .progress-bar::after {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  animation: progress-active 2s ease infinite;
}

@keyframes progress-active {
  0% {
    opacity: 0.4;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}
.vertical-timeline::after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.375rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}
.vertical-timeline-element:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element:last-child {
  margin-bottom: 0;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}
.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}
.vertical-timeline-element-content p {
  color: #6c757d;
  margin: 0 0 0.5rem;
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619047619rem;
  white-space: nowrap;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}
.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.vertical-timeline-element--no-children .vertical-timeline-element-content {
  background: 0 0;
  box-shadow: none;
}
.vertical-timeline-element--no-children .vertical-timeline-element-content::before {
  display: none;
}

.vertical-without-time::before {
  left: 11px;
}
.vertical-without-time .vertical-timeline-element-content {
  margin-left: 36px;
}
.vertical-without-time .vertical-timeline-element-icon {
  left: 4px;
}

.vertical-time-icons {
  padding: 2rem 0 0;
}
.vertical-time-icons::before {
  content: "";
  position: absolute;
  top: 0;
  left: 14px;
  height: 100%;
  width: 6px;
  background: #e9ecef;
  border-radius: 0.375rem;
}
.vertical-time-icons .vertical-timeline-element {
  margin-bottom: 1rem;
}
.vertical-time-icons .vertical-timeline-element-content {
  margin-left: 50px;
}
.vertical-time-icons .vertical-timeline-element-icon {
  width: 34px;
  height: 34px;
  left: 0;
  top: -7px;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {
  width: 34px;
  height: 34px;
  background: #fff;
  border-radius: 50px;
  border-width: 2px;
  border-style: solid;
  box-shadow: 0 0 0 5px #fff;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {
  display: block;
  font-size: 1.1rem;
  margin: 0 auto;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {
  margin: 0 auto;
}

.vertical-time-simple {
  padding: 0.5rem 0;
}
.vertical-time-simple .vertical-timeline-element {
  margin: 0 0 0.5rem;
}
.vertical-time-simple .timeline-title {
  font-weight: normal;
  font-size: 0.9166666667rem;
  padding: 0;
}
.vertical-time-simple .vertical-timeline-element-icon {
  height: 14px;
  width: 14px;
  background: #e9ecef;
  position: absolute;
  left: 6px;
  top: 2px;
  display: block;
  border-radius: 20px;
}
.vertical-time-simple .vertical-timeline-element-icon::after {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.vertical-time-simple .timeline-title {
  text-transform: none;
}

.dot-primary .vertical-timeline-element-icon {
  background: #545cd8;
}

.dot-secondary .vertical-timeline-element-icon {
  background: #6c757d;
}

.dot-success .vertical-timeline-element-icon {
  background: #3ac47d;
}

.dot-info .vertical-timeline-element-icon {
  background: #30b1ff;
}

.dot-warning .vertical-timeline-element-icon {
  background: #f7b924;
}

.dot-danger .vertical-timeline-element-icon {
  background: #d92550;
}

.dot-light .vertical-timeline-element-icon {
  background: #eeeeee;
}

.dot-dark .vertical-timeline-element-icon {
  background: #343a40;
}

.dot-focus .vertical-timeline-element-icon {
  background: #444054;
}

.dot-alternate .vertical-timeline-element-icon {
  background: #83588a;
}

.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
  visibility: visible;
  animation: cd-bounce-2 0.6s;
}

@media only screen and (min-width: 1170px) {
  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@media only screen and (max-width: 1169px) {
  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
.todo-list-wrapper .todo-indicator {
  position: absolute;
  width: 4px;
  height: 60%;
  border-radius: 0.5rem;
  left: 0.5rem;
  top: 20%;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.todo-list-wrapper .list-group-item:hover .todo-indicator {
  opacity: 0.9;
}
.todo-list-wrapper .custom-control,
.todo-list-wrapper input[checkbox] {
  margin-left: 0.5rem;
}

.list-group-flush + .card-footer {
  border-top: 0;
}

.rm-list-borders .list-group-item {
  border: 0;
  padding: 0.6666666667rem 0;
}

.rm-list-borders-scroll .list-group-item {
  border: 0;
  padding-right: 1.5rem;
}

.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.input-group > div:not([class]) {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > div:not([class]) .react-datepicker__input-container .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .input-group-prepend + div {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

legend {
  font-size: 0.88rem;
  font-weight: bold;
}

.form-heading {
  font-size: 1.1rem;
  margin: 0;
  color: #545cd8;
}
.form-heading p {
  color: #6c757d;
  padding: 0.3rem 0 0;
  font-size: 0.88rem;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pagination li a {
  position: relative;
  display: block;
  padding: 0.375rem 0.75rem;
  margin-left: -var(--bs-border-width);
  color: #545cd8;
  color: var(--bs-link-color);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
}
.pagination li a:hover {
  z-index: 2;
  color: rgb(67.2, 73.6, 172.8);
  color: var(--bs-link-hover-color);
  text-decoration: none;
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  border-color: #dee2e6;
  border-color: var(--bs-border-color);
}
.pagination li a:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}
.pagination li a:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.pagination li:first-child a {
  margin-left: 0;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.pagination li:last-child a {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.pagination li.active a {
  z-index: 1;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.pagination li.active a:hover {
  color: #fff;
}
.pagination li.disabled a {
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
  pointer-events: none;
  cursor: auto;
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  border-color: #dee2e6;
  border-color: var(--bs-border-color);
}

.pagination-rounded li a {
  border-radius: 50px !important;
  margin: 0 0.3rem;
}

.chat-box-wrapper {
  display: flex;
  clear: both;
  padding: 0.75rem;
}
.chat-box-wrapper + .chat-box-wrapper {
  padding-top: 0;
}
.chat-box-wrapper .chat-box {
  box-shadow: 0 0 0 transparent;
  position: relative;
  opacity: 1;
  background: #e0f3ff;
  border: 0;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  border-top-left-radius: 0.375rem;
  flex: 1 1;
  display: flex;
  max-width: 50%;
  min-width: 100%;
  text-align: left;
}
.chat-box-wrapper .chat-box + small, .chat-box-wrapper .chat-box + .small {
  text-align: left;
  padding: 0.5rem 0 0;
  margin-left: 1.5rem;
  display: block;
}
.chat-box-wrapper.chat-box-wrapper-right {
  text-align: right;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box {
  border-radius: 30px;
  border-top-left-radius: 30px;
  border-top-right-radius: 0.375rem;
  margin-left: auto;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box + small, .chat-box-wrapper.chat-box-wrapper-right .chat-box + .small {
  text-align: right;
  margin-right: 1.5rem;
  margin-left: 0;
}

.forms-wizard {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-radius: 0.375rem;
}
.forms-wizard li {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem 0;
  color: #adb5bd;
  position: relative;
}
.forms-wizard li::after, .forms-wizard li::before {
  position: absolute;
  height: 4px;
  top: 50%;
  margin-top: -1rem;
  width: 50%;
  content: "";
  background: #dee2e6;
  z-index: 5;
  transition: all 0.2s;
}
.forms-wizard li::after {
  left: 50%;
}
.forms-wizard li::before {
  left: 0;
}
.forms-wizard li:first-child::before {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.forms-wizard li:last-child::after {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.forms-wizard li em {
  font-style: normal;
  font-size: 1.32rem;
  background: #ced4da;
  color: #fff;
  text-align: center;
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  display: block;
  margin: 0 auto 0.5rem;
  position: relative;
  z-index: 7;
  transition: all 0.2s;
}
.forms-wizard li.form-wizard-step-doing {
  color: #495057;
}
.forms-wizard li.form-wizard-step-doing em {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-doing::before {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-done em {
  font-family: "Linearicons-Free";
  background: #3ac47d;
  overflow: hidden;
}
.forms-wizard li.form-wizard-step-done em::before {
  width: 42px;
  height: 42px;
  font-size: 1.2rem;
  line-height: 40px;
  text-align: center;
  display: block;
}
.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {
  background: #3ac47d;
}
.forms-wizard li:hover {
  color: #6c757d;
}

.forms-wizard-alt .forms-wizard li {
  font-size: 0.88rem;
}
.forms-wizard-alt .forms-wizard li em {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-indent: -999rem;
  border: #fff solid 2px;
  margin: -7px auto 0;
}

.forms-wizard-vertical .forms-wizard {
  display: block;
  width: 30%;
  float: left;
  padding: 0 1.5rem 1.5rem 0;
}
.forms-wizard-vertical .forms-wizard li {
  text-align: left;
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.2s;
}
.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
  display: none;
}
.forms-wizard-vertical .forms-wizard li em {
  margin: 0 0.75rem 0 0;
}
.forms-wizard-vertical .forms-wizard li:hover {
  background: #e9ecef;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
  background: #545cd8;
  color: #fff;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
  background: rgba(255, 255, 255, 0.2);
}
.forms-wizard-vertical .form-wizard-content {
  width: 70%;
  overflow: auto;
}

@media screen and (min-width: 360px) and (max-width: 812px) {
  .forms-wizard-vertical .forms-wizard {
    display: block;
    width: 50%;
    float: left;
    padding: 0 1.5rem 1.5rem 0;
  }
  .forms-wizard-vertical .forms-wizard li {
    text-align: left;
    display: flex;
    align-items: center;
    align-content: flex-start;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 0.5rem;
    transition: all 0.2s;
  }
  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
    display: none;
  }
  .forms-wizard-vertical .forms-wizard li em {
    margin: 0 0.75rem 0 0;
  }
  .forms-wizard-vertical .forms-wizard li:hover {
    background: #e9ecef;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
    background: #545cd8;
    color: #fff;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
    background: rgba(255, 255, 255, 0.2);
  }
  .forms-wizard-vertical .form-wizard-content {
    width: 50%;
    overflow: auto;
  }
}
.icon-wrapper {
  display: flex;
  align-content: center;
  align-items: center;
}

.widget-chart {
  text-align: center;
  padding: 1rem;
  position: relative;
}
.widget-chart .progress-sub-label {
  opacity: 0.8;
  padding: 5px 0 0;
}
.widget-chart .progress-circle-wrapper {
  min-width: 68px;
  margin-right: 1rem;
}
.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {
  font-size: 0.8rem;
}
.widget-chart .widget-chart-content {
  position: relative;
  z-index: 5;
}
.widget-chart .widget-chart-content-lg {
  padding: 2rem 0 1rem 2rem;
}
.widget-chart .widget-chart-content-lg .widget-numbers {
  margin-bottom: 0;
}
.widget-chart .widget-chart-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.25;
  z-index: 6;
  border-bottom-right-radius: 0.375rem;
  border-bottom-right-radius: var(--bs-border-radius);
  border-bottom-left-radius: 0.375rem;
  border-bottom-left-radius: var(--bs-border-radius);
  overflow: hidden;
}
.widget-chart .widget-numbers {
  font-weight: bold;
  font-size: 2.5rem;
  display: block;
  line-height: 1;
  margin: 1rem auto;
}
.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {
  margin-top: -0.5rem;
}
.widget-chart .widget-subheading {
  margin: -0.5rem 0 0;
  display: block;
  opacity: 0.6;
}
.widget-chart .widget-subheading:first-child {
  margin-top: 0;
}
.widget-chart .widget-subheading + .widget-numbers {
  margin-top: 0.5rem;
}
.widget-chart .widget-description {
  margin: 1rem 0 0;
}
.widget-chart.widget-chart-hover {
  transition: all 0.2s;
}
.widget-chart.widget-chart-hover:hover {
  z-index: 15;
  transform: scale(1.15);
  box-shadow: 0 0.46875rem 4.1875rem rgba(42, 46, 108, 0.05), 0 0.9375rem 2.40625rem rgba(42, 46, 108, 0.05), 0 0.25rem 1.3125rem rgba(42, 46, 108, 0.06), 0 0.125rem 1.1875rem rgba(42, 46, 108, 0.06);
  cursor: pointer;
  background: #fff;
}
.widget-chart .widget-chart-actions {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 12;
}
.widget-chart .widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}
.widget-chart .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  margin: 0 -1px -1px;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.375rem;
  border-bottom-right-radius: var(--bs-border-radius);
  border-bottom-left-radius: 0.375rem;
  border-bottom-left-radius: var(--bs-border-radius);
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {
  border-bottom-left-radius: 0.375rem;
  border-bottom-left-radius: var(--bs-border-radius);
}
.widget-chart .widget-chart-flex {
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 1rem;
}
.widget-chart .widget-chart-flex:last-child {
  margin-bottom: 0;
}
.widget-chart .widget-chart-flex .widget-subheading {
  margin: 0;
}
.widget-chart .widget-chart-flex .widget-description {
  margin-top: 0;
}
.widget-chart.text-start {
  flex-direction: row;
  align-items: center;
}
.widget-chart.text-start .icon-wrapper {
  min-width: 54px;
  margin: 0 1rem 0 0;
}
.widget-chart.text-start .widget-numbers {
  margin-left: 0;
}
.widget-chart.text-start .widget-chart-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  flex: 1 1;
  position: relative;
}
.widget-chart.text-start .widget-chart-content > .widget-numbers:first-child {
  margin-top: 0;
}
.widget-chart.text-start .widget-chart-content .widget-description {
  align-self: flex-start;
}
.widget-chart.text-start .widget-chart-wrapper {
  height: 35%;
}
.widget-chart.widget-chart-left {
  padding-bottom: 15%;
}
.widget-chart .chart-wrapper-relative {
  position: relative;
  opacity: 1;
  margin-top: 1rem;
}

.widget-chart-actions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 12;
}
.widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}

.widget-chart:hover .widget-chart-actions .btn-link,
.widget-content:hover .widget-chart-actions .btn-link {
  opacity: 1;
}

.grid-menu .widget-chart.widget-chart-hover:hover {
  background: #fff;
  background: var(--bs-body-bg);
  border-radius: 0.375rem;
}

.icon-wrapper {
  width: 54px;
  height: 54px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.icon-wrapper[class*=border-] {
  border-width: 1px;
  border-style: solid;
}
.icon-wrapper .icon-wrapper-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 3;
  opacity: 0.2;
}
.icon-wrapper .icon-wrapper-bg.bg-light {
  opacity: 0.08;
}
.icon-wrapper i {
  margin: 0 auto;
  font-size: 1.7rem;
  position: relative;
  z-index: 5;
}
.icon-wrapper i:before {
  margin-top: -3px;
}
.icon-wrapper .progress-circle-wrapper {
  width: 100%;
  margin-right: 0;
}

.widget-chart2 .widget-chart-flex {
  display: flex;
  align-items: baseline;
  align-content: center;
  margin-bottom: 0;
}
.widget-chart2 .widget-chart-flex .widget-subtitle {
  margin-left: auto;
}
.widget-chart2 .widget-chart-flex .widget-numbers {
  font-weight: normal;
}
.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {
  margin-bottom: 0;
}
.widget-chart2 .widget-chat-wrapper-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  max-width: 100%;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {
  height: 70px;
  opacity: 0.8;
  position: relative;
  margin: 1rem auto -0.5rem;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {
  height: 130px;
}

.card-btm-border {
  border-bottom: transparent solid 4px;
}

.progress-box {
  text-align: center;
}
.progress-box h4, .progress-box .h4 {
  font-size: 0.88rem;
  font-weight: bold;
  opacity: 0.6;
  text-transform: uppercase;
  padding-bottom: 0.3333333333rem;
}
.progress-box svg {
  margin: 0 auto;
}

.svg-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}
.svg-bg svg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.widget-numbers-sm {
  font-size: 1.5rem;
}

.widget-content {
  padding: 1rem;
  flex-direction: row;
  align-items: center;
}
.widget-content .widget-content-wrapper {
  display: flex;
  flex: 1 1;
  position: relative;
  align-items: center;
}
.widget-content .widget-content-left .widget-heading {
  opacity: 0.8;
  font-weight: bold;
}
.widget-content .widget-content-left .widget-subheading {
  opacity: 0.5;
}
.widget-content .widget-content-right {
  margin-left: auto;
}
.widget-content .widget-numbers {
  font-weight: bold;
  font-size: 1.8rem;
  display: block;
}
.widget-content .widget-content-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.widget-content .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-content .widget-progress-wrapper .progress-sub-label {
  margin-top: 0.3333333333rem;
  opacity: 0.5;
  display: flex;
  align-content: center;
  align-items: center;
}
.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {
  margin-left: auto;
}
.widget-content .widget-content-right.widget-content-actions {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}
.widget-content:hover .widget-content-right.widget-content-actions {
  visibility: visible;
  opacity: 1;
}

.profile-block {
  position: relative;
  overflow: hidden;
}
.profile-block .profile-blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  transform: scale(1.8);
  position: absolute;
  left: -25%;
  top: -25%;
}
.profile-block .profile-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  left: 0;
  top: 0;
}
.profile-block .dropdown-menu-header .menu-header-content {
  padding: 3rem;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {
  margin: 0.75rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {
  color: #fff;
  padding: 0;
  width: 44px;
  height: 44px;
  line-height: 37px;
  font-size: 1.1rem;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.app-logo {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.app-logo-inverse {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.app-login-box .app-logo {
  margin-bottom: 3rem;
}
.app-login-box h4, .app-login-box .h4 {
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.app-login-box h4 div, .app-login-box .h4 div {
  opacity: 0.6;
}
.app-login-box h4 span, .app-login-box .h4 span {
  font-size: 1.1rem;
}

.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {
  width: auto;
  float: none;
}
.app-inner-layout .app-inner-layout__header {
  width: 100%;
  padding: 1.5rem;
  text-align: left;
  border-bottom: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__header .app-page-title {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-inner-layout .app-inner-layout__header-boxed {
  padding: 1.5rem;
}
.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {
  border-radius: 0.5rem;
}
.app-inner-layout .app-inner-layout__wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {
  flex: 1 1;
  display: flex;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  border: 0;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
  padding: 0.75rem 1.5rem;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {
  display: flex;
  align-items: center;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {
  padding: 1.5rem;
  border-top: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {
  width: 270px;
  list-style: none;
  text-align: left;
  order: -1;
  flex: 0 0 270px;
  display: flex;
  margin: 0;
  position: relative;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {
  white-space: normal;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  background: #f8f9fa;
  border: 0;
  border-right: #e9ecef solid 1px;
  border-left: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {
  background: #f8f9fa;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {
  width: 60px;
}
.app-inner-layout .app-inner-layout__footer {
  width: 100%;
  height: 50px;
}

.app-wrapper-footer .app-footer {
  border-top: #e9ecef solid 1px;
}
.app-wrapper-footer .app-footer .app-footer__inner {
  border-left: #e9ecef solid 1px;
}

.chat-layout.app-inner-layout .app-inner-layout__sidebar {
  width: 360px;
  flex: 0 0 360px;
}
.chat-layout .app-inner-layout__top-pane h4, .chat-layout .app-inner-layout__top-pane .h4 {
  font-size: 1.1rem;
}
.chat-layout .app-inner-layout__top-pane h4 div, .chat-layout .app-inner-layout__top-pane .h4 div {
  font-size: 0.88rem;
}
.chat-layout .chat-box-wrapper {
  padding: 1.5rem;
}

@media (max-width: 991.98px) {
  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {
    white-space: normal;
  }
}
.mobile-app-menu-btn {
  display: none;
  margin: 3px 1.5rem 0 0;
}

@media (max-width: 767.98px) {
  .app-inner-layout__sidebar {
    display: none !important;
  }
  .mobile-app-menu-btn {
    display: block;
  }
  .open-mobile-menu .app-inner-layout__sidebar {
    display: block !important;
  }
}
/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none !important;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0;
  /* please don't change 'position' */
  position: absolute;
  z-index: 7;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
  border-radius: 50px;
  z-index: 7;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus {
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.12);
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.12);
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.scrollbar-container {
  position: relative;
  height: 100%;
}

.scroll-area {
  overflow-x: hidden;
  height: 400px;
}

.scroll-area-xs {
  height: 150px;
  overflow-x: hidden;
}

.scroll-area-sm {
  height: 200px;
  overflow-x: hidden;
}

.scroll-area-md {
  height: 300px;
  overflow-x: hidden;
}

.scroll-area-lg {
  height: 400px;
  overflow-x: hidden;
}

.scroll-area-x {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.shadow-overflow {
  position: relative;
}
.shadow-overflow::after, .shadow-overflow::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 1.5rem;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.shadow-overflow::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.rc-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.rc-tabs-bar,
.rc-tabs-nav-container {
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  outline: none;
  zoom: 1;
  transition: padding 0.45s;
}

.rc-tabs-ink-bar {
  margin-top: 0;
  border-radius: 0.375rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.rc-tabs-ink-bar-animated {
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
}

.rc-tabs-tab-prev,
.rc-tabs-tab-next {
  -webkit-user-select: none;
  user-select: none;
  z-index: 1;
  line-height: 36px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: absolute;
}

.rc-tabs-tab-prev-icon,
.rc-tabs-tab-next-icon {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  font-smoothing: antialiased;
  text-stroke-width: 0;
  font-family: sans-serif;
}

.rc-tabs-tab-prev-icon:before,
.rc-tabs-tab-next-icon:before {
  display: block;
}

.rc-tabs-tab-btn-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-nav-wrap {
  overflow: hidden;
}

.rc-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  position: relative;
  margin: 0;
  float: left;
  list-style: none;
  display: inline-block;
  transform-origin: 0 0;
}
.rc-tabs-nav > div:first-child {
  z-index: 5;
  position: relative;
}

.rc-tabs-nav-animated {
  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);
}

.rc-tabs-nav:before,
.rc-tabs-nav:after {
  display: table;
  content: " ";
}

.rc-tabs-nav:after {
  clear: both;
}

.rc-tabs-tab {
  box-sizing: border-box;
  position: relative;
  display: block;
  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  padding: 8px 20px;
  cursor: pointer;
}

.rc-tabs-tab:hover {
  color: #545cd8;
}

.rc-tabs-tab-active,
.rc-tabs-tab-active:hover {
  color: #fff;
  cursor: default;
  transform: translateZ(0);
}

.rc-tabs-tab-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-tab-disabled:hover {
  color: #495057;
}

.rc-tabs-content {
  zoom: 1;
}

.rc-tabs-content .rc-tabs-tabpane {
  overflow: hidden;
}

.rc-tabs-content-animated {
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  display: flex;
  will-change: transform;
}

.rc-tabs-content-animated .rc-tabs-tabpane {
  flex-shrink: 0;
}

.no-flexbox .rc-tabs-content {
  transform: none !important;
  overflow: hidden;
}

.no-csstransitions .rc-tabs-tabpane-inactive,
.no-flexbox .rc-tabs-tabpane-inactive,
.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {
  display: none;
}

.rc-tabs-bottom .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-content {
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-container-scrolling {
  padding-left: 35px;
  padding-right: 35px;
}

.rc-tabs-top .rc-tabs-nav-scroll {
  width: 99999px;
}

.rc-tabs-top .rc-tabs-nav-swipe {
  position: relative;
  left: 0;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {
  display: flex;
  flex: 1 1;
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {
  display: flex;
  flex-shrink: 0;
  margin-right: 0;
  padding: 8px 0;
  justify-content: center;
}

.rc-tabs-top .rc-tabs-nav-wrap {
  width: 100%;
  padding: 1.5rem 0.5rem;
}

.rc-tabs-top .rc-tabs-content-animated {
  flex-direction: row;
}

.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {
  width: 100%;
}

.rc-tabs-top .rc-tabs-tab-next {
  right: 2px;
}

.rc-tabs-top .rc-tabs-tab-next-icon:before {
  content: ">";
}

.rc-tabs-top .rc-tabs-tab-prev {
  left: 0;
}

.rc-tabs-top .rc-tabs-tab-prev-icon:before {
  content: "<";
}

.rc-tabs-top .rc-tabs-tab-prev,
.rc-tabs-top .rc-tabs-tab-next {
  margin-right: -2px;
  width: 0;
  height: 0;
  top: 0;
  text-align: center;
  opacity: 0;
  transition: width 0.3s, height 0.3s, opacity 0.3s;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 35px;
  height: 100%;
}

.rc-tabs-top .rc-tabs-ink-bar {
  height: 35px;
  bottom: 0;
  left: 0;
  background: #545cd8;
}

.rc-tabs-top .rc-tabs-tab {
  float: left;
  height: 100%;
  line-height: 1.3;
  margin-right: 0.75rem;
}

.rc-tabs-top .rc-tabs-tabpane-inactive {
  height: 0;
  overflow: visible;
}

/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2018 Hakim El Hattab, http://hakim.se
 */
/*************************************
 * CONFIG
 */
/*************************************
 * MIXINS
 */
/*************************************
 * Opacity animation for spin.js
 */
@keyframes ladda-spinner-line-fade {
  0%, 100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
/*************************************
 * BUTTON BASE
 */
.ladda-button {
  position: relative;
}

/* Spinner animation */
.ladda-button .ladda-spinner {
  position: absolute;
  z-index: 2;
  display: inline-block;
  width: 32px;
  top: 50%;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
}

/* Button label */
.ladda-button .ladda-label {
  position: relative;
  z-index: 3;
}

[class*=btn-outline-] .ladda-spinner div div div {
  background: #000 !important;
}
[class*=btn-outline-].ladda-button .ladda-label {
  transition: none !important;
}

/* Progress bar */
.ladda-button .ladda-progress {
  position: absolute;
  width: 0;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  display: none;
  transition: 0.1s linear all !important;
}

.ladda-button[data-loading] .ladda-progress {
  display: block;
}

/*************************************
 * EASING
 */
.ladda-button,
.ladda-button .ladda-spinner,
.ladda-button .ladda-label {
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
}

.ladda-button[data-style=zoom-in],
.ladda-button[data-style=zoom-in] .ladda-spinner,
.ladda-button[data-style=zoom-in] .ladda-label,
.ladda-button[data-style=zoom-out],
.ladda-button[data-style=zoom-out] .ladda-spinner,
.ladda-button[data-style=zoom-out] .ladda-label {
  transition: 0.3s ease all !important;
}

/*************************************
 * EXPAND RIGHT
 */
.ladda-button[data-style=expand-right] .ladda-spinner {
  right: -6px;
}
.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {
  right: -12px;
}
.ladda-button[data-style=expand-right][data-loading] {
  padding-right: 56px;
}
.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {
  padding-right: 40px;
}

/*************************************
 * EXPAND LEFT
 */
.ladda-button[data-style=expand-left] .ladda-spinner {
  left: 26px;
}
.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {
  left: 4px;
}
.ladda-button[data-style=expand-left][data-loading] {
  padding-left: 56px;
}
.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {
  padding-left: 40px;
}

/*************************************
 * EXPAND UP
 */
.ladda-button[data-style=expand-up] {
  overflow: hidden;
}
.ladda-button[data-style=expand-up] .ladda-spinner {
  top: -32px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-up][data-loading] {
  padding-top: 54px;
}
.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {
  opacity: 1;
  top: 26px;
  margin-top: 0;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {
  padding-top: 32px;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {
  top: 4px;
}

/*************************************
 * EXPAND DOWN
 */
.ladda-button[data-style=expand-down] {
  overflow: hidden;
}
.ladda-button[data-style=expand-down] .ladda-spinner {
  top: 52px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {
  top: 40px;
}
.ladda-button[data-style=expand-down][data-loading] {
  padding-bottom: 54px;
}
.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {
  padding-bottom: 32px;
}

/*************************************
 * SLIDE LEFT
 */
.ladda-button[data-style=slide-left] {
  overflow: hidden;
}
.ladda-button[data-style=slide-left] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-left] .ladda-spinner {
  left: 100%;
  margin-left: 0;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-label {
  opacity: 0;
  left: -100%;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE RIGHT
 */
.ladda-button[data-style=slide-right] {
  overflow: hidden;
}
.ladda-button[data-style=slide-right] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-right] .ladda-spinner {
  right: 100%;
  margin-left: 0;
  left: 16px;
}
[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {
  right: auto;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-label {
  opacity: 0;
  left: 100%;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE UP
 */
.ladda-button[data-style=slide-up] {
  overflow: hidden;
}
.ladda-button[data-style=slide-up] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-up] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: 1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-label {
  opacity: 0;
  top: -1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * SLIDE DOWN
 */
.ladda-button[data-style=slide-down] {
  overflow: hidden;
}
.ladda-button[data-style=slide-down] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-down] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: -2em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-label {
  opacity: 0;
  top: 1em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * ZOOM-OUT
 */
.ladda-button[data-style=zoom-out] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-out] .ladda-spinner {
  left: 50%;
  margin-left: 32px;
  transform: scale(2.5);
}

.ladda-button[data-style=zoom-out] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(0.5);
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * ZOOM-IN
 */
.ladda-button[data-style=zoom-in] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-in] .ladda-spinner {
  left: 50%;
  margin-left: -16px;
  transform: scale(0.2);
}

.ladda-button[data-style=zoom-in] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(2.2);
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * CONTRACT
 */
.ladda-button[data-style=contract] {
  overflow: hidden;
  width: 100px;
}

.ladda-button[data-style=contract] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract][data-loading] {
  border-radius: 50%;
  width: 52px;
}

.ladda-button[data-style=contract][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract][data-loading] .ladda-spinner {
  opacity: 1;
}

/*************************************
 * OVERLAY
 */
.ladda-button[data-style=contract-overlay] {
  overflow: hidden;
  width: 100px;
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);
}

.ladda-button[data-style=contract-overlay] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] {
  border-radius: 50%;
  width: 52px;
  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {
  opacity: 1;
}

[dir=rtl] .ladda-spinner > div {
  left: 25% !important;
}

/*!
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0px 0px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger.is-active:hover {
  opacity: 0.7;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #545cd8;
}

.hamburger-box {
  width: 24px;
  height: 14px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -1px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #545cd8;
  border-radius: 10px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -6px;
}
.hamburger-inner::after {
  bottom: -6px;
}

/*
 * Elastic
 */
.hamburger--elastic .hamburger-inner {
  top: 1px;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic .hamburger-inner::before {
  top: 6px;
  transition: opacity 0.125s 0.275s ease;
}
.hamburger--elastic .hamburger-inner::after {
  top: 12px;
  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic.is-active .hamburger-inner {
  transform: translate3d(0, 6px, 0) rotate(135deg);
  transition-delay: 0.075s;
}
.hamburger--elastic.is-active .hamburger-inner::before {
  transition-delay: 0s;
  opacity: 0;
}
.hamburger--elastic.is-active .hamburger-inner::after {
  transform: translate3d(0, -12px, 0) rotate(-270deg);
  transition-delay: 0.075s;
}

.drawer-content-wrapper {
  background: #fff;
  position: relative;
  padding: 1.5rem;
}
.drawer-content-wrapper .drawer-heading {
  font-size: 0.968rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
}
.drawer-content-wrapper .drawer-heading:first-child {
  border-top: 0;
}
.drawer-content-wrapper .drawer-section {
  padding: 1.5rem;
}
.drawer-content-wrapper > .app-sidebar__heading:first-child {
  margin-top: 0;
}

.drawer-nav-btn {
  border-radius: 30px;
  background: #fff;
  position: fixed;
  right: 0.75rem;
  top: 0.75rem;
  padding: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 20;
}
.drawer-nav-btn .hamburger {
  margin-top: 4px;
}

.sa-icon {
  width: 80px;
  height: 80px;
  border: 4px solid #dee2e6;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}
.sa-icon.sa-error {
  border-color: #d92550;
}
.sa-icon.sa-error .sa-x-mark {
  position: relative;
  display: block;
}
.sa-icon.sa-error .sa-line {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #d92550;
  display: block;
  top: 37px;
  border-radius: 2px;
}
.sa-icon.sa-error .sa-line.sa-left {
  transform: rotate(45deg);
  left: 17px;
}
.sa-icon.sa-error .sa-line.sa-right {
  transform: rotate(-45deg);
  right: 16px;
}
.sa-icon.sa-warning {
  border-color: #f7b924;
}
.sa-icon.sa-warning .sa-body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f7b924;
}
.sa-icon.sa-warning .sa-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f7b924;
}
.sa-icon.sa-info {
  border-color: #30b1ff;
}
.sa-icon.sa-info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #30b1ff;
}
.sa-icon.sa-info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #30b1ff;
}
.sa-icon.sa-success {
  border-color: #3ac47d;
}
.sa-icon.sa-success::before, .sa-icon.sa-success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}
.sa-icon.sa-success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}
.sa-icon.sa-success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}
.sa-icon.sa-success .sa-placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 40px;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}
.sa-icon.sa-success .sa-fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}
.sa-icon.sa-success .sa-line {
  height: 5px;
  background-color: #3ac47d;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}
.sa-icon.sa-success .sa-line.sa-tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}
.sa-icon.sa-success .sa-line.sa-long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}
.sa-icon.sa-custom {
  background-size: contain;
  border-radius: 0;
  border: none;
  background-position: center center;
  background-repeat: no-repeat;
}
@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
.animateSuccessTip {
  animation: animateSuccessTip 0.75s;
}

.animateSuccessLong {
  animation: animateSuccessLong 0.75s;
}

.sa-icon.sa-success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}

/* Success icon */
.sweet-alert .sa-icon.sa-success {
  border-color: transparent \\9 ;
}

.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {
  -ms-transform: rotate(45deg) \\9 ;
}

.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {
  -ms-transform: rotate(-45deg) \\9 ;
}

.Toastify__toast-container {
  z-index: 2147483647;
  position: fixed;
  padding: 0;
  width: 320px;
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1rem;
  left: 1rem;
}
.Toastify__toast-container--top-center {
  top: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--top-right {
  top: 1rem;
  right: 1rem;
}
.Toastify__toast-container--bottom-left {
  bottom: 1rem;
  left: 1rem;
}
.Toastify__toast-container--bottom-center {
  bottom: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--bottom-right {
  bottom: 1rem;
  right: 1rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: auto;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: 54px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.375rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  display: flex;
  justify-content: space-between;
  max-height: 800px;
  overflow: hidden;
  font-family: sans-serif;
  cursor: pointer;
  direction: ltr;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast--default {
  background: #fff;
  color: #495057;
  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);
}
.Toastify__toast--info {
  background: #30b1ff;
  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);
}
.Toastify__toast--success {
  background: #3ac47d;
  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);
}
.Toastify__toast--warning {
  background: #f7b924;
  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);
}
.Toastify__toast--error {
  background: #d92550;
  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);
}
.Toastify__toast-body {
  margin: auto 0;
  padding: 0 0 0.4rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  font-size: 14px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  position: absolute;
  top: 5px;
  right: 9px;
}
.Toastify__close-button--default {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    width: 96%;
  }
  100% {
    width: 0;
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 9%;
  left: 2%;
  width: 0;
  height: 5px;
  z-index: 2147483647;
  animation: Toastify__trackProgress linear 1;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.375rem;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: auto;
  left: initial;
}
.Toastify__progress-bar--default {
  background: #545cd8;
}
@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

/* -- container -- */
.rodal,
.rodal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.rodal {
  position: fixed;
}

/* -- mask -- */
.rodal-mask {
  position: absolute;
  background-color: #000;
  opacity: 0.5;
}

/* -- dialog -- */
.rodal-dialog {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 101;
  background: #fff;
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(26, 29, 32, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.375rem;
  height: auto !important;
}

.rodal-dialog:focus {
  outline: none;
}

/* -- close button -- */
.rodal-close {
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
}

.rodal-close:before,
.rodal-close:after {
  position: absolute;
  content: "";
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #adb5bd;
  border-radius: 100%;
  transition: background 0.2s;
}

.rodal-close:before {
  transform: rotate(45deg);
}

.rodal-close:after {
  transform: rotate(-45deg);
}

.rodal-close:hover:before,
.rodal-close:hover:after {
  background: #343a40;
}

/* -- fade -- */
@keyframes rodal-fade-enter {
  from {
    opacity: 0;
  }
}
.rodal-fade-enter {
  animation: rodal-fade-enter both ease-in;
}

@keyframes rodal-fade-leave {
  to {
    opacity: 0;
  }
}
.rodal-fade-leave {
  animation: rodal-fade-leave both ease-out;
}

@keyframes rodal-zoom-enter {
  from {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-enter {
  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-zoom-leave {
  to {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-leave {
  animation: rodal-zoom-leave both;
}

@keyframes rodal-slideDown-enter {
  from {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-enter {
  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideDown-leave {
  to {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-leave {
  animation: rodal-slideDown-leave both;
}

/* -- slideLeft -- */
@keyframes rodal-slideLeft-enter {
  from {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-enter {
  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideLeft-leave {
  to {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-leave {
  animation: rodal-slideLeft-leave both;
}

/* -- slideRight -- */
@keyframes rodal-slideRight-enter {
  from {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-enter {
  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideRight-leave {
  to {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-leave {
  animation: rodal-slideRight-leave both;
}

/* -- slideUp -- */
@keyframes rodal-slideUp-enter {
  from {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-enter {
  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideUp-leave {
  to {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-leave {
  animation: rodal-slideUp-leave both;
}

/* -- flip -- */
@keyframes rodal-flip-enter {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);
  }
  70% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px);
  }
}
.rodal-flip-enter {
  animation: rodal-flip-enter both ease-in;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

@keyframes rodal-flip-leave {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);
  }
}
.rodal-flip-leave {
  animation: rodal-flip-leave both;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

/* -- rotate -- */
@keyframes rodal-rotate-enter {
  from {
    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-enter {
  animation: rodal-rotate-enter both;
  transform-origin: center;
}

@keyframes rodal-rotate-leave {
  to {
    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-leave {
  animation: rodal-rotate-leave both;
  transform-origin: center;
}

/* -- door -- */
@keyframes rodal-door-enter {
  from {
    transform: scale3d(0, 1, 1);
  }
}
.rodal-door-enter {
  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-door-leave {
  60% {
    transform: scale3d(0.01, 1, 1);
  }
  to {
    transform: scale3d(0, 1, 0.1);
  }
}
.rodal-door-leave {
  animation: rodal-door-leave both;
}

.react-sweet-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.react-sweet-progress-symbol {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 35px;
  height: 20px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 200;
}

.react-sweet-progress-symbol-absolute {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  align-items: center;
  justify-content: center;
  transform: translate3d(-50%, -50%, 0);
}

.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
  padding: 0;
  width: 100%;
}

.react-sweet-progress-circle-outer {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.react-sweet-progress-line {
  width: 100%;
  border-radius: 100px;
  background-color: #efefef;
  vertical-align: middle;
}

.react-sweet-progress-line-inner {
  position: relative;
  min-height: 10px;
  border-radius: 100px;
  transition: width 0.3s ease;
}

.react-sweet-progress-line-inner-status-active:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  background: #fff;
  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
  content: "";
  opacity: 0;
}

@keyframes active-anim {
  0% {
    width: 0;
    opacity: 0.1;
  }
  20% {
    width: 0;
    opacity: 0.5;
  }
  to {
    width: 100%;
    opacity: 0;
  }
}
.react-sweet-progress-circle path {
  stroke-linecap: round;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.slick-slider-sm .slick-slider {
  max-width: 450px;
}
.slick-slider-sm .slick-slider .slick-prev {
  left: -20px;
}
.slick-slider-sm .slick-slider .slick-next {
  right: -20px;
}

.slick-slider-md .slick-slider {
  max-width: 650px;
  margin: 0 auto;
}

.slick-slider-hover .slick-arrow {
  opacity: 0;
  background: #545cd8;
  color: #fff !important;
}
.slick-slider-hover .slick-prev {
  left: -30px;
}
.slick-slider-hover .slick-next {
  right: -30px;
}
.slick-slider-hover:hover .slick-arrow {
  opacity: 1;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 40px;
  width: 40px;
  cursor: pointer;
  color: #6c757d;
  top: 50%;
  transform: translate(0, -80%);
  padding: 0;
  border: none;
  outline: none;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  transition: all 0.2s;
  font-family: "Pe-icon-7-stroke";
  border-radius: 50px;
  background: #fff;
  z-index: 6;
  overflow: hidden;
}
.slick-prev::before,
.slick-next::before {
  font-size: 35px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  color: #545cd8;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}

.slick-prev {
  left: 0;
}
.slick-prev:before {
  content: "\\e686";
}

.slick-next {
  right: 0;
}
.slick-next:before {
  content: "\\e684";
}

/* Dots */
.slick-dots {
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0.75rem 0 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  padding: 0;
  margin: 0 5px;
  cursor: pointer;
  transform: scale(0.8);
  transition: all 0.2s;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 14px;
  width: 14px;
  background: #545cd8;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  color: transparent;
}
.slick-dots li button::before {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.slick-dots li.slick-active {
  transform: scale(1.2);
}

.slick-center {
  transform: scale(1.1);
}

.slick-slider .slide-img-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: 0.4;
  z-index: 10;
}
.slick-slider .slider-content {
  position: relative;
  z-index: 15;
  text-align: center;
  margin: 0 6rem;
}
.slick-slider .slider-content h3, .slick-slider .slider-content .h3 {
  font-size: 1.54rem;
  font-weight: normal;
  margin-bottom: 1.5rem;
}
.slick-slider .slider-content p {
  font-size: 0.88rem;
  opacity: 0.7;
}

.slider-light .slick-dots {
  position: absolute;
  bottom: 10px;
}
.slider-light .slick-dots li button {
  background: rgba(255, 255, 255, 0.25);
}
.slider-light .slick-prev,
.slider-light .slick-next {
  background: transparent;
  color: #fff;
  box-shadow: 0 0 0 0 transparent;
}
.slider-light .slick-prev:hover,
.slider-light .slick-next:hover {
  background: rgba(255, 255, 255, 0.15);
}
.slider-light .slick-next {
  right: 15px;
}
.slider-light .slick-prev {
  left: 15px;
}
.slider-light .slider-content {
  color: #fff;
}

.loading-indicator {
  text-align: center;
}

.loading-bullet {
  display: inline-block;
  opacity: 0;
  font-size: 2em;
  color: #02a17c;
}

.block-ui {
  position: relative;
  min-height: 3em;
}

.block-ui-container {
  position: absolute;
  z-index: 1010;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  min-height: 2em;
  cursor: wait;
  overflow: hidden;
}

.block-ui-container:focus {
  outline: none;
}

.block-ui-overlay {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: white;
}

.block-ui-message-container {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
  z-index: 10001;
}

.block-ui-message {
  color: #333;
  background: none;
  z-index: 1011;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-overlay-dark .block-ui-overlay {
  background: rgb(0, 0, 0);
}

.popover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}
.popover .grid-menu {
  margin-bottom: -1rem;
  padding: 1px;
}
.popover .grid-menu [class*=col-] {
  padding: 1rem;
}
.popover .grid-menu + .nav .nav-item-btn {
  margin-bottom: 1rem;
}
.popover .grid-menu-xl {
  margin-bottom: -0.7407407407rem;
}
.popover .grid-menu-xl [class*=col-] {
  padding: 0;
}
.popover .popover-inner .dropdown-menu-header {
  border-top-left-radius: 0.5rem;
  border-top-left-radius: var(--bs-border-radius-lg);
  border-top-right-radius: 0.5rem;
  border-top-right-radius: var(--bs-border-radius-lg);
  overflow: hidden;
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
}

.rm-max-width > .popover {
  max-width: none;
  max-width: initial;
}

.rm-pointers > .popover .arrow {
  display: none !important;
}

.popover-primary {
  background-color: #545cd8 !important;
}

.popover-secondary {
  background-color: #6c757d !important;
}

.popover-success {
  background-color: #3ac47d !important;
}

.popover-info {
  background-color: #30b1ff !important;
}

.popover-warning {
  background-color: #f7b924 !important;
}

.popover-danger {
  background-color: #d92550 !important;
}

.popover-light {
  background-color: #eeeeee !important;
}

.popover-dark {
  background-color: #343a40 !important;
}

.popover-focus {
  background-color: #444054 !important;
}

.popover-alternate {
  background-color: #83588a !important;
}

.popover-custom .popover-body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.popover-custom .popover-body .dropdown-menu-header {
  margin-top: 0;
  border-top-left-radius: 0.5rem;
  border-top-left-radius: var(--bs-border-radius-lg);
  border-top-right-radius: 0.5rem;
  border-top-right-radius: var(--bs-border-radius-lg);
  overflow: hidden;
}
.popover-custom .popover-body .dropdown-menu-header .menu-header-content {
  padding: 0 1.5rem;
}
.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {
  color: rgba(0, 0, 0, 0.8);
}
.popover-custom.popover-custom-lg {
  min-width: 22rem;
}
.popover-custom.popover-custom-xl {
  min-width: 25rem;
}
.popover-custom.popover-custom-sm {
  min-width: 15rem;
}

.popover-bg {
  border: 0;
}
.popover-bg .arrow {
  display: none;
}
.popover-bg .popover-header {
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  color: rgb(255, 255, 255);
}
.popover-bg .popover-header::before {
  display: none;
}
.popover-bg .popover-body {
  color: rgba(255, 255, 255, 0.7);
}
.popover-bg.text-dark .popover-header {
  color: rgba(0, 0, 0, 0.8);
}
.popover-bg.text-dark .popover-body {
  color: rgba(0, 0, 0, 0.7);
}

.tooltip-light > .tooltip .tooltip-inner {
  background: #fff;
  color: #343a40;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  border: rgba(63, 69, 162, 0.125) solid 1px;
}
.tooltip-light > .tooltip .arrow {
  display: none;
}

.scrollable-block {
  margin-bottom: 50px;
  overflow: hidden;
  position: relative;
}
.scrollable-block .sticky {
  z-index: 2;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1;
  min-height: 580px;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #999999;
}

.rbc-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  flex: 1 0;
  flex-basis: auto !important;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  z-index: 4;
}

.rbc-today {
  background-color: #e0f3ff;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  width: 100%;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #fff;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: #545cd8;
  border: 1px solid #545cd8;
  padding: 0.375rem 1rem;
  border-radius: 0.375rem;
  line-height: normal;
  white-space: nowrap;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 0.88rem;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: rgb(75.6, 82.8, 194.4);
  border-color: rgb(73.92, 80.96, 190.08);
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgb(69.72, 76.36, 179.28);
  border-color: #3f45a2;
}
.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgb(75.6, 82.8, 194.4);
  border-color: rgb(73.92, 80.96, 190.08);
}
.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgb(75.6, 82.8, 194.4);
  border-color: rgb(73.92, 80.96, 190.08);
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-event {
  cursor: pointer;
  padding: 0.125rem;
  background-color: #545cd8;
  border-radius: 0.375rem;
  color: #fff;
}
.rbc-event.rbc-selected {
  background-color: rgb(75.6, 82.8, 194.4);
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  height: 100%;
}
.rbc-month-view .rbc-header {
  border-bottom: 1px solid #e9ecef;
}
.rbc-month-view .rbc-header + .rbc-header {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #e9ecef;
}

.rbc-date-cell {
  padding-right: 5px;
  text-align: right;
  flex: 1 1;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-off-range-bg {
  background: #f8f9fa;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table {
  width: 100%;
  border: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table tbody > tr > td + td {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr + tr {
  border-top: 1px solid #e9ecef;
}
.rbc-agenda-view table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e9ecef;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-event {
  border: 1px solid rgb(75.6, 82.8, 194.4);
  display: flex;
  max-height: 100%;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid rgb(235.2, 237.9, 240.6);
}

.rbc-time-slot {
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-day-slot .rbc-event {
  position: absolute;
  z-index: 2;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.5);
  color: #white;
  font-size: 75%;
  padding: 3px;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #e9ecef;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}
.rbc-time-view .rbc-allday-cell {
  width: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row > * + * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header > .rbc-row > * + * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #e9ecef;
}
.rbc-time-header .rbc-gutter-cell {
  flex: none;
}
.rbc-time-header > .rbc-gutter-cell + * {
  width: 100%;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #e9ecef;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 1;
  left: 0;
  height: 1px;
  background-color: #3ac47d;
  pointer-events: none;
}
.rbc-current-time-indicator::before {
  display: block;
  position: absolute;
  left: -3px;
  top: -3px;
  content: " ";
  background-color: #3ac47d;
  border-radius: 50%;
  width: 8px;
  height: 8px;
}
.rbc-rtl .rbc-current-time-indicator::before {
  left: 0;
  right: -3px;
}

.handle-bar {
  background: transparent !important;
  border-radius: 30px;
}
.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {
  background-color: #e9ecef !important;
}
.handle-bar.resize-not-allowed:hover {
  background-color: #e9ecef;
}
.handle-bar .handle-bar_drag {
  border-color: #545cd8 !important;
}

/**
 * Extra class applied to VirtualScroll through className prop
 */
.rst__virtualScrollOverride {
  overflow: auto !important;
}

.ReactVirtualized__Grid__innerScrollContainer {
  overflow: visible !important;
}

.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {
  direction: rtl;
}

.ReactVirtualized__Grid {
  outline: none;
}

.rst__node {
  min-width: 100%;
  white-space: nowrap;
  position: relative;
  text-align: left;
}

.rst__node.rst__rtl {
  text-align: right;
}

.rst__nodeContent {
  position: absolute;
  top: 0;
  bottom: 0;
}

/* ==========================================================================
   Scaffold

    Line-overlaid blocks used for showing the tree structure
   ========================================================================== */
.rst__lineBlock,
.rst__absoluteLineBlock {
  height: 100%;
  position: relative;
  display: inline-block;
}

.rst__absoluteLineBlock {
  position: absolute;
  top: 0;
}

.rst__lineHalfHorizontalRight::before,
.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  position: absolute;
  content: "";
  background-color: black;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |     |
 * +-----+
 */
.rst__lineHalfHorizontalRight::before {
  height: 1px;
  top: 50%;
  right: 0;
  width: 50%;
}

.rst__rtl.rst__lineHalfHorizontalRight::before {
  left: 0;
  right: auto;
  right: initial;
}

.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  width: 1px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__lineFullVertical::after,
.rst__rtl.rst__lineHalfVerticalTop::after,
.rst__rtl.rst__lineHalfVerticalBottom::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__lineHalfVerticalTop::after {
  height: 50%;
}

.rst__lineHalfVerticalBottom::after {
  top: auto;
  bottom: 0;
  height: 50%;
}

/* Highlight line for pointing to dragged row destination
   ========================================================================== */
.rst__highlightLineVertical {
  z-index: 3;
}

.rst__highlightLineVertical::before {
  position: absolute;
  content: "";
  background-color: #545cd8;
  width: 8px;
  margin-left: -4px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__highlightLineVertical::before {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  left: auto;
  left: initial;
  right: 50%;
}

@keyframes arrow-pulse {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  30% {
    transform: translate(0, 300%);
    opacity: 1;
  }
  70% {
    transform: translate(0, 700%);
    opacity: 1;
  }
  100% {
    transform: translate(0, 1000%);
    opacity: 0;
  }
}
.rst__highlightLineVertical::after {
  content: "";
  position: absolute;
  height: 0;
  margin-left: -4px;
  left: 50%;
  top: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid white;
  animation: arrow-pulse 1s infinite linear both;
}

.rst__rtl.rst__highlightLineVertical::after {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  right: 50%;
  left: auto;
  left: initial;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |  |  |
 * +--+--+
 */
.rst__highlightTopLeftCorner::before {
  z-index: 3;
  content: "";
  position: absolute;
  border-top: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(50% + 4px);
  top: 50%;
  margin-top: -4px;
  right: 0;
  width: calc(50% + 4px);
}

.rst__rtl.rst__highlightTopLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 0;
  right: auto;
  right: initial;
}

/**
 * +--+--+
 * |  |  |
 * |  |  |
 * |  +->|
 * +-----+
 */
.rst__highlightBottomLeftCorner {
  z-index: 3;
}

.rst__highlightBottomLeftCorner::before {
  content: "";
  position: absolute;
  border-bottom: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(100% + 4px);
  top: 0;
  right: 12px;
  width: calc(50% - 8px);
}

.rst__rtl.rst__highlightBottomLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 12px;
  right: auto;
  right: initial;
}

.rst__highlightBottomLeftCorner::after {
  content: "";
  position: absolute;
  height: 0;
  right: 0;
  top: 100%;
  margin-top: -12px;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid #545cd8;
}

.rst__rtl.rst__highlightBottomLeftCorner::after {
  left: 0;
  right: auto;
  right: initial;
  border-right: 12px solid #545cd8;
  border-left: none;
}

.rst__rowWrapper {
  padding: 10px 10px 10px 0;
  height: 100%;
  box-sizing: border-box;
}

.rst__rtl.rst__rowWrapper {
  padding: 10px 0 10px 10px;
}

.rst__row {
  height: 100%;
  white-space: nowrap;
  display: flex;
}

.rst__row > * {
  box-sizing: border-box;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__rowLandingPad,
.rst__rowCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__rowLandingPad > *,
.rst__rowCancelPad > * {
  opacity: 0 !important;
}

.rst__rowLandingPad::before,
.rst__rowCancelPad::before {
  background-color: lightblue;
  border: 1px dashed #fff;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__rowCancelPad::before {
  background-color: #e6a8ad;
}

/**
 * Nodes matching the search conditions are highlighted
 */
.rst__rowSearchMatch {
  outline: solid 3px #0080ff;
}

/**
 * The node that matches the search conditions and is currently focused
 */
.rst__rowSearchFocus {
  outline: solid 3px #fc6421;
}

.rst__rowContents,
.rst__rowLabel,
.rst__rowToolbar,
.rst__moveHandle,
.rst__toolbarButton {
  display: inline-block;
  vertical-align: middle;
}

.rst__rowContents {
  position: relative;
  height: 100%;
  border: solid #dee2e6 1px;
  border-left: none;
  padding: 0 5px 0 10px;
  border-radius: 2px;
  min-width: 230px;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.rst__rtl.rst__rowContents {
  border-right: none;
  border-left: solid #dee2e6 1px;
  padding: 0 10px 0 5px;
}

.rst__rowContentsDragDisabled {
  border-left: solid #dee2e6 1px;
}

.rst__rtl.rst__rowContentsDragDisabled {
  border-right: solid #dee2e6 1px;
  border-left: solid #dee2e6 1px;
}

.rst__rowLabel {
  flex: 0 1 auto;
  padding-right: 20px;
}

.rst__rtl.rst__rowLabel {
  padding-left: 20px;
  padding-right: inherit;
}

.rst__rowToolbar {
  flex: 0 1 auto;
  display: flex;
}

.rst__moveHandle,
.rst__loadingHandle {
  height: 100%;
  width: 44px;
  background: #e9ecef url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center;
  border: solid #aaa 1px;
  cursor: move;
  border-radius: 1px;
  z-index: 1;
}

.rst__loadingHandle {
  cursor: default;
  background: #e9ecef;
}

@keyframes pointFade {
  0%, 19.999%, 100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}
.rst__loadingCircle {
  width: 80%;
  height: 80%;
  margin: 10%;
  position: relative;
}

.rst__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.rst__rtl.rst__loadingCirclePoint {
  right: 0;
  left: auto;
  left: initial;
}

.rst__loadingCirclePoint::before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}

.rst__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(1)::before,
.rst__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}

.rst__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}

.rst__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}

.rst__loadingCirclePoint:nth-of-type(2)::before,
.rst__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}

.rst__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}

.rst__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}

.rst__loadingCirclePoint:nth-of-type(3)::before,
.rst__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}

.rst__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}

.rst__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}

.rst__loadingCirclePoint:nth-of-type(4)::before,
.rst__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}

.rst__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}

.rst__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}

.rst__loadingCirclePoint:nth-of-type(5)::before,
.rst__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}

.rst__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}

.rst__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}

.rst__loadingCirclePoint:nth-of-type(6)::before,
.rst__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}

.rst__loadingCirclePoint:nth-of-type(7)::before,
.rst__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.rst__rowTitle {
  font-weight: bold;
}

.rst__rowTitleWithSubtitle {
  font-size: 85%;
  display: block;
  height: 0.8rem;
}

.rst__rowSubtitle {
  font-size: 70%;
  line-height: 1;
}

.rst__collapseButton,
.rst__expandButton {
  -webkit-appearance: none;
          appearance: none;
  border: none;
  position: absolute;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #000;
  width: 16px;
  height: 16px;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.rst__rtl.rst__collapseButton,
.rst__rtl.rst__expandButton {
  transform: translate(50%, -50%);
}

.rst__collapseButton:focus,
.rst__expandButton:focus {
  outline: none;
  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;
}

.rst__collapseButton:hover:not(:active),
.rst__expandButton:hover:not(:active) {
  background-size: 24px;
  height: 20px;
  width: 20px;
}

.rst__collapseButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center;
}

.rst__expandButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat center;
}

/**
 * Line for under a node with children
 */
.rst__lineChildren {
  height: 100%;
  display: inline-block;
  position: absolute;
}

.rst__lineChildren::after {
  content: "";
  position: absolute;
  background-color: black;
  width: 1px;
  left: 50%;
  bottom: 0;
  height: 10px;
}

.rst__rtl.rst__lineChildren::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__placeholder {
  position: relative;
  height: 68px;
  max-width: 300px;
  padding: 10px;
}

.rst__placeholder,
.rst__placeholder > * {
  box-sizing: border-box;
}

.rst__placeholder::before {
  border: 3px dashed #e9ecef;
  content: "";
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: -1;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__placeholderLandingPad,
.rst__placeholderCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__placeholderLandingPad *,
.rst__placeholderCancelPad * {
  opacity: 0 !important;
}

.rst__placeholderLandingPad::before,
.rst__placeholderCancelPad::before {
  background-color: lightblue;
  border-color: white;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__placeholderCancelPad::before {
  background-color: #e6a8ad;
}

/* Collection default theme */
/* Grid default theme */
/* Table default theme */
.ReactVirtualized__Table__headerRow {
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__headerTruncatedText {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ReactVirtualized__Table__headerColumn,
.ReactVirtualized__Table__rowColumn {
  margin-right: 10px;
  min-width: 0px;
}

.ReactVirtualized__Table__rowColumn {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReactVirtualized__Table__headerColumn:first-of-type,
.ReactVirtualized__Table__rowColumn:first-of-type {
  margin-left: 10px;
}

.ReactVirtualized__Table__sortableHeaderColumn {
  cursor: pointer;
}

.ReactVirtualized__Table__sortableHeaderIconContainer {
  display: flex;
  align-items: center;
}

.ReactVirtualized__Table__sortableHeaderIcon {
  flex: 0 0 24px;
  height: 1em;
  width: 1em;
  fill: currentColor;
}

/* List default theme */
.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}
.ReactTable .-pagination input,
.ReactTable .-pagination select,
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  display: block;
  width: 100%;
  color: #495057;
  color: var(--bs-body-color);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  height: calc(1.5em + 0.5rem + calc(1px * 2));
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.ReactTable .-pagination input::-ms-expand,
.ReactTable .-pagination select::-ms-expand,
.ReactTable .rt-thead.-filters input::-ms-expand,
.ReactTable .rt-thead.-filters select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.ReactTable .-pagination input::placeholder,
.ReactTable .-pagination select::placeholder,
.ReactTable .rt-thead.-filters input::placeholder,
.ReactTable .rt-thead.-filters select::placeholder {
  color: rgba(73, 80, 87, 0.75);
  color: var(--bs-secondary-color);
  opacity: 1;
}
.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],
.ReactTable .-pagination select:disabled,
.ReactTable .-pagination select[readonly],
.ReactTable .rt-thead.-filters input:disabled,
.ReactTable .rt-thead.-filters input[readonly],
.ReactTable .rt-thead.-filters select:disabled,
.ReactTable .rt-thead.-filters select[readonly] {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
          user-select: none;
}
.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-headerGroups .rt-th,
.ReactTable .rt-thead.-headerGroups .rt-td {
  padding: 0.3rem;
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:hover,
.ReactTable .rt-thead.-headerGroups .rt-td:hover {
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:empty,
.ReactTable .rt-thead.-headerGroups .rt-td:empty {
  padding: 0;
}
.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}
.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-filters.-header {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-thead .rt-tr {
  text-align: center;
}
.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: bold;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}
.ReactTable .rt-thead .rt-th:hover,
.ReactTable .rt-thead .rt-td:hover {
  color: rgb(71.4, 78.2, 183.6);
}
.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}
.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}
.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}
.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}
.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}
.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}
.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px #e9ecef;
}
.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}
.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid #e9ecef;
  align-items: center;
  align-content: center;
  display: flex;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true] {
  width: 100%;
  border: 1px solid transparent;
  background: #fff !important;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}
.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {
  padding: 3px 5px;
  border-color: rgb(126.75, 132.75, 225.75);
  outline: none;
}
.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}
.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}
.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  text-overflow: ellipsis;
  padding: 0.55rem;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}
.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}
.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  color: transparent;
  margin: 0 10px 0 0;
}
.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}
.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}
.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}
.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}
.ReactTable.-fixed .-header {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-fixed .pagination-bottom {
  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: #e0f3ff;
}
.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
          appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.375rem;
  padding: 6px;
  font-size: 1em;
  color: #545cd8;
  background: #f8f9fa;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  font-weight: bold;
}
.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}
.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: #545cd8;
  color: #fff;
}
.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}
.ReactTable .-pagination .-center {
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ReactTable .-pagination .-totalPages {
  padding-left: 5px;
  font-weight: bold;
}
.ReactTable .-pagination .-pageInfo {
  display: inherit;
  margin: 3px 0 3px 10px;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
}
.ReactTable .-pagination .-pageJump {
  display: inline-block;
  margin: 0 5px;
}
.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}
.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}
.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: #545cd8;
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}
.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}
.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.table thead th,
.table td {
  vertical-align: middle;
}

.table th .filter {
  margin-top: 0.375rem;
  height: auto;
  padding: 0.3rem 0.5rem;
}

.caret-4-asc,
.caret-4-desc {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  margin-left: 0.375rem;
}

.table .sortable:hover .caret-4-asc,
.table .sortable:hover .caret-4-desc {
  color: #545cd8;
}

.table-lg th,
.table-lg td {
  padding: 1.1rem 0.825rem;
}

.rdt_Table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.rdt_TableCol {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: 700;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}

.rdt_TableCell {
  border-right: 1px solid #e9ecef;
}

.rdt_TableRow:nth-child(odd) {
  background-color: #FFFFFF;
}

.rdt_TableRow:nth-child(even) {
  background-color: #f7f7f7;
}

.rdt_TableRow:hover {
  background-color: #e0f3ff;
}

@font-face {
  font-family: "Linearicons-Free";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=lnr-],
[class*=" lnr-"] {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.lnr-home:before {
  content: "\\e800";
}

.lnr-apartment:before {
  content: "\\e801";
}

.lnr-pencil:before {
  content: "\\e802";
}

.lnr-magic-wand:before {
  content: "\\e803";
}

.lnr-drop:before {
  content: "\\e804";
}

.lnr-lighter:before {
  content: "\\e805";
}

.lnr-poop:before {
  content: "\\e806";
}

.lnr-sun:before {
  content: "\\e807";
}

.lnr-moon:before {
  content: "\\e808";
}

.lnr-cloud:before {
  content: "\\e809";
}

.lnr-cloud-upload:before {
  content: "\\e80a";
}

.lnr-cloud-download:before {
  content: "\\e80b";
}

.lnr-cloud-sync:before {
  content: "\\e80c";
}

.lnr-cloud-check:before {
  content: "\\e80d";
}

.lnr-database:before {
  content: "\\e80e";
}

.lnr-lock:before {
  content: "\\e80f";
}

.lnr-cog:before {
  content: "\\e810";
}

.lnr-trash:before {
  content: "\\e811";
}

.lnr-dice:before {
  content: "\\e812";
}

.lnr-heart:before {
  content: "\\e813";
}

.lnr-star:before {
  content: "\\e814";
}

.lnr-star-half:before {
  content: "\\e815";
}

.lnr-star-empty:before {
  content: "\\e816";
}

.lnr-flag:before {
  content: "\\e817";
}

.lnr-envelope:before {
  content: "\\e818";
}

.lnr-paperclip:before {
  content: "\\e819";
}

.lnr-inbox:before {
  content: "\\e81a";
}

.lnr-eye:before {
  content: "\\e81b";
}

.lnr-printer:before {
  content: "\\e81c";
}

.lnr-file-empty:before {
  content: "\\e81d";
}

.lnr-file-add:before {
  content: "\\e81e";
}

.lnr-enter:before {
  content: "\\e81f";
}

.lnr-exit:before {
  content: "\\e820";
}

.lnr-graduation-hat:before {
  content: "\\e821";
}

.lnr-license:before {
  content: "\\e822";
}

.lnr-music-note:before {
  content: "\\e823";
}

.lnr-film-play:before {
  content: "\\e824";
}

.lnr-camera-video:before {
  content: "\\e825";
}

.lnr-camera:before {
  content: "\\e826";
}

.lnr-picture:before {
  content: "\\e827";
}

.lnr-book:before {
  content: "\\e828";
}

.lnr-bookmark:before {
  content: "\\e829";
}

.lnr-user:before {
  content: "\\e82a";
}

.lnr-users:before {
  content: "\\e82b";
}

.lnr-shirt:before {
  content: "\\e82c";
}

.lnr-store:before {
  content: "\\e82d";
}

.lnr-cart:before {
  content: "\\e82e";
}

.lnr-tag:before {
  content: "\\e82f";
}

.lnr-phone-handset:before {
  content: "\\e830";
}

.lnr-phone:before {
  content: "\\e831";
}

.lnr-pushpin:before {
  content: "\\e832";
}

.lnr-map-marker:before {
  content: "\\e833";
}

.lnr-map:before {
  content: "\\e834";
}

.lnr-location:before {
  content: "\\e835";
}

.lnr-calendar-full:before {
  content: "\\e836";
}

.lnr-keyboard:before {
  content: "\\e837";
}

.lnr-spell-check:before {
  content: "\\e838";
}

.lnr-screen:before {
  content: "\\e839";
}

.lnr-smartphone:before {
  content: "\\e83a";
}

.lnr-tablet:before {
  content: "\\e83b";
}

.lnr-laptop:before {
  content: "\\e83c";
}

.lnr-laptop-phone:before {
  content: "\\e83d";
}

.lnr-power-switch:before {
  content: "\\e83e";
}

.lnr-bubble:before {
  content: "\\e83f";
}

.lnr-heart-pulse:before {
  content: "\\e840";
}

.lnr-construction:before {
  content: "\\e841";
}

.lnr-pie-chart:before {
  content: "\\e842";
}

.lnr-chart-bars:before {
  content: "\\e843";
}

.lnr-gift:before {
  content: "\\e844";
}

.lnr-diamond:before {
  content: "\\e845";
}

.lnr-linearicons:before {
  content: "\\e846";
}

.lnr-dinner:before {
  content: "\\e847";
}

.lnr-coffee-cup:before {
  content: "\\e848";
}

.lnr-leaf:before {
  content: "\\e849";
}

.lnr-paw:before {
  content: "\\e84a";
}

.lnr-rocket:before {
  content: "\\e84b";
}

.lnr-briefcase:before {
  content: "\\e84c";
}

.lnr-bus:before {
  content: "\\e84d";
}

.lnr-car:before {
  content: "\\e84e";
}

.lnr-train:before {
  content: "\\e84f";
}

.lnr-bicycle:before {
  content: "\\e850";
}

.lnr-wheelchair:before {
  content: "\\e851";
}

.lnr-select:before {
  content: "\\e852";
}

.lnr-earth:before {
  content: "\\e853";
}

.lnr-smile:before {
  content: "\\e854";
}

.lnr-sad:before {
  content: "\\e855";
}

.lnr-neutral:before {
  content: "\\e856";
}

.lnr-mustache:before {
  content: "\\e857";
}

.lnr-alarm:before {
  content: "\\e858";
}

.lnr-bullhorn:before {
  content: "\\e859";
}

.lnr-volume-high:before {
  content: "\\e85a";
}

.lnr-volume-medium:before {
  content: "\\e85b";
}

.lnr-volume-low:before {
  content: "\\e85c";
}

.lnr-volume:before {
  content: "\\e85d";
}

.lnr-mic:before {
  content: "\\e85e";
}

.lnr-hourglass:before {
  content: "\\e85f";
}

.lnr-undo:before {
  content: "\\e860";
}

.lnr-redo:before {
  content: "\\e861";
}

.lnr-sync:before {
  content: "\\e862";
}

.lnr-history:before {
  content: "\\e863";
}

.lnr-clock:before {
  content: "\\e864";
}

.lnr-download:before {
  content: "\\e865";
}

.lnr-upload:before {
  content: "\\e866";
}

.lnr-enter-down:before {
  content: "\\e867";
}

.lnr-exit-up:before {
  content: "\\e868";
}

.lnr-bug:before {
  content: "\\e869";
}

.lnr-code:before {
  content: "\\e86a";
}

.lnr-link:before {
  content: "\\e86b";
}

.lnr-unlink:before {
  content: "\\e86c";
}

.lnr-thumbs-up:before {
  content: "\\e86d";
}

.lnr-thumbs-down:before {
  content: "\\e86e";
}

.lnr-magnifier:before {
  content: "\\e86f";
}

.lnr-cross:before {
  content: "\\e870";
}

.lnr-menu:before {
  content: "\\e871";
}

.lnr-list:before {
  content: "\\e872";
}

.lnr-chevron-up:before, .caret-4-asc:before {
  content: "\\e873";
}

.lnr-chevron-down:before, .caret-4-desc:before {
  content: "\\e874";
}

.lnr-chevron-left:before {
  content: "\\e875";
}

.lnr-chevron-right:before {
  content: "\\e876";
}

.lnr-arrow-up:before {
  content: "\\e877";
}

.lnr-arrow-down:before {
  content: "\\e878";
}

.lnr-arrow-left:before {
  content: "\\e879";
}

.lnr-arrow-right:before {
  content: "\\e87a";
}

.lnr-move:before {
  content: "\\e87b";
}

.lnr-warning:before {
  content: "\\e87c";
}

.lnr-question-circle:before {
  content: "\\e87d";
}

.lnr-menu-circle:before {
  content: "\\e87e";
}

.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {
  content: "\\e87f";
}

.lnr-cross-circle:before {
  content: "\\e880";
}

.lnr-plus-circle:before {
  content: "\\e881";
}

.lnr-circle-minus:before {
  content: "\\e882";
}

.lnr-arrow-up-circle:before {
  content: "\\e883";
}

.lnr-arrow-down-circle:before {
  content: "\\e884";
}

.lnr-arrow-left-circle:before {
  content: "\\e885";
}

.lnr-arrow-right-circle:before {
  content: "\\e886";
}

.lnr-chevron-up-circle:before {
  content: "\\e887";
}

.lnr-chevron-down-circle:before {
  content: "\\e888";
}

.lnr-chevron-left-circle:before {
  content: "\\e889";
}

.lnr-chevron-right-circle:before {
  content: "\\e88a";
}

.lnr-crop:before {
  content: "\\e88b";
}

.lnr-frame-expand:before {
  content: "\\e88c";
}

.lnr-frame-contract:before {
  content: "\\e88d";
}

.lnr-layers:before {
  content: "\\e88e";
}

.lnr-funnel:before {
  content: "\\e88f";
}

.lnr-text-format:before {
  content: "\\e890";
}

.lnr-text-format-remove:before {
  content: "\\e891";
}

.lnr-text-size:before {
  content: "\\e892";
}

.lnr-bold:before {
  content: "\\e893";
}

.lnr-italic:before {
  content: "\\e894";
}

.lnr-underline:before {
  content: "\\e895";
}

.lnr-strikethrough:before {
  content: "\\e896";
}

.lnr-highlight:before {
  content: "\\e897";
}

.lnr-text-align-left:before {
  content: "\\e898";
}

.lnr-text-align-center:before {
  content: "\\e899";
}

.lnr-text-align-right:before {
  content: "\\e89a";
}

.lnr-text-align-justify:before {
  content: "\\e89b";
}

.lnr-line-spacing:before {
  content: "\\e89c";
}

.lnr-indent-increase:before {
  content: "\\e89d";
}

.lnr-indent-decrease:before {
  content: "\\e89e";
}

.lnr-pilcrow:before {
  content: "\\e89f";
}

.lnr-direction-ltr:before {
  content: "\\e8a0";
}

.lnr-direction-rtl:before {
  content: "\\e8a1";
}

.lnr-page-break:before {
  content: "\\e8a2";
}

.lnr-sort-alpha-asc:before {
  content: "\\e8a3";
}

.lnr-sort-amount-asc:before {
  content: "\\e8a4";
}

.lnr-hand:before {
  content: "\\e8a5";
}

.lnr-pointer-up:before {
  content: "\\e8a6";
}

.lnr-pointer-right:before {
  content: "\\e8a7";
}

.lnr-pointer-down:before {
  content: "\\e8a8";
}

.lnr-pointer-left:before {
  content: "\\e8a9";
}

/*
*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set
*/
@font-face {
  font-family: "Pe-icon-7-stroke";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=pe-7s-], [class*=" pe-7s-"] {
  display: inline-block;
  font-family: "Pe-icon-7-stroke";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* HELPER CLASS
 * -------------------------- */
/* FA based classes */
/*! Modified from font-awesome helper CSS classes - PIXEDEN
 *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (CSS: MIT License)
 */
/* makes the font 33% larger relative to the icon container */
.pe-lg {
  font-size: 1.1704rem;
  line-height: 0.75em;
  vertical-align: -15%;
}

.pe-2x {
  font-size: 1.76rem;
}

.pe-3x {
  font-size: 2.64rem;
}

.pe-4x {
  font-size: 3.52rem;
}

.pe-5x {
  font-size: 4.4rem;
}

.pe-fw {
  width: 1.2857142857em;
  text-align: center;
}

.pe-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.pe-ul > li {
  position: relative;
}

.pe-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.pe-li.pe-lg {
  left: -1.8571428571em;
}

.pe-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eeeeee;
  border-radius: 0.1em;
}

.pull-right {
  float: right;
}

.pe.pull-left {
  float: left;
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.pe-spin {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.pe-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.pe-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.pe-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.pe-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  transform: scale(-1, 1);
}

.pe-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  transform: scale(1, -1);
}

.pe-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.pe-stack-1x,
.pe-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.pe-stack-1x {
  line-height: inherit;
}

.pe-stack-2x {
  font-size: 2em;
}

.pe-inverse {
  color: #ffffff;
}

/* Custom classes / mods - PIXEDEN */
.pe-va {
  vertical-align: middle;
}

.pe-border {
  border: solid 0.08em #eaeaea;
}

.pe-7s-album:before {
  content: "\\e6aa";
}

.pe-7s-arc:before {
  content: "\\e6ab";
}

.pe-7s-back-2:before {
  content: "\\e6ac";
}

.pe-7s-bandaid:before {
  content: "\\e6ad";
}

.pe-7s-car:before {
  content: "\\e6ae";
}

.pe-7s-diamond:before {
  content: "\\e6af";
}

.pe-7s-door-lock:before {
  content: "\\e6b0";
}

.pe-7s-eyedropper:before {
  content: "\\e6b1";
}

.pe-7s-female:before {
  content: "\\e6b2";
}

.pe-7s-gym:before {
  content: "\\e6b3";
}

.pe-7s-hammer:before {
  content: "\\e6b4";
}

.pe-7s-headphones:before {
  content: "\\e6b5";
}

.pe-7s-helm:before {
  content: "\\e6b6";
}

.pe-7s-hourglass:before {
  content: "\\e6b7";
}

.pe-7s-leaf:before {
  content: "\\e6b8";
}

.pe-7s-magic-wand:before {
  content: "\\e6b9";
}

.pe-7s-male:before {
  content: "\\e6ba";
}

.pe-7s-map-2:before {
  content: "\\e6bb";
}

.pe-7s-next-2:before {
  content: "\\e6bc";
}

.pe-7s-paint-bucket:before {
  content: "\\e6bd";
}

.pe-7s-pendrive:before {
  content: "\\e6be";
}

.pe-7s-photo:before {
  content: "\\e6bf";
}

.pe-7s-piggy:before {
  content: "\\e6c0";
}

.pe-7s-plugin:before {
  content: "\\e6c1";
}

.pe-7s-refresh-2:before {
  content: "\\e6c2";
}

.pe-7s-rocket:before {
  content: "\\e6c3";
}

.pe-7s-settings:before {
  content: "\\e6c4";
}

.pe-7s-shield:before {
  content: "\\e6c5";
}

.pe-7s-smile:before {
  content: "\\e6c6";
}

.pe-7s-usb:before {
  content: "\\e6c7";
}

.pe-7s-vector:before {
  content: "\\e6c8";
}

.pe-7s-wine:before {
  content: "\\e6c9";
}

.pe-7s-cloud-upload:before {
  content: "\\e68a";
}

.pe-7s-cash:before {
  content: "\\e68c";
}

.pe-7s-close:before {
  content: "\\e680";
}

.pe-7s-bluetooth:before {
  content: "\\e68d";
}

.pe-7s-cloud-download:before {
  content: "\\e68b";
}

.pe-7s-way:before {
  content: "\\e68e";
}

.pe-7s-close-circle:before {
  content: "\\e681";
}

.pe-7s-id:before {
  content: "\\e68f";
}

.pe-7s-angle-up:before {
  content: "\\e682";
}

.pe-7s-wristwatch:before {
  content: "\\e690";
}

.pe-7s-angle-up-circle:before {
  content: "\\e683";
}

.pe-7s-world:before {
  content: "\\e691";
}

.pe-7s-angle-right:before {
  content: "\\e684";
}

.pe-7s-volume:before {
  content: "\\e692";
}

.pe-7s-angle-right-circle:before {
  content: "\\e685";
}

.pe-7s-users:before {
  content: "\\e693";
}

.pe-7s-angle-left:before {
  content: "\\e686";
}

.pe-7s-user-female:before {
  content: "\\e694";
}

.pe-7s-angle-left-circle:before {
  content: "\\e687";
}

.pe-7s-up-arrow:before {
  content: "\\e695";
}

.pe-7s-angle-down:before {
  content: "\\e688";
}

.pe-7s-switch:before {
  content: "\\e696";
}

.pe-7s-angle-down-circle:before {
  content: "\\e689";
}

.pe-7s-scissors:before {
  content: "\\e697";
}

.pe-7s-wallet:before {
  content: "\\e600";
}

.pe-7s-safe:before {
  content: "\\e698";
}

.pe-7s-volume2:before {
  content: "\\e601";
}

.pe-7s-volume1:before {
  content: "\\e602";
}

.pe-7s-voicemail:before {
  content: "\\e603";
}

.pe-7s-video:before {
  content: "\\e604";
}

.pe-7s-user:before {
  content: "\\e605";
}

.pe-7s-upload:before {
  content: "\\e606";
}

.pe-7s-unlock:before {
  content: "\\e607";
}

.pe-7s-umbrella:before {
  content: "\\e608";
}

.pe-7s-trash:before {
  content: "\\e609";
}

.pe-7s-tools:before {
  content: "\\e60a";
}

.pe-7s-timer:before {
  content: "\\e60b";
}

.pe-7s-ticket:before {
  content: "\\e60c";
}

.pe-7s-target:before {
  content: "\\e60d";
}

.pe-7s-sun:before {
  content: "\\e60e";
}

.pe-7s-study:before {
  content: "\\e60f";
}

.pe-7s-stopwatch:before {
  content: "\\e610";
}

.pe-7s-star:before {
  content: "\\e611";
}

.pe-7s-speaker:before {
  content: "\\e612";
}

.pe-7s-signal:before {
  content: "\\e613";
}

.pe-7s-shuffle:before {
  content: "\\e614";
}

.pe-7s-shopbag:before {
  content: "\\e615";
}

.pe-7s-share:before {
  content: "\\e616";
}

.pe-7s-server:before {
  content: "\\e617";
}

.pe-7s-search:before {
  content: "\\e618";
}

.pe-7s-film:before {
  content: "\\e6a5";
}

.pe-7s-science:before {
  content: "\\e619";
}

.pe-7s-disk:before {
  content: "\\e6a6";
}

.pe-7s-ribbon:before {
  content: "\\e61a";
}

.pe-7s-repeat:before {
  content: "\\e61b";
}

.pe-7s-refresh:before {
  content: "\\e61c";
}

.pe-7s-add-user:before {
  content: "\\e6a9";
}

.pe-7s-refresh-cloud:before {
  content: "\\e61d";
}

.pe-7s-paperclip:before {
  content: "\\e69c";
}

.pe-7s-radio:before {
  content: "\\e61e";
}

.pe-7s-note2:before {
  content: "\\e69d";
}

.pe-7s-print:before {
  content: "\\e61f";
}

.pe-7s-network:before {
  content: "\\e69e";
}

.pe-7s-prev:before {
  content: "\\e620";
}

.pe-7s-mute:before {
  content: "\\e69f";
}

.pe-7s-power:before {
  content: "\\e621";
}

.pe-7s-medal:before {
  content: "\\e6a0";
}

.pe-7s-portfolio:before {
  content: "\\e622";
}

.pe-7s-like2:before {
  content: "\\e6a1";
}

.pe-7s-plus:before {
  content: "\\e623";
}

.pe-7s-left-arrow:before {
  content: "\\e6a2";
}

.pe-7s-play:before {
  content: "\\e624";
}

.pe-7s-key:before {
  content: "\\e6a3";
}

.pe-7s-plane:before {
  content: "\\e625";
}

.pe-7s-joy:before {
  content: "\\e6a4";
}

.pe-7s-photo-gallery:before {
  content: "\\e626";
}

.pe-7s-pin:before {
  content: "\\e69b";
}

.pe-7s-phone:before {
  content: "\\e627";
}

.pe-7s-plug:before {
  content: "\\e69a";
}

.pe-7s-pen:before {
  content: "\\e628";
}

.pe-7s-right-arrow:before {
  content: "\\e699";
}

.pe-7s-paper-plane:before {
  content: "\\e629";
}

.pe-7s-delete-user:before {
  content: "\\e6a7";
}

.pe-7s-paint:before {
  content: "\\e62a";
}

.pe-7s-bottom-arrow:before {
  content: "\\e6a8";
}

.pe-7s-notebook:before {
  content: "\\e62b";
}

.pe-7s-note:before {
  content: "\\e62c";
}

.pe-7s-next:before {
  content: "\\e62d";
}

.pe-7s-news-paper:before {
  content: "\\e62e";
}

.pe-7s-musiclist:before {
  content: "\\e62f";
}

.pe-7s-music:before {
  content: "\\e630";
}

.pe-7s-mouse:before {
  content: "\\e631";
}

.pe-7s-more:before {
  content: "\\e632";
}

.pe-7s-moon:before {
  content: "\\e633";
}

.pe-7s-monitor:before {
  content: "\\e634";
}

.pe-7s-micro:before {
  content: "\\e635";
}

.pe-7s-menu:before {
  content: "\\e636";
}

.pe-7s-map:before {
  content: "\\e637";
}

.pe-7s-map-marker:before {
  content: "\\e638";
}

.pe-7s-mail:before {
  content: "\\e639";
}

.pe-7s-mail-open:before {
  content: "\\e63a";
}

.pe-7s-mail-open-file:before {
  content: "\\e63b";
}

.pe-7s-magnet:before {
  content: "\\e63c";
}

.pe-7s-loop:before {
  content: "\\e63d";
}

.pe-7s-look:before {
  content: "\\e63e";
}

.pe-7s-lock:before {
  content: "\\e63f";
}

.pe-7s-lintern:before {
  content: "\\e640";
}

.pe-7s-link:before {
  content: "\\e641";
}

.pe-7s-like:before {
  content: "\\e642";
}

.pe-7s-light:before {
  content: "\\e643";
}

.pe-7s-less:before {
  content: "\\e644";
}

.pe-7s-keypad:before {
  content: "\\e645";
}

.pe-7s-junk:before {
  content: "\\e646";
}

.pe-7s-info:before {
  content: "\\e647";
}

.pe-7s-home:before {
  content: "\\e648";
}

.pe-7s-help2:before {
  content: "\\e649";
}

.pe-7s-help1:before {
  content: "\\e64a";
}

.pe-7s-graph3:before {
  content: "\\e64b";
}

.pe-7s-graph2:before {
  content: "\\e64c";
}

.pe-7s-graph1:before {
  content: "\\e64d";
}

.pe-7s-graph:before {
  content: "\\e64e";
}

.pe-7s-global:before {
  content: "\\e64f";
}

.pe-7s-gleam:before {
  content: "\\e650";
}

.pe-7s-glasses:before {
  content: "\\e651";
}

.pe-7s-gift:before {
  content: "\\e652";
}

.pe-7s-folder:before {
  content: "\\e653";
}

.pe-7s-flag:before {
  content: "\\e654";
}

.pe-7s-filter:before {
  content: "\\e655";
}

.pe-7s-file:before {
  content: "\\e656";
}

.pe-7s-expand1:before {
  content: "\\e657";
}

.pe-7s-exapnd2:before {
  content: "\\e658";
}

.pe-7s-edit:before {
  content: "\\e659";
}

.pe-7s-drop:before {
  content: "\\e65a";
}

.pe-7s-drawer:before {
  content: "\\e65b";
}

.pe-7s-download:before {
  content: "\\e65c";
}

.pe-7s-display2:before {
  content: "\\e65d";
}

.pe-7s-display1:before {
  content: "\\e65e";
}

.pe-7s-diskette:before {
  content: "\\e65f";
}

.pe-7s-date:before {
  content: "\\e660";
}

.pe-7s-cup:before {
  content: "\\e661";
}

.pe-7s-culture:before {
  content: "\\e662";
}

.pe-7s-crop:before {
  content: "\\e663";
}

.pe-7s-credit:before {
  content: "\\e664";
}

.pe-7s-copy-file:before {
  content: "\\e665";
}

.pe-7s-config:before {
  content: "\\e666";
}

.pe-7s-compass:before {
  content: "\\e667";
}

.pe-7s-comment:before {
  content: "\\e668";
}

.pe-7s-coffee:before {
  content: "\\e669";
}

.pe-7s-cloud:before {
  content: "\\e66a";
}

.pe-7s-clock:before {
  content: "\\e66b";
}

.pe-7s-check:before {
  content: "\\e66c";
}

.pe-7s-chat:before {
  content: "\\e66d";
}

.pe-7s-cart:before {
  content: "\\e66e";
}

.pe-7s-camera:before {
  content: "\\e66f";
}

.pe-7s-call:before {
  content: "\\e670";
}

.pe-7s-calculator:before {
  content: "\\e671";
}

.pe-7s-browser:before {
  content: "\\e672";
}

.pe-7s-box2:before {
  content: "\\e673";
}

.pe-7s-box1:before {
  content: "\\e674";
}

.pe-7s-bookmarks:before {
  content: "\\e675";
}

.pe-7s-bicycle:before {
  content: "\\e676";
}

.pe-7s-bell:before {
  content: "\\e677";
}

.pe-7s-battery:before {
  content: "\\e678";
}

.pe-7s-ball:before {
  content: "\\e679";
}

.pe-7s-back:before {
  content: "\\e67a";
}

.pe-7s-attention:before {
  content: "\\e67b";
}

.pe-7s-anchor:before {
  content: "\\e67c";
}

.pe-7s-albums:before {
  content: "\\e67d";
}

.pe-7s-alarm:before {
  content: "\\e67e";
}

.pe-7s-airplay:before {
  content: "\\e67f";
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -6px;
  position: absolute;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-sizing: content-box;
  position: absolute;
  border: 6px solid transparent;
  height: 0;
  width: 1px;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  content: "";
  z-index: -1;
  border-width: 6px;
  left: -6px;
  border-bottom-color: #dee2e6;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -6px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #fff;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #dee2e6;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -6px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #dee2e6;
}

.react-datepicker-wrapper {
  display: block;
  z-index: 10;
}

.react-datepicker {
  background-color: #fff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  display: inline-block;
  position: relative;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}
.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 102;
}
.react-datepicker-popper[data-placement^=bottom] {
  margin-top: 8px;
}
.react-datepicker-popper[data-placement^=top] {
  margin-bottom: 8px;
}
.react-datepicker-popper[data-placement^=right] {
  margin-left: 6px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  margin-right: 6px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding-top: 10px;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
  margin-top: 0;
  color: #343a40;
  font-weight: bold;
  font-size: 0.968rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 15px;
  padding: 0;
  border: 0.35rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #ced4da;
}
.react-datepicker__navigation--previous:hover {
  border-right-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(195.7, 201.4, 207.1);
  cursor: default;
}
.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #ced4da;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}
.react-datepicker__navigation--next:hover {
  border-left-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(195.7, 201.4, 207.1);
  cursor: default;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ced4da;
}
.react-datepicker__navigation--years-previous:hover {
  border-top-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ced4da;
}
.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: rgb(185.4, 190.8, 196.2);
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.5rem;
  text-align: center;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #dee2e6;
  width: 120px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -122px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 120px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: calc(195px + 2rem / 2);
  overflow-y: scroll;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  padding: 5px 10px;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #e0f3ff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #545cd8;
  color: #fff;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #545cd8;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ced4da;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ced4da;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.375rem;
  background-color: #fff;
}

.react-datepicker__day-names {
  background: #f8f9fa;
  border-top: #dee2e6 solid 1px;
  margin-top: 10px;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #495057;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day {
  cursor: pointer;
  border-radius: 0.375rem;
}
.react-datepicker__day:hover {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted {
  border-radius: 0.375rem;
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--highlighted:hover {
  background-color: rgb(79.8, 87.4, 205.2);
}
.react-datepicker__day--highlighted-custom-1 {
  color: #f7b924;
}
.react-datepicker__day--highlighted-custom-2 {
  color: #444054;
}
.react-datepicker__day--selected {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--selected:hover {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {
  background-color: #e0f3ff;
  color: #495057;
  color: var(--bs-body-color);
}
.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {
  background-color: #e0f3ff;
  color: #495057;
  color: var(--bs-body-color);
}
.react-datepicker__day--keyboard-selected {
  border-radius: 0.375rem;
  background-color: rgb(101.1, 108.3, 219.9);
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover {
  background-color: rgb(79.8, 87.4, 205.2);
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
  background-color: #e0f3ff;
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--disabled {
  cursor: default;
  color: #ced4da;
}
.react-datepicker__day--disabled:hover {
  background-color: transparent;
  color: #ced4da;
}

.react-datepicker__day--selecting-range-start,
.react-datepicker__day--selecting-range-end {
  background-color: #545cd8 !important;
  color: #fff !important;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.375rem;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ced4da;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.35rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ced4da;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(185.4, 190.8, 196.2);
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}
.react-datepicker__close-icon::after {
  background-color: #545cd8;
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "×";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid #dee2e6;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1050;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.584rem;
}
.react-datepicker__portal .react-datepicker__navigation {
  border: 0.63rem solid transparent;
  margin-top: 3px;
}
.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: rgb(75.6, 82.8, 194.4);
}
.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(195.7, 201.4, 207.1);
  cursor: default;
}
.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: rgb(75.6, 82.8, 194.4);
}
.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(195.7, 201.4, 207.1);
  cursor: default;
}

.rangeButtonSelectedStyle {
  background: #545cd8 !important;
}

.rangebuttonstyle {
  outline: none !important;
  color: #545cd8 !important;
}

.rc-slider-tooltip {
  z-index: 555;
}

.rc-tooltip.rc-tooltip-zoom-enter,
.rc-tooltip.rc-tooltip-zoom-leave {
  display: block;
}

.rc-tooltip-zoom-enter,
.rc-tooltip-zoom-appear {
  opacity: 0;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation-play-state: paused;
}

.rc-tooltip-zoom-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
  animation-play-state: paused;
}

.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,
.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {
  animation-name: rcToolTipZoomIn;
  animation-play-state: running;
}

.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {
  animation-name: rcToolTipZoomOut;
  animation-play-state: running;
}

@keyframes rcToolTipZoomIn {
  0% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
  100% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
}
@keyframes rcToolTipZoomOut {
  0% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
}
.rc-tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.9;
}

.rc-tooltip-hidden {
  display: none;
}

.rc-tooltip-placement-top,
.rc-tooltip-placement-topLeft,
.rc-tooltip-placement-topRight {
  padding: 5px 0 9px 0;
}

.rc-tooltip-placement-right,
.rc-tooltip-placement-rightTop,
.rc-tooltip-placement-rightBottom {
  padding: 0 5px 0 9px;
}

.rc-tooltip-placement-bottom,
.rc-tooltip-placement-bottomLeft,
.rc-tooltip-placement-bottomRight {
  padding: 9px 0 5px 0;
}

.rc-tooltip-placement-left,
.rc-tooltip-placement-leftTop,
.rc-tooltip-placement-leftBottom {
  padding: 0 9px 0 5px;
}

.rc-tooltip-inner {
  padding: 12px 14px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  background-color: #343a40;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
  min-height: 34px;
  font-weight: bold;
}

.rc-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-tooltip-placement-top .rc-tooltip-arrow,
.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  bottom: 4px;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #343a40;
}

.rc-tooltip-placement-top .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-topLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-tooltip-placement-right .rc-tooltip-arrow,
.rc-tooltip-placement-rightTop .rc-tooltip-arrow,
.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  left: 4px;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #343a40;
}

.rc-tooltip-placement-right .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-rightTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-left .rc-tooltip-arrow,
.rc-tooltip-placement-leftTop .rc-tooltip-arrow,
.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  right: 4px;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #343a40;
}

.rc-tooltip-placement-left .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-leftTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow,
.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,
.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  top: 4px;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #343a40;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-slider {
  position: relative;
  height: 20px;
  padding: 8px 0 0;
  width: 100%;
  border-radius: 0.375rem;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-rail {
  position: absolute;
  width: 100%;
  background-color: #e9ecef;
  height: 4px;
  border-radius: 0.375rem;
}

.rc-slider-track {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 0.375rem;
  background-color: #545cd8;
}

.rc-slider-handle {
  position: absolute;
  margin-left: -8px;
  margin-top: -6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  cursor: grab;
  border-radius: 50%;
  border: solid 2px #545cd8;
  background-color: #fff;
  touch-action: pan-x;
  transition: box-shadow 200ms;
}
.rc-slider-handle:focus {
  outline: none;
}
.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {
  border-color: rgb(71.4, 78.2, 183.6);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-handle:active {
  cursor: grabbing;
}

.rc-slider-mark {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  font-size: 12px;
}

.rc-slider-mark-text {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  color: #6c757d;
}

.rc-slider-mark-text-active {
  color: #343a40;
}

.rc-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}

.rc-slider-dot {
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  border: 2px solid #dee2e6;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}

.rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-disabled {
  background-color: #e9ecef;
}

.rc-slider-disabled .rc-slider-track {
  background-color: #ced4da;
}

.rc-slider-disabled .rc-slider-handle,
.rc-slider-disabled .rc-slider-dot {
  border-color: #ced4da;
  box-shadow: none;
  background-color: #fff;
  cursor: not-allowed;
}

.rc-slider-disabled .rc-slider-mark-text,
.rc-slider-disabled .rc-slider-dot {
  cursor: not-allowed !important;
}

.rc-slider-vertical {
  width: 14px;
  height: 100%;
  padding: 0 5px;
}

.rc-slider-vertical .rc-slider-rail {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-track {
  left: 5px;
  bottom: 0;
  width: 4px;
}

.rc-slider-vertical .rc-slider-handle {
  margin-left: -6px;
  margin-bottom: -7px;
  touch-action: pan-y;
}

.rc-slider-vertical .rc-slider-mark {
  top: 0;
  left: 18px;
  height: 100%;
}

.rc-slider-vertical .rc-slider-step {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-dot {
  left: 2px;
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:first-child {
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:last-child {
  margin-bottom: -4px;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
  animation-name: rcSliderTooltipZoomDownIn;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
  animation-name: rcSliderTooltipZoomDownOut;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  transform: scale(0, 0);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.rc-slider-tooltip-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes rcSliderTooltipZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
}
@keyframes rcSliderTooltipZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
}
.rc-slider-tooltip {
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-tooltip-hidden {
  display: none;
}

.rc-slider-tooltip-placement-top {
  padding: 4px 0 8px 0;
}

.rc-slider-tooltip-inner {
  padding: 0 8px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #212529;
  border-radius: 0.375rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  font-weight: bold;
}

.rc-slider-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
  bottom: 4px;
  left: 50%;
  margin-left: -4px;
  border-width: 4px 4px 0;
  border-top-color: #212529;
}

.rc-slider-primary .rc-slider-track {
  background-color: #545cd8;
}
.rc-slider-primary .rc-slider-handle {
  border-color: #545cd8;
  background-color: #fff;
}
.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {
  border-color: rgb(71.4, 78.2, 183.6);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-primary .rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-secondary .rc-slider-track {
  background-color: #6c757d;
}
.rc-slider-secondary .rc-slider-handle {
  border-color: #6c757d;
  background-color: #fff;
}
.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {
  border-color: rgb(91.8, 99.45, 106.25);
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);
}
.rc-slider-secondary .rc-slider-dot-active {
  border-color: #6c757d;
}

.rc-slider-success .rc-slider-track {
  background-color: #3ac47d;
}
.rc-slider-success .rc-slider-handle {
  border-color: #3ac47d;
  background-color: #fff;
}
.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {
  border-color: rgb(49.3, 166.6, 106.25);
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);
}
.rc-slider-success .rc-slider-dot-active {
  border-color: #3ac47d;
}

.rc-slider-info .rc-slider-track {
  background-color: #30b1ff;
}
.rc-slider-info .rc-slider-handle {
  border-color: #30b1ff;
  background-color: #fff;
}
.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {
  border-color: rgb(40.8, 150.45, 216.75);
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);
}
.rc-slider-info .rc-slider-dot-active {
  border-color: #30b1ff;
}

.rc-slider-warning .rc-slider-track {
  background-color: #f7b924;
}
.rc-slider-warning .rc-slider-handle {
  border-color: #f7b924;
  background-color: #fff;
}
.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {
  border-color: rgb(209.95, 157.25, 30.6);
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);
}
.rc-slider-warning .rc-slider-dot-active {
  border-color: #f7b924;
}

.rc-slider-danger .rc-slider-track {
  background-color: #d92550;
}
.rc-slider-danger .rc-slider-handle {
  border-color: #d92550;
  background-color: #fff;
}
.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {
  border-color: rgb(184.45, 31.45, 68);
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);
}
.rc-slider-danger .rc-slider-dot-active {
  border-color: #d92550;
}

.rc-slider-light .rc-slider-track {
  background-color: #eeeeee;
}
.rc-slider-light .rc-slider-handle {
  border-color: #eeeeee;
  background-color: #fff;
}
.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {
  border-color: rgb(202.3, 202.3, 202.3);
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);
}
.rc-slider-light .rc-slider-dot-active {
  border-color: #eeeeee;
}

.rc-slider-dark .rc-slider-track {
  background-color: #343a40;
}
.rc-slider-dark .rc-slider-handle {
  border-color: #343a40;
  background-color: #fff;
}
.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {
  border-color: rgb(44.2, 49.3, 54.4);
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);
}
.rc-slider-dark .rc-slider-dot-active {
  border-color: #343a40;
}

.rc-slider-focus .rc-slider-track {
  background-color: #444054;
}
.rc-slider-focus .rc-slider-handle {
  border-color: #444054;
  background-color: #fff;
}
.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {
  border-color: rgb(57.8, 54.4, 71.4);
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);
}
.rc-slider-focus .rc-slider-dot-active {
  border-color: #444054;
}

.rc-slider-alternate .rc-slider-track {
  background-color: #83588a;
}
.rc-slider-alternate .rc-slider-handle {
  border-color: #83588a;
  background-color: #fff;
}
.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {
  border-color: rgb(111.35, 74.8, 117.3);
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);
}
.rc-slider-alternate .rc-slider-dot-active {
  border-color: #83588a;
}

.rc-slider-line .rc-slider-handle {
  border-radius: 0;
  border-width: 0 3px 0 0;
  margin-left: -8px;
  width: 10px;
  background-color: transparent;
  box-shadow: 0 0 0 transparent !important;
}

.rc-slider-square .rc-slider-handle {
  border-radius: 3px;
  border-widtH: 1px;
}
.rc-slider-square .rc-slider-handle:before {
  position: absolute;
  height: 8px;
  width: 4px;
  border: #adb5bd solid 1px;
  border-width: 0 1px;
  display: block;
  content: "";
  top: 50%;
  left: 50%;
  margin: -4px -2px;
}

.rc-slider-lg.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-lg .rc-slider-rail {
  height: 4px;
}
.rc-slider-lg .rc-slider-track {
  height: 4px;
}
.rc-slider-lg .rc-slider-handle {
  margin-left: -10px;
  margin-top: -8px;
  width: 20px;
  height: 20px;
}
.rc-slider-lg.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-lg.rc-slider-square .rc-slider-handle:before {
  height: 10px;
  width: 6px;
  margin: -5px -3px;
}

.rc-slider-sm.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-sm .rc-slider-rail {
  height: 4px;
}
.rc-slider-sm .rc-slider-track {
  height: 4px;
}
.rc-slider-sm .rc-slider-handle {
  margin-left: -6px;
  margin-top: -4px;
  width: 12px;
  height: 12px;
}
.rc-slider-sm.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-sm.rc-slider-square .rc-slider-handle:before {
  height: 6px;
  margin: -3px 0 0 -1px;
  border: 0;
  width: 2px;
  background: #adb5bd;
}

.rdw-option-wrapper {
  border: 1px solid #F1F1F1;
  padding: 5px;
  min-width: 25px;
  height: 20px;
  border-radius: 2px;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-option-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-option-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-dropdown-wrapper {
  height: 30px;
  background: white;
  cursor: pointer;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  margin: 0 3px;
  text-transform: capitalize;
  background: white;
}

.rdw-dropdown-wrapper:focus {
  outline: none;
}

.rdw-dropdown-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdown-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-dropdown-carettoopen {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-top: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-carettoclose {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-bottom: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-selectedtext {
  display: flex;
  position: relative;
  height: 100%;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdown-optionwrapper {
  z-index: 100;
  position: relative;
  border: 1px solid #F1F1F1;
  width: 98%;
  background: white;
  border-radius: 2px;
  margin: 0;
  padding: 0;
  max-height: 250px;
  overflow-y: scroll;
}

.rdw-dropdown-optionwrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdownoption-default {
  min-height: 25px;
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdownoption-highlighted {
  background: #F1F1F1;
}

.rdw-dropdownoption-active {
  background: #f5f5f5;
}

.rdw-dropdownoption-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-inline-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-inline-dropdown {
  width: 50px;
}

.rdw-inline-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-block-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-block-dropdown {
  width: 110px;
}

.rdw-fontsize-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontsize-dropdown {
  min-width: 40px;
}

.rdw-fontsize-option {
  display: flex;
  justify-content: center;
}

.rdw-fontfamily-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontfamily-dropdown {
  width: 115px;
}

.rdw-fontfamily-placeholder {
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rdw-fontfamily-optionwrapper {
  width: 140px;
}

.rdw-list-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-list-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-list-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-text-align-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-text-align-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-text-align-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-right-aligned-block {
  text-align: right;
}

.rdw-left-aligned-block {
  text-align: left !important;
}

.rdw-center-aligned-block {
  text-align: center !important;
}

.rdw-justify-aligned-block {
  text-align: justify !important;
}

.rdw-right-aligned-block > div {
  display: inline-block;
}

.rdw-left-aligned-block > div {
  display: inline-block;
}

.rdw-center-aligned-block > div {
  display: inline-block;
}

.rdw-justify-aligned-block > div {
  display: inline-block;
}

.rdw-colorpicker-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-colorpicker-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 175px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-colorpicker-modal-header {
  display: flex;
  padding-bottom: 5px;
}

.rdw-colorpicker-modal-style-label {
  font-size: 15px;
  width: 50%;
  text-align: center;
  cursor: pointer;
  padding: 0 10px 5px;
}

.rdw-colorpicker-modal-style-label-active {
  border-bottom: 2px solid #0a66b7;
}

.rdw-colorpicker-modal-options {
  margin: 5px auto;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  overflow: scroll;
}

.rdw-colorpicker-cube {
  width: 22px;
  height: 22px;
  border: 1px solid #F1F1F1;
}

.rdw-colorpicker-option {
  margin: 3px;
  padding: 0;
  min-height: 20px;
  border: none;
  width: 22px;
  height: 22px;
  min-width: 22px;
  box-shadow: 1px 2px 1px #BFBDBD inset;
}

.rdw-colorpicker-option:hover {
  box-shadow: 1px 2px 1px #BFBDBD;
}

.rdw-colorpicker-option:active {
  box-shadow: -1px -2px 1px #BFBDBD;
}

.rdw-colorpicker-option-active {
  box-shadow: 0px 0px 2px 2px #BFBDBD;
}

.rdw-link-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-link-dropdown {
  width: 50px;
}

.rdw-link-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-link-dropdownPlaceholder {
  margin-left: 8px;
}

.rdw-link-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 205px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-link-modal-label {
  font-size: 15px;
}

.rdw-link-modal-input {
  margin-top: 5px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  height: 25px;
  margin-bottom: 15px;
  padding: 0 5px;
}

.rdw-link-modal-input:focus {
  outline: none;
}

.rdw-link-modal-buttonsection {
  margin: 0 auto;
}

.rdw-link-modal-target-option {
  margin-bottom: 20px;
}

.rdw-link-modal-target-option > span {
  margin-left: 5px;
}

.rdw-link-modal-btn {
  margin-left: 10px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-link-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-link-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-link-modal-btn:focus {
  outline: none !important;
}

.rdw-link-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-link-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-embedded-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-embedded-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  justify-content: space-between;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-embedded-modal-header {
  font-size: 15px;
  display: flex;
}

.rdw-embedded-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-embedded-modal-header-label {
  width: 95px;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-embedded-modal-link-section {
  display: flex;
  flex-direction: column;
}

.rdw-embedded-modal-link-input {
  width: 88%;
  height: 35px;
  margin: 10px 0;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-embedded-modal-link-input-wrapper {
  display: flex;
  align-items: center;
}

.rdw-embedded-modal-link-input:focus {
  outline: none;
}

.rdw-embedded-modal-btn-section {
  display: flex;
  justify-content: center;
}

.rdw-embedded-modal-btn {
  margin: 0 3px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-embedded-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-embedded-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-embedded-modal-btn:focus {
  outline: none !important;
}

.rdw-embedded-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-embedded-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-embedded-modal-size-input {
  width: 80%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-embedded-modal-size-input:focus {
  outline: none;
}

.rdw-emoji-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-emoji-modal {
  overflow: auto;
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-emoji-icon {
  margin: 2.5px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdw-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.rdw-spinner > div {
  width: 12px;
  height: 12px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.rdw-spinner .rdw-bounce1 {
  animation-delay: -0.32s;
}

.rdw-spinner .rdw-bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.rdw-image-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-image-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-image-modal-header {
  font-size: 15px;
  margin: 10px 0;
  display: flex;
}

.rdw-image-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-image-modal-header-label {
  width: 80px;
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
}

.rdw-image-modal-header-label-highlighted {
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-image-modal-upload-option {
  width: 100%;
  color: gray;
  cursor: pointer;
  display: flex;
  border: none;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  outline: 2px dashed gray;
  outline-offset: -10px;
  margin: 10px 0;
  padding: 9px 0;
}

.rdw-image-modal-upload-option-highlighted {
  outline: 2px dashed #0a66b7;
}

.rdw-image-modal-upload-option-label {
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.rdw-image-modal-upload-option-label span {
  padding: 0 20px;
}

.rdw-image-modal-upload-option-image-preview {
  max-width: 100%;
  max-height: 200px;
}

.rdw-image-modal-upload-option-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.rdw-image-modal-url-section {
  display: flex;
  align-items: center;
}

.rdw-image-modal-url-input {
  width: 90%;
  height: 35px;
  margin: 15px 0 12px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-image-modal-btn-section {
  margin: 10px auto 0;
}

.rdw-image-modal-url-input:focus {
  outline: none;
}

.rdw-image-modal-btn {
  margin: 0 5px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-image-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-image-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-image-modal-btn:focus {
  outline: none !important;
}

.rdw-image-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-image-modal-spinner {
  position: absolute;
  top: -3px;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.rdw-image-modal-alt-input {
  width: 70%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
  margin-left: 5px;
}

.rdw-image-modal-alt-input:focus {
  outline: none;
}

.rdw-image-modal-alt-lbl {
  font-size: 12px;
}

.rdw-image-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-image-modal-size-input {
  width: 40%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-image-modal-size-input:focus {
  outline: none;
}

.rdw-image-mandatory-sign {
  color: red;
  margin-left: 3px;
  margin-right: 3px;
}

.rdw-remove-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-history-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-history-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-link-decorator-wrapper {
  position: relative;
}

.rdw-link-decorator-icon {
  position: absolute;
  left: 40%;
  top: 0;
  cursor: pointer;
  background-color: white;
}

.rdw-mention-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-suggestion-wrapper {
  position: relative;
}

.rdw-suggestion-dropdown {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid #F1F1F1;
  min-width: 100px;
  max-height: 150px;
  overflow: auto;
  background: white;
  z-index: 100;
}

.rdw-suggestion-option {
  padding: 7px 5px;
  border-bottom: 1px solid #f1f1f1;
}

.rdw-suggestion-option-active {
  background-color: #F1F1F1;
}

.rdw-hashtag-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-image-alignment-options-popup {
  position: absolute;
  background: white;
  display: flex;
  padding: 5px 2px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  width: 105px;
  cursor: pointer;
  z-index: 100;
}

.rdw-alignment-option-left {
  justify-content: flex-start;
}

.rdw-image-alignment-option {
  height: 15px;
  width: 15px;
  min-width: 15px;
}

.rdw-image-alignment {
  position: relative;
}

.rdw-image-imagewrapper {
  position: relative;
}

.rdw-image-center {
  display: flex;
  justify-content: center;
}

.rdw-image-left {
  display: flex;
}

.rdw-image-right {
  display: flex;
  justify-content: flex-end;
}

.rdw-image-alignment-options-popup-right {
  right: 0;
}

.rdw-editor-main {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.rdw-editor-toolbar {
  padding: 6px 5px 0;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  display: flex;
  justify-content: flex-start;
  background: white;
  flex-wrap: wrap;
  font-size: 15px;
  margin-bottom: 5px;
  -webkit-user-select: none;
          user-select: none;
}

.public-DraftStyleDefault-block {
  margin: 1em 0;
}

.rdw-editor-wrapper:focus {
  outline: none;
}

.rdw-editor-wrapper {
  box-sizing: content-box;
}

.rdw-editor-main blockquote {
  border-left: 5px solid #f1f1f1;
  padding-left: 5px;
}

.rdw-editor-main pre {
  background: #f1f1f1;
  border-radius: 3px;
  padding: 1px 10px;
} /**
* Draft v0.9.1
*
* Copyright (c) 2013-present, Facebook, Inc.
* All rights reserved.
*
* This source code is licensed under the BSD-style license found in the
* LICENSE file in the root directory of this source tree. An additional grant
* of patent rights can be found in the PATENTS file in the same directory.
*/
.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {
  height: inherit;
  text-align: left;
  text-align: initial;
}

.public-DraftEditor-content[contenteditable=true] {
  -webkit-user-modify: read-write-plaintext-only;
}

.DraftEditor-root {
  position: relative;
}

.DraftEditor-editorContainer {
  background-color: rgba(255, 255, 255, 0);
  border-left: 0.1px solid transparent;
  position: relative;
  z-index: 1;
}

.public-DraftEditor-block {
  position: relative;
}

.DraftEditor-alignLeft .public-DraftStyleDefault-block {
  text-align: left;
}

.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
  left: 0;
  text-align: left;
}

.DraftEditor-alignCenter .public-DraftStyleDefault-block {
  text-align: center;
}

.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.DraftEditor-alignRight .public-DraftStyleDefault-block {
  text-align: right;
}

.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
  right: 0;
  text-align: right;
}

.public-DraftEditorPlaceholder-root {
  color: #9197a3;
  position: absolute;
  z-index: 0;
}

.public-DraftEditorPlaceholder-hasFocus {
  color: #bdc1c9;
}

.DraftEditorPlaceholder-hidden {
  display: none;
}

.public-DraftStyleDefault-block {
  position: relative;
  white-space: pre-wrap;
}

.public-DraftStyleDefault-ltr {
  direction: ltr;
  text-align: left;
}

.public-DraftStyleDefault-rtl {
  direction: rtl;
  text-align: right;
}

.public-DraftStyleDefault-listLTR {
  direction: ltr;
}

.public-DraftStyleDefault-listRTL {
  direction: rtl;
}

.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {
  margin: 16px 0;
  padding: 0;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
  margin-left: 1.5em;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
  margin-right: 1.5em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
  margin-left: 3em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
  margin-right: 3em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
  margin-left: 4.5em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
  margin-right: 4.5em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
  margin-left: 6em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
  margin-right: 6em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
  margin-left: 7.5em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
  margin-right: 7.5em;
}

.public-DraftStyleDefault-unorderedListItem {
  list-style-type: square;
  position: relative;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
  list-style-type: disc;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
  list-style-type: circle;
}

.public-DraftStyleDefault-orderedListItem {
  list-style-type: none;
  position: relative;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
  left: -36px;
  position: absolute;
  text-align: right;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
  position: absolute;
  right: -36px;
  text-align: left;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem:before {
  content: counter(ol0) ". ";
  counter-increment: ol0;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
  content: counter(ol1) ". ";
  counter-increment: ol1;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
  content: counter(ol2) ". ";
  counter-increment: ol2;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
  content: counter(ol3) ". ";
  counter-increment: ol3;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
  content: counter(ol4) ". ";
  counter-increment: ol4;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
  counter-reset: ol0;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
  counter-reset: ol1;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
  counter-reset: ol2;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
  counter-reset: ol3;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
  counter-reset: ol4;
}

.demo-editor {
  height: 275px !important;
  border: 1px solid #F1F1F1 !important;
  padding: 5px !important;
  border-radius: 2px !important;
}

.has-switch {
  border-radius: 30px;
  cursor: pointer;
  display: inline-block;
  line-height: 1.72222;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 60px;
  -webkit-user-select: none;
          user-select: none;
}

.has-switch.deactivate {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.has-switch.deactivate label,
.has-switch.deactivate span {
  cursor: default !important;
}

.has-switch > div {
  position: relative;
  top: 0;
  width: 100px;
}

.has-switch > div.switch-animate {
  transition: left 0.25s ease-out;
}

.has-switch > div.switch-off {
  left: -35px;
}

.has-switch > div.switch-on {
  left: 0;
}

.has-switch > div label {
  background-color: #FFFFFF;
  background: rgb(255, 255, 255);
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);
  background-size: 150% 150%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.has-switch input[type=checkbox] {
  display: none;
}

.has-switch span {
  cursor: pointer;
  float: left;
  font-size: 11px;
  font-weight: 400;
  height: 24px;
  line-height: 15px;
  margin: 0;
  padding-bottom: 6px;
  padding-top: 5px;
  position: relative;
  text-align: center;
  text-indent: -10px;
  width: 50%;
  z-index: 1;
  transition: 0.25s ease-out;
}

.has-switch span.switch-left {
  background-color: #545cd8;
  border-left: 1px solid rgba(0, 0, 0, 0);
  border-radius: 30px 0 0 30px;
  color: #FFFFFF;
}

.has-switch .switch-off span.switch-left {
  background-color: #ced4da !important;
}

.has-switch span.switch-right {
  border-radius: 0 30px 30px 0;
  background-color: #545cd8;
  color: #ffffff;
  text-indent: 1px;
}

.has-switch .switch-off span.switch-right {
  background-color: #ced4da !important;
}

.has-switch label {
  border-radius: 12px;
  float: left;
  height: 22px;
  margin: 1px -13px;
  padding: 0;
  position: relative;
  vertical-align: middle;
  width: 22px;
  z-index: 10;
  transition: 0.25s ease-out;
}

.has-switch .switch-on .fa-check:before {
  margin-left: 10px;
}

.has-switch:hover .switch-on label {
  margin: 1px -17px;
  width: 26px;
}

.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 26px;
}

.has-switch-sm.has-switch span {
  height: 18px;
  line-height: 18px;
  padding: 0;
}
.has-switch-sm.has-switch label {
  height: 16px;
  width: 16px;
  margin: 1px -8px;
}
.has-switch-sm.has-switch .switch-off label {
  margin: 1px -13px;
}
.has-switch-sm.has-switch:hover .switch-on label {
  margin: 1px -11px;
  width: 20px;
}
.has-switch-sm.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 20px;
}

.dropzone-wrapper {
  width: 100%;
  border: #ced4da dashed 2px;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  height: 230px;
  transition: all 0.2s;
}
.dropzone-wrapper:hover {
  border-color: #545cd8;
}
.dropzone-wrapper > div {
  width: 100%;
  height: 100%;
  outline: none !important;
  display: flex;
  align-items: center;
}
.dropzone-wrapper.dropzone-wrapper-lg {
  height: 300px;
}
.dropzone-wrapper.dropzone-wrapper-sm {
  height: 150px;
}
.dropzone-wrapper input {
  width: 100%;
  height: 100%;
}
.dropzone-wrapper .dropzone-content {
  margin: 0 auto;
  color: #6c757d;
}
.dropzone-wrapper[aria-disabled=true] {
  border-color: #dee2e6;
}
.dropzone-wrapper[aria-disabled=true] .dropzone-content {
  color: #ced4da;
}

.rbt {
  outline: none;
}
.rbt-menu {
  margin-bottom: 2px;
}
.rbt-menu > li a {
  overflow: hidden;
  text-overflow: ellipsis;
}
.rbt-menu > li a:focus {
  outline: none;
}
.rbt-menu-pagination-option {
  text-align: center;
}
.rbt .rbt-input-main::-ms-clear {
  display: none;
}
.rbt-input-multi {
  cursor: text;
  overflow: hidden;
  position: relative;
}
.rbt-input-multi.form-control[disabled] {
  background-color: #e9ecef;
  opacity: 1;
}
.rbt-input-multi input::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.rbt-input-multi input:-ms-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi input::-webkit-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi .rbt-input-wrapper {
  margin-top: 2px;
  overflow: hidden;
}
.rbt-input-multi .rbt-input-main {
  height: auto;
}
.rbt-input-multi .rbt-input-hint-container {
  display: inline-block;
}
.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {
  height: auto;
}
.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {
  height: auto;
}
.rbt-close {
  z-index: 1;
}
.rbt-close-lg {
  font-size: 24px;
}
.rbt-token {
  background-color: #e0f3ff;
  border: 0;
  border-radius: 0.375rem;
  color: #545cd8;
  display: inline-block;
  line-height: 1em;
  margin: 0 3px 3px 0;
  padding: 4px 7px;
  position: relative;
}
.rbt-token-disabled {
  background-color: #f8f9fa;
  color: #adb5bd;
  pointer-events: none;
}
.rbt-token-removeable {
  cursor: pointer;
  padding-right: 21px;
}
.rbt-token-active {
  background-color: #545cd8;
  color: #fff;
  outline: none;
  text-decoration: none;
}
.rbt-token .rbt-token-remove-button {
  bottom: 0;
  color: #495057;
  font-size: inherit;
  font-weight: normal;
  opacity: 1;
  outline: none;
  padding: 3px 7px;
  position: absolute;
  right: 0;
  text-shadow: none;
  top: -1px;
}
.rbt-loader {
  animation: loader-animation 600ms infinite linear;
  border: 1px solid #e0f3ff;
  border-radius: 50%;
  border-top-color: rgb(201.6, 218.7, 229.5);
  display: block;
  height: 16px;
  width: 16px;
}
.rbt-loader-lg {
  height: 20px;
  width: 20px;
}
.rbt-aux {
  display: flex;
  align-items: center;
  bottom: 0;
  justify-content: center;
  pointer-events: none; /* Don't block clicks on the input */
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
}
.rbt-aux-lg {
  width: 46px;
}
.rbt-aux .rbt-close {
  margin-top: -1px;
  pointer-events: auto; /* Override pointer-events: none; above */
  background-color: transparent;
  border: none;
}
.has-aux .rbt-input {
  padding-right: 34px;
}
.rbt-highlight-text {
  background-color: inherit;
  color: inherit;
  font-weight: bold;
  padding: 0;
}

/* Input Groups */
.input-group > .rbt {
  flex: 1 1;
}
.input-group > .rbt .rbt-input-hint-container {
  display: flex;
}
.input-group > .rbt .rbt-input-hint {
  z-index: 5;
}
.input-group > .rbt .rbt-aux {
  z-index: 5;
}
.input-group > .rbt:not(:first-child) .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .rbt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

@keyframes loader-animation {
  to {
    transform: rotate(1turn);
  }
}
.input-group > .rbt .rbt-input-hint-container {
  flex: 1 1;
  height: 100%;
}

.rbt-token-remove-button {
  background-color: transparent;
  border: none;
}

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate(500px);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(42, 46, 108, 0.03), -0.9375rem 0 1.40625rem rgba(42, 46, 108, 0.03), -0.25rem 0 0.53125rem rgba(42, 46, 108, 0.05), -0.125rem 0 0.1875rem rgba(42, 46, 108, 0.03);
}
.ui-theme-settings .btn-open-options {
  border-radius: 50px;
  position: absolute;
  left: -114px;
  bottom: 80px;
  padding: 0;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
  display: block;
  box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
  margin-top: -27px;
}
.ui-theme-settings .btn-open-options svg {
  top: 50%;
  left: 50%;
  position: absolute;
  margin: -0.5em 0 0 -0.5em;
}
.ui-theme-settings .theme-settings__inner {
  background: #fff;
  width: 500px;
  height: 100vh;
  padding: 0;
}
.ui-theme-settings.settings-open {
  transform: translate(0);
  right: 0;
}
.ui-theme-settings .theme-settings-swatches {
  text-align: center;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img {
  width: 72px;
  height: auto;
  border-radius: 3px;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {
  width: 100%;
}
.ui-theme-settings .themeoptions-heading {
  font-size: 1.1rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
  display: flex;
  align-items: center;
  align-content: center;
}
.ui-theme-settings .themeoptions-heading:first-child {
  border-top: 0;
}
.ui-theme-settings .list-group-item h5, .ui-theme-settings .list-group-item .h5 {
  color: #545cd8;
  font-size: 0.968rem;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;
}
.swatch-holder.active {
  border: #fff solid 2px;
  box-shadow: 0 0 0 5px #545cd8;
  opacity: 1;
}
.swatch-holder:hover {
  opacity: 1;
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.font-icon-wrapper {
  text-align: center;
  border: #e9ecef solid 1px;
  border-radius: 0.375rem;
  margin: 0 0 10px;
  padding: 5px;
}
.font-icon-wrapper.font-icon-lg {
  float: left;
  padding: 10px;
  text-align: center;
  margin-right: 15px;
  min-width: 64px;
}
.font-icon-wrapper.font-icon-lg i {
  font-size: 2.2rem;
}
.font-icon-wrapper:hover {
  background: #f8f9fa;
  color: #545cd8;
}
.font-icon-wrapper:hover p {
  color: #6c757d;
}
.font-icon-wrapper i {
  font-size: 1.65rem;
}
.font-icon-wrapper p {
  color: #adb5bd;
  font-size: 0.8066666667rem;
  margin: 5px 0 0;
}

.btn-icon-vertical {
  min-width: 100px;
}

.card.mb-3 {
  margin-bottom: 1rem !important;
}

.demo-image-bg {
  height: 350px;
  margin-bottom: 1rem;
}

.loader-wrapper {
  width: 150px;
  height: 100px;
  float: left;
}

.slider-item {
  background: #dee2e6;
  border-radius: 0.375rem;
  color: #6c757d;
  font-size: 36px;
  padding: 0;
  position: relative;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 1.5rem;
  transition: all 0.2s;
}

.slick-center .slider-item {
  background: #adb5bd;
  color: #495057;
}

.after-img {
  max-width: 100%;
}

@media only screen and (max-width: 1320px) {
  .header-user-info {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .app-main {
    display: block;
  }
  .dropdown-menu::before, .dropdown-menu::after {
    display: none;
  }
  .app-sidebar {
    flex: 0 0 280px !important;
    width: 280px !important;
    transform: translateX(-280px);
  }
  .app-sidebar .app-header__logo {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar {
    transform: translateX(0);
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {
    text-indent: 0;
    text-indent: initial;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {
    text-indent: 0;
    text-indent: initial;
    padding: 0 1.5rem 0 45px;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {
    text-indent: 0;
    text-indent: initial;
    left: 5px;
    margin-left: 0;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {
    visibility: visible;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {
    padding: 0.5em 0 0 2rem;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
    height: 2.3em;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
    padding-left: 1em;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo {
    width: auto !important;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {
    width: 97px !important;
    margin-left: auto;
    margin-right: 0;
  }
  .sidebar-mobile-open .fixed-sidebar .app-sidebar {
    height: 100%;
  }
  .sidebar-mobile-open .sidebar-mobile-overlay {
    display: block;
  }
  .app-main .app-main__outer {
    padding-left: 0 !important;
    width: auto;
  }
  .app-header {
    justify-content: space-between;
  }
  .app-header .app-header__logo {
    display: none;
    order: 2;
    background: transparent !important;
    border: 0 !important;
  }
  .app-header .app-header__content {
    visibility: hidden;
    opacity: 0;
    box-shadow: 0 0.46875rem 2.1875rem rgba(42, 46, 108, 0.03), 0 0.9375rem 1.40625rem rgba(42, 46, 108, 0.03), 0 0.25rem 0.53125rem rgba(42, 46, 108, 0.05), 0 0.125rem 0.1875rem rgba(42, 46, 108, 0.03);
    position: absolute;
    left: 5%;
    width: 90%;
    top: 0;
    transition: all 0.2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
  }
  .app-header .app-header__content .header-btn-lg {
    margin-left: 0.5rem;
    padding: 0 0.5rem;
  }
  .app-header .app-header__content .header-btn-lg .hamburger-box {
    margin-top: 5px;
  }
  .app-header .app-header__content .header-btn-lg + .header-btn-lg {
    display: none;
  }
  .app-header .app-header__content .app-header-left .nav {
    display: none;
  }
  .app-header .app-header__content.header-mobile-open {
    visibility: visible;
    opacity: 1;
    top: 80px;
  }
  .app-header .app-header__mobile-menu {
    display: flex;
    order: 1;
  }
  .app-header .app-header__menu {
    display: flex;
    order: 3;
  }
  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.1);
  }
  .app-header.header-text-light .header-mobile-open {
    background: #343a40;
  }
  .popover,
  .dropdown-menu {
    position: fixed !important;
    z-index: 50;
    left: 5% !important;
    top: 50% !important;
    width: 90% !important;
    transform: translateY(-50%) !important;
    min-width: 10px !important;
  }
  .popover .btn-icon-vertical .btn-icon-wrapper,
  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {
    display: none;
  }
  .popover {
    max-width: none;
    max-width: initial;
  }
  .popover .arrow {
    display: none !important;
  }
  .app-page-title {
    text-align: center;
  }
  .app-page-title .page-title-heading,
  .app-page-title .page-title-wrapper {
    margin: 0 auto;
    display: block;
  }
  .app-page-title .page-title-actions {
    margin: 0.5rem auto 0;
  }
  .app-page-title .page-title-actions .breadcrumb-item,
  .app-page-title .page-title-actions .breadcrumb,
  .app-page-title .page-title-subheading .breadcrumb-item,
  .app-page-title .page-title-subheading .breadcrumb {
    display: inline-block;
  }
  .app-footer .app-footer__inner .app-footer-right {
    display: none;
  }
  .app-footer .app-footer__inner .app-footer-left {
    width: 100%;
  }
  .app-footer .app-footer__inner .app-footer-left .footer-dots {
    margin: 0 auto;
  }
  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {
    margin-left: 0 !important;
  }
  .widget-content .widget-numbers {
    font-size: 1.6rem;
    line-height: 1;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big {
    display: block !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
    display: inline-block !important;
    padding: 0 1.5rem !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {
    margin-top: -20px;
  }
  .ReactTable .-pagination .-center {
    display: none;
  }
  .ReactTable .-pagination .-previous {
    padding-right: 3px;
  }
  .bg-transparent.list-group-item {
    border-color: transparent;
  }
  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {
    font-size: 1.5rem;
  }
  .page-title-head {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .app-page-title .page-title-icon,
  .ui-theme-settings {
    display: none;
  }
  .card-header.responsive-center {
    display: block;
    text-align: center;
    height: auto;
    padding: 1.5rem;
  }
  .card-header.responsive-center .nav,
  .card-header.responsive-center .btn-actions-pane-right {
    margin: 0.75rem 0 0;
  }
  .card-header.responsive-center .nav .d-inline-block.ml-2,
  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {
    width: 100% !important;
    text-align: left;
    margin: 0 !important;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
}
@media (min-width: 992px) {
  .slick-slider-sm .slick-slider {
    max-width: 850px !important;
  }
}
@media (max-width: 991.98px) {
  .-hide-paging .-pagination .-center {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .app-main .app-main__inner {
    padding: 15px 15px 0;
  }
  .mbg-3,
  body .card.mb-3 {
    margin-bottom: 0.5rem !important;
  }
  .app-page-title {
    padding: 0.5rem;
    margin: -0.5rem -0.5rem 1rem;
  }
  .body-tabs.body-tabs-layout {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    padding: 0 0.5rem;
  }
  .app-main .app-main__inner > .RRT__container > .RRT__panel {
    margin-top: 0.5rem;
  }
  .popover,
  .dropdown-menu {
    width: 80%;
    left: 10%;
  }
  body .card-header {
    height: auto;
    display: block;
    padding: 0.75rem 1.5rem;
    text-align: center;
  }
  body .card-header .btn-actions-pane-right {
    padding: 0.75rem 0 0;
  }
  body .card-header .actions-icon-btn {
    padding: 0;
  }
  .card-header.card-header-tab .card-header-title {
    display: inline-flex !important;
    line-height: 1;
  }
  .card-header.card-header-tab > .nav {
    margin: 0.75rem 0 -0.75rem;
    display: table !important;
    width: 100%;
  }
  .card-header.card-header-tab > .nav .nav-item {
    display: table-cell;
  }
  .header-icon {
    display: none;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
  .slick-slider-sm .slick-slider .slick-prev {
    left: 0.5rem;
  }
  .slick-slider-sm .slick-slider .slick-next {
    right: 0.5rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
}
.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
  text-align: left;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: flex;
  align-items: center;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.375rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 5px;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
  padding-left: 35px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 35px;
}

@media (min-width: 768px) {
  .header-btn-lg .dropdown-menu {
    position: absolute !important;
    left: auto !important;
    right: 0 !important;
    top: 100% !important;
    transform: none !important;
    width: auto !important;
    min-width: 280px !important;
    max-width: 320px !important;
  }
}
.badge.text-bg-success,
.badge.text-bg-success small,
.badge.text-bg-success .small {
  color: white !important;
}

.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
  text-align: left;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: flex;
  align-items: center;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.375rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 5px;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
  padding-left: 35px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 35px;
}

.closed-sidebar .app-sidebar {
  transition: all 0.3s ease;
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px;
  z-index: 13;
}
.closed-sidebar .app-sidebar .app-sidebar__inner {
  padding: 2px 1.5rem;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {
  text-indent: -999em;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0.75rem 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 5px;
  width: calc(100% - 10px);
  height: 1px;
  background: #e0f3ff;
  text-indent: 1px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {
  text-indent: -99rem;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  position: relative;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  position: static;
  transform: none;
  margin: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {
  visibility: hidden;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-item {
  width: 100%;
  display: flex;
  justify-content: center;
}
.closed-sidebar .app-sidebar:hover {
  flex: 0 0 280px !important;
  width: 280px !important;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner {
  padding: 2px 1.5rem 1.5rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {
  text-indent: 0;
  text-indent: initial;
  justify-content: flex-start;
  padding: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {
  display: none;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {
  text-indent: 0;
  text-indent: initial;
  padding: 0 1.5rem 0 45px;
  justify-content: flex-start;
  margin: 0;
  width: 100%;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {
  visibility: visible;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container {
  display: block;
  padding: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  padding-left: 35px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 35px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-item {
  width: 100%;
  display: block;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {
  position: static;
  height: auto;
  overflow: visible !important;
  overflow: initial !important;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {
  position: absolute;
  height: 100%;
  overflow: hidden !important;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {
  width: 80px;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {
  display: none;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {
  margin-right: auto;
}
.closed-sidebar.fixed-sidebar .app-main__outer {
  padding-left: 80px;
}
.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {
  width: auto;
  display: flex;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {
  display: flex;
  width: 80px;
  padding: 0 1.5rem !important;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {
  display: block !important;
  margin: 0 auto;
  width: 21px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {
  width: 280px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {
  width: 97px;
  margin: 0;
}
.closed-sidebar.closed-sidebar-mobile .app-header {
  margin-left: 0 !important;
}
.closed-sidebar.fixed-footer .app-footer__inner {
  margin-left: 0 !important;
}

.Toastify__toast-container {
  z-index: 2147483647 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/base.scss","webpack://./src/assets/themes/default/_variables.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/layout/generic/_generic-base.scss","webpack://./src/assets/layout/generic/_animations.scss","webpack://./src/assets/layout/header/_header-base.scss","webpack://./src/assets/layout/_layout-variables.scss","webpack://./src/assets/layout/header/modifiers/_fixed-header.scss","webpack://./src/assets/layout/header/modifiers/_header-dots.scss","webpack://./src/assets/layout/header/modifiers/_header-megamenu.scss","webpack://./src/assets/layout/header/modifiers/_header-buttons.scss","webpack://./src/assets/layout/header/themes/_header-light.scss","webpack://./src/assets/layout/header/themes/_header-dark.scss","webpack://./src/assets/layout/sidebar/_sidebar-base.scss","webpack://./src/assets/layout/sidebar/modifiers/_navmenu-vertical.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-light.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-dark.scss","webpack://./src/assets/layout/sidebar/modifiers/_fixed-sidebar.scss","webpack://./src/assets/layout/sidebar/modifiers/_closed-sidebar.scss","webpack://./src/assets/layout/main/_main-base.scss","webpack://./src/assets/layout/main/themes/_main-white.scss","webpack://./src/assets/layout/main/themes/_main-gray.scss","webpack://./src/assets/layout/footer/_footer-base.scss","webpack://./src/assets/layout/footer/_fixed-footer.scss","webpack://./src/assets/layout/elements/page-title/_page-title-base.scss","webpack://./src/assets/layout/elements/search-box/_search-box.scss","webpack://./src/assets/utils/helpers/_opacity.scss","webpack://./src/assets/utils/helpers/_grayscale.scss","webpack://./src/assets/utils/_helpers.scss","webpack://./src/assets/utils/_backgrounds.scss","webpack://./src/assets/utils/_animate.scss","webpack://./node_modules/animate-sass/helpers/_base.scss","webpack://./node_modules/animate-sass/helpers/_mixins.scss","webpack://./node_modules/animate-sass/helpers/_settings.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeIn.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInDown.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInUp.scss","webpack://./node_modules/animate-sass/animations/fade-exit/_fadeOut.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedIn.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedOut.scss","webpack://./src/assets/utils/_comps-animations.scss","webpack://./src/assets/elements/_buttons.scss","webpack://./src/assets/elements/_dropdown.scss","webpack://./src/assets/elements/_navs.scss","webpack://./src/assets/elements/_badges.scss","webpack://./src/assets/elements/_cards.scss","webpack://./src/assets/elements/_tabs.scss","webpack://./src/assets/elements/_accordions.scss","webpack://./src/assets/elements/_modals.scss","webpack://./src/assets/elements/_loaders.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse.scss","webpack://./node_modules/loaders.css/src/_mixins.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-sync.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale.scss","webpack://./node_modules/loaders.css/src/animations/ball-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-triangle-trace.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-rise.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag-deflect.scss","webpack://./node_modules/loaders.css/src/animations/line-scale.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-random.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid.scss","webpack://./node_modules/loaders.css/src/animations/line-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/triangle-skew-spin.scss","webpack://./node_modules/loaders.css/src/animations/square-spin.scss","webpack://./node_modules/loaders.css/src/animations/pacman.scss","webpack://./node_modules/loaders.css/src/animations/cube-transition.scss","webpack://./node_modules/loaders.css/src/animations/semi-circle-spin.scss","webpack://./src/assets/elements/_progressbar.scss","webpack://./src/assets/elements/_timeline.scss","webpack://./src/assets/elements/listgroup.scss","webpack://./src/assets/elements/_forms.scss","webpack://./src/assets/elements/_pagination.scss","webpack://./src/assets/elements/_chat.scss","webpack://./src/assets/elements/_forms-wizard.scss","webpack://./src/assets/widgets/chart-boxes/_chart-boxes.scss","webpack://./src/assets/widgets/content-boxes/_content-boxes.scss","webpack://./src/assets/widgets/profile-boxes/_profile-boxes.scss","webpack://./src/assets/pages/_userpages.scss","webpack://./src/assets/applications/_applications-base.scss","webpack://./src/assets/applications/_chat.scss","webpack://./src/assets/applications/_responsive.scss","webpack://./src/assets/components/perfect-scrollbar/_perfect-scrollbar.scss","webpack://./src/assets/components/rc-tabs/_rc-tabs.scss","webpack://./src/assets/components/loading-buttons/_loading-buttons.scss","webpack://./src/assets/components/hamburgers/hamburgers.scss","webpack://./src/assets/components/hamburgers/_base.scss","webpack://./src/assets/components/hamburgers/types/_elastic.scss","webpack://./src/assets/components/drawer/_drawer.scss","webpack://./src/assets/components/notifications/_sweetalerts.scss","webpack://./src/assets/components/notifications/toastify/_toastContainer.scss","webpack://./src/assets/components/notifications/toastify/_variables.scss","webpack://./src/assets/components/notifications/toastify/_toast.scss","webpack://./src/assets/components/notifications/toastify/_closeButton.scss","webpack://./src/assets/components/notifications/toastify/_progressBar.scss","webpack://./src/assets/components/notifications/toastify/animations/_bounce.scss","webpack://./src/assets/components/notifications/toastify/animations/_zoom.scss","webpack://./src/assets/components/notifications/toastify/animations/_flip.scss","webpack://./src/assets/components/notifications/toastify/animations/_slide.scss","webpack://./src/assets/components/modals/_rodal.scss","webpack://./src/assets/components/progress-bar/_progress-bar.scss","webpack://./src/assets/components/slick-carousel/slick/_slick.scss","webpack://./src/assets/components/slick-carousel/slick/_slick-theme.scss","webpack://./src/assets/components/block-loading/_block-loading.scss","webpack://./src/assets/components/popovers-tooltips/_popovers-tooltips.scss","webpack://./src/assets/components/sticky-elements/_sticky-elements.scss","webpack://./src/assets/components/calendar/scss/_reset.scss","webpack://./src/assets/components/calendar/_calendar.scss","webpack://./src/assets/components/calendar/scss/_variables.scss","webpack://./src/assets/components/calendar/scss/_toolbar.scss","webpack://./src/assets/components/calendar/scss/_event.scss","webpack://./src/assets/components/calendar/scss/_month.scss","webpack://./src/assets/components/calendar/scss/_agenda.scss","webpack://./src/assets/components/calendar/scss/_time-column.scss","webpack://./src/assets/components/calendar/scss/_time-grid.scss","webpack://./src/assets/components/splitters/_splitters.scss","webpack://./src/assets/components/tree-view/_tree-view.scss","webpack://./src/assets/components/tables/_tables.scss","webpack://./src/assets/components/icons/_linearicons.scss","webpack://./node_modules/pe7-icon/dist/scss/pe-icon-7-stroke.scss","webpack://./node_modules/pe7-icon/dist/scss/_path.scss","webpack://./node_modules/pe7-icon/dist/scss/_core.scss","webpack://./node_modules/pe7-icon/dist/scss/_helper.scss","webpack://./node_modules/pe7-icon/dist/scss/_icons.scss","webpack://./node_modules/pe7-icon/dist/scss/_variables.scss","webpack://./src/assets/components/forms/datepicker/_mixins.scss","webpack://./src/assets/components/forms/datepicker/_variables.scss","webpack://./src/assets/components/forms/datepicker/_datepicker.scss","webpack://./src/assets/components/forms/rangeslider/_tooltip.scss","webpack://./src/assets/components/forms/rangeslider/_rangeslider.scss","webpack://./src/assets/components/forms/wysiwyg/_wysiwyg.scss","webpack://./src/assets/components/forms/toggle-switch/_switch.scss","webpack://./src/assets/components/forms/dropzone/_dropzone.scss","webpack://./src/assets/components/forms/typeahead/_typeahead.scss","webpack://./src/assets/components/forms/typeahead/_mixins.scss","webpack://./src/assets/demo-ui/elements/_theme-options.scss","webpack://./src/assets/demo-ui/_demo.scss","webpack://./src/assets/layout/responsive/_responsive-base.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,oEAAA;ACoLE;EACE,qBA/FW;ADlFf;;ACgLE;EACE,qBA/FW;AD9Ef;;AC4KE;EACE,qBA/FW;AD1Ef;;ACwKE;EACE,qBA/FW;ADtEf;;ACoKE;EACE,qBA/FW;ADlEf;;ACgKE;EACE,qBA/FW;AD9Df;;AC4JE;EACE,qBA/FW;AD1Df;;ACwJE;EACE,qBA/FW;ADtDf;;ACoJE;EACE,qBA/FW;ADlDf;;ACgJE;EACE,qBA/FW;AD9Cf;;AExCA;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAIA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,gCAAA;EAIA,iDAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,gDAAA;EAAA,gDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,oDAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,4BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,6CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFsCF;;AItJI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,oDAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,yCAAA;EACA,kDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,sDAAA;AFsCJ;;AK9MA;;;EAGE,sBAAA;ALiNF;;AKlMI;EANJ;IAOM,uBAAA;ELsMJ;AACF;;AKzLA;EACE,SAAA;EACA,4MAAA;EAAA,uCAAA;EF6OI,kBALI;EAKJ,mCALI;EEtOR,gBAAA;EAAA,uCAAA;EACA,gBAAA;EAAA,uCAAA;EACA,cAAA;EAAA,2BAAA;EACA,qCAAA;EACA,sBAAA;EAAA,mCAAA;EACA,8BAAA;EACA,6CAAA;AL4LF;;AKnLA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,qBAAA;EAAA,wCAAA;EACA,aCynB4B;ANnc9B;;AK5KA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBJMqB;EILrB,gBCwjB4B;EDvjB5B,cAAA;EAAA,8BAAA;AL6KF;;AK1KA;EFuMQ,kCAAA;AHzBR;AGnII;EE3CJ;IF8MQ,iBAAA;EH5BN;AACF;;AK9KA;EFkMQ,mCAAA;AHhBR;AG5II;EEtCJ;IFyMQ,kBAAA;EHnBN;AACF;;AKlLA;EF6LQ,mCAAA;AHPR;AGrJI;EEjCJ;IFoMQ,kBAAA;EHVN;AACF;;AKtLA;EFwLQ,mCAAA;AHER;AG9JI;EE5BJ;IF+LQ,kBAAA;EHDN;AACF;;AK1LA;EF+KM,iBALI;AHoBV;;AKzLA;EF0KM,kBALI;AHwBV;;AKlLA;EACE,aAAA;EACA,mBCwV0B;ANnK5B;;AK3KA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AL8KF;;AKxKA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AL2KF;;AKrKA;;EAEE,kBAAA;ALwKF;;AKrKA;;;EAGE,aAAA;EACA,mBAAA;ALwKF;;AKrKA;;;;EAIE,gBAAA;ALwKF;;AKrKA;EACE,gBC6b4B;ANrR9B;;AKnKA;EACE,qBAAA;EACA,cAAA;ALsKF;;AKhKA;EACE,gBAAA;ALmKF;;AK3JA;;EAEE,mBCsa4B;ANxQ9B;;AKtJA;EF6EM,kBALI;AHkFV;;AKnJA;EACE,iBCqf4B;EDpf5B,cAAA;EAAA,gCAAA;EACA,wCAAA;EAAA,wCAAA;ALsJF;;AK7IA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALgJF;;AK7IA;EAAM,eAAA;ALiJN;;AKhJA;EAAM,WAAA;ALoJN;;AK/IA;EACE,2BAAA;EAAA,gEAAA;EACA,0BCgNwC;AN9D1C;AKhJE;EACE,mDAAA;ALkJJ;;AKvIE;EAEE,cAAA;EACA,qBAAA;ALyIJ;;AKlIA;;;;EAIE,iGCgV4B;EDhV5B,qCCgV4B;EHlUxB,cALI;AH6HV;;AK9HA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AHqIV;AK7HE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AL+HJ;;AK3HA;EFVM,kBALI;EEiBR,cAAA;EAAA,2BAAA;EACA,qBAAA;AL8HF;AK3HE;EACE,cAAA;AL6HJ;;AKzHA;EACE,2BAAA;EFtBI,kBALI;EE6BR,WC25CkC;ED35ClC,wBC25CkC;ED15ClC,yBC25CkC;ED35ClC,sCC25CkC;EChsDhC,sBAAA;APkaJ;AK1HE;EACE,UAAA;EF7BE,cALI;AH+JV;;AKlHA;EACE,gBAAA;ALqHF;;AK/GA;;EAEE,sBAAA;ALkHF;;AK1GA;EACE,oBAAA;EACA,yBAAA;AL6GF;;AK1GA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,6BC4Z4B;ED5Z5B,gCC4Z4B;ED3Z5B,gBAAA;AL6GF;;AKtGA;EAEE,mBAAA;EACA,gCAAA;ALwGF;;AKrGA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALwGF;;AKhGA;EACE,qBAAA;ALmGF;;AK7FA;EAEE,gBAAA;AL+FF;;AKvFA;EACE,UAAA;AL0FF;;AKrFA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALwFF;;AKpFA;;EAEE,oBAAA;ALuFF;;AKlFA;EACE,eAAA;ALqFF;;AKlFA;EAGE,iBAAA;ALmFF;AKhFE;EACE,UAAA;ALkFJ;;AK3EA;EACE,wBAAA;AL8EF;;AKtEA;;;;EAIE,0BAAA;ALyEF;AKtEI;;;;EACE,eAAA;AL2EN;;AKpEA;EACE,UAAA;EACA,kBAAA;ALuEF;;AKlEA;EACE,gBAAA;ALqEF;;AK3DA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AL8DF;;AKtDA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AH4QR;AGxaI;EEyWJ;IFtMQ,iBAAA;EHyQN;AACF;AK3DE;EACE,WAAA;AL6DJ;;AKtDA;;;;;;;EAOE,UAAA;ALyDF;;AKtDA;EACE,YAAA;ALyDF;;AKhDA;EACE,6BAAA;EACA,oBAAA;ALmDF;;AK3CA;;;;;;;CAAA;AAWA;EACE,wBAAA;AL2CF;;AKtCA;EACE,UAAA;ALyCF;;AKlCA;EACE,aAAA;EACA,0BAAA;ALqCF;;AKvCA;EACE,aAAA;EACA,0BAAA;ALqCF;;AKhCA;EACE,qBAAA;ALmCF;;AK9BA;EACE,SAAA;ALiCF;;AK1BA;EACE,kBAAA;EACA,eAAA;AL6BF;;AKrBA;EACE,wBAAA;ALwBF;;AKhBA;EACE,wBAAA;ALmBF;;AQxlBA;ELmQM,iBALI;EK5PR,gBFwoB4B;AN7C9B;;AQtlBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH4VR;AGxfI;EKpGF;ILuQM,eAAA;EHyVN;AACF;;AQjmBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHuWR;AGngBI;EKpGF;ILuQM,iBAAA;EHoWN;AACF;;AQ5mBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHkXR;AG9gBI;EKpGF;ILuQM,eAAA;EH+WN;AACF;;AQvnBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH6XR;AGzhBI;EKpGF;ILuQM,iBAAA;EH0XN;AACF;;AQloBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHwYR;AGpiBI;EKpGF;ILuQM,eAAA;EHqYN;AACF;;AQ7oBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHmZR;AG/iBI;EKpGF;ILuQM,iBAAA;EHgZN;AACF;;AQhoBA;ECvDE,eAAA;EACA,gBAAA;AT2rBF;;AQhoBA;EC5DE,eAAA;EACA,gBAAA;ATgsBF;;AQloBA;EACE,qBAAA;ARqoBF;AQnoBE;EACE,oBFsoB0B;AND9B;;AQ3nBA;EL8MM,kBALI;EKvMR,yBAAA;AR8nBF;;AQ1nBA;EACE,mBFiUO;EH1HH,iBALI;AH4bV;AQ3nBE;EACE,gBAAA;AR6nBJ;;AQznBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cP7ES;ADysBX;AQ1nBE;EACE,aAAA;AR4nBJ;;AU5tBA;ECIE,eAAA;EAGA,YAAA;AX0tBF;;AU3tBA;EACE,gBJ+jDkC;EI9jDlC,sBJ+jDkC;EI/jDlC,mCJ+jDkC;EI9jDlC,yBAAA;EAAA,2DAAA;EHGE,uBAAA;EAAA,sCAAA;EIRF,eAAA;EAGA,YAAA;AXmuBF;;AUrtBA;EAEE,qBAAA;AVutBF;;AUptBA;EACE,qBAAA;EACA,cAAA;AVutBF;;AUptBA;EPyPM,kBALI;EOlPR,6BJkjDkC;EIljDlC,gCJkjDkC;AN31BpC;;AYzvBE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AbswBF;;AchtBI;EF5CE;IACE,gBNkee;EN8RrB;AACF;ActtBI;EF5CE;IACE,gBNkee;ENmSrB;AACF;Ac3tBI;EF5CE;IACE,gBNkee;ENwSrB;AACF;AchuBI;EF5CE;IACE,iBNkee;EN6SrB;AACF;AcruBI;EF5CE;IACE,iBNkee;ENkTrB;AACF;AeryBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;Af2yBJ;;AetyBE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhB+yBF;Ae7yBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhByyBF;;AgB1vBM;EACE,SAAA;AhB6vBR;;AgB1vBM;EApCJ,cAAA;EACA,WAAA;AhBkyBF;;AgBpxBE;EACE,cAAA;EACA,WAAA;AhBuxBJ;;AgBzxBE;EACE,cAAA;EACA,UAAA;AhB4xBJ;;AgB9xBE;EACE,cAAA;EACA,mBAAA;AhBiyBJ;;AgBnyBE;EACE,cAAA;EACA,UAAA;AhBsyBJ;;AgBxyBE;EACE,cAAA;EACA,UAAA;AhB2yBJ;;AgB7yBE;EACE,cAAA;EACA,mBAAA;AhBgzBJ;;AgBjxBM;EAhDJ,cAAA;EACA,WAAA;AhBq0BF;;AgBhxBU;EAhEN,cAAA;EACA,kBAAA;AhBo1BJ;;AgBrxBU;EAhEN,cAAA;EACA,mBAAA;AhBy1BJ;;AgB1xBU;EAhEN,cAAA;EACA,UAAA;AhB81BJ;;AgB/xBU;EAhEN,cAAA;EACA,mBAAA;AhBm2BJ;;AgBpyBU;EAhEN,cAAA;EACA,mBAAA;AhBw2BJ;;AgBzyBU;EAhEN,cAAA;EACA,UAAA;AhB62BJ;;AgB9yBU;EAhEN,cAAA;EACA,mBAAA;AhBk3BJ;;AgBnzBU;EAhEN,cAAA;EACA,mBAAA;AhBu3BJ;;AgBxzBU;EAhEN,cAAA;EACA,UAAA;AhB43BJ;;AgB7zBU;EAhEN,cAAA;EACA,mBAAA;AhBi4BJ;;AgBl0BU;EAhEN,cAAA;EACA,mBAAA;AhBs4BJ;;AgBv0BU;EAhEN,cAAA;EACA,WAAA;AhB24BJ;;AgBp0BY;EAxDV,wBAAA;AhBg4BF;;AgBx0BY;EAxDV,yBAAA;AhBo4BF;;AgB50BY;EAxDV,gBAAA;AhBw4BF;;AgBh1BY;EAxDV,yBAAA;AhB44BF;;AgBp1BY;EAxDV,yBAAA;AhBg5BF;;AgBx1BY;EAxDV,gBAAA;AhBo5BF;;AgB51BY;EAxDV,yBAAA;AhBw5BF;;AgBh2BY;EAxDV,yBAAA;AhB45BF;;AgBp2BY;EAxDV,gBAAA;AhBg6BF;;AgBx2BY;EAxDV,yBAAA;AhBo6BF;;AgB52BY;EAxDV,yBAAA;AhBw6BF;;AgBr2BQ;;EAEE,gBAAA;AhBw2BV;;AgBr2BQ;;EAEE,gBAAA;AhBw2BV;;AgB/2BQ;;EAEE,sBAAA;AhBk3BV;;AgB/2BQ;;EAEE,sBAAA;AhBk3BV;;AgBz3BQ;;EAEE,qBAAA;AhB43BV;;AgBz3BQ;;EAEE,qBAAA;AhB43BV;;AgBn4BQ;;EAEE,mBAAA;AhBs4BV;;AgBn4BQ;;EAEE,mBAAA;AhBs4BV;;AgB74BQ;;EAEE,qBAAA;AhBg5BV;;AgB74BQ;;EAEE,qBAAA;AhBg5BV;;AgBv5BQ;;EAEE,mBAAA;AhB05BV;;AgBv5BQ;;EAEE,mBAAA;AhB05BV;;Acp9BI;EEUE;IACE,SAAA;EhB88BN;EgB38BI;IApCJ,cAAA;IACA,WAAA;EhBk/BA;EgBp+BA;IACE,cAAA;IACA,WAAA;EhBs+BF;EgBx+BA;IACE,cAAA;IACA,UAAA;EhB0+BF;EgB5+BA;IACE,cAAA;IACA,mBAAA;EhB8+BF;EgBh/BA;IACE,cAAA;IACA,UAAA;EhBk/BF;EgBp/BA;IACE,cAAA;IACA,UAAA;EhBs/BF;EgBx/BA;IACE,cAAA;IACA,mBAAA;EhB0/BF;EgB39BI;IAhDJ,cAAA;IACA,WAAA;EhB8gCA;EgBz9BQ;IAhEN,cAAA;IACA,kBAAA;EhB4hCF;EgB79BQ;IAhEN,cAAA;IACA,mBAAA;EhBgiCF;EgBj+BQ;IAhEN,cAAA;IACA,UAAA;EhBoiCF;EgBr+BQ;IAhEN,cAAA;IACA,mBAAA;EhBwiCF;EgBz+BQ;IAhEN,cAAA;IACA,mBAAA;EhB4iCF;EgB7+BQ;IAhEN,cAAA;IACA,UAAA;EhBgjCF;EgBj/BQ;IAhEN,cAAA;IACA,mBAAA;EhBojCF;EgBr/BQ;IAhEN,cAAA;IACA,mBAAA;EhBwjCF;EgBz/BQ;IAhEN,cAAA;IACA,UAAA;EhB4jCF;EgB7/BQ;IAhEN,cAAA;IACA,mBAAA;EhBgkCF;EgBjgCQ;IAhEN,cAAA;IACA,mBAAA;EhBokCF;EgBrgCQ;IAhEN,cAAA;IACA,WAAA;EhBwkCF;EgBjgCU;IAxDV,cAAA;EhB4jCA;EgBpgCU;IAxDV,wBAAA;EhB+jCA;EgBvgCU;IAxDV,yBAAA;EhBkkCA;EgB1gCU;IAxDV,gBAAA;EhBqkCA;EgB7gCU;IAxDV,yBAAA;EhBwkCA;EgBhhCU;IAxDV,yBAAA;EhB2kCA;EgBnhCU;IAxDV,gBAAA;EhB8kCA;EgBthCU;IAxDV,yBAAA;EhBilCA;EgBzhCU;IAxDV,yBAAA;EhBolCA;EgB5hCU;IAxDV,gBAAA;EhBulCA;EgB/hCU;IAxDV,yBAAA;EhB0lCA;EgBliCU;IAxDV,yBAAA;EhB6lCA;EgB1hCM;;IAEE,gBAAA;EhB4hCR;EgBzhCM;;IAEE,gBAAA;EhB2hCR;EgBliCM;;IAEE,sBAAA;EhBoiCR;EgBjiCM;;IAEE,sBAAA;EhBmiCR;EgB1iCM;;IAEE,qBAAA;EhB4iCR;EgBziCM;;IAEE,qBAAA;EhB2iCR;EgBljCM;;IAEE,mBAAA;EhBojCR;EgBjjCM;;IAEE,mBAAA;EhBmjCR;EgB1jCM;;IAEE,qBAAA;EhB4jCR;EgBzjCM;;IAEE,qBAAA;EhB2jCR;EgBlkCM;;IAEE,mBAAA;EhBokCR;EgBjkCM;;IAEE,mBAAA;EhBmkCR;AACF;Ac9nCI;EEUE;IACE,SAAA;EhBunCN;EgBpnCI;IApCJ,cAAA;IACA,WAAA;EhB2pCA;EgB7oCA;IACE,cAAA;IACA,WAAA;EhB+oCF;EgBjpCA;IACE,cAAA;IACA,UAAA;EhBmpCF;EgBrpCA;IACE,cAAA;IACA,mBAAA;EhBupCF;EgBzpCA;IACE,cAAA;IACA,UAAA;EhB2pCF;EgB7pCA;IACE,cAAA;IACA,UAAA;EhB+pCF;EgBjqCA;IACE,cAAA;IACA,mBAAA;EhBmqCF;EgBpoCI;IAhDJ,cAAA;IACA,WAAA;EhBurCA;EgBloCQ;IAhEN,cAAA;IACA,kBAAA;EhBqsCF;EgBtoCQ;IAhEN,cAAA;IACA,mBAAA;EhBysCF;EgB1oCQ;IAhEN,cAAA;IACA,UAAA;EhB6sCF;EgB9oCQ;IAhEN,cAAA;IACA,mBAAA;EhBitCF;EgBlpCQ;IAhEN,cAAA;IACA,mBAAA;EhBqtCF;EgBtpCQ;IAhEN,cAAA;IACA,UAAA;EhBytCF;EgB1pCQ;IAhEN,cAAA;IACA,mBAAA;EhB6tCF;EgB9pCQ;IAhEN,cAAA;IACA,mBAAA;EhBiuCF;EgBlqCQ;IAhEN,cAAA;IACA,UAAA;EhBquCF;EgBtqCQ;IAhEN,cAAA;IACA,mBAAA;EhByuCF;EgB1qCQ;IAhEN,cAAA;IACA,mBAAA;EhB6uCF;EgB9qCQ;IAhEN,cAAA;IACA,WAAA;EhBivCF;EgB1qCU;IAxDV,cAAA;EhBquCA;EgB7qCU;IAxDV,wBAAA;EhBwuCA;EgBhrCU;IAxDV,yBAAA;EhB2uCA;EgBnrCU;IAxDV,gBAAA;EhB8uCA;EgBtrCU;IAxDV,yBAAA;EhBivCA;EgBzrCU;IAxDV,yBAAA;EhBovCA;EgB5rCU;IAxDV,gBAAA;EhBuvCA;EgB/rCU;IAxDV,yBAAA;EhB0vCA;EgBlsCU;IAxDV,yBAAA;EhB6vCA;EgBrsCU;IAxDV,gBAAA;EhBgwCA;EgBxsCU;IAxDV,yBAAA;EhBmwCA;EgB3sCU;IAxDV,yBAAA;EhBswCA;EgBnsCM;;IAEE,gBAAA;EhBqsCR;EgBlsCM;;IAEE,gBAAA;EhBosCR;EgB3sCM;;IAEE,sBAAA;EhB6sCR;EgB1sCM;;IAEE,sBAAA;EhB4sCR;EgBntCM;;IAEE,qBAAA;EhBqtCR;EgBltCM;;IAEE,qBAAA;EhBotCR;EgB3tCM;;IAEE,mBAAA;EhB6tCR;EgB1tCM;;IAEE,mBAAA;EhB4tCR;EgBnuCM;;IAEE,qBAAA;EhBquCR;EgBluCM;;IAEE,qBAAA;EhBouCR;EgB3uCM;;IAEE,mBAAA;EhB6uCR;EgB1uCM;;IAEE,mBAAA;EhB4uCR;AACF;AcvyCI;EEUE;IACE,SAAA;EhBgyCN;EgB7xCI;IApCJ,cAAA;IACA,WAAA;EhBo0CA;EgBtzCA;IACE,cAAA;IACA,WAAA;EhBwzCF;EgB1zCA;IACE,cAAA;IACA,UAAA;EhB4zCF;EgB9zCA;IACE,cAAA;IACA,mBAAA;EhBg0CF;EgBl0CA;IACE,cAAA;IACA,UAAA;EhBo0CF;EgBt0CA;IACE,cAAA;IACA,UAAA;EhBw0CF;EgB10CA;IACE,cAAA;IACA,mBAAA;EhB40CF;EgB7yCI;IAhDJ,cAAA;IACA,WAAA;EhBg2CA;EgB3yCQ;IAhEN,cAAA;IACA,kBAAA;EhB82CF;EgB/yCQ;IAhEN,cAAA;IACA,mBAAA;EhBk3CF;EgBnzCQ;IAhEN,cAAA;IACA,UAAA;EhBs3CF;EgBvzCQ;IAhEN,cAAA;IACA,mBAAA;EhB03CF;EgB3zCQ;IAhEN,cAAA;IACA,mBAAA;EhB83CF;EgB/zCQ;IAhEN,cAAA;IACA,UAAA;EhBk4CF;EgBn0CQ;IAhEN,cAAA;IACA,mBAAA;EhBs4CF;EgBv0CQ;IAhEN,cAAA;IACA,mBAAA;EhB04CF;EgB30CQ;IAhEN,cAAA;IACA,UAAA;EhB84CF;EgB/0CQ;IAhEN,cAAA;IACA,mBAAA;EhBk5CF;EgBn1CQ;IAhEN,cAAA;IACA,mBAAA;EhBs5CF;EgBv1CQ;IAhEN,cAAA;IACA,WAAA;EhB05CF;EgBn1CU;IAxDV,cAAA;EhB84CA;EgBt1CU;IAxDV,wBAAA;EhBi5CA;EgBz1CU;IAxDV,yBAAA;EhBo5CA;EgB51CU;IAxDV,gBAAA;EhBu5CA;EgB/1CU;IAxDV,yBAAA;EhB05CA;EgBl2CU;IAxDV,yBAAA;EhB65CA;EgBr2CU;IAxDV,gBAAA;EhBg6CA;EgBx2CU;IAxDV,yBAAA;EhBm6CA;EgB32CU;IAxDV,yBAAA;EhBs6CA;EgB92CU;IAxDV,gBAAA;EhBy6CA;EgBj3CU;IAxDV,yBAAA;EhB46CA;EgBp3CU;IAxDV,yBAAA;EhB+6CA;EgB52CM;;IAEE,gBAAA;EhB82CR;EgB32CM;;IAEE,gBAAA;EhB62CR;EgBp3CM;;IAEE,sBAAA;EhBs3CR;EgBn3CM;;IAEE,sBAAA;EhBq3CR;EgB53CM;;IAEE,qBAAA;EhB83CR;EgB33CM;;IAEE,qBAAA;EhB63CR;EgBp4CM;;IAEE,mBAAA;EhBs4CR;EgBn4CM;;IAEE,mBAAA;EhBq4CR;EgB54CM;;IAEE,qBAAA;EhB84CR;EgB34CM;;IAEE,qBAAA;EhB64CR;EgBp5CM;;IAEE,mBAAA;EhBs5CR;EgBn5CM;;IAEE,mBAAA;EhBq5CR;AACF;Ach9CI;EEUE;IACE,SAAA;EhBy8CN;EgBt8CI;IApCJ,cAAA;IACA,WAAA;EhB6+CA;EgB/9CA;IACE,cAAA;IACA,WAAA;EhBi+CF;EgBn+CA;IACE,cAAA;IACA,UAAA;EhBq+CF;EgBv+CA;IACE,cAAA;IACA,mBAAA;EhBy+CF;EgB3+CA;IACE,cAAA;IACA,UAAA;EhB6+CF;EgB/+CA;IACE,cAAA;IACA,UAAA;EhBi/CF;EgBn/CA;IACE,cAAA;IACA,mBAAA;EhBq/CF;EgBt9CI;IAhDJ,cAAA;IACA,WAAA;EhBygDA;EgBp9CQ;IAhEN,cAAA;IACA,kBAAA;EhBuhDF;EgBx9CQ;IAhEN,cAAA;IACA,mBAAA;EhB2hDF;EgB59CQ;IAhEN,cAAA;IACA,UAAA;EhB+hDF;EgBh+CQ;IAhEN,cAAA;IACA,mBAAA;EhBmiDF;EgBp+CQ;IAhEN,cAAA;IACA,mBAAA;EhBuiDF;EgBx+CQ;IAhEN,cAAA;IACA,UAAA;EhB2iDF;EgB5+CQ;IAhEN,cAAA;IACA,mBAAA;EhB+iDF;EgBh/CQ;IAhEN,cAAA;IACA,mBAAA;EhBmjDF;EgBp/CQ;IAhEN,cAAA;IACA,UAAA;EhBujDF;EgBx/CQ;IAhEN,cAAA;IACA,mBAAA;EhB2jDF;EgB5/CQ;IAhEN,cAAA;IACA,mBAAA;EhB+jDF;EgBhgDQ;IAhEN,cAAA;IACA,WAAA;EhBmkDF;EgB5/CU;IAxDV,cAAA;EhBujDA;EgB//CU;IAxDV,wBAAA;EhB0jDA;EgBlgDU;IAxDV,yBAAA;EhB6jDA;EgBrgDU;IAxDV,gBAAA;EhBgkDA;EgBxgDU;IAxDV,yBAAA;EhBmkDA;EgB3gDU;IAxDV,yBAAA;EhBskDA;EgB9gDU;IAxDV,gBAAA;EhBykDA;EgBjhDU;IAxDV,yBAAA;EhB4kDA;EgBphDU;IAxDV,yBAAA;EhB+kDA;EgBvhDU;IAxDV,gBAAA;EhBklDA;EgB1hDU;IAxDV,yBAAA;EhBqlDA;EgB7hDU;IAxDV,yBAAA;EhBwlDA;EgBrhDM;;IAEE,gBAAA;EhBuhDR;EgBphDM;;IAEE,gBAAA;EhBshDR;EgB7hDM;;IAEE,sBAAA;EhB+hDR;EgB5hDM;;IAEE,sBAAA;EhB8hDR;EgBriDM;;IAEE,qBAAA;EhBuiDR;EgBpiDM;;IAEE,qBAAA;EhBsiDR;EgB7iDM;;IAEE,mBAAA;EhB+iDR;EgB5iDM;;IAEE,mBAAA;EhB8iDR;EgBrjDM;;IAEE,qBAAA;EhBujDR;EgBpjDM;;IAEE,qBAAA;EhBsjDR;EgB7jDM;;IAEE,mBAAA;EhB+jDR;EgB5jDM;;IAEE,mBAAA;EhB8jDR;AACF;AcznDI;EEUE;IACE,SAAA;EhBknDN;EgB/mDI;IApCJ,cAAA;IACA,WAAA;EhBspDA;EgBxoDA;IACE,cAAA;IACA,WAAA;EhB0oDF;EgB5oDA;IACE,cAAA;IACA,UAAA;EhB8oDF;EgBhpDA;IACE,cAAA;IACA,mBAAA;EhBkpDF;EgBppDA;IACE,cAAA;IACA,UAAA;EhBspDF;EgBxpDA;IACE,cAAA;IACA,UAAA;EhB0pDF;EgB5pDA;IACE,cAAA;IACA,mBAAA;EhB8pDF;EgB/nDI;IAhDJ,cAAA;IACA,WAAA;EhBkrDA;EgB7nDQ;IAhEN,cAAA;IACA,kBAAA;EhBgsDF;EgBjoDQ;IAhEN,cAAA;IACA,mBAAA;EhBosDF;EgBroDQ;IAhEN,cAAA;IACA,UAAA;EhBwsDF;EgBzoDQ;IAhEN,cAAA;IACA,mBAAA;EhB4sDF;EgB7oDQ;IAhEN,cAAA;IACA,mBAAA;EhBgtDF;EgBjpDQ;IAhEN,cAAA;IACA,UAAA;EhBotDF;EgBrpDQ;IAhEN,cAAA;IACA,mBAAA;EhBwtDF;EgBzpDQ;IAhEN,cAAA;IACA,mBAAA;EhB4tDF;EgB7pDQ;IAhEN,cAAA;IACA,UAAA;EhBguDF;EgBjqDQ;IAhEN,cAAA;IACA,mBAAA;EhBouDF;EgBrqDQ;IAhEN,cAAA;IACA,mBAAA;EhBwuDF;EgBzqDQ;IAhEN,cAAA;IACA,WAAA;EhB4uDF;EgBrqDU;IAxDV,cAAA;EhBguDA;EgBxqDU;IAxDV,wBAAA;EhBmuDA;EgB3qDU;IAxDV,yBAAA;EhBsuDA;EgB9qDU;IAxDV,gBAAA;EhByuDA;EgBjrDU;IAxDV,yBAAA;EhB4uDA;EgBprDU;IAxDV,yBAAA;EhB+uDA;EgBvrDU;IAxDV,gBAAA;EhBkvDA;EgB1rDU;IAxDV,yBAAA;EhBqvDA;EgB7rDU;IAxDV,yBAAA;EhBwvDA;EgBhsDU;IAxDV,gBAAA;EhB2vDA;EgBnsDU;IAxDV,yBAAA;EhB8vDA;EgBtsDU;IAxDV,yBAAA;EhBiwDA;EgB9rDM;;IAEE,gBAAA;EhBgsDR;EgB7rDM;;IAEE,gBAAA;EhB+rDR;EgBtsDM;;IAEE,sBAAA;EhBwsDR;EgBrsDM;;IAEE,sBAAA;EhBusDR;EgB9sDM;;IAEE,qBAAA;EhBgtDR;EgB7sDM;;IAEE,qBAAA;EhB+sDR;EgBttDM;;IAEE,mBAAA;EhBwtDR;EgBrtDM;;IAEE,mBAAA;EhButDR;EgB9tDM;;IAEE,qBAAA;EhBguDR;EgB7tDM;;IAEE,qBAAA;EhB+tDR;EgBtuDM;;IAEE,mBAAA;EhBwuDR;EgBruDM;;IAEE,mBAAA;EhBuuDR;AACF;AiB71DA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,gCAAA;EACA,yCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjB41DF;AiBr1DE;EACE,sBAAA;EAEA,4BAAA;EAAA,qFAAA;EACA,oCAAA;EACA,wBX+sB0B;EW/sB1B,2CX+sB0B;EW9sB1B,wDAAA;EAAA,2GAAA;AjBs1DJ;AiBn1DE;EACE,uBAAA;AjBq1DJ;AiBl1DE;EACE,sBAAA;AjBo1DJ;;AiBh1DA;EACE,4CAAA;EAAA,+DAAA;AjBm1DF;;AiB50DA;EACE,iBAAA;AjB+0DF;;AiBr0DE;EACE,wBAAA;AjBw0DJ;;AiBzzDE;EACE,mBAAA;EAAA,sCAAA;AjB4zDJ;AiBzzDI;EACE,mBAAA;EAAA,sCAAA;AjB2zDN;;AiBpzDE;EACE,sBAAA;AjBuzDJ;AiBpzDE;EACE,mBAAA;AjBszDJ;;AiB5yDE;EACE,oDAAA;EACA,8CAAA;AjB+yDJ;;AiBzyDE;EACE,oDAAA;EACA,8CAAA;AjB4yDJ;;AiBpyDA;EACE,oDAAA;EACA,8CAAA;AjBuyDF;;AiB/xDE;EACE,mDAAA;EACA,6CAAA;AjBkyDJ;;AkB96DE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB06DJ;;AkB57DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBw7DJ;;AkB18DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBs8DJ;;AkBx9DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBo9DJ;;AkBt+DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBk+DJ;;AkBp/DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBg/DJ;;AkBlgEE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB8/DJ;;AkBhhEE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB4gEJ;;AiB33DI;EACE,gBAAA;EACA,iCAAA;AjB83DN;;Acz9DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBo4DJ;AACF;Ach+DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB04DJ;AACF;Act+DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBg5DJ;AACF;Ac5+DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBs5DJ;AACF;Acl/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB45DJ;AACF;AmBhkEA;EACE,qBbu2BsC;AN2tCxC;;AmBzjEA;EACE,iCAAA;EAAA,oDAAA;EACA,oCAAA;EAAA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;AN29C9B;;AmBtjEA;EACE,+BAAA;EAAA,kDAAA;EACA,kCAAA;EAAA,qDAAA;EhBoQI,iBALI;AH2zDV;;AmBtjEA;EACE,gCAAA;EAAA,mDAAA;EACA,mCAAA;EAAA,sDAAA;EhB8PI,mBALI;AHi0DV;;AoBvlEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,6Bd+1BsC;Ec/1BtC,gCd+1BsC;ANyvCxC;;AqB7lEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,kBALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,cf43BsC;Ee53BtC,2Bf43BsC;Ee33BtC,wBAAA;UAAA,gBAAA;EACA,sBfq3BsC;Eer3BtC,mCfq3BsC;Eep3BtC,4BAAA;EACA,yBAAA;EAAA,2DAAA;EdGE,uBAAA;EAAA,sCAAA;EeHE,wEDMJ;ArB2lEF;AsB7lEM;EDhBN;ICiBQ,gBAAA;EtBgmEN;AACF;AqB9lEE;EACE,gBAAA;ArBgmEJ;AqB9lEI;EACE,eAAA;ArBgmEN;AqB3lEE;EACE,cfs2BoC;Eet2BpC,2Bfs2BoC;Eer2BpC,sBfg2BoC;Eeh2BpC,mCfg2BoC;Ee/1BpC,yCpB0HuB;EoBzHvB,UAAA;EAKE,iDfkhBkB;ANukDxB;AqBrlEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBykEJ;AqBpkEE;EACE,cAAA;EACA,UAAA;ArBskEJ;AqBlkEE;EACE,6Bf40BoC;Ee50BpC,gCf40BoC;Ee10BpC,UAAA;ArBmkEJ;AqB3jEE;EAEE,yBf8yBoC;Ee9yBpC,wCf8yBoC;Ee3yBpC,UAAA;ArB0jEJ;AqBtjEE;EACE,yBAAA;EACA,0BAAA;EACA,2BforB0B;UeprB1B,0BforB0B;EenrB1B,cfsyBoC;EetyBpC,2BfsyBoC;EiBp4BtC,yBjBqiCgC;EiBriChC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfgsB0B;EehsB1B,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,6FD0FF;EC1FE,qFD0FF;ArBwjEJ;AqBpkEE;EACE,yBAAA;EACA,0BAAA;EACA,2BforB0B;UeprB1B,0BforB0B;EenrB1B,cfsyBoC;EetyBpC,2BfsyBoC;EiBp4BtC,yBjBqiCgC;EiBriChC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfgsB0B;EehsB1B,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qFD0FF;ArBwjEJ;AsB9oEM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;EtBipEN;EqBxkEA;ICzEM,gBAAA;EtBipEN;AACF;AqB1jEE;EACE,yBf47B8B;Ee57B9B,wCf47B8B;ANgoClC;AqB7jEE;EACE,yBf47B8B;Ee57B9B,wCf47B8B;ANgoClC;;AqBnjEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,cf2xBsC;Ee3xBtC,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,mBAAA;EAAA,sCAAA;ArBsjEF;AqBpjEE;EACE,UAAA;ArBsjEJ;AqBnjEE;EAEE,gBAAA;EACA,eAAA;ArBojEJ;;AqBziEA;EACE,gDf4wBsC;Ee5wBtC,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,sBAAA;EAAA,yCAAA;APirEJ;AqB1iEE;EACE,uBAAA;EACA,wBAAA;EACA,0BfooB0B;UepoB1B,yBfooB0B;ANw6C9B;AqB/iEE;EACE,uBAAA;EACA,wBAAA;EACA,0BfooB0B;UepoB1B,yBfooB0B;ANw6C9B;;AqBxiEA;EACE,8CfgwBsC;EehwBtC,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,iBALI;EIvQN,qBAAA;EAAA,yCAAA;AP6rEJ;AqBziEE;EACE,oBAAA;EACA,qBAAA;EACA,wBf2nB0B;Ue3nB1B,uBf2nB0B;ANg7C9B;AqB9iEE;EACE,oBAAA;EACA,qBAAA;EACA,wBf2nB0B;Ue3nB1B,uBf2nB0B;ANg7C9B;;AqBniEE;EACE,iDf6uBoC;Ee7uBpC,oEf6uBoC;ANyzCxC;AqBniEE;EACE,gDf0uBoC;Ee1uBpC,mEf0uBoC;AN2zCxC;AqBliEE;EACE,8CfuuBoC;EevuBpC,iEfuuBoC;AN6zCxC;;AqB/hEA;EACE,WfquBsC;EepuBtC,6Cf8tBsC;Ee9tBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;ANi9C9B;AqBhiEE;EACE,eAAA;ArBkiEJ;AqB/hEE;EACE,oBAAA;EdvLA,uBAAA;EAAA,sCAAA;APytEJ;AqB9hEE;EACE,oBAAA;Ed5LA,uBAAA;EAAA,sCAAA;AP6tEJ;AqB7hEE;EAAoB,4Cf8sBkB;Ee9sBlB,+Df8sBkB;ANk1CxC;AqB/hEE;EAAoB,0Cf8sBkB;Ee9sBlB,6Df8sBkB;ANo1CxC;;AwBjvEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,kBALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,clBy3BsC;EkBz3BtC,2BlBy3BsC;EkBx3BtC,wBAAA;UAAA,gBAAA;EACA,sBlBk3BsC;EkBl3BtC,mClBk3BsC;EkBj3BtC,oDAAA;EAAA,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,yBAAA;EAAA,2DAAA;EjBHE,uBAAA;EAAA,sCAAA;EeHE,wEESJ;AxBivEF;AsBtvEM;EEfN;IFgBQ,gBAAA;EtByvEN;AACF;AwBpvEE;EACE,yCvBkIuB;EuBjIvB,UAAA;EAKE,iDlBi+B4B;ANixClC;AwB9uEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxB+uEJ;AwB5uEE;EAEE,yBlBu1BoC;EkBv1BpC,wClBu1BoC;ANs5CxC;AwBxuEE;EACE,kBAAA;EACA,0BAAA;EAAA,uCAAA;AxB0uEJ;;AwBtuEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,sBAAA;EAAA,yCAAA;APoxEJ;;AwBtuEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,iBALI;EIvQN,qBAAA;EAAA,yCAAA;AP4xEJ;;AwBpuEI;EACE,gEAAA;AxBuuEN;;AyB/yEA;EACE,cAAA;EACA,mBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AN64C1C;AyBhzEE;EACE,WAAA;EACA,mBAAA;AzBkzEJ;;AyB9yEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzBizEF;AyB/yEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzBizEJ;;AyB7yEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,wBAAA;UAAA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBnB24BwC;EmB34BxC,2DnB24BwC;EmB14BxC,iCAAA;UAAA,yBAAA;AzB+yEF;AyB5yEE;ElB3BE,qBAAA;AP00EJ;AyB3yEE;EAEE,kBnBm4BsC;ANy6C1C;AyBzyEE;EACE,uBnB03BsC;ANi7C1C;AyBxyEE;EACE,yCxBkGuB;EwBjGvB,UAAA;EACA,iDnB8foB;AN4yDxB;AyBvyEE;EACE,yBxBnBI;EwBoBJ,qBxBpBI;AD6zER;AyBvyEI;EAII,iEAAA;AzBsyER;AyBlyEI;EAII,iEAAA;AzBiyER;AyB5xEE;EACE,yBxBxCI;EwByCJ,qBxBzCI;EwB8CF,iEAAA;AzB0xEN;AyBtxEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;ANs7C3C;AyBjxEI;EACE,eAAA;EACA,YnBy1BqC;AN07C3C;;AyBrwEA;EACE,mBnBo1BgC;ANo7ClC;AyBtwEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBuwEJ;AsBz3EM;EG0GJ;IHzGM,gBAAA;EtB43EN;AACF;AyB1wEI;EACE,4DAAA;AzB4wEN;AyBzwEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBuwER;AyBlwEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzBowEJ;AyBlwEI;EACE,oBAAA;EACA,cAAA;AzBowEN;;AyB/vEA;EACE,qBAAA;EACA,kBnBsyBgC;AN49ClC;;AyB/vEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzBkwEF;AyB9vEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AN0mD9B;;AyBzvEI;EACE,4DAAA;AzB4vEN;;A0B/6EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;UAAA,gBAAA;EACA,6BAAA;A1Bk7EF;A0Bh7EE;EACE,UAAA;A1Bk7EJ;A0B96EI;EAA0B,iEpB8gCa;ANm6C3C;A0Bh7EI;EAA0B,iEpB6gCa;ANs6C3C;A0Bh7EE;EACE,SAAA;A1Bk7EJ;A0B/6EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,wBAAA;UAAA,gBAAA;EH1BF,yBtB2CM;EyBfJ,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1Bg7EJ;AsB/7EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtBk8EN;AACF;A0Bn7EI;EHjCF,0CjB8hCyC;ANy7C3C;A0Bj7EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,yBpBu+B8B;EoBv+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;APi9EJ;A0B/6EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBtB2CM;EyBWJ,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1Bg7EJ;AsBz9EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtB49EN;AACF;A0Bn7EI;EH3DF,0CjB8hCyC;ANm9C3C;A0Bj7EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,yBpB68B8B;EoB78B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;AP2+EJ;A0B/6EE;EACE,oBAAA;A1Bi7EJ;A0B/6EI;EACE,wCpBg9BqC;EoBh9BrC,2CpBg9BqC;ANi+C3C;A0B96EI;EACE,wCpB48BqC;EoB58BrC,2CpB48BqC;ANo+C3C;;A2BvgFA;EACE,kBAAA;A3B0gFF;A2BxgFE;;;EAGE,oCrBwiCoC;EqBxiCpC,uDrBwiCoC;EqBviCpC,wCrBuiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;ANm+CxC;A2BvgFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EAAA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EAAA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3BygFJ;AsBhhFM;EKTJ;ILUM,gBAAA;EtBmhFN;AACF;A2B3gFE;;EAEE,qBAAA;A3B6gFJ;A2B3gFI;;EACE,kBAAA;A3B8gFN;A2B3gFI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;ANogDxC;A2B3gFI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ANygDxC;A2B1gFE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;AN4yD9B;A2BrgFI;;;;EACE,8DrBy/BkC;ANihDxC;A2BrgFI;EACE,8DrBm/BkC;ANohDxC;A2BlgFI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,sBrBqzBkC;EqBrzBlC,mCrBqzBkC;ECh3BpC,uBAAA;EAAA,sCAAA;APikFJ;A2BlgFE;EACE,yBrBkzBoC;EqBlzBpC,wCrBkzBoC;ANktDxC;A2BhgFI;EACE,mBAAA;EAAA,sCAAA;A3BkgFN;A2B9/EE;;EAEE,c1BvEO;ADukFX;;A4B1lFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5B6lFF;A4B3lFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5B6lFJ;A4BzlFE;;;EAGE,UAAA;A5B2lFJ;A4BrlFE;EACE,kBAAA;EACA,UAAA;A5BulFJ;A4BrlFI;EACE,UAAA;A5BulFN;;A4B5kFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,kBALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,ctBm1BsC;EsBn1BtC,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,0C3ByEqB;E2BxErB,yBAAA;EAAA,2DAAA;ErBtCE,uBAAA;EAAA,sCAAA;APsnFJ;;A4BtkFA;;;;EAIE,oBAAA;EzBwNI,iBALI;EIvQN,qBAAA;EAAA,yCAAA;AP+nFJ;;A4BtkFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,sBAAA;EAAA,yCAAA;APwoFJ;;A4BtkFA;;EAEE,mBAAA;A5BykFF;;A4B5jFI;;;;ErBjEA,0BAAA;EACA,6BAAA;APooFJ;A4B3jFI;;;;ErB1EA,0BAAA;EACA,6BAAA;AP2oFJ;A4BrjFE;EACE,2BAAA;EAAA,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;APkoFJ;A4BrjFE;;ErB9EE,yBAAA;EACA,4BAAA;APuoFJ;;A6B/pFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,cvBkjCqB;EuBljCrB,iCvBkjCqB;AN+mDzB;;A6B9pFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,yBvBoiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,uBAAA;EAAA,sCAAA;AP4rFJ;;A6B5pFI;;;;EAEE,cAAA;A7BiqFN;;A6BhtFI;EAqDE,qBvBuhCmB;EuBvhCnB,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7B6pFR;A6B1pFM;EACE,qBvB4gCiB;EuB5gCjB,+CvB4gCiB;EuBvgCf,kDvBugCe;EuBvgCf,2DvBugCe;ANipDzB;;A6B7tFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7BkpFR;;A6BluFI;EAuFE,qBvBq/BmB;EuBr/BnB,+CvBq/BmB;AN0pDzB;A6B5oFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7B6oFV;A6BzoFM;EACE,qBvBw+BiB;EuBx+BjB,+CvBw+BiB;EuBn+Bf,kDvBm+Be;EuBn+Bf,2DvBm+Be;ANoqDzB;;A6BhvFI;EAkHI,yCAAA;A7BkoFR;;A6BpvFI;EAyHE,qBvBm9BmB;EuBn9BnB,+CvBm9BmB;AN4qDzB;A6B7nFM;EACE,yBvBg9BiB;EuBh9BjB,4CvBg9BiB;AN+qDzB;A6B5nFM;EACE,kDvB48BiB;EuB58BjB,2DvB48BiB;ANkrDzB;A6B3nFM;EACE,cvBw8BiB;EuBx8BjB,iCvBw8BiB;ANqrDzB;;A6BxnFI;EACE,kBAAA;A7B2nFN;;A6BrwFI;;;;;EAoJM,UAAA;A7BynFV;;A6BzvFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,cvBkjCqB;EuBljCrB,mCvBkjCqB;ANysDzB;;A6BxvFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,yBvBoiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,uBAAA;EAAA,sCAAA;APsxFJ;;A6BtvFI;;;;EAEE,cAAA;A7B2vFN;;A6B1yFI;EAqDE,qBvBuhCmB;EuBvhCnB,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BuvFR;A6BpvFM;EACE,qBvB4gCiB;EuB5gCjB,iDvB4gCiB;EuBvgCf,iDvBugCe;EuBvgCf,0DvBugCe;AN2uDzB;;A6BvzFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7B4uFR;;A6B5zFI;EAuFE,qBvBq/BmB;EuBr/BnB,iDvBq/BmB;ANovDzB;A6BtuFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BuuFV;A6BnuFM;EACE,qBvBw+BiB;EuBx+BjB,iDvBw+BiB;EuBn+Bf,iDvBm+Be;EuBn+Bf,0DvBm+Be;AN8vDzB;;A6B10FI;EAkHI,yCAAA;A7B4tFR;;A6B90FI;EAyHE,qBvBm9BmB;EuBn9BnB,iDvBm9BmB;ANswDzB;A6BvtFM;EACE,yBvBg9BiB;EuBh9BjB,8CvBg9BiB;ANywDzB;A6BttFM;EACE,iDvB48BiB;EuB58BjB,0DvB48BiB;AN4wDzB;A6BrtFM;EACE,cvBw8BiB;EuBx8BjB,mCvBw8BiB;AN+wDzB;;A6BltFI;EACE,kBAAA;A7BqtFN;;A6B/1FI;;;;;EAsJM,UAAA;A7BitFV;;A8Bz2FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,2BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,2EAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qFQwBJ;A9Bu2FF;AsB33FM;EQhBN;IRiBQ,gBAAA;EtB83FN;AACF;A8B12FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9B22FJ;A8Bx2FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9By2FJ;A8Bt2FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Bo2FN;A8Bh2FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B81FN;A8B11FE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9Bs1FJ;A8Bn1FI;EAKI,0CAAA;A9Bi1FR;A8B50FE;EAKI,0CAAA;A9B00FN;A8Bt0FE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9Bq0FJ;;A8BzzFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B46FF;;A8B10FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B67FF;;A8B31FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B88FF;;A8B52FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B+9FF;;A8B73FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bg/FF;;A8B94FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BigGF;;A8B/5FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BkhGF;;A8Bh7FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BmiGF;;A8Bj8FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BojGF;;A8Bl9FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BqkGF;;A8Bz8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6jGF;;A8B19FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B8kGF;;A8B3+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B+lGF;;A8B5/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BgnGF;;A8B7gGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BioGF;;A8B9hGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BkpGF;;A8B/iGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BmqGF;;A8BhkGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BorGF;;A8BjlGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BqsGF;;A8BlmGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BstGF;;A8BvmGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,wCAAA;EAEA,0BxB8QwC;AN21F1C;A8B/lGE;EACE,0BAAA;A9BimGJ;A8B9lGE;EACE,gCAAA;A9BgmGJ;;A8BrlGA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,0BALI;E4BvNR,kDAAA;A/B0uGF;;A8BxlGA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/BivGF;;AgCpzGA;EVgBM,gCUfJ;AhCuzGF;AsBpyGM;EUpBN;IVqBQ,gBAAA;EtBuyGN;AACF;AgC1zGE;EACE,UAAA;AhC4zGJ;;AgCtzGE;EACE,aAAA;AhCyzGJ;;AgCrzGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhCwzGF;AsBtzGM;EULN;IVMQ,gBAAA;EtByzGN;AACF;AgC3zGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhC6zGJ;AsBh0GM;EUAJ;IVCM,gBAAA;EtBm0GN;AACF;;AiCx1GA;;;;;;EAME,kBAAA;AjC21GF;;AiCx1GA;EACE,mBAAA;AjC21GF;AkCn0GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlC22GF;AkCjzGI;EACE,cAAA;AlCmzGN;;AiCj2GA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;EACA,8BAAA;E9BuQI,gCALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,oCAAA;EACA,mCAAA;EACA,oCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AP24GJ;AiC91GE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCg2GJ;;AiCx0GI;EACE,oBAAA;AjC20GN;AiCz0GM;EACE,WAAA;EACA,OAAA;AjC20GR;;AiCv0GI;EACE,kBAAA;AjC00GN;AiCx0GM;EACE,QAAA;EACA,UAAA;AjC00GR;;Acp3GI;EmB4BA;IACE,oBAAA;EjC41GJ;EiC11GI;IACE,WAAA;IACA,OAAA;EjC41GN;EiCx1GE;IACE,kBAAA;EjC01GJ;EiCx1GI;IACE,QAAA;IACA,UAAA;EjC01GN;AACF;Acr4GI;EmB4BA;IACE,oBAAA;EjC42GJ;EiC12GI;IACE,WAAA;IACA,OAAA;EjC42GN;EiCx2GE;IACE,kBAAA;EjC02GJ;EiCx2GI;IACE,QAAA;IACA,UAAA;EjC02GN;AACF;Acr5GI;EmB4BA;IACE,oBAAA;EjC43GJ;EiC13GI;IACE,WAAA;IACA,OAAA;EjC43GN;EiCx3GE;IACE,kBAAA;EjC03GJ;EiCx3GI;IACE,QAAA;IACA,UAAA;EjC03GN;AACF;Acr6GI;EmB4BA;IACE,oBAAA;EjC44GJ;EiC14GI;IACE,WAAA;IACA,OAAA;EjC44GN;EiCx4GE;IACE,kBAAA;EjC04GJ;EiCx4GI;IACE,QAAA;IACA,UAAA;EjC04GN;AACF;Acr7GI;EmB4BA;IACE,oBAAA;EjC45GJ;EiC15GI;IACE,WAAA;IACA,OAAA;EjC45GN;EiCx5GE;IACE,kBAAA;EjC05GJ;EiCx5GI;IACE,QAAA;IACA,UAAA;EjC05GN;AACF;AiCj5GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjCm5GJ;AkCv+GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlCwgHF;AkCr9GI;EACE,cAAA;AlCu9GN;;AiCv5GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjC05GJ;AkC5/GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlCshHF;AkC1+GI;EACE,cAAA;AlC4+GN;AiCl6GI;EACE,iBAAA;AjCo6GN;;AiC95GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjCi6GJ;AkCphHI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlCshHN;AkC3gHM;EACE,aAAA;AlC6gHR;AkC1gHM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCgjHF;AkC1gHI;EACE,cAAA;AlC4gHN;AiCj7GI;EACE,iBAAA;AjCm7GN;;AiC56GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjC+6GF;;AiCz6GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,gBAAA;EAAA,uDAAA;APmlHJ;AiC16GE;EAEE,0CAAA;EV1LF,kDU4LuB;AjC06GzB;AiCv6GE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjCw6GzB;AiCr6GE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjCs6GJ;;AiCh6GA;EACE,cAAA;AjCm6GF;;AiC/5GA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjCk6GF;;AiC95GA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjCi6GF;;AiC75GA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjC+5GF;;AmCrpHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCwpHF;AmCtpHE;;EACE,kBAAA;EACA,cAAA;AnCypHJ;AmCppHE;;;;;;;;;;;;EAME,UAAA;AnC4pHJ;;AmCvpHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnC0pHF;AmCxpHE;EACE,WAAA;AnC0pHJ;;AmCtpHA;E5BhBI,uBAAA;EAAA,sCAAA;AP0qHJ;AmCtpHE;;EAEE,2BAAA;EAAA,8CAAA;AnCwpHJ;AmCppHE;;;E5BVE,0BAAA;EACA,6BAAA;APmqHJ;AmChpHE;;;E5BNE,yBAAA;EACA,4BAAA;AP2pHJ;;AmCnoHA;EACE,wBAAA;EACA,uBAAA;AnCsoHF;AmCpoHE;EAGE,cAAA;AnCooHJ;AmCjoHE;EACE,eAAA;AnCmoHJ;;AmC/nHA;EACE,uBAAA;EACA,sBAAA;AnCkoHF;;AmC/nHA;EACE,sBAAA;EACA,qBAAA;AnCkoHF;;AmC9mHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCinHF;AmC/mHE;;EAEE,WAAA;AnCinHJ;AmC9mHE;;EAEE,0BAAA;EAAA,6CAAA;AnCgnHJ;AmC5mHE;;E5B1FE,6BAAA;EACA,4BAAA;AP0sHJ;AmCxmHE;;;E5BjHE,yBAAA;EACA,0BAAA;AP8tHJ;;AoCtvHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCqvHF;;AoClvHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApCqvHF;AsBjwHM;EcGN;IdFQ,gBAAA;EtBowHN;AACF;AoCxvHE;EAEE,qCAAA;ApCyvHJ;AoCrvHE;EACE,UAAA;EACA,iD9BkhBoB;ANquGxB;AoCnvHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApCovHJ;;AoC5uHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApC4uHF;AoC1uHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AP0xHJ;AoC3uHI;EAGE,kBAAA;EACA,wDAAA;ApC2uHN;AoCvuHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCyuHJ;AoCtuHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;APyyHJ;;AoC9tHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCguHF;AoC7tHE;E7B5FE,gDAAA;AP4zHJ;AoC5tHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApC8tHzB;;AoCrtHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApCqtHF;AoCntHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApCqtHJ;AoCntHI;EAEE,iCAAA;ApCotHN;AoChtHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApCktHJ;;AoCxsHE;;EAEE,cAAA;EACA,kBAAA;ApC2sHJ;;AoCtsHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApCysHJ;;AoCnsHE;;EACE,WAAA;ApCusHJ;;AoC7rHE;EACE,aAAA;ApCgsHJ;AoC9rHE;EACE,cAAA;ApCgsHJ;;AqC73HA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,qCAAA;EACA,kCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,kCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArC63HF;AqCv3HE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArC+3HJ;AqC32HA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArC62HF;AqC32HE;EAEE,yCAAA;ArC42HJ;;AqCl2HA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCi2HF;AqC91HI;EAEE,oCAAA;ArC+1HN;AqC31HE;EACE,gBAAA;ArC61HJ;;AqCp1HA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArCu1HF;AqCr1HE;;;EAGE,oCAAA;ArCu1HJ;;AqC10HA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArC20HF;;AqCv0HA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,uDAAA;EAAA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArC00HF;AsBn9HM;EeiIN;IfhIQ,gBAAA;EtBs9HN;AACF;AqC70HE;EACE,qBAAA;ArC+0HJ;AqC50HE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArC80HJ;;AqCx0HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArC20HF;;AqCx0HA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;ArC20HF;;Acr8HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCk0HN;EqCh0HM;IACE,mBAAA;ErCk0HR;EqCh0HQ;IACE,kBAAA;ErCk0HV;EqC/zHQ;IACE,kDAAA;IACA,iDAAA;ErCi0HV;EqC7zHM;IACE,iBAAA;ErC+zHR;EqC5zHM;IACE,wBAAA;IACA,gBAAA;ErC8zHR;EqC3zHM;IACE,aAAA;ErC6zHR;EqC1zHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC0zHR;EqCvzHQ;IACE,aAAA;ErCyzHV;EqCtzHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCwzHV;AACF;Acr/HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCi3HN;EqC/2HM;IACE,mBAAA;ErCi3HR;EqC/2HQ;IACE,kBAAA;ErCi3HV;EqC92HQ;IACE,kDAAA;IACA,iDAAA;ErCg3HV;EqC52HM;IACE,iBAAA;ErC82HR;EqC32HM;IACE,wBAAA;IACA,gBAAA;ErC62HR;EqC12HM;IACE,aAAA;ErC42HR;EqCz2HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCy2HR;EqCt2HQ;IACE,aAAA;ErCw2HV;EqCr2HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCu2HV;AACF;AcpiII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCg6HN;EqC95HM;IACE,mBAAA;ErCg6HR;EqC95HQ;IACE,kBAAA;ErCg6HV;EqC75HQ;IACE,kDAAA;IACA,iDAAA;ErC+5HV;EqC35HM;IACE,iBAAA;ErC65HR;EqC15HM;IACE,wBAAA;IACA,gBAAA;ErC45HR;EqCz5HM;IACE,aAAA;ErC25HR;EqCx5HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCw5HR;EqCr5HQ;IACE,aAAA;ErCu5HV;EqCp5HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCs5HV;AACF;AcnlII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC+8HN;EqC78HM;IACE,mBAAA;ErC+8HR;EqC78HQ;IACE,kBAAA;ErC+8HV;EqC58HQ;IACE,kDAAA;IACA,iDAAA;ErC88HV;EqC18HM;IACE,iBAAA;ErC48HR;EqCz8HM;IACE,wBAAA;IACA,gBAAA;ErC28HR;EqCx8HM;IACE,aAAA;ErC08HR;EqCv8HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCu8HR;EqCp8HQ;IACE,aAAA;ErCs8HV;EqCn8HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCq8HV;AACF;AcloII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC8/HN;EqC5/HM;IACE,mBAAA;ErC8/HR;EqC5/HQ;IACE,kBAAA;ErC8/HV;EqC3/HQ;IACE,kDAAA;IACA,iDAAA;ErC6/HV;EqCz/HM;IACE,iBAAA;ErC2/HR;EqCx/HM;IACE,wBAAA;IACA,gBAAA;ErC0/HR;EqCv/HM;IACE,aAAA;ErCy/HR;EqCt/HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCs/HR;EqCn/HQ;IACE,aAAA;ErCq/HV;EqCl/HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCo/HV;AACF;AqC3iII;EAEI,iBAAA;EACA,2BAAA;ArC4iIR;AqC1iIQ;EACE,mBAAA;ArC4iIV;AqC1iIU;EACE,kBAAA;ArC4iIZ;AqCziIU;EACE,kDAAA;EACA,iDAAA;ArC2iIZ;AqCviIQ;EACE,iBAAA;ArCyiIV;AqCtiIQ;EACE,wBAAA;EACA,gBAAA;ArCwiIV;AqCriIQ;EACE,aAAA;ArCuiIV;AqCpiIQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArCoiIV;AqCjiIU;EACE,aAAA;ArCmiIZ;AqChiIU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCkiIZ;;AqCjhIA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArCmhIF;;AqC7gII;EACE,qEAAA;ArCghIN;;AsCzyIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,gDAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EAAA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AP2zIJ;AsCtyIE;EACE,eAAA;EACA,cAAA;AtCwyIJ;AsCryIE;EACE,mBAAA;EACA,sBAAA;AtCuyIJ;AsCryII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AP8zIJ;AsCryII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;APqzIJ;AsClyIE;;EAEE,aAAA;AtCoyIJ;;AsChyIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCiyIF;;AsC9xIA;EACE,4CAAA;EACA,iCAAA;AtCiyIF;;AsC9xIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCiyIF;;AsC9xIA;EACE,gBAAA;AtCiyIF;;AsCzxIE;EACE,oCAAA;AtC4xIJ;;AsCpxIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtCuxIF;AsCrxIE;E/B7FE,wFAAA;APq3IJ;;AsCnxIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtCsxIF;AsCpxIE;E/BxGE,wFAAA;AP+3IJ;;AsC7wIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCgxIF;AsC9wIE;EACE,mCAAA;EACA,sCAAA;AtCgxIJ;;AsC5wIA;EACE,uDAAA;EACA,sDAAA;AtC+wIF;;AsC3wIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;APy5IJ;;AsC3wIA;;;EAGE,WAAA;AtC8wIF;;AsC3wIA;;E/B3II,0DAAA;EACA,2DAAA;AP25IJ;;AsC5wIA;;E/BlII,8DAAA;EACA,6DAAA;APm5IJ;;AsCrwIE;EACE,0CAAA;AtCwwIJ;Acn4II;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtCwwIF;EsCrwIE;IACE,SAAA;IACA,gBAAA;EtCuwIJ;EsCrwII;IACE,cAAA;IACA,cAAA;EtCuwIN;EsClwIM;I/B1KJ,0BAAA;IACA,6BAAA;EP+6IF;EsCnwIQ;;IAGE,0BAAA;EtCowIV;EsClwIQ;;IAGE,6BAAA;EtCmwIV;EsC/vIM;I/B3KJ,yBAAA;IACA,4BAAA;EP66IF;EsChwIQ;;IAGE,yBAAA;EtCiwIV;EsC/vIQ;;IAGE,4BAAA;EtCgwIV;AACF;;AuCp+IA;EAEE,0CAAA;EACA,oCAAA;EACA,8HAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,yCAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvCs+IF;;AuCl+IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,kBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvCq+IF;AsB5/IM;EiBUN;IjBTQ,gBAAA;EtB+/IN;AACF;AuCx+IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvC0+IJ;AuCx+II;EACE,qDAAA;EACA,iDAAA;AvC0+IN;AuCr+IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvCu+IJ;AsBrhJM;EiBqCJ;IjBpCM,gBAAA;EtBwhJN;AACF;AuCz+IE;EACE,UAAA;AvC2+IJ;AuCx+IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvC0+IJ;;AuCt+IA;EACE,gBAAA;AvCy+IF;;AuCt+IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCy+IF;AuCv+IE;EhC7DE,yDAAA;EACA,0DAAA;APuiJJ;AuCx+II;EhChEA,+DAAA;EACA,gEAAA;AP2iJJ;AuCv+IE;EACE,aAAA;AvCy+IJ;AuCr+IE;EhC5DE,6DAAA;EACA,4DAAA;APoiJJ;AuCr+IM;EhChEF,mEAAA;EACA,kEAAA;APwiJJ;AuCp+II;EhCrEA,6DAAA;EACA,4DAAA;AP4iJJ;;AuCl+IA;EACE,8EAAA;AvCq+IF;;AuC59IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AP8kJJ;AuC79II;EAAgB,aAAA;AvCg+IpB;AuC/9II;EAAe,gBAAA;AvCk+InB;AuC/9II;;;EhCrHA,gBAAA;APylJJ;;AuCz9II;EACE,iEAAA;EACA,wEAAA;AvC49IN;;AwCjnJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;APinJJ;;AwC3mJE;EACE,iDAAA;AxC8mJJ;AwC5mJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,yDAAA;EAAA,uFAAA;AxC8mJN;AwC1mJE;EACE,6CAAA;AxC4mJJ;;AyCjpJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,kCALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;ATsqJF;;AyC/oJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzCkpJF;AsBnqJM;EmBQN;InBPQ,gBAAA;EtBsqJN;AACF;AyCrpJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzCspJJ;AyCnpJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzCqpJJ;AyClpJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzCmpJJ;AyChpJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzCipJJ;;AyC5oJE;EACE,2BnC8sCgC;EmC9sChC,8CnC8sCgC;ANi8GpC;AyC1oJM;ElC9BF,0DAAA;EACA,6DAAA;AP2qJJ;AyCxoJM;ElClDF,2DAAA;EACA,8DAAA;AP6rJJ;;AyC3nJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,iCALI;EuCnRR,yDAAA;A1CiuJF;;AyC9nJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1CwuJF;;A2C1uJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AP+uJJ;A2CtuJE;EACE,aAAA;A3CwuJJ;;A2CnuJA;EACE,kBAAA;EACA,SAAA;A3CsuJF;;A4CtwJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AP0wJJ;;A4ClwJA;EAEE,cAAA;A5CowJF;;A4ChwJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5CmwJF;;A4C3vJA;EACE,mBtCs+C8B;ANwxGhC;A4C3vJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5C6vJJ;;A4CrvJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CwvJJ;;A4C5vJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5C+vJJ;;A4CnwJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CswJJ;;A4C1wJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5C6wJJ;;A4CjxJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CoxJJ;;A4CxxJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5C2xJJ;;A4C/xJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5CkyJJ;;A4CtyJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CyyJJ;;A4C7yJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5CgzJJ;;A4CpzJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CuzJJ;;A6Cn3JE;EACE;IAAK,gDAAA;E7Cu3JP;AACF;A6Cn3JA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AP23JJ;;A6C92JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7Ci3JF;AsBt4JM;EuBYN;IvBXQ,gBAAA;EtBy4JN;AACF;;A6Cn3JA;EtBAE,qMAAA;EsBEA,oEAAA;A7Cs3JF;;A6Cn3JA;EACE,iBAAA;A7Cs3JF;;A6Cn3JA;EACE,WAAA;A7Cs3JF;;A6Cl3JE;EACE,kDAAA;A7Cq3JJ;A6Cl3JM;EAJJ;IAKM,eAAA;E7Cq3JN;AACF;;A8Cj7JA;EAEE,2CAAA;EACA,qCAAA;EACA,qDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AP27JJ;;A8C56JA;EACE,qBAAA;EACA,sBAAA;A9C+6JF;A8C76JE;EAEE,oCAAA;EACA,0BAAA;A9C86JJ;;A8Ct6JA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9Cy6JF;A8Cv6JE;EvC9BE,+BAAA;EACA,gCAAA;APw8JJ;A8Cv6JE;EvCpBE,mCAAA;EACA,kCAAA;AP87JJ;A8Cv6JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9Cw6JJ;A8Cp6JE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9Cs6JJ;A8Cl6JE;EACE,mBAAA;A9Co6JJ;A8Cl6JI;EACE,wDAAA;EACA,mDAAA;A9Co6JN;;A8C15JA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9C65JF;A8Cz5JI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9C05JN;A8Cv5JI;EACE,+CAAA;EACA,uDAAA;A9Cy5JN;;A8C54JI;EACE,mBAAA;A9C+4JN;A8C54JQ;EvCzDJ,6DAAA;EAZA,0BAAA;APq9JJ;A8C34JQ;EvC1EJ,2DAAA;EAYA,4BAAA;AP68JJ;A8C14JQ;EACE,aAAA;A9C44JV;A8Cz4JQ;EACE,mDAAA;EACA,oBAAA;A9C24JV;A8Cz4JU;EACE,yDAAA;EACA,oDAAA;A9C24JZ;;Acn+JI;EgCgEA;IACE,mBAAA;E9Cu6JJ;E8Cp6JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP6+JF;E8Cn6JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPq+JF;E8Cl6JM;IACE,aAAA;E9Co6JR;E8Cj6JM;IACE,mDAAA;IACA,oBAAA;E9Cm6JR;E8Cj6JQ;IACE,yDAAA;IACA,oDAAA;E9Cm6JV;AACF;Ac5/JI;EgCgEA;IACE,mBAAA;E9C+7JJ;E8C57JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPqgKF;E8C37JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP6/JF;E8C17JM;IACE,aAAA;E9C47JR;E8Cz7JM;IACE,mDAAA;IACA,oBAAA;E9C27JR;E8Cz7JQ;IACE,yDAAA;IACA,oDAAA;E9C27JV;AACF;AcphKI;EgCgEA;IACE,mBAAA;E9Cu9JJ;E8Cp9JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP6hKF;E8Cn9JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPqhKF;E8Cl9JM;IACE,aAAA;E9Co9JR;E8Cj9JM;IACE,mDAAA;IACA,oBAAA;E9Cm9JR;E8Cj9JQ;IACE,yDAAA;IACA,oDAAA;E9Cm9JV;AACF;Ac5iKI;EgCgEA;IACE,mBAAA;E9C++JJ;E8C5+JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPqjKF;E8C3+JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP6iKF;E8C1+JM;IACE,aAAA;E9C4+JR;E8Cz+JM;IACE,mDAAA;IACA,oBAAA;E9C2+JR;E8Cz+JQ;IACE,yDAAA;IACA,oDAAA;E9C2+JV;AACF;AcpkKI;EgCgEA;IACE,mBAAA;E9CugKJ;E8CpgKM;IvCzDJ,6DAAA;IAZA,0BAAA;EP6kKF;E8CngKM;IvC1EJ,2DAAA;IAYA,4BAAA;EPqkKF;E8ClgKM;IACE,aAAA;E9CogKR;E8CjgKM;IACE,mDAAA;IACA,oBAAA;E9CmgKR;E8CjgKQ;IACE,yDAAA;IACA,oDAAA;E9CmgKV;AACF;A8Ct/JA;EvClJI,gBAAA;AP2oKJ;A8Ct/JE;EACE,mDAAA;A9Cw/JJ;A8Ct/JI;EACE,sBAAA;A9Cw/JN;;A8C3+JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C8+JJ;;A8Cx/JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9C2/JJ;;A8CrgKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9CwgKJ;;A8ClhKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9CqhKJ;;A8C/hKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9CkiKJ;;A8C5iKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9C+iKJ;;A8CzjKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9C4jKJ;;A8CtkKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9CykKJ;;A8CnlKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9CslKJ;;A8ChmKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9CmmKJ;;A+CjyKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,kEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EAAA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/CiyKF;A+C9xKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/CgyKJ;A+C7xKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C+xKJ;A+C5xKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C6xKJ;;A+CrxKA;EAHE,iEAAA;A/C4xKF;;A+CrxKA;;EAEE,uBAAA;A/CwxKF;;AIn0KI;E2CkCF,iEAAA;A/CqyKF;;AgDt1KA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AP+1KJ;AgDp1KE;EACE,UAAA;AhDs1KJ;AgDn1KE;EACE,aAAA;AhDq1KJ;;AgDj1KA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AhDm1KF;AgDj1KE;EACE,sCAAA;AhDm1KJ;;AgD/0KA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;APm3KJ;AgDj1KE;EACE,oDAAA;EACA,sCAAA;AhDm1KJ;;AgD/0KA;EACE,kCAAA;EACA,qBAAA;AhDk1KF;;AiDh5KA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjD84KF;;AiDv4KA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDy4KF;AiDt4KE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjDw4KJ;AsBl7KM;E2BwCJ;I3BvCM,gBAAA;EtBq7KN;AACF;AiD34KE;EACE,e3Cg8CgC;AN68HpC;AiDz4KE;EACE,sB3C67CgC;AN88HpC;;AiDv4KA;EACE,+CAAA;AjD04KF;AiDx4KE;EACE,gBAAA;EACA,gBAAA;AjD04KJ;AiDv4KE;EACE,gBAAA;AjDy4KJ;;AiDr4KA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDw4KF;;AiDp4KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjDo4KF;;AiDh4KA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjDs4K9D;AkDl/KE;EAAS,UAAA;AlDq/KX;AkDp/KE;EAAS,mCD2GiF;AjD44K5F;;AiDv4KA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;APg/KJ;AiDz4KE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjD04KJ;;AiDr4KA;EACE,gBAAA;EACA,8CAAA;AjDw4KF;;AiDn4KA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjDo4KF;;AiDh4KA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;APigLJ;AiD/3KE;EACE,8CAAA;AjDi4KJ;;Ach/KI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjD+3KF;EiD33KA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjD63KF;EiD13KA;IACE,uBAAA;EjD43KF;AACF;Ac//KI;EmCuIF;;IAEE,uBAAA;EjD23KF;AACF;AcrgLI;EmC8IF;IACE,wBAAA;EjD03KF;AACF;AiDj3KI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDm3KN;AiDj3KM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;APikLJ;AiDh3KM;;E1CjNF,gBAAA;APqkLJ;AiD/2KM;EACE,gBAAA;AjDi3KR;;Ac/gLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDu4KJ;EiDr4KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPqlLF;EiDp4KI;;I1CjNF,gBAAA;EPylLF;EiDn4KI;IACE,gBAAA;EjDq4KN;AACF;AcpiLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD25KJ;EiDz5KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPymLF;EiDx5KI;;I1CjNF,gBAAA;EP6mLF;EiDv5KI;IACE,gBAAA;EjDy5KN;AACF;AcxjLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD+6KJ;EiD76KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP6nLF;EiD56KI;;I1CjNF,gBAAA;EPioLF;EiD36KI;IACE,gBAAA;EjD66KN;AACF;Ac5kLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDm8KJ;EiDj8KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPipLF;EiDh8KI;;I1CjNF,gBAAA;EPqpLF;EiD/7KI;IACE,gBAAA;EjDi8KN;AACF;AchmLI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDu9KJ;EiDr9KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPqqLF;EiDp9KI;;I1CjNF,gBAAA;EPyqLF;EiDn9KI;IACE,gBAAA;EjDq9KN;AACF;AmD/rLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,4M9C+lB4B;E8C/lB5B,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnDusLF;AmDrsLE;EAAS,kCAAA;AnDwsLX;AmDtsLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnDwsLJ;AmDtsLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDwsLN;;AmDnsLA;EACE,iDAAA;AnDssLF;AmDpsLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnDssLJ;;AmDlsLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnDqsLF;AmDnsLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnDqsLJ;;AmDjsLA,mBAAA;AAEA;EACE,8CAAA;AnDmsLF;AmDjsLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDmsLJ;;AmD/rLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDksLF;AmDhsLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDksLJ;;AmD9rLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APkxLJ;;AqDryLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,mDAAA;EACA,sDAAA;EACA,2FAAA;EACA,mNAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,sCALI;EkD5QR,kCAAA;EACA,4BAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,4M9C+lB4B;E8C/lB5B,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APg0LJ;AqD5yLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD8yLJ;AqD5yLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArD6yLN;;AqDvyLE;EACE,oFAAA;ArD0yLJ;AqDxyLI;EAEE,wFAAA;ArDyyLN;AqDtyLI;EACE,SAAA;EACA,gDAAA;ArDwyLN;AqDryLI;EACE,sCAAA;EACA,sCAAA;ArDuyLN;;AqDlyLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDoyLJ;AqDlyLI;EAEE,kIAAA;ArDmyLN;AqDhyLI;EACE,OAAA;EACA,kDAAA;ArDkyLN;AqD/xLI;EACE,oCAAA;EACA,wCAAA;ArDiyLN;;AqD5xLA,mBAAA;AAGE;EACE,iFAAA;ArD6xLJ;AqD3xLI;EAEE,wFAAA;ArD4xLN;AqDzxLI;EACE,MAAA;EACA,mDAAA;ArD2xLN;AqDxxLI;EACE,mCAAA;EACA,yCAAA;ArD0xLN;AqDrxLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArDuxLJ;;AqDnxLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArDqxLJ;AqDnxLI;EAEE,kIAAA;ArDoxLN;AqDjxLI;EACE,QAAA;EACA,iDAAA;ArDmxLN;AqDhxLI;EACE,qCAAA;EACA,uCAAA;ArDkxLN;;AqD7wLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AP45LJ;AqD9vLE;EACE,aAAA;ArDgwLJ;;AqD5vLA;EACE,0EAAA;EACA,mCAAA;ArD+vLF;;AsDp7LA;EACE,kBAAA;AtDu7LF;;AsDp7LA;EACE,mBAAA;AtDu7LF;;AsDp7LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDu7LF;AuD78LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD+8LJ;;AsDx7LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EhClBI,sCgCmBJ;AtD27LF;AsB18LM;EgCQN;IhCPQ,gBAAA;EtB68LN;AACF;;AsD77LA;;;EAGE,cAAA;AtDg8LF;;AsD77LA;;EAEE,2BAAA;AtDg8LF;;AsD77LA;;EAEE,4BAAA;AtDg8LF;;AsDv7LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtD07LJ;AsDv7LE;;;EAGE,UAAA;EACA,UAAA;AtDy7LJ;AsDt7LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtDw7LJ;AsBj/LM;EgCqDJ;;IhCpDM,gBAAA;EtBq/LN;AACF;;AsDr7LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WrDjFM;EqDkFN,kBAAA;EACA,gBAAA;EACA,SAAA;EAAA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtDu7LF;AsB3gMM;EgCkEN;;IhCjEQ,gBAAA;EtB+gMN;AACF;AsD17LE;;;EAEE,WrD5FI;EqD6FJ,qBAAA;EACA,UAAA;EACA,YhDogDiC;ANy7IrC;;AsD17LA;EACE,OAAA;AtD67LF;;AsD17LA;EACE,QAAA;AtD67LF;;AsDx7LA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtD27LF;;AsDx7LA;EACE,0TAAA;AtD27LF;;AsDz7LA;EACE,yTAAA;AtD47LF;;AsDp7LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;ANm+IrC;AsDp7LE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,sBAAA;EAAA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtDq7LJ;AsBnlMM;EgC6IJ;IhC5IM,gBAAA;EtBslMN;AACF;AsDv7LE;EACE,UhDw8CiC;ANi/IrC;;AsDh7LA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,WAAA;EAAA,uCAAA;EACA,kBAAA;AtDm7LF;;AsDx6LA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDi7LF;;AsD16LA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtD66LF;;AIxnMI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AtD87LF;;AwDzoMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD2oMF;;AwDvoMA;EACE;IAAK,0CAAA;ExD2oML;AACF;AwDxoMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDuoMF;;AwDpoMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDsoMF;;AwD7nMA;EACE;IACE,mBAAA;ExDgoMF;EwD9nMA;IACE,UAAA;IACA,eAAA;ExDgoMF;AACF;AwD5nMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD2nMF;;AwDxnMA;EACE,wBAAA;EACA,yBAAA;AxD2nMF;;AwDvnME;EACE;;IAEE,kCAAA;ExD0nMJ;AACF;AyD1sMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD2sMF;;Ac9oMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD4rMJ;AACF;AsBvtMM;EmCYJ;InCXM,gBAAA;EtB0tMN;AACF;AcpqMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDmsMN;EyDhsMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDksMN;EyD/rMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDisMN;EyD9rMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDgsMN;EyD7rMI;IAEE,eAAA;EzD8rMN;EyD3rMI;IAGE,mBAAA;EzD2rMN;AACF;AcxtMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD0rMN;EyDxrMM;IACE,aAAA;EzD0rMR;EyDvrMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDwrMR;AACF;;Ac5tMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD0wMJ;AACF;AsBryMM;EmCYJ;InCXM,gBAAA;EtBwyMN;AACF;AclvMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDixMN;EyD9wMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDgxMN;EyD7wMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD+wMN;EyD5wMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD8wMN;EyD3wMI;IAEE,eAAA;EzD4wMN;EyDzwMI;IAGE,mBAAA;EzDywMN;AACF;ActyMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDwwMN;EyDtwMM;IACE,aAAA;EzDwwMR;EyDrwMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDswMR;AACF;;Ac1yMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDw1MJ;AACF;AsBn3MM;EmCYJ;InCXM,gBAAA;EtBs3MN;AACF;Ach0MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD+1MN;EyD51MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD81MN;EyD31MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD61MN;EyD11MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD41MN;EyDz1MI;IAEE,eAAA;EzD01MN;EyDv1MI;IAGE,mBAAA;EzDu1MN;AACF;Acp3MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDs1MN;EyDp1MM;IACE,aAAA;EzDs1MR;EyDn1MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDo1MR;AACF;;Acx3MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDs6MJ;AACF;AsBj8MM;EmCYJ;InCXM,gBAAA;EtBo8MN;AACF;Ac94MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD66MN;EyD16MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD46MN;EyDz6MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD26MN;EyDx6MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD06MN;EyDv6MI;IAEE,eAAA;EzDw6MN;EyDr6MI;IAGE,mBAAA;EzDq6MN;AACF;Acl8MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDo6MN;EyDl6MM;IACE,aAAA;EzDo6MR;EyDj6MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDk6MR;AACF;;Act8MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDo/MJ;AACF;AsB/gNM;EmCYJ;InCXM,gBAAA;EtBkhNN;AACF;Ac59MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD2/MN;EyDx/MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD0/MN;EyDv/MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDy/MN;EyDt/MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDw/MN;EyDr/MI;IAEE,eAAA;EzDs/MN;EyDn/MI;IAGE,mBAAA;EzDm/MN;AACF;AchhNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDk/MN;EyDh/MM;IACE,aAAA;EzDk/MR;EyD/+MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDg/MR;AACF;;AyDhkNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDikNN;AsB3lNM;EmCYJ;InCXM,gBAAA;EtB8lNN;AACF;AyDpkNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDskNR;AyDnkNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDqkNR;AyDlkNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDokNR;AyDjkNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDmkNR;AyDhkNM;EAEE,eAAA;AzDikNR;AyD9jNM;EAGE,mBAAA;AzD8jNR;;AyDniNA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sBjDmBM;ADwoNR;AkDxpNE;EAAS,UAAA;AlD2pNX;AkD1pNE;EAAS,Y5Cm+CyB;AN0rKpC;;AyD/iNA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDkjNF;AyDhjNE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzDijNJ;;AyD7iNA;EACE,gBAAA;EACA,kDAAA;AzDgjNF;;AyD7iNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDgjNF;;A0DjsNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANo5KpC;A0DlsNE;EACE,qBAAA;EACA,WAAA;A1DosNJ;;A0D/rNA;EACE,iBAAA;A1DksNF;;A0D/rNA;EACE,iBAAA;A1DksNF;;A0D/rNA;EACE,iBAAA;A1DksNF;;A0D7rNE;EACE,mDAAA;A1DgsNJ;;A0D5rNA;EACE;IACE,YpDmxCgC;EN46KlC;AACF;A0D5rNA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A1D8rNF;;A0D3rNA;EACE;IACE,+BAAA;YAAA,uBAAA;E1D8rNF;AACF;AuD7uNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD+uNJ;;A2DlvNE;EACE,sBAAA;EACA,iDAAA;EAAA,iFAAA;A3DqvNJ;;A2DvvNE;EACE,sBAAA;EACA,mDAAA;EAAA,mFAAA;A3D0vNJ;;A2D5vNE;EACE,sBAAA;EACA,kDAAA;EAAA,iFAAA;A3D+vNJ;;A2DjwNE;EACE,sBAAA;EACA,kDAAA;EAAA,8EAAA;A3DowNJ;;A2DtwNE;EACE,sBAAA;EACA,kDAAA;EAAA,iFAAA;A3DywNJ;;A2D3wNE;EACE,sBAAA;EACA,iDAAA;EAAA,gFAAA;A3D8wNJ;;A2DhxNE;EACE,sBAAA;EACA,mDAAA;EAAA,+EAAA;A3DmxNJ;;A2DrxNE;EACE,sBAAA;EACA,gDAAA;EAAA,8EAAA;A3DwxNJ;;A2D1xNE;EACE,sBAAA;EACA,gDAAA;EAAA,+EAAA;A3D6xNJ;;A2D/xNE;EACE,sBAAA;EACA,kDAAA;EAAA,mFAAA;A3DkyNJ;;A4DpyNE;EACE,sCAAA;EAAA,wEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,0GAAA;UAAA,kGAAA;A5DuyNJ;A4DpyNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5DoyNR;;A4D7yNE;EACE,wCAAA;EAAA,0EAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,4GAAA;UAAA,oGAAA;A5DgzNJ;A4D7yNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5D6yNR;;A4DtzNE;EACE,uCAAA;EAAA,wEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,0GAAA;UAAA,kGAAA;A5DyzNJ;A4DtzNM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5DszNR;;A4D/zNE;EACE,uCAAA;EAAA,qEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,uGAAA;UAAA,+FAAA;A5Dk0NJ;A4D/zNM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5D+zNR;;A4Dx0NE;EACE,uCAAA;EAAA,wEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,0GAAA;UAAA,kGAAA;A5D20NJ;A4Dx0NM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5Dw0NR;;A4Dj1NE;EACE,sCAAA;EAAA,uEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,yGAAA;UAAA,iGAAA;A5Do1NJ;A4Dj1NM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5Di1NR;;A4D11NE;EACE,wCAAA;EAAA,sEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,wGAAA;UAAA,gGAAA;A5D61NJ;A4D11NM;EAGE,wCAAA;EAAA,gEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,kGAAA;UAAA,0FAAA;A5D01NR;;A4Dn2NE;EACE,qCAAA;EAAA,qEAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,uGAAA;UAAA,+FAAA;A5Ds2NJ;A4Dn2NM;EAGE,qCAAA;EAAA,6DAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,+FAAA;UAAA,uFAAA;A5Dm2NR;;A4D52NE;EACE,qCAAA;EAAA,sEAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,wGAAA;UAAA,gGAAA;A5D+2NJ;A4D52NM;EAGE,qCAAA;EAAA,6DAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,+FAAA;UAAA,uFAAA;A5D42NR;;A4Dr3NE;EACE,uCAAA;EAAA,0EAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,4GAAA;UAAA,oGAAA;A5Dw3NJ;A4Dr3NM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5Dq3NR;;A4D92NA;EACE,kCAAA;EAAA,+EAAA;EACA,0DAAA;UAAA,kDAAA;EAAA,iHAAA;UAAA,yGAAA;A5Di3NF;A4D92NI;EAEE,qCAAA;EAAA,kFAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,oHAAA;UAAA,4GAAA;A5D+2NN;;A6Dz4NA;EACE,UAAA;EAEA,iDAAA;EAAA,kJAAA;A7D24NF;;A8D94NA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,qDAAA;UAAA,6CAAA;EAAA,0FAAA;UAAA,kFAAA;EACA,6BxD2c4B;EwD1c5B,mCAAA;UAAA,2BAAA;A9Di5NF;A8D/4NE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9Di5NJ;AsB14NM;EwCZJ;IxCaM,gBAAA;EtB64NN;AACF;;A8D/4NI;EACE,oCAAA;EAAA,mEAAA;A9Dk5NN;;A+Dr6NA;EACE,kBAAA;EACA,WAAA;A/Dw6NF;A+Dt6NE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/Dw6NJ;A+Dr6NE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/Du6NJ;;A+Dl6NE;EACE,uBAAA;A/Dq6NJ;;A+Dt6NE;EACE,sBAAA;A/Dy6NJ;;A+D16NE;EACE,yBAAA;A/D66NJ;;A+D96NE;EACE,iCAAA;A/Di7NJ;;AgEt8NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANk2LpC;;AgEt8NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN02LpC;;AgEj8NI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANi3LpC;;AgEj8NI;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,a1D6kC8B;ANu3LpC;;Acr6NI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN83LlC;EgE98NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENm4LlC;AACF;Acl7NI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN04LlC;EgE19NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN+4LlC;AACF;Ac97NI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENs5LlC;EgEt+NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN25LlC;AACF;Ac18NI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENk6LlC;EgEl/NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENu6LlC;AACF;Act9NI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN86LlC;EgE9/NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENm7LlC;AACF;AiEhiOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEkiOF;;AiE/hOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEkiOF;;AkE1iOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnE2iOF;AmExiOE;;EACE,6BAAA;AnE2iOJ;AmEviOE;;EACE,2BAAA;AnE0iOJ;;AoE7jOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEgkOJ;;AqExkOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE4kOF;;AuEllOA;EACE,qBAAA;EACA,mBAAA;EACA,UjEisB4B;EiEjsB5B,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN05M9B;;AwEzhOQ;EAOI,mCAAA;AxEshOZ;;AwE7hOQ;EAOI,8BAAA;AxE0hOZ;;AwEjiOQ;EAOI,iCAAA;AxE8hOZ;;AwEriOQ;EAOI,iCAAA;AxEkiOZ;;AwEziOQ;EAOI,sCAAA;AxEsiOZ;;AwE7iOQ;EAOI,mCAAA;AxE0iOZ;;AwEjjOQ;EAOI,sBAAA;AxE8iOZ;;AwErjOQ;EAOI,uBAAA;AxEkjOZ;;AwEzjOQ;EAOI,sBAAA;AxEsjOZ;;AwE7jOQ;EAOI,8BAAA;AxE0jOZ;;AwEjkOQ;EAOI,4BAAA;AxE8jOZ;;AwErkOQ;EAOI,2BAAA;AxEkkOZ;;AwEzkOQ;EAOI,iCAAA;AxEskOZ;;AwE7kOQ;EAOI,2BAAA;AxE0kOZ;;AwEjlOQ;EAOI,qBAAA;AxE8kOZ;;AwErlOQ;EAOI,wBAAA;AxEklOZ;;AwEzlOQ;EAOI,uBAAA;AxEslOZ;;AwE7lOQ;EAOI,wBAAA;AxE0lOZ;;AwEjmOQ;EAOI,qBAAA;AxE8lOZ;;AwErmOQ;EAOI,yBAAA;AxEkmOZ;;AwEzmOQ;EAOI,2BAAA;AxEsmOZ;;AwE7mOQ;EAOI,4BAAA;AxE0mOZ;;AwEjnOQ;EAOI,2BAAA;AxE8mOZ;;AwErnOQ;EAOI,2BAAA;AxEknOZ;;AwEznOQ;EAOI,6BAAA;AxEsnOZ;;AwE7nOQ;EAOI,8BAAA;AxE0nOZ;;AwEjoOQ;EAOI,6BAAA;AxE8nOZ;;AwEroOQ;EAOI,2BAAA;AxEkoOZ;;AwEzoOQ;EAOI,6BAAA;AxEsoOZ;;AwE7oOQ;EAOI,8BAAA;AxE0oOZ;;AwEjpOQ;EAOI,6BAAA;AxE8oOZ;;AwErpOQ;EAOI,0BAAA;AxEkpOZ;;AwEzpOQ;EAOI,gCAAA;AxEspOZ;;AwE7pOQ;EAOI,yBAAA;AxE0pOZ;;AwEjqOQ;EAOI,wBAAA;AxE8pOZ;;AwErqOQ;EAOI,+BAAA;AxEkqOZ;;AwEzqOQ;EAOI,yBAAA;AxEsqOZ;;AwE7qOQ;EAOI,6BAAA;AxE0qOZ;;AwEjrOQ;EAOI,8BAAA;AxE8qOZ;;AwErrOQ;EAOI,wBAAA;AxEkrOZ;;AwEzrOQ;EAOI,+BAAA;AxEsrOZ;;AwE7rOQ;EAOI,wBAAA;AxE0rOZ;;AwEjsOQ;EAOI,wDAAA;EAAA,2CAAA;AxE8rOZ;;AwErsOQ;EAOI,8DAAA;EAAA,8CAAA;AxEksOZ;;AwEzsOQ;EAOI,uDAAA;EAAA,8CAAA;AxEssOZ;;AwE7sOQ;EAOI,2BAAA;AxE0sOZ;;AwE3tOQ;EACE,gFAAA;AxE8tOV;;AwE/tOQ;EACE,kFAAA;AxEkuOV;;AwEnuOQ;EACE,gFAAA;AxEsuOV;;AwEvuOQ;EACE,6EAAA;AxE0uOV;;AwE3uOQ;EACE,gFAAA;AxE8uOV;;AwE/uOQ;EACE,+EAAA;AxEkvOV;;AwEnvOQ;EACE,8EAAA;AxEsvOV;;AwEvvOQ;EACE,6EAAA;AxE0vOV;;AwE3vOQ;EACE,8EAAA;AxE8vOV;;AwE/vOQ;EACE,kFAAA;AxEkwOV;;AwEzvOQ;EAOI,2BAAA;AxEsvOZ;;AwE7vOQ;EAOI,6BAAA;AxE0vOZ;;AwEjwOQ;EAOI,6BAAA;AxE8vOZ;;AwErwOQ;EAOI,0BAAA;AxEkwOZ;;AwEzwOQ;EAOI,mCAAA;EAAA,2BAAA;AxEswOZ;;AwE7wOQ;EAOI,iBAAA;AxE0wOZ;;AwEjxOQ;EAOI,mBAAA;AxE8wOZ;;AwErxOQ;EAOI,oBAAA;AxEkxOZ;;AwEzxOQ;EAOI,oBAAA;AxEsxOZ;;AwE7xOQ;EAOI,sBAAA;AxE0xOZ;;AwEjyOQ;EAOI,uBAAA;AxE8xOZ;;AwEryOQ;EAOI,kBAAA;AxEkyOZ;;AwEzyOQ;EAOI,oBAAA;AxEsyOZ;;AwE7yOQ;EAOI,qBAAA;AxE0yOZ;;AwEjzOQ;EAOI,mBAAA;AxE8yOZ;;AwErzOQ;EAOI,qBAAA;AxEkzOZ;;AwEzzOQ;EAOI,sBAAA;AxEszOZ;;AwE7zOQ;EAOI,2CAAA;AxE0zOZ;;AwEj0OQ;EAOI,sCAAA;AxE8zOZ;;AwEr0OQ;EAOI,sCAAA;AxEk0OZ;;AwEz0OQ;EAOI,oCAAA;EAAA,uFAAA;AxEs0OZ;;AwE70OQ;EAOI,oBAAA;AxE00OZ;;AwEj1OQ;EAOI,wCAAA;EAAA,2FAAA;AxE80OZ;;AwEr1OQ;EAOI,wBAAA;AxEk1OZ;;AwEz1OQ;EAOI,0CAAA;EAAA,6FAAA;AxEs1OZ;;AwE71OQ;EAOI,0BAAA;AxE01OZ;;AwEj2OQ;EAOI,2CAAA;EAAA,8FAAA;AxE81OZ;;AwEr2OQ;EAOI,2BAAA;AxEk2OZ;;AwEz2OQ;EAOI,yCAAA;EAAA,4FAAA;AxEs2OZ;;AwE72OQ;EAOI,yBAAA;AxE02OZ;;AwEj3OQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxE+2OZ;;AwEt3OQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxEo3OZ;;AwE33OQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxEy3OZ;;AwEh4OQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxE83OZ;;AwEr4OQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxEm4OZ;;AwE14OQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEw4OZ;;AwE/4OQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxE64OZ;;AwEp5OQ;EAIQ,sBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxEk5OZ;;AwEz5OQ;EAIQ,sBAAA;EAGJ,mEAAA;EAAA,4EAAA;AxEu5OZ;;AwE95OQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,gFAAA;AxE45OZ;;AwEn6OQ;EAIQ,sBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxEi6OZ;;AwEx6OQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEs6OZ;;AwE76OQ;EAOI,iDAAA;EAAA,wDAAA;AxE06OZ;;AwEj7OQ;EAOI,+CAAA;EAAA,0DAAA;AxE86OZ;;AwEr7OQ;EAOI,+CAAA;EAAA,wDAAA;AxEk7OZ;;AwEz7OQ;EAOI,+CAAA;EAAA,qDAAA;AxEs7OZ;;AwE77OQ;EAOI,+CAAA;EAAA,wDAAA;AxE07OZ;;AwEj8OQ;EAOI,+CAAA;EAAA,uDAAA;AxE87OZ;;AwEr8OQ;EAOI,gCAAA;EAAA,sDAAA;AxEk8OZ;;AwEz8OQ;EAOI,gCAAA;EAAA,qDAAA;AxEs8OZ;;AwE78OQ;EAOI,4BAAA;AxE08OZ;;AwEj9OQ;EAOI,4BAAA;AxE88OZ;;AwEr9OQ;EAOI,4BAAA;AxEk9OZ;;AwEz9OQ;EAOI,4BAAA;AxEs9OZ;;AwE79OQ;EAOI,4BAAA;AxE09OZ;;AwE3+OQ;EACE,wBAAA;AxE8+OV;;AwE/+OQ;EACE,yBAAA;AxEk/OV;;AwEn/OQ;EACE,wBAAA;AxEs/OV;;AwEv/OQ;EACE,yBAAA;AxE0/OV;;AwE3/OQ;EACE,sBAAA;AxE8/OV;;AwEr/OQ;EAOI,qBAAA;AxEk/OZ;;AwEz/OQ;EAOI,qBAAA;AxEs/OZ;;AwE7/OQ;EAOI,qBAAA;AxE0/OZ;;AwEjgPQ;EAOI,sBAAA;AxE8/OZ;;AwErgPQ;EAOI,sBAAA;AxEkgPZ;;AwEzgPQ;EAOI,0BAAA;AxEsgPZ;;AwE7gPQ;EAOI,uBAAA;AxE0gPZ;;AwEjhPQ;EAOI,2BAAA;AxE8gPZ;;AwErhPQ;EAOI,sBAAA;AxEkhPZ;;AwEzhPQ;EAOI,sBAAA;AxEshPZ;;AwE7hPQ;EAOI,sBAAA;AxE0hPZ;;AwEjiPQ;EAOI,uBAAA;AxE8hPZ;;AwEriPQ;EAOI,uBAAA;AxEkiPZ;;AwEziPQ;EAOI,2BAAA;AxEsiPZ;;AwE7iPQ;EAOI,wBAAA;AxE0iPZ;;AwEjjPQ;EAOI,4BAAA;AxE8iPZ;;AwErjPQ;EAOI,yBAAA;AxEkjPZ;;AwEzjPQ;EAOI,8BAAA;AxEsjPZ;;AwE7jPQ;EAOI,iCAAA;AxE0jPZ;;AwEjkPQ;EAOI,sCAAA;AxE8jPZ;;AwErkPQ;EAOI,yCAAA;AxEkkPZ;;AwEzkPQ;EAOI,uBAAA;AxEskPZ;;AwE7kPQ;EAOI,uBAAA;AxE0kPZ;;AwEjlPQ;EAOI,yBAAA;AxE8kPZ;;AwErlPQ;EAOI,yBAAA;AxEklPZ;;AwEzlPQ;EAOI,0BAAA;AxEslPZ;;AwE7lPQ;EAOI,4BAAA;AxE0lPZ;;AwEjmPQ;EAOI,kCAAA;AxE8lPZ;;AwErmPQ;EAOI,sCAAA;AxEkmPZ;;AwEzmPQ;EAOI,oCAAA;AxEsmPZ;;AwE7mPQ;EAOI,kCAAA;AxE0mPZ;;AwEjnPQ;EAOI,yCAAA;AxE8mPZ;;AwErnPQ;EAOI,wCAAA;AxEknPZ;;AwEznPQ;EAOI,wCAAA;AxEsnPZ;;AwE7nPQ;EAOI,kCAAA;AxE0nPZ;;AwEjoPQ;EAOI,gCAAA;AxE8nPZ;;AwEroPQ;EAOI,8BAAA;AxEkoPZ;;AwEzoPQ;EAOI,gCAAA;AxEsoPZ;;AwE7oPQ;EAOI,+BAAA;AxE0oPZ;;AwEjpPQ;EAOI,oCAAA;AxE8oPZ;;AwErpPQ;EAOI,kCAAA;AxEkpPZ;;AwEzpPQ;EAOI,gCAAA;AxEspPZ;;AwE7pPQ;EAOI,uCAAA;AxE0pPZ;;AwEjqPQ;EAOI,sCAAA;AxE8pPZ;;AwErqPQ;EAOI,iCAAA;AxEkqPZ;;AwEzqPQ;EAOI,2BAAA;AxEsqPZ;;AwE7qPQ;EAOI,iCAAA;AxE0qPZ;;AwEjrPQ;EAOI,+BAAA;AxE8qPZ;;AwErrPQ;EAOI,6BAAA;AxEkrPZ;;AwEzrPQ;EAOI,+BAAA;AxEsrPZ;;AwE7rPQ;EAOI,8BAAA;AxE0rPZ;;AwEjsPQ;EAOI,oBAAA;AxE8rPZ;;AwErsPQ;EAOI,mBAAA;AxEksPZ;;AwEzsPQ;EAOI,mBAAA;AxEssPZ;;AwE7sPQ;EAOI,mBAAA;AxE0sPZ;;AwEjtPQ;EAOI,mBAAA;AxE8sPZ;;AwErtPQ;EAOI,mBAAA;AxEktPZ;;AwEztPQ;EAOI,mBAAA;AxEstPZ;;AwE7tPQ;EAOI,mBAAA;AxE0tPZ;;AwEjuPQ;EAOI,oBAAA;AxE8tPZ;;AwEruPQ;EAOI,0BAAA;AxEkuPZ;;AwEzuPQ;EAOI,yBAAA;AxEsuPZ;;AwE7uPQ;EAOI,uBAAA;AxE0uPZ;;AwEjvPQ;EAOI,yBAAA;AxE8uPZ;;AwErvPQ;EAOI,uBAAA;AxEkvPZ;;AwEzvPQ;EAOI,uBAAA;AxEsvPZ;;AwE7vPQ;EAOI,0BAAA;EAAA,yBAAA;AxE2vPZ;;AwElwPQ;EAOI,gCAAA;EAAA,+BAAA;AxEgwPZ;;AwEvwPQ;EAOI,+BAAA;EAAA,8BAAA;AxEqwPZ;;AwE5wPQ;EAOI,6BAAA;EAAA,4BAAA;AxE0wPZ;;AwEjxPQ;EAOI,+BAAA;EAAA,8BAAA;AxE+wPZ;;AwEtxPQ;EAOI,6BAAA;EAAA,4BAAA;AxEoxPZ;;AwE3xPQ;EAOI,6BAAA;EAAA,4BAAA;AxEyxPZ;;AwEhyPQ;EAOI,wBAAA;EAAA,2BAAA;AxE8xPZ;;AwEryPQ;EAOI,8BAAA;EAAA,iCAAA;AxEmyPZ;;AwE1yPQ;EAOI,6BAAA;EAAA,gCAAA;AxEwyPZ;;AwE/yPQ;EAOI,2BAAA;EAAA,8BAAA;AxE6yPZ;;AwEpzPQ;EAOI,6BAAA;EAAA,gCAAA;AxEkzPZ;;AwEzzPQ;EAOI,2BAAA;EAAA,8BAAA;AxEuzPZ;;AwE9zPQ;EAOI,2BAAA;EAAA,8BAAA;AxE4zPZ;;AwEn0PQ;EAOI,wBAAA;AxEg0PZ;;AwEv0PQ;EAOI,8BAAA;AxEo0PZ;;AwE30PQ;EAOI,6BAAA;AxEw0PZ;;AwE/0PQ;EAOI,2BAAA;AxE40PZ;;AwEn1PQ;EAOI,6BAAA;AxEg1PZ;;AwEv1PQ;EAOI,2BAAA;AxEo1PZ;;AwE31PQ;EAOI,2BAAA;AxEw1PZ;;AwE/1PQ;EAOI,0BAAA;AxE41PZ;;AwEn2PQ;EAOI,gCAAA;AxEg2PZ;;AwEv2PQ;EAOI,+BAAA;AxEo2PZ;;AwE32PQ;EAOI,6BAAA;AxEw2PZ;;AwE/2PQ;EAOI,+BAAA;AxE42PZ;;AwEn3PQ;EAOI,6BAAA;AxEg3PZ;;AwEv3PQ;EAOI,6BAAA;AxEo3PZ;;AwE33PQ;EAOI,2BAAA;AxEw3PZ;;AwE/3PQ;EAOI,iCAAA;AxE43PZ;;AwEn4PQ;EAOI,gCAAA;AxEg4PZ;;AwEv4PQ;EAOI,8BAAA;AxEo4PZ;;AwE34PQ;EAOI,gCAAA;AxEw4PZ;;AwE/4PQ;EAOI,8BAAA;AxE44PZ;;AwEn5PQ;EAOI,8BAAA;AxEg5PZ;;AwEv5PQ;EAOI,yBAAA;AxEo5PZ;;AwE35PQ;EAOI,+BAAA;AxEw5PZ;;AwE/5PQ;EAOI,8BAAA;AxE45PZ;;AwEn6PQ;EAOI,4BAAA;AxEg6PZ;;AwEv6PQ;EAOI,8BAAA;AxEo6PZ;;AwE36PQ;EAOI,4BAAA;AxEw6PZ;;AwE/6PQ;EAOI,4BAAA;AxE46PZ;;AwEn7PQ;EAOI,qBAAA;AxEg7PZ;;AwEv7PQ;EAOI,2BAAA;AxEo7PZ;;AwE37PQ;EAOI,0BAAA;AxEw7PZ;;AwE/7PQ;EAOI,wBAAA;AxE47PZ;;AwEn8PQ;EAOI,0BAAA;AxEg8PZ;;AwEv8PQ;EAOI,wBAAA;AxEo8PZ;;AwE38PQ;EAOI,2BAAA;EAAA,0BAAA;AxEy8PZ;;AwEh9PQ;EAOI,iCAAA;EAAA,gCAAA;AxE88PZ;;AwEr9PQ;EAOI,gCAAA;EAAA,+BAAA;AxEm9PZ;;AwE19PQ;EAOI,8BAAA;EAAA,6BAAA;AxEw9PZ;;AwE/9PQ;EAOI,gCAAA;EAAA,+BAAA;AxE69PZ;;AwEp+PQ;EAOI,8BAAA;EAAA,6BAAA;AxEk+PZ;;AwEz+PQ;EAOI,yBAAA;EAAA,4BAAA;AxEu+PZ;;AwE9+PQ;EAOI,+BAAA;EAAA,kCAAA;AxE4+PZ;;AwEn/PQ;EAOI,8BAAA;EAAA,iCAAA;AxEi/PZ;;AwEx/PQ;EAOI,4BAAA;EAAA,+BAAA;AxEs/PZ;;AwE7/PQ;EAOI,8BAAA;EAAA,iCAAA;AxE2/PZ;;AwElgQQ;EAOI,4BAAA;EAAA,+BAAA;AxEggQZ;;AwEvgQQ;EAOI,yBAAA;AxEogQZ;;AwE3gQQ;EAOI,+BAAA;AxEwgQZ;;AwE/gQQ;EAOI,8BAAA;AxE4gQZ;;AwEnhQQ;EAOI,4BAAA;AxEghQZ;;AwEvhQQ;EAOI,8BAAA;AxEohQZ;;AwE3hQQ;EAOI,4BAAA;AxEwhQZ;;AwE/hQQ;EAOI,2BAAA;AxE4hQZ;;AwEniQQ;EAOI,iCAAA;AxEgiQZ;;AwEviQQ;EAOI,gCAAA;AxEoiQZ;;AwE3iQQ;EAOI,8BAAA;AxEwiQZ;;AwE/iQQ;EAOI,gCAAA;AxE4iQZ;;AwEnjQQ;EAOI,8BAAA;AxEgjQZ;;AwEvjQQ;EAOI,4BAAA;AxEojQZ;;AwE3jQQ;EAOI,kCAAA;AxEwjQZ;;AwE/jQQ;EAOI,iCAAA;AxE4jQZ;;AwEnkQQ;EAOI,+BAAA;AxEgkQZ;;AwEvkQQ;EAOI,iCAAA;AxEokQZ;;AwE3kQQ;EAOI,+BAAA;AxEwkQZ;;AwE/kQQ;EAOI,0BAAA;AxE4kQZ;;AwEnlQQ;EAOI,gCAAA;AxEglQZ;;AwEvlQQ;EAOI,+BAAA;AxEolQZ;;AwE3lQQ;EAOI,6BAAA;AxEwlQZ;;AwE/lQQ;EAOI,+BAAA;AxE4lQZ;;AwEnmQQ;EAOI,6BAAA;AxEgmQZ;;AwEvmQQ;EAOI,iBAAA;AxEomQZ;;AwE3mQQ;EAOI,uBAAA;AxEwmQZ;;AwE/mQQ;EAOI,sBAAA;AxE4mQZ;;AwEnnQQ;EAOI,oBAAA;AxEgnQZ;;AwEvnQQ;EAOI,sBAAA;AxEonQZ;;AwE3nQQ;EAOI,oBAAA;AxEwnQZ;;AwE/nQQ;EAOI,qBAAA;AxE4nQZ;;AwEnoQQ;EAOI,2BAAA;AxEgoQZ;;AwEvoQQ;EAOI,0BAAA;AxEooQZ;;AwE3oQQ;EAOI,wBAAA;AxEwoQZ;;AwE/oQQ;EAOI,0BAAA;AxE4oQZ;;AwEnpQQ;EAOI,wBAAA;AxEgpQZ;;AwEvpQQ;EAOI,wBAAA;AxEopQZ;;AwE3pQQ;EAOI,8BAAA;AxEwpQZ;;AwE/pQQ;EAOI,6BAAA;AxE4pQZ;;AwEnqQQ;EAOI,2BAAA;AxEgqQZ;;AwEvqQQ;EAOI,6BAAA;AxEoqQZ;;AwE3qQQ;EAOI,2BAAA;AxEwqQZ;;AwE/qQQ;EAOI,4GAAA;EAAA,gDAAA;AxE4qQZ;;AwEnrQQ;EAOI,6CAAA;AxEgrQZ;;AwEvrQQ;EAOI,8CAAA;AxEorQZ;;AwE3rQQ;EAOI,8CAAA;AxEwrQZ;;AwE/rQQ;EAOI,8CAAA;AxE4rQZ;;AwEnsQQ;EAOI,4BAAA;AxEgsQZ;;AwEvsQQ;EAOI,6BAAA;AxEosQZ;;AwE3sQQ;EAOI,6BAAA;AxEwsQZ;;AwE/sQQ;EAOI,6BAAA;AxE4sQZ;;AwEntQQ;EAOI,+BAAA;AxEgtQZ;;AwEvtQQ;EAOI,2BAAA;AxEotQZ;;AwE3tQQ;EAOI,2BAAA;AxEwtQZ;;AwE/tQQ;EAOI,2BAAA;AxE4tQZ;;AwEnuQQ;EAOI,2BAAA;AxEguQZ;;AwEvuQQ;EAOI,2BAAA;AxEouQZ;;AwE3uQQ;EAOI,8BAAA;AxEwuQZ;;AwE/uQQ;EAOI,yBAAA;AxE4uQZ;;AwEnvQQ;EAOI,4BAAA;AxEgvQZ;;AwEvvQQ;EAOI,2BAAA;AxEovQZ;;AwE3vQQ;EAOI,yBAAA;AxEwvQZ;;AwE/vQQ;EAOI,2BAAA;AxE4vQZ;;AwEnwQQ;EAOI,4BAAA;AxEgwQZ;;AwEvwQQ;EAOI,6BAAA;AxEowQZ;;AwE3wQQ;EAOI,gCAAA;AxEwwQZ;;AwE/wQQ;EAOI,qCAAA;AxE4wQZ;;AwEnxQQ;EAOI,wCAAA;AxEgxQZ;;AwEvxQQ;EAOI,oCAAA;AxEoxQZ;;AwE3xQQ;EAOI,oCAAA;AxEwxQZ;;AwE/xQQ;EAOI,qCAAA;AxE4xQZ;;AwEnyQQ;EAOI,8BAAA;AxEgyQZ;;AwEvyQQ;EAOI,8BAAA;AxEoyQZ;;AwEzzQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE0yQZ;;AwEvxQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;AxEgzQZ;;AwEvzQQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,uEAAA;AxEqzQZ;;AwE5zQQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,qEAAA;AxE0zQZ;;AwEj0QQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,kEAAA;AxE+zQZ;;AwEt0QQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,qEAAA;AxEo0QZ;;AwE30QQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,oEAAA;AxEy0QZ;;AwEh1QQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxE80QZ;;AwEr1QQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,kEAAA;AxEm1QZ;;AwE11QQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,mEAAA;AxEw1QZ;;AwE/1QQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,uEAAA;AxE61QZ;;AwEp2QQ;EAIQ,oBAAA;EAGJ,uDAAA;EAAA,mEAAA;AxEk2QZ;;AwEz2QQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxEu2QZ;;AwE92QQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,wEAAA;AxE42QZ;;AwEn3QQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxEi3QZ;;AwEx3QQ;EAIQ,oBAAA;EAGJ,oCAAA;AxEs3QZ;;AwE73QQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE23QZ;;AwEl4QQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxEg4QZ;;AwEv4QQ;EAIQ,oBAAA;EAGJ,uCAAA;EAAA,0CAAA;AxEq4QZ;;AwE54QQ;EAIQ,oBAAA;EAGJ,sBAAA;EAAA,0CAAA;AxE04QZ;;AwEj5QQ;EAIQ,oBAAA;EAGJ,yBAAA;AxE+4QZ;;AwEh6QQ;EACE,uBAAA;AxEm6QV;;AwEp6QQ;EACE,sBAAA;AxEu6QV;;AwEx6QQ;EACE,uBAAA;AxE26QV;;AwE56QQ;EACE,oBAAA;AxE+6QV;;AwEt6QQ;EAOI,uCAAA;EAAA,iDAAA;AxEm6QZ;;AwE16QQ;EAOI,qCAAA;EAAA,mDAAA;AxEu6QZ;;AwE96QQ;EAOI,qCAAA;EAAA,iDAAA;AxE26QZ;;AwEl7QQ;EAOI,sCAAA;EAAA,8CAAA;AxE+6QZ;;AwEt7QQ;EAOI,qCAAA;EAAA,iDAAA;AxEm7QZ;;AwE17QQ;EAOI,qCAAA;EAAA,gDAAA;AxEu7QZ;;AwE97QQ;EAOI,yBAAA;EAAA,+CAAA;AxE27QZ;;AwEl8QQ;EAOI,yBAAA;EAAA,8CAAA;AxE+7QZ;;AwEh9QQ;EACE,sBAAA;AxEm9QV;;AwE/8QU;EACE,sBAAA;AxEk9QZ;;AwEx9QQ;EACE,uBAAA;AxE29QV;;AwEv9QU;EACE,uBAAA;AxE09QZ;;AwEh+QQ;EACE,sBAAA;AxEm+QV;;AwE/9QU;EACE,sBAAA;AxEk+QZ;;AwEx+QQ;EACE,uBAAA;AxE2+QV;;AwEv+QU;EACE,uBAAA;AxE0+QZ;;AwEh/QQ;EACE,oBAAA;AxEm/QV;;AwE/+QU;EACE,oBAAA;AxEk/QZ;;AwE9+QQ;EAOI,yCAAA;AxE2+QZ;;AwEt+QU;EAOI,yCAAA;AxEm+Qd;;AwEt/QQ;EAOI,wCAAA;AxEm/QZ;;AwE9+QU;EAOI,wCAAA;AxE2+Qd;;AwE9/QQ;EAOI,yCAAA;AxE2/QZ;;AwEt/QU;EAOI,yCAAA;AxEm/Qd;;AwEtgRQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,uGAAA;UAAA,+FAAA;AxEogRZ;;AwE3gRQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,yGAAA;UAAA,iGAAA;AxEygRZ;;AwEhhRQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,uGAAA;UAAA,+FAAA;AxE8gRZ;;AwErhRQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,oGAAA;UAAA,4FAAA;AxEmhRZ;;AwE1hRQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,uGAAA;UAAA,+FAAA;AxEwhRZ;;AwE/hRQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,sGAAA;UAAA,8FAAA;AxE6hRZ;;AwEpiRQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,qGAAA;UAAA,6FAAA;AxEkiRZ;;AwEziRQ;EAIQ,8BAAA;EAGJ,4FAAA;UAAA,oFAAA;EAAA,oGAAA;UAAA,4FAAA;AxEuiRZ;;AwE9iRQ;EAIQ,8BAAA;EAGJ,4FAAA;UAAA,oFAAA;EAAA,qGAAA;UAAA,6FAAA;AxE4iRZ;;AwEnjRQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,yGAAA;UAAA,iGAAA;AxEijRZ;;AwExjRQ;EAIQ,8BAAA;EAGJ,8DAAA;UAAA,sDAAA;EAAA,6GAAA;UAAA,qGAAA;AxEsjRZ;;AwEvkRQ;EACE,8BAAA;AxE0kRV;;AwEtkRU;EACE,8BAAA;AxEykRZ;;AwE/kRQ;EACE,gCAAA;AxEklRV;;AwE9kRU;EACE,gCAAA;AxEilRZ;;AwEvlRQ;EACE,iCAAA;AxE0lRV;;AwEtlRU;EACE,iCAAA;AxEylRZ;;AwE/lRQ;EACE,gCAAA;AxEkmRV;;AwE9lRU;EACE,gCAAA;AxEimRZ;;AwEvmRQ;EACE,iCAAA;AxE0mRV;;AwEtmRU;EACE,iCAAA;AxEymRZ;;AwE/mRQ;EACE,8BAAA;AxEknRV;;AwE9mRU;EACE,8BAAA;AxEinRZ;;AwE7mRQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxE2mRZ;;AwElnRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxEgnRZ;;AwEvnRQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxEqnRZ;;AwE5nRQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxE0nRZ;;AwEjoRQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxE+nRZ;;AwEtoRQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEooRZ;;AwE3oRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEyoRZ;;AwEhpRQ;EAIQ,kBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxE8oRZ;;AwErpRQ;EAIQ,kBAAA;EAGJ,mEAAA;EAAA,4EAAA;AxEmpRZ;;AwE1pRQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,gFAAA;AxEwpRZ;;AwE/pRQ;EAIQ,kBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxE6pRZ;;AwEpqRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEkqRZ;;AwEzqRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,8EAAA;AxEuqRZ;;AwE9qRQ;EAIQ,kBAAA;EAGJ,wCAAA;AxE4qRZ;;AwEnrRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,mFAAA;AxEirRZ;;AwExrRQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,kFAAA;AxEsrRZ;;AwEvsRQ;EACE,oBAAA;AxE0sRV;;AwE3sRQ;EACE,qBAAA;AxE8sRV;;AwE/sRQ;EACE,oBAAA;AxEktRV;;AwEntRQ;EACE,qBAAA;AxEstRV;;AwEvtRQ;EACE,kBAAA;AxE0tRV;;AwEjtRQ;EAOI,qDAAA;EAAA,wDAAA;AxE8sRZ;;AwErtRQ;EAOI,mDAAA;EAAA,0DAAA;AxEktRZ;;AwEztRQ;EAOI,mDAAA;EAAA,wDAAA;AxEstRZ;;AwE7tRQ;EAOI,mDAAA;EAAA,qDAAA;AxE0tRZ;;AwEjuRQ;EAOI,mDAAA;EAAA,wDAAA;AxE8tRZ;;AwEruRQ;EAOI,mDAAA;EAAA,uDAAA;AxEkuRZ;;AwEzuRQ;EAOI,mDAAA;EAAA,sDAAA;AxEsuRZ;;AwE7uRQ;EAOI,oCAAA;EAAA,qDAAA;AxE0uRZ;;AwEjvRQ;EAOI,uGAAA;EAAA,+CAAA;AxE8uRZ;;AwErvRQ;EAOI,mCAAA;UAAA,2BAAA;AxEkvRZ;;AwEzvRQ;EAOI,oCAAA;UAAA,4BAAA;AxEsvRZ;;AwE7vRQ;EAOI,oCAAA;UAAA,4BAAA;AxE0vRZ;;AwEjwRQ;EAOI,+BAAA;AxE8vRZ;;AwErwRQ;EAOI,+BAAA;AxEkwRZ;;AwEzwRQ;EAOI,kCAAA;EAAA,iDAAA;AxEswRZ;;AwE7wRQ;EAOI,2BAAA;AxE0wRZ;;AwEjxRQ;EAOI,iCAAA;EAAA,oDAAA;AxE8wRZ;;AwErxRQ;EAOI,kCAAA;EAAA,iDAAA;AxEkxRZ;;AwEzxRQ;EAOI,gCAAA;EAAA,oDAAA;AxEsxRZ;;AwE7xRQ;EAOI,8BAAA;EAAA,oDAAA;AxE0xRZ;;AwEjyRQ;EAOI,8BAAA;EAAA,qDAAA;AxE8xRZ;;AwEryRQ;EAOI,6BAAA;AxEkyRZ;;AwEzyRQ;EAOI,+BAAA;EAAA,sDAAA;AxEsyRZ;;AwE7yRQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxE2yRZ;;AwElzRQ;EAOI,oCAAA;EAAA,qCAAA;AxEgzRZ;;AwEvzRQ;EAOI,0CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,8DAAA;AxEqzRZ;;AwE5zRQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxE0zRZ;;AwEj0RQ;EAOI,yCAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,8DAAA;AxE+zRZ;;AwEt0RQ;EAOI,uCAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,8DAAA;AxEo0RZ;;AwE30RQ;EAOI,uCAAA;EAAA,8DAAA;EAAA,wCAAA;EAAA,+DAAA;AxEy0RZ;;AwEh1RQ;EAOI,sCAAA;EAAA,uCAAA;AxE80RZ;;AwEr1RQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,yCAAA;EAAA,gEAAA;AxEm1RZ;;AwE11RQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxEw1RZ;;AwE/1RQ;EAOI,qCAAA;EAAA,wCAAA;AxE61RZ;;AwEp2RQ;EAOI,2CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,iEAAA;AxEk2RZ;;AwEz2RQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxEu2RZ;;AwE92RQ;EAOI,0CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,iEAAA;AxE42RZ;;AwEn3RQ;EAOI,wCAAA;EAAA,8DAAA;EAAA,2CAAA;EAAA,iEAAA;AxEi3RZ;;AwEx3RQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,kEAAA;AxEs3RZ;;AwE73RQ;EAOI,uCAAA;EAAA,0CAAA;AxE23RZ;;AwEl4RQ;EAOI,yCAAA;EAAA,gEAAA;EAAA,4CAAA;EAAA,mEAAA;AxEg4RZ;;AwEv4RQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxEq4RZ;;AwE54RQ;EAOI,wCAAA;EAAA,uCAAA;AxE04RZ;;AwEj5RQ;EAOI,8CAAA;EAAA,iEAAA;EAAA,6CAAA;EAAA,gEAAA;AxE+4RZ;;AwEt5RQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxEo5RZ;;AwE35RQ;EAOI,6CAAA;EAAA,iEAAA;EAAA,4CAAA;EAAA,gEAAA;AxEy5RZ;;AwEh6RQ;EAOI,2CAAA;EAAA,iEAAA;EAAA,0CAAA;EAAA,gEAAA;AxE85RZ;;AwEr6RQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,0CAAA;EAAA,iEAAA;AxEm6RZ;;AwE16RQ;EAOI,0CAAA;EAAA,yCAAA;AxEw6RZ;;AwE/6RQ;EAOI,4CAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,kEAAA;AxE66RZ;;AwEp7RQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEk7RZ;;AwEz7RQ;EAOI,uCAAA;EAAA,oCAAA;AxEu7RZ;;AwE97RQ;EAOI,6CAAA;EAAA,gEAAA;EAAA,0CAAA;EAAA,6DAAA;AxE47RZ;;AwEn8RQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEi8RZ;;AwEx8RQ;EAOI,4CAAA;EAAA,gEAAA;EAAA,yCAAA;EAAA,6DAAA;AxEs8RZ;;AwE78RQ;EAOI,0CAAA;EAAA,gEAAA;EAAA,uCAAA;EAAA,6DAAA;AxE28RZ;;AwEl9RQ;EAOI,0CAAA;EAAA,iEAAA;EAAA,uCAAA;EAAA,8DAAA;AxEg9RZ;;AwEv9RQ;EAOI,yCAAA;EAAA,sCAAA;AxEq9RZ;;AwE59RQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,wCAAA;EAAA,+DAAA;AxE09RZ;;AwEj+RQ;EAOI,8BAAA;AxE89RZ;;AwEr+RQ;EAOI,6BAAA;AxEk+RZ;;AwEz+RQ;EAOI,sBAAA;AxEs+RZ;;AwE7+RQ;EAOI,qBAAA;AxE0+RZ;;AwEj/RQ;EAOI,qBAAA;AxE8+RZ;;AwEr/RQ;EAOI,qBAAA;AxEk/RZ;;AwEz/RQ;EAOI,qBAAA;AxEs/RZ;;AchgSI;E0DGI;IAOI,sBAAA;ExE2/RV;EwElgSM;IAOI,uBAAA;ExE8/RV;EwErgSM;IAOI,sBAAA;ExEigSV;EwExgSM;IAOI,8BAAA;ExEogSV;EwE3gSM;IAOI,4BAAA;ExEugSV;EwE9gSM;IAOI,2BAAA;ExE0gSV;EwEjhSM;IAOI,iCAAA;ExE6gSV;EwEphSM;IAOI,2BAAA;ExEghSV;EwEvhSM;IAOI,0BAAA;ExEmhSV;EwE1hSM;IAOI,gCAAA;ExEshSV;EwE7hSM;IAOI,yBAAA;ExEyhSV;EwEhiSM;IAOI,wBAAA;ExE4hSV;EwEniSM;IAOI,+BAAA;ExE+hSV;EwEtiSM;IAOI,yBAAA;ExEkiSV;EwEziSM;IAOI,6BAAA;ExEqiSV;EwE5iSM;IAOI,8BAAA;ExEwiSV;EwE/iSM;IAOI,wBAAA;ExE2iSV;EwEljSM;IAOI,+BAAA;ExE8iSV;EwErjSM;IAOI,wBAAA;ExEijSV;EwExjSM;IAOI,yBAAA;ExEojSV;EwE3jSM;IAOI,8BAAA;ExEujSV;EwE9jSM;IAOI,iCAAA;ExE0jSV;EwEjkSM;IAOI,sCAAA;ExE6jSV;EwEpkSM;IAOI,yCAAA;ExEgkSV;EwEvkSM;IAOI,uBAAA;ExEmkSV;EwE1kSM;IAOI,uBAAA;ExEskSV;EwE7kSM;IAOI,yBAAA;ExEykSV;EwEhlSM;IAOI,yBAAA;ExE4kSV;EwEnlSM;IAOI,0BAAA;ExE+kSV;EwEtlSM;IAOI,4BAAA;ExEklSV;EwEzlSM;IAOI,kCAAA;ExEqlSV;EwE5lSM;IAOI,sCAAA;ExEwlSV;EwE/lSM;IAOI,oCAAA;ExE2lSV;EwElmSM;IAOI,kCAAA;ExE8lSV;EwErmSM;IAOI,yCAAA;ExEimSV;EwExmSM;IAOI,wCAAA;ExEomSV;EwE3mSM;IAOI,wCAAA;ExEumSV;EwE9mSM;IAOI,kCAAA;ExE0mSV;EwEjnSM;IAOI,gCAAA;ExE6mSV;EwEpnSM;IAOI,8BAAA;ExEgnSV;EwEvnSM;IAOI,gCAAA;ExEmnSV;EwE1nSM;IAOI,+BAAA;ExEsnSV;EwE7nSM;IAOI,oCAAA;ExEynSV;EwEhoSM;IAOI,kCAAA;ExE4nSV;EwEnoSM;IAOI,gCAAA;ExE+nSV;EwEtoSM;IAOI,uCAAA;ExEkoSV;EwEzoSM;IAOI,sCAAA;ExEqoSV;EwE5oSM;IAOI,iCAAA;ExEwoSV;EwE/oSM;IAOI,2BAAA;ExE2oSV;EwElpSM;IAOI,iCAAA;ExE8oSV;EwErpSM;IAOI,+BAAA;ExEipSV;EwExpSM;IAOI,6BAAA;ExEopSV;EwE3pSM;IAOI,+BAAA;ExEupSV;EwE9pSM;IAOI,8BAAA;ExE0pSV;EwEjqSM;IAOI,oBAAA;ExE6pSV;EwEpqSM;IAOI,mBAAA;ExEgqSV;EwEvqSM;IAOI,mBAAA;ExEmqSV;EwE1qSM;IAOI,mBAAA;ExEsqSV;EwE7qSM;IAOI,mBAAA;ExEyqSV;EwEhrSM;IAOI,mBAAA;ExE4qSV;EwEnrSM;IAOI,mBAAA;ExE+qSV;EwEtrSM;IAOI,mBAAA;ExEkrSV;EwEzrSM;IAOI,oBAAA;ExEqrSV;EwE5rSM;IAOI,0BAAA;ExEwrSV;EwE/rSM;IAOI,yBAAA;ExE2rSV;EwElsSM;IAOI,uBAAA;ExE8rSV;EwErsSM;IAOI,yBAAA;ExEisSV;EwExsSM;IAOI,uBAAA;ExEosSV;EwE3sSM;IAOI,uBAAA;ExEusSV;EwE9sSM;IAOI,0BAAA;IAAA,yBAAA;ExE2sSV;EwEltSM;IAOI,gCAAA;IAAA,+BAAA;ExE+sSV;EwEttSM;IAOI,+BAAA;IAAA,8BAAA;ExEmtSV;EwE1tSM;IAOI,6BAAA;IAAA,4BAAA;ExEutSV;EwE9tSM;IAOI,+BAAA;IAAA,8BAAA;ExE2tSV;EwEluSM;IAOI,6BAAA;IAAA,4BAAA;ExE+tSV;EwEtuSM;IAOI,6BAAA;IAAA,4BAAA;ExEmuSV;EwE1uSM;IAOI,wBAAA;IAAA,2BAAA;ExEuuSV;EwE9uSM;IAOI,8BAAA;IAAA,iCAAA;ExE2uSV;EwElvSM;IAOI,6BAAA;IAAA,gCAAA;ExE+uSV;EwEtvSM;IAOI,2BAAA;IAAA,8BAAA;ExEmvSV;EwE1vSM;IAOI,6BAAA;IAAA,gCAAA;ExEuvSV;EwE9vSM;IAOI,2BAAA;IAAA,8BAAA;ExE2vSV;EwElwSM;IAOI,2BAAA;IAAA,8BAAA;ExE+vSV;EwEtwSM;IAOI,wBAAA;ExEkwSV;EwEzwSM;IAOI,8BAAA;ExEqwSV;EwE5wSM;IAOI,6BAAA;ExEwwSV;EwE/wSM;IAOI,2BAAA;ExE2wSV;EwElxSM;IAOI,6BAAA;ExE8wSV;EwErxSM;IAOI,2BAAA;ExEixSV;EwExxSM;IAOI,2BAAA;ExEoxSV;EwE3xSM;IAOI,0BAAA;ExEuxSV;EwE9xSM;IAOI,gCAAA;ExE0xSV;EwEjySM;IAOI,+BAAA;ExE6xSV;EwEpySM;IAOI,6BAAA;ExEgySV;EwEvySM;IAOI,+BAAA;ExEmySV;EwE1ySM;IAOI,6BAAA;ExEsySV;EwE7ySM;IAOI,6BAAA;ExEyySV;EwEhzSM;IAOI,2BAAA;ExE4ySV;EwEnzSM;IAOI,iCAAA;ExE+ySV;EwEtzSM;IAOI,gCAAA;ExEkzSV;EwEzzSM;IAOI,8BAAA;ExEqzSV;EwE5zSM;IAOI,gCAAA;ExEwzSV;EwE/zSM;IAOI,8BAAA;ExE2zSV;EwEl0SM;IAOI,8BAAA;ExE8zSV;EwEr0SM;IAOI,yBAAA;ExEi0SV;EwEx0SM;IAOI,+BAAA;ExEo0SV;EwE30SM;IAOI,8BAAA;ExEu0SV;EwE90SM;IAOI,4BAAA;ExE00SV;EwEj1SM;IAOI,8BAAA;ExE60SV;EwEp1SM;IAOI,4BAAA;ExEg1SV;EwEv1SM;IAOI,4BAAA;ExEm1SV;EwE11SM;IAOI,qBAAA;ExEs1SV;EwE71SM;IAOI,2BAAA;ExEy1SV;EwEh2SM;IAOI,0BAAA;ExE41SV;EwEn2SM;IAOI,wBAAA;ExE+1SV;EwEt2SM;IAOI,0BAAA;ExEk2SV;EwEz2SM;IAOI,wBAAA;ExEq2SV;EwE52SM;IAOI,2BAAA;IAAA,0BAAA;ExEy2SV;EwEh3SM;IAOI,iCAAA;IAAA,gCAAA;ExE62SV;EwEp3SM;IAOI,gCAAA;IAAA,+BAAA;ExEi3SV;EwEx3SM;IAOI,8BAAA;IAAA,6BAAA;ExEq3SV;EwE53SM;IAOI,gCAAA;IAAA,+BAAA;ExEy3SV;EwEh4SM;IAOI,8BAAA;IAAA,6BAAA;ExE63SV;EwEp4SM;IAOI,yBAAA;IAAA,4BAAA;ExEi4SV;EwEx4SM;IAOI,+BAAA;IAAA,kCAAA;ExEq4SV;EwE54SM;IAOI,8BAAA;IAAA,iCAAA;ExEy4SV;EwEh5SM;IAOI,4BAAA;IAAA,+BAAA;ExE64SV;EwEp5SM;IAOI,8BAAA;IAAA,iCAAA;ExEi5SV;EwEx5SM;IAOI,4BAAA;IAAA,+BAAA;ExEq5SV;EwE55SM;IAOI,yBAAA;ExEw5SV;EwE/5SM;IAOI,+BAAA;ExE25SV;EwEl6SM;IAOI,8BAAA;ExE85SV;EwEr6SM;IAOI,4BAAA;ExEi6SV;EwEx6SM;IAOI,8BAAA;ExEo6SV;EwE36SM;IAOI,4BAAA;ExEu6SV;EwE96SM;IAOI,2BAAA;ExE06SV;EwEj7SM;IAOI,iCAAA;ExE66SV;EwEp7SM;IAOI,gCAAA;ExEg7SV;EwEv7SM;IAOI,8BAAA;ExEm7SV;EwE17SM;IAOI,gCAAA;ExEs7SV;EwE77SM;IAOI,8BAAA;ExEy7SV;EwEh8SM;IAOI,4BAAA;ExE47SV;EwEn8SM;IAOI,kCAAA;ExE+7SV;EwEt8SM;IAOI,iCAAA;ExEk8SV;EwEz8SM;IAOI,+BAAA;ExEq8SV;EwE58SM;IAOI,iCAAA;ExEw8SV;EwE/8SM;IAOI,+BAAA;ExE28SV;EwEl9SM;IAOI,0BAAA;ExE88SV;EwEr9SM;IAOI,gCAAA;ExEi9SV;EwEx9SM;IAOI,+BAAA;ExEo9SV;EwE39SM;IAOI,6BAAA;ExEu9SV;EwE99SM;IAOI,+BAAA;ExE09SV;EwEj+SM;IAOI,6BAAA;ExE69SV;EwEp+SM;IAOI,iBAAA;ExEg+SV;EwEv+SM;IAOI,uBAAA;ExEm+SV;EwE1+SM;IAOI,sBAAA;ExEs+SV;EwE7+SM;IAOI,oBAAA;ExEy+SV;EwEh/SM;IAOI,sBAAA;ExE4+SV;EwEn/SM;IAOI,oBAAA;ExE++SV;EwEt/SM;IAOI,qBAAA;ExEk/SV;EwEz/SM;IAOI,2BAAA;ExEq/SV;EwE5/SM;IAOI,0BAAA;ExEw/SV;EwE//SM;IAOI,wBAAA;ExE2/SV;EwElgTM;IAOI,0BAAA;ExE8/SV;EwErgTM;IAOI,wBAAA;ExEigTV;EwExgTM;IAOI,wBAAA;ExEogTV;EwE3gTM;IAOI,8BAAA;ExEugTV;EwE9gTM;IAOI,6BAAA;ExE0gTV;EwEjhTM;IAOI,2BAAA;ExE6gTV;EwEphTM;IAOI,6BAAA;ExEghTV;EwEvhTM;IAOI,2BAAA;ExEmhTV;EwE1hTM;IAOI,2BAAA;ExEshTV;EwE7hTM;IAOI,4BAAA;ExEyhTV;EwEhiTM;IAOI,6BAAA;ExE4hTV;AACF;AcviTI;E0DGI;IAOI,sBAAA;ExEiiTV;EwExiTM;IAOI,uBAAA;ExEoiTV;EwE3iTM;IAOI,sBAAA;ExEuiTV;EwE9iTM;IAOI,8BAAA;ExE0iTV;EwEjjTM;IAOI,4BAAA;ExE6iTV;EwEpjTM;IAOI,2BAAA;ExEgjTV;EwEvjTM;IAOI,iCAAA;ExEmjTV;EwE1jTM;IAOI,2BAAA;ExEsjTV;EwE7jTM;IAOI,0BAAA;ExEyjTV;EwEhkTM;IAOI,gCAAA;ExE4jTV;EwEnkTM;IAOI,yBAAA;ExE+jTV;EwEtkTM;IAOI,wBAAA;ExEkkTV;EwEzkTM;IAOI,+BAAA;ExEqkTV;EwE5kTM;IAOI,yBAAA;ExEwkTV;EwE/kTM;IAOI,6BAAA;ExE2kTV;EwEllTM;IAOI,8BAAA;ExE8kTV;EwErlTM;IAOI,wBAAA;ExEilTV;EwExlTM;IAOI,+BAAA;ExEolTV;EwE3lTM;IAOI,wBAAA;ExEulTV;EwE9lTM;IAOI,yBAAA;ExE0lTV;EwEjmTM;IAOI,8BAAA;ExE6lTV;EwEpmTM;IAOI,iCAAA;ExEgmTV;EwEvmTM;IAOI,sCAAA;ExEmmTV;EwE1mTM;IAOI,yCAAA;ExEsmTV;EwE7mTM;IAOI,uBAAA;ExEymTV;EwEhnTM;IAOI,uBAAA;ExE4mTV;EwEnnTM;IAOI,yBAAA;ExE+mTV;EwEtnTM;IAOI,yBAAA;ExEknTV;EwEznTM;IAOI,0BAAA;ExEqnTV;EwE5nTM;IAOI,4BAAA;ExEwnTV;EwE/nTM;IAOI,kCAAA;ExE2nTV;EwEloTM;IAOI,sCAAA;ExE8nTV;EwEroTM;IAOI,oCAAA;ExEioTV;EwExoTM;IAOI,kCAAA;ExEooTV;EwE3oTM;IAOI,yCAAA;ExEuoTV;EwE9oTM;IAOI,wCAAA;ExE0oTV;EwEjpTM;IAOI,wCAAA;ExE6oTV;EwEppTM;IAOI,kCAAA;ExEgpTV;EwEvpTM;IAOI,gCAAA;ExEmpTV;EwE1pTM;IAOI,8BAAA;ExEspTV;EwE7pTM;IAOI,gCAAA;ExEypTV;EwEhqTM;IAOI,+BAAA;ExE4pTV;EwEnqTM;IAOI,oCAAA;ExE+pTV;EwEtqTM;IAOI,kCAAA;ExEkqTV;EwEzqTM;IAOI,gCAAA;ExEqqTV;EwE5qTM;IAOI,uCAAA;ExEwqTV;EwE/qTM;IAOI,sCAAA;ExE2qTV;EwElrTM;IAOI,iCAAA;ExE8qTV;EwErrTM;IAOI,2BAAA;ExEirTV;EwExrTM;IAOI,iCAAA;ExEorTV;EwE3rTM;IAOI,+BAAA;ExEurTV;EwE9rTM;IAOI,6BAAA;ExE0rTV;EwEjsTM;IAOI,+BAAA;ExE6rTV;EwEpsTM;IAOI,8BAAA;ExEgsTV;EwEvsTM;IAOI,oBAAA;ExEmsTV;EwE1sTM;IAOI,mBAAA;ExEssTV;EwE7sTM;IAOI,mBAAA;ExEysTV;EwEhtTM;IAOI,mBAAA;ExE4sTV;EwEntTM;IAOI,mBAAA;ExE+sTV;EwEttTM;IAOI,mBAAA;ExEktTV;EwEztTM;IAOI,mBAAA;ExEqtTV;EwE5tTM;IAOI,mBAAA;ExEwtTV;EwE/tTM;IAOI,oBAAA;ExE2tTV;EwEluTM;IAOI,0BAAA;ExE8tTV;EwEruTM;IAOI,yBAAA;ExEiuTV;EwExuTM;IAOI,uBAAA;ExEouTV;EwE3uTM;IAOI,yBAAA;ExEuuTV;EwE9uTM;IAOI,uBAAA;ExE0uTV;EwEjvTM;IAOI,uBAAA;ExE6uTV;EwEpvTM;IAOI,0BAAA;IAAA,yBAAA;ExEivTV;EwExvTM;IAOI,gCAAA;IAAA,+BAAA;ExEqvTV;EwE5vTM;IAOI,+BAAA;IAAA,8BAAA;ExEyvTV;EwEhwTM;IAOI,6BAAA;IAAA,4BAAA;ExE6vTV;EwEpwTM;IAOI,+BAAA;IAAA,8BAAA;ExEiwTV;EwExwTM;IAOI,6BAAA;IAAA,4BAAA;ExEqwTV;EwE5wTM;IAOI,6BAAA;IAAA,4BAAA;ExEywTV;EwEhxTM;IAOI,wBAAA;IAAA,2BAAA;ExE6wTV;EwEpxTM;IAOI,8BAAA;IAAA,iCAAA;ExEixTV;EwExxTM;IAOI,6BAAA;IAAA,gCAAA;ExEqxTV;EwE5xTM;IAOI,2BAAA;IAAA,8BAAA;ExEyxTV;EwEhyTM;IAOI,6BAAA;IAAA,gCAAA;ExE6xTV;EwEpyTM;IAOI,2BAAA;IAAA,8BAAA;ExEiyTV;EwExyTM;IAOI,2BAAA;IAAA,8BAAA;ExEqyTV;EwE5yTM;IAOI,wBAAA;ExEwyTV;EwE/yTM;IAOI,8BAAA;ExE2yTV;EwElzTM;IAOI,6BAAA;ExE8yTV;EwErzTM;IAOI,2BAAA;ExEizTV;EwExzTM;IAOI,6BAAA;ExEozTV;EwE3zTM;IAOI,2BAAA;ExEuzTV;EwE9zTM;IAOI,2BAAA;ExE0zTV;EwEj0TM;IAOI,0BAAA;ExE6zTV;EwEp0TM;IAOI,gCAAA;ExEg0TV;EwEv0TM;IAOI,+BAAA;ExEm0TV;EwE10TM;IAOI,6BAAA;ExEs0TV;EwE70TM;IAOI,+BAAA;ExEy0TV;EwEh1TM;IAOI,6BAAA;ExE40TV;EwEn1TM;IAOI,6BAAA;ExE+0TV;EwEt1TM;IAOI,2BAAA;ExEk1TV;EwEz1TM;IAOI,iCAAA;ExEq1TV;EwE51TM;IAOI,gCAAA;ExEw1TV;EwE/1TM;IAOI,8BAAA;ExE21TV;EwEl2TM;IAOI,gCAAA;ExE81TV;EwEr2TM;IAOI,8BAAA;ExEi2TV;EwEx2TM;IAOI,8BAAA;ExEo2TV;EwE32TM;IAOI,yBAAA;ExEu2TV;EwE92TM;IAOI,+BAAA;ExE02TV;EwEj3TM;IAOI,8BAAA;ExE62TV;EwEp3TM;IAOI,4BAAA;ExEg3TV;EwEv3TM;IAOI,8BAAA;ExEm3TV;EwE13TM;IAOI,4BAAA;ExEs3TV;EwE73TM;IAOI,4BAAA;ExEy3TV;EwEh4TM;IAOI,qBAAA;ExE43TV;EwEn4TM;IAOI,2BAAA;ExE+3TV;EwEt4TM;IAOI,0BAAA;ExEk4TV;EwEz4TM;IAOI,wBAAA;ExEq4TV;EwE54TM;IAOI,0BAAA;ExEw4TV;EwE/4TM;IAOI,wBAAA;ExE24TV;EwEl5TM;IAOI,2BAAA;IAAA,0BAAA;ExE+4TV;EwEt5TM;IAOI,iCAAA;IAAA,gCAAA;ExEm5TV;EwE15TM;IAOI,gCAAA;IAAA,+BAAA;ExEu5TV;EwE95TM;IAOI,8BAAA;IAAA,6BAAA;ExE25TV;EwEl6TM;IAOI,gCAAA;IAAA,+BAAA;ExE+5TV;EwEt6TM;IAOI,8BAAA;IAAA,6BAAA;ExEm6TV;EwE16TM;IAOI,yBAAA;IAAA,4BAAA;ExEu6TV;EwE96TM;IAOI,+BAAA;IAAA,kCAAA;ExE26TV;EwEl7TM;IAOI,8BAAA;IAAA,iCAAA;ExE+6TV;EwEt7TM;IAOI,4BAAA;IAAA,+BAAA;ExEm7TV;EwE17TM;IAOI,8BAAA;IAAA,iCAAA;ExEu7TV;EwE97TM;IAOI,4BAAA;IAAA,+BAAA;ExE27TV;EwEl8TM;IAOI,yBAAA;ExE87TV;EwEr8TM;IAOI,+BAAA;ExEi8TV;EwEx8TM;IAOI,8BAAA;ExEo8TV;EwE38TM;IAOI,4BAAA;ExEu8TV;EwE98TM;IAOI,8BAAA;ExE08TV;EwEj9TM;IAOI,4BAAA;ExE68TV;EwEp9TM;IAOI,2BAAA;ExEg9TV;EwEv9TM;IAOI,iCAAA;ExEm9TV;EwE19TM;IAOI,gCAAA;ExEs9TV;EwE79TM;IAOI,8BAAA;ExEy9TV;EwEh+TM;IAOI,gCAAA;ExE49TV;EwEn+TM;IAOI,8BAAA;ExE+9TV;EwEt+TM;IAOI,4BAAA;ExEk+TV;EwEz+TM;IAOI,kCAAA;ExEq+TV;EwE5+TM;IAOI,iCAAA;ExEw+TV;EwE/+TM;IAOI,+BAAA;ExE2+TV;EwEl/TM;IAOI,iCAAA;ExE8+TV;EwEr/TM;IAOI,+BAAA;ExEi/TV;EwEx/TM;IAOI,0BAAA;ExEo/TV;EwE3/TM;IAOI,gCAAA;ExEu/TV;EwE9/TM;IAOI,+BAAA;ExE0/TV;EwEjgUM;IAOI,6BAAA;ExE6/TV;EwEpgUM;IAOI,+BAAA;ExEggUV;EwEvgUM;IAOI,6BAAA;ExEmgUV;EwE1gUM;IAOI,iBAAA;ExEsgUV;EwE7gUM;IAOI,uBAAA;ExEygUV;EwEhhUM;IAOI,sBAAA;ExE4gUV;EwEnhUM;IAOI,oBAAA;ExE+gUV;EwEthUM;IAOI,sBAAA;ExEkhUV;EwEzhUM;IAOI,oBAAA;ExEqhUV;EwE5hUM;IAOI,qBAAA;ExEwhUV;EwE/hUM;IAOI,2BAAA;ExE2hUV;EwEliUM;IAOI,0BAAA;ExE8hUV;EwEriUM;IAOI,wBAAA;ExEiiUV;EwExiUM;IAOI,0BAAA;ExEoiUV;EwE3iUM;IAOI,wBAAA;ExEuiUV;EwE9iUM;IAOI,wBAAA;ExE0iUV;EwEjjUM;IAOI,8BAAA;ExE6iUV;EwEpjUM;IAOI,6BAAA;ExEgjUV;EwEvjUM;IAOI,2BAAA;ExEmjUV;EwE1jUM;IAOI,6BAAA;ExEsjUV;EwE7jUM;IAOI,2BAAA;ExEyjUV;EwEhkUM;IAOI,2BAAA;ExE4jUV;EwEnkUM;IAOI,4BAAA;ExE+jUV;EwEtkUM;IAOI,6BAAA;ExEkkUV;AACF;Ac7kUI;E0DGI;IAOI,sBAAA;ExEukUV;EwE9kUM;IAOI,uBAAA;ExE0kUV;EwEjlUM;IAOI,sBAAA;ExE6kUV;EwEplUM;IAOI,8BAAA;ExEglUV;EwEvlUM;IAOI,4BAAA;ExEmlUV;EwE1lUM;IAOI,2BAAA;ExEslUV;EwE7lUM;IAOI,iCAAA;ExEylUV;EwEhmUM;IAOI,2BAAA;ExE4lUV;EwEnmUM;IAOI,0BAAA;ExE+lUV;EwEtmUM;IAOI,gCAAA;ExEkmUV;EwEzmUM;IAOI,yBAAA;ExEqmUV;EwE5mUM;IAOI,wBAAA;ExEwmUV;EwE/mUM;IAOI,+BAAA;ExE2mUV;EwElnUM;IAOI,yBAAA;ExE8mUV;EwErnUM;IAOI,6BAAA;ExEinUV;EwExnUM;IAOI,8BAAA;ExEonUV;EwE3nUM;IAOI,wBAAA;ExEunUV;EwE9nUM;IAOI,+BAAA;ExE0nUV;EwEjoUM;IAOI,wBAAA;ExE6nUV;EwEpoUM;IAOI,yBAAA;ExEgoUV;EwEvoUM;IAOI,8BAAA;ExEmoUV;EwE1oUM;IAOI,iCAAA;ExEsoUV;EwE7oUM;IAOI,sCAAA;ExEyoUV;EwEhpUM;IAOI,yCAAA;ExE4oUV;EwEnpUM;IAOI,uBAAA;ExE+oUV;EwEtpUM;IAOI,uBAAA;ExEkpUV;EwEzpUM;IAOI,yBAAA;ExEqpUV;EwE5pUM;IAOI,yBAAA;ExEwpUV;EwE/pUM;IAOI,0BAAA;ExE2pUV;EwElqUM;IAOI,4BAAA;ExE8pUV;EwErqUM;IAOI,kCAAA;ExEiqUV;EwExqUM;IAOI,sCAAA;ExEoqUV;EwE3qUM;IAOI,oCAAA;ExEuqUV;EwE9qUM;IAOI,kCAAA;ExE0qUV;EwEjrUM;IAOI,yCAAA;ExE6qUV;EwEprUM;IAOI,wCAAA;ExEgrUV;EwEvrUM;IAOI,wCAAA;ExEmrUV;EwE1rUM;IAOI,kCAAA;ExEsrUV;EwE7rUM;IAOI,gCAAA;ExEyrUV;EwEhsUM;IAOI,8BAAA;ExE4rUV;EwEnsUM;IAOI,gCAAA;ExE+rUV;EwEtsUM;IAOI,+BAAA;ExEksUV;EwEzsUM;IAOI,oCAAA;ExEqsUV;EwE5sUM;IAOI,kCAAA;ExEwsUV;EwE/sUM;IAOI,gCAAA;ExE2sUV;EwEltUM;IAOI,uCAAA;ExE8sUV;EwErtUM;IAOI,sCAAA;ExEitUV;EwExtUM;IAOI,iCAAA;ExEotUV;EwE3tUM;IAOI,2BAAA;ExEutUV;EwE9tUM;IAOI,iCAAA;ExE0tUV;EwEjuUM;IAOI,+BAAA;ExE6tUV;EwEpuUM;IAOI,6BAAA;ExEguUV;EwEvuUM;IAOI,+BAAA;ExEmuUV;EwE1uUM;IAOI,8BAAA;ExEsuUV;EwE7uUM;IAOI,oBAAA;ExEyuUV;EwEhvUM;IAOI,mBAAA;ExE4uUV;EwEnvUM;IAOI,mBAAA;ExE+uUV;EwEtvUM;IAOI,mBAAA;ExEkvUV;EwEzvUM;IAOI,mBAAA;ExEqvUV;EwE5vUM;IAOI,mBAAA;ExEwvUV;EwE/vUM;IAOI,mBAAA;ExE2vUV;EwElwUM;IAOI,mBAAA;ExE8vUV;EwErwUM;IAOI,oBAAA;ExEiwUV;EwExwUM;IAOI,0BAAA;ExEowUV;EwE3wUM;IAOI,yBAAA;ExEuwUV;EwE9wUM;IAOI,uBAAA;ExE0wUV;EwEjxUM;IAOI,yBAAA;ExE6wUV;EwEpxUM;IAOI,uBAAA;ExEgxUV;EwEvxUM;IAOI,uBAAA;ExEmxUV;EwE1xUM;IAOI,0BAAA;IAAA,yBAAA;ExEuxUV;EwE9xUM;IAOI,gCAAA;IAAA,+BAAA;ExE2xUV;EwElyUM;IAOI,+BAAA;IAAA,8BAAA;ExE+xUV;EwEtyUM;IAOI,6BAAA;IAAA,4BAAA;ExEmyUV;EwE1yUM;IAOI,+BAAA;IAAA,8BAAA;ExEuyUV;EwE9yUM;IAOI,6BAAA;IAAA,4BAAA;ExE2yUV;EwElzUM;IAOI,6BAAA;IAAA,4BAAA;ExE+yUV;EwEtzUM;IAOI,wBAAA;IAAA,2BAAA;ExEmzUV;EwE1zUM;IAOI,8BAAA;IAAA,iCAAA;ExEuzUV;EwE9zUM;IAOI,6BAAA;IAAA,gCAAA;ExE2zUV;EwEl0UM;IAOI,2BAAA;IAAA,8BAAA;ExE+zUV;EwEt0UM;IAOI,6BAAA;IAAA,gCAAA;ExEm0UV;EwE10UM;IAOI,2BAAA;IAAA,8BAAA;ExEu0UV;EwE90UM;IAOI,2BAAA;IAAA,8BAAA;ExE20UV;EwEl1UM;IAOI,wBAAA;ExE80UV;EwEr1UM;IAOI,8BAAA;ExEi1UV;EwEx1UM;IAOI,6BAAA;ExEo1UV;EwE31UM;IAOI,2BAAA;ExEu1UV;EwE91UM;IAOI,6BAAA;ExE01UV;EwEj2UM;IAOI,2BAAA;ExE61UV;EwEp2UM;IAOI,2BAAA;ExEg2UV;EwEv2UM;IAOI,0BAAA;ExEm2UV;EwE12UM;IAOI,gCAAA;ExEs2UV;EwE72UM;IAOI,+BAAA;ExEy2UV;EwEh3UM;IAOI,6BAAA;ExE42UV;EwEn3UM;IAOI,+BAAA;ExE+2UV;EwEt3UM;IAOI,6BAAA;ExEk3UV;EwEz3UM;IAOI,6BAAA;ExEq3UV;EwE53UM;IAOI,2BAAA;ExEw3UV;EwE/3UM;IAOI,iCAAA;ExE23UV;EwEl4UM;IAOI,gCAAA;ExE83UV;EwEr4UM;IAOI,8BAAA;ExEi4UV;EwEx4UM;IAOI,gCAAA;ExEo4UV;EwE34UM;IAOI,8BAAA;ExEu4UV;EwE94UM;IAOI,8BAAA;ExE04UV;EwEj5UM;IAOI,yBAAA;ExE64UV;EwEp5UM;IAOI,+BAAA;ExEg5UV;EwEv5UM;IAOI,8BAAA;ExEm5UV;EwE15UM;IAOI,4BAAA;ExEs5UV;EwE75UM;IAOI,8BAAA;ExEy5UV;EwEh6UM;IAOI,4BAAA;ExE45UV;EwEn6UM;IAOI,4BAAA;ExE+5UV;EwEt6UM;IAOI,qBAAA;ExEk6UV;EwEz6UM;IAOI,2BAAA;ExEq6UV;EwE56UM;IAOI,0BAAA;ExEw6UV;EwE/6UM;IAOI,wBAAA;ExE26UV;EwEl7UM;IAOI,0BAAA;ExE86UV;EwEr7UM;IAOI,wBAAA;ExEi7UV;EwEx7UM;IAOI,2BAAA;IAAA,0BAAA;ExEq7UV;EwE57UM;IAOI,iCAAA;IAAA,gCAAA;ExEy7UV;EwEh8UM;IAOI,gCAAA;IAAA,+BAAA;ExE67UV;EwEp8UM;IAOI,8BAAA;IAAA,6BAAA;ExEi8UV;EwEx8UM;IAOI,gCAAA;IAAA,+BAAA;ExEq8UV;EwE58UM;IAOI,8BAAA;IAAA,6BAAA;ExEy8UV;EwEh9UM;IAOI,yBAAA;IAAA,4BAAA;ExE68UV;EwEp9UM;IAOI,+BAAA;IAAA,kCAAA;ExEi9UV;EwEx9UM;IAOI,8BAAA;IAAA,iCAAA;ExEq9UV;EwE59UM;IAOI,4BAAA;IAAA,+BAAA;ExEy9UV;EwEh+UM;IAOI,8BAAA;IAAA,iCAAA;ExE69UV;EwEp+UM;IAOI,4BAAA;IAAA,+BAAA;ExEi+UV;EwEx+UM;IAOI,yBAAA;ExEo+UV;EwE3+UM;IAOI,+BAAA;ExEu+UV;EwE9+UM;IAOI,8BAAA;ExE0+UV;EwEj/UM;IAOI,4BAAA;ExE6+UV;EwEp/UM;IAOI,8BAAA;ExEg/UV;EwEv/UM;IAOI,4BAAA;ExEm/UV;EwE1/UM;IAOI,2BAAA;ExEs/UV;EwE7/UM;IAOI,iCAAA;ExEy/UV;EwEhgVM;IAOI,gCAAA;ExE4/UV;EwEngVM;IAOI,8BAAA;ExE+/UV;EwEtgVM;IAOI,gCAAA;ExEkgVV;EwEzgVM;IAOI,8BAAA;ExEqgVV;EwE5gVM;IAOI,4BAAA;ExEwgVV;EwE/gVM;IAOI,kCAAA;ExE2gVV;EwElhVM;IAOI,iCAAA;ExE8gVV;EwErhVM;IAOI,+BAAA;ExEihVV;EwExhVM;IAOI,iCAAA;ExEohVV;EwE3hVM;IAOI,+BAAA;ExEuhVV;EwE9hVM;IAOI,0BAAA;ExE0hVV;EwEjiVM;IAOI,gCAAA;ExE6hVV;EwEpiVM;IAOI,+BAAA;ExEgiVV;EwEviVM;IAOI,6BAAA;ExEmiVV;EwE1iVM;IAOI,+BAAA;ExEsiVV;EwE7iVM;IAOI,6BAAA;ExEyiVV;EwEhjVM;IAOI,iBAAA;ExE4iVV;EwEnjVM;IAOI,uBAAA;ExE+iVV;EwEtjVM;IAOI,sBAAA;ExEkjVV;EwEzjVM;IAOI,oBAAA;ExEqjVV;EwE5jVM;IAOI,sBAAA;ExEwjVV;EwE/jVM;IAOI,oBAAA;ExE2jVV;EwElkVM;IAOI,qBAAA;ExE8jVV;EwErkVM;IAOI,2BAAA;ExEikVV;EwExkVM;IAOI,0BAAA;ExEokVV;EwE3kVM;IAOI,wBAAA;ExEukVV;EwE9kVM;IAOI,0BAAA;ExE0kVV;EwEjlVM;IAOI,wBAAA;ExE6kVV;EwEplVM;IAOI,wBAAA;ExEglVV;EwEvlVM;IAOI,8BAAA;ExEmlVV;EwE1lVM;IAOI,6BAAA;ExEslVV;EwE7lVM;IAOI,2BAAA;ExEylVV;EwEhmVM;IAOI,6BAAA;ExE4lVV;EwEnmVM;IAOI,2BAAA;ExE+lVV;EwEtmVM;IAOI,2BAAA;ExEkmVV;EwEzmVM;IAOI,4BAAA;ExEqmVV;EwE5mVM;IAOI,6BAAA;ExEwmVV;AACF;AcnnVI;E0DGI;IAOI,sBAAA;ExE6mVV;EwEpnVM;IAOI,uBAAA;ExEgnVV;EwEvnVM;IAOI,sBAAA;ExEmnVV;EwE1nVM;IAOI,8BAAA;ExEsnVV;EwE7nVM;IAOI,4BAAA;ExEynVV;EwEhoVM;IAOI,2BAAA;ExE4nVV;EwEnoVM;IAOI,iCAAA;ExE+nVV;EwEtoVM;IAOI,2BAAA;ExEkoVV;EwEzoVM;IAOI,0BAAA;ExEqoVV;EwE5oVM;IAOI,gCAAA;ExEwoVV;EwE/oVM;IAOI,yBAAA;ExE2oVV;EwElpVM;IAOI,wBAAA;ExE8oVV;EwErpVM;IAOI,+BAAA;ExEipVV;EwExpVM;IAOI,yBAAA;ExEopVV;EwE3pVM;IAOI,6BAAA;ExEupVV;EwE9pVM;IAOI,8BAAA;ExE0pVV;EwEjqVM;IAOI,wBAAA;ExE6pVV;EwEpqVM;IAOI,+BAAA;ExEgqVV;EwEvqVM;IAOI,wBAAA;ExEmqVV;EwE1qVM;IAOI,yBAAA;ExEsqVV;EwE7qVM;IAOI,8BAAA;ExEyqVV;EwEhrVM;IAOI,iCAAA;ExE4qVV;EwEnrVM;IAOI,sCAAA;ExE+qVV;EwEtrVM;IAOI,yCAAA;ExEkrVV;EwEzrVM;IAOI,uBAAA;ExEqrVV;EwE5rVM;IAOI,uBAAA;ExEwrVV;EwE/rVM;IAOI,yBAAA;ExE2rVV;EwElsVM;IAOI,yBAAA;ExE8rVV;EwErsVM;IAOI,0BAAA;ExEisVV;EwExsVM;IAOI,4BAAA;ExEosVV;EwE3sVM;IAOI,kCAAA;ExEusVV;EwE9sVM;IAOI,sCAAA;ExE0sVV;EwEjtVM;IAOI,oCAAA;ExE6sVV;EwEptVM;IAOI,kCAAA;ExEgtVV;EwEvtVM;IAOI,yCAAA;ExEmtVV;EwE1tVM;IAOI,wCAAA;ExEstVV;EwE7tVM;IAOI,wCAAA;ExEytVV;EwEhuVM;IAOI,kCAAA;ExE4tVV;EwEnuVM;IAOI,gCAAA;ExE+tVV;EwEtuVM;IAOI,8BAAA;ExEkuVV;EwEzuVM;IAOI,gCAAA;ExEquVV;EwE5uVM;IAOI,+BAAA;ExEwuVV;EwE/uVM;IAOI,oCAAA;ExE2uVV;EwElvVM;IAOI,kCAAA;ExE8uVV;EwErvVM;IAOI,gCAAA;ExEivVV;EwExvVM;IAOI,uCAAA;ExEovVV;EwE3vVM;IAOI,sCAAA;ExEuvVV;EwE9vVM;IAOI,iCAAA;ExE0vVV;EwEjwVM;IAOI,2BAAA;ExE6vVV;EwEpwVM;IAOI,iCAAA;ExEgwVV;EwEvwVM;IAOI,+BAAA;ExEmwVV;EwE1wVM;IAOI,6BAAA;ExEswVV;EwE7wVM;IAOI,+BAAA;ExEywVV;EwEhxVM;IAOI,8BAAA;ExE4wVV;EwEnxVM;IAOI,oBAAA;ExE+wVV;EwEtxVM;IAOI,mBAAA;ExEkxVV;EwEzxVM;IAOI,mBAAA;ExEqxVV;EwE5xVM;IAOI,mBAAA;ExEwxVV;EwE/xVM;IAOI,mBAAA;ExE2xVV;EwElyVM;IAOI,mBAAA;ExE8xVV;EwEryVM;IAOI,mBAAA;ExEiyVV;EwExyVM;IAOI,mBAAA;ExEoyVV;EwE3yVM;IAOI,oBAAA;ExEuyVV;EwE9yVM;IAOI,0BAAA;ExE0yVV;EwEjzVM;IAOI,yBAAA;ExE6yVV;EwEpzVM;IAOI,uBAAA;ExEgzVV;EwEvzVM;IAOI,yBAAA;ExEmzVV;EwE1zVM;IAOI,uBAAA;ExEszVV;EwE7zVM;IAOI,uBAAA;ExEyzVV;EwEh0VM;IAOI,0BAAA;IAAA,yBAAA;ExE6zVV;EwEp0VM;IAOI,gCAAA;IAAA,+BAAA;ExEi0VV;EwEx0VM;IAOI,+BAAA;IAAA,8BAAA;ExEq0VV;EwE50VM;IAOI,6BAAA;IAAA,4BAAA;ExEy0VV;EwEh1VM;IAOI,+BAAA;IAAA,8BAAA;ExE60VV;EwEp1VM;IAOI,6BAAA;IAAA,4BAAA;ExEi1VV;EwEx1VM;IAOI,6BAAA;IAAA,4BAAA;ExEq1VV;EwE51VM;IAOI,wBAAA;IAAA,2BAAA;ExEy1VV;EwEh2VM;IAOI,8BAAA;IAAA,iCAAA;ExE61VV;EwEp2VM;IAOI,6BAAA;IAAA,gCAAA;ExEi2VV;EwEx2VM;IAOI,2BAAA;IAAA,8BAAA;ExEq2VV;EwE52VM;IAOI,6BAAA;IAAA,gCAAA;ExEy2VV;EwEh3VM;IAOI,2BAAA;IAAA,8BAAA;ExE62VV;EwEp3VM;IAOI,2BAAA;IAAA,8BAAA;ExEi3VV;EwEx3VM;IAOI,wBAAA;ExEo3VV;EwE33VM;IAOI,8BAAA;ExEu3VV;EwE93VM;IAOI,6BAAA;ExE03VV;EwEj4VM;IAOI,2BAAA;ExE63VV;EwEp4VM;IAOI,6BAAA;ExEg4VV;EwEv4VM;IAOI,2BAAA;ExEm4VV;EwE14VM;IAOI,2BAAA;ExEs4VV;EwE74VM;IAOI,0BAAA;ExEy4VV;EwEh5VM;IAOI,gCAAA;ExE44VV;EwEn5VM;IAOI,+BAAA;ExE+4VV;EwEt5VM;IAOI,6BAAA;ExEk5VV;EwEz5VM;IAOI,+BAAA;ExEq5VV;EwE55VM;IAOI,6BAAA;ExEw5VV;EwE/5VM;IAOI,6BAAA;ExE25VV;EwEl6VM;IAOI,2BAAA;ExE85VV;EwEr6VM;IAOI,iCAAA;ExEi6VV;EwEx6VM;IAOI,gCAAA;ExEo6VV;EwE36VM;IAOI,8BAAA;ExEu6VV;EwE96VM;IAOI,gCAAA;ExE06VV;EwEj7VM;IAOI,8BAAA;ExE66VV;EwEp7VM;IAOI,8BAAA;ExEg7VV;EwEv7VM;IAOI,yBAAA;ExEm7VV;EwE17VM;IAOI,+BAAA;ExEs7VV;EwE77VM;IAOI,8BAAA;ExEy7VV;EwEh8VM;IAOI,4BAAA;ExE47VV;EwEn8VM;IAOI,8BAAA;ExE+7VV;EwEt8VM;IAOI,4BAAA;ExEk8VV;EwEz8VM;IAOI,4BAAA;ExEq8VV;EwE58VM;IAOI,qBAAA;ExEw8VV;EwE/8VM;IAOI,2BAAA;ExE28VV;EwEl9VM;IAOI,0BAAA;ExE88VV;EwEr9VM;IAOI,wBAAA;ExEi9VV;EwEx9VM;IAOI,0BAAA;ExEo9VV;EwE39VM;IAOI,wBAAA;ExEu9VV;EwE99VM;IAOI,2BAAA;IAAA,0BAAA;ExE29VV;EwEl+VM;IAOI,iCAAA;IAAA,gCAAA;ExE+9VV;EwEt+VM;IAOI,gCAAA;IAAA,+BAAA;ExEm+VV;EwE1+VM;IAOI,8BAAA;IAAA,6BAAA;ExEu+VV;EwE9+VM;IAOI,gCAAA;IAAA,+BAAA;ExE2+VV;EwEl/VM;IAOI,8BAAA;IAAA,6BAAA;ExE++VV;EwEt/VM;IAOI,yBAAA;IAAA,4BAAA;ExEm/VV;EwE1/VM;IAOI,+BAAA;IAAA,kCAAA;ExEu/VV;EwE9/VM;IAOI,8BAAA;IAAA,iCAAA;ExE2/VV;EwElgWM;IAOI,4BAAA;IAAA,+BAAA;ExE+/VV;EwEtgWM;IAOI,8BAAA;IAAA,iCAAA;ExEmgWV;EwE1gWM;IAOI,4BAAA;IAAA,+BAAA;ExEugWV;EwE9gWM;IAOI,yBAAA;ExE0gWV;EwEjhWM;IAOI,+BAAA;ExE6gWV;EwEphWM;IAOI,8BAAA;ExEghWV;EwEvhWM;IAOI,4BAAA;ExEmhWV;EwE1hWM;IAOI,8BAAA;ExEshWV;EwE7hWM;IAOI,4BAAA;ExEyhWV;EwEhiWM;IAOI,2BAAA;ExE4hWV;EwEniWM;IAOI,iCAAA;ExE+hWV;EwEtiWM;IAOI,gCAAA;ExEkiWV;EwEziWM;IAOI,8BAAA;ExEqiWV;EwE5iWM;IAOI,gCAAA;ExEwiWV;EwE/iWM;IAOI,8BAAA;ExE2iWV;EwEljWM;IAOI,4BAAA;ExE8iWV;EwErjWM;IAOI,kCAAA;ExEijWV;EwExjWM;IAOI,iCAAA;ExEojWV;EwE3jWM;IAOI,+BAAA;ExEujWV;EwE9jWM;IAOI,iCAAA;ExE0jWV;EwEjkWM;IAOI,+BAAA;ExE6jWV;EwEpkWM;IAOI,0BAAA;ExEgkWV;EwEvkWM;IAOI,gCAAA;ExEmkWV;EwE1kWM;IAOI,+BAAA;ExEskWV;EwE7kWM;IAOI,6BAAA;ExEykWV;EwEhlWM;IAOI,+BAAA;ExE4kWV;EwEnlWM;IAOI,6BAAA;ExE+kWV;EwEtlWM;IAOI,iBAAA;ExEklWV;EwEzlWM;IAOI,uBAAA;ExEqlWV;EwE5lWM;IAOI,sBAAA;ExEwlWV;EwE/lWM;IAOI,oBAAA;ExE2lWV;EwElmWM;IAOI,sBAAA;ExE8lWV;EwErmWM;IAOI,oBAAA;ExEimWV;EwExmWM;IAOI,qBAAA;ExEomWV;EwE3mWM;IAOI,2BAAA;ExEumWV;EwE9mWM;IAOI,0BAAA;ExE0mWV;EwEjnWM;IAOI,wBAAA;ExE6mWV;EwEpnWM;IAOI,0BAAA;ExEgnWV;EwEvnWM;IAOI,wBAAA;ExEmnWV;EwE1nWM;IAOI,wBAAA;ExEsnWV;EwE7nWM;IAOI,8BAAA;ExEynWV;EwEhoWM;IAOI,6BAAA;ExE4nWV;EwEnoWM;IAOI,2BAAA;ExE+nWV;EwEtoWM;IAOI,6BAAA;ExEkoWV;EwEzoWM;IAOI,2BAAA;ExEqoWV;EwE5oWM;IAOI,2BAAA;ExEwoWV;EwE/oWM;IAOI,4BAAA;ExE2oWV;EwElpWM;IAOI,6BAAA;ExE8oWV;AACF;AczpWI;E0DGI;IAOI,sBAAA;ExEmpWV;EwE1pWM;IAOI,uBAAA;ExEspWV;EwE7pWM;IAOI,sBAAA;ExEypWV;EwEhqWM;IAOI,8BAAA;ExE4pWV;EwEnqWM;IAOI,4BAAA;ExE+pWV;EwEtqWM;IAOI,2BAAA;ExEkqWV;EwEzqWM;IAOI,iCAAA;ExEqqWV;EwE5qWM;IAOI,2BAAA;ExEwqWV;EwE/qWM;IAOI,0BAAA;ExE2qWV;EwElrWM;IAOI,gCAAA;ExE8qWV;EwErrWM;IAOI,yBAAA;ExEirWV;EwExrWM;IAOI,wBAAA;ExEorWV;EwE3rWM;IAOI,+BAAA;ExEurWV;EwE9rWM;IAOI,yBAAA;ExE0rWV;EwEjsWM;IAOI,6BAAA;ExE6rWV;EwEpsWM;IAOI,8BAAA;ExEgsWV;EwEvsWM;IAOI,wBAAA;ExEmsWV;EwE1sWM;IAOI,+BAAA;ExEssWV;EwE7sWM;IAOI,wBAAA;ExEysWV;EwEhtWM;IAOI,yBAAA;ExE4sWV;EwEntWM;IAOI,8BAAA;ExE+sWV;EwEttWM;IAOI,iCAAA;ExEktWV;EwEztWM;IAOI,sCAAA;ExEqtWV;EwE5tWM;IAOI,yCAAA;ExEwtWV;EwE/tWM;IAOI,uBAAA;ExE2tWV;EwEluWM;IAOI,uBAAA;ExE8tWV;EwEruWM;IAOI,yBAAA;ExEiuWV;EwExuWM;IAOI,yBAAA;ExEouWV;EwE3uWM;IAOI,0BAAA;ExEuuWV;EwE9uWM;IAOI,4BAAA;ExE0uWV;EwEjvWM;IAOI,kCAAA;ExE6uWV;EwEpvWM;IAOI,sCAAA;ExEgvWV;EwEvvWM;IAOI,oCAAA;ExEmvWV;EwE1vWM;IAOI,kCAAA;ExEsvWV;EwE7vWM;IAOI,yCAAA;ExEyvWV;EwEhwWM;IAOI,wCAAA;ExE4vWV;EwEnwWM;IAOI,wCAAA;ExE+vWV;EwEtwWM;IAOI,kCAAA;ExEkwWV;EwEzwWM;IAOI,gCAAA;ExEqwWV;EwE5wWM;IAOI,8BAAA;ExEwwWV;EwE/wWM;IAOI,gCAAA;ExE2wWV;EwElxWM;IAOI,+BAAA;ExE8wWV;EwErxWM;IAOI,oCAAA;ExEixWV;EwExxWM;IAOI,kCAAA;ExEoxWV;EwE3xWM;IAOI,gCAAA;ExEuxWV;EwE9xWM;IAOI,uCAAA;ExE0xWV;EwEjyWM;IAOI,sCAAA;ExE6xWV;EwEpyWM;IAOI,iCAAA;ExEgyWV;EwEvyWM;IAOI,2BAAA;ExEmyWV;EwE1yWM;IAOI,iCAAA;ExEsyWV;EwE7yWM;IAOI,+BAAA;ExEyyWV;EwEhzWM;IAOI,6BAAA;ExE4yWV;EwEnzWM;IAOI,+BAAA;ExE+yWV;EwEtzWM;IAOI,8BAAA;ExEkzWV;EwEzzWM;IAOI,oBAAA;ExEqzWV;EwE5zWM;IAOI,mBAAA;ExEwzWV;EwE/zWM;IAOI,mBAAA;ExE2zWV;EwEl0WM;IAOI,mBAAA;ExE8zWV;EwEr0WM;IAOI,mBAAA;ExEi0WV;EwEx0WM;IAOI,mBAAA;ExEo0WV;EwE30WM;IAOI,mBAAA;ExEu0WV;EwE90WM;IAOI,mBAAA;ExE00WV;EwEj1WM;IAOI,oBAAA;ExE60WV;EwEp1WM;IAOI,0BAAA;ExEg1WV;EwEv1WM;IAOI,yBAAA;ExEm1WV;EwE11WM;IAOI,uBAAA;ExEs1WV;EwE71WM;IAOI,yBAAA;ExEy1WV;EwEh2WM;IAOI,uBAAA;ExE41WV;EwEn2WM;IAOI,uBAAA;ExE+1WV;EwEt2WM;IAOI,0BAAA;IAAA,yBAAA;ExEm2WV;EwE12WM;IAOI,gCAAA;IAAA,+BAAA;ExEu2WV;EwE92WM;IAOI,+BAAA;IAAA,8BAAA;ExE22WV;EwEl3WM;IAOI,6BAAA;IAAA,4BAAA;ExE+2WV;EwEt3WM;IAOI,+BAAA;IAAA,8BAAA;ExEm3WV;EwE13WM;IAOI,6BAAA;IAAA,4BAAA;ExEu3WV;EwE93WM;IAOI,6BAAA;IAAA,4BAAA;ExE23WV;EwEl4WM;IAOI,wBAAA;IAAA,2BAAA;ExE+3WV;EwEt4WM;IAOI,8BAAA;IAAA,iCAAA;ExEm4WV;EwE14WM;IAOI,6BAAA;IAAA,gCAAA;ExEu4WV;EwE94WM;IAOI,2BAAA;IAAA,8BAAA;ExE24WV;EwEl5WM;IAOI,6BAAA;IAAA,gCAAA;ExE+4WV;EwEt5WM;IAOI,2BAAA;IAAA,8BAAA;ExEm5WV;EwE15WM;IAOI,2BAAA;IAAA,8BAAA;ExEu5WV;EwE95WM;IAOI,wBAAA;ExE05WV;EwEj6WM;IAOI,8BAAA;ExE65WV;EwEp6WM;IAOI,6BAAA;ExEg6WV;EwEv6WM;IAOI,2BAAA;ExEm6WV;EwE16WM;IAOI,6BAAA;ExEs6WV;EwE76WM;IAOI,2BAAA;ExEy6WV;EwEh7WM;IAOI,2BAAA;ExE46WV;EwEn7WM;IAOI,0BAAA;ExE+6WV;EwEt7WM;IAOI,gCAAA;ExEk7WV;EwEz7WM;IAOI,+BAAA;ExEq7WV;EwE57WM;IAOI,6BAAA;ExEw7WV;EwE/7WM;IAOI,+BAAA;ExE27WV;EwEl8WM;IAOI,6BAAA;ExE87WV;EwEr8WM;IAOI,6BAAA;ExEi8WV;EwEx8WM;IAOI,2BAAA;ExEo8WV;EwE38WM;IAOI,iCAAA;ExEu8WV;EwE98WM;IAOI,gCAAA;ExE08WV;EwEj9WM;IAOI,8BAAA;ExE68WV;EwEp9WM;IAOI,gCAAA;ExEg9WV;EwEv9WM;IAOI,8BAAA;ExEm9WV;EwE19WM;IAOI,8BAAA;ExEs9WV;EwE79WM;IAOI,yBAAA;ExEy9WV;EwEh+WM;IAOI,+BAAA;ExE49WV;EwEn+WM;IAOI,8BAAA;ExE+9WV;EwEt+WM;IAOI,4BAAA;ExEk+WV;EwEz+WM;IAOI,8BAAA;ExEq+WV;EwE5+WM;IAOI,4BAAA;ExEw+WV;EwE/+WM;IAOI,4BAAA;ExE2+WV;EwEl/WM;IAOI,qBAAA;ExE8+WV;EwEr/WM;IAOI,2BAAA;ExEi/WV;EwEx/WM;IAOI,0BAAA;ExEo/WV;EwE3/WM;IAOI,wBAAA;ExEu/WV;EwE9/WM;IAOI,0BAAA;ExE0/WV;EwEjgXM;IAOI,wBAAA;ExE6/WV;EwEpgXM;IAOI,2BAAA;IAAA,0BAAA;ExEigXV;EwExgXM;IAOI,iCAAA;IAAA,gCAAA;ExEqgXV;EwE5gXM;IAOI,gCAAA;IAAA,+BAAA;ExEygXV;EwEhhXM;IAOI,8BAAA;IAAA,6BAAA;ExE6gXV;EwEphXM;IAOI,gCAAA;IAAA,+BAAA;ExEihXV;EwExhXM;IAOI,8BAAA;IAAA,6BAAA;ExEqhXV;EwE5hXM;IAOI,yBAAA;IAAA,4BAAA;ExEyhXV;EwEhiXM;IAOI,+BAAA;IAAA,kCAAA;ExE6hXV;EwEpiXM;IAOI,8BAAA;IAAA,iCAAA;ExEiiXV;EwExiXM;IAOI,4BAAA;IAAA,+BAAA;ExEqiXV;EwE5iXM;IAOI,8BAAA;IAAA,iCAAA;ExEyiXV;EwEhjXM;IAOI,4BAAA;IAAA,+BAAA;ExE6iXV;EwEpjXM;IAOI,yBAAA;ExEgjXV;EwEvjXM;IAOI,+BAAA;ExEmjXV;EwE1jXM;IAOI,8BAAA;ExEsjXV;EwE7jXM;IAOI,4BAAA;ExEyjXV;EwEhkXM;IAOI,8BAAA;ExE4jXV;EwEnkXM;IAOI,4BAAA;ExE+jXV;EwEtkXM;IAOI,2BAAA;ExEkkXV;EwEzkXM;IAOI,iCAAA;ExEqkXV;EwE5kXM;IAOI,gCAAA;ExEwkXV;EwE/kXM;IAOI,8BAAA;ExE2kXV;EwEllXM;IAOI,gCAAA;ExE8kXV;EwErlXM;IAOI,8BAAA;ExEilXV;EwExlXM;IAOI,4BAAA;ExEolXV;EwE3lXM;IAOI,kCAAA;ExEulXV;EwE9lXM;IAOI,iCAAA;ExE0lXV;EwEjmXM;IAOI,+BAAA;ExE6lXV;EwEpmXM;IAOI,iCAAA;ExEgmXV;EwEvmXM;IAOI,+BAAA;ExEmmXV;EwE1mXM;IAOI,0BAAA;ExEsmXV;EwE7mXM;IAOI,gCAAA;ExEymXV;EwEhnXM;IAOI,+BAAA;ExE4mXV;EwEnnXM;IAOI,6BAAA;ExE+mXV;EwEtnXM;IAOI,+BAAA;ExEknXV;EwEznXM;IAOI,6BAAA;ExEqnXV;EwE5nXM;IAOI,iBAAA;ExEwnXV;EwE/nXM;IAOI,uBAAA;ExE2nXV;EwEloXM;IAOI,sBAAA;ExE8nXV;EwEroXM;IAOI,oBAAA;ExEioXV;EwExoXM;IAOI,sBAAA;ExEooXV;EwE3oXM;IAOI,oBAAA;ExEuoXV;EwE9oXM;IAOI,qBAAA;ExE0oXV;EwEjpXM;IAOI,2BAAA;ExE6oXV;EwEppXM;IAOI,0BAAA;ExEgpXV;EwEvpXM;IAOI,wBAAA;ExEmpXV;EwE1pXM;IAOI,0BAAA;ExEspXV;EwE7pXM;IAOI,wBAAA;ExEypXV;EwEhqXM;IAOI,wBAAA;ExE4pXV;EwEnqXM;IAOI,8BAAA;ExE+pXV;EwEtqXM;IAOI,6BAAA;ExEkqXV;EwEzqXM;IAOI,2BAAA;ExEqqXV;EwE5qXM;IAOI,6BAAA;ExEwqXV;EwE/qXM;IAOI,2BAAA;ExE2qXV;EwElrXM;IAOI,2BAAA;ExE8qXV;EwErrXM;IAOI,4BAAA;ExEirXV;EwExrXM;IAOI,6BAAA;ExEorXV;AACF;AyE3uXA;ED+CQ;IAOI,4BAAA;ExEyrXV;EwEhsXM;IAOI,6BAAA;ExE4rXV;EwEnsXM;IAOI,6BAAA;ExE+rXV;EwEtsXM;IAOI,6BAAA;ExEksXV;AACF;AyEtuXA;ED4BQ;IAOI,0BAAA;ExEusXV;EwE9sXM;IAOI,gCAAA;ExE0sXV;EwEjtXM;IAOI,yBAAA;ExE6sXV;EwEptXM;IAOI,wBAAA;ExEgtXV;EwEvtXM;IAOI,+BAAA;ExEmtXV;EwE1tXM;IAOI,yBAAA;ExEstXV;EwE7tXM;IAOI,6BAAA;ExEytXV;EwEhuXM;IAOI,8BAAA;ExE4tXV;EwEnuXM;IAOI,wBAAA;ExE+tXV;EwEtuXM;IAOI,+BAAA;ExEkuXV;EwEzuXM;IAOI,wBAAA;ExEquXV;AACF;A0E7yXA;;;EAGE,wBAAA;A1E+yXF;;A0E5yXA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;A1E+yXF;;A2EzzXA;EACE,4BAAA;EACA,UAAA;A3E4zXF;A2E1zXE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A3E4zXJ;;A2E/yXA;EACE,4BAAA;EACA,UAAA;A3EkzXF;A2EhzXE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A3EkzXJ;;A2E5yXA;EACE,4BAAA;EACA,UAAA;A3E+yXF;A2E7yXE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;A3E+yXJ;;A4Ev1XA;EACE,YCWgC;EDVhC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;A5E01XF;A4Ex1XE;EACE,sM3EwGiB;ADkvXrB;A4Ev1XE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,YCP8B;A7Eg2XlC;A4Ev1XI;EACE,aAAA;EACA,mBAAA;A5Ey1XN;A4Et1XI;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;A5Ew1XN;A4En1XI;EAEE,mBAAA;A5Eo1XN;A4Ej1XI;EACE,iB3EwDS;AD2xXf;;A4E90XA;EACE,iBAAA;EACA,YCnCgC;EDoChC,YC1CgC;ED2ChC,aAAA;EACA,mBAAA;EACA,sBAAA;A5Ei1XF;A4E/0XE;EACE,YC7C8B;ED8C9B,WC7C8B;ED8C9B,oDAAA;A5Ei1XJ;A4E90XE;EACE,cAAA;EACA,iBAAA;A5Eg1XJ;;A4E50XA;;EAEE,aAAA;EACA,iBAAA;EACA,YCzDgC;ED0DhC,mBAAA;A5E+0XF;;A8Ep5XE;EACE,eAAA;EACA,WAAA;EACA,MAAA;A9Eu5XJ;A8Er5XI;EACE,mBAAA;A9Eu5XN;A8En5XE;EACE,iBAAA;A9Eq5XJ;A8Eh5XM;EACE,kBAAA;A9Ek5XR;;A+Ep6XA;EACE,iBAAA;EACA,aAAA;A/Eu6XF;A+Er6XE;EACE,aAAA;EACA,qBAAA;A/Eu6XJ;A+Ep6XE;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;A/Es6XJ;A+Ep6XI;ExECA,mBAAA;EwECE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;A/Es6XN;A+Ep6XM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;A/Es6XR;A+Ej6XI;EACE,YAAA;EACA,wBAAA;ExEnBF,mBAAA;APu7XJ;A+Eh6XI;EACE,cAAA;A/Ek6XN;A+E/5XI;EACE;IACE,UAAA;E/Ei6XN;AACF;A+E95XI;EACE,iBAAA;A/Eg6XN;A+E75XI;EACE,eAAA;A/E+5XN;A+E75XM;EACE,YAAA;A/E+5XR;A+E35XI;EACE,QAAA;EACA,UAAA;EACA,SAAA;A/E65XN;;AgF19XI;EACE,c/EgBK;E+EfL,6BAAA;EACA,8BAAA;AhF69XN;AgF39XM;EACE,gBAAA;AhF69XR;AgF19XM;EACE,c/ESG;ADm9XX;AgFz9XM;EACE,eAAA;AhF29XR;;AiF5+XA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AjF++XF;AiF7+XE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBhFMO;EgFLP,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AjF++XJ;AiF5+XE;;;EAGE,mBhFDO;AD++XX;;AkFlgYI;EACE,+BAAA;AlFqgYN;AkFngYM;EACE,+BAAA;AlFqgYR;AkFlgYM;EACE,yBAAA;AlFogYR;AkF7/XQ;EACE,8BAAA;EACA,oBAAA;AlF+/XV;AkF5/XQ;EACE,+CAAA;EACA,oBAAA;EACA,UAAA;AlF8/XV;AkF1/XU;EACE,+BAAA;AlF4/XZ;AkFz/XU;EACE,gDAAA;AlF2/XZ;AkFv/XQ;EACE,yBAAA;AlFy/XV;AkFn/XQ;;;EAGE,+BAAA;AlFq/XV;AkFj/XU;EACE,2FAAA;AlFm/XZ;AkF3+XQ;EACE,8BAAA;AlF6+XV;AkFz+XU;EAKE,0CAAA;AlFu+XZ;AkFj+XQ;EACE,oCAAA;AlFm+XV;AkFj+XU;EACE,+BAAA;AlFm+XZ;AkFh+XU;EACE,oCAAA;AlFk+XZ;AkF39XM;EACE,oCAAA;AlF69XR;AkFv9XM;;;;;;;;EAIE,qDAAA;AlF69XR;AkFz9XI;EACE,sCAAA;AlF29XN;AkFx9XI;;;EAGE,oCAAA;AlF09XN;AkFt9XM;EACE,oDAAA;AlFw9XR;AkFn9XM;;;EAGE,oCAAA;AlFq9XR;;AmFllYI;EACE,yBAAA;AnFqlYN;AmFnlYM;EACE,yBAAA;AnFqlYR;AmFllYM;EACE,mBAAA;AnFolYR;AmF7kYQ;EACE,wBAAA;EACA,oBAAA;AnF+kYV;AmF5kYQ;EACE,yCAAA;EACA,oBAAA;EACA,UAAA;AnF8kYV;AmF1kYU;EACE,yBAAA;AnF4kYZ;AmFzkYU;EACE,0CAAA;AnF2kYZ;AmFvkYQ;EACE,yBAAA;AnFykYV;AmFnkYQ;;;EAGE,yBAAA;AnFqkYV;AmF9jYQ;EACE,8BAAA;AnFgkYV;AmF3jYQ;EACE,8BAAA;AnF6jYV;AmF3jYU;EACE,yBAAA;AnF6jYZ;AmF1jYU;EACE,8BAAA;AnF4jYZ;AmFrjYM;EACE,8BAAA;AnFujYR;AmFjjYM;;;;;;;;EAIE,+CAAA;AnFujYR;AmFnjYI;EACE,gCAAA;AnFqjYN;AmFljYI;;;EAGE,8BAAA;AnFojYN;AmFhjYM;EACE,oDAAA;AnFkjYR;;AoFvpYA;EACE,YPGgC;EOFhC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBPDgC;EOEhC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBPCgC;EOAhC,oBAAA;ApF0pYF;AoFxpYE;EACE,0BAAA;EACA,WAAA;ApF0pYJ;AoFvpYE;EACE,WAAA;EACA,WAAA;ApFypYJ;AoFtpYE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ApFwpYJ;AoFrpYE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;ApFupYJ;AoFppYE;EACE,0CAAA;ApFspYJ;;AoFlpYA;EACE,yBAAA;EACA,iBnF8Ca;EmF7Cb,iBAAA;EACA,iBAAA;EACA,cnFRM;EmFSN,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;ApFqpYF;;AoFlpYA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ApFqpYF;;AqF7tYA;EACE,kBAAA;ArFguYF;AqF9tYE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;ArFguYJ;AqF7tYE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;ArF+tYJ;AqF5tYE;EACE,gBAAA;EACA,gBAAA;ArF8tYJ;AqF5tYI;EACE,UAAA;EACA,yBAAA;ArF8tYN;AqF3tYI;EACE,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;E9EnBF,uBAAA;E8EqBE,cpFfK;EoFgBL,mBAAA;ArF6tYN;AqF3tYM;EACE,mBpFoEiB;EoFnEjB,qBAAA;ArF6tYR;AqF3tYQ;EACE,YAAA;ArF6tYV;AqF1tYQ;EACE,UAAA;ArF4tYV;AqFxtYM;EACE,cpFVA;EoFWA,mBpFsDiB;ADoqYzB;AqFvtYM;EAEE,iBAAA;ArFwtYR;AqFptYI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;ArFstYN;AqFntYI;EACE,2BAAA;EACA,UAAA;EACA,UAAA;ArFqtYN;AqFntYM;EACE,0BAAA;ArFqtYR;AqFjtYI;EACE,yBAAA;ArFmtYN;AqFjtYM;EACE,uBAAA;ArFmtYR;AqFjtYQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mBpFSe;EoFRf,kBAAA;EACA,UAAA;EACA,MAAA;E9EvFN,mBAAA;AP2yYJ;AqFhtYQ;EACE,aAAA;EACA,kBAAA;EACA,cpF1FC;EoF2FD,eAAA;EACA,kBAAA;ArFktYV;AqFhtYU;EACE,cpFvEJ;ADyxYR;AqF/sYU;EACE,aAAA;ArFitYZ;AqF9sYU;EACE,cpF/EJ;EoFgFI,mBpFfa;AD+tYzB;AqF3sYM;EACE,SAAA;EACA,gBAAA;ArF6sYR;AqF1sYM;EACE,kBAAA;ArF4sYR;;AsFn1YE;EACE,0BAAA;AtFs1YJ;AsFp1YI;EACE,+BAAA;AtFs1YN;AsFp1YM;EACE,+CAAA;AtFs1YR;AsFh1YQ;EACE,+BAAA;AtFk1YV;AsFh1YU;EACE,yBAAA;EACA,oCAAA;AtFk1YZ;AsF/0YU;EACE,oCAAA;AtFi1YZ;AsF30YY;EACE,+BAAA;AtF60Yd;AsF30Yc;EACE,oCAAA;EACA,+BAAA;AtF60YhB;AsF10Yc;EACE,yBAAA;AtF40YhB;AsFv0YY;EACE,oCAAA;AtFy0Yd;AsFp0YQ;;EAEE,YAAA;AtFs0YV;AsFj0YI;EACE,oCAAA;AtFm0YN;AsF/zYM;EACE,oCAAA;AtFi0YR;AsF5zYM;EACE,oDAAA;AtF8zYR;AsF3zYM;;;EAGE,0CAAA;AtF6zYR;;AuFt4YE;EACE,0BAAA;AvFy4YJ;AuFv4YI;EACE,yBAAA;AvFy4YN;AuFv4YM;EACE,yCAAA;AvFy4YR;AuFn4YQ;EACE,yBAAA;AvFq4YV;AuFn4YU;EACE,mBAAA;EACA,8BAAA;AvFq4YZ;AuFl4YU;EACE,8BAAA;AvFo4YZ;AuF93YY;EACE,yBAAA;AvFg4Yd;AuF93Yc;EACE,8BAAA;AvFg4YhB;AuF53YY;EACE,8BAAA;AvF83Yd;AuF13YU;;EAEE,YAAA;AvF43YZ;AuFt3YI;EACE,8BAAA;AvFw3YN;AuFp3YM;EACE,8BAAA;AvFs3YR;AuFh3YM;;;EAGE,oCAAA;AvFk3YR;;AwFl7YE;EACE,eAAA;EACA,aAAA;AxFq7YJ;AwFh7YI;EACE,UAAA;EACA,mBXJ4B;A7Es7YlC;AwF36YM;EACE,aAAA;AxF66YR;AwFt6YM;EACE,aAAA;AxFw6YR;AwFp6YI;EAEE,kBX1B4B;A7E+7YlC;AwFn6YM;EACE,aAAA;AxFq6YR;AwFz5YM;EACE,iBXzC0B;A7Eo8YlC;AwFt5YQ;EACE,WX/CwB;EWgDxB,UAAA;AxFw5YV;AwFt5YU;EACE,aAAA;AxFw5YZ;AwFr5YU;EACE,kBAAA;AxFu5YZ;;AyFl9YE;EACE,yBAAA;EACA,WZE8B;EYD9B,eZC8B;EYA9B,cAAA;EACA,WAAA;AzFq9YJ;AyFn9YI;EACE,mBAAA;AzFq9YN;AyFn9YM;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AzFq9YR;AyFn9YQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,WAAA;EACA,mBxFmFe;EwFlFf,gBAAA;AzFq9YV;AyFj9YM;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AzFm9YR;AyFh9YM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AzFk9YR;AyF/8YM;EACE,kBAAA;AzFi9YR;AyF98YM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AzFg9YR;AyF98YQ;EACE,UAAA;AzFg9YV;AyF98YU;EACE,SAAA;AzFg9YZ;AyF58YQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AzF88YV;AyFz8YI;EACE,0BAAA;EACA,uBAAA;AzF28YN;AyFz8YM;EACE,0BAAA;AzF28YR;AyFz8YQ;EACE,cAAA;EAAA,oBAAA;EACA,2BAAA;EACA,UAAA;AzF28YV;AyF18YU;EACE,aAAA;AzF48YZ;AyFx8YQ;EACE,cAAA;EAAA,oBAAA;EACA,wBAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;AzF08YV;AyFv8YQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AzFy8YV;AyFt8YQ;EACE,mBAAA;AzFw8YV;AyFr8YQ;EACE,cAAA;EACA,UAAA;AzFu8YV;AyFr8YU;EACE,uBAAA;AzFu8YZ;AyFr8YY;EACE,aAAA;EACA,kBAAA;AzFu8Yd;AyFl8YY;EACE,kBAAA;AzFo8Yd;AyFh8YU;EACE,WAAA;EACA,cAAA;AzFk8YZ;AyFx7YM;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EAAA,4BAAA;AzF07YR;AyFt7YQ;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;AzFw7YV;AyFh7YM;EACE,WZ3J0B;A7E6kZlC;AyFh7YQ;EACE,aAAA;AzFk7YV;AyF/6YQ;EACE,kBAAA;AzFi7YV;AyFz6YI;EACE,kBZ3K4B;A7EslZlC;AyFr6YM;EACE,kBAAA;AzFu6YR;AyF/5YM;;EACE,WAAA;EACA,aAAA;AzFk6YR;AyFh6YQ;;EACE,aAAA;AzFm6YV;AyF75YM;EACE,aAAA;EACA,WZvM0B;EYwM1B,4BAAA;AzF+5YR;AyF75YQ;EACE,yBAAA;EACA,cAAA;EACA,WAAA;AzF+5YV;AyF55YQ;EACE,aAAA;AzF85YV;AyFz5YQ;EACE,YZxNwB;A7EmnZlC;AyFz5YU;EACE,WZvNsB;EYwNtB,SAAA;AzF25YZ;AyFp5YI;EACE,yBAAA;AzFs5YN;AyFj5YI;EACE,yBAAA;AzFm5YN;;A0FjoZA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;A1FooZF;A0FloZE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;A1FooZJ;A0FjoZE;EACE,oBAAA;EACA,SAAA;A1FmoZJ;A0FhoZM;EACE,gBzFoEY;AD8jZpB;A0F9nZQ;EACE,mBAAA;A1FgoZV;;A0FnnZM;EACE,2BAAA;A1FsnZR;A0FnnZM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A1FqnZR;A0FnnZQ;EACE,iBAAA;A1FqnZV;A0FlnZQ;EACE,kBpF8kC0B;ANsiXpC;A0FjnZQ;EACE,WzF3CF;AD8pZR;A0FhnZQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;A1FknZV;A0FhnZU;EACE,YAAA;EACA,aAAA;EnFnDR,uBAAA;EmFqDQ,iIACQ;A1FinZpB;;A2F7qZE;EACE,mBAVe;A3F0rZnB;A2F7qZE;EACE,mBAba;A3F4rZjB;A2F5qZE;EACE,qCAAA;A3F8qZJ;A2F3qZE;;EAEE,mBArBY;A3FksZhB;A2FzqZI;EACE,oCAAA;A3F2qZN;;A4F9rZE;EACE,mBAVe;A5F2sZnB;A4F9rZE;EACE,mBAba;EAcb,+BAAA;A5FgsZJ;A4F7rZE;EACE,+BAAA;A5F+rZJ;A4F5rZE;;EAEE,mBAtBY;A5FotZhB;A4F3rZE;EACE,6BAAA;A5F6rZJ;A4FzrZI;EACE,0CAAA;A5F2rZN;A4FtrZI;EACE,+BApCe;A5F4tZrB;A4FprZE;EACE,iBAAA;A5FsrZJ;A4FnrZE;EACE,0CAAA;A5FqrZJ;A4FjrZM;EACE,oBAAA;EACA,iB3FsCO;E2FrCP,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;A5FmrZR;A4FjrZQ;EACE,kBAAA;EACA,WAAA;EACA,mB3FrBF;EM5BJ,mBAAA;EqFmDM,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;A5FmrZV;A4F7qZE;EACE,yBAAA;A5F+qZJ;;A6F3vZA;EACE,YhBSgC;A7EqvZlC;A6F5vZE;EACE,2BAAA;EACA,YhBK8B;EgBJ9B,oBAAA;EAEA,aAAA;EACA,qBAAA;EACA,mBAAA;A7F6vZJ;A6F3vZI;EACE,aAAA;EACA,mBAAA;A7F6vZN;A6F1vZI;EACE,iBAAA;EACA,aAAA;A7F4vZN;;A6FrvZA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;A7FwvZF;A6FtvZE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mB5FpBO;AD4wZX;;A6FpvZA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;A7FuvZF;A6FrvZE;EACE,UAAA;A7FuvZJ;A6FrvZI;EACE,SAAA;EACA,kBAAA;A7FuvZN;A6FnvZE;EACE,iBAAA;A7FqvZJ;A6FlvZE;EACE,qBAAA;EACA,UAAA;A7FovZJ;;A8FlzZE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;A9FqzZJ;A8FnzZI;EACE,kBjBH4B;EiBI5B,+CAAA;A9FqzZN;A8FjzZE;EACE,oBjBH8B;A7EszZlC;A8F9yZM;EACE,4BAAA;A9FgzZR;;A+Fn0ZA;EACE,a9FsFkB;E8FrFlB,wBAAA;EACA,kBAAA;A/Fs0ZF;A+Fp0ZE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;A/Fs0ZJ;A+Fn0ZE;;EAEE,SAAA;EACA,UAAA;A/Fq0ZJ;A+Fl0ZE;EACE,iBzFsmB0B;EyFrmB1B,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;A/Fo0ZJ;A+Fj0ZE;EACE,gBAAA;EACA,kB9FgEa;E8F/Db,YAAA;A/Fm0ZJ;A+Fj0ZI;EACE,UAAA;EACA,eAAA;EACA,uBAAA;A/Fm0ZN;A+F/zZE;EACE,iBAAA;A/Fi0ZJ;A+F/zZI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;A/Fi0ZN;A+F7zZE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gB9F1CI;E8F2CJ,sM9FwDiB;EMjGjB,uBAAA;EwF2CA,WAAA;EACA,YAAA;A/F+zZJ;A+F7zZI;EACE,YAAA;A/F+zZN;A+F5zZI;EACE,6BAAA;A/F8zZN;A+F1zZE;EACE,4BAAA;A/F4zZJ;A+FzzZE;EAEE,8BAAA;EACA,4BAAA;A/F0zZJ;A+FxzZE;EACE;IAEE,4BAAA;IACA,4BAAA;E/FyzZJ;AACF;A+FtzZE;EACE,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A/FwzZJ;;A+FnzZE;ExFlFE,mBAAA;APy4ZJ;;A+FlzZA;EACE,8BAAA;A/FqzZF;;A+FnzZA;EACE;IACE,4BAAA;E/FszZF;AACF;A+FhzZE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;A/FkzZJ;;AgGv6ZA;EACE,kBAAA;EACA,6BAAA;AhG06ZF;AgGx6ZE;EACE,YAPkB;EAQlB,WARkB;EASlB,gBAAA;EACA,kBAAA;EACA,gCAAA;AhG06ZJ;AgGx6ZI;EACE,WAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,wDAAA;EACA,sBAAA;EACA,kB/FgEW;AD02ZjB;AgGv6ZI;EACE,WA/BgB;EAgChB,YAhCgB;EAiChB,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,+BAAA;EzF1BF,mBAAA;APo8ZJ;AgGv6ZM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;AhGy6ZR;AgGv6ZQ;EAEE,kBAAA;EACA,WAAA;AhGw6ZV;AgGr6ZQ;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mB/FtBF;AD67ZR;AgGp6ZQ;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,yBAAA;AhGs6ZV;AgGh6ZE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EAEA,4DAAA;EACA,sBAAA;AhGi6ZJ;AgG/5ZI;EAEE,kBAAA;EACA,mB/FvDE;E+FwDF,kBAAA;AhGg6ZN;AgG75ZI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;AhG+5ZN;AgG55ZI;EACE,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;AhG85ZN;AgG15ZE;EACE,YAAA;AhG45ZJ;AgG15ZI;EACE,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,wDAAA;AhG45ZN;AgG15ZM;EACE,UAAA;EACA,6BAAA;AhG45ZR;AgGz5ZM;EACE,WApIc;EAqId,YArIc;EAsId,SAAA;EACA,mBAAA;AhG25ZR;AgGz5ZQ;EACE,yBAAA;AhG25ZV;AgGt5ZI;EACE,WAAA;EACA,uBAAA;EAEA,wDAAA;EACA,sBAAA;AhGu5ZN;AgGr5ZM;EACE,qBAAA;AhGu5ZR;AgGn5ZI;EACE,UAAA;AhGq5ZN;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,wBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,uBAAA;AjGqjaF;;AiGljaA;EACE,qBAAA;AjGqjaF;;AkGnoaA;EACE,gCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,iCAAA;AlGsoaF;;AkGnoaA;EACE,kCAAA;AlGsoaF;;AmG/paA;EACE,2CAAA;AnGkqaF;;AmG/paA;EACE,4CAAA;AnGkqaF;;AmG/paA;EACE,8CAAA;AnGkqaF;;AmG/paA;EACE,+CAAA;AnGkqaF;;AmG/paA;EACE,2BAAA;AnGkqaF;;AmG/paA;EACE,0BAAA;AnGkqaF;;AmG/paA;E5FXI,uBAAA;AP8qaJ;;AmG7paA;EACE,4BAAA;EACA,6BAAA;AnGgqaF;;AmG7paA;EACE,cAAA;AnGgqaF;AmG9paE;EACE,cAAA;AnGgqaJ;;AmG5paA;EACE,cAAA;AnG+paF;;AmG5paA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AnG+paF;;AmG3paE;EACE,MAAA;EACA,UAAA;EACA,YAAA;AnG8paJ;;AmGxpaA;EACE,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,4BAAA;AnG2paF;;AmGtpaA;EACE,4BAAA;AnGypaF;;AmGtpaA;EACE,4BAAA;AnGypaF;;AmGtpaA;EACE,4BAAA;AnGypaF;;AmGppaA;EACE,wCAAA;AnGupaF;;AmGlpaA;EACE,wBAAA;AnGqpaF;;AmGlpaA;EACE,uBAAA;AnGqpaF;;AmGlpaA;EACE,YAAA;AnGqpaF;;AmGlpaA;EACE,aAAA;AnGqpaF;;AmGlpaA;EACE,mBAAA;AnGqpaF;;AmGhpaA;EACE,6BAAA;AnGmpaF;;AmGhpaA;EACE,4BAAA;AnGmpaF;;AmGhpaA;EACE,4BAAA;AnGmpaF;;AmGhpaA;EACE,0BAAA;AnGmpaF;;AmGhpaA;EACE,UAAA;AnGmpaF;;AmGhpaA;EACE,cAAA;AnGmpaF;;AmG9oaA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AnGipaF;;AmG9oaA;EACE,SAAA;AnGipaF;;AmG5oaA;EACE,gB7F0PO;E6FzPP,mB7FyPO;E6FxPP,WAAA;EACA,gBAAA;EACA,mBlGhJS;AD+xaX;;AmG5oaA;EACE,aAAA;EAAA,gBAAA;AnG+oaF;;AmG1oaA;EACE,eAAA;EACA,kBAAA;AnG6oaF;AmG3oaE;EACE,clGzJO;EkG0JP,iB7F0c0B;ANmsZ9B;AmG1oaE;EACE,clGhKO;EkGiKP,iBlGvFW;ADmuaf;;AmGtoaA;EACE,8BAAA;AnGyoaF;AmG7naA;EACE;IACE,6BAAA;EnGwoaF;EmGtoaA;IACE,2BAAA;EnGwoaF;AACF;AmGnoaA;EACE,WAAA;AnGqoaF;;AmGloaA;EACE,sBAAA;AnGqoaF;;AmGhoaA;EACE,mBlGrIkB;ADwwapB;;AmG9naA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AnGioaF;AmG/naE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AnGioaJ;AmG9naE;EACE,gBAAA;EACA,cAAA;EACA,clGjOO;EkGkOP,mBAAA;AnGgoaJ;AmG7naE;EACE,kBAAA;EACA,cAAA;AnG+naJ;;AmG3naA;EACE,sBAAA;AnG8naF;;AmG3naA;EACE,cAAA;AnG8naF;;AmG3naA;EACE,sCAAA;AnG8naF;;AmG3naA;EACE,gCAAA;AnG8naF;;AmG3naA;EACE,cAAA;AnG8naF;;AmG1naA;EACE,0BAAA;AnG6naF;;AmG1naA;EACE,WAAA;EACA,YAAA;AnG6naF;;AoGx5aA;EACE,0FAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,gFAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,2GAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,0GAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,yEAAA;ApG25aF;;AoGx5aA;EACE,6EAAA;ApG25aF;;AoGx5aA;EACE,8EAAA;ApG25aF;;AoGx5aA;EACE,0FAAA;ApG25aF;;AoGx5aA;EACE,8KAAA;EACA,+BAAA;ApG25aF;;AoGx5aA;EACE,wEAAA;ApG25aF;;AoGx5aA;EACE,iFAAA;ApG25aF;;AoGx5aA;EACE,kCAAA;ApG25aF;;AqGvgbA,uEAAA;ACCA;;;;CAAA;AAMA;EACC,mCAAA;AtGygbD;;AsGtgbA;ECII,4BAAA;EAAA,yBAAA;AvGygbJ;AsGzgbC;EACE,mCENuB;AxGihb1B;AsGxgbC;ECJG,gCAAA;AvGghbJ;AsGxgbC;ECRG,mCAAA;AvGohbJ;AsGvgbC;ECbG,mCAAA;AvGwhbJ;AuGngbI;EEjCF;IAAI,UAAA;EzGijbJ;EyGhjbA;IAAM,UAAA;EzGmjbN;AACF;AyGjjbC;EFQG,sBAAA;AvG6ibJ;A0G9ibC;EACC;IACC,UAAA;IACA,4BAAA;E1G2jbD;E0GxjbA;IACC,UAAA;IACA,wBAAA;E1G0jbD;AACF;A0GvjbC;EHXG,0BAAA;AvGskbJ;A2GvkbC;EACC;IACC,UAAA;IACA,2BAAA;E3GolbD;E2GjlbA;IACC,UAAA;IACA,wBAAA;E3GmlbD;AACF;A2GhlbC;EJXG,wBAAA;AvG+lbJ;AuG1kbI;EKjCF;IAAI,UAAA;E5GwnbJ;E4GvnbA;IAAM,UAAA;E5G0nbN;AACF;A4GxnbC;ELQG,uBAAA;AvGonbJ;A6G1nbC;EACC;IAAK,yCAAA;IAAmD,UAAA;E7GipbxD;E6GhpbA;IAAM,wCAAA;IAAkD,UAAA;E7GopbxD;E6GnpbA;IAAM,uCAAA;IAAqD,UAAA;E7Gupb3D;E6GtpbA;IAAO,qCAAA;IAAuC,UAAA;E7G0pb9C;AACF;A6GxpbC;ENDG,4BAAA;EAAA,mCAAA;AvG+pbJ;A8GvqbC;EACC;IAAK,qCAAA;IAAuC,UAAA;E9Gsrb5C;E8GrrbA;IAAO,yCAAA;IAAmD,UAAA;E9Gyrb1D;AACF;A8GvrbC;EPGG,6BAAA;EAAA,kCAAA;AvG0rbJ;;A+G/rbE;EACE,iEAAA;A/GksbJ;;A+G7rbE;EACE,cAAA;EACA,iEAAA;A/GgsbJ;;A+G3rbE;EACE,iEAAA;EACA,uBAAA;EACA,oBAAA;A/G8rbJ;;A+G1rbA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,UAAA;E/G6rbF;E+G3rbA;IACE,eAAA;IACA,mBAAA;IACA,UAAA;E/G6rbF;AACF;A+G1rbA;EACE,oBAAA;A/G4rbF;;AgH/tbA;EACE,iBAAA;AhHkubF;;AgH9tbE;EACE,iBAAA;EACA,gBAAA;AhHiubJ;AgH9tbE;EACE,iBAAA;AhHgubJ;AgH7tbE;EzGJE,gBAAA;APoubJ;;AgH3tbA;EACE,iBAAA;EACA,gBAAA;AhH8tbF;AgH1tbE;EzGeE,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;AP8tbJ;;AgHttbA;EACE,oBAAA;AhHytbF;;AgHptbA;EACE,sBAAA;AhHutbF;AgHptbI;EACE,mBAAA;EACA,eAAA;AhHstbN;AgHltbE;EACE,oBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;AhHotbJ;AgHjtbE;EACE,qBAAA;AhHmtbJ;AgH/sbI;EACE,eAAA;AhHitbN;AgH5sbI;EACE,eAAA;AhH8sbN;;AgHxsbE;EACE,cAAA;EACA,eAAA;AhH2sbJ;;AgHrsbA;EACE,kBAAA;AhHwsbF;AgHtsbE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EAGA,gBAAA;AhHwsbJ;AgHrsbE;EACE,WAAA;EACA,wCAAA;EACA,gCAAA;AhHusbJ;AgHnsbI;EzGtEA,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;AP4xbJ;;AgHhsbA;EACE,iBAAA;EACA,oBAAA;AhHmsbF;AgHjsbE;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AhHmsbJ;AgHhsbE;EACE,qBAAA;AhHksbJ;AgH9rbI;EACE,eAAA;AhHgsbN;AgH3rbI;EACE,eAAA;AhH6rbN;AgHtrbI;EACE,UAAA;AhHwrbN;AgHnrbI;EACE,oBAAA;AhHqrbN;AgHhrbI;EACE,+BAAA;AhHkrbN;AgH9qbM;EACE,qBAAA;AhHgrbR;AgHzqbQ;EACE,sBAAA;AhH2qbV;;AgHpqbA;EACE,4BAAA;AhHuqbF;;AgHlqbA;EACE,c/G/KS;E+GgLT,qB/GpLS;E+GqLT,sBAAA;AhHqqbF;AgHnqbE;EACE,yBAAA;EACA,6BAAA;AhHqqbJ;AgHnqbI;EACE,c/GhKE;E+GiKF,mB/G9LK;ADm2bX;AgHjqbE;EAEE,c/G/LO;E+GgMP,qB/GpMO;ADs2bX;AgH9pbI;EACE,gBAAA;AhHgqbN;;AgHzpbI;EACE,gCAAA;EACA,gCAAA;EACA,2BAAA;EAAA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,W/GxNE;ADo3bR;;AgHrpbA;EzG7NI,2BAAA;APs3bJ;;AgHlpbE;EjFvLA,4BAAA;EACA,0BAAA;E5B8NI,0BALI;E4BvNR,+CAAA;A/B60bF;;AgHnpbE;EjF7LA,0BAAA;EACA,wBAAA;E5B8NI,0BALI;E4BvNR,kDAAA;A/Bo1bF;;AgHppbE;EjFnMA,2BAAA;EACA,wBAAA;E5B8NI,0BALI;E4BvNR,kDAAA;A/B21bF;;AgHnpbE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;AhHspbJ;;AgHhpbI;EACE,MAAA;AhHmpbN;;AgH9obA;EACE,+CAAA;AhHipbF;;AgHxibE;EA5BA,mFAAA;EACA,wCAuBQ;EAtBR,oCAsBQ;EArBR,WAAA;AhHwkbF;AgHtkbE;EAGE,0GAAA;EACA,WAAA;EACA,uCAAA;AhHskbJ;AgHnkbE;EAIE,sBAAA;EACA,+CAAA;AhHkkbJ;AgHrjbI;EACE,mGAAA;AhHujbN;AgHrjbM;EACE,mGAAA;AhHujbR;;AgH9jbE;EA5BA,qFAAA;EACA,0CAuBQ;EAtBR,sCAsBQ;EArBR,WAAA;AhH8lbF;AgH5lbE;EAGE,8GAAA;EACA,WAAA;EACA,wCAAA;AhH4lbJ;AgHzlbE;EAIE,sBAAA;EACA,6CAAA;AhHwlbJ;AgH3kbI;EACE,uGAAA;AhH6kbN;AgH3kbM;EACE,uGAAA;AhH6kbR;;AgHplbE;EA5BA,qFAAA;EACA,0CAuBQ;EAtBR,sCAsBQ;EArBR,WAAA;AhHonbF;AgHlnbE;EAGE,6GAAA;EACA,WAAA;EACA,wCAAA;AhHknbJ;AgH/mbE;EAIE,sBAAA;EACA,8CAAA;AhH8mbJ;AgHjmbI;EACE,qGAAA;AhHmmbN;AgHjmbM;EACE,qGAAA;AhHmmbR;;AgH1mbE;EA5BA,sFAAA;EACA,2CAuBQ;EAtBR,uCAsBQ;EArBR,WAAA;AhH0obF;AgHxobE;EAGE,8GAAA;EACA,WAAA;EACA,0CAAA;AhHwobJ;AgHrobE;EAIE,sBAAA;EACA,8CAAA;AhHoobJ;AgHvnbI;EACE,qGAAA;AhHynbN;AgHvnbM;EACE,qGAAA;AhHynbR;;AgHhobE;EA5BA,sFAAA;EACA,2CAuBQ;EAtBR,uCAsBQ;EArBR,WAAA;AhHgqbF;AgH9pbE;EAGE,8GAAA;EACA,WAAA;EACA,0CAAA;AhH8pbJ;AgH3pbE;EAIE,sBAAA;EACA,8CAAA;AhH0pbJ;AgH7obI;EACE,qGAAA;AhH+obN;AgH7obM;EACE,qGAAA;AhH+obR;;AgHtpbE;EA5BA,mFAAA;EACA,wCAuBQ;EAtBR,oCAsBQ;EArBR,WAAA;AhHsrbF;AgHprbE;EAGE,0GAAA;EACA,WAAA;EACA,wCAAA;AhHorbJ;AgHjrbE;EAIE,sBAAA;EACA,6CAAA;AhHgrbJ;AgHnqbI;EACE,mGAAA;AhHqqbN;AgHnqbM;EACE,mGAAA;AhHqqbR;;AgH5qbE;EA5BA,kFAAA;EACA,uCAuBQ;EAtBR,mCAsBQ;EArBR,WAAA;AhH4sbF;AgH1sbE;EAGE,wGAAA;EACA,WAAA;EACA,sCAAA;AhH0sbJ;AgHvsbE;EAIE,sBAAA;EACA,8CAAA;AhHssbJ;AgHzrbI;EACE,iGAAA;AhH2rbN;AgHzrbM;EACE,iGAAA;AhH2rbR;;AgHlsbE;EA5BA,qFAAA;EACA,0CAuBQ;EAtBR,sCAsBQ;EArBR,WAAA;AhHkubF;AgHhubE;EAGE,6GAAA;EACA,WAAA;EACA,yCAAA;AhHgubJ;AgH7tbE;EAIE,sBAAA;EACA,gDAAA;AhH4tbJ;AgH/sbI;EACE,qGAAA;AhHitbN;AgH/sbM;EACE,qGAAA;AhHitbR;;AgHxtbE;EA5BA,qFAAA;EACA,0CAuBQ;EAtBR,sCAsBQ;EArBR,WAAA;AhHwvbF;AgHtvbE;EAGE,8GAAA;EACA,WAAA;EACA,yCAAA;AhHsvbJ;AgHnvbE;EAIE,sBAAA;EACA,iDAAA;AhHkvbJ;AgHrubI;EACE,uGAAA;AhHuubN;AgHrubM;EACE,uGAAA;AhHuubR;;AgH9ubE;EA5BA,kFAAA;EACA,uCAuBQ;EAtBR,mCAsBQ;EArBR,WAAA;AhH8wbF;AgH5wbE;EAGE,wGAAA;EACA,WAAA;EACA,sCAAA;AhH4wbJ;AgHzwbE;EAIE,sBAAA;EACA,8CAAA;AhHwwbJ;AgH3vbI;EACE,iGAAA;AhH6vbN;AgH3vbM;EACE,iGAAA;AhH6vbR;;AgHtvbE;EACE,0CAAA;AhHyvbJ;;AgH7ubE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B4ncF;AgH3vbI;EACE,mGAAA;AhH6vbN;AgH3vbM;EACE,mGAAA;AhH6vbR;;AgHpwbE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BmpcF;AgHlxbI;EACE,uGAAA;AhHoxbN;AgHlxbM;EACE,uGAAA;AhHoxbR;;AgH3xbE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B0qcF;AgHzybI;EACE,qGAAA;AhH2ybN;AgHzybM;EACE,qGAAA;AhH2ybR;;AgHlzbE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BiscF;AgHh0bI;EACE,qGAAA;AhHk0bN;AgHh0bM;EACE,qGAAA;AhHk0bR;;AgHz0bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BwtcF;AgHv1bI;EACE,qGAAA;AhHy1bN;AgHv1bM;EACE,qGAAA;AhHy1bR;;AgHh2bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B+ucF;AgH92bI;EACE,mGAAA;AhHg3bN;AgH92bM;EACE,mGAAA;AhHg3bR;;AgHv3bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BswcF;AgHr4bI;EACE,uGAAA;AhHu4bN;AgHr4bM;EACE,uGAAA;AhHu4bR;;AgH94bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,+CAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B6xcF;AgH55bI;EACE,iGAAA;AhH85bN;AgH55bM;EACE,iGAAA;AhH85bR;;AgHr6bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BozcF;AgHn7bI;EACE,iGAAA;AhHq7bN;AgHn7bM;EACE,iGAAA;AhHq7bR;;AgH57bE;EjF3YA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B20cF;AgH18bI;EACE,qGAAA;AhH48bN;AgH18bM;EACE,qGAAA;AhH48bR;;AgHp8bI;EACE,mGAAA;AhHu8bN;;AgHx8bI;EACE,uGAAA;AhH28bN;;AgH58bI;EACE,qGAAA;AhH+8bN;;AgHh9bI;EACE,qGAAA;AhHm9bN;;AgHp9bI;EACE,qGAAA;AhHu9bN;;AgHx9bI;EACE,mGAAA;AhH29bN;;AgH59bI;EACE,uGAAA;AhH+9bN;;AgHh+bI;EACE,iGAAA;AhHm+bN;;AgHp+bI;EACE,iGAAA;AhHu+bN;;AgHx+bI;EACE,qGAAA;AhH2+bN;;AgHr+bE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bi3cF;AgHn/bI;EACE,mGAAA;AhHq/bN;AgHn/bM;EAIE,mGAAA;AhHk/bR;AgH/+bM;EACE,oDAAA;AhHi/bR;;AgH//bE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B24cF;AgH7gcI;EACE,uGAAA;AhH+gcN;AgH7gcM;EAIE,uGAAA;AhH4gcR;AgHzgcM;EACE,sDAAA;AhH2gcR;;AgHzhcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bq6cF;AgHvicI;EACE,qGAAA;AhHyicN;AgHvicM;EAIE,qGAAA;AhHsicR;AgHnicM;EACE,qDAAA;AhHqicR;;AgHnjcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B+7cF;AgHjkcI;EACE,qGAAA;AhHmkcN;AgHjkcM;EAIE,qGAAA;AhHgkcR;AgH7jcM;EACE,qDAAA;AhH+jcR;;AgH7kcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/By9cF;AgH3lcI;EACE,qGAAA;AhH6lcN;AgH3lcM;EAIE,qGAAA;AhH0lcR;AgHvlcM;EACE,qDAAA;AhHylcR;;AgHvmcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bm/cF;AgHrncI;EACE,mGAAA;AhHuncN;AgHrncM;EAIE,mGAAA;AhHoncR;AgHjncM;EACE,oDAAA;AhHmncR;;AgHjocE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6gdF;AgH/ocI;EACE,uGAAA;AhHipcN;AgH/ocM;EAIE,uGAAA;AhH8ocR;AgH3ocM;EACE,sDAAA;AhH6ocR;;AgH3pcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BuidF;AgHzqcI;EACE,iGAAA;AhH2qcN;AgHzqcM;EAIE,iGAAA;AhHwqcR;AgHrqcM;EACE,mDAAA;AhHuqcR;;AgHrrcE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BikdF;AgHnscI;EACE,iGAAA;AhHqscN;AgHnscM;EAIE,iGAAA;AhHkscR;AgH/rcM;EACE,mDAAA;AhHiscR;;AgH/scE;EjFxYA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2ldF;AgH7tcI;EACE,qGAAA;AhH+tcN;AgH7tcM;EAIE,qGAAA;AhH4tcR;AgHztcM;EACE,qDAAA;AhH2tcR;;AgHrtcA;EACE,kBAAA;E1F1bI,qF0F2bJ;AhHwtcF;AsB/odM;E0FqbN;I1FpbQ,gBAAA;EtBkpdN;AACF;;AgH1tcA;EACE,sCAAA;AhH6tcF;;AgH1tcA;EACE,cAAA;AhH6tcF;;AiH5qdA;EACE,sMAAA;EAIA,kBhHsFe;EgHpFf,gB3G6sCkC;AN89apC;AiHzqdE;EACE,mBAAA;AjH2qdJ;AiHxqdE;EACE,yBAAA;EACA,0BAAA;EACA,chH2BI;EgH1BJ,iBAAA;AjH0qdJ;AiHvqdE;EACE,kBhHsEa;EgHrEb,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AjHyqdJ;AiHvqdI;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AjHyqdN;AiHrqdM;EACE,YAAA;AjHuqdR;AiHlqdE;EACE,sMAAA;AjHoqdJ;;AiH7pdA;E1GtCI,mBAAA;E0GwCF,gBhHuDmB;ADymdrB;AiH9pdE;E1G1CE,mBAAA;AP2sdJ;AiH7pdE;EACE,qBAAA;EACA,sBAAA;AjH+pdJ;AiH5pdE;EACE,qBAAA;EACA,sBAAA;E1G5CA,4BAAA;EACA,6BAAA;AP2sdJ;AiH5pdE;;E1GhDE,4BAAA;EACA,6BAAA;APgtdJ;;AiHzpdI;EACE,gBAAA;EACA,chHvCE;ADmsdR;;AiHrpdI;EACE,mBhH/CE;EgHgDF,WhH9EE;ADsudR;;AiHlpdE;EACE,gBAAA;AjHqpdJ;AiHlpdE;EACE,gBAAA;AjHopdJ;;AiH7odE;;;E1GrFE,gCAAA;EAAA,+CAAA;EACA,iCAAA;EAAA,gDAAA;APwudJ;;AiH7odA;EACE,WhHxGM;EgHyGN,oBAAA;EACA,sBhHTmB;EgHUnB,kBAAA;EACA,UAAA;AjHgpdF;AiH9odE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;AjHgpdJ;AiH7odE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AjH+odJ;AiH5odE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AjH8odJ;AiH5odI;EACE,oBAAA;AjH8odN;AiH3odI;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AjH6odN;AiH3odM;EACE,kBAAA;AjH6odR;AiHzodI;EACE,gBAAA;EACA,kBAAA;AjH2odN;AiHvodE;EACE,oBAAA;AjHyodJ;;AiHrodA;EACE,gBAAA;EACA,iB3Gwc4B;E2Gvc5B,SAAA;AjHwodF;;AiHrodA;EACE,0M3Gua4B;E2Gva5B,oC3Gua4B;E2Gta5B,eAAA;EACA,YAAA;AjHwodF;;AiHpodE;EACE,uBAAA;EACA,YAAA;AjHuodJ;AiHrodI;EACE,gBhHlFe;ADytdrB;AiHnodE;EACE,+BAAA;AjHqodJ;AiHnodI;EACE,UAAA;AjHqodN;;AiH7ndE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AjHgodJ;;AiH3ndE;EACE,cAAA;AjH8ndJ;;AiHxndI;EACE,MAAA;AjH2ndN;;AiHtndA;EACE,+CAAA;AjHyndF;;AiHlndE;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AjHondJ;AiHjndE;EACE,gB3G09BgC;E2G19BhC,6B3G09BgC;E2Gz9BhC,UAAA;AjHmndJ;AiHhndE;EACE,SAAA;EACA,gC3Gq9BgC;E2Gr9BhC,8C3Gq9BgC;E2Gp9BhC,UAAA;AjHkndJ;AiH9mdI;EAEE,SAAA;EACA,YAAA;AjH+mdN;AiH5mdI;EACE,YAAA;AjH8mdN;AiHzmdI;EAEE,UAAA;EACA,WAAA;EACA,QAAA;AjH0mdN;AiHvmdI;EACE,QAAA;EACA,WAAA;AjHymdN;AiHpmdI;EAEE,WAAA;EACA,UAAA;EACA,QAAA;AjHqmdN;AiHlmdI;EACE,QAAA;EACA,UAAA;AjHomdN;AiH/ldI;EAEE,UAAA;EACA,UAAA;AjHgmdN;AiH7ldI;EACE,UAAA;AjH+ldN;AiH1ldI;EAEE,aAAA;AjH2ldN;;AiHpldA;EACE,YAAA;EACA,a3G8EO;ANygdT;AiHrldE;EACE,oBAAA;EACA,kBhHhPa;EgHiPb,cAAA;EACA,mBAAA;AjHuldJ;AiHpldE;EACE,gBAAA;AjHsldJ;;AiHlldA;EACE,YAAA;AjHqldF;;AiHhldA;EACE,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;E1GhVE,gBAAA;E0GkVF,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mCAAA;AjHmldF;AiHjldE;EAEE,aAAA;AjHkldJ;;AkH37dE;EACE,mBAAA;AlH87dJ;;AkH17dA;EACE,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;AlH67dF;AkH37dE;EACE,cjH8BI;EiH7BJ,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AlH67dJ;AkH17dE;EACE,cjHFO;AD87dX;AkH17dI;EACE,YAAA;EACA,cjHiBE;AD26dR;AkHt7dI;EACE,YAAA;AlHw7dN;;AkHl7dE;EACE,yBAAA;EACA,0BAAA;EACA,cjHvBO;EiHwBP,iBAAA;EACA,oBAAA;AlHq7dJ;AkHl7dE;EACE,oBAAA;AlHo7dJ;AkHj7dE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBjHvCO;AD09dX;;AkH96dE;EACE,gBAAA;AlHi7dJ;;AkH16dI;EAEE,WjHzDE;ADq+dR;AkH16dM;EACE,WjH5DA;EiH6DA,YAAA;AlH46dR;AkHx6dI;EACE,yBAAA;AlH06dN;;AkHj6dE;EACE,6BAAA;EACA,gCAAA;AlHo6dJ;AkHl6dI;EACE,UAAA;AlHo6dN;AkH95dI;EACE,sBAAA;AlHg6dN;AkH75dI;EACE,uBAAA;AlH+5dN;AkH55dI;EACE,qBAAA;AlH85dN;AkH15dE;EACE,sBAAA;AlH45dJ;AkHr5dM;EACE,sBAAA;AlHu5dR;AkHp5dM;EACE,uBAAA;AlHs5dR;AkHn5dM;EACE,qBAAA;AlHq5dR;AkHh5dE;EACE,cAAA;EACA,SAAA;EACA,eAAA;AlHk5dJ;;AmHvheA;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AnH0heF;;AmHvheA;EACE,gBlHCM;ADyheR;;AmHvheA;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;E5GLE,mBAAA;E4GOF,cAAA;AnH0heF;;AmHvheA;EACE,WAAA;EACA,YAAA;AnH0heF;;AmHvheA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AnH0heF;AmHxheE;EACE,WAAA;EACA,WAAA;EACA,YAAA;E5GvBA,uBAAA;E4GyBA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,gBlH/BI;ADyjeR;;AmHtheA;EACE,UAAA;EACA,WAAA;AnHyheF;;AmHrheE;EACE,gBAAA;AnHwheJ;AmHrheE;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AnHuheJ;AmHrheI;EACE,WAAA;EACA,YAAA;AnHuheN;AmHpheI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;AnHsheN;AmHlheE;EACE,SAAA;EACA,WAAA;AnHoheJ;;AmH/geE;EACE,QAAA;EACA,UAAA;AnHkheJ;AmH/geE;EACE,QAAA;EACA,UAAA;AnHiheJ;AmH9geE;EACE,SAAA;EACA,WAAA;AnHgheJ;AmH7geE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AnH+geJ;;AmH3geA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AnH8geF;;AmHzgeA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;AnH4geF;AmH1geE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AnH4geJ;AmH1geI;EACE,cAAA;AnH4geN;AmHzgeI;EACE,SAAA;EACA,WAAA;EACA,YAAA;AnH2geN;AmHvgeE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AnHygeJ;AmHvgeI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;AnHygeN;AmHvgeM;EACE,SAAA;EACA,QAAA;EACA,SAAA;AnHygeR;;AmHjgeE;EACE,mBlHpDqB;EkHqDrB,8CAAA;EACA,clHvHI;EkHwHJ,kBAAA;EACA,YAAA;AnHogeJ;AmHlgeI;EACE,kBAAA;EACA,sBAAA;EACA,kB7G8cwB;E6G7cxB,cAAA;EACA,YAAA;AnHogeN;AmHhgeE;EACE,eAAA;AnHkgeJ;AmHhgeI;EACE,UAAA;AnHkgeN;;AmH1/dI;EACE,YAAA;AnH6/dN;;AmHx/dA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;E5GvLE,mBAAA;APmreJ;AmHz/dE;E5G1LE,iCAAA;APsreJ;;AmHt/dE;EACE,WAAA;EACA,YAAA;AnHy/dJ;AmHr/dI;EACE,kB7G+ZwB;ANwld9B;;AmHj/dE;EACE,WAAA;EACA,YAAA;AnHo/dJ;AmHh/dI;EACE,kB7GmZwB;AN+ld9B;;AmH5+dE;EACE,WAAA;EACA,YAAA;AnH++dJ;AmH3+dI;EACE,iBlHpJS;ADioef;;AmHv+dE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;AnH0+dJ;AmHt+dI;EACE,iBAAA;EACA,kBlHpKW;AD4oejB;AmHn+dI;EACE,mBAAA;AnHq+dN;;AmHh+dA;EACE,sBAAA;EACA,gBAAA;AnHm+dF;AmHj+dE;EACE,WAAA;EACA,YAAA;AnHm+dJ;;AmH99dE;EACE,UAAA;EACA,kBAAA;AnHi+dJ;AmH/9dI;EACE,UAAA;AnHi+dN;AmH99dI;EACE,kBAAA;AnHg+dN;AmH99dI;EACE,kBAAA;AnHg+dN;AmH99dI;EACE,kBAAA;AnHg+dN;AmH99dI;EACE,kBAAA;AnHg+dN;AmH79dI;EAEE,yBAAA;AnH89dN;AmH/7dA;EACE,oCAAA;EACA,2CAAA;EACA,kBAAA;AnHw9dF;AmHt9dE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,gEAAA;EACA,2CAAA;AnHq9dJ;AmHl9dE;EACE,8BAAA;EACA,gCAAA;AnHo9dJ;;AoHtzeA;EACE,sMnH+GmB;EmH9GnB,eAAA;EACA,oBAAA;ApHyzeF;AoHvzeE;EACE,SAAA;ApHyzeJ;AoHvzeI;E7GgBA,gCAAA;EAAA,+CAAA;EACA,iCAAA;EAAA,gDAAA;AP0yeJ;AoHpzeI;;;EAEE,oCAAA;EACA,+BAAA;ApHuzeN;AoHlzeI;;EAEE,yBAAA;ApHozeN;AoHhzeE;EACE,aAAA;EACA,mBAAA;ApHkzeJ;;AoH9yeA;EACE,iBAAA;EACA,mBAAA;ApHizeF;;AoH9yeA;EACE,kBAAA;ApHizeF;;AoH7yeE;EACE,eAAA;EACA,gBAAA;EAQA,cnHnCO;AD40eX;AoH/yeI;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;ApHizeN;AoH5yeI;EACE,cnHfE;AD6zeR;;AoHzyeA;;EAEE,yBAAA;EACA,mCAAA;EACA,iBAAA;EACA,kBnHuBe;ADqxejB;;AoHzyeA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;ApH4yeF;AoH1yeE;EACE,SAAA;EACA,UAAA;EACA,YAAA;ApH4yeJ;AoHzyeE;EACE,cAAA;ApH2yeJ;AoHvyeI;EACE,WAAA;EACA,iBAAA;ApHyyeN;AoHtyeI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApHwyeN;AoHpyeE;EACE,kBAAA;EACA,oBAAA;ApHsyeJ;AoHnyeE;EACE,oBAAA;EACA,YAAA;EACA,WAAA;ApHqyeJ;AoHnyeI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ApHqyeN;AoHlyeI;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,cnHxGK;AD44eX;AoHlyeM;EACE,WAAA;E7GhHJ,mBAAA;E6GkHI,mBnHtFA;EmHuFA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;ApHoyeR;AoHjyeM;EACE,cnHjGA;ADo4eR;AoHhyeM;EACE,cnHrGA;ADu4eR;AoHhyeQ;EACE,UAAA;ApHkyeV;AoH1xeM;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;ApH4xeR;AoHvxeQ;EACE,mBAAA;ApHyxeV;;AoHlxeA;EACE,6BAAA;EACA,iBAAA;ApHqxeF;;AoHjxeE;EACE,sMAAA;ApHoxeJ;;AoH5weE;EACE,sMAAA;ApH+weJ;;AoHxweA;EACE,mB9GiNO;E8GhNP,mBnHxGa;EmHyGb,oCAAA;ApH2weF;;AoHvweE;EACE,sMAAA;ApH0weJ;;AoH3weE;EACE,8MAAA;ApH8weJ;;AoH/weE;EACE,0MAAA;ApHkxeJ;;AoHnxeE;EACE,0MAAA;ApHsxeJ;;AoHvxeE;EACE,0MAAA;ApH0xeJ;;AoH3xeE;EACE,sMAAA;ApH8xeJ;;AoH/xeE;EACE,8MAAA;ApHkyeJ;;AoHnyeE;EACE,kMAAA;ApHsyeJ;;AoHvyeE;EACE,kMAAA;ApH0yeJ;;AoH3yeE;EACE,0MAAA;ApH8yeJ;;AoHryeA;EACE,kBAAA;EACA,YAAA;ApHwyeF;;AoHnyeI;EACE,sMnH5Ge;ADk5erB;;AqHlgfA;;EAEE,mB/GmZO;ANkneT;;AqHlgfA;EACE,iBAAA;ArHqgfF;AqHngfE;EACE,eAAA;ArHqgfJ;;AqH9/eI;EACE,yBAAA;ArHigfN;AqH9/eI;EACE,cpHsBE;AD0+eR;;AqHx/eI;EACE,yBAAA;ArH2/eN;AqHx/eI;EACE,mBpHSE;ADi/eR;AqHx/eM;EACE,sBAAA;ArH0/eR;;AqHl/eA;EACE,kBAAA;ArHq/eF;;AqHl/eA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;ArHq/eF;;AqHl/eA;EACE,sBAAA;ArHq/eF;;AqHl/eA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;ArHq/eF;AqHn/eE;EACE,cpHxBI;AD6gfR;AqHl/eE;EACE,UAAA;ArHo/eJ;;AqHh/eA;EACE,cpHjCM;ADohfR;;AqHh/eA;EACE,YAAA;EACA,mBAAA;ArHm/eF;;AqHh/eA;EACE,UAAA;ArHm/eF;;AqHh/eA;EACE,kBAAA;ArHm/eF;;AqHh/eA;EACE,kBAAA;ArHm/eF;;AqHh/eA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;ArHm/eF;;AqH7+eE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EAEA,cAAA;EACA,aAAA;E9GjGA,mBAAA;E8GmGA,yBAAA;EACA,UAAA;ArH++eJ;AqH7+eI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,cpHpFE;ADmkfR;AqH7+eM;EACE,cpH5GG;AD2lfX;AqH5+eM;EACE,WpHzHA;ADumfR;AqH5+eQ;EACE,WpH5HF;AD0mfR;AqHz+eI;EACE,uBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,eAAA;ArH0+eN;AqHx+eM;EACE,kBAAA;EACA,WAAA;EACA,gBpH5IA;EoH6IA,WAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;E9G9IJ,mBAAA;APynfJ;AqHv+eM;EACE,uBAAA;EACA,gBAAA;E9GpJJ,mBAAA;E8GsJI,6BAAA;ArHy+eR;AqHt+eM;EACE,iBAAA;ArHw+eR;;AqHh+eA;EACE,gB/GmOO;ANgweT;;AqH39eA;E9G3KI,uBAAA;E8G6KF,mBpHjJM;EoHkJN,eAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WpHhHkB;EoHiHlB,QAAA;EACA,iBAAA;EACA,iBAAA;ArH89eF;AqH59eE;EACE,aAAA;ArH89eJ;;AqHz9eA;EACE,kBAAA;EACA,UAAA;EACA,WpHxMM;EoHyMN,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;ArH49eF;;AqHz9eA;EACE,iIAAA;ArH49eF;;AqHv9eA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gBpH5HmB;EoH6HnB,kBAAA;EACA,oBAAA;EACA,kBpH/Ie;EoHgJf,cpHvNS;EoHwNT,gBAAA;EACA,gBAAA;EACA,sB/Gy+BkC;E+Gz+BlC,mC/Gy+BkC;E+Gx+BlC,4BAAA;EACA,sCAAA;EAAA,uEAAA;E9GjOE,uBAAA;EAAA,sCAAA;E8GmOF,sMpHlImB;AD4lfrB;AqHx9eE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gB/G+W0B;E+G9W1B,c/Gs+BgC;E+Gt+BhC,2B/Gs+BgC;E+Gr+BhC,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;ArH09eJ;AqHx9eI;EAEE,yBAAA;EAAA,sCAAA;EACA,qBAAA;EACA,mBpHzJmB;ADknfzB;;AqHp9eA;EACE,cAAA;ArHu9eF;AqHr9eE;EACE,cpHnOI;AD0rfR;;AqHj9eA;EACE,WAAA;ArHo9eF;;AqHj9eA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yBpHlPM;EM5BJ,mBAAA;E8GgRF,yDAAA;EACA,UAAA;ArHo9eF;;AqHh9eE;EACE,kBAAA;ArHm9eJ;AqHj9eI;EACE,eAAA;EACA,mBAAA;ArHm9eN;AqHj9eM;EACE,oBAAA;EACA,gBAAA;ArHm9eR;AqH98eE;EACE,qCAAA;EACA,oBAAA;ArHg9eJ;AqH78eE;EACE,a/G6FK;E+G5FL,SAAA;ArH+8eJ;AqH18eI;EACE,+BAAA;ArH48eN;AqH18eM;EACE,WpHrTA;ADiwfR;AqHx8eI;EACE,WpH1TE;ADowfR;AqHv8eI;EACE,oCAAA;ArHy8eN;;AqHn8eE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;ArHs8eJ;AqHp8eI;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;ArHs8eN;AqHl8eE;EACE,kBAAA;EACA,WxC7V8B;EwC8V9B,UAAA;ArHo8eJ;AqHj8eE;EACE,sBAAA;ArHm8eJ;AqHh8eE;EACE,WpH3VI;AD6xfR;AqH/7eE;EACE,YAAA;EACA,aAAA;E9G9VA,uBAAA;E8GgWA,iIAAA;ArHi8eJ;;AqH17eE;EACE,aAAA;ArH67eJ;AqH17eE;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;ArH47eJ;AqHz7eE;EACE,YAAA;ArH27eJ;;AqHv7eA;EACE,gCAAA;ArH07eF;AqHx7eE;EACE,qBAAA;EACA,mBAAA;EACA,kBpHjTa;AD2ufjB;AqHt7eI;EACE,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;ArHw7eN;AqHr7eI;EACE,WAAA;EACA,gBAAA;ArHu7eN;;AqHh7eE;;EACE,SAAA;EACA,UAAA;EACA,kBAAA;ArHo7eJ;AqHl7eI;;;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;ArHq7eN;AqHl7eI;;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;ArHo7eN;;AqH56eE;EACE,UAAA;EACA,YAAA;ArH+6eJ;AqH76eI;EACE,kB/G+KwB;E+G9KxB,gBAAA;ArH+6eN;AqH56eI;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;ArH86eN;AqH36eI;EACE,SAAA;ArH66eN;AqH36eM;EACE,iBAAA;EACA,+BAAA;EACA,mBpHxcG;ADq3fX;AqH36eQ;EACE,gBpH5cF;ADy3fR;AqH56eU;EACE,WpHpcJ;EoHqcI,YAAA;ArH86eZ;AqH16eQ;EACE,gBpHpdF;EoHqdE,gBAAA;ArH46eV;AqHz6eQ;EACE,gBpHzdF;ADo4fR;AqHz6eU;EACE,WpHldJ;EoHmdI,YAAA;ArH26eZ;AqHr6eQ;EACE,eAAA;ArHu6eV;;AsH15fA;E/GiBI,uBAAA;E+GfF,yBAAA;AtH65fF;AsH35fE;EACE,+BAAA;AtH65fJ;AsH35fI;EACE,aAAA;EACA,YAAA;AtH65fN;AsH35fM;;;EAGE,qBAAA;AtH65fR;AsHz5fQ;EACE,SAAA;AtH25fV;AsHt5fI;EACE,oCAAA;AtHw5fN;AsHt5fM;EACE,4BrHXG;ADm6fX;;AuHp7fA;;EAEE,mBtHcS;ADy6fX;;AuHp7fA;EhHmCI,oCAAA;EACA,mCAAA;APq5fJ;;AuHr7fA;EACE,+LtHiHsB;EM1GpB,uBAAA;APk7fJ;;AwHr8fA,sEAAA;AAoCA;;EAAA;AChCA;EACE;IACE,mBAAA;IACA,UAAA;EzHw8fF;EyHt8fA;IACE,qBAAA;IACA,YAAA;EzHw8fF;EyHt8fA;IACE,mBAAA;IACA,UAAA;EzHw8fF;AACF;AyHl8fI;EACE,0EAAA;AzHo8fN;AyHr8fI;EACE,0EAAA;AzHu8fN;AyHx8fI;EACE,0EAAA;AzH08fN;AyH38fI;EACE,sEAAA;AzH68fN;AyHr8fE;EC9BA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;ED8BE,qBAAA;AzH08fJ;;A2Hv+fA;EACE;IACE,2BAAA;E3H0+fF;E2Hx+fA;IACE,4BAAA;E3H0+fF;E2Hx+fA;IACE,wBAAA;E3H0+fF;AACF;A2Hr+fI;EACE,2DAAA;A3Hu+fN;A2Hx+fI;EACE,2DAAA;A3H0+fN;A2H3+fI;EACE,2DAAA;A3H6+fN;A2H9+fI;EACE,uDAAA;A3Hg/fN;A2Hx+fE;ED5BA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EC4BE,qBAAA;A3H6+fJ;;A4H3ggBA;EACE;IACE,mBAAA;E5H8ggBF;E4H5ggBA;IACE,mBAAA;IACA,UAAA;E5H8ggBF;AACF;A4HzggBE;EFdA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EEcE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gDAAA;A5H8ggBJ;;A6HjigBA;EACE;IACE,uBAAA;E7HoigBF;E6HligBA;IACE,yBAAA;E7HoigBF;E6HligBA;IACE,yBAAA;E7HoigBF;AACF;A6HjigBA;EACE,kBAAA;A7HmigBF;A6HjigBE;EHjBA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EGiBE,kBAAA;A7HsigBJ;A6HpigBI;EACE,qEAAA;A7HsigBN;A6HnigBI;EH3BF,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EK2BH,WAAA;EACA,kBAAA;EACA,YAAA;A7HwigBN;A6HrigBI;EACE,QAAA;EACA,WAAA;A7HuigBN;A6HpigBI;EACE,QAAA;EACA,UAAA;A7HsigBN;;A8H9kgBA;EACE;IACE,gCAAA;E9HilgBF;E8H/kgBA;IACE,oCAAA;E9HilgBF;E8H/kgBA;IACC,kCAAA;E9HilgBD;AACF;A8H5kgBE;EJhBA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EIgBE,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;A9HilgBJ;;A+HzmgBA;EACE;IACE,gCAAA;E/H4mgBF;E+H1mgBA;IACE,oCAAA;E/H4mgBF;E+H1mgBA;IACC,kCAAA;E/H4mgBD;AACF;A+HzmgBA;EACE;IACE,qBAAA;E/H2mgBF;E+HzmgBA;IACE,mBAAA;E/H2mgBF;AACF;A+HxmgBA;EACE,kBAAA;EACA,4BAAA;A/H0mgBF;A+HxmgBE;ELvBA,yBAAA;EK0BE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/HymgBJ;A+HvmgBI;EACE,mB9HUE;E8HTF,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,mEAAA;A/HymgBN;A+HtmgBI;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,qDAAA;EACA,oEAAA;EACA,sBAAA;A/HwmgBN;;AgI7pgBA;EACE;IACE,gCAAA;EhIgqgBF;EgI9pgBA;IACE,oCAAA;EhIgqgBF;EgI9pgBA;IACC,kCAAA;EhIgqgBD;AACF;AgI7pgBA;EACE,kBAAA;AhI+pgBF;AgI7pgBE;ENbA,yBAAA;EMgBE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;AhI8pgBJ;AgI5pgBI;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,qDAAA;EACA,4BAAA;AhI8pgBN;;AiInsgBA;EACE;IACE,qBAAA;IACA,UAAA;EjIssgBF;EiIpsgBA;IACE,mBAAA;IACA,YAAA;EjIssgBF;EiIpsgBA;IACE,UAAA;EjIssgBF;AACF;AiIjsgBE;EPdA,yBAAA;EOiBE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EAAA;AjIksgBJ;;AkIttgBA;EACE;IACE,qBAAA;IACA,UAAA;ElIytgBF;EkIvtgBA;IACE,mBAAA;IACA,YAAA;ElIytgBF;EkIvtgBA;IACE,UAAA;ElIytgBF;AACF;AkI9sgBA;EAGE,kBAAA;EACA,4BAAA;AlI8sgBF;AkIxtgBI;EACE,sBAAA;AlI0tgBN;AkI3tgBI;EACE,sBAAA;AlI6tgBN;AkI9tgBI;EACE,sBAAA;AlIgugBN;AkIjugBI;EACE,sBAAA;AlImugBN;AkIxtgBE;ER7BA,yBAAA;EQgCE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WApCG;EAqCH,YArCG;EAsCH,mBAAA;EACA,yBAAA;EACA,2FAAA;AlIytgBJ;;AmIlwgBA;EACE;IACE,YAAA;IACA,sBAAA;EnIqwgBF;EmInwgBA;IACE,UAAA;IACA,mBAAA;EnIqwgBF;AACF;AmIhwgBE;ETfA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;ESeE,qBAAA;EACA,4CAAA;AnIqwgBJ;AmInwgBI;EACE,kCAAA;AnIqwgBN;;AoIvxgBA;EACE;IACE,mBAAA;IACA,UAAA;EpI0xgBF;EoIxxgBA;IACE,UAAA;EpI0xgBF;EoIxxgBA;IACE,mBAAA;IACA,UAAA;EpI0xgBF;AACF;AoI/wgBA;EAGE,kBAAA;EACA,4BAAA;ApI+wgBF;AoIzxgBI;EACE,sBAAA;ApI2xgBN;AoI5xgBI;EACE,sBAAA;ApI8xgBN;AoInxgBE;EVjCA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EUiCE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAvCG;EAwCH,YAxCG;EAyCH,oDAAA;ApIwxgBJ;;AqIh0gBA;EACE;IACE,iCAAA;ErIm0gBF;EqIj0gBA;IACE,+BAAA;ErIm0gBF;EqIj0gBA;IACE,8BAAA;ErIm0gBF;AACF;AqIh0gBA;EACE;IACE,gCAAA;ErIk0gBF;EqIh0gBA;IACE,iCAAA;ErIk0gBF;EqIh0gBA;IACE,8BAAA;ErIk0gBF;AACF;AqI/zgBA;EACE;IACE,gCAAA;ErIi0gBF;EqI/zgBA;IACE,kCAAA;ErIi0gBF;EqI/zgBA;IACE,8BAAA;ErIi0gBF;AACF;AqIhzgBA;EACE,kBAAA;EAEA,wDAAA;ArIizgBF;AqI9zgBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;ArIg0gBN;AqIr0gBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;ArIu0gBN;AqI50gBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;ArI80gBN;AqIp0gBE;EXvDA,yBAAA;EW0DE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;ArIq0gBJ;AqIn0gBI;EACE,SAnEG;ArIw4gBT;AqIl0gBI;EACE,UAAA;ArIo0gBN;AqIj0gBI;EACE,SA3EG;EA4EH,UA5EG;ArI+4gBT;;AsI74gBA;EACE;IACE,qBAAA;EtIg5gBF;EsI94gBA;IACE,4BAAA;EtIg5gBF;EsI94gBA;IACE,qBAAA;EtIg5gBF;EsI94gBA;IACE,2BAAA;EtIg5gBF;EsI94gBA;IACE,wBAAA;IACA,mBAAA;EtIg5gBF;AACF;AsI74gBA;EACE;IACE,qBAAA;EtI+4gBF;EsI74gBA;IACE,2BAAA;EtI+4gBF;EsI74gBA;IACE,qBAAA;EtI+4gBF;EsI74gBA;IACE,4BAAA;EtI+4gBF;EsI74gBA;IACE,wBAAA;IACA,sBAAA;EtI+4gBF;AACF;AsI14gBE;EZ5CA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EY4CE,qBAAA;EACA,sBAAA;EACA,6DAAA;EACA,mCAAA;EACA,kBAAA;AtI+4gBJ;AsI74gBI;EACE,oCAAA;AtI+4gBN;AsI54gBI;EACE,mCAAA;AtI84gBN;;AuIv8gBA;EACE;IACE,YAAA;EvI08gBF;EuIx8gBA;IACE,UAAA;EvI08gBF;AACF;AuI77gBA;EAEE,WAAA;AvI87gBF;AuIx8gBI;EACE,sBAAA;EACA,yBAAA;AvI08gBN;AuI58gBI;EACE,sBAAA;EACA,yBAAA;AvI88gBN;AuIh9gBI;EACE,sBAAA;EACA,yBAAA;AvIk9gBN;AuIp9gBI;EACE,sBAAA;EACA,yBAAA;AvIs9gBN;AuIx9gBI;EACE,sBAAA;EACA,yBAAA;AvI09gBN;AuI59gBI;EACE,sBAAA;EACA,yBAAA;AvI89gBN;AuIh+gBI;EACE,sBAAA;EACA,yBAAA;AvIk+gBN;AuIp+gBI;EACE,sBAAA;EACA,yBAAA;AvIs+gBN;AuIx+gBI;EACE,sBAAA;EACA,yBAAA;AvI0+gBN;AuIh+gBE;EbzBA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EayBE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mCAAA;EACA,kBAAA;AvIq+gBJ;;AwIpghBA;EACE;IACE,mBAAA;ExIughBF;EwIrghBA;IACE,qBAAA;IACA,YAAA;ExIughBF;EwIrghBA;IACE,mBAAA;IACA,UAAA;ExIughBF;AACF;AwI1/gBA;EAEE,WAAA;AxI2/gBF;AwIrghBI;EACE,sBAAA;EACA,yBAAA;AxIughBN;AwIzghBI;EACE,uBAAA;EACA,yBAAA;AxI2ghBN;AwI7ghBI;EACE,sBAAA;EACA,wBAAA;AxI+ghBN;AwIjhhBI;EACE,sBAAA;EACA,yBAAA;AxImhhBN;AwIrhhBI;EACE,uBAAA;EACA,yBAAA;AxIuhhBN;AwIzhhBI;EACE,uBAAA;EACA,yBAAA;AxI2hhBN;AwI7hhBI;EACE,sBAAA;EACA,wBAAA;AxI+hhBN;AwIjihBI;EACE,sBAAA;EACA,yBAAA;AxImihBN;AwIrihBI;EACE,uBAAA;EACA,yBAAA;AxIuihBN;AwI7hhBE;Ed9BA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;Ec8BE,qBAAA;EACA,WAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;AxIkihBJ;;AyInkhBA;EACE;IACE,YAAA;IACA,qBAAA;EzIskhBF;EyIpkhBA;IACE,UAAA;IACA,mBAAA;EzIskhBF;AACF;AyI9hhBA;EAGE,kBAAA;EACA,UAAA;EACA,WAAA;AzI8hhBF;AyItkhBI;EAKI,SApBC;EAqBD,OAAA;EAwBF,0DAAA;AzI6ihBN;AyI3khBI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,0DAAA;AzIkjhBN;AyIhlhBI;EAWI,MAAA;EACA,UA3BC;EA6CH,0DAAA;AzIujhBN;AyIrlhBI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,yDAAA;AzI4jhBN;AyI1lhBI;EAiBI,UAAA;EACA,OAAA;EAYF,0DAAA;AzIikhBN;AyI/lhBI;EAoBI,qBAAA;EACA,sBAAA;EASF,0DAAA;AzIskhBN;AyIpmhBI;EAuBI,MAAA;EACA,WAAA;EAMF,0DAAA;AzI2khBN;AyIzmhBI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,0DAAA;AzIglhBN;AyIpkhBE;Ef5DA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;Ee4DE,kBAAA;AzIykhBJ;;A0IrohBA;EACE;IACE,YAAA;E1IwohBF;E0ItohBA;IACE,UAAA;E1IwohBF;AACF;A0IhmhBA;EAEE,kBAAA;A1IimhBF;A0ItohBI;EAKI,SAlBC;EAmBD,OAAA;EAwBF,mDAAA;A1I6mhBN;A0I3ohBI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,mDAAA;A1IknhBN;A0IhphBI;EAWI,MAAA;EACA,UAzBC;EA2CH,mDAAA;A1IunhBN;A0IrphBI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,mDAAA;A1I4nhBN;A0I1phBI;EAiBI,UAAA;EACA,OAAA;EAYF,mDAAA;A1IiohBN;A0I/phBI;EAoBI,qBAAA;EACA,sBAAA;EASF,mDAAA;A1IsohBN;A0IpqhBI;EAuBI,MAAA;EACA,WAAA;EAMF,mDAAA;A1I2ohBN;A0IzqhBI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,mDAAA;A1IgphBN;A0IvohBE;EhBlDA,yBAAA;EgBqDE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;A1IwohBJ;;A2IjshBA;EACE;IACE,kCAAA;E3IoshBF;E2IlshBA;IACE,iCAAA;E3IoshBF;E2IlshBA;IACE,0BAAA;E3IoshBF;AACF;A2IjshBA;EACE;IACE,gCAAA;E3ImshBF;E2IjshBA;IACE,iCAAA;E3ImshBF;E2IjshBA;IACE,0BAAA;E3ImshBF;AACF;A2IhshBA;EACE,kBAAA;EACA,kCAAA;A3IkshBF;A2IhshBE;EjBhCA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EiBgCE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;A3IqshBJ;A2InshBI;EACE,2CAAA;A3IqshBN;A2IlshBI;EACE,2CAAA;A3IoshBN;;A4I9uhBA;EACE;IACE,kCAAA;E5IivhBF;E4I/uhBA;IACE,iCAAA;E5IivhBF;E4I/uhBA;IACE,0BAAA;E5IivhBF;E4I/uhBA;IACE,iCAAA;E5IivhBF;E4I/uhBA;IACE,kCAAA;E5IivhBF;E4I/uhBA;IACE,0BAAA;E5IivhBF;AACF;A4I9uhBA;EACE;IACE,gCAAA;E5IgvhBF;E4I9uhBA;IACE,iCAAA;E5IgvhBF;E4I9uhBA;IACE,0BAAA;E5IgvhBF;E4I9uhBA;IACE,iCAAA;E5IgvhBF;E4I9uhBA;IACE,gCAAA;E5IgvhBF;E4I9uhBA;IACE,0BAAA;E5IgvhBF;AACF;A4I7uhBA;EACE,kBAAA;EACA,kCAAA;A5I+uhBF;A4I7uhBE;ElBlDA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;EECP,yBAAA;EkBkDE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;A5IkvhBJ;A4IhvhBI;EACE,mDAAA;A5IkvhBN;A4I/uhBI;EACE,mDAAA;A5IivhBN;;AwHvvhBA;;EAAA;AqBvDA;EACE;IACE,oBAAA;E7IozhBF;E6IlzhBA;IACE,sBAAA;E7IozhBF;E6IlzhBA;IACE,oBAAA;E7IozhBF;AACF;A6I/yhBI;EACE,2EAAA;A7IizhBN;A6IlzhBI;EACE,2EAAA;A7IozhBN;A6IrzhBI;EACE,2EAAA;A7IuzhBN;A6IxzhBI;EACE,2EAAA;A7I0zhBN;A6I3zhBI;EACE,wEAAA;A7I6zhBN;A6IrzhBE;EnB1BA,yBzH8CM;EyH3BN,UFdW;EEeX,YFhBY;EEiBZ,kBAAA;EACA,WFnBO;EECP,yBAAA;EmB0BE,qBAAA;A7I0zhBJ;;A8It1hBA;EACE;IACE,mBAAA;E9Iy1hBF;E8Iv1hBA;IAEE,qBAAA;E9Iw1hBF;E8It1hBA;IACE,mBAAA;E9Iw1hBF;AACF;A8In1hBI;EACE,qBAAA;EACA,yBAAA;A9Iq1hBN;A8Iv1hBI;EACE,qBAAA;EACA,yBAAA;A9Iy1hBN;A8I31hBI;EACE,sBAAA;EACA,yBAAA;A9I61hBN;A8I/1hBI;EACE,uBAAA;EACA,yBAAA;A9Ii2hBN;A8Iz1hBE;EpB3BA,yBzH8CM;EyH3BN,UFdW;EEeX,YFhBY;EEiBZ,kBAAA;EACA,WFnBO;EECP,yBAAA;EoB2BE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;A9I81hBJ;;A+I73hBA;EACE;IACE,oBAAA;E/Ig4hBF;E+I93hBA;IACE,sBAAA;E/Ig4hBF;E+I93hBA;IACE,oBAAA;E/Ig4hBF;AACF;A+I33hBE;ErBjBA,yBzH8CM;EyH3BN,UFdW;EEeX,YFhBY;EEiBZ,kBAAA;EACA,WFnBO;EECP,yBAAA;EqBiBE,qBAAA;EACA,wFAAA;A/Ig4hBJ;A+I93hBI;EACE,iCAAA;A/Ig4hBN;A+I73hBI;EACE,iCAAA;A/I+3hBN;;AgJ15hBA;EACE;IACE,oBAAA;EhJ65hBF;EgJ35hBA;IACE,sBAAA;EhJ65hBF;EgJ35hBA;IACE,oBAAA;EhJ65hBF;AACF;AgJx5hBE;EtBhBA,yBzH8CM;EyH3BN,UFdW;EEeX,YFhBY;EEiBZ,kBAAA;EACA,WFnBO;EECP,yBAAA;EsBgBE,qBAAA;EACA,sBAAA;EACA,8FAAA;AhJ65hBJ;AgJ35hBI;EACE,kCAAA;AhJ65hBN;AgJ15hBI;EACE,8BAAA;AhJ45hBN;;AiJp7hBA;EACE;IACE,YAAA;EjJu7hBF;EiJr7hBA;IACE,UAAA;EjJu7hBF;AACF;AiJz4hBA;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;AjJ04hBF;AiJv7hBI;EAKI,SAlBC;EAmBD,OAAA;EA8BF,iEAAA;AjJw5hBN;AiJ57hBI;EAQI,oBANQ;EAOR,qBAPQ;EAQR,yBAAA;EA0BF,iEAAA;AjJ85hBN;AiJl8hBI;EAYI,MAAA;EACA,UA1BC;EA2BD,wBAAA;EAsBF,gEAAA;AjJo6hBN;AiJx8hBI;EAgBI,qBAAA;EACA,qBAfQ;EAgBR,wBAAA;EAkBF,iEAAA;AjJ06hBN;AiJ98hBI;EAoBI,UAAA;EACA,OAAA;EAeF,iEAAA;AjJ+6hBN;AiJn9hBI;EAuBI,qBAAA;EACA,sBAAA;EACA,yBAAA;EAWF,iEAAA;AjJq7hBN;AiJz9hBI;EA2BI,MAAA;EACA,WAAA;EACA,wBAAA;EAOF,iEAAA;AjJ27hBN;AiJ/9hBI;EA+BI,oBA7BQ;EA8BR,sBAAA;EACA,wBAAA;EAGF,6DAAA;AjJi8hBN;AiJt7hBE;EvB/DA,yBzH8CM;EyH3BN,UFdW;EEeX,YFhBY;EEiBZ,kBAAA;EACA,WFnBO;EECP,yBAAA;EuB+DE,kBAAA;EACA,UAAA;EACA,YAAA;AjJ27hBJ;;AwH77hBA;;EAAA;A0B/DA;EACE;IACE,wDAAA;ElJkgiBF;EkJhgiBA;IACE,6DAAA;ElJkgiBF;EkJhgiBA;IACE,wDAAA;ElJkgiBF;EkJhgiBA;IACE,mDAAA;ElJkgiBF;AACF;AkJ7/hBE;ExBjBA,yBAAA;EwBoBE,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gFAAA;AlJ8/hBJ;;AmJzhiBA;EACE;IACE,wDAAA;EnJ4hiBF;EmJ1hiBA;IACE,6DAAA;EnJ4hiBF;EmJ1hiBA;IACE,wDAAA;EnJ4hiBF;EmJ1hiBA;IACE,mDAAA;EnJ4hiBF;AACF;AmJvhiBE;EzBfA,yBAAA;EyBkBE,WAAA;EACA,YAAA;EACA,mBlJsBI;EkJrBJ,yEAAA;AnJwhiBJ;;AoJ5iiBA;EACI;IACK,yBAAA;EpJ+iiBP;EoJ7iiBE;IACK,yBAAA;EpJ+iiBP;EoJ7iiBE;IACK,yBAAA;EpJ+iiBP;AACF;AoJ5iiBA;EACI;IACK,wBAAA;EpJ8iiBP;EoJ5iiBE;IACK,uBAAA;EpJ8iiBP;EoJ5iiBE;IACK,wBAAA;EpJ8iiBP;AACF;AoJjiiBA;EACE;IACE,YAAA;EpJmiiBF;EoJjiiBA;IACE,qCAAA;EpJmiiBF;AACF;AoJxhiBA;EAGE,kBAAA;ApJwhiBF;AoJjiiBI;EACE,iDAAA;ApJmiiBN;AoJpiiBI;EACE,iDAAA;ApJsiiBN;AoJviiBI;EACE,iDAAA;ApJyiiBN;AoJ1iiBI;EACE,6CAAA;ApJ4iiBN;AoJliiBE;EA/BE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EA4DH,iDAAA;EACA,kBAAA;EACA,WAAA;ApJ0iiBJ;AoJviiBE;EAtCE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EAmEH,mDAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;ApJ+iiBJ;AoJ5iiBE;;;;E1B5EA,yBzH8CM;EyHpCN,WFRU;EESV,YFTU;EEUV,mBAAA;EACA,WFVO;E4B+EL,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;ApJgjiBJ;;AqJnoiBA;EACE;IACE,qDAAA;ErJsoiBF;EqJpoiBA;IACE,gDAAA;ErJsoiBF;EqJpoiBA;IACE,sDAAA;ErJsoiBF;EqJpoiBA;IACE,0BAAA;ErJsoiBF;AACF;AqJnoiBA;EACE,kBAAA;EACA,kCAAA;ArJqoiBF;AqJnoiBE;E3BpBA,yBAAA;E2BuBE,WAxBG;EAyBH,YAzBG;EA0BH,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBpJcI;EoJbJ,uDAAA;ArJooiBJ;AqJloiBI;EACE,sBAAA;ArJooiBN;;AsJnqiBA;EACE;IACE,uBAAA;EtJsqiBF;EsJpqiBA;IACE,yBAAA;EtJsqiBF;EsJpqiBA;IACE,yBAAA;EtJsqiBF;AACF;AsJnqiBA;EACE,kBAAA;EACA,WAjBK;EAkBL,YAlBK;EAmBL,gBAAA;AtJqqiBF;AsJnqiBE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6FAAA;EACA,WAAA;EACA,YAAA;AtJqqiBJ;;AuJ/riBI;EhJ8BA,iCAAA;EAAA,gDAAA;EACA,oCAAA;EAAA,mDAAA;APqqiBJ;AuJ/riBE;EACE,cAAA;AvJisiBJ;AuJ9riBE;EACE,cAAA;AvJgsiBJ;AuJ7riBE;EhJCE,mBAAA;AP+riBJ;;AuJzriBE;;EAEE,kBAAA;AvJ4riBJ;AuJ1riBI;;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBtJpBE;EsJqBF,2CAAA;AvJ6riBN;;AuJxriBA;EACE;IACE,YAAA;IACA,QAAA;EvJ2riBF;EuJzriBA;IACE,UAAA;IACA,WAAA;EvJ2riBF;AACF;AwJ5uiBA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;AxJ8uiBF;AwJ5uiBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AxJ8uiBJ;AwJ3uiBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBvJDO;EMAP,uBAAA;AP+uiBJ;;AwJzuiBA;EACE,kBAAA;EACA,gBAAA;AxJ4uiBF;AwJ1uiBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AxJ4uiBJ;AwJzuiBE;EACE,gBAAA;AxJ2uiBJ;;AwJvuiBA;EACE,kBAAA;EACA,iBAAA;EACA,iBvJuDa;ADmriBf;AwJxuiBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AxJ0uiBJ;AwJvuiBE;EACE,iBvJ8CW;EuJ7CX,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AxJyuiBJ;AwJtuiBE;EACE,cvJrCO;EuJsCP,kBAAA;AxJwuiBJ;AwJruiBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,mBAAA;EACA,iBAAA;EACA,cvJjDO;EuJkDP,0BAAA;EACA,mBAAA;AxJuuiBJ;;AwJnuiBA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AxJsuiBF;AwJpuiBE;EACE,0BAAA;AxJsuiBJ;;AwJluiBA;EACE,eAAA;EACA,gBAAA;AxJquiBF;AwJnuiBE;EACE,aAAA;AxJquiBJ;;AwJhuiBE;EACE,UAAA;AxJmuiBJ;AwJhuiBE;EACE,iBAAA;AxJkuiBJ;AwJ/tiBE;EACE,SAAA;AxJiuiBJ;;AwJ7tiBA;EACE,iBAAA;AxJguiBF;AwJ9tiBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBvJrGO;EMAP,uBAAA;APs0iBJ;AwJ7tiBE;EACE,mBlJ4RK;ANm8hBT;AwJ5tiBE;EACE,iBAAA;AxJ8tiBJ;AwJ3tiBE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;AxJ6tiBJ;AwJ3tiBI;EACE,WAAA;EACA,YAAA;EACA,gBvJ5HE;EMEJ,mBAAA;EiJ4HE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AxJ6tiBN;AwJ3tiBM;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AxJ6tiBR;AwJ1tiBM;EACE,cAAA;AxJ4tiBR;;AwJptiBA;EACE,iBAAA;AxJutiBF;AwJrtiBE;EACE,kBAAA;AxJutiBJ;AwJptiBE;EACE,mBAAA;EACA,0BAAA;EACA,UAAA;AxJstiBJ;AwJntiBE;EACE,YAAA;EACA,WAAA;EACA,mBvJnKO;EuJoKP,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EjJvKA,mBAAA;AP63iBJ;AwJntiBI;EACE,WAAA;EACA,kBAAA;EACA,gBvJ/KE;EuJgLF,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EjJnLF,mBAAA;APy4iBJ;AwJjtiBE;EACE,oBAAA;AxJmtiBJ;;AwJ7siBI;EACE,mBvJ7HS;AD60iBf;;AwJjtiBI;EACE,mBvJ7HS;ADi1iBf;;AwJrtiBI;EACE,mBvJ7HS;ADq1iBf;;AwJztiBI;EACE,mBvJ7HS;ADy1iBf;;AwJ7tiBI;EACE,mBvJ7HS;AD61iBf;;AwJjuiBI;EACE,mBvJ7HS;ADi2iBf;;AwJruiBI;EACE,mBvJ7HS;ADq2iBf;;AwJzuiBI;EACE,mBvJ7HS;ADy2iBf;;AwJ7uiBI;EACE,mBvJ7HS;AD62iBf;;AwJjviBI;EACE,mBvJ7HS;ADi3iBf;;AwJxuiBA;EACE,kBAAA;AxJ2uiBF;;AwJxuiBA;EACE,mBAAA;EACA,2BAAA;AxJ2uiBF;AwJtsiBA;EACE;IACE,UAAA;IAKA,qBAAA;ExJmuiBF;EwJhuiBA;IACE,UAAA;IAKA,qBAAA;ExJkuiBF;EwJ/tiBA;IAKE,mBAAA;ExJiuiBF;AACF;AwJ7tiBA;EACE,kBAAA;AxJ+tiBF;;AwJ5tiBA;EACE,mBAAA;EAGA,2BAAA;AxJ+tiBF;;AwJ5tiBA;EACE;IAGE,mCAAA;ExJ+tiBF;AACF;AwJ3tiBA;EACE;IACE,mBAAA;IAGA,mCAAA;ExJ6tiBF;AACF;AwJvriBA;EACE;IACE,UAAA;IAKA,6BAAA;ExJmtiBF;EwJhtiBA;IACE,UAAA;IAKA,2BAAA;ExJktiBF;EwJ/siBA;IAKE,wBAAA;ExJitiBF;AACF;AwJ3qiBA;EACE;IACE,UAAA;IAKA,4BAAA;ExJusiBF;EwJpsiBA;IACE,UAAA;IAKA,4BAAA;ExJssiBF;EwJnsiBA;IAKE,wBAAA;ExJqsiBF;AACF;AyJ/njBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;ElJWA,qBAAA;EkJTA,YAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;AzJiojBJ;AyJ5njBM;EACE,YAAA;AzJ8njBR;AyJznjBE;;EAEE,mBAAA;AzJ2njBJ;;AyJvnjBA;EACE,aAAA;AzJ0njBF;;AyJtnjBE;EACE,SAAA;EACA,0BAAA;AzJynjBJ;;AyJpnjBE;EACE,SAAA;EACA,qBAAA;AzJunjBJ;;A0J7pjBM;EnJ2CF,yBAAA;EACA,4BAAA;EAfA,4CAAA;EAAA,2DAAA;EACA,+CAAA;EAAA,8DAAA;APsojBJ;A0J7pjBE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A1J+pjBJ;A0J5pjBM;EnJgBF,0BAAA;EACA,6BAAA;AP+ojBJ;;A0JtpjBI;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A1JypjBN;A0JrpjBE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;A1JupjBJ;A0JrpjBI;EnJQA,yBAAA;EACA,4BAAA;APgpjBJ;;A0JjpjBA;EACE,kBzJ6Ce;EyJ5Cf,iBAAA;A1JopjBF;;A0J/ojBA;EACE,iBzJuCa;EyJtCb,SAAA;EACA,czJZM;AD8pjBR;A0JhpjBE;EACE,czJvCO;EyJwCP,mBAAA;EACA,kBzJ+Ba;ADmnjBjB;;A0J9ojBA;EACE,wBAAA;EACA,qBAAA;A1JipjBF;;A2J7sjBI;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,oCAAA;EAEA,crJowC8B;EqJpwC9B,2BrJowC8B;EqJnwC9B,sBrJowC8B;EqJpwC9B,mCrJowC8B;EqJnwC9B,yBAAA;EAAA,2DAAA;A3J+sjBN;A2J7sjBM;EACE,UAAA;EACA,6BrJ0wC4B;EqJ1wC5B,iCrJ0wC4B;EqJzwC5B,qBAAA;EACA,yBrJywC4B;EqJzwC5B,uCrJywC4B;EqJxwC5B,qBrJywC4B;EqJzwC5B,oCrJywC4B;ANs8gBpC;A2J5sjBM;EACE,UAAA;EACA,UrJgwC4B;EqJ/vC5B,gB1JyEsB;ADqojB9B;A2J1sjBM;EACE,eAAA;A3J4sjBR;A2JvsjBM;EACE,cAAA;EpJOJ,gCAAA;EACA,mCAAA;APmsjBJ;A2JtsjBM;EpJZF,iCAAA;EACA,oCAAA;APqtjBJ;A2JrsjBI;EACE,UAAA;EACA,W1JrCE;E0JsCF,yB1JRE;E0JSF,qB1JTE;ADgtjBR;A2JrsjBM;EACE,W1J1CA;ADivjBR;A2JnsjBI;EACE,6BrJwuC8B;EqJxuC9B,gCrJwuC8B;EqJvuC9B,oBAAA;EAEA,YAAA;EACA,yBrJquC8B;EqJruC9B,wCrJquC8B;EqJpuC9B,qBrJquC8B;EqJruC9B,oCrJquC8B;AN+9gBpC;;A2J5rjBE;EpJ1DE,8BAAA;EoJ4DA,gBAAA;A3J+rjBJ;;A4J1wjBA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;A5J6wjBF;A4J3wjBE;EACE,cAAA;A5J6wjBJ;A4J1wjBE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mB3J+FqB;E2J9FrB,SAAA;EACA,uBAAA;ErJAA,mBAAA;EqJEA,gCtJ6gB0B;EsJ5gB1B,SAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;A5J4wjBJ;A4J1wjBI;EACE,gBAAA;EACA,mBAAA;EACA,mB/EzB4B;E+E0B5B,cAAA;A5J4wjBN;A4JxwjBE;EACE,iBAAA;A5J0wjBJ;A4JxwjBI;ErJpBA,mBAAA;EqJsBE,4BAAA;EACA,iCtJwfwB;EsJvfxB,iBAAA;A5J0wjBN;A4JxwjBM;EACE,iBAAA;EACA,oB/EzC0B;E+E0C1B,cAAA;A5J0wjBR;;A6JtzjBA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EtJSE,uBAAA;APizjBJ;A6JvzjBE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,c5JEO;E4JDP,kBAAA;A7JyzjBJ;A6JvzjBI;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mB5JXK;E4JYL,UAAA;EACA,oBAAA;A7JwzjBN;A6JrzjBI;EACE,SAAA;A7JuzjBN;A6JpzjBI;EACE,OAAA;A7JszjBN;A6JlzjBM;EtJIF,4BAAA;EACA,+BAAA;APizjBJ;A6JhzjBM;EtJhBF,6BAAA;EACA,gCAAA;APm0jBJ;A6J/yjBI;EACE,kBAAA;EACA,kBvJikBwB;EuJhkBxB,mB5JtCK;E4JuCL,W5J3CE;E4J4CF,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EtJ9CF,mBAAA;EsJgDE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;A7JizjBN;A6J9yjBI;EACE,c5JnDK;ADm2jBX;A6J/yjBM;EACE,mB5J9BA;AD+0jBR;A6J9yjBM;EACE,mB5JlCA;ADk1jBR;A6J3yjBM;EACE,+BAAA;EAEA,mB5JlCA;E4JmCA,gBAAA;A7J4yjBR;A6J3yjBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;A7J6yjBV;A6JzyjBM;EAEE,mB5JhDA;AD01jBR;A6JtyjBI;EACE,c5JrFK;AD63jBX;;A6J9xjBI;EACE,kB5JxBW;ADyzjBjB;A6J/xjBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;A7JiyjBR;;A6JzxjBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;A7J4xjBJ;A6J1xjBI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EtJhIF,qBAAA;EsJkIE,oBAAA;A7J4xjBN;A6J1xjBM;EAEE,aAAA;A7J2xjBR;A6JxxjBM;EACE,qBAAA;A7J0xjBR;A6JvxjBM;EACE,mB5J9IG;ADu6jBX;A6JtxjBM;EACE,mB5JtHA;E4JuHA,W5JrJA;AD66jBR;A6JtxjBQ;EACE,oCAAA;A7JwxjBV;A6JlxjBE;EACE,UAAA;EACA,cAAA;A7JoxjBJ;;A6JjxjBA;EAEI;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,0BAAA;E7JmxjBJ;E6JjxjBI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,qBAAA;ItJ/KJ,qBAAA;IsJiLI,oBAAA;E7JmxjBN;E6JjxjBM;IAEE,aAAA;E7JkxjBR;E6J/wjBM;IACE,qBAAA;E7JixjBR;E6J9wjBM;IACE,mB5J7LC;ED68jBT;E6J7wjBM;IACE,mB5JrKF;I4JsKE,W5JpMF;EDm9jBN;E6J7wjBQ;IACE,oCAAA;E7J+wjBV;E6JzwjBE;IACE,UAAA;IACA,cAAA;E7J2wjBJ;AACF;A8Jp+jBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;A9Js+jBF;;A8Jn+jBA;EACE,kBAAA;EACA,axJyYO;EwJxYP,kBAAA;A9Js+jBF;A8Jp+jBE;EACE,YAAA;EACA,gBAAA;A9Js+jBJ;A8Jn+jBE;EACE,eAAA;EACA,kBxJ+XK;ANsmjBT;A8Jn+jBI;EACE,iB7JqES;ADg6jBf;A8Jj+jBE;EACE,kBAAA;EACA,UAAA;A9Jm+jBJ;A8Jh+jBE;EACE,yBAAA;A9Jk+jBJ;A8Jh+jBI;EACE,gBAAA;A9Jk+jBN;A8J99jBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EvJVA,oCAAA;EAAA,mDAAA;EACA,mCAAA;EAAA,kDAAA;EuJWA,gBAAA;A9Ji+jBJ;A8J99jBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;A9Jg+jBJ;A8J99jBI;EAGE,mBAAA;A9J89jBN;A8J19jBE;EACE,mBAAA;EACA,cAAA;EACA,YAAA;A9J49jBJ;A8J19jBI;EACE,aAAA;A9J49jBN;A8Jz9jBI;EACE,kBAAA;A9J29jBN;A8Jv9jBE;EACE,gBAAA;A9Jy9jBJ;A8Jt9jBE;EACE,oBAAA;A9Jw9jBJ;A8Jt9jBI;EACE,WAAA;EACA,sBAAA;EACA,qMAAA;EAIA,eAAA;EACA,gB7JnFE;ADwikBR;A8Jj9jBE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;A9Jm9jBJ;A8Jj9jBI;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;A9Jm9jBN;A8J/8jBE;EACE,gBxJkSK;AN+qjBT;A8J/8jBI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;A9Ji9jBN;A8J/8jBM;EACE,mBAAA;A9Ji9jBR;A8J98jBM;EvJvGF,yBAAA;EACA,0BAAA;EAaA,oCAAA;EAAA,mDAAA;EACA,mCAAA;EAAA,kDAAA;AP4ikBJ;A8Jh9jBQ;EACE,mCxJ4rC0B;EwJ5rC1B,kDxJ4rC0B;ANsxhBpC;A8J38jBE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBxJsQK;ANusjBT;A8J38jBI;EACE,gBAAA;A9J68jBN;A8J18jBI;EACE,SAAA;A9J48jBN;A8Jz8jBI;EACE,aAAA;A9J28jBN;A8Jv8jBE;EACE,mBAAA;EACA,mBAAA;A9Jy8jBJ;A8Jv8jBI;EACE,eAAA;EACA,kBAAA;A9Jy8jBN;A8Jt8jBI;EACE,cAAA;A9Jw8jBN;A8Jr8jBI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;A9Ju8jBN;A8Jr8jBM;EACE,aAAA;A9Ju8jBR;A8Jp8jBM;EACE,sBAAA;A9Js8jBR;A8Jl8jBI;EACE,WAAA;A9Jo8jBN;A8Jh8jBE;EACE,mBAAA;A9Jk8jBJ;A8J/7jBE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;A9Ji8jBJ;;A8J77jBA;EACE,kBAAA;EACA,WxJwMO;EwJvMP,SxJuMO;EwJtMP,WAAA;A9Jg8jBF;A8J97jBE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;A9Jg8jBJ;;A8Jx7jBM;;EACE,UAAA;A9J47jBR;;A8Jn7jBM;EACE,gBxJimC4B;EwJjmC5B,6BxJimC4B;EC1zChC,uBAAA;APgpkBJ;;A8J/6jBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;EACA,gBAAA;A9Ji7jBF;A8J/6jBE;EACE,iBAAA;EACA,mBAAA;A9Ji7jBJ;A8J96jBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;A9Jg7jBJ;A8J96jBI;EACE,aAAA;A9Jg7jBN;A8J36jBE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;A9J66jBJ;A8J36jBI;EACE,gBAAA;A9J66jBN;A8Jz6jBE;EACE,WAAA;EACA,eAAA;A9J26jBJ;;A8Jt6jBE;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;A9Jy6jBJ;A8Jn6jBI;EACE,iBAAA;A9Jq6jBN;A8Jl6jBI;EACE,mBAAA;A9Jo6jBN;A8Jh6jBM;EACE,gBAAA;A9Jk6jBR;A8J75jBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;A9J+5jBJ;A8J75jBI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;A9J+5jBN;A8J55jBI;EACE,aAAA;A9J85jBN;;A8Jv5jBA;EACE,oCAAA;A9J05jBF;;A8Jr5jBA;EACE,kBAAA;A9Jw5jBF;A8Jt5jBE;EACE,kB7JzPa;E6J0Pb,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;A9Jw5jBJ;A8Jr5jBE;EACE,cAAA;A9Ju5jBJ;;A8Jn5jBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A9Js5jBF;A8Jp5jBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;A9Js5jBJ;;A8Jl5jBA;EACE,iBAAA;A9Jq5jBF;;A+JjwkBA;EACE,azJgZO;EyJ/YP,mBAAA;EACA,mBAAA;A/JowkBF;A+JlwkBE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;A/JowkBJ;A+J/vkBI;EACE,YAAA;EACA,iBAAA;A/JiwkBN;A+J9vkBI;EACE,YAAA;A/JgwkBN;A+J5vkBE;EACE,iBAAA;A/J8vkBJ;A+J3vkBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;A/J6vkBJ;A+J1vkBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;A/J4vkBJ;A+JzvkBE;EACE,gBzJwWK;ANm5jBT;A+JzvkBI;EACE,2BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;A/J2vkBN;A+JrvkBM;EACE,iBAAA;A/JuvkBR;A+JjvkBI;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;A/JmvkBN;A+J7ukBM;EACE,mBAAA;EACA,UAAA;A/J+ukBR;;AgK3zkBA;EACE,kBAAA;EACA,gBAAA;AhK8zkBF;AgK5zkBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AhK8zkBJ;AgK3zkBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AhK6zkBJ;AgKxzkBI;EACE,anFzB4B;A7Em1kBlC;AgKxzkBM;EACE,mBAAA;AhK0zkBR;AgKvzkBM;EACE,kBAAA;AhKyzkBR;AgKrzkBI;EACE,kBAAA;AhKuzkBN;AgKrzkBM;EACE,W/J5BA;E+J6BA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iB/J8CO;ADywkBf;AgKrzkBQ;EACE,oCAAA;AhKuzkBV;;AiK12kBA;EACE,YpFQgC;EoFPhC,WpFQgC;EoFPhC,oDAAA;AjK62kBF;;AiK12kBA;EACE,YpFEgC;EoFDhC,WpFEgC;EoFDhC,oDAAA;AjK62kBF;;AiKz2kBE;EACE,mBpFX8B;A7Eu3kBlC;AiKz2kBE;EACE,qBpFd8B;EoFe9B,mBAAA;AjK22kBJ;AiKz2kBI;EACE,YAAA;AjK22kBN;AiKx2kBI;EACE,iBhKoES;ADsykBf;;AkKx3kBM;EACE,WAAA;EACA,WAAA;AlK23kBR;AkKt3kBE;EACE,WAAA;EACA,erFjB8B;EqFkB9B,gBAAA;EAQA,gCAAA;AlKi3kBJ;AkKv3kBI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;AlKy3kBN;AkKn3kBE;EACE,erF9B8B;A7Em5kBlC;AkKn3kBI;E3JnBA,qBAAA;APy4kBJ;AkKj3kBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AlKm3kBJ;AkKj3kBI;EACE,SAAA;EACA,aAAA;AlKm3kBN;AkKj3kBM;EACE,+BAAA;EACA,gBAAA;EACA,SAAA;AlKm3kBR;AkKh3kBM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlKk3kBR;AkK/2kBM;EACE,aAAA;EACA,mBAAA;AlKi3kBR;AkK92kBM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AlKg3kBR;AkK72kBM;EACE,erFzE0B;EqF0E1B,6BAAA;AlK+2kBR;AkK32kBI;EACE,YAjF8B;EAkF9B,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AlK62kBN;AkK32kBM;EACE,mBAAA;AlK62kBR;AkK12kBM;EACE,+BAAA;EACA,gBAAA;EACA,mBjKnFG;EiKoFH,SAAA;EACA,+BAAA;EACA,8BAAA;AlK42kBR;AkKz2kBM;;EAEE,mBjK3FG;ADs8kBX;AkKv2kBI;EACE,WA7G8B;AlKs9kBpC;AkKr2kBE;EACE,WAAA;EACA,YAlHgC;AlKy9kBpC;;AkKl2kBE;EACE,6BAAA;AlKq2kBJ;AkKn2kBI;EACE,8BAAA;AlKq2kBN;;AmKj+kBI;EACE,YAL0B;EAM1B,eAAA;AnKo+kBN;AmKh+kBE;EACE,iB7JgnB0B;ANk3jB9B;AmKh+kBI;EACE,kBlKgFW;ADk5kBjB;AmK99kBE;EACE,etFd8B;A7E8+kBlC;;Acx6kBI;EqJhDI;IACE,mBAAA;EnK49kBR;AACF;AkK92kBA;EACE,aAAA;EACA,sBAAA;AlKg3kBF;;Acl7kBI;EsJzEF;IACE,wBAAA;EpK+/kBF;EoK5/kBA;IACE,cAAA;EpK8/kBF;EoKz/kBE;IACE,yBAAA;EpK2/kBJ;AACF;AqK1glBA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;ArK4glBF;;AqKzglBA;;EAAA;AAGA;EACE,wBAAA;EACA,UAAA;EACA,6DAAA;EACA,YAAA;EACA,mDAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;ArK4glBF;;AqKzglBA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;E9JbE,mBAAA;E8JeF,UAAA;ArK4glBF;;AqKzglBA;;EAEE,cAAA;EACA,6BAAA;ArK4glBF;;AqKzglBA;;;;;;EAME,YAAA;ArK4glBF;;AqKzglBA;;;;EAIE,oCAAA;EACA,YAAA;ArK4glBF;;AqKzglBA;;EAAA;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,iEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;ArK4glBF;;AqKzglBA;EACE,oCAAA;EACA,kBAAA;EACA,gEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;ArK4glBF;;AqKzglBA;;EAEE,qCAAA;EACA,YAAA;ArK4glBF;;AqKzglBA;;EAEE,qCAAA;EACA,WAAA;ArK4glBF;;AqKzglBA,gBAAA;AACA;EACE;IACE,yBAAA;ErK4glBF;AACF;AqKzglBA;EACE;IACE,yBAAA;ErK2glBF;AACF;AqKxglBA;EACE,kBAAA;EACA,YAAA;ArK0glBF;;AqKrglBA;EACE,kBAAA;EACA,aAAA;ArKwglBF;;AqKrglBA;EACE,aAAA;EACA,kBAAA;ArKwglBF;;AqKrglBA;EACE,aAAA;EACA,kBAAA;ArKwglBF;;AqKrglBA;EACE,aAAA;EACA,kBAAA;ArKwglBF;;AqKrglBA;EACE,aAAA;EACA,kBAAA;ArKwglBF;;AqKrglBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;ArKwglBF;;AqKrglBA;EACE,kBAAA;ArKwglBF;AqKtglBE;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,cxFvJ8B;EwFwJ9B,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;ArKuglBJ;AqKpglBE;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;ArKqglBJ;;AsK5qlBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AtK+qlBF;;AsK5qlBA;;EAEE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,yBAAA;AtK+qlBF;;AsK5qlBA;EACE,aAAA;E/JJE,uBAAA;E+JMF,iIACQ;AtK8qlBV;;AsKzqlBA;EACE,yDAAA;AtK4qlBF;;AsKzqlBA;;EAEE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AtK4qlBF;;AsKzqlBA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;AtK4qlBF;;AsKzqlBA;;EAEE,cAAA;AtK4qlBF;;AsKzqlBA;EACE,eAAA;EACA,crKhDS;AD4tlBX;;AsKzqlBA;EACE,gBAAA;AtK4qlBF;;AsKzqlBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AtK4qlBF;AsK1qlBE;EACE,UAAA;EACA,kBAAA;AtK4qlBJ;;AsKxqlBA;EACE,yDAAA;AtK2qlBF;;AsKxqlBA;;EAEE,cAAA;EACA,YAAA;AtK2qlBF;;AsKxqlBA;EACE,WAAA;AtK2qlBF;;AsKxqlBA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,iBAAA;EACA,eAAA;AtK2qlBF;;AsKxqlBA;EACE,crKxEM;ADmvlBR;;AsKxqlBA;;EAEE,WrK3GM;EqK4GN,eAAA;EACA,wBAAA;AtK2qlBF;;AsKxqlBA;EACE,eAAA;EACA,crK3GS;ADsxlBX;;AsKxqlBA;EACE,crK/GS;AD0xlBX;;AsKxqlBA;EACE,OAAA;AtK2qlBF;;AsKxqlBA;EACE,gBAAA;AtK2qlBF;;AsKxqlBA;EACE,0JAAA;EAEA,aAAA;EACA,sBAAA;AtK2qlBF;;AsKxqlBA;EAEE,cAAA;AtK2qlBF;;AsKxqlBA;EACE,0BAAA;EACA,gBAAA;AtK2qlBF;;AsKxqlBA;;;EAGE,aAAA;AtK2qlBF;;AsKxqlBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AtK2qlBF;;AsKvqlBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AtK0qlBF;;AsKvqlBA;EACE,WAAA;AtK0qlBF;;AsKvqlBA;EACE,kBAAA;EACA,mBAAA;AtK0qlBF;;AsKvqlBA;EACE,cAAA;AtK0qlBF;;AsKvqlBA;EACE,kBAAA;EACA,OAAA;AtK0qlBF;;AsKvqlBA;EAEE,aAAA;EAEA,SAAA;EACA,WAAA;AtK0qlBF;;AsKvqlBA;EAEE,aAAA;EAEA,cAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;AtK0qlBF;;AsKvqlBA;EACE,WAAA;EACA,sBAAA;AtK0qlBF;;AsKvqlBA;EAEE,mBAAA;AtK0qlBF;;AsKvqlBA;EACE,WAAA;AtK0qlBF;;AsKvqlBA;EACE,UAAA;AtK0qlBF;;AsKvqlBA;EACE,YAAA;AtK0qlBF;;AsKvqlBA;EACE,OAAA;AtK0qlBF;;AsKvqlBA;EACE,YAAA;AtK0qlBF;;AsKvqlBA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,iDAAA;AtK0qlBF;;AsKvqlBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AtK0qlBF;;AsKvqlBA;EACE,YAAA;EACA,SAAA;EACA,OAAA;EACA,mBrK/NM;ADy4lBR;;AsKvqlBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AtK0qlBF;;AsKvqlBA;EACE,SAAA;EACA,iBAAA;AtK0qlBF;;AuKp8lBA;;;;;;EAAA;AASA;;EAAA;AASA;;EAAA;AAYA;;EAAA;AAIA;EACE;IACE,aAAA,EAAA,oBAAA;EvKq7lBF;EuKn7lBA;IACE,UAAA;EvKq7lBF;AACF;AuKj7lBA;;EAAA;AAIA;EACE,kBAAA;AvKk7lBF;;AuK96lBA,sBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WA3CY;EA4CZ,QAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AvKi7lBF;;AuK96lBA,iBAAA;AACA;EACE,kBAAA;EACA,UAAA;AvKi7lBF;;AuK76lBE;EACE,2BAAA;AvKg7lBJ;AuK76lBE;EACE,2BAAA;AvK+6lBJ;;AuK36lBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,8BAAA;EACA,aAAA;EAlEA,sCAAA;AvKi/lBF;;AuK36lBA;EACE,cAAA;AvK86lBF;;AuK16lBA;;EAAA;AAIA;;;EA/EE,uEAAA;AvK8/lBF;;AuKz6lBA;;;;;;EArFE,oCAAA;AvKugmBF;;AuKx6lBA;;EAAA;AAKE;EACE,WAAA;AvKy6lBJ;AuKt6lBE;EAEE,YAAA;AvKu6lBJ;AuKp6lBE;EACE,mBAAA;AvKs6lBJ;AuKp6lBI;EACE,UAAA;AvKs6lBN;AuKn6lBI;EAEE,mBAAA;AvKo6lBN;;AuK95lBA;;EAAA;AAKE;EACE,UAAA;AvK+5lBJ;AuK55lBE;EAEE,SAAA;AvK65lBJ;AuK15lBE;EACE,kBAAA;AvK45lBJ;AuK15lBI;EACE,UAAA;AvK45lBN;AuKz5lBI;EAEE,kBAAA;AvK05lBN;;AuKp5lBA;;EAAA;AAIA;EACE,gBAAA;AvKs5lBF;AuKp5lBE;EACE,UAAA;EACA,SAAA;EACA,cAAA;AvKs5lBJ;AuKn5lBE;EACE,iBAAA;AvKq5lBJ;AuKn5lBI;EACE,UAAA;EACA,SAAA;EACA,aAAA;AvKq5lBN;AuKl5lBI;EAEE,iBAAA;AvKm5lBN;AuKj5lBM;EACE,QAAA;AvKm5lBR;;AuK54lBA;;EAAA;AAIA;EACE,gBAAA;AvK84lBF;AuK54lBE;EACE,SAAA;EACA,SAAA;EACA,cAAA;AvK84lBJ;AuK34lBE;EAEE,SAAA;AvK44lBJ;AuKz4lBE;EACE,oBAAA;AvK24lBJ;AuKz4lBI;EACE,UAAA;AvK24lBN;AuKx4lBI;EAEE,oBAAA;AvKy4lBN;;AuKn4lBA;;EAAA;AAGA;EACE,gBAAA;AvKs4lBF;AuKp4lBE;EACE,kBAAA;AvKs4lBJ;AuKp4lBE;EACE,UAAA;EACA,cAAA;AvKs4lBJ;AuKl4lBI;EACE,UAAA;EACA,WAAA;AvKo4lBN;AuKl4lBI;EACE,UAAA;EACA,SAAA;AvKo4lBN;;AuK93lBA;;EAAA;AAGA;EACE,gBAAA;AvKi4lBF;AuK/3lBE;EACE,kBAAA;AvKi4lBJ;AuK/3lBE;EACE,WAAA;EACA,cAAA;EACA,UAAA;AvKi4lBJ;AuK/3lBI;EACE,WAAA;AvKi4lBN;AuK53lBI;EACE,UAAA;EACA,UAAA;AvK83lBN;AuK53lBI;EACE,UAAA;EACA,SAAA;AvK83lBN;;AuKx3lBA;;EAAA;AAGA;EACE,gBAAA;AvK23lBF;AuKz3lBE;EACE,kBAAA;AvK23lBJ;AuKz3lBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AvK23lBJ;AuKv3lBI;EACE,UAAA;EACA,SAAA;AvKy3lBN;AuKv3lBI;EACE,UAAA;EACA,aAAA;AvKy3lBN;;AuKn3lBA;;EAAA;AAGA;EACE,gBAAA;AvKs3lBF;AuKp3lBE;EACE,kBAAA;AvKs3lBJ;AuKp3lBE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AvKs3lBJ;AuKl3lBI;EACE,UAAA;EACA,QAAA;AvKo3lBN;AuKl3lBI;EACE,UAAA;EACA,aAAA;AvKo3lBN;;AuK92lBA;;EAAA;AAIA;EACE,gBAAA;AvKg3lBF;;AuK92lBA;EACE,SAAA;EACA,iBAhWY;EAYZ,qBAsVoB;AvKg3lBtB;;AuK92lBA;EACE,kBAAA;EACA,qBAAA;AvKi3lBF;;AuK92lBA;EACE,UAAA;EA9VA,qBAgWoB;AvKg3lBtB;;AuK92lBA;EACE,UAAA;EACA,cAAA;EApWA,eAsWoB;AvKg3lBtB;;AuK52lBA;;EAAA;AAIA;EACE,gBAAA;AvK82lBF;;AuK52lBA;EACE,SAAA;EACA,kBAAA;EAnXA,qBAqXoB;AvK82lBtB;;AuK52lBA;EACE,kBAAA;EACA,qBAAA;AvK+2lBF;;AuK52lBA;EACE,UAAA;EA7XA,qBA+XoB;AvK82lBtB;;AuK52lBA;EACE,UAAA;EACA,cAAA;EAnYA,eAqYoB;AvK82lBtB;;AuK12lBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;AvK42lBF;;AuK12lBA;EACE,SAAA;EACA,cAAA;AvK62lBF;;AuK12lBA;EACE,kBAAA;EACA,WAAA;AvK62lBF;;AuK32lBA;EACE,UAAA;AvK82lBF;;AuK52lBA;EACE,UAAA;AvK+2lBF;;AuK12lBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;EAEA,+CAAA;AvK22lBF;;AuKz2lBA;EACE,SAAA;EACA,cAAA;AvK42lBF;;AuKz2lBA;EACE,kBAAA;EACA,WAAA;EAEA,+CAAA;EACA,iDAAA;AvK22lBF;;AuKz2lBA;EACE,UAAA;AvK42lBF;;AuK12lBA;EACE,UAAA;AvK62lBF;;AuKz2lBA;EACE,oBAAA;AvK42lBF;;AwKx0mBA;;;;;;EAAA;ACGA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAGA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AzK40mBF;AyK10mBE;EAKI,YDT2B;AxKi1mBjC;AyKn0mBI;EAKI,YDnByB;AxKo1mBjC;AyK7zmBI;;;EAGE,yBxKGE;AD4zmBR;;AyK1zmBA;EACE,WDrC+B;ECsC/B,YAAA;EACA,qBAAA;EACA,kBAAA;AzK6zmBF;;AyK1zmBA;EACE,cAAA;EACA,QAAA;EACA,gBAAA;AzK6zmBF;AyK3zmBE;EAGE,WDnD6B;ECoD7B,WDnD6B;ECoD7B,yBxKnBI;EwKoBJ,mBDlD6B;ECmD7B,kBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;AzK2zmBJ;AyKxzmBE;EAEE,WAAA;EACA,cAAA;AzKyzmBJ;AyKtzmBE;EACE,SAAA;AzKwzmBJ;AyKrzmBE;EACE,YAAA;AzKuzmBJ;;A0Kz4mBE;;EAAA;AAIE;EACE,QAAA;EACA,2BAAA;EACA,kEAAA;A1K24mBN;A0Kz4mBM;EACE,QAAA;EACA,sCAAA;A1K24mBR;A0Kx4mBM;EACE,SAAA;EACA,mEAAA;A1K04mBR;A0Kr4mBM;EAGE,gDAAA;EACA,wBAAA;A1Kq4mBR;A0Kn4mBQ;EACE,oBAAA;EACA,UAAA;A1Kq4mBV;A0Kl4mBQ;EACE,mDAAA;EACA,wBAAA;A1Ko4mBV;;A2Kr6mBA;EACE,gB1KYM;E0KXN,kBAAA;EACA,e9FDgC;A7Ey6mBlC;A2Kt6mBE;EACE,mB1KuFW;E0KtFX,c1KaO;E0KZP,SAAA;EACA,mB1KKO;E0KJP,uBAAA;EACA,gCAAA;EACA,6BAAA;A3Kw6mBJ;A2Kt6mBI;EACE,aAAA;A3Kw6mBN;A2Kp6mBE;EACE,e9FlB8B;A7Ew7mBlC;A2Kn6mBE;EACE,aAAA;A3Kq6mBJ;;A2Kj6mBA;EpKbI,mBAAA;EoKeF,gB1KjBM;E0KkBN,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mDrKwgB4B;EqKvgB5B,WAAA;A3Ko6mBF;A2Kl6mBE;EACE,eAAA;A3Ko6mBJ;;A4K7smBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;A5KgtmBF;A4K9smBE;EACE,qB3K1NE;AD06mBN;A4K9smBI;EACE,kBAAA;EACA,cAAA;A5KgtmBN;A4K7smBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yB3KrOA;E2KsOA,cAAA;EACA,SAAA;EACA,kBAAA;A5K+smBN;A4K7smBM;EAEE,wBAAA;EACA,UAAA;A5K+smBR;A4K5smBM;EAEE,yBAAA;EACA,WAAA;A5K8smBR;A4KzsmBE;EACE,qB3KvPK;ADk8mBT;A4KzsmBI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EAEA,kBAAA;EACA,iBAAA;EACA,yB3KlQG;AD68mBT;A4KxsmBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yB3K9QG;ADw9mBT;A4KtsmBE;EACE,qB3KhRG;ADw9mBP;A4KtsmBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yB3K3RC;ADm+mBP;A4KrsmBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yB3KtSC;AD6+mBP;A4KnsmBE;EACE,qB3K7SI;ADk/mBR;A4KnsmBI;EAEE,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gB3K7VE;E2K+VF,wBAAA;A5KosmBN;A4KjsmBI;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;EAEA,yBAAA;EAEA,2BAAA;A5KmsmBN;A4KhsmBI;EAEE,8BAAA;EACA,UAAA;EACA,UAAA;EAEA,yBAAA;EAEA,wBAAA;A5KksmBN;A4K/rmBI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A5KismBN;A4K9rmBI;EACE,UAAA;EACA,YAAA;EACA,sB3KzYE;E2K0YF,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,yBAAA;A5KgsmBN;A4K7rmBI;EACE,WAAA;EACA,yB3K9WE;E2K+WF,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A5K+rmBN;A4K7rmBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,wBAAA;A5K+rmBR;A4K5rmBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,yBAAA;A5K8rmBR;A4KzrmBE;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;A5K2rmBJ;A4Kl+lBA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;E5KggmBF;E4K9/lBA;IACE,QAAA;IACA,SAAA;IACA,SAAA;E5KggmBF;E4K9/lBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E5KggmBF;E4K9/lBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E5KggmBF;E4K9/lBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E5KggmBF;AACF;A4Kt+lBA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;E5K8/lBF;E4K5/lBA;IACE,QAAA;IACA,WAAA;IACA,SAAA;E5K8/lBF;E4K5/lBA;IACE,WAAA;IACA,QAAA;IACA,SAAA;E5K8/lBF;E4K5/lBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E5K8/lBF;AACF;A4Kr9lBA;EAEE,kCAAA;A5Ku9lBF;;A4Kp9lBA;EAEE,mCAAA;A5Ku9lBF;;A4Kp9lBA;EAEE,0CAAA;A5Ku9lBF;;A4K9ylBA,iBAAA;AACA;EACE,6BAAA;A5KizlBF;;A4K7ylBA;EACE,gCAAA;A5KgzlBF;;A4K5ylBA;EACE,iCAAA;A5K+ylBF;;A6KzvnBA;EACI,mBCcS;EDbT,eAAA;EACA,UAAA;EACA,YCLa;EDMb,sBAAA;EACA,W5KSI;ADmvnBR;A6K3vnBI;EACI,SvK+YC;EuK9YD,UvK8YC;AN+2mBT;A6K3vnBI;EACI,SvK2YC;EuK1YD,SAAA;EACA,mBAAA;A7K6vnBR;A6K3vnBI;EACI,SvKsYC;EuKrYD,WvKqYC;ANw3mBT;A6K3vnBI;EACI,YvKkYC;EuKjYD,UvKiYC;AN43mBT;A6K3vnBI;EACI,YvK8XC;EuK7XD,SAAA;EACA,mBAAA;A7K6vnBR;A6K3vnBI;EACI,YvKyXC;EuKxXD,WvKwXC;ANq4mBT;;A6KzvnBA;EACI;IACI,YAAA;IACA,UAAA;IACA,OAAA;IACA,SAAA;E7K4vnBN;E6K3vnBM;IAGI,MAAA;E7K2vnBV;E6KzvnBM;IAGI,SAAA;E7KyvnBV;E6KvvnBM;IACE,QAAA;IACA,UAAA;IAAA,aAAA;E7KyvnBR;AACF;A+K/ynBA;EACI,kBAAA;EACA,gBDDkB;ECElB,sBAAA;EACA,mBAAA;EACA,azKkZK;ECtYL,uBAAA;EwKVA,sM9K2GiB;E8K1GjB,aAAA;EACA,8BAAA;EACA,iBDRkB;ECSlB,gBAAA;EACA,uBDEa;ECDb,eAAA;EACA,cAAA;A/KiznBJ;A+KhznBI;EACI,cAAA;A/KkznBR;A+KhznBI;EACI,gBDdW;ECeX,c9KEG;EAsJT,sMAAA;AD2pnBF;A+KhznBI;EACI,mB9K+BD;EAqHL,0MAAA;AD+pnBF;A+KhznBI;EACI,mB9KyBA;EAuHN,0MAAA;ADmqnBF;A+KhznBI;EACI,mB9KoBC;EAwHP,0MAAA;ADuqnBF;A+KhznBI;EACI,mB9KcF;EA0HJ,sMAAA;AD2qnBF;A+KhznBI;EACI,cAAA;EACA,mBAAA;A/KkznBR;;A+K9ynBA;EACE;IACE,gBAAA;E/KiznBF;AACF;AgLn2nBA;EACE,W/KgBM;E+KfN,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AhLq2nBF;AgLp2nBE;EACE,WAAA;EACA,YAAA;AhLs2nBJ;AgLn2nBE;EAEE,UAAA;AhLo2nBJ;;AiLx3nBA;EACE;IACE,UAAA;EjL23nBF;EiLz3nBA;IACE,QAAA;EjL23nBF;AACF;AiLx3nBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,mBHEW;EGDX,2CAAA;EACA,0CAAA;E1KEE,uBAAA;APy3nBJ;AiLx3nBE;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AjL03nBJ;AiLx3nBE;EACE,mBhLsBI;ADo2nBR;AkL/4nBA;EACI;IAJA,8DAAA;ElLs5nBF;EkL34nBE;IACI,UAAA;IACA,oCAAA;ElL64nBN;EkL34nBE;IACI,UAAA;IACA,mCAAA;ElL64nBN;EkL34nBE;IACI,kCAAA;ElL64nBN;EkL34nBE;IACI,kCAAA;ElL64nBN;EkL34nBE;IACI,eAAA;ElL64nBN;AACF;AkL14nBA;EACI;IACI,UAAA;IACA,mCAAA;ElL44nBN;EkL14nBE;IACI,UAAA;IACA,oCAAA;ElL44nBN;AACF;AkLz4nBA;EACI;IA1CA,8DAAA;ElLs7nBF;EkLr4nBE;IACI,UAAA;IACA,qCAAA;ElLu4nBN;EkLr4nBE;IACI,UAAA;IACA,kCAAA;ElLu4nBN;EkLr4nBE;IACI,mCAAA;ElLu4nBN;EkLr4nBE;IACI,iCAAA;ElLu4nBN;EkLr4nBE;IACI,eAAA;ElLu4nBN;AACF;AkLp4nBA;EACI;IACI,UAAA;IACA,kCAAA;ElLs4nBN;EkLp4nBE;IACI,UAAA;IACA,qCAAA;ElLs4nBN;AACF;AkLn4nBA;EACI;IAhFA,8DAAA;ElLs9nBF;EkL/3nBE;IACI,UAAA;IACA,oCAAA;ElLi4nBN;EkL/3nBE;IACI,UAAA;IACA,mCAAA;ElLi4nBN;EkL/3nBE;IACI,kCAAA;ElLi4nBN;EkL/3nBE;IACI,kCAAA;ElLi4nBN;EkL/3nBE;IACI,+BAAA;ElLi4nBN;AACF;AkL93nBA;EACI;IACI,mCAAA;ElLg4nBN;EkL93nBE;IAEI,UAAA;IACA,kCAAA;ElL+3nBN;EkL73nBE;IACI,UAAA;IACA,qCAAA;ElL+3nBN;AACF;AkL53nBA;EACI;IA1HA,8DAAA;ElLy/nBF;EkLx3nBE;IACI,UAAA;IACA,qCAAA;ElL03nBN;EkLx3nBE;IACI,UAAA;IACA,kCAAA;ElL03nBN;EkLx3nBE;IACI,mCAAA;ElL03nBN;EkLx3nBE;IACI,iCAAA;ElL03nBN;EkLx3nBE;IACI,eAAA;ElL03nBN;AACF;AkLv3nBA;EACI;IACI,kCAAA;ElLy3nBN;EkLv3nBE;IAEI,UAAA;IACA,mCAAA;ElLw3nBN;EkLt3nBE;IACI,UAAA;IACA,oCAAA;ElLw3nBN;AACF;AkLp3nBI;EAEI,sCAAA;AlLq3nBR;AkLn3nBI;EAEI,uCAAA;AlLo3nBR;AkLl3nBI;EACI,sCAAA;AlLo3nBR;AkLl3nBI;EACI,oCAAA;AlLo3nBR;;AkL/2nBI;EAEI,uCAAA;AlLi3nBR;AkL/2nBI;EAEI,wCAAA;AlLg3nBR;AkL92nBI;EACI,qCAAA;AlLg3nBR;AkL92nBI;EACI,uCAAA;AlLg3nBR;;AmLljoBA;EACI;IACI,UAAA;IACA,iCAAA;EnLqjoBN;EmLnjoBE;IACI,UAAA;EnLqjoBN;AACF;AmLljoBA;EACI;IACI,UAAA;EnLojoBN;EmLljoBE;IACI,UAAA;IACA,iCAAA;EnLojoBN;EmLljoBE;IACI,UAAA;EnLojoBN;AACF;AmLjjoBA;EACI,gCAAA;AnLmjoBJ;;AmLhjoBA;EACI,iCAAA;AnLmjoBJ;;AoL/koBA;EACI;IACI,sDAAA;IACA,kCAAA;IACA,UAAA;EpLkloBN;EoLhloBE;IACI,uDAAA;IACA,kCAAA;EpLkloBN;EoLhloBE;IACI,sDAAA;IACA,UAAA;EpLkloBN;EoLhloBE;IACI,sDAAA;EpLkloBN;EoLhloBE;IACI,6BAAA;EpLkloBN;AACF;AoL/koBA;EACI;IACI,6BAAA;EpLiloBN;EoL/koBE;IACI,uDAAA;IACA,UAAA;EpLiloBN;EoL/koBE;IACI,sDAAA;IACA,UAAA;EpLiloBN;AACF;AoL9koBA;EACI,gCAAA;ApLgloBJ;;AoL7koBA;EACI,iCAAA;ApLgloBJ;;AqLrnoBA;EACI;IACI,kCAAA;IACA,mBAAA;ErLwnoBN;EqLtnoBE;IARA,+BAAA;ErLiooBF;AACF;AqLrnoBA;EACI;IACI,mCAAA;IACA,mBAAA;ErLunoBN;EqLrnoBE;IAlBA,+BAAA;ErL0ooBF;AACF;AqLpnoBA;EACI;IACI,kCAAA;IACA,mBAAA;ErLsnoBN;EqLpnoBE;IA5BA,+BAAA;ErLmpoBF;AACF;AqLnnoBA;EACI;IACI,mCAAA;IACA,mBAAA;ErLqnoBN;EqLnnoBE;IAtCA,+BAAA;ErL4poBF;AACF;AqLlnoBA;EACI;IA5CA,+BAAA;ErLiqoBF;EqLlnoBE;IACI,kBAAA;IACA,kCAAA;ErLonoBN;AACF;AqLjnoBA;EACI;IAtDA,+BAAA;ErL0qoBF;EqLjnoBE;IACI,kBAAA;IACA,mCAAA;ErLmnoBN;AACF;AqLhnoBA;EACI;IAhEA,+BAAA;ErLmroBF;EqLhnoBE;IACI,kBAAA;IACA,mCAAA;ErLknoBN;AACF;AqL/moBA;EACI;IA1EA,+BAAA;ErL4roBF;EqL/moBE;IACI,kBAAA;IACA,oCAAA;ErLinoBN;AACF;AqL7moBI;EAEI,qCAAA;ArL8moBR;AqL5moBI;EAEI,sCAAA;ArL6moBR;AqL3moBI;EACI,qCAAA;ArL6moBR;AqL3moBI;EACI,mCAAA;ArL6moBR;;AqLxmoBI;EAEI,sCAAA;ArL0moBR;AqLxmoBI;EAEI,uCAAA;ArLymoBR;AqLvmoBI;EACI,oCAAA;ArLymoBR;AqLvmoBI;EACI,sCAAA;ArLymoBR;;AsL3toBA,oBAAA;AACA;;EAEE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AtL8toBF;;AsL3toBA;EACE,eAAA;AtL8toBF;;AsL3toBA,eAAA;AACA;EACE,kBAAA;EACA,sBrLUM;EqLTN,YhL69CkC;ANiwlBpC;;AsL3toBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gBrLZM;EqLaN,+LrL+FsB;EM1GpB,uBAAA;E+KaF,uBAAA;AtL8toBF;;AsL3toBA;EACE,aAAA;AtL8toBF;;AsL3toBA,uBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AtL8toBF;;AsL3toBA;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,mBrLpCS;EqLqCT,mBAAA;EACA,2BAAA;AtL8toBF;;AsL3toBA;EACE,wBAAA;AtL8toBF;;AsL3toBA;EACE,yBAAA;AtL8toBF;;AsL3toBA;;EAEE,mBrLhDS;AD8woBX;;AsL3toBA,eAAA;AAEA;EACE;IACE,UAAA;EtL6toBF;AACF;AsL1toBA;EACE,wCAAA;AtL4toBF;;AsLztoBA;EACE;IACE,UAAA;EtL4toBF;AACF;AsLztoBA;EACE,yCAAA;AtL2toBF;;AsLxtoBA;EACE;IACE,iCAAA;EtL2toBF;AACF;AsLxtoBA;EACE,6DAAA;AtL0toBF;;AsLvtoBA;EACE;IACE,iCAAA;EtL0toBF;AACF;AsLvtoBA;EACE,gCAAA;AtLytoBF;;AsLttoBA;EACE;IACE,oCAAA;EtLytoBF;AACF;AsLttoBA;EACE,kEAAA;AtLwtoBF;;AsLrtoBA;EACE;IACE,oCAAA;EtLwtoBF;AACF;AsLrtoBA;EACE,qCAAA;AtLutoBF;;AsLptoBA,oBAAA;AAEA;EACE;IACE,oCAAA;EtLstoBF;AACF;AsLntoBA;EACE,kEAAA;AtLqtoBF;;AsLltoBA;EACE;IACE,oCAAA;EtLqtoBF;AACF;AsLltoBA;EACE,qCAAA;AtLotoBF;;AsLjtoBA,qBAAA;AAEA;EACE;IACE,mCAAA;EtLmtoBF;AACF;AsLhtoBA;EACE,mEAAA;AtLktoBF;;AsL/soBA;EACE;IACE,mCAAA;EtLktoBF;AACF;AsL/soBA;EACE,sCAAA;AtLitoBF;;AsL9soBA,kBAAA;AAEA;EACE;IACE,mCAAA;EtLgtoBF;AACF;AsL7soBA;EACE,gEAAA;AtL+soBF;;AsL5soBA;EACE;IACE,mCAAA;EtL+soBF;AACF;AsL5soBA;EACE,mCAAA;AtL8soBF;;AsL3soBA,eAAA;AAEA;EACE;IACE,sDAAA;EtL6soBF;EsL3soBA;IACE,uDAAA;EtL6soBF;EsL3soBA;IACE,6BAAA;EtL6soBF;AACF;AsL1soBA;EACE,wCAAA;EACA,+CAAA;UAAA,uCAAA;AtL4soBF;;AsLzsoBA;EACE;IACE,6BAAA;EtL4soBF;EsL1soBA;IACE,uDAAA;EtL4soBF;EsL1soBA;IACE,sDAAA;EtL4soBF;AACF;AsLzsoBA;EACE,gCAAA;EACA,+CAAA;UAAA,uCAAA;AtL2soBF;;AsLxsoBA,iBAAA;AAEA;EACE;IACE,4DAAA;EtL0soBF;AACF;AsLvsoBA;EACE,kCAAA;EACA,wBAAA;AtLysoBF;;AsLtsoBA;EACE;IACE,2DAAA;EtLysoBF;AACF;AsLtsoBA;EACE,kCAAA;EACA,wBAAA;AtLwsoBF;;AsLrsoBA,eAAA;AAEA;EACE;IACE,2BAAA;EtLusoBF;AACF;AsLpsoBA;EACE,6DAAA;AtLssoBF;;AsLnsoBA;EACE;IACE,8BAAA;EtLssoBF;EsLpsoBA;IACE,6BAAA;EtLssoBF;AACF;AsLnsoBA;EACE,gCAAA;AtLqsoBF;;AuLn+oBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AvLs+oBF;;AuLn+oBA;EACE,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AvLs+oBF;;AuLn+oBA;EAEE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,qCAAA;AvLs+oBF;;AuLn+oBA;EACE,UAAA;EACA,WAAA;AvLs+oBF;;AuLn+oBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AvLs+oBF;;AuLn+oBA;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AvLs+oBF;;AuLn+oBA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;AvLs+oBF;;AuLn+oBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,gEAAA;EACA,WAAA;EACA,UAAA;AvLs+oBF;;AuLn+oBA;EACE;IACE,QAAA;IACA,YAAA;EvLs+oBF;EuLp+oBA;IACE,QAAA;IACA,YAAA;EvLs+oBF;EuLp+oBA;IACE,WAAA;IACA,UAAA;EvLs+oBF;AACF;AuLn+oBA;EACE,qBAAA;AvLq+oBF;;AwL3jpBA,WAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AxL6jpBF;;AwLzjpBE;EACE,gBAAA;AxL4jpBJ;AwL1jpBI;EACE,WAAA;AxL4jpBN;AwLzjpBI;EACE,YAAA;AxL2jpBN;;AwLrjpBE;EACE,gBAAA;EACA,cAAA;AxLwjpBJ;;AwLnjpBE;EACE,UAAA;EACA,mBvLGI;EuLFJ,sBAAA;AxLsjpBJ;AwLnjpBE;EACE,WAAA;AxLqjpBJ;AwLjjpBE;EACE,YAAA;AxLmjpBJ;AwL9ipBI;EACE,UAAA;AxLgjpBN;;AwL3ipBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AxL8ipBF;AwL5ipBE;EACE,aAAA;AxL8ipBJ;AwL3ipBE;EACE,eAAA;EACA,YAAA;AxL6ipBJ;;AwLzipBA;;EAME,+BAAA;AxL4ipBF;;AwLzipBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AxL4ipBF;AwL1ipBE;EAEE,WAAA;EACA,cAAA;AxL2ipBJ;AwLxipBE;EACE,WAAA;AxL0ipBJ;AwLvipBE;EACE,kBAAA;AxLyipBJ;;AwLripBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;AxL8hpBF;AwLxipBE;EACE,YAAA;AxL0ipBJ;AwLxipBE;EACE,cAAA;AxL0ipBJ;AwLxipBE;EACE,aAAA;AxL0ipBJ;AwLripBE;EACE,oBAAA;AxLuipBJ;AwLpipBE;EACE,cAAA;AxLsipBJ;AwLnipBE;EACE,kBAAA;AxLqipBJ;AwLlipBE;EACE,cAAA;EACA,YAAA;EACA,6BAAA;AxLoipBJ;;AwLhipBA;EACE,aAAA;AxLmipBF;;AyL1qpBA,WAAA;AAEA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cxLDS;EwLET,QAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,sMxLsFmB;EwLrFnB,oBAAA;EACA,+BAAA;ElLbE,mBAAA;EkLeF,gBxLjBM;EwLkBN,UAAA;EACA,gBAAA;AzL4qpBF;AyL1qpBE;;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AzL6qpBJ;AyL1qpBE;;;EACE,aAAA;EACA,4CnLigB0B;EmLhgB1B,cxLDI;AD+qpBR;AyL3qpBE;;EACE,aAvCuB;AzLqtpB3B;;AyL1qpBA;EACE,OAAA;AzL6qpBF;AyL5qpBE;EACE,gBAlDmB;AzLgupBvB;;AyLzqpBA;EACE,QAAA;AzL4qpBF;AyL3qpBE;EACE,gBA3DmB;AzLwupBvB;;AyLzqpBA,SAAA;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AzL2qpBF;AyL1qpBE;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AzL4qpBJ;AyL1qpBI;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBxLhDE;EwLiDF,eAAA;EACA,kBAAA;ElL9EF,mBAAA;EkLgFE,kBAAA;AzL4qpBN;AyL1qpBM;EACE,WAAA;EACA,kBAAA;EACA,gBxLvFA;EwLwFA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;ElL3FJ,mBAAA;APwwpBJ;AyLxqpBI;EACE,qBAAA;AzL0qpBN;;AyLrqpBA;EACE,qBAAA;AzLwqpBF;;AyLpqpBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AzLuqpBJ;AyLpqpBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AzLsqpBJ;AyLpqpBI;EACE,kBnL0ewB;EmLzexB,mBAAA;EACA,qB5G/I4B;A7EqzpBlC;AyLnqpBI;EACE,kBxLvDW;EwLwDX,YAAA;AzLqqpBN;;AyL7ppBE;EACE,kBAAA;EACA,YAAA;AzLgqpBJ;AyL9ppBI;EACE,qCAAA;AzLgqpBN;AyL5ppBE;;EAEE,uBAAA;EACA,WxL1JI;EwL2JJ,+BAAA;AzL8ppBJ;AyL5ppBI;;EACE,qCAAA;AzL+ppBN;AyL3ppBE;EACE,WAAA;AzL6ppBJ;AyL1ppBE;EACE,UAAA;AzL4ppBJ;AyLzppBE;EACE,WxL3KI;ADs0pBR;;A0Lv1pBA;EACE,kBAAA;A1L01pBF;;A0Lv1pBA;EACE,qBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;A1L01pBF;;A0Lv1pBA;EACE,kBAAA;EACA,eAAA;A1L01pBF;;A0Lv1pBA;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;A1L01pBF;;A0Lv1pBA;EACE,aAAA;A1L01pBF;;A0Lv1pBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;A1L01pBF;;A0Lv1pBA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;A1L01pBF;;A0Lv1pBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Ly1pBF;;A0Lr1pBE;EACE,wBAAA;A1Lw1pBJ;;A2Ll5pBA;EACE,sM1L6GmB;ADwypBrB;A2Ln5pBE;EACE,oBAAA;EACA,YAAA;A3Lq5pBJ;A2Ln5pBI;EACE,arL2YG;AN0gpBT;A2Lj5pBM;EACE,mBrLsYC;AN6gpBT;A2L94pBE;EACE,+BAAA;A3Lg5pBJ;A2L94pBI;EACE,UAAA;A3Lg5pBN;A2L34pBI;EpLLA,8BAAA;EAAA,kDAAA;EACA,+BAAA;EAAA,mDAAA;EoLME,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A3L84pBN;;A2Lx4pBE;EACE,eAAA;EAAA,kBAAA;A3L24pBJ;;A2Lr4pBI;EACE,wBAAA;A3Lw4pBN;;A2Ll4pBE;EACE,oCAAA;A3Lq4pBJ;;A2Lt4pBE;EACE,oCAAA;A3Ly4pBJ;;A2L14pBE;EACE,oCAAA;A3L64pBJ;;A2L94pBE;EACE,oCAAA;A3Li5pBJ;;A2Ll5pBE;EACE,oCAAA;A3Lq5pBJ;;A2Lt5pBE;EACE,oCAAA;A3Ly5pBJ;;A2L15pBE;EACE,oCAAA;A3L65pBJ;;A2L95pBE;EACE,oCAAA;A3Li6pBJ;;A2Ll6pBE;EACE,oCAAA;A3Lq6pBJ;;A2Lt6pBE;EACE,oCAAA;A3Ly6pBJ;;A2Lh6pBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A3Lm6pBJ;A2Lj6pBI;EACE,aAAA;EpL9CF,8BAAA;EAAA,kDAAA;EACA,+BAAA;EAAA,mDAAA;EoL+CE,gBAAA;A3Lo6pBN;A2Ll6pBM;EACE,iBAAA;A3Lo6pBR;A2Lj6pBM;EACE,yBAAA;A3Lm6pBR;A2L95pBE;EACE,gBAAA;A3Lg6pBJ;A2L75pBE;EACE,gBAAA;A3L+5pBJ;A2L55pBE;EACE,gBAAA;A3L85pBJ;;A2L15pBA;EACE,SAAA;A3L65pBF;A2L35pBE;EACE,aAAA;A3L65pBJ;A2L15pBE;EACE,oCAAA;EACA,gBAAA;EACA,yBAAA;A3L45pBJ;A2L15pBI;EACE,aAAA;A3L45pBN;A2Lx5pBE;EACE,+BAAA;A3L05pBJ;A2Lt5pBI;EACE,yBAAA;A3Lw5pBN;A2Lr5pBI;EACE,yBAAA;A3Lu5pBN;;A2L94pBI;EACE,gB1LzHE;E0L0HF,c1LlHK;E0LmHL,sM1LxBe;E0LyBf,0CAAA;A3Li5pBN;A2L94pBI;EACE,aAAA;A3Lg5pBN;;A4L/hqBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;A5LkiqBF;A4LjiqBE;EACE,UAAA;A5LmiqBJ;;A6L1iqBA;EACE,cAAA;EACA,aAAA;EACA,SAAA;A7L6iqBF;;A6L1iqBA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;A7L6iqBF;;A6L1iqBA;EACE,mBAAA;A7L6iqBF;;A6L1iqBA;EACE,SAAA;EACA,UAAA;A7L6iqBF;;A8L5jqBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACE,SAAA;EACA,iBAAA;A9L+jqBJ;;A8L5jqBA;;;EAGE,mBAAA;A9L+jqBF;;A8L5jqBA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;A9L+jqBF;;A8L5jqBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9L+jqBF;;A8L5jqBA;EACE,cAAA;A9L+jqBF;;A8L5jqBA;EACE,cCtCmB;A/LqmqBrB;;A8L5jqBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;A9L+jqBF;A8L5jqBI;EACE,cAAA;EACA,qBAAA;A9L8jqBN;;A8LzjqBA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;A9L4jqBF;;A8LzjqBA;EACE,yB7LwCuB;ADohqBzB;;AgM7nqBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AhMgoqBF;AgM9nqBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AhMgoqBJ;AgM7nqBE;EACE,W/LHI;E+LIJ,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,mB/LsBI;E+LrBJ,yBAAA;EACA,sBAAA;EACA,uB1LsgB0B;E0LrgB1B,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AhM+nqBJ;AgM7nqBI;EAEE,sBAAA;EACA,gDAAA;EACA,wCAnCc;EAoCd,uCAnCU;AhMiqqBhB;AgM5nqBM;EAEE,W/L3BA;E+L4BA,2CAAA;EACA,qBAAA;AhM6nqBR;AgMznqBI;EACE,W/LlCE;E+LmCF,wCAhDc;EAiDd,uCAhDU;AhM2qqBhB;AgMxnqBI;EACE,W/LxCE;E+LyCF,wCAtDc;EAuDd,uCAtDU;AhMgrqBhB;;AgMrnqBA;EACE,qBAAA;EACA,mBAAA;AhMwnqBF;AgMtnqBE;EACE,0BAAA;EACA,6BAAA;AhMwnqBJ;AgMrnqBE;EACE,yBAAA;EACA,4BAAA;AhMunqBJ;AgMpnqBE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AhMsnqBJ;AgMnnqBE;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;AhMqnqBJ;AgMlnqBE;EACE,gBAAA;AhMonqBJ;AgMjnqBE;EACE,iBAAA;AhMmnqBJ;AgMhnqBE;EACE,cAAA;EACA,kBAAA;AhMknqBJ;AgM/mqBE;EAEE,iBAAA;AhMgnqBJ;;AiMvtqBA;EACE,eAAA;EACA,iB3LotCkC;E2LntClC,yBhM0CM;EgMzCN,uB3L4hB4B;E2L3hB5B,WhMUM;ADgtqBR;AiMxtqBE;EACE,wCAAA;AjM0tqBJ;;AiMttqBA;EAEE,cAAA;AjMwtqBF;;AiMrtqBA;EACE,kDAAA;AjMwtqBF;;AiMrtqBA;EACE,yBAAA;EACA,4BAAA;AjMwtqBF;;AiMttqBA;EACE,0BAAA;EACA,6BAAA;AjMytqBF;;AiMrtqBA;EACE,yBAAA;EACA,0BAAA;AjMwtqBF;;AiMttqBA;EACE,4BAAA;EACA,6BAAA;AjMytqBF;;AkM7vqBA;EACE,aAAA;EACA,mBAAA;AlMgwqBF;;AkM7vqBA;EACE,sBAAA;AlMgwqBF;AkMzvqBA;EACE,oCHHwB;A/L8vqB1B;;AkMvvqBA;EAEE,0CAAA;EACA,UHFa;EGGb,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AlMyvqBF;;AkMtvqBA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,YAAA;AlMwvqBF;AkMtvqBE;EACE,gCAAA;AlMwvqBJ;AkMrvqBE;EACE,8BAAA;AlMuvqBJ;AkMpvqBE;EACE,oBAAA;EACA,+BAAA;AlMsvqBJ;;AkMlvqBA;EACE,aAAA;EACA,mBAAA;AlMqvqBF;;AkMlvqBA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EAEA,YAAA;AlMovqBF;AkMlvqBE;EACE,6BAAA;AlMovqBJ;;AkMhvqBA;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;AlMmvqBF;AkMjvqBE;EACE,iBAAA;AlMmvqBJ;AkM/uqBI;EACE,cAAA;EACA,qBAAA;AlMivqBN;;AkM5uqBA;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AlM8uqBF;;AkM3uqBA;EACA,SAAA;AlM8uqBA;AkM7uqBE;EACE,8BAAA;AlM+uqBJ;AkM5uqBE;EACE,oBAAA;EACA,+BAAA;AlM8uqBJ;;AkM1uqBA;EACI,mBjMhGO;AD60qBX;;AkM1uqBA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;AlM6uqBF;AkM3uqBE;EACE,eAAA;AlM6uqBJ;;AkMzuqBA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;AlM4uqBF;;AmMh3qBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AnMm3qBF;AmMj3qBE;EACE,WAAA;EACA,yBAAA;AnMm3qBJ;AmMj3qBI;EACE,iBAAA;EACA,mBAAA;AnMm3qBN;AmM/2qBI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;AnMi3qBN;AmM92qBI;EACE,8BAAA;AnMg3qBN;AmM52qBM;EACE,oBAAA;EACA,+BAAA;AnM82qBR;AmM12qBI;EACE,6BAAA;AnM42qBN;AmMz2qBI;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;AnM22qBN;AmMz2qBM;EACE,iBAAA;AnM22qBR;;AmMr2qBA;EACE,yBAAA;AnMw2qBF;AmMt2qBE;EACE,aAAA;AnMw2qBJ;AmMt2qBE;EACE,aAAA;AnMw2qBJ;;AmMp2qBA;;EAEE,mBAAA;AnMu2qBF;;AmMl2qBA;EACE,WAAA;AnMq2qBF;;AoMv6qBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;ApM06qBF;AoMx6qBE;EACE,SAAA;ApM06qBJ;;AoMr6qBA;EACE,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;ApMw6qBF;;AoMr6qBA;;EAEE,UAAA;ApMw6qBF;;AoMr6qBA;EACE,cAAA;ApMw6qBF;;AoMr6qBA;EACE,kBAAA;ApMw6qBF;AoMt6qBE;EACE,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;ApMw6qBJ;AoMr6qBE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;ApMu6qBJ;AoMp6qBE;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;ApMs6qBJ;AoMn6qBE;EACE,8CAAA;ApMq6qBJ;;AoMj6qBA;EACE,SAAA;ApMo6qBF;AoMl6qBE;EACE,iBAAA;ApMo6qBJ;;AoMh6qBA;EACE,kBAAA;ApMm6qBF;;AoMh6qBA;EACE,kBAAA;EACA,UAAA;ApMm6qBF;;AqM5+qBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,oCNMwB;EMLxB,aNIqB;EMHrB,cAAA;EACA,YAAA;ArM++qBF;;AqM5+qBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;ArM++qBF;AqM7+qBE;EACE,mBAAA;ArM++qBJ;AqM5+qBE;EACE,WAAA;EACA,kBAAA;ArM8+qBJ;AqM3+qBE;EACE,kBAAA;EACA,UAAA;ArM6+qBJ;AqM1+qBE;EACE,gBAAA;ArM4+qBJ;;AqMv+qBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;ArM0+qBF;AqMx+qBE;EACE,+BAAA;ArM0+qBJ;AqMv+qBE;EACE,qBAAA;EACA,8BAAA;ArMy+qBJ;AqMt+qBE;EACE,8BAAA;ArMw+qBJ;AqMr+qBE;EACE,oBAAA;EACA,+BAAA;ArMu+qBJ;AqMp+qBE;EACE,gCAAA;ArMs+qBJ;AqMn+qBE;EACE,UAAA;ArMq+qBJ;AqMl+qBE;EACE,WAAA;ArMo+qBJ;;AqMh+qBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;ArMm+qBF;AqMj+qBE;EACE,UAAA;ArMm+qBJ;AqMh+qBE;EACE,8BAAA;ArMk+qBJ;AqM/9qBE;EACE,oBAAA;EACA,+BAAA;ArMi+qBJ;AqM99qBE;EACE,WAAA;EACA,yBAAA;UAAA,iBAAA;ArMg+qBJ;;AqM59qBA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EAEA,yBpMxDM;EoMyDN,oBAAA;ArM89qBF;AqM59qBE;EACE,cAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;EAEA,YAAA;EACA,yBpMnEI;EoMqEJ,kBAAA;EACA,UAAA;EACA,WAAA;ArM29qBJ;AqMx9qBE;EACE,OAAA;EACA,WAAA;ArM09qBJ;;AsM3lrBA;EACE,kCAAA;E/LgBE,mBAAA;AP+krBJ;AsM5lrBE;EAGE,oCAAA;AtM4lrBJ;AsMzlrBE;EACE,yBrMMO;ADqlrBX;AsMxlrBE;EACE,gCAAA;AtM0lrBJ;;AuM3mrBA;;EAAA;AAGA;EACE,yBAAA;AvM8mrBF;;AuM3mrBA;EACE,4BAAA;AvM8mrBF;;AuM3mrBA;EACE,cAAA;AvM8mrBF;;AuM3mrBA;EACE,aAAA;AvM8mrBF;;AuM3mrBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AvM8mrBF;;AuM3mrBA;EACE,iBAAA;AvM8mrBF;;AuM3mrBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;AvM8mrBF;;AuM3mrBA;;;;+EAAA;AAKA;;EAEE,YAAA;EACA,kBAAA;EACA,qBAAA;AvM8mrBF;;AuM3mrBA;EACE,kBAAA;EACA,MAAA;AvM8mrBF;;AuM3mrBA;;;;EAIE,kBAAA;EACA,WAAA;EACA,uBAAA;AvM8mrBF;;AuM3mrBA;;;;;;EAAA;AAOA;EACE,WAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AvM8mrBF;;AuM3mrBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;AvM8mrBF;;AuM3mrBA;;;EAGE,UAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AvM8mrBF;;AuM3mrBA;;;EAGE,UAAA;EACA,UAAA;EAAA,aAAA;AvM8mrBF;;AuM3mrBA;EACE,WAAA;AvM8mrBF;;AuM3mrBA;EACE,SAAA;EACA,SAAA;EACA,WAAA;AvM8mrBF;;AuM3mrBA;+EAAA;AAEA;EACE,UAAA;AvM8mrBF;;AuM5mrBA;EACE,kBAAA;EACA,WAAA;EACA,yBtMpEM;EsMqEN,UAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AvM+mrBF;;AuM5mrBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EAAA,aAAA;EACA,UAAA;AvM+mrBF;;AuM5mrBA;EACE;IACE,0BAAA;IACA,UAAA;EvM+mrBF;EuM7mrBA;IACE,6BAAA;IACA,UAAA;EvM+mrBF;EuM7mrBA;IACE,6BAAA;IACA,UAAA;EvM+mrBF;EuM7mrBA;IACE,8BAAA;IACA,UAAA;EvM+mrBF;AACF;AuM7mrBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AvM+mrBF;;AuM5mrBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EAAA,aAAA;AvM+mrBF;;AuM5mrBA;;;;;;EAAA;AAOA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;AvM+mrBF;;AuM5mrBA;EACE,+BAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AvM+mrBF;;AuM5mrBA;;;;;;EAAA;AAOA;EACE,UAAA;AvM+mrBF;;AuM7mrBA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AvMgnrBF;;AuM7mrBA;EACE,+BAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EAAA,cAAA;AvMgnrBF;;AuM7mrBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;AvMgnrBF;;AuM7mrBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;EACA,gCAAA;EACA,iBAAA;AvMgnrBF;;AuM7mrBA;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AvMgnrBF;;AuM7mrBA;EACE,yBAAA;AvMgnrBF;;AuM7mrBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AvMgnrBF;;AuM9mrBA;EACE,sBAAA;AvMinrBF;;AuM9mrBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AvMinrBF;;AuM/mrBA;;EAEE,qBAAA;AvMknrBF;;AuMhnrBA;;EAEE,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AvMmnrBF;;AuMhnrBA;;EAAA;AAGA;EACE,yBAAA;AvMmnrBF;;AuMhnrBA;;EAAA;AAGA;EACE,0BAAA;AvMmnrBF;;AuMhnrBA;;EAAA;AAGA;EACE,0BAAA;AvMmnrBF;;AuMhnrBA;;;;;EAKE,qBAAA;EACA,sBAAA;AvMmnrBF;;AuMhnrBA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AvMmnrBF;;AuMhnrBA;EACE,kBAAA;EACA,8BAAA;EACA,qBAAA;AvMmnrBF;;AuMhnrBA;EACE,8BAAA;AvMmnrBF;;AuMhnrBA;EACE,+BAAA;EACA,8BAAA;AvMmnrBF;;AuMhnrBA;EACE,cAAA;EACA,mBAAA;AvMmnrBF;;AuMjnrBA;EACE,kBAAA;EACA,sBAAA;AvMonrBF;;AuMjnrBA;EACE,cAAA;EACA,aAAA;AvMonrBF;;AuMjnrBA;;EAEE,YAAA;EACA,WAAA;EACA,6EAAA;EAGA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AvMknrBF;;AuM/mrBA;EACE,eAAA;EACA,mBtMvWS;ADy9rBX;;AuM/mrBA;EACE;IAGE,UAAA;EvMgnrBF;EuM9mrBA;IACE,UAAA;EvMgnrBF;AACF;AuM7mrBA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AvM+mrBF;;AuM5mrBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AvM+mrBF;;AuM5mrBA;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AvM+mrBF;;AuM5mrBA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBtMjZM;EsMkZN,kBAAA;EACA,oDAAA;AvM+mrBF;;AuM7mrBA;EACE,uBAAA;AvMgnrBF;;AuM9mrBA;EACE,yBAAA;AvMinrBF;;AuM/mrBA;;EAEE,uBAAA;AvMknrBF;;AuMhnrBA;EACE,wBAAA;AvMmnrBF;;AuMjnrBA;EACE,yBAAA;AvMonrBF;;AuMlnrBA;;EAEE,uBAAA;AvMqnrBF;;AuMnnrBA;EACE,wBAAA;AvMsnrBF;;AuMpnrBA;EACE,yBAAA;AvMunrBF;;AuMrnrBA;;EAEE,uBAAA;AvMwnrBF;;AuMtnrBA;EACE,wBAAA;AvMynrBF;;AuMvnrBA;EACE,yBAAA;AvM0nrBF;;AuMxnrBA;;EAEE,uBAAA;AvM2nrBF;;AuMznrBA;EACE,yBAAA;AvM4nrBF;;AuM1nrBA;EACE,yBAAA;AvM6nrBF;;AuM3nrBA;;EAEE,uBAAA;AvM8nrBF;;AuM5nrBA;EACE,yBAAA;AvM+nrBF;;AuM7nrBA;EACE,yBAAA;AvMgorBF;;AuM9nrBA;;EAEE,uBAAA;AvMiorBF;;AuM/nrBA;EACE,yBAAA;AvMkorBF;;AuMhorBA;EACE,yBAAA;AvMmorBF;;AuMjorBA;;EAEE,oBAAA;AvMoorBF;;AuMjorBA;EACE,iBAAA;AvMoorBF;;AuMjorBA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AvMoorBF;;AuMjorBA;EACE,cAAA;EACA,cAAA;AvMoorBF;;AuMjorBA;;EAEE,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;AvMoorBF;;AuMlorBA;;EAEE,+BAAA;AvMqorBF;;AuMnorBA;;EAEE,aAAA;EACA,+CAAA;AvMsorBF;;AuMporBA;;EAEE,qBAAA;EACA,YAAA;EACA,WAAA;AvMuorBF;;AuMporBA;EACE,0EAAA;AvMuorBF;;AuMlorBA;EACE,0EAAA;AvMqorBF;;AuMhorBA;;EAAA;AAGA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AvMmorBF;;AuMjorBA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AvMoorBF;;AuMjorBA;EACE,UAAA;EACA,UAAA;EAAA,aAAA;AvMoorBF;;AuMjorBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AvMoorBF;;AuMlorBA;;EAEE,sBAAA;AvMqorBF;;AuMnorBA;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AvMsorBF;;AuMnorBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AvMsorBF;;AuMporBA;;EAEE,qBAAA;AvMuorBF;;AuMrorBA;;EAEE,2BAAA;EACA,mBAAA;AvMworBF;;AuMrorBA;;EAAA;AAGA;EACE,yBAAA;AvMworBF;;AuMrorBA,6BAAA;AAQA,uBAAA;AAQA,wBAAA;AAQA;EACE,gBAAA;EACA,yBAAA;EAGA,aAAA;EAIA,mBAAA;EAGA,mBAAA;AvMmnrBF;;AuMjnrBA;EAGE,aAAA;EAIA,mBAAA;EAGA,mBAAA;AvMonrBF;;AuMjnrBA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AvMonrBF;;AuMjnrBA;;EAEE,kBAAA;EACA,cAAA;AvMonrBF;;AuMlnrBA;EACE,uBAAA;EACA,mBAAA;AvMqnrBF;;AuMlnrBA;;EAEE,iBAAA;AvMqnrBF;;AuMnnrBA;EACE,eAAA;AvMsnrBF;;AuMnnrBA;EAGE,aAAA;EAGA,mBAAA;AvMsnrBF;;AuMpnrBA;EAGE,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AvMunrBF;;AuMpnrBA,uBAAA;ACxsBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AxMg0sBF;AwM9zsBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AxMg0sBJ;AwM7zsBE;;;;EAIE,cAAA;EACA,WAAA;EACA,clMg3BoC;EkMh3BpC,2BlMg3BoC;EkM/2BpC,sBlM02BoC;EkM12BpC,mClM02BoC;EkMz2BpC,4BAAA;EACA,yBAAA;EAAA,2DAAA;EAEA,4ClMo4BoC;EkMp4BpC,+DlMo4BoC;EkMn4BpC,uBAAA;EjMXA,sBAAA;EAAA,yCAAA;EiMgBE,uBlM02BkC;EkM12BlC,sClM02BkC;EiKt3BtC,mFAAA;AvKw0sBF;AwMpzsBI;;;;EACE,6BAAA;EACA,SAAA;AxMyzsBN;AwMnzsBI;;;;EACE,6BlMm2BkC;EkMn2BlC,gClMm2BkC;EkMl2BlC,UAAA;AxMwzsBN;AwMrzsBI;;;;;;;EAEE,yBlM20BkC;EkM30BlC,wClM20BkC;EkM10BlC,UAAA;AxM4zsBN;AwMxzsBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;AxM0zsBJ;AwMxzsBI;EACE,+BAAA;EACA,gCAAA;AxM0zsBN;AwMxzsBM;;EAEE,evMiEgB;EuMhEhB,cvMrDG;AD+2sBX;AwMxzsBQ;;EACE,cvMxDC;ADm3sBX;AwMxzsBQ;;EACE,UAAA;AxM2zsBV;AwMrzsBI;EACE,gCAAA;EACA,mBvMzEK;ADg4sBX;AwMrzsBM;EACE,+BAAA;AxMuzsBR;AwMpzsBM;EACE,4CAAA;AxMszsBR;AwMlzsBI;EACE,kBAAA;AxMozsBN;AwMjzsBI;;EAEE,gBvM+Be;EuM9Bf,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,cvMrEE;ADw3sBR;AwMjzsBM;;EACE,6BAAA;AxMozsBR;AwMhzsBI;;EAEE,mCAAA;AxMkzsBN;AwM/ysBI;;EAEE,oCAAA;AxMizsBN;AwM9ysBI;;EAEE,eAAA;AxMgzsBN;AwM7ysBI;;EAEE,eAAA;AxM+ysBN;AwM5ysBI;EACE,iBAAA;AxM8ysBN;AwM3ysBI;EACE,gBAAA;AxM6ysBN;AwM1ysBI;EACE,gBAAA;EACA,uBAAA;AxM4ysBN;AwMzysBI;EACE,2BAAA;AxM2ysBN;AwMxysBI;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AxM0ysBN;AwMvysBI;EACE,oCAAA;EACA,uBvM7JE;EuM8JF,iBAAA;EACA,gBAAA;AxMyysBN;AwMtysBI;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AxMwysBN;AwMpysBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AxMsysBJ;AwMpysBI;EACE,gCAAA;AxMsysBN;AwMnysBI;EACE,gBAAA;AxMqysBN;AwMlysBI;EACE,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AxMoysBN;AwMlysBM;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;EjM/LJ,sBAAA;EAAA,yCAAA;APo+sBJ;AwMlysBQ;EACE,gBAAA;EACA,yCvMzDiB;EuM0DjB,aAAA;AxMoysBV;AwM/xsBI;EACE,eAAA;AxMiysBN;AwM9xsBI;EACE,eAAA;EACA,mBAAA;AxMgysBN;AwM5xsBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AxM8xsBJ;AwM3xsBE;EACE,cAAA;EACA,oBAAA;AxM6xsBJ;AwM1xsBE;;EAEE,SAAA;EACA,uBAAA;EACA,gBvM5GiB;EuM8GjB,qBAAA;EACA,uDAAA;AxM2xsBJ;AwMzxsBI;;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AxM4xsBN;AwMxxsBE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AxM0xsBJ;AwMzxsBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AxM2xsBN;AwMzxsBI;EACE,0CAAA;AxM2xsBN;AwMvxsBE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AxMyxsBJ;AwMtxsBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AxMwxsBJ;AwMtxsBI;EACE,+BAAA;AxMwxsBN;AwMvxsBM;EACE,eAAA;AxMyxsBR;AwMpxsBE;EACE,+BAAA;AxMsxsBJ;AwMlxsBI;EACE,2CAAA;AxMoxsBN;AwMjxsBI;EACE,4CAAA;AxMmxsBN;AwM/wsBE;EACE,mBvMrNqB;ADs+sBzB;AwM9wsBE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;AxMgxsBJ;AwM9wsBI;EACE,wBAAA;UAAA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBlM2MwB;EkM1MxB,YAAA;EACA,cAAA;EACA,cvM3SE;EuM4SF,mBvMzUK;EuM0UL,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AxMgxsBN;AwM7wsBI;EACE,YAAA;EACA,eAAA;AxM+wsBN;AwM5wsBI;EACE,mBvMzTE;EuM0TF,WvMxVE;ADsmtBR;AwM3wsBI;;EAEE,SAAA;EACA,kBAAA;AxM6wsBN;AwM1wsBI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AxM4wsBN;AwMzwsBI;EACE,iBAAA;EACA,iBAAA;AxM2wsBN;AwMxwsBI;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AxM0wsBN;AwMvwsBI;EACE,qBAAA;EACA,aAAA;AxMywsBN;AwMtwsBI;EACE,WAAA;EACA,kBAAA;AxMwwsBN;AwMrwsBI;EACE,gBAAA;AxMuwsBN;AwMnwsBE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AxMqwsBJ;AwMlwsBE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AxMowsBJ;AwMjwsBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,cvM7YI;EuM8YJ,2BAAA;EACA,yDAAA;AxMmwsBJ;AwMhwsBE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AxMkwsBJ;AwM/vsBE;EACE,0BAAA;AxMiwsBJ;AwM9vsBE;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AxMgwsBJ;;AwM3vsBA;;EAEE,sBAAA;AxM8vsBF;;AwM1vsBE;EACE,oBAAA;EACA,YAAA;EACA,sBAAA;AxM6vsBJ;;AwMzvsBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AxM4vsBF;;AwMxvsBE;;EAEE,cvMjcI;AD4rtBR;;AwM5usBE;;EAEE,wBAAA;AxM+usBJ;;AwMzusBA;EACE,oCAAA;AxM4usBF;;AwMzusBA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,cAAA;AxM4usBF;;AwMzusBA;EACE,+BAAA;AxM4usBF;;AwMzusBA;EACE,yBAAA;AxM4usBF;;AwM1usBA;EACE,yBAAA;AxM6usBF;;AwM1usBA;EACE,yBvMnbuB;ADgqtBzB;;AyM5wtBA;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;AzM2wtBF;AyMxwtBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AzMywtBF;;AyMtwtBA;EACE,gBAAA;AzMywtBF;;AyMvwtBA;EACE,gBAAA;AzM0wtBF;;AyMxwtBA;EACE,gBAAA;AzM2wtBF;;AyMzwtBA;EACE,gBAAA;AzM4wtBF;;AyM1wtBA;EACE,gBAAA;AzM6wtBF;;AyM3wtBA;EACE,gBAAA;AzM8wtBF;;AyM5wtBA;EACE,gBAAA;AzM+wtBF;;AyM7wtBA;EACE,gBAAA;AzMgxtBF;;AyM9wtBA;EACE,gBAAA;AzMixtBF;;AyM/wtBA;EACE,gBAAA;AzMkxtBF;;AyMhxtBA;EACE,gBAAA;AzMmxtBF;;AyMjxtBA;EACE,gBAAA;AzMoxtBF;;AyMlxtBA;EACE,gBAAA;AzMqxtBF;;AyMnxtBA;EACE,gBAAA;AzMsxtBF;;AyMpxtBA;EACE,gBAAA;AzMuxtBF;;AyMrxtBA;EACE,gBAAA;AzMwxtBF;;AyMtxtBA;EACE,gBAAA;AzMyxtBF;;AyMvxtBA;EACE,gBAAA;AzM0xtBF;;AyMxxtBA;EACE,gBAAA;AzM2xtBF;;AyMzxtBA;EACE,gBAAA;AzM4xtBF;;AyM1xtBA;EACE,gBAAA;AzM6xtBF;;AyM3xtBA;EACE,gBAAA;AzM8xtBF;;AyM5xtBA;EACE,gBAAA;AzM+xtBF;;AyM7xtBA;EACE,gBAAA;AzMgytBF;;AyM9xtBA;EACE,gBAAA;AzMiytBF;;AyM/xtBA;EACE,gBAAA;AzMkytBF;;AyMhytBA;EACE,gBAAA;AzMmytBF;;AyMjytBA;EACE,gBAAA;AzMoytBF;;AyMlytBA;EACE,gBAAA;AzMqytBF;;AyMnytBA;EACE,gBAAA;AzMsytBF;;AyMpytBA;EACE,gBAAA;AzMuytBF;;AyMrytBA;EACE,gBAAA;AzMwytBF;;AyMtytBA;EACE,gBAAA;AzMyytBF;;AyMvytBA;EACE,gBAAA;AzM0ytBF;;AyMxytBA;EACE,gBAAA;AzM2ytBF;;AyMzytBA;EACE,gBAAA;AzM4ytBF;;AyM1ytBA;EACE,gBAAA;AzM6ytBF;;AyM3ytBA;EACE,gBAAA;AzM8ytBF;;AyM5ytBA;EACE,gBAAA;AzM+ytBF;;AyM7ytBA;EACE,gBAAA;AzMgztBF;;AyM9ytBA;EACE,gBAAA;AzMiztBF;;AyM/ytBA;EACE,gBAAA;AzMkztBF;;AyMhztBA;EACE,gBAAA;AzMmztBF;;AyMjztBA;EACE,gBAAA;AzMoztBF;;AyMlztBA;EACE,gBAAA;AzMqztBF;;AyMnztBA;EACE,gBAAA;AzMsztBF;;AyMpztBA;EACE,gBAAA;AzMuztBF;;AyMrztBA;EACE,gBAAA;AzMwztBF;;AyMtztBA;EACE,gBAAA;AzMyztBF;;AyMvztBA;EACE,gBAAA;AzM0ztBF;;AyMxztBA;EACE,gBAAA;AzM2ztBF;;AyMzztBA;EACE,gBAAA;AzM4ztBF;;AyM1ztBA;EACE,gBAAA;AzM6ztBF;;AyM3ztBA;EACE,gBAAA;AzM8ztBF;;AyM5ztBA;EACE,gBAAA;AzM+ztBF;;AyM7ztBA;EACE,gBAAA;AzMg0tBF;;AyM9ztBA;EACE,gBAAA;AzMi0tBF;;AyM/ztBA;EACE,gBAAA;AzMk0tBF;;AyMh0tBA;EACE,gBAAA;AzMm0tBF;;AyMj0tBA;EACE,gBAAA;AzMo0tBF;;AyMl0tBA;EACE,gBAAA;AzMq0tBF;;AyMn0tBA;EACE,gBAAA;AzMs0tBF;;AyMp0tBA;EACE,gBAAA;AzMu0tBF;;AyMr0tBA;EACE,gBAAA;AzMw0tBF;;AyMt0tBA;EACE,gBAAA;AzMy0tBF;;AyMv0tBA;EACE,gBAAA;AzM00tBF;;AyMx0tBA;EACE,gBAAA;AzM20tBF;;AyMz0tBA;EACE,gBAAA;AzM40tBF;;AyM10tBA;EACE,gBAAA;AzM60tBF;;AyM30tBA;EACE,gBAAA;AzM80tBF;;AyM50tBA;EACE,gBAAA;AzM+0tBF;;AyM70tBA;EACE,gBAAA;AzMg1tBF;;AyM90tBA;EACE,gBAAA;AzMi1tBF;;AyM/0tBA;EACE,gBAAA;AzMk1tBF;;AyMh1tBA;EACE,gBAAA;AzMm1tBF;;AyMj1tBA;EACE,gBAAA;AzMo1tBF;;AyMl1tBA;EACE,gBAAA;AzMq1tBF;;AyMn1tBA;EACE,gBAAA;AzMs1tBF;;AyMp1tBA;EACE,gBAAA;AzMu1tBF;;AyMr1tBA;EACE,gBAAA;AzMw1tBF;;AyMt1tBA;EACE,gBAAA;AzMy1tBF;;AyMv1tBA;EACE,gBAAA;AzM01tBF;;AyMx1tBA;EACE,gBAAA;AzM21tBF;;AyMz1tBA;EACE,gBAAA;AzM41tBF;;AyM11tBA;EACE,gBAAA;AzM61tBF;;AyM31tBA;EACE,gBAAA;AzM81tBF;;AyM51tBA;EACE,gBAAA;AzM+1tBF;;AyM71tBA;EACE,gBAAA;AzMg2tBF;;AyM91tBA;EACE,gBAAA;AzMi2tBF;;AyM/1tBA;EACE,gBAAA;AzMk2tBF;;AyMh2tBA;EACE,gBAAA;AzMm2tBF;;AyMj2tBA;EACE,gBAAA;AzMo2tBF;;AyMl2tBA;EACE,gBAAA;AzMq2tBF;;AyMn2tBA;EACE,gBAAA;AzMs2tBF;;AyMp2tBA;EACE,gBAAA;AzMu2tBF;;AyMr2tBA;EACE,gBAAA;AzMw2tBF;;AyMt2tBA;EACE,gBAAA;AzMy2tBF;;AyMv2tBA;EACE,gBAAA;AzM02tBF;;AyMx2tBA;EACE,gBAAA;AzM22tBF;;AyMz2tBA;EACE,gBAAA;AzM42tBF;;AyM12tBA;EACE,gBAAA;AzM62tBF;;AyM32tBA;EACE,gBAAA;AzM82tBF;;AyM52tBA;EACE,gBAAA;AzM+2tBF;;AyM72tBA;EACE,gBAAA;AzMg3tBF;;AyM92tBA;EACE,gBAAA;AzMi3tBF;;AyM/2tBA;EACE,gBAAA;AzMk3tBF;;AyMh3tBA;EACE,gBAAA;AzMm3tBF;;AyMj3tBA;EACE,gBAAA;AzMo3tBF;;AyMl3tBA;EACE,gBAAA;AzMq3tBF;;AyMn3tBA;EACE,gBAAA;AzMs3tBF;;AyMp3tBA;EACE,gBAAA;AzMu3tBF;;AyMr3tBA;EACE,gBAAA;AzMw3tBF;;AyMt3tBA;EACE,gBAAA;AzMy3tBF;;AyMv3tBA;EACE,gBAAA;AzM03tBF;;AyMx3tBA;EACE,gBAAA;AzM23tBF;;AyMz3tBA;EACE,gBAAA;AzM43tBF;;AyM13tBA;EACE,gBAAA;AzM63tBF;;AyM33tBA;EACE,gBAAA;AzM83tBF;;AyM53tBA;EACE,gBAAA;AzM+3tBF;;AyM73tBA;EACE,gBAAA;AzMg4tBF;;AyM93tBA;EACE,gBAAA;AzMi4tBF;;AyM/3tBA;EACE,gBAAA;AzMk4tBF;;AyMh4tBA;EACE,gBAAA;AzMm4tBF;;AyMj4tBA;EACE,gBAAA;AzMo4tBF;;AyMl4tBA;EACE,gBAAA;AzMq4tBF;;AyMn4tBA;EACE,gBAAA;AzMs4tBF;;AyMp4tBA;EACE,gBAAA;AzMu4tBF;;AyMr4tBA;EACE,gBAAA;AzMw4tBF;;AyMt4tBA;EACE,gBAAA;AzMy4tBF;;AyMv4tBA;EACE,gBAAA;AzM04tBF;;AyMx4tBA;EACE,gBAAA;AzM24tBF;;AyMz4tBA;EACE,gBAAA;AzM44tBF;;AyM14tBA;EACE,gBAAA;AzM64tBF;;AyM34tBA;EACE,gBAAA;AzM84tBF;;AyM54tBA;EACE,gBAAA;AzM+4tBF;;AyM74tBA;EACE,gBAAA;AzMg5tBF;;AyM94tBA;EACE,gBAAA;AzMi5tBF;;AyM/4tBA;EACE,gBAAA;AzMk5tBF;;AyMh5tBA;EACE,gBAAA;AzMm5tBF;;AyMj5tBA;EACE,gBAAA;AzMo5tBF;;AyMl5tBA;EACE,gBAAA;AzMq5tBF;;AyMn5tBA;EACE,gBAAA;AzMs5tBF;;AyMp5tBA;EACE,gBAAA;AzMu5tBF;;AyMr5tBA;EACE,gBAAA;AzMw5tBF;;AyMt5tBA;EACE,gBAAA;AzMy5tBF;;AyMv5tBA;EACE,gBAAA;AzM05tBF;;AyMx5tBA;EACE,gBAAA;AzM25tBF;;AyMz5tBA;EACE,gBAAA;AzM45tBF;;AyM15tBA;EACE,gBAAA;AzM65tBF;;AyM35tBA;EACE,gBAAA;AzM85tBF;;AyM55tBA;EACE,gBAAA;AzM+5tBF;;AyM75tBA;EACE,gBAAA;AzMg6tBF;;AyM95tBA;EACE,gBAAA;AzMi6tBF;;AyM/5tBA;EACE,gBAAA;AzMk6tBF;;AyMh6tBA;EACE,gBAAA;AzMm6tBF;;AyMj6tBA;EACE,gBAAA;AzMo6tBF;;AyMl6tBA;EACE,gBAAA;AzMq6tBF;;AyMn6tBA;EACE,gBAAA;AzMs6tBF;;AyMp6tBA;EACE,gBAAA;AzMu6tBF;;AyMr6tBA;EACE,gBAAA;AzMw6tBF;;AyMt6tBA;EACE,gBAAA;AzMy6tBF;;AyMv6tBA;EACE,gBAAA;AzM06tBF;;AyMx6tBA;EACE,gBAAA;AzM26tBF;;AyMz6tBA;EACE,gBAAA;AzM46tBF;;AyM16tBA;EACE,gBAAA;AzM66tBF;;AyM36tBA;EACE,gBAAA;AzM86tBF;;AyM56tBA;EACE,gBAAA;AzM+6tBF;;AyM76tBA;EACE,gBAAA;AzMg7tBF;;AyM96tBA;EACE,gBAAA;AzMi7tBF;;AyM/6tBA;EACE,gBAAA;AzMk7tBF;;A0M78uBA;;CAAA;ACAA;EACC,+BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;A3Mg9uBD;A4Mx9uBA;EACC,qBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;A5My9uBD;;A6Mp+uBA;+BAAA;AAGA,qBAAA;AAEA;;;EAAA;AAKA,6DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,kBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,kBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,kBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,iBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,qBAAA;EACA,kBAAA;A7Mo+uBF;;A6Mj+uBA;EACE,eAAA;EACA,2BAAA;EACA,qBAAA;A7Mo+uBF;A6Ml+uBE;EACE,kBAAA;A7Mo+uBJ;;A6Mh+uBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;A7Mm+uBF;A6Mj+uBE;EACE,qBAAA;A7Mm+uBJ;;A6M/9uBA;EACE,4BAAA;EACA,4BAAA;EACA,oBAAA;A7Mk+uBF;;A6M/9uBA;EACE,YAAA;A7Mk+uBF;;A6M99uBE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;A7Mi+uBJ;;A6M79uBA;EACE,kCAAA;A7Mg+uBF;;A6M79uBA;EACE;IACE,uBAAA;E7Mg+uBF;E6M99uBA;IACE,yBAAA;E7Mg+uBF;AACF;A6M79uBA;EACE,gEAAA;EACA,wBAAA;A7M+9uBF;;A6M59uBA;EACE,gEAAA;EACA,yBAAA;A7M+9uBF;;A6M59uBA;EACE,gEAAA;EACA,yBAAA;A7M+9uBF;;A6M59uBA;EACE,0EAAA;EACA,uBAAA;A7M+9uBF;;A6M59uBA;EACE,0EAAA;EACA,uBAAA;A7M+9uBF;;A6M59uBA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;A7M+9uBF;;A6M59uBA;;EAEE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;A7M+9uBF;;A6M59uBA;EACE,oBAAA;A7M+9uBF;;A6M59uBA;EACE,cAAA;A7M+9uBF;;A6M59uBA;EACE,cAAA;A7M+9uBF;;A6M59uBA,oCAAA;AACA;EACE,sBAAA;A7M+9uBF;;A6M59uBA;EACE,4BAAA;A7M+9uBF;;A8MvnvBA;EACE,gBCGe;A/MunvBjB;;A8MvnvBA;EACE,gBAAA;A9M0nvBF;;A8MxnvBA;EACE,gBCFgB;A/M6nvBlB;;A8MznvBA;EACE,gBCJiB;A/MgovBnB;;A8M1nvBA;EACE,gBCNa;A/MmovBf;;A8M3nvBA;EACE,gBCRiB;A/MsovBnB;;A8M5nvBA;EACE,gBCVmB;A/MyovBrB;;A8M7nvBA;EACE,gBCZoB;A/M4ovBtB;;A8M9nvBA;EACE,gBCdgB;A/M+ovBlB;;A8M/nvBA;EACE,gBChBa;A/MkpvBf;;A8MhovBA;EACE,gBClBgB;A/MqpvBlB;;A8MjovBA;EACE,gBCpBoB;A/MwpvBtB;;A8MlovBA;EACE,gBCtBc;A/M2pvBhB;;A8MnovBA;EACE,gBCxBmB;A/M8pvBrB;;A8MpovBA;EACE,gBC1Bc;A/MiqvBhB;;A8MrovBA;EACE,gBC5BoB;A/MoqvBtB;;A8MtovBA;EACE,gBC9Bc;A/MuqvBhB;;A8MvovBA;EACE,gBChCe;A/M0qvBjB;;A8MxovBA;EACE,gBClCgB;A/M6qvBlB;;A8MzovBA;EACE,gBCpCsB;A/MgrvBxB;;A8M1ovBA;EACE,gBCtCkB;A/MmrvBpB;;A8M3ovBA;EACE,gBCxCe;A/MsrvBjB;;A8M5ovBA;EACE,gBC1Ce;A/MyrvBjB;;A8M7ovBA;EACE,gBC5CgB;A/M4rvBlB;;A8M9ovBA;EACE,gBC9CmB;A/M+rvBrB;;A8M/ovBA;EACE,gBChDgB;A/MksvBlB;;A8MhpvBA;EACE,gBClDkB;A/MqsvBpB;;A8MjpvBA;EACE,gBCpDgB;A/MwsvBlB;;A8MlpvBA;EACE,gBCtDe;A/M2svBjB;;A8MnpvBA;EACE,gBCxDa;A/M8svBf;;A8MppvBA;EACE,gBC1DgB;A/MitvBlB;;A8MrpvBA;EACE,gBC5Dc;A/MotvBhB;;A8MtpvBA;EACE,gBC9DsB;A/MutvBxB;;A8MvpvBA;EACE,gBChEc;A/M0tvBhB;;A8MxpvBA;EACE,gBClEe;A/M6tvBjB;;A8MzpvBA;EACE,gBCpEmB;A/MguvBrB;;A8M1pvBA;EACE,gBCtEwB;A/MmuvB1B;;A8M3pvBA;EACE,gBCxEa;A/MsuvBf;;A8M5pvBA;EACE,gBC1EsB;A/MyuvBxB;;A8M7pvBA;EACE,gBC5EY;A/M4uvBd;;A8M9pvBA;EACE,gBC9EkB;A/M+uvBpB;;A8M/pvBA;EACE,gBChFoB;A/MkvvBtB;;A8MhqvBA;EACE,gBClFyB;A/MqvvB3B;;A8MjqvBA;EACE,gBCpFe;A/MwvvBjB;;A8MlqvBA;EACE,gBCtFqB;A/M2vvBvB;;A8MnqvBA;EACE,gBCxFgB;A/M8vvBlB;;A8MpqvBA;EACE,gBC1F4B;A/MiwvB9B;;A8MrqvBA;EACE,gBC5Fe;A/MowvBjB;;A8MtqvBA;EACE,gBC9FoB;A/MuwvBtB;;A8MvqvBA;EACE,gBChGqB;A/M0wvBvB;;A8MxqvBA;EACE,gBClG2B;A/M6wvB7B;;A8MzqvBA;EACE,gBCpGkB;A/MgxvBpB;;A8M1qvBA;EACE,gBCtGoB;A/MmxvBtB;;A8M3qvBA;EACE,gBCxGgB;A/MsxvBlB;;A8M5qvBA;EACE,gBC1G2B;A/MyxvB7B;;A8M7qvBA;EACE,gBC5GkB;A/M4xvBpB;;A8M9qvBA;EACE,gBC9GgB;A/M+xvBlB;;A8M/qvBA;EACE,gBChHc;A/MkyvBhB;;A8MhrvBA;EACE,gBClHiB;A/MqyvBnB;;A8MjrvBA;EACE,gBCpHiB;A/MwyvBnB;;A8MlrvBA;EACE,gBCtHmB;A/M2yvBrB;;A8MnrvBA;EACE,gBCxHe;A/M8yvBjB;;A8MprvBA;EACE,gBC1Hc;A/MizvBhB;;A8MrrvBA;EACE,gBC5HgB;A/MozvBlB;;A8MtrvBA;EACE,gBC9HgB;A/MuzvBlB;;A8MvrvBA;EACE,gBChIkB;A/M0zvBpB;;A8MxrvBA;EACE,gBClIe;A/M6zvBjB;;A8MzrvBA;EACE,gBCpIe;A/Mg0vBjB;;A8M1rvBA;EACE,gBCtIe;A/Mm0vBjB;;A8M3rvBA;EACE,gBCxIgB;A/Ms0vBlB;;A8M5rvBA;EACE,gBC1IgB;A/My0vBlB;;A8M7rvBA;EACE,gBC5Ia;A/M40vBf;;A8M9rvBA;EACE,gBC9Ie;A/M+0vBjB;;A8M/rvBA;EACE,gBChJmB;A/Mk1vBrB;;A8MhsvBA;EACE,gBClJc;A/Mq1vBhB;;A8MjsvBA;EACE,gBCpJiB;A/Mw1vBnB;;A8MlsvBA;EACE,gBCtJgB;A/M21vBlB;;A8MnsvBA;EACE,gBCxJiB;A/M81vBnB;;A8MpsvBA;EACE,gBC1JiB;A/Mi2vBnB;;A8MrsvBA;EACE,gBC5Je;A/Mo2vBjB;;A8MtsvBA;EACE,gBC9JgB;A/Mu2vBlB;;A8MvsvBA;EACE,gBChKgB;A/M02vBlB;;A8MxsvBA;EACE,gBClKc;A/M62vBhB;;A8MzsvBA;EACE,gBCpKiB;A/Mg3vBnB;;A8M1svBA;EACE,gBCtKc;A/Mm3vBhB;;A8M3svBA;EACE,gBCxKgB;A/Ms3vBlB;;A8M5svBA;EACE,gBC1KgB;A/My3vBlB;;A8M7svBA;EACE,gBC5KiB;A/M43vBnB;;A8M9svBA;EACE,gBC9KkB;A/M+3vBpB;;A8M/svBA;EACE,gBChLuB;A/Mk4vBzB;;A8MhtvBA;EACE,gBClLmB;A/Mq4vBrB;;A8MjtvBA;EACE,gBCpLe;A/Mw4vBjB;;A8MltvBA;EACE,gBCtLe;A/M24vBjB;;A8MntvBA;EACE,gBCxLe;A/M84vBjB;;A8MptvBA;EACE,gBC1LiB;A/Mi5vBnB;;A8MrtvBA;EACE,gBC5Lc;A/Mo5vBhB;;A8MttvBA;EACE,gBC9Lc;A/Mu5vBhB;;A8MvtvBA;EACE,gBChMe;A/M05vBjB;;A8MxtvBA;EACE,gBClMe;A/M65vBjB;;A8MztvBA;EACE,gBCpMmB;A/Mg6vBrB;;A8M1tvBA;EACE,gBCtMe;A/Mm6vBjB;;A8M3tvBA;EACE,gBCxMc;A/Ms6vBhB;;A8M5tvBA;EACE,gBC1MoB;A/My6vBtB;;A8M7tvBA;EACE,gBC5Mc;A/M46vBhB;;A8M9tvBA;EACE,gBC9Ma;A/M+6vBf;;A8M/tvBA;EACE,gBChNe;A/Mk7vBjB;;A8MhuvBA;EACE,gBClNa;A/Mq7vBf;;A8MjuvBA;EACE,gBCpNuB;A/Mw7vBzB;;A8MluvBA;EACE,gBCtNa;A/M27vBf;;A8MnuvBA;EACE,gBCxNe;A/M87vBjB;;A8MpuvBA;EACE,gBC1Nc;A/Mi8vBhB;;A8MruvBA;EACE,gBC5Na;A/Mo8vBf;;A8MtuvBA;EACE,gBC9NqB;A/Mu8vBvB;;A8MvuvBA;EACE,gBChOqB;A/M08vBvB;;A8MxuvBA;EACE,gBClOqB;A/M68vBvB;;A8MzuvBA;EACE,gBCpOe;A/Mg9vBjB;;A8M1uvBA;EACE,gBCtOsB;A/Mm9vBxB;;A8M3uvBA;EACE,gBCxOkB;A/Ms9vBpB;;A8M5uvBA;EACE,gBC1Oc;A/My9vBhB;;A8M7uvBA;EACE,gBC5Oc;A/M49vBhB;;A8M9uvBA;EACE,gBC9OoB;A/M+9vBtB;;A8M/uvBA;EACE,gBChPmB;A/Mk+vBrB;;A8MhvvBA;EACE,gBClPe;A/Mq+vBjB;;A8MjvvBA;EACE,gBCpPe;A/Mw+vBjB;;A8MlvvBA;EACE,gBCtPc;A/M2+vBhB;;A8MnvvBA;EACE,gBCxPc;A/M8+vBhB;;A8MpvvBA;EACE,gBC1PiB;A/Mi/vBnB;;A8MrvvBA;EACE,gBC5Pe;A/Mo/vBjB;;A8MtvvBA;EACE,gBC9Pc;A/Mu/vBhB;;A8MvvvBA;EACE,gBChQa;A/M0/vBf;;A8MxvvBA;EACE,gBClQoB;A/M6/vBtB;;A8MzvvBA;EACE,gBCpQc;A/MggwBhB;;A8M1vvBA;EACE,gBCtQmB;A/MmgwBrB;;A8M3vvBA;EACE,gBCxQwB;A/MsgwB1B;;A8M5vvBA;EACE,gBC1QgB;A/MygwBlB;;A8M7vvBA;EACE,gBC5Qc;A/M4gwBhB;;A8M9vvBA;EACE,gBC9Qc;A/M+gwBhB;;A8M/vvBA;EACE,gBChRc;A/MkhwBhB;;A8MhwvBA;EACE,gBClRiB;A/MqhwBnB;;A8MjwvBA;EACE,gBCpRc;A/MwhwBhB;;A8MlwvBA;EACE,gBCtRc;A/M2hwBhB;;A8MnwvBA;EACE,gBCxRe;A/M8hwBjB;;A8MpwvBA;EACE,gBC1Rc;A/MiiwBhB;;A8MrwvBA;EACE,gBC5RgB;A/MoiwBlB;;A8MtwvBA;EACE,gBC9Rc;A/MuiwBhB;;A8MvwvBA;EACE,gBChSc;A/M0iwBhB;;A8MxwvBA;EACE,gBClSc;A/M6iwBhB;;A8MzwvBA;EACE,gBCpSe;A/MgjwBjB;;A8M1wvBA;EACE,gBCtSe;A/MmjwBjB;;A8M3wvBA;EACE,gBCxSgB;A/MsjwBlB;;A8M5wvBA;EACE,gBC1SgB;A/MyjwBlB;;A8M7wvBA;EACE,gBC5SgB;A/M4jwBlB;;A8M9wvBA;EACE,gBC9Se;A/M+jwBjB;;A8M/wvBA;EACE,gBChTgB;A/MkkwBlB;;A8MhxvBA;EACE,gBClTe;A/MqkwBjB;;A8MjxvBA;EACE,gBCpTiB;A/MwkwBnB;;A8MlxvBA;EACE,gBCtTc;A/M2kwBhB;;A8MnxvBA;EACE,gBCxTgB;A/M8kwBlB;;A8MpxvBA;EACE,gBC1Tc;A/MilwBhB;;A8MrxvBA;EACE,gBC5TgB;A/MolwBlB;;A8MtxvBA;EACE,gBC9Tc;A/MulwBhB;;A8MvxvBA;EACE,gBChUiB;A/M0lwBnB;;A8MxxvBA;EACE,gBClUiB;A/M6lwBnB;;A8MzxvBA;EACE,gBCpUc;A/MgmwBhB;;A8M1xvBA;EACE,gBCtUc;A/MmmwBhB;;A8M3xvBA;EACE,gBCxUgB;A/MsmwBlB;;A8M5xvBA;EACE,gBC1UkB;A/MymwBpB;;A8M7xvBA;EACE,gBC5UkB;A/M4mwBpB;;A8M9xvBA;EACE,gBC9UkB;A/M+mwBpB;;A8M/xvBA;EACE,gBChVkB;A/MknwBpB;;A8MhyvBA;EACE,gBClVc;A/MqnwBhB;;A8MjyvBA;EACE,gBCpVa;A/MwnwBf;;A8MlyvBA;EACE,gBCtViB;A/M2nwBnB;;A8MnyvBA;EACE,gBCxVc;A/M8nwBhB;;A8MpyvBA;EACE,gBC1VgB;A/MiowBlB;;A8MryvBA;EACE,gBC5VmB;A/MoowBrB;;A8MtyvBA;EACE,gBC9VgB;A/MuowBlB;;A8MvyvBA;EACE,gBChWiB;A/M0owBnB;;A8MxyvBA;EACE,gBClWiB;A/M6owBnB;;A8MzyvBA;EACE,gBCpWgB;A/MgpwBlB;;A8M1yvBA;EACE,gBCtWe;A/MmpwBjB;;A8M3yvBA;EACE,gBCxWe;A/MspwBjB;;A8M5yvBA;EACE,gBC1We;A/MypwBjB;;A8M7yvBA;EACE,gBC5Wc;A/M4pwBhB;;A8M9yvBA;EACE,gBC9Wc;A/M+pwBhB;;A8M/yvBA;EACE,gBChXgB;A/MkqwBlB;;A8MhzvBA;EACE,gBClXc;A/MqqwBhB;;A8MjzvBA;EACE,gBCpXoB;A/MwqwBtB;;A8MlzvBA;EACE,gBCtXiB;A/M2qwBnB;;A8MnzvBA;EACE,gBCxXc;A/M8qwBhB;;A8MpzvBA;EACE,gBC1Xc;A/MirwBhB;;A8MrzvBA;EACE,gBC5XmB;A/MorwBrB;;A8MtzvBA;EACE,gBC9XiB;A/MurwBnB;;A8MvzvBA;EACE,gBChYc;A/M0rwBhB;;A8MxzvBA;EACE,gBClYiB;A/M6rwBnB;;A8MzzvBA;EACE,gBCpYc;A/MgswBhB;;A8M1zvBA;EACE,gBCtYc;A/MmswBhB;;A8M3zvBA;EACE,gBCxYmB;A/MsswBrB;;A8M5zvBA;EACE,gBC1YgB;A/MyswBlB;;A8M7zvBA;EACE,gBC5YgB;A/M4swBlB;;A8M9zvBA;EACE,gBC9Ye;A/M+swBjB;;A8M/zvBA;EACE,gBChZiB;A/MktwBnB;;AgN/5wBA;;;EACE,iBAAA;EACA,kBAAA;AhNo6wBF;AgNl6wBE;;;;;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EAEA,SAAA;EACA,UAAA;AhNs6wBJ;AgNn6wBE;;;EACE,WAAA;EACA,WAAA;EACA,iBCGwB;EDDxB,UAAA;EACA,4BAAA;AhNs6wBJ;;AgNl6wBA;EAGE,MAAA;EACA,gBAAA;AhNm6wBF;AgNj6wBE;EAEE,gBAAA;EACA,yB/MhBI;ADk7wBR;AgN/5wBE;EACE,SAAA;EACA,4B/MlBO;ADm7wBX;;AgN75wBA;;;EAGE,SAAA;EACA,mBAAA;AhNg6wBF;AgN95wBE;;;;;EAEE,mBAAA;EACA,sBAAA;AhNm6wBJ;AgNh6wBE;;;EACE,YAAA;EACA,yB/MpCO;ADw8wBX;;AkNz9wBA;EACE,cAAA;EACA,WAAA;AlN49wBF;;AkNz9wBA;EACE,sBjNQM;EiNPN,cjNcS;EiNbT,yBAAA;EACA,uB5MshB4B;E4MrhB5B,qBAAA;EACA,kBAAA;EAEA,sMjNoGmB;ADu3wBrB;;AkNv9wBE;EACE,UAAA;AlN09wBJ;AkNv9wBE;EACE,cAAA;AlNy9wBJ;AkNt9wBE;EACE,qBAAA;AlNw9wBJ;AkNr9wBE;EACE,qBAAA;AlNu9wBJ;;AkNn9wBA;EACE,kBAAA;EACA,UAAA;AlNs9wBF;;AkNn9wBA;EACE,YAAA;AlNs9wBF;AkNp9wBE;EACE,eAAA;AlNs9wBJ;AkN/8wBE;EACE,kBAAA;AlNi9wBJ;AkN18wBE;EACE,gBD1CwB;AjNs/wB5B;AkN18wBI;EACE,UAAA;EACA,WAAA;AlN48wBN;AkNx8wBE;EACE,iBDnDwB;AjN6/wB5B;AkNx8wBI;EACE,UAAA;EACA,WAAA;AlN08wBN;;AkNr8wBA;EACE,kBAAA;EACA,sBjNjEM;EiNkEN,gCAAA;EACA,gC5M8c4B;E4M7c5B,iC5M6c4B;E4M5c5B,iBAAA;EACA,kBAAA;AlNw8wBF;AkNt8wBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AlNw8wBJ;;AkNp8wBA;;;;;;EAME,qBAAA;EACA,aAAA;AlNu8wBF;;AkNp8wBA;;EAEE,aAAA;EACA,cjNpFS;EiNqFT,iBAAA;EACA,mBAAA;AlNu8wBF;;AkNp8wBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AlNu8wBF;;AkNp8wBA;EACE,gBAAA;EACA,iBDzGsB;EC0GtB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AlNu8wBF;AkNr8wBE;EACE,UAAA;EACA,2BjNpHO;AD2jxBX;AkNr8wBI;EACE,4CAAA;AlNu8wBN;AkNp8wBI;EAEE,4CDvIkC;ECwIlC,eAAA;AlNq8wBN;AkNj8wBE;EACE,WAAA;EACA,0BjNnIO;ADskxBX;AkNl8wBI;EACE,WAAA;AlNo8wBN;AkNj8wBI;EACE,2CAAA;AlNm8wBN;AkNh8wBI;EAEE,2CDzJkC;EC0JlC,eAAA;AlNi8wBN;AkN77wBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AlN+7wBJ;AkN77wBI;EACE,QAAA;EACA,yBjN5JK;AD2lxBX;AkN77wBM;EACE,0CAAA;AlN+7wBR;AkN37wBI;EACE,SAAA;EACA,4BjNrKK;ADkmxBX;AkN37wBM;EACE,6CAAA;AlN67wBR;;AkNv7wBA;EACE,WAAA;AlN07wBF;;AkNv7wBA;EACE,cDtLmB;ECuLnB,kBAAA;AlN07wBF;;AkNv7wBA;EACE,YAAA;EACA,8BAAA;EACA,YAAA;AlN07wBF;AkNx7wBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;AlN07wBJ;AkNv7wBE;EACE,kBAAA;EACA,iBAAA;AlNy7wBJ;AkNv7wBI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AlNy7wBN;AkNx7wBM;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AlN07wBR;AkNx7wBQ;EACE,iBAAA;AlN07wBV;AkNz7wBU;EACE,eAAA;EACA,yBjNhIa;AD2jxBzB;AkNz7wBU;EACE,yBD5OiB;EC6OjB,WjNnOJ;EiNoOI,iBAAA;AlN27wBZ;AkN17wBY;EACE,yBDhPe;AjN4qxB7B;AkNz7wBU;EACE,cjNtOD;ADiqxBX;AkNz7wBY;EACE,eAAA;EACA,6BAAA;AlN27wBd;;AkNl7wBA;EACE,cjNpPS;EiNqPT,qBAAA;EACA,WD1PsB;EC2PtB,iBD3PsB;EC4PtB,kBAAA;EACA,gBDhQuB;AjNqrxBzB;AkNp7wBE;EACE,eAAA;AlNs7wBJ;AkNr7wBI;EACE,uB5MgRwB;E4M/QxB,sBjNlQE;ADyrxBR;;AkNl7wBA;EACE,mBjNvQS;EiNwQT,6BAAA;EACA,gBAAA;AlNq7wBF;;AkNl7wBA;;EAEE,mBAAA;AlNq7wBF;;AkNl7wBA;;;EAGE,cjN9QS;EiN+QT,qBAAA;EACA,WDvRsB;ECwRtB,iBDxRsB;ECyRtB,kBAAA;EACA,gBD7RuB;AjNktxBzB;;AkNl7wBA;EACE,eAAA;E3M5RE,uBAAA;APktxBJ;AkNn7wBE;EACE,yBjNpQI;EiNqQJ,WjNnSI;ADwtxBR;AkNl7wBE;EACE,iBAAA;AlNo7wBJ;AkNj7wBE;EACE,uB5MsO0B;E4MrO1B,yBDzT4B;EC0T5B,WjN7SI;ADguxBR;AkNj7wBI;EACE,wCAAA;AlNm7wBN;AkNh7wBI;EACE,cjN/QG;ADisxBT;AkN/6wBI;EACE,cjNxRG;ADysxBT;AkN76wBE;EACE,yBAAA;EACA,WjN9TI;AD6uxBR;AkN76wBI;EACE,yBAAA;EACA,WjNlUE;ADivxBR;AkN36wBE;EAEE,yBjNzOqB;EiN0OrB,c5M04BgC;E4M14BhC,2B5M04BgC;ANkivBpC;AkN16wBI;EACE,yBjN7OmB;EiN8OnB,c5Ms4B8B;E4Mt4B9B,2B5Ms4B8B;ANsivBpC;AkNv6wBE;EACE,uB5M8L0B;E4M7L1B,0CAAA;EACA,WjNrVI;AD8vxBR;AkNv6wBI;EACE,wCAAA;AlNy6wBN;AkNr6wBE;EACE,yBjN9PqB;ADqqxBzB;AkNn6wBI;EACE,yBAAA;EACA,WjNnWE;ADwwxBR;AkNj6wBE;EACE,eAAA;EACA,cjNrWO;ADwwxBX;AkNj6wBI;EACE,6BAAA;EACA,cjNzWK;AD4wxBX;;AkN75wBA;;EAEE,oCAAA;EACA,sBAAA;AlNg6wBF;;AkN75wBA;;;EAGE,6BAAA;EACA,uB5MoJ4B;AN4wwB9B;AkN95wBE;;;EACE,eAAA;AlNk6wBJ;AkNh6wBI;;;;;;EAEE,0CAAA;AlNs6wBN;AkNl6wBE;;;EAEE,yBjNtYO;EiNuYP,YAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBD7Y0B;AjNkzxB9B;;AkNj6wBA;;;EAGE,sBjNtZM;EiNuZN,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,uB5MoH4B;E4MnH5B,yBAAA;AlNo6wBF;AkNl6wBE;;;EACE,eAAA;AlNs6wBJ;AkNn6wBE;;;EACE,aAAA;EACA,kBAAA;AlNu6wBJ;;AkNn6wBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AlNs6wBF;AkNp6wBE;;;EACE,gC5M6F0B;E4M5F1B,iC5M4F0B;AN40wB9B;AkNr6wBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,mC5MoF0B;E4MnF1B,oC5MmF0B;ANs1wB9B;AkNt6wBE;;;EACE,yBjN9bO;ADw2xBX;AkNx6wBI;;;EACE,6CAAA;AlN46wBN;AkNz6wBI;;;EACE,0CAAA;AlN66wBN;AkNz6wBE;;;EACE,kBAAA;EACA,UAAA;AlN66wBJ;;AkNz6wBA;EACE,6BAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AlN46wBF;AkN16wBE;EACE,yBD3eyB;EC4ezB,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WjNreI;EiNseJ,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AlN46wBJ;;AkNx6wBA;EACE,gBjNrfM;EiNsfN,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AlN26wBF;;AkNx6wBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,a5M8lBkC;E4M7lBlC,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AlN26wBF;AkNz6wBE;;;EAGE,WAAA;EACA,iBAAA;AlN26wBJ;AkNv6wBE;EACE;;;IAGE,WAAA;IACA,iBAAA;ElNy6wBJ;AACF;AkNt6wBE;;EAEE,mBAAA;AlNw6wBJ;AkNr6wBE;EACE,iCAAA;EACA,eAAA;AlNu6wBJ;AkNp6wBE;EACE,2BjNxgBI;AD86xBR;AkNp6wBI;EACE,0CAAA;AlNs6wBN;AkNn6wBI;EAEE,4CDrjBkC;ECsjBlC,eAAA;AlNo6wBN;AkNh6wBE;EACE,0BjNthBI;ADw7xBR;AkNh6wBI;EACE,yCAAA;AlNk6wBN;AkN/5wBI;EAEE,2CDnkBkC;ECokBlC,eAAA;AlNg6wBN;;AkN35wBA;EACE,8BAAA;AlN85wBF;;AkN35wBA;EACE,wBAAA;EACA,yBAAA;AlN85wBF;;AmNv/xBA;EACE,YAAA;AnN0/xBF;;AmNv/xBA;;EAEE,cAAA;AnN0/xBF;;AmNv/xBA;;EAEE,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,+DAAA;EACA,4BAAA;AnN0/xBF;;AmNv/xBA;EACE,wBAAA;EACA,yBAAA;EACA,8DAAA;EACA,4BAAA;AnN0/xBF;;AmNv/xBA;;EAEE,+BAAA;EACA,6BAAA;AnN0/xBF;;AmNv/xBA;EACE,gCAAA;EACA,6BAAA;AnN0/xBF;;AmNv/xBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;EnN0/xBF;EmNx/xBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;EnN0/xBF;AACF;AmNv/xBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;EnNy/xBF;EmNv/xBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;EnNy/xBF;AACF;AmNt/xBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AnNw/xBF;;AmNr/xBA;EACE,aAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,oBAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,oBAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,oBAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,oBAAA;AnNw/xBF;;AmNr/xBA;EACE,kBAAA;EACA,WlNrFM;EkNsFN,gBAAA;EACA,qBAAA;EACA,yBlNhFS;EkNiFT,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AnNw/xBF;;AmNr/xBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBlNrGS;AD6lyBX;;AmNr/xBA;EACE,SAAA;AnNw/xBF;;AmNr/xBA;EACE,SAAA;AnNw/xBF;;AmNr/xBA;EACE,UAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,SAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BlN1HS;ADknyBX;;AmNr/xBA;EACE,QAAA;AnNw/xBF;;AmNr/xBA;EACE,QAAA;EACA,aAAA;AnNw/xBF;;AmNr/xBA;EACE,WAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BlNhJS;ADwoyBX;;AmNr/xBA;EACE,QAAA;AnNw/xBF;;AmNr/xBA;EACE,QAAA;EACA,aAAA;AnNw/xBF;;AmNr/xBA;EACE,WAAA;AnNw/xBF;;AmNr/xBA;;;EAGE,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,4BlNtKS;AD8pyBX;;AmNr/xBA;EACE,SAAA;AnNw/xBF;;AmNr/xBA;EACE,SAAA;AnNw/xBF;;AmNr/xBA;EACE,UAAA;AnNw/xBF;;AoNjsyBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;E7MaE,uBAAA;E6MVF,kBAAA;EACA,sBAAA;EACA,6CAAA;ApNosyBF;;AoNjsyBA;EACE,kBAAA;EACA,WAAA;EACA,yBnNES;EmNDT,WAAA;E7MCE,uBAAA;APosyBJ;;AoNjsyBA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;E7MNE,uBAAA;E6MQF,yBnNoBM;ADgryBR;;AoNjsyBA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBnNxBM;EmN0BN,mBAAA;EACA,4BAAA;ApNosyBF;AoNlsyBE;EACE,aAAA;ApNosyBJ;AoNjsyBE;EAGE,oCAAA;EACA,sGAAA;ApNisyBJ;AoN7ryBE;EAEE,gBAAA;ApN+ryBJ;;AoN3ryBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;ApN8ryBF;;AoN3ryBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,cnNvDS;ADqvyBX;;AoN3ryBA;EACE,cnNzDS;ADuvyBX;;AoN3ryBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;ApN8ryBF;;AoN3ryBA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sBnNlFM;EmNmFN,eAAA;EACA,kBAAA;EACA,sBAAA;ApN8ryBF;;AoN3ryBA;EACE,qBnN3DM;ADyvyBR;;AoN3ryBA;EACE,yBnN3FS;ADyxyBX;;AoN3ryBA;EACE,yBnN7FS;AD2xyBX;;AoN3ryBA;;EAEE,qBnNlGS;EmNmGT,gBAAA;EACA,sBnNxGM;EmNyGN,mBAAA;ApN8ryBF;;AoN3ryBA;;EAEE,8BAAA;ApN8ryBF;;AoN3ryBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;ApN8ryBF;;AoN3ryBA;EACE,YAAA;EACA,UAAA;ApN8ryBF;;AoN3ryBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;ApN8ryBF;;AoN3ryBA;EACE,iBAAA;EACA,mBAAA;EAEA,mBAAA;ApN8ryBF;;AoN3ryBA;EACE,MAAA;EACA,UAAA;EACA,YAAA;ApN8ryBF;;AoN3ryBA;EACE,YAAA;EACA,UAAA;ApN8ryBF;;AoN3ryBA;EACE,SAAA;EACA,mBAAA;ApN8ryBF;;AoN3ryBA;EACE,mBAAA;ApN8ryBF;;AoN3ryBA;EACE,mBAAA;ApN8ryBF;;AoN3ryBA;;EAEE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;ApN8ryBF;;AoN3ryBA;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;ApN8ryBF;;AoN3ryBA;;EAEE,yCAAA;EACA,6BAAA;ApN8ryBF;;AoN3ryBA;EACE,0CAAA;EACA,6BAAA;ApN8ryBF;;AoN3ryBA;;EAEE,sBAAA;EACA,yDAAA;ApN8ryBF;;AoN3ryBA;EACE,iEAAA;ApN8ryBF;;AoN3ryBA;EACE;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;EpN8ryBF;EoN5ryBA;IACE,0BAAA;IACA,sBAAA;EpN8ryBF;AACF;AoN3ryBA;EACE;IACE,0BAAA;IACA,sBAAA;EpN6ryBF;EoN3ryBA;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;EpN6ryBF;AACF;AoN1ryBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;ApN4ryBF;;AoNzryBA;EACE,aAAA;ApN4ryBF;;AoNzryBA;EACE,oBAAA;ApN4ryBF;;AoNzryBA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WnNnPM;EmNoPN,kBAAA;EACA,qBAAA;EACA,yBnN7OS;EMPP,uBAAA;E6MsPF,sMnNrJmB;EmNsJnB,iBAAA;ApN4ryBF;;AoNzryBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;ApN4ryBF;;AoNzryBA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBnNhQS;AD47yBX;;AoNrryBI;EACE,yBnN5MS;ADo4yBf;AoNrryBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;AD68yBR;AoNrryBM;EAGE,oCAAA;EACA,sGAAA;ApNqryBR;AoNhryBI;EACE,qBnN7NS;AD+4yBf;;AoNpsyBI;EACE,yBnN5MS;ADm5yBf;AoNpsyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;AD49yBR;AoNpsyBM;EAGE,sCAAA;EACA,0GAAA;ApNosyBR;AoN/ryBI;EACE,qBnN7NS;AD85yBf;;AoNntyBI;EACE,yBnN5MS;ADk6yBf;AoNntyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;AD2+yBR;AoNntyBM;EAGE,sCAAA;EACA,wGAAA;ApNmtyBR;AoN9syBI;EACE,qBnN7NS;AD66yBf;;AoNluyBI;EACE,yBnN5MS;ADi7yBf;AoNluyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;AD0/yBR;AoNluyBM;EAGE,uCAAA;EACA,wGAAA;ApNkuyBR;AoN7tyBI;EACE,qBnN7NS;AD47yBf;;AoNjvyBI;EACE,yBnN5MS;ADg8yBf;AoNjvyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADygzBR;AoNjvyBM;EAGE,uCAAA;EACA,wGAAA;ApNivyBR;AoN5uyBI;EACE,qBnN7NS;AD28yBf;;AoNhwyBI;EACE,yBnN5MS;AD+8yBf;AoNhwyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADwhzBR;AoNhwyBM;EAGE,oCAAA;EACA,sGAAA;ApNgwyBR;AoN3vyBI;EACE,qBnN7NS;AD09yBf;;AoN/wyBI;EACE,yBnN5MS;AD89yBf;AoN/wyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADuizBR;AoN/wyBM;EAGE,sCAAA;EACA,0GAAA;ApN+wyBR;AoN1wyBI;EACE,qBnN7NS;ADy+yBf;;AoN9xyBI;EACE,yBnN5MS;AD6+yBf;AoN9xyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADsjzBR;AoN9xyBM;EAGE,mCAAA;EACA,oGAAA;ApN8xyBR;AoNzxyBI;EACE,qBnN7NS;ADw/yBf;;AoN7yyBI;EACE,yBnN5MS;AD4/yBf;AoN7yyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADqkzBR;AoN7yyBM;EAGE,mCAAA;EACA,oGAAA;ApN6yyBR;AoNxyyBI;EACE,qBnN7NS;ADugzBf;;AoN5zyBI;EACE,yBnN5MS;AD2gzBf;AoN5zyBI;EACE,qBnNhNS;EmNiNT,sBnNtRE;ADolzBR;AoN5zyBM;EAGE,sCAAA;EACA,wGAAA;ApN4zyBR;AoNvzyBI;EACE,qBnN7NS;ADshzBf;;AoNjzyBE;E7MxSE,gBAAA;E6M0SA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,wCAAA;ApNozyBJ;;AoN/yyBE;E7MnTE,kBAAA;E6MqTA,iBAAA;ApNkzyBJ;AoNhzyBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;ApNkzyBN;;AoN1yyBE;EACE,YAAA;EACA,gBAAA;ApN6yyBJ;AoN1yyBE;EACE,WAAA;ApN4yyBJ;AoNzyyBE;EACE,WAAA;ApN2yyBJ;AoNxyyBE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ApN0yyBJ;AoNtyyBI;EACE,iBAAA;EACA,WAAA;ApNwyyBN;AoNlyyBM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;ApNoyyBR;;AoN5xyBE;EACE,YAAA;EACA,gBAAA;ApN+xyBJ;AoN5xyBE;EACE,WAAA;ApN8xyBJ;AoN3xyBE;EACE,WAAA;ApN6xyBJ;AoN1xyBE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ApN4xyBJ;AoNxxyBI;EACE,iBAAA;EACA,WAAA;ApN0xyBN;AoNpxyBM;EACE,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mBnNhZG;ADsqzBX;;AqN5rzBA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;ArN+rzBF;;AqN7rzBA;EACE,+BAAA;ArNgszBF;;AqN9rzBA;EACE,qCAAA;ArNiszBF;;AqN/rzBA;EACE,qCAAA;ArNkszBF;;AqNhszBA;EACE,YAAA;EACA,eAAA;ArNmszBF;;AqNjszBA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;ArNoszBF;;AqNlszBA;EACE,aAAA;ArNqszBF;;AqNnszBA;EACE,+BAAA;EACA,yBAAA;ArNsszBF;;AqNpszBA;EACE,qCAAA;ArNuszBF;;AqNrszBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;ArNwszBF;;AqNtszBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;ArNyszBF;;AqNvszBA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;ArN0szBF;;AqNxszBA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;ArN2szBF;;AqNzszBA;EACE,+BAAA;EACA,yBAAA;ArN4szBF;;AqN1szBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ArN6szBF;;AqN3szBA;EACE,mBAAA;ArN8szBF;;AqN5szBA;EACE,mBAAA;ArN+szBF;;AqN7szBA;EACE,YAAA;EACA,eAAA;ArNgtzBF;;AqN9szBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNitzBF;;AqN/szBA;EACE,WAAA;ArNktzBF;;AqNhtzBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArNmtzBF;;AqNjtzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNotzBF;;AqNltzBA;EACE,YAAA;ArNqtzBF;;AqNntzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNstzBF;;AqNptzBA;EACE,eAAA;ArNutzBF;;AqNrtzBA;EACE,aAAA;EACA,uBAAA;ArNwtzBF;;AqNttzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNytzBF;;AqNvtzBA;EACE,YAAA;ArN0tzBF;;AqNxtzBA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;ArN2tzBF;;AqNztzBA;EACE,YAAA;ArN4tzBF;;AqN1tzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArN6tzBF;;AqN3tzBA;EACE,WAAA;EACA,WAAA;ArN8tzBF;;AqN5tzBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArN+tzBF;;AqN7tzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNguzBF;;AqN9tzBA;EACE,WAAA;EACA,WAAA;ArNiuzBF;;AqN/tzBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArNkuzBF;;AqNhuzBA;EACE,iBAAA;ArNmuzBF;;AqNjuzBA;EACE,2BAAA;ArNouzBF;;AqNluzBA;EACE,6BAAA;ArNquzBF;;AqNnuzBA;EACE,8BAAA;ArNsuzBF;;AqNpuzBA;EACE,qBAAA;ArNuuzBF;;AqNruzBA;EACE,qBAAA;ArNwuzBF;;AqNtuzBA;EACE,qBAAA;ArNyuzBF;;AqNvuzBA;EACE,qBAAA;ArN0uzBF;;AqNxuzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArN2uzBF;;AqNzuzBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;ArN4uzBF;;AqN1uzBA;EACE,aAAA;EACA,mBAAA;ArN6uzBF;;AqN3uzBA;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;ArN8uzBF;;AqN5uzBA;EACE,gCAAA;ArN+uzBF;;AqN7uzBA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ArNgvzBF;;AqN9uzBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;ArNivzBF;;AqN/uzBA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;ArNkvzBF;;AqNhvzBA;EACE,+BAAA;ArNmvzBF;;AqNjvzBA;EACE,iCAAA;ArNovzBF;;AqNlvzBA;EACE,mCAAA;ArNqvzBF;;AqNnvzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArNsvzBF;;AqNpvzBA;EACE,WAAA;ArNuvzBF;;AqNrvzBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArNwvzBF;;AqNtvzBA;EACE,gBAAA;ArNyvzBF;;AqNvvzBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;ArN0vzBF;;AqNxvzBA;EACE,eAAA;ArN2vzBF;;AqNzvzBA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;ArN4vzBF;;AqN1vzBA;EACE,aAAA;ArN6vzBF;;AqN3vzBA;EACE,cAAA;ArN8vzBF;;AqN5vzBA;EACE,mBAAA;ArN+vzBF;;AqN7vzBA;EACE,gBAAA;ArNgwzBF;;AqN9vzBA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;ArNiwzBF;;AqN/vzBA;EACE,+BAAA;ArNkwzBF;;AqNhwzBA;EACE,qCAAA;ArNmwzBF;;AqNjwzBA;EACE,wBAAA;ArNowzBF;;AqNlwzBA;EACE,mBAAA;ArNqwzBF;;AqNnwzBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArNswzBF;;AqNpwzBA;EACE,WAAA;ArNuwzBF;;AqNrwzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArNwwzBF;;AqNtwzBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;ArNywzBF;;AqNvwzBA;EACE,eAAA;EACA,aAAA;ArN0wzBF;;AqNxwzBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ArN2wzBF;;AqNzwzBA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;ArN4wzBF;;AqN1wzBA;EACE,aAAA;EACA,sBAAA;ArN6wzBF;;AqN3wzBA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;ArN8wzBF;;AqN5wzBA;EACE,aAAA;EACA,mBAAA;ArN+wzBF;;AqN7wzBA;EACE,aAAA;ArNgxzBF;;AqN9wzBA;EACE,aAAA;EACA,uBAAA;ArNixzBF;;AqN/wzBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;ArNkxzBF;;AqNhxzBA;EACE,+BAAA;ArNmxzBF;;AqNjxzBA;EACE,qCAAA;ArNoxzBF;;AqNlxzBA;EACE,wBAAA;ArNqxzBF;;AqNnxzBA;EACE,mBAAA;ArNsxzBF;;AqNpxzBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;ArNuxzBF;;AqNrxzBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ArNwxzBF;;AqNtxzBA;EACE,aAAA;ArNyxzBF;;AqNvxzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArN0xzBF;;AqNxxzBA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;ArN2xzBF;;AqNzxzBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArN4xzBF;;AqN1xzBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ArN6xzBF;;AqN3xzBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;ArN6xzBF;;AqN3xzBA;EAEE,uBAAA;ArN8xzBF;;AqN5xzBA;EAEE,uBAAA;ArN+xzBF;AqNzxzBA;EACE;IAEE,mBAAA;ErNoyzBF;EqNnyzBE;IAEA,mBAAA;ErNqyzBF;AACF;AqNnyzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArNqyzBF;;AqNnyzBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;ArNsyzBF;;AqNpyzBA;EACE,eAAA;EACA,cAAA;EACA,aAAA;ArNuyzBF;;AqNryzBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ArNwyzBF;;AqNtyzBA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ArNyyzBF;;AqNvyzBA;EACE,mBAAA;EACA,gCAAA;ArN0yzBF;;AqNxyzBA;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;ArN2yzBF;;AqNzyzBA;EACE,2BAAA;ArN4yzBF;;AqN1yzBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ArN6yzBF;;AqN3yzBA;EACE,eAAA;ArN8yzBF;;AqN5yzBA;EACE,eAAA;EACA,iBAAA;ArN+yzBF;;AqN7yzBA;EACC,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ArNgzzBD;;AqN9yzBA;EACE,aAAA;EACA,mBAAA;ArNizzBF;;AqN/yzBA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;ArNkzzBF;;AqNhzzBA;EACE,mBAAA;ArNmzzBF;;AqNjzzBA;EACE,aAAA;ArNozzBF;;AqNlzzBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;ArNqzzBF;;AqNnzzBA;EACE,+BAAA;ArNszzBF;;AqNpzzBA;EACE,qCAAA;ArNuzzBF;;AqNrzzBA;EACE,wBAAA;ArNwzzBF;;AqNtzzBA;EACE,mBAAA;ArNyzzBF;;AqNvzzBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ArN0zzBF;;AqNxzzBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ArN2zzBF;;AqNzzzBA;EACE,aAAA;ArN4zzBF;;AqN1zzBA;EACE,eAAA;ArN6zzBF;;AqN3zzBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;ArN8zzBF;;AqN5zzBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ArN+zzBF;;AqN7zzBA;EACE,aAAA;ArNg0zBF;;AqN9zzBA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;ArNi0zBF;;AqN/zzBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ArNk0zBF;;AqNh0zBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArNm0zBF;;AqNj0zBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;ArNo0zBF;;AqNl0zBA;EACE,WAAA;ArNq0zBF;;AqNn0zBA;EACE,kBAAA;ArNs0zBF;;AqNp0zBA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,uBAAA;ArNu0zBF;;AqNr0zBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ArNw0zBF;;AqNt0zBA;EACE,kBAAA;ArNy0zBF;;AqNv0zBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;ArN00zBF;;AqNx0zBA;EACE,gBAAA;EACA,gCAAA;ArN20zBF;;AqNz0zBA;EACE,yBAAA;ArN40zBF;;AqN10zBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ArN60zBF;;AqN30zBA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;ArN80zBF;;AqN50zBA;EACE,2BAAA;ArN+0zBF;;AqN70zBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;ArNg1zBF;;AqN90zBA;EACE,kBAAA;ArNi1zBF;;AqN/0zBA;EACE,kBAAA;ArNk1zBF;;AqNh1zBA;EACE,aAAA;EACA,uBAAA;ArNm1zBF;;AqNj1zBA;EACE,aAAA;ArNo1zBF;;AqNl1zBA;EACE,aAAA;EACA,yBAAA;ArNq1zBF;;AqNn1zBA;EACE,QAAA;ArNs1zBF;;AqNp1zBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;ArNu1zBF;;AqNr1zBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;ArNw1zBF;;AqNt1zBA;EACE,aAAA;ArNy1zBF;;AqNv1zBA;EACE,aAAA;ArN01zBF;;AqNx1zBA;EACE,uBAAA;ArN21zBF;;AqNz1zBA;EACE,8BAAA;EACA,iBAAA;ArN41zBF;;AqN11zBA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;ArN61zBF,EqN51zBC;;;;;;;;;CAAA;AAUD;EAA2E,eAAA;EAAe,gBAAA;EAAA,mBAAA;ArN+1zB1F;;AqN/1zB6G;EAAkD,8CAAA;ArNm2zB/J;;AqNn2zB6M;EAAkB,kBAAA;ArNu2zB/N;;AqNv2zBiP;EAA6B,wCAAA;EAAqC,oCAAA;EAAmC,kBAAA;EAAkB,UAAA;ArN82zBxW;;AqN92zBkX;EAA0B,kBAAA;ArNk3zB5Y;;AqNl3zB8Z;EAAuD,gBAAA;ArNs3zBrd;;AqNt3zBqe;EAA2D,OAAA;EAAO,gBAAA;ArN23zBviB;;AqN33zBujB;EAAyD,kBAAA;ArN+3zBhnB;;AqN/3zBkoB;EAA6D,cAAA;EAAc,kBAAA;EAAkB,WAAA;ArNq4zB/tB;;AqNr4zB0uB;EAAwD,iBAAA;ArNy4zBlyB;;AqNz4zBmzB;EAA4D,QAAA;EAAQ,iBAAA;ArN84zBv3B;;AqN94zBw4B;EAAoC,cAAA;EAAc,kBAAA;EAAkB,UAAA;ArNo5zB58B;;AqNp5zBs9B;EAAwC,cAAA;ArNw5zB9/B;;AqNx5zB4gC;EAA+B,aAAA;ArN45zB3iC;;AqN55zBwjC;EAAgC,kBAAA;EAAkB,qBAAA;ArNi6zB1mC;;AqNj6zB+nC;EAA8B,cAAA;EAAc,gBAAA;ArNs6zB3qC;;AqNt6zB2rC;EAA8B,cAAA;EAAc,iBAAA;ArN26zBvuC;;AqN36zBwvC;EAAkC,cAAA;ArN+6zB1xC;;AqN/6zBwyC;EAAkC,cAAA;ArNm7zB10C;;AqNn7zBw1C;EAA0D,cAAA;EAAc,UAAA;ArNw7zBh6C;;AqNx7zB06C;EAAkE,kBAAA;ArN47zB5+C;;AqN57zB8/C;EAAkE,mBAAA;ArNg8zBhkD;;AqNh8zBmlD;EAAkE,gBAAA;ArNo8zBrpD;;AqNp8zBqqD;EAAkE,iBAAA;ArNw8zBvuD;;AqNx8zBwvD;EAAkE,kBAAA;ArN48zB1zD;;AqN58zB40D;EAAkE,mBAAA;ArNg9zB94D;;AqNh9zBi6D;EAAkE,gBAAA;ArNo9zBn+D;;AqNp9zBm/D;EAAkE,iBAAA;ArNw9zBrjE;;AqNx9zBskE;EAAkE,kBAAA;ArN49zBxoE;;AqN59zB0pE;EAAkE,mBAAA;ArNg+zB5tE;;AqNh+zB+uE;EAA4C,uBAAA;EAAuB,kBAAA;ArNq+zBlzE;;AqNr+zBo0E;EAA4E,qBAAA;ArNy+zBh5E;;AqNz+zBq6E;EAA4E,uBAAA;ArN6+zBj/E;;AqN7+zBwgF;EAA0C,qBAAA;EAAqB,kBAAA;ArNk/zBvkF;;AqNl/zBylF;EAAkF,WAAA;EAAW,kBAAA;EAAkB,iBAAA;EAAiB,WAAA;ArNy/zBztF;;AqNz/zBouF;EAAkF,kBAAA;EAAkB,YAAA;EAAY,gBAAA;EAAgB,WAAA;ArNgg0Bp2F;;AqNhg0B+2F;EAAiD,0BAAA;EAA0B,sBAAA;ArNqg0B17F;;AqNrg0Bg9F;EAAiF,0BAAA;EAA0B,sBAAA;ArN0g0B3jG;;AqN1g0BilG;EAAiF,0BAAA;EAA0B,sBAAA;ArN+g0B5rG;;AqN/g0BktG;EAAiF,0BAAA;EAA0B,sBAAA;ArNoh0B7zG;;AqNph0Bm1G;EAAiF,0BAAA;EAA0B,sBAAA;ArNyh0B97G;;AqNzh0Bo9G;EAAgE,kBAAA;ArN6h0BphH;;AqN7h0BsiH;EAAgE,kBAAA;ArNii0BtmH;;AqNji0BwnH;EAAgE,kBAAA;ArNqi0BxrH;;AqNri0B0sH;EAAgE,kBAAA;ArNyi0B1wH;;AqNzi0B4xH;EAAgE,kBAAA;ArN6i0B51H;;AqN3i0BA;EACE,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;ArN8i0BF;;AsNl41BA;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AtNq41BF;;AsNl41BA;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;AtNq41BF;;AsNn41BA;;EAEE,0BAAA;AtNs41BF;;AsNp41BA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;AtNu41BF;;AsNr41BA;EACE,+BAAA;AtNw41BF;;AsNt41BA;EACE,WAAA;AtNy41BF;;AsNt41BA;EACE,OAAA;AtNy41BF;;AsNh41BA;EACE,yBAAA;EANA,8BAOwB;EANxB,sFAAA;EACA,0BAAA;EAOA,kEAAA;EACA,eAAA;AtNo41BF;;AsNl41BA;EACE,aAAA;AtNq41BF;;AsNn41BA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;AtNs41BF;;AsNp41BA;EACE,yBrN3BM;EqN4BN,uCAAA;EACA,4BAAA;EACA,cAAA;AtNu41BF;;AsNr41BA;EACE,oCAAA;AtNw41BF;;AsNt41BA;EACE,4BAAA;EACA,yBrNrCM;EqNsCN,cAAA;EACA,gBAAA;AtNy41BF;;AsNv41BA;EACE,oCAAA;AtN041BF;;AsNv41BA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;AtN041BF;;AsNx41BA;EACE,iBAAA;AtN241BF;;AsNz41BA;EACE,iBAAA;EACA,WAAA;AtN441BF;;AsN141BA;EACE,iBAAA;EACA,WAAA;AtN641BF;;AsNt41BI;EACE,YAAA;EACA,iBAAA;EACA,UAAA;AtNy41BN;AsNv41BI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AtNy41BN;AsNr41BM;EACE,iBAAA;AtNu41BR;AsNl41BM;EACE,iBAAA;EACA,WAAA;AtNo41BR;AsNj41BM;EACE,iBAAA;EACA,WAAA;AtNm41BR;;AuNnh2BA;EACE,WAAA;EACA,0BAAA;EhNeE,qBAAA;EgNbF,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AvNsh2BF;AuNph2BE;EACE,qBtNiCI;ADq/1BR;AuNnh2BE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AvNqh2BJ;AuNlh2BE;EACE,aAAA;AvNoh2BJ;AuNjh2BE;EACE,aAAA;AvNmh2BJ;AuNhh2BE;EACE,WAAA;EACA,YAAA;AvNkh2BJ;AuN/g2BE;EACE,cAAA;EACA,ctNjBO;ADki2BX;AuN9g2BE;EACE,qBtNxBO;ADwi2BX;AuN9g2BI;EACE,ctN1BK;AD0i2BX;;AwN7j2BA;EACE,aAAA;AxNgk2BF;AwN9j2BE;EACE,kBAAA;AxNgk2BJ;AwN9j2BI;EACE,gBAAA;EACA,uBAAA;AxNgk2BN;AwN9j2BM;EACE,aAAA;AxNgk2BR;AwN5j2BI;EACE,kBAAA;AxN8j2BN;AwNzj2BE;EACE,aAAA;AxN2j2BJ;AwNxj2BE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AxN0j2BJ;AwNvj2BI;EACE,yBAAA;EACA,UAAA;AxNyj2BN;AyNvj2BE;EACE,cDCuB;ECAvB,UAAA;AzNyj2BJ;AyNrj2BE;EACE,cDLuB;AxN4j2B3B;AyNnj2BE;EACE,cDVuB;AxN+j2B3B;AwN5j2BI;EACE,eAAA;EACA,gBAAA;AxN8j2BN;AwN3j2BI;EACE,YAAA;AxN6j2BN;AwN1j2BI;EACE,qBAAA;AxN4j2BN;AwNtj2BQ;EACE,YAAA;AxNwj2BV;AwNnj2BQ;EACE,YAAA;AxNqj2BV;AwN/i2BE;EACE,UAAA;AxNij2BJ;AwN/i2BI;EACE,eAAA;AxNij2BN;AwN7i2BE;EACE,yBvNgCqB;EuN/BrB,SAAA;EjN9DA,uBAAA;EiNgEA,cvNpCI;EuNqCJ,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AxN+i2BJ;AwN7i2BI;EACE,yBvNzEK;EuN0EL,cvNtEK;EuNuEL,oBAAA;AxN+i2BN;AwN5i2BI;EACE,eAAA;EACA,mBAAA;AxN8i2BN;AwN3i2BI;EACE,yBvNvDE;EuNwDF,WvNtFE;EuNuFF,aAAA;EACA,qBAAA;AxN6i2BN;AwN1i2BI;EACE,SAAA;EACA,cvNtFK;EuNuFL,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;AxN4i2BN;AwNxi2BE;ECvHA,iDDwHqB;EACnB,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AxN4i2BJ;AwN1i2BI;EACE,YAAA;EACA,WAAA;AxN4i2BN;AwNxi2BE;EClHA,aAAA;EDoHE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA,EAAA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AxN8i2BJ;AwN5i2BI;EACE,WAAA;AxN8i2BN;AwN3i2BI;EACE,gBAAA;EACA,oBAAA,EAAA,yCAAA;EACA,6BAAA;EACA,YAAA;AxN6i2BN;AwNzi2BE;EACE,mBAAA;AxN2i2BJ;AwNxi2BE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AxN0i2BJ;;AwNti2BA,iBAAA;AACA;EC9IE,SD+Ic;AxN6i2BhB;AwN3i2BE;ECzJA,aAAA;AzN2s2BF;AwN9i2BE;EAEE,UAAA;AxN+i2BJ;AwN5i2BE;EAEE,UAAA;AxN6i2BJ;AwN1i2BE;EACE,yBAAA;EACA,4BAAA;AxN4i2BJ;AwNzi2BE;EACE,0BAAA;EACA,6BAAA;AxN2i2BJ;;AwNvi2BA;EACE;IACE,wBAAA;ExN0i2BF;AACF;AwNhi2BE;ECvLA,SDwLgB;EACd,YAAA;AxN2i2BJ;;AwNvi2BA;EACE,6BAAA;EACA,YAAA;AxN0i2BF;;A0Njw2BA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,0MAAA;A1Now2BF;A0N/v2BE;EnNFE,mBAAA;EmNIA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,sMzNoFiB;EyNnFjB,iBAAA;A1Niw2BJ;A0N/v2BI;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;A1Niw2BN;A0N7v2BE;EACE,gBzN3BI;EyN4BJ,YAvCkB;EAwClB,aAAA;EACA,UAAA;A1N+v2BJ;A0N5v2BE;EACE,uBAAA;EACA,QAAA;A1N8v2BJ;A0N3v2BE;EACE,kBAAA;A1N6v2BJ;A0N3v2BI;EACE,WAAA;EACA,YAAA;EnNzCF,kBAAA;APuy2BJ;A0N3v2BM;EACE,WAAA;A1N6v2BR;A0Nxv2BE;EACE,iBzN0BW;EyNzBX,czN/CO;EyNgDP,SAAA;EACA,mBzNvDO;EyNwDP,uBAAA;EACA,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;A1N0v2BJ;A0Nxv2BI;EACE,aAAA;A1N0v2BN;A0Nrv2BI;EACE,czNzCE;EyN0CF,mBzNQS;EyNPT,yBAAA;EACA,SAAA;EACA,kBAAA;A1Nuv2BN;;A0Nlv2BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;EnNrFE,mBAAA;AP202BJ;A0Nnv2BE;EACE,sBAAA;EACA,6BAAA;EACA,UAAA;A1Nqv2BJ;A0Nlv2BE;EACE,UAAA;A1Nov2BJ;;A0Nhv2BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;A1Nmv2BF;;A2Np22BA;EACE,kBAAA;EACA,yBAAA;EpNSE,uBAAA;EoNPF,gBAAA;EACA,YAAA;A3Nu22BF;A2Nr22BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;A3Nu22BJ;A2Nr22BI;EACE,iBrNimBwB;ANsw1B9B;A2Nn22BE;EACE,mB1NVO;E0NWP,c1NkBI;ADm12BR;A2Nn22BI;EACE,c1NTK;AD822BX;A2Nj22BE;EACE,kBAAA;A3Nm22BJ;A2Nh22BE;EACE,c1NnBO;E0NoBP,0BAAA;EACA,eAAA;A3Nk22BJ;;A2N912BA;EACE,gBAAA;A3Ni22BF;;A2N912BA;EACE,8BAAA;A3Ni22BF;;A2N512BA;EACE,aAAA;EACA,mB1NgCkB;AD+z2BpB;;A2N112BA;EACE,YAAA;EACA,aAAA;EACA,WAAA;A3N612BF;;A2Nx12BA;EACE,mB1NrDS;EMDP,uBAAA;EoNwDF,c1NpDS;E0NqDT,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;A3N212BF;;A2Nv12BE;EACE,mB1NlEO;E0NmEP,c1NjEO;AD252BX;;A2Np12BA;EACE,eAAA;A3Nu12BF;;A4Nn72BA;EACE;IACE,aAAA;E5Ns72BF;AACF;Acj32BI;E8MhEF;IACE,cAAA;E5No72BF;E4Nh72BE;IAEE,aAAA;E5Ni72BJ;E4N762BA;IACE,0BAAA;IACA,uBAAA;IACA,6BAAA;E5N+62BF;E4N762BE;IACE,aAAA;E5N+62BJ;E4Nz62BE;IAEE,wBAAA;E5N062BJ;E4Nt62BM;IACE,cAAA;IAAA,oBAAA;E5Nw62BR;E4Nt62BQ;IACE,aAAA;E5Nw62BV;E4Np62BM;IACE,cAAA;IAAA,oBAAA;IACA,wBAAA;E5Ns62BR;E4Nn62BM;IACE,cAAA;IAAA,oBAAA;IACA,SAAA;IACA,cAAA;E5Nq62BR;E4Nl62BM;IACE,mBAAA;E5No62BR;E4Nh62BQ;IACE,uBAAA;E5Nk62BV;E4Nh62BU;IACE,aAAA;E5Nk62BZ;E4N752BU;IACE,iBAAA;E5N+52BZ;E4Nz52BI;IACE,sBAAA;E5N252BN;E4Nz52BM;IACE,sBAAA;IACA,iBAAA;IACA,eAAA;E5N252BR;E4Nt52BE;IACE,YAAA;E5Nw52BJ;E4Nr52BE;IACE,cAAA;E5Nu52BJ;E4Nj52BE;IACE,0BAAA;IACA,WAAA;E5Nm52BJ;E4N/42BA;IACE,8BAAA;E5Ni52BF;E4N/42BE;IACE,aAAA;IACA,QAAA;IACA,kCAAA;IACA,oBAAA;E5Ni52BJ;E4N942BE;IACE,kBAAA;IACA,UAAA;IACA,sM3NNe;I2NOf,kBAAA;IACA,QAAA;IACA,UAAA;IACA,MAAA;IACA,oBAAA;IACA,gB3N/GE;IMEJ,mBAAA;IqN+GE,eAAA;IACA,gBAAA;E5Ng52BJ;E4N942BI;IACE,mBAAA;IACA,iBAAA;E5Ng52BN;E4N942BM;IACE,eAAA;E5Ng52BR;E4N742BM;IACE,aAAA;E5N+42BR;E4N142BM;IACE,aAAA;E5N442BR;E4Nx42BI;IACE,mBAAA;IACA,UAAA;IACA,SAAA;E5N042BN;E4Nt42BE;IACE,aAAA;IACA,QAAA;E5Nw42BJ;E4Nr42BE;IACE,aAAA;IACA,QAAA;E5Nu42BJ;E4Nl42BM;IAEE,oCAAA;IACA,sCAAA;E5Nm42BR;E4N/32BI;IACE,mB3N1JG;ED2h3BT;E4N332BA;;IAEE,0BAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,qBAAA;IACA,sCAAA;IACA,0BAAA;E5N632BF;E4N332BE;;IACE,aAAA;E5N832BJ;E4Nz32BA;IACE,eAAA;IAAA,kBAAA;E5N232BF;E4Nz32BE;IACE,wBAAA;E5N232BJ;E4Nv32BA;IACE,kBAAA;E5Ny32BF;E4Nv32BE;;IAEE,cAAA;IACA,cAAA;E5Ny32BJ;E4Nt32BE;IACE,qBAAA;E5Nw32BJ;E4Nn32BI;;;;IAEE,qBAAA;E5Nu32BN;E4N/22BE;IACE,aAAA;E5Ni32BJ;E4N922BE;IACE,WAAA;E5Ng32BJ;E4N922BI;IACE,cAAA;E5Ng32BN;E4Nx22BM;IACE,yBAAA;E5N022BR;E4Nj22BE;IACE,iBAAA;IACA,cAAA;E5Nm22BJ;E4N912BE;IACE,2BAAA;E5Ng22BJ;E4N312BE;IACE,yBAAA;E5N612BJ;E4N312BI;IACE,gCAAA;IACA,4BAAA;E5N612BN;E4N112BI;IACE,iBAAA;E5N412BN;E4Nt12BE;IACE,aAAA;E5Nw12BJ;E4Nr12BE;IACE,kBAAA;E5Nu12BJ;E4Nn12BA;IACE,yBAAA;E5Nq12BF;E4N/02BI;IACE,iBAAA;E5Ni12BN;E4N502BA;IACE,cAAA;E5N802BF;AACF;Ac1j3BI;E8MiPF;;IAEE,aAAA;E5N402BF;E4Nx02BE;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,e/IjU4B;E7E2o3BhC;E4Nx02BI;;IAEE,mBAAA;E5N002BN;E4Nx02BM;;IACE,sBAAA;IACA,gBAAA;IACA,oBAAA;E5N202BR;E4Np02BE;IACE,2BAAA;E5Ns02BJ;AACF;Achm3BI;E8MiSA;IACE,2BAAA;E5Nk02BJ;AACF;Acxl3BI;E8M4RF;IACE,aAAA;E5N+z2BF;AACF;Ac7l3BI;E8MkSF;IACE,oBAAA;E5N8z2BF;E4N3z2BA;;IAEE,gCAAA;E5N6z2BF;E4N1z2BA;IACE,eAAA;IACA,4BAAA;E5N4z2BF;E4Nzz2BA;IACE,oBAAA;IACA,qBAAA;IACA,iBAAA;E5N2z2BF;E4Nxz2BA;IACE,kBAAA;E5N0z2BF;E4Nvz2BA;;IAEE,UAAA;IACA,SAAA;E5Nyz2BF;E4Ntz2BA;IACE,YAAA;IACA,cAAA;IACA,uBAAA;IACA,kBAAA;E5Nwz2BF;E4Ntz2BE;IACE,oBAAA;E5Nwz2BJ;E4Nrz2BE;IACE,UAAA;E5Nuz2BJ;E4Njz2BI;IACE,+BAAA;IACA,cAAA;E5Nmz2BN;E4Nhz2BI;IACE,0BAAA;IACA,yBAAA;IACA,WAAA;E5Nkz2BN;E4Nhz2BM;IACE,mBAAA;E5Nkz2BR;E4N5y2BA;IACE,aAAA;E5N8y2BF;E4Nzy2BE;;IACE,cAAA;IACA,kBAAA;E5N4y2BJ;E4N1y2BI;;IACE,0BAAA;E5N6y2BN;E4N1y2BI;;IACE,gBAAA;E5N6y2BN;E4Nxy2BA;IACE,YAAA;E5N0y2BF;E4Nvy2BA;IACE,aAAA;E5Nyy2BF;AACF;A4Nty2BA;EAEI;IACE,cAAA;IACA,kBAAA;E5Nuy2BJ;E4Nry2BI;IACE,0BAAA;E5Nuy2BN;E4Npy2BI;IACE,gBAAA;E5Nsy2BN;AACF;AAvk3BA;EACE,kBAAA;AAyk3BF;AAvk3BE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AAyk3BJ;AAtk3BE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;AAwk3BJ;AArk3BE;EACE,gBAAA;EACA,gBAAA;AAuk3BJ;AArk3BI;EACE,UAAA;EACA,yBAAA;AAuk3BN;AApk3BI;EACE,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBMuUwB;ENtUxB,cCnMK;EDoML,mBAAA;AAsk3BN;AApk3BM;EACE,mBChHiB;EDiHjB,qBAAA;AAsk3BR;AApk3BQ;EACE,YAAA;AAsk3BV;AAnk3BQ;EACE,UAAA;AAqk3BV;AAjk3BM;EACE,cC9LA;ED+LA,mBC9HiB;ADis3BzB;AAhk3BM;EAEE,iBAAA;AAik3BR;AA7j3BI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AA+j3BN;AA5j3BI;EACE,2BAAA;EACA,UAAA;EACA,UAAA;AA8j3BN;AA5j3BM;EACE,0BAAA;AA8j3BR;AA1j3BI;EACE,yBAAA;AA4j3BN;AA1j3BM;EACE,uBAAA;AA4j3BR;AA1j3BQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mBC3Ke;ED4Kf,kBAAA;EACA,UAAA;EACA,MAAA;EACA,mBAAA;AA4j3BV;AAzj3BQ;EACE,aAAA;EACA,kBAAA;EACA,cC9QC;ED+QD,eAAA;EACA,kBAAA;AA2j3BV;AAzj3BU;EACE,cC3PJ;ADsz3BR;AAxj3BU;EACE,aAAA;AA0j3BZ;AAvj3BU;EACE,cCnQJ;EDoQI,mBCnMa;AD4v3BzB;AApj3BM;EACE,SAAA;EACA,gBAAA;AAsj3BR;AAnj3BM;EACE,kBAAA;AAqj3BR;;AA5i3BA;EACE;IACE,6BAAA;IACA,qBAAA;IACA,mBAAA;IACA,oBAAA;IACA,0BAAA;IACA,sBAAA;IACA,2BAAA;IACA,2BAAA;EA+i3BF;AACF;AA3i3BA;;;EAEE,uBAAA;AA8i3BF;;AqFn43BA;EACE,kBAAA;ArFs43BF;AqFp43BE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;ArFs43BJ;AqFn43BE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;ArFq43BJ;AqFl43BE;EACE,gBAAA;EACA,gBAAA;ArFo43BJ;AqFl43BI;EACE,UAAA;EACA,yBAAA;ArFo43BN;AqFj43BI;EACE,6EAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;E9EnBF,uBAAA;E8EqBE,cpFfK;EoFgBL,mBAAA;ArFm43BN;AqFj43BM;EACE,mBpFoEiB;EoFnEjB,qBAAA;ArFm43BR;AqFj43BQ;EACE,YAAA;ArFm43BV;AqFh43BQ;EACE,UAAA;ArFk43BV;AqF933BM;EACE,cpFVA;EoFWA,mBpFsDiB;AD003BzB;AqF733BM;EAEE,iBAAA;ArF833BR;AqF133BI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;ArF433BN;AqFz33BI;EACE,2BAAA;EACA,UAAA;EACA,UAAA;ArF233BN;AqFz33BM;EACE,0BAAA;ArF233BR;AqFv33BI;EACE,yBAAA;ArFy33BN;AqFv33BM;EACE,uBAAA;ArFy33BR;AqFv33BQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mBpFSe;EoFRf,kBAAA;EACA,UAAA;EACA,MAAA;E9EvFN,mBAAA;APi93BJ;AqFt33BQ;EACE,aAAA;EACA,kBAAA;EACA,cpF1FC;EoF2FD,eAAA;EACA,kBAAA;ArFw33BV;AqFt33BU;EACE,cpFvEJ;AD+73BR;AqFr33BU;EACE,aAAA;ArFu33BZ;AqFp33BU;EACE,cpF/EJ;EoFgFI,mBpFfa;ADq43BzB;AqFj33BM;EACE,SAAA;EACA,gBAAA;ArFm33BR;AqFh33BM;EACE,kBAAA;ArFk33BR;;AyFv/3BE;EACE,yBAAA;EACA,WZE8B;EYD9B,eZC8B;EYA9B,cAAA;EACA,WAAA;AzF0/3BJ;AyFx/3BI;EACE,mBAAA;AzF0/3BN;AyFx/3BM;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;AzF0/3BR;AyFx/3BQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,WAAA;EACA,mBxFmFe;EwFlFf,gBAAA;AzF0/3BV;AyFt/3BM;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AzFw/3BR;AyFr/3BM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AzFu/3BR;AyFp/3BM;EACE,kBAAA;AzFs/3BR;AyFn/3BM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AzFq/3BR;AyFn/3BQ;EACE,UAAA;AzFq/3BV;AyFn/3BU;EACE,SAAA;AzFq/3BZ;AyFj/3BQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AzFm/3BV;AyF9+3BI;EACE,0BAAA;EACA,uBAAA;AzFg/3BN;AyF9+3BM;EACE,0BAAA;AzFg/3BR;AyF9+3BQ;EACE,cAAA;EAAA,oBAAA;EACA,2BAAA;EACA,UAAA;AzFg/3BV;AyF/+3BU;EACE,aAAA;AzFi/3BZ;AyF7+3BQ;EACE,cAAA;EAAA,oBAAA;EACA,wBAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;AzF++3BV;AyF5+3BQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AzF8+3BV;AyF3+3BQ;EACE,mBAAA;AzF6+3BV;AyF1+3BQ;EACE,cAAA;EACA,UAAA;AzF4+3BV;AyF1+3BU;EACE,uBAAA;AzF4+3BZ;AyF1+3BY;EACE,aAAA;EACA,kBAAA;AzF4+3Bd;AyFv+3BY;EACE,kBAAA;AzFy+3Bd;AyFr+3BU;EACE,WAAA;EACA,cAAA;AzFu+3BZ;AyF793BM;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EAAA,4BAAA;AzF+93BR;AyF393BQ;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;AzF693BV;AyFr93BM;EACE,WZ3J0B;A7Ekn4BlC;AyFr93BQ;EACE,aAAA;AzFu93BV;AyFp93BQ;EACE,kBAAA;AzFs93BV;AyF983BI;EACE,kBZ3K4B;A7E2n4BlC;AyF183BM;EACE,kBAAA;AzF483BR;AyFp83BM;;EACE,WAAA;EACA,aAAA;AzFu83BR;AyFr83BQ;;EACE,aAAA;AzFw83BV;AyFl83BM;EACE,aAAA;EACA,WZvM0B;EYwM1B,4BAAA;AzFo83BR;AyFl83BQ;EACE,yBAAA;EACA,cAAA;EACA,WAAA;AzFo83BV;AyFj83BQ;EACE,aAAA;AzFm83BV;AyF973BQ;EACE,YZxNwB;A7Ewp4BlC;AyF973BU;EACE,WZvNsB;EYwNtB,SAAA;AzFg83BZ;AyFz73BI;EACE,yBAAA;AzF273BN;AyFt73BI;EACE,yBAAA;AzFw73BN;;AAz03BA;EACE,8BAAA;AA403BF","sourcesContent":["/* NOTE: bootstrap/ is loaded from node_modules/ using sass-loader */\r\n\r\n// SASS IMPORTS\r\n@use \"sass:math\";\r\n\r\n// BOOTSTRAP 5 VARIABLES\r\n\r\n// 1. Include functions first (so you can manipulate colors, SVGs, calc, etc)\r\n@import \"bootstrap/scss/functions\";\r\n\r\n// 2. Include any default variable overrides here\r\n\r\n@import \"themes/layout-variables\";\r\n\r\n// 3. Include remainder of required Bootstrap stylesheets\r\n\r\n@import \"bootstrap/scss/variables\";\r\n@import \"bootstrap/scss/variables-dark\";\r\n@import \"bootstrap/scss/maps\";\r\n@import \"bootstrap/scss/mixins\";\r\n@import \"bootstrap/scss/utilities\";\r\n\r\n// BOOTSTRAP 5 IMPORTS\r\n\r\n@import \"bootstrap/scss/root\";\r\n@import \"bootstrap/scss/reboot\";\r\n@import \"bootstrap/scss/type\";\r\n@import \"bootstrap/scss/images\";\r\n@import \"bootstrap/scss/containers\";\r\n@import \"bootstrap/scss/grid\";\r\n@import \"bootstrap/scss/tables\";\r\n@import \"bootstrap/scss/forms\";\r\n@import \"bootstrap/scss/buttons\";\r\n@import \"bootstrap/scss/transitions\";\r\n@import \"bootstrap/scss/dropdown\";\r\n@import \"bootstrap/scss/button-group\";\r\n@import \"bootstrap/scss/nav\";\r\n@import \"bootstrap/scss/navbar\";\r\n@import \"bootstrap/scss/card\";\r\n@import \"bootstrap/scss/accordion\";\r\n@import \"bootstrap/scss/breadcrumb\";\r\n@import \"bootstrap/scss/pagination\";\r\n@import \"bootstrap/scss/badge\";\r\n@import \"bootstrap/scss/alert\";\r\n@import \"bootstrap/scss/progress\";\r\n@import \"bootstrap/scss/list-group\";\r\n@import \"bootstrap/scss/close\";\r\n@import \"bootstrap/scss/toasts\";\r\n@import \"bootstrap/scss/modal\";\r\n@import \"bootstrap/scss/tooltip\";\r\n@import \"bootstrap/scss/popover\";\r\n@import \"bootstrap/scss/carousel\";\r\n@import \"bootstrap/scss/spinners\";\r\n@import \"bootstrap/scss/offcanvas\";\r\n@import \"bootstrap/scss/placeholders\";\r\n@import \"bootstrap/scss/helpers\";\r\n@import \"bootstrap/scss/utilities/api\";\r\n\r\n// LAYOUT\r\n\r\n@import \"layout/layout\";\r\n\r\n// UTILS\r\n\r\n@import \"utils/helpers\";\r\n@import \"utils/backgrounds\";\r\n@import \"utils/animate\";\r\n@import \"utils/comps-animations\";\r\n\r\n// ELEMENTS\r\n\r\n@import \"elements/buttons\";\r\n@import \"elements/dropdown\";\r\n@import \"elements/navs\";\r\n@import \"elements/badges\";\r\n@import \"elements/cards\";\r\n@import \"elements/tabs\";\r\n@import \"elements/accordions\";\r\n@import \"elements/modals\";\r\n@import \"elements/loaders\";\r\n@import \"elements/progressbar\";\r\n@import \"elements/timeline\";\r\n@import \"elements/listgroup\";\r\n@import \"elements/forms\";\r\n@import \"elements/pagination\";\r\n@import \"elements/chat\";\r\n@import \"elements/forms-wizard\";\r\n\r\n// DASHBOARD BOXES\r\n\r\n@import \"widgets/chart-boxes/chart-boxes\";\r\n@import \"widgets/content-boxes/content-boxes\";\r\n@import \"widgets/profile-boxes/profile-boxes\";\r\n\r\n// PAGES\r\n\r\n@import \"pages/userpages\";\r\n\r\n// Applications\r\n\r\n@import \"applications/applications-base\";\r\n\r\n// COMPONENTS\r\n\r\n// Perfect Scrollbar\r\n@import \"components/perfect-scrollbar/perfect-scrollbar\";\r\n\r\n// RC Tabs\r\n@import \"components/rc-tabs/rc-tabs\";\r\n\r\n// Loading Buttons\r\n@import \"components/loading-buttons/loading-buttons\";\r\n\r\n// Hamburger Button\r\n@import \"components/hamburgers/hamburgers\";\r\n\r\n// Drawer\r\n@import \"components/drawer/drawer\";\r\n\r\n// Notifications\r\n@import \"components/notifications/sweetalerts\";\r\n@import \"components/notifications/toastify\";\r\n\r\n// Modals\r\n@import \"components/modals/rodal\";\r\n\r\n// Progress Bar\r\n@import \"components/progress-bar/progress-bar\";\r\n\r\n// Slick Carousel\r\n@import \"components/slick-carousel/slick/slick\";\r\n\r\n// Block loading\r\n@import \"components/block-loading/block-loading\";\r\n\r\n// Popovers & Tooltips\r\n@import \"components/popovers-tooltips/popovers-tooltips\";\r\n\r\n// Sticky Elements\r\n@import \"components/sticky-elements/sticky-elements\";\r\n\r\n// Calendar\r\n@import \"components/calendar/calendar\";\r\n\r\n// Splitters\r\n@import \"components/splitters/splitters\";\r\n\r\n// Tree View\r\n@import \"components/tree-view/tree-view\";\r\n\r\n// Tables\r\n@import \"components/tables/tables\";\r\n\r\n// Icons\r\n@import \"components/icons/linearicons\";\r\n@import \"components/icons/p7icons\";\r\n\r\n// FORMS\r\n\r\n@import \"components/forms/datepicker/datepicker\";\r\n@import \"components/forms/rangeslider/rangeslider\";\r\n@import \"components/forms/multiselect/multiselect\";\r\n@import \"components/forms/wysiwyg/wysiwyg\";\r\n@import \"components/forms/toggle-switch/switch\";\r\n@import \"components/forms/dropzone/dropzone\";\r\n@import \"components/forms/typeahead/typeahead\";\r\n\r\n// REACT WIDGETS (Disabled for React 19 compatibility)\r\n\r\n// @import \"components/react-widgets/scss/react-widgets\";\r\n\r\n// DEMO\r\n\r\n@import \"demo-ui/demo\";\r\n\r\n// Responsive\r\n\r\n@import \"layout/responsive/responsive-base\";\r\n\r\n// ORIGINAL ARCHITECTUI NAVIGATION STYLES\r\n\r\n// Navigation Menu Vertical\r\n.vertical-nav-menu {\r\n  position: relative;\r\n\r\n  &::after {\r\n    content: \" \";\r\n    pointer-events: none;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .metismenu-container,\r\n  .metismenu-item {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n  }\r\n  \r\n  .metismenu-container {\r\n    list-style: none;\r\n    text-align: left;\r\n\r\n    &:before {\r\n      opacity: 0;\r\n      transition: opacity 300ms;\r\n    }\r\n\r\n    .metismenu-link {\r\n      transition: transform .2s, height 300ms, color 300ms, background-color 300ms;\r\n      display: flex;\r\n      align-items: center;\r\n      line-height: 2.5rem;\r\n      height: 2.5rem;\r\n      padding: 0 $layout-spacer-x 0 45px;\r\n      position: relative;\r\n      border-radius: $border-radius;\r\n      color: $gray-800;\r\n      white-space: nowrap;\r\n\r\n      &:hover {\r\n        background: $dropdown-link-hover-bg;\r\n        text-decoration: none;\r\n\r\n        i.metismenu-icon {\r\n          opacity: .6;\r\n        }\r\n\r\n        i.metismenu-state-icon {\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        color: $primary;\r\n        background: $dropdown-link-hover-bg;\r\n      }\r\n\r\n      &.has-active-child,\r\n      &.active {\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    i.metismenu-state-icon,\r\n    i.metismenu-icon {\r\n      text-align: center;\r\n      width: 34px;\r\n      height: 34px;\r\n      line-height: 34px;\r\n      position: absolute;\r\n      left: 5px;\r\n      top: 50%;\r\n      margin-top: -17px;\r\n      font-size: 1.5rem;\r\n      opacity: .3;\r\n      transition: color 300ms;\r\n    }\r\n\r\n    i.metismenu-state-icon {\r\n      transition: transform 300ms;\r\n      left: auto;\r\n      right: 5px;\r\n\r\n      &.rotate-minus-90 {\r\n        transform: rotate(-180deg);\r\n      }\r\n    }\r\n\r\n    .metismenu-container {\r\n      transition: padding 300ms;\r\n\r\n      &.visible {\r\n        padding: .5em 0 0 2rem;\r\n\r\n        &:before {\r\n          content: '';\r\n          height: 100%;\r\n          opacity: 1;\r\n          width: 3px;\r\n          background: $dropdown-link-hover-bg;\r\n          position: absolute;\r\n          left: 20px;\r\n          top: 0;\r\n          border-radius: 15px;\r\n        }\r\n\r\n        & > .metismenu-item > .metismenu-link {\r\n          height: 2.3em;\r\n          line-height: 2.3em;\r\n          color: $gray-600;\r\n          margin: 0 0 3px;\r\n          padding-left: 35px;\r\n\r\n          &:hover {\r\n            color: $primary;\r\n          }\r\n\r\n          .metismenu-icon {\r\n            display: none;\r\n          }\r\n\r\n          &.active {\r\n            color: $primary;\r\n            background: $dropdown-link-hover-bg;\r\n          }\r\n        }\r\n      }\r\n\r\n      .metismenu-item > .metismenu-link {\r\n        height: 0;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .metismenu-link {\r\n        padding-left: 35px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// CUSTOM FIXES FOR UI ISSUES\r\n\r\n// Fix: User profile dropdown positioning on desktop\r\n@media (min-width: 768px) {\r\n  .header-btn-lg .dropdown-menu {\r\n    position: absolute !important;\r\n    left: auto !important;\r\n    right: 0 !important;\r\n    top: 100% !important;\r\n    transform: none !important;\r\n    width: auto !important;\r\n    min-width: 280px !important;\r\n    max-width: 320px !important;\r\n  }\r\n}\r\n\r\n// Fix: Badge text color override\r\n.badge.text-bg-success,\r\n.badge.text-bg-success small {\r\n  color: white !important;\r\n}\r\n\r\n// ORIGINAL ARCHITECTUI NAVIGATION STYLES\r\n@import \"layout/sidebar/modifiers/_navmenu-vertical\";\r\n@import \"layout/sidebar/modifiers/_closed-sidebar\";\r\n\r\n\r\n\r\n// Ensure Toastify toasts appear above any header/overlay\r\n.Toastify__toast-container {\r\n  z-index: 2147483647 !important;\r\n}\r\n","@use \"sass:math\";\r\n@use \"sass:map\";\r\n\r\n// GENERIC\r\n\r\n$enable-caret: true;\r\n$enable-rounded: true;\r\n$enable-shadows: false;\r\n$enable-gradients: false;\r\n$enable-transitions: true;\r\n$enable-grid-classes: true;\r\n$enable-print-styles: false;\r\n\r\n$body-bg: #fff;\r\n\r\n// Colors\r\n\r\n$white: #fff;\r\n$gray-100: #f8f9fa;\r\n$gray-200: #e9ecef;\r\n$gray-300: #dee2e6;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #6c757d;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black: #000;\r\n\r\n$grays: ();\r\n\r\n$grays: map.merge(\r\n                (\r\n                        \"100\": $gray-100,\r\n                        \"200\": $gray-200,\r\n                        \"300\": $gray-300,\r\n                        \"400\": $gray-400,\r\n                        \"500\": $gray-500,\r\n                        \"600\": $gray-600,\r\n                        \"700\": $gray-700,\r\n                        \"800\": $gray-800,\r\n                        \"900\": $gray-900\r\n                ),\r\n                $grays\r\n);\r\n\r\n//--#{$color}\r\n$brand: #545cd8;\r\n$blue: #86c6fb;\r\n$indigo: #444054;\r\n$purple: #83588a;\r\n$pink: #f65ca2;\r\n$red: #d92550;\r\n$orange: #fd7e14;\r\n$yellow: #f7b924;\r\n$green: #3ac47d;\r\n$teal: #16E0BD;\r\n$cyan: #30b1ff;\r\n$blue-light: #eeeeee;\r\n\r\n$primary: $brand;\r\n$secondary: $gray-600;\r\n$success: $green;\r\n$info: $cyan;\r\n$warning: $yellow;\r\n$danger: $red;\r\n$light: $blue-light;\r\n$dark: $gray-800;\r\n$focus: $indigo;\r\n$alt: $purple;\r\n\r\n$theme-colors: ();\r\n\r\n$custom-colors: (\r\n  \"primary\": $primary,\r\n  \"secondary\": $secondary,\r\n  \"success\": $success,\r\n  \"info\": $info,\r\n  \"warning\": $warning,\r\n  \"danger\": $danger,\r\n  \"light\": $light,\r\n  \"dark\": $dark,\r\n  \"focus\": $focus,\r\n  \"alternate\": $alt\r\n);\r\n\r\n$theme-colors: map.merge( $theme-colors, $custom-colors);\r\n\r\n// BOOTSTRAP OVERWRITES\r\n\r\n// Global gutter width override (reduce from Bootstrap default 1.5rem to 1rem)\r\n$grid-gutter-width: 1rem !default;\r\n\r\n$headings-font-weight: 400;\r\n\r\n$font-size-base: 0.88rem;\r\n$font-size-lg: ($font-size-base * 1.25);\r\n$font-size-sm: ($font-size-base * 1.1);\r\n$font-size-xs: math.div($font-size-base, 1.1);\r\n\r\n$btn-transition: color .15s, background-color .15s, border-color .15s, box-shadow .15s;\r\n$btn-focus-width: 0;\r\n$btn-focus-box-shadow: none;\r\n\r\n$pagination-focus-box-shadow: none;\r\n\r\n$body-color: $gray-700;\r\n\r\n$card-cap-bg: $white;\r\n$card-border-color: rgba(shade-color($primary, 25%), .125);\r\n\r\n$dropdown-min-width: 15rem;\r\n$dropdown-link-hover-bg: #e0f3ff;\r\n$dropdown-item-padding-y: .4rem;\r\n$dropdown-padding-y: .65rem;\r\n\r\n$box-shadow-default: 0 0.46875rem 2.1875rem rgba(shade-color($primary, 50%), .03), 0 0.9375rem 1.40625rem rgba(shade-color($primary, 50%), .03), 0 0.25rem 0.53125rem rgba(shade-color($primary, 50%), .05), 0 0.125rem 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n\r\n$box-shadow-default-right: 0.46875rem 0 2.1875rem rgba(shade-color($primary, 50%), .03),\r\n0.9375rem 0 1.40625rem rgba(shade-color($primary, 50%), .03),\r\n0.25rem 0 0.53125rem rgba(shade-color($primary, 50%), .05),\r\n0.125rem 0 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n\r\n$box-shadow-default-inverse: 0 -0.46875rem 2.1875rem rgba(shade-color($primary, 50%), .03), 0 -0.9375rem 1.40625rem rgba(shade-color($primary, 50%), .03), 0 -0.25rem 0.53125rem rgba(shade-color($primary, 50%), .05), 0 -0.125rem 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n\r\n$box-shadow-lg-default: 0 0.76875rem 2.4875rem rgba($gray-800, .3), 0 1.3375rem 1.70625rem rgba($gray-800, .3), 0 0.55rem 0.53125rem rgba(shade-color($gray-800, 50%), .05), 0 0.225rem 0.4375rem rgba($gray-800, .3);\r\n\r\n$form-check-input-margin-y: 0.3rem;\r\n\r\n$input-group-addon-bg: tint-color($dropdown-link-hover-bg, 3%);\r\n\r\n// Tables\r\n\r\n$table-accent-bg: rgba($black, .03);\r\n$table-hover-bg: $dropdown-link-hover-bg;\r\n$table-active-bg: $table-hover-bg;\r\n$table-border-color: $gray-200;\r\n$table-head-bg: $gray-100;\r\n$table-head-color: $gray-600;\r\n$table-cell-padding: .55rem;\r\n$table-cell-padding-sm: .3rem;\r\n\r\n// Popovers\r\n\r\n$popover-max-width: 320px;\r\n$popover-box-shadow: $box-shadow-default;\r\n$popover-border-color: $card-border-color;\r\n$popover-header-bg: $white;\r\n\r\n// Color Modifiers\r\n\r\n$link-color: $primary;\r\n$component-active-bg: $primary;\r\n$custom-control-indicator-checked-disabled-bg: rgba($primary, .5);\r\n$form-feedback-valid-color: $success;\r\n$form-feedback-invalid-color: $danger;\r\n$progress-bar-bg: $primary;\r\n$input-btn-focus-color: rgba($component-active-bg, .25);\r\n$input-focus-border-color: tint-color($component-active-bg, 25%);\r\n$custom-control-indicator-checked-bg: $component-active-bg;\r\n$custom-control-indicator-active-bg: tint-color($component-active-bg, 35%);\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg;\r\n$custom-range-thumb-bg: $component-active-bg;\r\n$custom-range-thumb-active-bg: tint-color($component-active-bg, 35%);\r\n$dropdown-link-active-bg: $component-active-bg;\r\n$nav-pills-link-active-bg: $component-active-bg;\r\n$pagination-active-bg: $component-active-bg;\r\n$list-group-active-bg: $component-active-bg;\r\n\r\n$list-group-border-color: rgba($primary, .08) !default;\r\n\r\n// Mixins\r\n\r\n@mixin box-shadow-architect($shadow) {\r\n  box-shadow: 0 0.66875rem 2.3875rem rgba($shadow, .03), 0 1.1375rem 1.60625rem rgba($shadow, .03), 0 0.45rem 0.73125rem rgba($shadow, .05), 0 0.325rem 0.3875rem rgba($shadow, .03);\r\n}\r\n\r\n// Border\r\n\r\n@each $color, $value in $theme-colors {\r\n  .border-#{$color} {\r\n    border-color: $value;\r\n  }\r\n}\r\n\r\n// List Group\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   @include list-group-item-variant($color, color-level($color, -9), color-level($color, 6));\r\n// }\r\n\r\n// // Background\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   @include bg-variant(\".bg-#{$color}\", $value);\r\n// }\r\n\r\n@if $enable-gradients {\r\n  @each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n  }\r\n}",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// General\r\n\r\na,\r\nbutton,\r\n.btn {\r\n  outline: none !important;\r\n}\r\n\r\n.app-container {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  flex-direction: column;\r\n  margin: 0;\r\n}","// Sidebar Animation\r\n\r\n.SidebarAnimation-appear {\r\n  transform: translateX(-30px);\r\n  opacity: 0;\r\n\r\n  &.SidebarAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    transition: all .4s linear;\r\n  }\r\n}\r\n\r\n// Tabs Animation\r\n\r\n.TabsAnimation-appear {\r\n  @extend .animated;\r\n  @extend .fadeInUp;\r\n}\r\n\r\n// Header Animation\r\n\r\n.HeaderAnimation-appear {\r\n  transform: translateY(-30px);\r\n  opacity: 0;\r\n\r\n  &.HeaderAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: all .4s linear;\r\n  }\r\n}\r\n\r\n// Main Animation\r\n\r\n.MainAnimation-appear {\r\n  transform: translateY(-30px);\r\n  opacity: 0;\r\n\r\n  &.MainAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: all .4s linear;\r\n  }\r\n}","// Header Base\r\n\r\n.app-header {\r\n  height: $app-header-height;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  position: relative;\r\n  z-index: 10;\r\n  transition: all .2s;\r\n\r\n  &.header-shadow {\r\n    box-shadow: $box-shadow-default;\r\n  }\r\n\r\n  .app-header__content {\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    flex: 1;\r\n    padding: 0 $layout-spacer-x;\r\n    height: $app-header-height;\r\n\r\n    .app-header-left {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .app-header-right {\r\n      align-items: center;\r\n      display: flex;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n\r\n  .header-user-info {\r\n    & > .widget-heading,\r\n    & > .widget-subheading {\r\n      white-space: nowrap;\r\n    }\r\n\r\n    & > .widget-subheading {\r\n      font-size: $font-size-xs;\r\n    }\r\n  }\r\n}\r\n\r\n.app-header__logo {\r\n  padding: 0 $layout-spacer-x;\r\n  height: $app-header-height;\r\n  width: $app-sidebar-width;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: width .2s;\r\n\r\n  .logo-src {\r\n    height: $logo-height;\r\n    width: $logo-width;\r\n    background: url('../../../assets/utils/images/logo-inverse.png');\r\n  }\r\n\r\n  .Burger {\r\n    padding: 0 8px;\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n.app-header__menu,\r\n.app-header__mobile-menu {\r\n  display: none;\r\n  padding: 0 $layout-spacer-x;\r\n  height: $app-header-height;\r\n  align-items: center;\r\n}\r\n\r\n// Header Modifiers\r\n\r\n@import \"modifiers/fixed-header\";\r\n@import \"modifiers/header-dots\";\r\n@import \"modifiers/header-megamenu\";\r\n@import \"modifiers/header-buttons\";\r\n//@import \"modifiers/header-horizontal\";\r\n\r\n// Header Themes\r\n\r\n@import \"themes/header-light\";\r\n@import \"themes/header-dark\";\r\n//@import \"themes/header-inverted\";","// Variables\r\n\r\n$spacer-lg                      : 3rem;\r\n$spacer-sm                      : 1.5rem;\r\n\r\n$layout-spacer-lg               : 3rem;\r\n$layout-spacer-x                : 1.5rem;\r\n\r\n$app-sidebar-width              : 280px;\r\n$app-sidebar-width-collapsed    : 80px;\r\n\r\n$logo-height                    : 23px;\r\n$logo-width                     : 97px;\r\n\r\n$app-header-height              : 60px;","// Fixed Header\r\n\r\n.fixed-header {\r\n  .app-header {\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0;\r\n\r\n    .app-header__logo {\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  .app-main {\r\n    padding-top: $app-header-height;\r\n  }\r\n\r\n  &:not(.fixed-sidebar):not(.closed-sidebar) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        visibility: hidden;\r\n      }\r\n    }\r\n  }\r\n}","// Header Dots\r\n\r\n.header-dots {\r\n  margin-left: auto;\r\n  display: flex;\r\n\r\n  & > .dropdown {\r\n    display: flex;\r\n    align-content: center;\r\n  }\r\n\r\n  .icon-wrapper-alt {\r\n    margin: 0;\r\n    height: 44px;\r\n    width: 44px;\r\n    text-align: center;\r\n    overflow: visible;\r\n\r\n    .language-icon {\r\n      @include border-radius(30px);\r\n      position: relative;\r\n      z-index: 4;\r\n      width: 28px;\r\n      height: 28px;\r\n      overflow: hidden;\r\n      margin: 0 auto;\r\n\r\n      img {\r\n        position: relative;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin: -22px 0 0 -20px;\r\n      }\r\n\r\n    }\r\n\r\n    .icon-wrapper-bg {\r\n      opacity: .1;\r\n      transition: opacity .2s;\r\n      @include border-radius(40px);\r\n    }\r\n\r\n    svg {\r\n      margin: 0 auto;\r\n    }\r\n\r\n    @-moz-document url-prefix() {\r\n      svg {\r\n        width: 50%;\r\n      }\r\n    }\r\n\r\n    i {\r\n      font-size: 1.3rem;\r\n    }\r\n\r\n    &:hover {\r\n      cursor: pointer;\r\n\r\n      .icon-wrapper-bg {\r\n        opacity: .2;\r\n      }\r\n    }\r\n\r\n    .badge-dot {\r\n      top: 1px;\r\n      right: 1px;\r\n      border: 0;\r\n    }\r\n  }\r\n}","// Header Mega Menu\r\n\r\n@use \"sass:math\";\r\n\r\n.header-megamenu {\r\n  &.nav {\r\n    & > li > .nav-link {\r\n      color: $gray-600;\r\n      padding-left: math.div($nav-link-padding-x, 1.5);\r\n      padding-right: math.div($nav-link-padding-x, 1.5);\r\n\r\n      .rounded-pill {\r\n        padding: 5px 7px;\r\n      }\r\n\r\n      &:hover {\r\n        color: $gray-800;\r\n      }\r\n\r\n      svg {\r\n        margin-top: 1px;\r\n      }\r\n    }\r\n  }\r\n}","\r\n// Header Buttons\r\n\r\n.header-btn-lg {\r\n  padding: 0 0 0 ($layout-spacer-x);\r\n  margin-left: ($layout-spacer-x);\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n  &::before {\r\n    position: absolute;\r\n    left: -1px;\r\n    top: 50%;\r\n    background: $border-color;\r\n    width: 1px;\r\n    height: 30px;\r\n    margin-top: -15px;\r\n    content: '';\r\n  }\r\n\r\n  .hamburger-inner,\r\n  .hamburger-inner::before,\r\n  .hamburger-inner::after {\r\n    background: $gray-600;\r\n  }\r\n\r\n}","// Header Light\r\n\r\n.app-header {\r\n  &.header-text-light {\r\n    .app-header-left > .nav > li > .nav-link {\r\n      color: rgba(255, 255, 255, .7);\r\n\r\n      .nav-link-icon {\r\n        color: rgba(255, 255, 255, .8);\r\n      }\r\n\r\n      &:hover {\r\n        color: rgba(255, 255, 255, 1);\r\n      }\r\n    }\r\n\r\n    .app-header-right {\r\n      .icon-wrapper-alt {\r\n\r\n        svg {\r\n          fill: rgba(255, 255, 255, .7);\r\n          transition: all .2s;\r\n        }\r\n\r\n        .icon-wrapper-bg {\r\n          background: rgba(255, 255, 255, .1) !important;\r\n          transition: all .2s;\r\n          opacity: 1;\r\n        }\r\n\r\n        &:hover {\r\n          svg {\r\n            fill: rgba(255, 255, 255, .95);\r\n          }\r\n\r\n          .icon-wrapper-bg {\r\n            background: rgba(255, 255, 255, .15) !important;\r\n          }\r\n        }\r\n\r\n        .badge-dot {\r\n          border-color: transparent;\r\n        }\r\n      }\r\n\r\n      & > .header-btn-lg {\r\n\r\n        & .widget-content-left .btn-group > .btn-link,\r\n        .widget-heading,\r\n        .widget-subheading {\r\n          color: rgba(255, 255, 255, .8);\r\n        }\r\n\r\n        .header-user-info {\r\n          & > .btn-shadow {\r\n            box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, .1), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .search-wrapper {\r\n      .input-holder {\r\n        .search-icon {\r\n          background: rgba(0, 0, 0, .1);\r\n        }\r\n\r\n        .search-input {\r\n          &::placeholder,\r\n          &::-webkit-input-placeholder,\r\n          &:-ms-input-placeholder,\r\n          &:-moz-placeholder,\r\n          &::-moz-placeholder {\r\n            color: rgba(255, 255, 255, .5) !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        .input-holder {\r\n          background: rgba(255, 255, 255, .1);\r\n\r\n          .search-input {\r\n            color: rgba(255, 255, 255, .8);\r\n          }\r\n\r\n          .search-icon {\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .header-btn-lg {\r\n      &::before {\r\n        background: rgba(255, 255, 255, .2);\r\n      }\r\n    }\r\n\r\n    .header-btn-lg,\r\n    .header__pane {\r\n      .hamburger-inner,\r\n      .hamburger.is-active .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(255, 255, 255, .8) !important;\r\n      }\r\n    }\r\n\r\n    .search-wrapper .input-holder .search-icon span::after {\r\n      border-color: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .search-wrapper .close::before,\r\n    .search-wrapper .close::after,\r\n    .search-wrapper .input-holder .search-icon span::before {\r\n      background: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo.png');\r\n      }\r\n    }\r\n\r\n    .app-header__mobile-menu {\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background: rgba(255, 255, 255, .9);\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}","// Header Dark\r\n\r\n.app-header {\r\n  &.header-text-dark {\r\n    .app-header-left > .nav > li > .nav-link {\r\n      color: rgba(0,0,0,.7);\r\n\r\n      .nav-link-icon {\r\n        color: rgba(0, 0, 0, .8);\r\n      }\r\n\r\n      &:hover {\r\n        color: rgba(0,0,0,1);\r\n      }\r\n    }\r\n\r\n    .app-header-right {\r\n      .icon-wrapper-alt {\r\n\r\n        svg {\r\n          fill: rgba(0,0,0,.7);\r\n          transition: all .2s;\r\n        }\r\n\r\n        .icon-wrapper-bg {\r\n          background: rgba(0,0,0,.1) !important;\r\n          transition: all .2s;\r\n          opacity: 1;\r\n        }\r\n\r\n        &:hover {\r\n          svg {\r\n            fill: rgba(0,0,0,.95);\r\n          }\r\n\r\n          .icon-wrapper-bg {\r\n            background: rgba(0,0,0,.15) !important;\r\n          }\r\n        }\r\n\r\n        .badge-dot {\r\n          border-color: transparent;\r\n        }\r\n      }\r\n\r\n      .widget-content-left {\r\n\r\n        & > .btn-group > .btn-link,\r\n        .widget-heading,\r\n        .widget-subheading {\r\n          color: rgba(0,0,0,.8);\r\n        }\r\n      }\r\n    }\r\n\r\n    .search-wrapper {\r\n      .input-holder {\r\n        .search-icon {\r\n          background: rgba(0,0,0,.1);\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        .input-holder {\r\n          background: rgba(0,0,0,.1);\r\n\r\n          .search-input {\r\n            color: rgba(0,0,0,.8);\r\n          }\r\n\r\n          .search-icon {\r\n            background: rgba(0,0,0,.1);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .header-btn-lg {\r\n      &::before {\r\n        background: rgba(0,0,0,.2);\r\n      }\r\n    }\r\n\r\n    .header-btn-lg,\r\n    .header__pane {\r\n      .hamburger-inner,\r\n      .hamburger.is-active .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(0, 0, 0, .8) !important;\r\n      }\r\n    }\r\n\r\n    .search-wrapper .input-holder .search-icon span::after {\r\n      border-color: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .search-wrapper .close::before,\r\n    .search-wrapper .close::after,\r\n    .search-wrapper .input-holder .search-icon span::before {\r\n      background: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo-inverse.png');\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n\r\n}","// Sidebar Base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-sidebar {\r\n  width: $app-sidebar-width;\r\n  display: flex;\r\n  z-index: 11;\r\n  overflow: hidden;\r\n  min-width: $app-sidebar-width;\r\n  position: relative;\r\n  flex: 0 0 $app-sidebar-width;\r\n  margin-top: -$app-header-height;\r\n  padding-top: $app-header-height;\r\n  transition: all .2s;\r\n\r\n  .app-sidebar__inner {\r\n    padding: 2px $layout-spacer-x $layout-spacer-x;\r\n    width: 100%;\r\n  }\r\n\r\n  .scrollbar-container {\r\n    z-index: 15;\r\n    width: 100%;\r\n  }\r\n\r\n  .app-sidebar-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    opacity: 0.05;\r\n    background-size: cover;\r\n    z-index: 10;\r\n  }\r\n\r\n  .app-header__logo {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    display: none;\r\n    z-index: 11;\r\n  }\r\n\r\n  &.sidebar-shadow {\r\n    box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\r\n  }\r\n}\r\n\r\n.app-sidebar__heading {\r\n  text-transform: uppercase;\r\n  font-size: $font-size-xs;\r\n  margin: math.div($layout-spacer-x, 2) 0;\r\n  font-weight: bold;\r\n  color: $primary;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar-mobile-overlay {\r\n  display: none;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #333;\r\n  opacity: .6;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: 12;\r\n}\r\n\r\n// Sidebar Components\r\n\r\n@import \"modifiers/navmenu-vertical\";\r\n\r\n// Sidebar Modifiers\r\n\r\n@import \"themes/sidebar-light\";\r\n@import \"themes/sidebar-dark\";\r\n//@import \"themes/sidebar-inverted\";\r\n\r\n\r\n@import \"modifiers/fixed-sidebar\";\r\n@import \"modifiers/closed-sidebar\";\r\n","// Navigation Menu Vertical\r\n\r\n.vertical-nav-menu {\r\n  position: relative;\r\n\r\n  &::after {\r\n    content: \" \";\r\n    pointer-events: none;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .metismenu-container,\r\n  .metismenu-item {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n  }\r\n  \r\n  .metismenu-container {\r\n    list-style: none;\r\n    text-align: left;\r\n\r\n    &:before {\r\n      opacity: 0;\r\n      transition: opacity 300ms;\r\n    }\r\n\r\n    .metismenu-link {\r\n      transition: transform .2s, height 300ms, color 300ms, background-color 300ms;\r\n      display: flex;\r\n      align-items: center;\r\n      line-height: 2.5rem;\r\n      height: 2.5rem;\r\n      padding: 0 $layout-spacer-x 0 45px;\r\n      position: relative;\r\n      @include border-radius($border-radius);\r\n      color: $gray-800;\r\n      white-space: nowrap;\r\n\r\n      &:hover {\r\n        background: $dropdown-link-hover-bg;\r\n        text-decoration: none;\r\n\r\n        i.metismenu-icon {\r\n          opacity: .6;\r\n        }\r\n\r\n        i.metismenu-state-icon {\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        color: $primary;\r\n        background: $dropdown-link-hover-bg;\r\n      }\r\n\r\n      &.has-active-child,\r\n      &.active {\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    i.metismenu-state-icon,\r\n    i.metismenu-icon {\r\n      text-align: center;\r\n      width: 34px;\r\n      height: 34px;\r\n      line-height: 34px;\r\n      position: absolute;\r\n      left: 5px;\r\n      top: 50%;\r\n      margin-top: -17px;\r\n      font-size: 1.5rem;\r\n      opacity: .3;\r\n      transition: color 300ms;\r\n    }\r\n\r\n    i.metismenu-state-icon {\r\n      transition: transform 300ms;\r\n      left: auto;\r\n      right: 5px;\r\n\r\n      &.rotate-minus-90 {\r\n        transform: rotate(-180deg);\r\n      }\r\n    }\r\n\r\n    .metismenu-container {\r\n      transition: padding 300ms;\r\n\r\n      &.visible {\r\n        padding: .5em 0 0 2rem;\r\n\r\n        &:before {\r\n          content: '';\r\n          height: 100%;\r\n          opacity: 1;\r\n          width: 3px;\r\n          background: $dropdown-link-hover-bg;\r\n          position: absolute;\r\n          left: 20px;\r\n          top: 0;\r\n          @include border-radius(15px);\r\n        }\r\n\r\n        & > .metismenu-item > .metismenu-link {\r\n          height: 2.3em;\r\n          line-height: 2.3em;\r\n          color: $gray-600;\r\n          margin: 0 0 3px;\r\n          padding-left: 35px;\r\n\r\n          &:hover {\r\n            color: $primary;\r\n          }\r\n\r\n          .metismenu-icon {\r\n            display: none;\r\n          }\r\n\r\n          &.active {\r\n            color: $primary;\r\n            background: $dropdown-link-hover-bg;\r\n          }\r\n        }\r\n      }\r\n\r\n      .metismenu-item > .metismenu-link {\r\n        height: 0;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .metismenu-link {\r\n        padding-left: 35px;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Sidebar Light\r\n\r\n.app-sidebar {\r\n  &.sidebar-text-light {\r\n    border-right: 0 !important;\r\n\r\n    .app-sidebar__heading {\r\n      color: rgba(255, 255, 255, .6);\r\n\r\n      &::before {\r\n        background: rgba(255, 255, 255, 0.2) !important;\r\n      }\r\n    }\r\n\r\n    .metismenu {\r\n      .metismenu-container {\r\n        .metismenu-link {\r\n          color: rgba(255, 255, 255, .7);\r\n\r\n          &:hover {\r\n            color: rgba(255, 255, 255, 1);\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n\r\n          &.active {\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n        }\r\n\r\n        &.metismenu-container {\r\n          &.visible {\r\n            .metismenu-item > .metismenu-link {\r\n              color: rgba(255, 255, 255, .6);\r\n\r\n              &.active {\r\n                background: rgba(255, 255, 255, .1);\r\n                color: rgba(255, 255, 255, .8);\r\n              }\r\n\r\n              &:hover {\r\n                color: rgba(255, 255, 255, 1);\r\n              }\r\n\r\n            }\r\n\r\n            &::before {\r\n              background: rgba(255, 255, 255, .3);\r\n            }\r\n          }\r\n        }\r\n\r\n        i.metismenu-state-icon,\r\n        i.metismenu-icon {\r\n          opacity: .5;\r\n        }\r\n      }\r\n    }\r\n\r\n    .ps__thumb-y {\r\n      background: rgba(255, 255, 255, .3);\r\n    }\r\n\r\n    .ps__rail-y:hover {\r\n      .ps__thumb-y {\r\n        background: rgba(255, 255, 255, .2);\r\n      }\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo.png');\r\n      }\r\n\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(255, 255, 255, .8);\r\n      }\r\n    }\r\n  }\r\n}","// Sidebar Light\r\n\r\n.app-sidebar {\r\n  &.sidebar-text-dark {\r\n    border-right: 0 !important;\r\n\r\n    .app-sidebar__heading {\r\n      color: rgba(0, 0, 0, .6);\r\n\r\n      &::before {\r\n        background: rgba(0, 0, 0, 0.5) !important;\r\n      }\r\n    }\r\n\r\n    .metismenu {\r\n      .metismenu-container {\r\n        .metismenu-link {\r\n          color: rgba(0, 0, 0, .7);\r\n\r\n          &:hover {\r\n            color: rgba(0, 0, 0, 1);\r\n            background: rgba(0, 0, 0, .1);\r\n          }\r\n\r\n          &.active {\r\n            background: rgba(0, 0, 0, .1);\r\n          }\r\n        }\r\n\r\n        &.metismenu-container {\r\n          &.visible {\r\n            .metismenu-item > .metismenu-link {\r\n              color: rgba(0, 0, 0, .6);\r\n\r\n              &.active {\r\n                background: rgba(0, 0, 0, .1);\r\n              }\r\n            }\r\n\r\n            &::before {\r\n              background: rgba(0, 0, 0, .3);\r\n            }\r\n          }\r\n\r\n          i.metismenu-state-icon,\r\n          i.metismenu-icon {\r\n            opacity: .5;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .ps__thumb-y {\r\n      background: rgba(0, 0, 0, .3);\r\n    }\r\n\r\n    .ps__rail-y:hover {\r\n      .ps__thumb-y {\r\n        background: rgba(0, 0, 0, .2);\r\n      }\r\n    }\r\n\r\n    .app-header__logo {\r\n\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(0, 0, 0, .8);\r\n      }\r\n    }\r\n  }\r\n}","// Fixed Sidebar\r\n\r\n.fixed-sidebar {\r\n  .app-sidebar {\r\n    position: fixed;\r\n    height: 100vh;\r\n  }\r\n\r\n  .app-main {\r\n\r\n    .app-main__outer {\r\n      z-index: 9;\r\n      padding-left: $app-sidebar-width;\r\n    }\r\n\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.fixed-header) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: flex;\r\n      }\r\n    }\r\n\r\n    .app-header {\r\n\r\n      margin-left: $app-sidebar-width;\r\n\r\n      .app-header__logo {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .app-main {\r\n      //z-index: 12;\r\n    }\r\n  }\r\n\r\n  &.closed-sidebar {\r\n    &:not(.fixed-header) {\r\n\r\n      .app-header {\r\n        margin-left: $app-sidebar-width-collapsed;\r\n      }\r\n\r\n      .app-sidebar {\r\n\r\n        .app-header__logo {\r\n          width: $app-sidebar-width-collapsed;\r\n          padding: 0;\r\n\r\n          .logo-src {\r\n            display: none;\r\n          }\r\n\r\n          .header__pane {\r\n            margin-right: auto;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","// Closed Sidebar\r\n\r\n// Sidebar Menu Hover\r\n\r\n.closed-sidebar {\r\n  .app-sidebar {\r\n    transition: all .3s ease;\r\n    width: $app-sidebar-width-collapsed;\r\n    min-width: $app-sidebar-width-collapsed;\r\n    flex: 0 0 $app-sidebar-width-collapsed;\r\n    z-index: 13;\r\n\r\n    .app-sidebar__inner {\r\n      padding: 2px $layout-spacer-x;\r\n\r\n      .app-sidebar__heading {\r\n        text-indent: -999em;\r\n        display: flex;\r\n        justify-content: center;\r\n        padding: 0;\r\n        margin: math.div($layout-spacer-x, 2) 0;\r\n\r\n        &::before {\r\n          content: '';\r\n          position: absolute;\r\n          top: 50%;\r\n          left: 5px;\r\n          width: calc(100% - 10px);\r\n          height: 1px;\r\n          background: $dropdown-link-hover-bg;\r\n          text-indent: 1px;\r\n        }\r\n      }\r\n\r\n      .metismenu-link {\r\n        text-indent: -99rem;\r\n        padding: 0;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        margin: 0 auto;\r\n        width: 100%;\r\n        position: relative;\r\n      }\r\n\r\n      .metismenu-icon {\r\n        text-indent: 0;\r\n        position: static;\r\n        transform: none;\r\n        margin: 0;\r\n      }\r\n\r\n      .metismenu-state-icon {\r\n        visibility: hidden;\r\n      }\r\n\r\n      .metismenu-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 0;\r\n        \r\n        &.visible {\r\n          padding: 0;\r\n\r\n          & > .metismenu-item > .metismenu-link {\r\n            height: 0;\r\n          }\r\n        }\r\n\r\n        .metismenu-item {\r\n          width: 100%;\r\n          display: flex;\r\n          justify-content: center;\r\n        }\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      flex: 0 0 $app-sidebar-width !important;\r\n      width: $app-sidebar-width !important;\r\n\r\n      .app-sidebar__inner {\r\n        padding: 2px $layout-spacer-x $layout-spacer-x;\r\n\r\n        .app-sidebar__heading {\r\n          text-indent: initial;\r\n          justify-content: flex-start;\r\n          padding: 0;\r\n          &::before {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        .metismenu-link {\r\n          text-indent: initial;\r\n          padding: 0 $layout-spacer-x 0 45px;\r\n          justify-content: flex-start;\r\n          margin: 0;\r\n          width: 100%;\r\n        }\r\n\r\n        .metismenu-icon {\r\n          position: absolute;\r\n          left: 5px;\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n          margin-left: 0;\r\n        }\r\n\r\n        .metismenu-state-icon {\r\n          visibility: visible;\r\n        }\r\n\r\n        .metismenu-container {\r\n          display: block;\r\n          padding: 0;\r\n          \r\n          &.visible {\r\n            padding: .5em 0 0 2rem;\r\n\r\n            & > .metismenu-item > .metismenu-link {\r\n              height: 2.3em;\r\n              padding-left: 35px;\r\n            }\r\n          }\r\n\r\n          .metismenu-container {\r\n            .metismenu-link {\r\n              padding-left: 35px;\r\n            }\r\n          }\r\n\r\n          .metismenu-item {\r\n            width: 100%;\r\n            display: block;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.sidebar-mobile-open) {\r\n\r\n    .app-sidebar {\r\n      .scrollbar-container {\r\n        position: static;\r\n        height: auto;\r\n        overflow: initial !important;\r\n      }\r\n\r\n      &:hover {\r\n        .scrollbar-container {\r\n          position: absolute;\r\n          height: 100%;\r\n          overflow: hidden !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.closed-sidebar-mobile) {\r\n    .app-header {\r\n      .app-header__logo {\r\n        width: $app-sidebar-width-collapsed;\r\n\r\n        .logo-src {\r\n          display: none;\r\n        }\r\n\r\n        .header__pane {\r\n          margin-right: auto;\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  &.fixed-sidebar {\r\n    .app-main__outer {\r\n      padding-left: $app-sidebar-width-collapsed;\r\n    }\r\n  }\r\n\r\n  &.fixed-header:not(.fixed-sidebar) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        visibility: hidden;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.closed-sidebar-mobile {\r\n    .app-sidebar,\r\n    .app-header {\r\n      .app-header__logo {\r\n        width: auto;\r\n        display: flex;\r\n\r\n        .header__pane {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: flex;\r\n        width: $app-sidebar-width-collapsed;\r\n        padding: 0 $layout-spacer-x !important;\r\n\r\n        .logo-src {\r\n          display: block !important;\r\n          margin: 0 auto;\r\n          width: $logo-width - 76;\r\n        }\r\n\r\n        .header__pane {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        .app-header__logo {\r\n          width: $app-sidebar-width;\r\n\r\n          .logo-src {\r\n            width: $logo-width;\r\n            margin: 0;\r\n\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .app-header {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n\r\n  &.fixed-footer {\r\n    .app-footer__inner {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n}","// Main Base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-main {\r\n  z-index: 8;\r\n  position: relative;\r\n  display: flex;\r\n\r\n  .app-main__outer {\r\n    flex: 1;\r\n    flex-direction: column;\r\n    display: flex;\r\n    z-index: 12;\r\n    width: 1px;\r\n  }\r\n\r\n  .app-main__inner {\r\n    padding: $grid-gutter-width $grid-gutter-width 0;\r\n    flex: 1;\r\n\r\n    & > .RRT__container {\r\n      & > .RRT__panel {\r\n        margin-top: $grid-gutter-width;\r\n      }\r\n\r\n      & > .body-tabs-layout {\r\n        .RRT__tab {\r\n          margin-top: (-(math.div($layout-spacer-x, 3)));\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Alternate Section Tabs\r\n\r\n.body-tabs-shadow-btn {\r\n\r\n  .app-main__inner {\r\n    & > .RRT__container {\r\n      & > .RRT__panel {\r\n        margin-top: math.div($grid-gutter-width, 1.5);\r\n      }\r\n\r\n      .body-tabs-layout {\r\n        border: 0;\r\n        background: transparent;\r\n        position: relative;\r\n        z-index: 7;\r\n\r\n        .RRT__showmore {\r\n          margin-top: -13px;\r\n        }\r\n\r\n        .RRT__tab {\r\n          margin-top: $nav-link-padding-y;\r\n        }\r\n\r\n        .RRT__tab--selected {\r\n          color: $white;\r\n        }\r\n\r\n        & + .RRT__inkbar-wrapper {\r\n          position: absolute;\r\n          top: ($nav-link-padding-y * 2.2);\r\n          z-index: 5;\r\n\r\n          .RRT__inkbar {\r\n            height: 35px;\r\n            margin-top: 0;\r\n            @include border-radius($border-radius);\r\n            box-shadow:\r\n                    0 16px 26px -10px rgba($primary, 0.56),\r\n                    0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n                    0 8px 10px -5px rgba($primary, 0.2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n}\r\n\r\n// Themes\r\n\r\n@import \"themes/main-white\";\r\n@import \"themes/main-gray\";\r\n//@import \"themes/main-inverted-blue\";\r\n//@import \"themes/main-inverted-black\";\r\n","// Theme White\r\n\r\n// Variables\r\n\r\n$app-container-bg: #f1f4f6;\r\n$app-sidebar-bg: #ffffff;\r\n$app-header-bg: #fafbfc;\r\n$app-header-logo-bg: rgba(255, 255, 255, .9);\r\n\r\n// Content\r\n\r\n.app-theme-white {\r\n\r\n  &.app-container {\r\n    background: $app-container-bg;\r\n  }\r\n\r\n  .app-sidebar {\r\n    background: $app-sidebar-bg;\r\n  }\r\n\r\n  .app-page-title {\r\n    background: rgba(255, 255, 255, .55);\r\n  }\r\n\r\n  .app-footer .app-footer__inner,\r\n  .app-header {\r\n    background: $app-header-bg;\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-header__logo {\r\n      background: rgba($app-header-bg, .1);\r\n    }\r\n  }\r\n\r\n}","// Theme Gray\r\n\r\n// Variables\r\n\r\n$app-container-bg: #ffffff;\r\n$app-sidebar-bg: #ffffff;\r\n$app-header-bg: #f8f9fa;\r\n$app-header-logo-bg: rgba(0, 0, 0, .03);\r\n\r\n// Content\r\n\r\n.app-theme-gray {\r\n\r\n  &.app-container {\r\n    background: $app-container-bg;\r\n  }\r\n\r\n  .app-sidebar {\r\n    background: $app-sidebar-bg;\r\n    border-right: $gray-300 solid 1px;\r\n  }\r\n\r\n  .app-page-title {\r\n    background: rgba(0, 0, 0, .03);\r\n  }\r\n\r\n  .app-footer,\r\n  .app-header {\r\n    background: $app-header-bg;\r\n  }\r\n\r\n  .app-footer {\r\n    border-top: $gray-300 solid 1px;\r\n  }\r\n\r\n  .app-header {\r\n    .app-header__logo {\r\n      border-right: rgba(0, 0, 0, .1) solid 1px;\r\n    }\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-header__logo {\r\n      background: $app-header-logo-bg;\r\n    }\r\n  }\r\n\r\n  .card {\r\n    border-width: 1px;\r\n  }\r\n\r\n  .main-card {\r\n    box-shadow: 0 0 0 0 transparent !important;\r\n\r\n    & > .card-body {\r\n\r\n      & > .card-title {\r\n        text-transform: none;\r\n        font-size: $font-size-lg;\r\n        font-weight: normal;\r\n        border-bottom: $gray-300 solid 1px;\r\n        position: relative;\r\n        padding: 0 0 ($card-spacer-y * 1.5);\r\n        margin: 0 0 ($card-spacer-y * 1.5);\r\n\r\n        &::before {\r\n          position: absolute;\r\n          width: 40px;\r\n          background: $primary;\r\n          @include border-radius(30px);\r\n          height: 5px;\r\n          left: 0;\r\n          bottom: -2px;\r\n          content: \"\";\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__sidebar {\r\n    border-left: 0 !important;\r\n  }\r\n\r\n}\r\n","// Footer base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-footer {\r\n  height: $app-header-height;\r\n\r\n  .app-footer__inner {\r\n    padding: 0 $layout-spacer-x 0 math.div($layout-spacer-x, 2);\r\n    height: $app-header-height;\r\n    transition: all .2s;\r\n\r\n    display: flex;\r\n    align-content: center;\r\n    align-items: center;\r\n\r\n    .app-footer-left {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .app-footer-right {\r\n      margin-left: auto;\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n\r\n// Footer Dots Section\r\n\r\n.footer-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n\r\n  .dots-separator {\r\n    height: 40px;\r\n    margin: 0 math.div($layout-spacer-x, 2.5);\r\n    width: 1px;\r\n    background: $gray-200;\r\n  }\r\n}\r\n\r\n.dot-btn-wrapper {\r\n  padding: .5rem;\r\n  position: relative;\r\n  display: flex;\r\n  opacity: .7;\r\n  transition: opacity .2s;\r\n\r\n  .badge-abs {\r\n    right: 50%;\r\n\r\n    &.badge-dot-sm {\r\n      top: -2px;\r\n      margin-right: -3px;\r\n    }\r\n  }\r\n\r\n  .dot-btn-icon {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  &:hover {\r\n    text-decoration: none;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Footer Modifiers\r\n\r\n@import \"fixed-footer\";\r\n","// Fixed Header\r\n\r\n.fixed-footer {\r\n  .app-footer {\r\n    position: fixed;\r\n    width: 100%;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 7;\r\n\r\n    .app-footer__inner {\r\n      margin-left: $app-sidebar-width;\r\n      box-shadow: 0 -2px 15px rgba(shade-color($primary, 50%), .05);\r\n    }\r\n  }\r\n\r\n  .app-main .app-main__outer {\r\n    padding-bottom: $app-header-height;\r\n  }\r\n\r\n  &.closed-sidebar {\r\n    .app-footer {\r\n      .app-footer__inner {\r\n        margin-left: $app-sidebar-width-collapsed !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Page title\r\n\r\n@use \"sass:math\";\r\n\r\n.app-page-title {\r\n  padding: $grid-gutter-width;\r\n  margin: (-$grid-gutter-width) (-$grid-gutter-width) ($grid-gutter-width);\r\n  position: relative;\r\n\r\n  .page-title-wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .page-title-heading,\r\n  .page-title-subheading {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .page-title-heading {\r\n    font-size: $h5-font-size;\r\n    font-weight: 400;\r\n    display: flex;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .page-title-subheading {\r\n    padding: 3px 0 0;\r\n    font-size: $font-size-base;\r\n    opacity: .6;\r\n\r\n    .breadcrumb {\r\n      padding: 0;\r\n      margin: 3px 0 0;\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  .page-title-actions {\r\n    margin-left: auto;\r\n\r\n    .breadcrumb {\r\n      margin: 0;\r\n      padding: 0;\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  .page-title-icon {\r\n    font-size: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    text-align: center;\r\n    padding: math.div($layout-spacer-x, 1.8);\r\n    margin: 0 ($grid-gutter-width) 0 0;\r\n    background: $white;\r\n    box-shadow: $box-shadow-default;\r\n    @include border-radius($border-radius);\r\n    width: 60px;\r\n    height: 60px;\r\n\r\n    i {\r\n      margin: auto;\r\n    }\r\n\r\n    &.rounded-circle {\r\n      margin: 0 math.div($grid-gutter-width, 1.5) 0 0;\r\n    }\r\n  }\r\n\r\n  & + .RRT__container {\r\n    margin-top: -(math.div($grid-gutter-width, 1.3));\r\n  }\r\n\r\n  & + .rc-tabs {\r\n    // to fix width issue in firefox\r\n    max-width: calc(100vw - 322px);\r\n    margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2))) (($grid-gutter-width * 1.3));\r\n  }\r\n  @media only screen and (max-width: 812px) and (min-width: 360px)  {\r\n    & + .rc-tabs {\r\n      // to fix width issue in firefox\r\n      max-width: calc(100vw - 0px);\r\n      margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2))) (($grid-gutter-width * 1.3));\r\n    }\r\n  }\r\n\r\n  &.app-page-title-simple {\r\n    margin: 0;\r\n    background: none !important;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    padding-top: 0;\r\n  }\r\n}\r\n\r\n.page-title-icon-rounded {\r\n  .page-title-icon {\r\n    @include border-radius(50px);\r\n  }\r\n}\r\n\r\n.closed-sidebar .rc-tabs {\r\n  max-width: calc(100vw - 110px);\r\n}\r\n@media only screen and (max-width: 812px) and (min-width: 360px) {\r\n  .closed-sidebar .rc-tabs {\r\n    max-width: calc(100vw - 0px);\r\n  }\r\n}\r\n\r\n// Body Tabs\r\n\r\n.body-tabs {\r\n  &.body-tabs-layout {\r\n    margin-left: -($grid-gutter-width);\r\n    margin-right: -($grid-gutter-width);\r\n    padding: 0 $grid-gutter-width;\r\n    border-top: 0;\r\n    border-bottom: $gray-300 solid 1px;\r\n  }\r\n}\r\n","// Search Box\r\n\r\n@use \"sass:math\";\r\n\r\n$search-box-size:     42px;\r\n\r\n.search-wrapper {\r\n  position: relative;\r\n  margin-right: math.div($nav-link-padding-x, 1.5);\r\n\r\n  .input-holder {\r\n    height: $search-box-size;\r\n    width: $search-box-size;\r\n    overflow: hidden;\r\n    position: relative;\r\n    transition: all 0.3s ease-in-out;\r\n\r\n    .search-input {\r\n      width: 100%;\r\n      padding: 0 70px 0 20px;\r\n      opacity: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      background: transparent;\r\n      box-sizing: border-box;\r\n      border: none;\r\n      outline: none;\r\n      transform: translate(0, 60px);\r\n      transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n      transition-delay: 0.3s;\r\n      font-size: $font-size-base;\r\n    }\r\n\r\n    .search-icon {\r\n      width: $search-box-size;\r\n      height: $search-box-size;\r\n      border: none;\r\n      padding: 0;\r\n      outline: none;\r\n      position: relative;\r\n      z-index: 2;\r\n      float: right;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease-in-out;\r\n      background: rgba(0,0,0,.06);\r\n      @include border-radius(30px);\r\n\r\n      span {\r\n        width: 22px;\r\n        height: 22px;\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        position: relative;\r\n        transform: rotate(45deg);\r\n        transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\r\n\r\n        &::before,\r\n        &::after {\r\n          position: absolute;\r\n          content: '';\r\n        }\r\n\r\n        &::before {\r\n          width: 4px;\r\n          height: 11px;\r\n          left: 9px;\r\n          top: 13px;\r\n          border-radius: 2px;\r\n          background: $primary;\r\n        }\r\n\r\n        &::after {\r\n          width: 14px;\r\n          height: 14px;\r\n          left: 4px;\r\n          top: 0;\r\n          border-radius: 16px;\r\n          border: 2px solid $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .btn-close {\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 50%;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-top: -10px;\r\n    cursor: pointer;\r\n    padding: 0px;\r\n    opacity: 0 !important;\r\n    // transform: rotate(-180deg);\r\n    transition: all .2s cubic-bezier(0.285, -0.450, 0.935, 0.110);\r\n    transition-delay: 0.1s;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      background: $primary;\r\n      border-radius: 2px;\r\n    }\r\n\r\n    &::before {\r\n      width: 2px;\r\n      height: 20px;\r\n      left: 9px;\r\n      top: 0;\r\n    }\r\n\r\n    &::after {\r\n      width: 20px;\r\n      height: 2px;\r\n      left: 0;\r\n      top: 9px;\r\n    }\r\n  }\r\n\r\n  &.active {\r\n    width: 330px;\r\n\r\n    .input-holder {\r\n      width: 290px;\r\n      border-radius: 50px;\r\n      background: rgba(0, 0, 0, 0.05);\r\n      transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n\r\n      .search-input {\r\n        opacity: 1;\r\n        transform: translate(0, 11px);\r\n      }\r\n\r\n      .search-icon {\r\n        width: $search-box-size;\r\n        height: $search-box-size;\r\n        margin: 0;\r\n        border-radius: 30px;\r\n\r\n        span {\r\n          transform: rotate(-45deg);\r\n        }\r\n      }\r\n    }\r\n\r\n    .btn-close {\r\n      left: 300px;\r\n      opacity: .6 !important;\r\n      // transform: rotate(45deg);\r\n      transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n      transition-delay: 0.5s;\r\n\r\n      &:hover {\r\n        opacity: 1 !important;\r\n      }\r\n    }\r\n\r\n    & + .header-megamenu {\r\n      opacity: 0;\r\n    }\r\n\r\n  }\r\n}","\r\n// Opacity\r\n\r\n.opacity-01 {\r\n  opacity: .01 !important;\r\n}\r\n\r\n.opacity-02 {\r\n  opacity: .02 !important;\r\n}\r\n\r\n.opacity-03 {\r\n  opacity: .03 !important;\r\n}\r\n\r\n.opacity-04 {\r\n  opacity: .04 !important;\r\n}\r\n\r\n.opacity-05 {\r\n  opacity: .05 !important;\r\n}\r\n\r\n.opacity-06 {\r\n  opacity: .06 !important;\r\n}\r\n\r\n.opacity-07 {\r\n  opacity: .07 !important;\r\n}\r\n\r\n.opacity-08 {\r\n  opacity: .08 !important;\r\n}\r\n\r\n.opacity-09 {\r\n  opacity: .09 !important;\r\n}\r\n\r\n.opacity-1 {\r\n  opacity: .1 !important;\r\n}\r\n\r\n.opacity-15 {\r\n  opacity: .15 !important;\r\n}\r\n\r\n.opacity-2 {\r\n  opacity: .2 !important;\r\n}\r\n\r\n.opacity-3 {\r\n  opacity: .3 !important;\r\n}\r\n\r\n.opacity-4 {\r\n  opacity: .4 !important;\r\n}\r\n\r\n.opacity-5 {\r\n  opacity: .5 !important;\r\n}\r\n\r\n.opacity-6 {\r\n  opacity: .6 !important;\r\n}\r\n\r\n.opacity-7 {\r\n  opacity: .7 !important;\r\n}\r\n\r\n.opacity-8 {\r\n  opacity: .8 !important;\r\n}\r\n\r\n.opacity-9 {\r\n  opacity: .9 !important;\r\n}\r\n\r\n.opacity-10 {\r\n  opacity: 1 !important;\r\n}","// Grayscale Filter\r\n\r\n.filter-grayscale-5 {\r\n  filter: grayscale(5%) !important;\r\n}\r\n\r\n.filter-grayscale-10 {\r\n  filter: grayscale(10%) !important;\r\n}\r\n\r\n.filter-grayscale-20 {\r\n  filter: grayscale(20%) !important;\r\n}\r\n\r\n.filter-grayscale-30 {\r\n  filter: grayscale(30%) !important;\r\n}\r\n\r\n.filter-grayscale-40 {\r\n  filter: grayscale(40%) !important;\r\n}\r\n\r\n.filter-grayscale-50 {\r\n  filter: grayscale(50%) !important;\r\n}\r\n\r\n.filter-grayscale-80 {\r\n  filter: grayscale(80%) !important;\r\n}\r\n\r\n.filter-grayscale-100 {\r\n  filter: grayscale(100%) !important;\r\n}","// Helpers imports\r\n@import \"helpers/opacity\";\r\n@import \"helpers/grayscale\";\r\n\r\n// Resets\r\n\r\n.br-tl {\r\n  border-top-left-radius: $border-radius !important;\r\n}\r\n\r\n.br-tr {\r\n  border-top-right-radius: $border-radius !important;\r\n}\r\n\r\n.br-bl {\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.br-br {\r\n  border-bottom-right-radius: $border-radius !important;\r\n}\r\n\r\n.b-radius-0 {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.rm-border {\r\n  border-width: 0 !important;\r\n}\r\n\r\n.br-a {\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n// Center Elements\r\n\r\n.margin-h-center {\r\n  margin-left: auto !important;\r\n  margin-right: auto !important;\r\n}\r\n\r\n.center-svg {\r\n  margin: 0 auto;\r\n\r\n  svg {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.apexcharts-canvas {\r\n  margin: 0 auto;\r\n}\r\n\r\n.apexcharts-donut {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.alert-dismissible {\r\n  .close {\r\n    top: 0;\r\n    right: 5px;\r\n    padding: 5px;\r\n  }\r\n}\r\n\r\n// Gradient Icons\r\n\r\n.icon-gradient {\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  text-fill-color: transparent;\r\n}\r\n\r\n// Font sizes\r\n\r\n.font-size-xlg {\r\n  font-size: 1.3rem !important;\r\n}\r\n\r\n.font-size-md {\r\n  font-size: .9rem !important;\r\n}\r\n\r\n.font-size-lg {\r\n  font-size: 1.1rem !important;\r\n}\r\n\r\n// No Shadow\r\n\r\n.no-shadow {\r\n  box-shadow: 0 0 0 transparent !important;\r\n}\r\n\r\n// Layout\r\n\r\n.h-100 {\r\n  height: 100vh !important;\r\n}\r\n\r\n.he-auto {\r\n  height: auto !important;\r\n}\r\n\r\n.he-100 {\r\n  height: 100%;\r\n}\r\n\r\n.h-sm {\r\n  height: 150px;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n// Font size\r\n\r\n.fsize-1 {\r\n  font-size: .95rem !important;\r\n}\r\n\r\n.fsize-2 {\r\n  font-size: 1.3rem !important;\r\n}\r\n\r\n.fsize-3 {\r\n  font-size: 1.6rem !important;\r\n}\r\n\r\n.fsize-4 {\r\n  font-size: 2rem !important;\r\n}\r\n\r\n.z-index-6 {\r\n  z-index: 6;\r\n}\r\n\r\n.line-height-1 {\r\n  line-height: 1;\r\n}\r\n\r\n// Center element\r\n\r\n.center-elem {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.flex2 {\r\n  flex: 2;\r\n}\r\n\r\n// Divider\r\n\r\n.divider {\r\n  margin-top: $spacer;\r\n  margin-bottom: $spacer;\r\n  height: 1px;\r\n  overflow: hidden;\r\n  background: $gray-200;\r\n}\r\n\r\n.list-group-item:hover {\r\n  z-index: initial;\r\n}\r\n\r\n// No Results\r\n\r\n.no-results {\r\n  padding: ($spacer * 1.5);\r\n  text-align: center;\r\n\r\n  .results-title {\r\n    color: $gray-700;\r\n    font-size: $h5-font-size;\r\n  }\r\n\r\n  .results-subtitle {\r\n    color: $gray-500;\r\n    font-size: $font-size-lg;\r\n  }\r\n}\r\n\r\n// Background Color Animation\r\n\r\n.bg-animation {\r\n  animation: bg-pan-left 8s both;\r\n}\r\n\r\n@-webkit-keyframes bg-pan-left {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n@keyframes bg-pan-left {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n// Width 100%\r\n\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n.mb--2 {\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n// Margins\r\n\r\n.mbg-3 {\r\n  margin-bottom: $grid-gutter-width;\r\n}\r\n\r\n// Loader\r\n\r\n.loader-container {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 100vh;\r\n  justify-content: center;\r\n  width: 100vw;\r\n  text-align: center;\r\n  line-height: 1.6rem;\r\n\r\n  .loader-container-inner {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    padding: 0 $layout-spacer-x;\r\n  }\r\n\r\n  small {\r\n    margin: 10px 0 0;\r\n    display: block;\r\n    color: $gray-600;\r\n    font-weight: normal;\r\n  }\r\n\r\n  h3 {\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.btn-info, .btn-success {\r\n  color:#fff !important;\r\n}\r\n\r\n.bg-warning {\r\n  color: #212529;\r\n}\r\n\r\n.list-group-item {\r\n  border: 1px solid rgba(0,0,0,0.125);\r\n}\r\n\r\n.btn-link, a {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.bg-light {\r\n  color: #212529;\r\n  // background: #fff;\r\n}\r\n\r\n.table {\r\n  --bs-table-accent-bg: none;\r\n}\r\n\r\n.form-check-input-custom {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}","// Gradients\r\n\r\n.bg-warm-flame {\r\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\r\n}\r\n\r\n.bg-night-fade {\r\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\r\n}\r\n\r\n.bg-sunny-morning {\r\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\r\n}\r\n\r\n.bg-tempting-azure {\r\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\r\n}\r\n\r\n.bg-amy-crisp {\r\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\r\n}\r\n\r\n.bg-heavy-rain {\r\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\r\n}\r\n\r\n.bg-mean-fruit {\r\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\r\n}\r\n\r\n.bg-malibu-beach {\r\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\r\n}\r\n\r\n.bg-deep-blue {\r\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\r\n}\r\n\r\n.bg-ripe-malin {\r\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\r\n}\r\n\r\n.bg-arielle-smile {\r\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\r\n}\r\n\r\n.bg-plum-plate {\r\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n}\r\n\r\n.bg-happy-fisher {\r\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\r\n}\r\n\r\n.bg-happy-itmeo {\r\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\r\n}\r\n\r\n.bg-mixed-hopes {\r\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\r\n}\r\n\r\n.bg-strong-bliss {\r\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\r\n}\r\n\r\n.bg-grow-early {\r\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\r\n}\r\n\r\n.bg-love-kiss {\r\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\r\n}\r\n\r\n.bg-premium-dark {\r\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\r\n}\r\n\r\n.bg-happy-green {\r\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\r\n}\r\n\r\n.bg-vicious-stance {\r\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\r\n}\r\n\r\n.bg-midnight-bloom {\r\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\r\n}\r\n\r\n.bg-night-sky {\r\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\r\n}\r\n\r\n.bg-slick-carbon {\r\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%) !important;\r\n  background-blend-mode: multiply;\r\n}\r\n\r\n.bg-royal {\r\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\r\n}\r\n\r\n.bg-asteroid {\r\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background: transparent !important;\r\n}","/* NOTE: animate-sass/ is loaded from node_modules/ using sass-loader */\r\n\r\n@import \"animate-sass/helpers/mixins\";\r\n@import \"animate-sass/helpers/settings\";\r\n@import \"animate-sass/helpers/base\";\r\n\r\n$base-duration              : .2s;\r\n\r\n\r\n$use-all                    :   false; // all animations status\r\n$use-fade               :   $use-all; // all fades\r\n$use-bounce             :   $use-all; // all bounces\r\n$use-rotate             :   $use-all; // all rotates\r\n$use-slide              :   $use-all; // all slide animations\r\n$use-flipers            :   $use-all; // all flip animations\r\n$use-light-speed        :   $use-all; // all light speed animations\r\n$use-attention-seekers  :   $use-all; // all attention seeker animations\r\n$use-special            :   $use-all; // all special animations\r\n$use-zoom               :   $use-all; // all zoom animations\r\n\r\n// Fade Enter\r\n$use-fade-in            :   $use-fade;\r\n$use-fadeIn \t\t\t:\t$use-fade-in;\r\n$use-fadeInUp \t\t\t:\t$use-fade-in;\r\n$use-fadeInUpBig \t\t:\t$use-fade-in;\r\n$use-fadeInDown \t\t:\t$use-fade-in;\r\n$use-fadeInDownBig \t\t:\t$use-fade-in;\r\n$use-fadeInLeft \t\t:\t$use-fade-in;\r\n$use-fadeInLeftBig \t\t:\t$use-fade-in;\r\n$use-fadeInRight \t\t:\t$use-fade-in;\r\n$use-fadeInRightBig \t:\t$use-fade-in;\r\n\r\n// Fade Exit\r\n$use-fade-out           :   $use-fade;\r\n$use-fadeOut\t\t\t:   $use-fade-out;\r\n$use-fadeOutUp\t\t\t:\t$use-fade-out;\r\n$use-fadeOutUpBig   \t:\t$use-fade-out;\r\n$use-fadeOutDown\t\t:\t$use-fade-out;\r\n$use-fadeOutDownBig \t:\t$use-fade-out;\r\n$use-fadeOutLeft\t\t:\t$use-fade-out;\r\n$use-fadeOutLeftBig \t:\t$use-fade-out;\r\n$use-fadeOutRight\t\t:\t$use-fade-out;\r\n$use-fadeOutRightBig\t:\t$use-fade-out;\r\n\r\n// Bounce Enter\r\n$use-bounce-in          :   $use-bounce;\r\n$use-bounceIn\t\t\t:\t$use-bounce-in;\r\n$use-bounceInUp\t\t\t: \t$use-bounce-in;\r\n$use-bounceInDown \t\t: \t$use-bounce-in;\r\n$use-bounceInLeft \t\t: \t$use-bounce-in;\r\n$use-bounceInRight \t\t: \t$use-bounce-in;\r\n\r\n// Bounce Exit\r\n$use-bounce-out         :   $use-bounce;\r\n$use-bounceOut\t\t\t:\t$use-bounce-out;\r\n$use-bounceOutUp\t\t: \t$use-bounce-out;\r\n$use-bounceOutDown \t\t: \t$use-bounce-out;\r\n$use-bounceOutLeft \t\t: \t$use-bounce-out;\r\n$use-bounceOutRight \t: \t$use-bounce-out;\r\n\r\n// Rotate Enter\r\n$use-rotate-in          :   $use-rotate;\r\n$use-rotateIn \t\t\t:\t$use-rotate-in;\r\n$use-rotateInUpLeft \t: \t$use-rotate-in;\r\n$use-rotateInUpRight \t: \t$use-rotate-in;\r\n$use-rotateInDownLeft \t: \t$use-rotate-in;\r\n$use-rotateInDownRight \t: \t$use-rotate-in;\r\n\r\n// Rotate Exit\r\n$use-rotate-out         :   $use-rotate;\r\n$use-rotateOut \t\t\t:\t$use-rotate-out;\r\n$use-rotateOutUpLeft \t: \t$use-rotate-out;\r\n$use-rotateOutUpRight \t: \t$use-rotate-out;\r\n$use-rotateOutDownLeft \t: \t$use-rotate-out;\r\n$use-rotateOutDownRight : \t$use-rotate-out;\r\n\r\n// Slide Enter\r\n$use-slide-in           :   $use-slide;\r\n$use-slideIn\t\t\t:   $use-slide-in;\r\n$use-slideInUp\t\t\t:   $use-slide-in;\r\n$use-slideInDown\t\t:   $use-slide-in;\r\n$use-slideInLeft\t\t:   $use-slide-in;\r\n$use-slideInRight\t\t:   $use-slide-in;\r\n\r\n// Slide Exit\r\n$use-slide-out          :   $use-slide;\r\n$use-slideOut\t\t\t:   $use-slide-out;\r\n$use-slideOutUp\t\t\t:   $use-slide-out;\r\n$use-slideOutDown\t\t:   $use-slide-out;\r\n$use-slideOutLeft\t\t:   $use-slide-out;\r\n$use-slideOutRight\t\t:   $use-slide-out;\r\n\r\n// Flippers\r\n$use-flip\t\t\t\t:\t$use-flipers;\r\n$use-flipInX\t\t\t:\t$use-flipers;\r\n$use-flipInY\t\t\t:\t$use-flipers;\r\n$use-flipOutX\t\t\t:\t$use-flipers;\r\n$use-flipOutY\t\t\t:\t$use-flipers;\r\n\r\n// Lightspeed\r\n$use-lightSpeedIn \t\t:\t$use-light-speed;\r\n$use-lightSpeedOut \t\t:\t$use-light-speed;\r\n\r\n// Attention Seekers\r\n$use-bounce\t\t\t\t:\t$use-attention-seekers;\r\n$use-flash\t\t\t\t:\t$use-attention-seekers;\r\n$use-pulse\t\t\t\t:\t$use-attention-seekers;\r\n$use-wiggle\t\t\t\t:\t$use-attention-seekers;\r\n$use-swing\t\t\t\t:\t$use-attention-seekers;\r\n$use-shake\t\t\t\t:\t$use-attention-seekers;\r\n$use-tada\t\t\t\t:\t$use-attention-seekers;\r\n$use-wobble\t\t\t\t:\t$use-attention-seekers;\r\n\r\n// Special\r\n$use-hinge\t\t\t\t:\t$use-special;\r\n$use-rollIn\t\t\t\t: \t$use-special;\r\n$use-rollOut \t\t\t:\t$use-special;\r\n\r\n// Zoom In\r\n$use-zoom-in            :   $use-zoom;\r\n$use-zoomIn \t\t\t:\t$use-zoom-in;\r\n$use-zoomInDown \t\t:\t$use-zoom-in;\r\n$use-zoomInLeft \t\t:\t$use-zoom-in;\r\n$use-zoomInRight \t\t:\t$use-zoom-in;\r\n$use-zoomInUp \t\t\t:\t$use-zoom-in;\r\n\r\n// Zoom Out\r\n$use-zoom-out           :   $use-zoom;\r\n$use-zoomOut\t\t\t:\t$use-zoom-out;\r\n$use-zoomOutDown\t\t:\t$use-zoom-out;\r\n$use-zoomOutLeft\t\t:\t$use-zoom-out;\r\n$use-zoomOutRight\t\t:\t$use-zoom-out;\r\n$use-zoomOutUp\t\t\t:\t$use-zoom-out;\r\n\r\n\r\n$use-fadeIn: true;\r\n$use-fadeOut: true;\r\n$use-fadeInDown: true;\r\n$use-fadeInUp: true;\r\n\r\n$use-lightSpeedIn: true;\r\n$use-lightSpeedOut: true;\r\n\r\n\r\n\r\n// ATTENTION\r\n//@import \"animate-sass/animations/attention-seekers/bounce\";\r\n//@import \"animate-sass/animations/attention-seekers/flash\";\r\n//@import \"animate-sass/animations/attention-seekers/pulse\";\r\n//@import \"animate-sass/animations/attention-seekers/shake\";\r\n//@import \"animate-sass/animations/attention-seekers/swing\";\r\n//@import \"animate-sass/animations/attention-seekers/wiggle\";\r\n//@import \"animate-sass/animations/attention-seekers/wobble\";\r\n//@import \"animate-sass/animations/attention-seekers/tada\";\r\n\r\n// BOUNCE\r\n//@import \"animate-sass/animations/bounce-enter/bounceIn\";\r\n//@import \"animate-sass/animations/bounce-enter/bounceInDown\";\r\n//@import \"animate-sass/animations/bounce-enter/bounceInLeft\";\r\n//@import \"animate-sass/animations/bounce-enter/bounceInRight\";\r\n//@import \"animate-sass/animations/bounce-enter/bounceInUp\";\r\n//@import \"animate-sass/animations/bounce-exit/bounceOut\";\r\n//@import \"animate-sass/animations/bounce-exit/bounceOutDown\";\r\n//@import \"animate-sass/animations/bounce-exit/bounceOutLeft\";\r\n//@import \"animate-sass/animations/bounce-exit/bounceOutRight\";\r\n//@import \"animate-sass/animations/bounce-exit/bounceOutUp\";\r\n\r\n// FADE\r\n@import \"animate-sass/animations/fade-enter/fadeIn\";\r\n@import \"animate-sass/animations/fade-enter/fadeInDown\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInDownBig\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInLeft\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInLeftBig\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInRight\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInRightBig\";\r\n@import \"animate-sass/animations/fade-enter/fadeInUp\";\r\n//@import \"animate-sass/animations/fade-enter/fadeInUpBig\";\r\n@import \"animate-sass/animations/fade-exit/fadeOut\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutDown\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutDownBig\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutLeft\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutLeftBig\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutRight\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutRightBig\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutUp\";\r\n//@import \"animate-sass/animations/fade-exit/fadeOutUpBig\";\r\n\r\n// FLIP\r\n//@import \"animate-sass/animations/flippers/flip\";\r\n//@import \"animate-sass/animations/flippers/flipInX\";\r\n//@import \"animate-sass/animations/flippers/flipInY\";\r\n//@import \"animate-sass/animations/flippers/flipOutX\";\r\n//@import \"animate-sass/animations/flippers/flipOutY\";\r\n\r\n// LIGHTSPEED\r\n@import \"animate-sass/animations/lightspeed/lightSpeedIn\";\r\n@import \"animate-sass/animations/lightspeed/lightSpeedOut\";\r\n\r\n// ROTATE\r\n//@import \"animate-sass/animations/rotate-enter/rotateIn\";\r\n//@import \"animate-sass/animations/rotate-enter/rotateInDownLeft\";\r\n//@import \"animate-sass/animations/rotate-enter/rotateInDownRight\";\r\n//@import \"animate-sass/animations/rotate-enter/rotateInUpLeft\";\r\n//@import \"animate-sass/animations/rotate-enter/rotateInUpRight\";\r\n//@import \"animate-sass/animations/rotate-exit/rotateOut\";\r\n//@import \"animate-sass/animations/rotate-exit/rotateOutDownLeft\";\r\n//@import \"animate-sass/animations/rotate-exit/rotateOutDownRight\";\r\n//@import \"animate-sass/animations/rotate-exit/rotateOutUpLeft\";\r\n//@import \"animate-sass/animations/rotate-exit/rotateOutUpRight\";\r\n\r\n// SLIDE\r\n//@import \"animate-sass/animations/slide-enter/slideInDown\";\r\n//@import \"animate-sass/animations/slide-enter/slideInLeft\";\r\n//@import \"animate-sass/animations/slide-enter/slideInRight\";\r\n//@import \"animate-sass/animations/slide-enter/slideInUp\";\r\n//@import \"animate-sass/animations/slide-exit/slideOutDown\";\r\n//@import \"animate-sass/animations/slide-exit/slideOutLeft\";\r\n//@import \"animate-sass/animations/slide-exit/slideOutRight\";\r\n//@import \"animate-sass/animations/slide-exit/slideOutUp\";\r\n\r\n// SPECIAL\r\n//@import \"animate-sass/animations/special/hinge\";\r\n//@import \"animate-sass/animations/special/rollIn\";\r\n//@import \"animate-sass/animations/special/rollOut\";\r\n\r\n// ZOOM\r\n//@import \"animate-sass/animations/zoom-enter/zoomIn\";\r\n//@import \"animate-sass/animations/zoom-enter/zoomInDown\";\r\n//@import \"animate-sass/animations/zoom-enter/zoomInLeft\";\r\n//@import \"animate-sass/animations/zoom-enter/zoomInRight\";\r\n//@import \"animate-sass/animations/zoom-enter/zoomInUp\";\r\n//@import \"animate-sass/animations/zoom-exit/zoomOut\";\r\n//@import \"animate-sass/animations/zoom-exit/zoomOutDown\";\r\n//@import \"animate-sass/animations/zoom-exit/zoomOutLeft\";\r\n//@import \"animate-sass/animations/zoom-exit/zoomOutRight\";\r\n//@import \"animate-sass/animations/zoom-exit/zoomOutUp\";","@charset \"UTF-8\";\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\n\nbody {\n\t-webkit-backface-visibility: hidden; // Addresses a small issue in webkit: https://css-tricks.com/almanac/properties/b/backface-visibility/\n}\n\n.animated {\n  \t@include animate-prefixer(animation-duration, calc( #{$base-duration} ) );\n  \t@include animate-prefixer(animation-fill-mode, $base-fill-mode);\n\n\t&.infinite {\n\t  animation-iteration-count: $base-iteration-count;\n\t}\n\n\t&.hinge {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 2 ) );\n\t}\n\n\t&.bounceIn,\n\t&.bounceOut {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n\n\t&.flipOutX,\n\t&.flipOutY {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n}","///////////////////////////////////////////////////////////////////\n// Sass Mixins which will be used by the modules                 //\n///////////////////////////////////////////////////////////////////\n\n//===============================================================//\n//          Automatically add vendor prefixes in one hit         //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, 'fadeIn');        //\n//      }                                                        //\n//===============================================================//\n//                                                               //\n//===============================================================//\n@mixin animate-prefixer($property, $value...) {\n    -webkit-#{$property}: unquote('#{$value}');\n    #{$property}: unquote('#{$value}');\n}\n//===============================================================//\n// Generate keyframes animations with vendor prefixes in one hit //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, fadeIn);        //\n//      }                                                        //\n//      @include animate-keyframe(fadeIn) {                      //\n//          0% {opacity: 0;}                                     //\n//          100% {opacity: 1;}                                   //\n//      }                                                        //\n//===============================================================//\n// Courtesy of @integralist: (twitter.com)                       //\n//===============================================================//\n\n@mixin animate-keyframe($animation-name) {\n    @-webkit-keyframes #{$animation-name} {\n        @content;\n    }\n\n    @keyframes #{$animation-name} {\n        @content;\n    }\n}\n","/////////////////////////////////////////////////////////\n// Animation Default Settings                          //\n/////////////////////////////////////////////////////////\n\n\n// Base module settings\n$base-duration\t\t\t\t\t: 1s !default;           // used in 1-base module\n$base-origin \t\t\t\t\t: top center !default;\n$base-degrees \t\t\t\t\t: 30deg !default;        // used in lightspeed & special modules\n$base-fill-mode\t\t\t\t\t: both !default;\n$base-iteration-count\t\t\t: infinite !default;\n\n$base-timing-function-in\t\t: ease-in !default;\n$base-timing-function-out\t\t: ease-out !default;\n$base-timing-function-in-out\t: ease-in-out !default;\n\n$base-distance\t\t\t\t\t: 10px !default; \t\t// used in fade, shake and bounce modules\n$base-distance-big\t\t\t\t: 1000px !default;       // used in fadeBig and bounce modules\n\n\n// Rotate module settings\n$rotate-degrees \t\t\t\t: 90deg !default;\n$rotate-degrees-max \t\t\t: 200deg !default;\n$rotate-origin \t\t\t\t\t: center center !default;\n\n// Flipper module settings\n$flipper-perspective\t\t\t: 400px !default;\n$flipper-translate \t\t\t\t: 150px !default;\n$flipper-degrees \t\t\t\t: 10deg !default;\n$flipper-degrees-max \t\t\t: 90deg !default;\n\n\n// Hinge module settings\n$hinge-origin \t\t\t\t\t: top left !default;\n$hinge-degrees-max \t\t\t\t: 80deg !default;\n$hinge-translate \t\t\t\t: 700px !default;\n\n\n//==================================================================================================//\n// Module loading                                                                                   //\n//==================================================================================================//\n// To include an animation module in the compiled css file, simply set it's attribute below to true //\n// (all modules set to false will not be included)                                                  //\n// The idea here is to only load the animations you want to use on a per project basis              //\n// This helps keep the compiled css file at its leanest                                             //\n//==================================================================================================//\n// Hugely influenced and inspired by @csswizardry's inuit.css _vars.scss file                       //\n//==================================================================================================//\n\n$use-all                    :   false !default; // all animations status\n$use-fade               :   $use-all !default; // all fades\n$use-bounce             :   $use-all !default; // all bounces\n$use-rotate             :   $use-all !default; // all rotates\n$use-slide              :   $use-all !default; // all slide animations\n$use-flipers            :   $use-all !default; // all flip animations\n$use-light-speed        :   $use-all !default; // all light speed animations\n$use-attention-seekers  :   $use-all !default; // all attention seeker animations\n$use-special            :   $use-all !default; // all special animations\n$use-zoom               :   $use-all !default; // all zoom animations\n// Fade Enter\n$use-fade-in            :   $use-fade !default;\n$use-fadeIn \t\t\t:\t$use-fade-in !default;\n$use-fadeInUp \t\t\t:\t$use-fade-in !default;\n$use-fadeInUpBig \t\t:\t$use-fade-in !default;\n$use-fadeInDown \t\t:\t$use-fade-in !default;\n$use-fadeInDownBig \t\t:\t$use-fade-in !default;\n$use-fadeInLeft \t\t:\t$use-fade-in !default;\n$use-fadeInLeftBig \t\t:\t$use-fade-in !default;\n$use-fadeInRight \t\t:\t$use-fade-in !default;\n$use-fadeInRightBig \t:\t$use-fade-in !default;\n\n\n// Fade Exit\n$use-fade-out           :   $use-fade !default;\n$use-fadeOut\t\t\t:   $use-fade-out !default;\n$use-fadeOutUp\t\t\t:\t$use-fade-out !default;\n$use-fadeOutUpBig   \t:\t$use-fade-out !default;\n$use-fadeOutDown\t\t:\t$use-fade-out !default;\n$use-fadeOutDownBig \t:\t$use-fade-out !default;\n$use-fadeOutLeft\t\t:\t$use-fade-out !default;\n$use-fadeOutLeftBig \t:\t$use-fade-out !default;\n$use-fadeOutRight\t\t:\t$use-fade-out !default;\n$use-fadeOutRightBig\t:\t$use-fade-out !default;\n\n\n// Bounce Enter\n$use-bounce-in          :   $use-bounce !default;\n$use-bounceIn\t\t\t:\t$use-bounce-in !default;\n$use-bounceInUp\t\t\t: \t$use-bounce-in !default;\n$use-bounceInDown \t\t: \t$use-bounce-in !default;\n$use-bounceInLeft \t\t: \t$use-bounce-in !default;\n$use-bounceInRight \t\t: \t$use-bounce-in !default;\n\n\n// Bounce Exit\n$use-bounce-out         :   $use-bounce !default;\n$use-bounceOut\t\t\t:\t$use-bounce-out !default;\n$use-bounceOutUp\t\t: \t$use-bounce-out !default;\n$use-bounceOutDown \t\t: \t$use-bounce-out !default;\n$use-bounceOutLeft \t\t: \t$use-bounce-out !default;\n$use-bounceOutRight \t: \t$use-bounce-out !default;\n\n\n\n// Rotate Enter\n$use-rotate-in          :   $use-rotate !default;\n$use-rotateIn \t\t\t:\t$use-rotate-in !default;\n$use-rotateInUpLeft \t: \t$use-rotate-in !default;\n$use-rotateInUpRight \t: \t$use-rotate-in !default;\n$use-rotateInDownLeft \t: \t$use-rotate-in !default;\n$use-rotateInDownRight \t: \t$use-rotate-in !default;\n\n\n// Rotate Exit\n$use-rotate-out         :   $use-rotate !default;\n$use-rotateOut \t\t\t:\t$use-rotate-out !default;\n$use-rotateOutUpLeft \t: \t$use-rotate-out !default;\n$use-rotateOutUpRight \t: \t$use-rotate-out !default;\n$use-rotateOutDownLeft \t: \t$use-rotate-out !default;\n$use-rotateOutDownRight : \t$use-rotate-out !default;\n\n\n// Slide Enter\n$use-slide-in           :   $use-slide !default;\n$use-slideIn\t\t\t:   $use-slide-in !default;\n$use-slideInUp\t\t\t:   $use-slide-in !default;\n$use-slideInDown\t\t:   $use-slide-in !default;\n$use-slideInLeft\t\t:   $use-slide-in !default;\n$use-slideInRight\t\t:   $use-slide-in !default;\n\n// Slide Exit\n$use-slide-out          :   $use-slide !default;\n$use-slideOut\t\t\t:   $use-slide-out !default;\n$use-slideOutUp\t\t\t:   $use-slide-out !default;\n$use-slideOutDown\t\t:   $use-slide-out !default;\n$use-slideOutLeft\t\t:   $use-slide-out !default;\n$use-slideOutRight\t\t:   $use-slide-out !default;\n\n// Flippers\n$use-flip\t\t\t\t:\t$use-flipers !default;\n$use-flipInX\t\t\t:\t$use-flipers !default;\n$use-flipInY\t\t\t:\t$use-flipers !default;\n$use-flipOutX\t\t\t:\t$use-flipers !default;\n$use-flipOutY\t\t\t:\t$use-flipers !default;\n\n\n// Lightspeed\n$use-lightSpeedIn \t\t:\t$use-light-speed !default;\n$use-lightSpeedOut \t\t:\t$use-light-speed !default;\n\n\n// Attention Seekers\n$use-bounce\t\t\t\t:\t$use-attention-seekers !default;\n$use-flash\t\t\t\t:\t$use-attention-seekers !default;\n$use-pulse\t\t\t\t:\t$use-attention-seekers !default;\n$use-wiggle\t\t\t\t:\t$use-attention-seekers !default;\n$use-swing\t\t\t\t:\t$use-attention-seekers !default;\n$use-shake\t\t\t\t:\t$use-attention-seekers !default;\n$use-tada\t\t\t\t:\t$use-attention-seekers !default;\n$use-wobble\t\t\t\t:\t$use-attention-seekers !default;\n\n\n// Special\n$use-hinge\t\t\t\t:\t$use-special !default;\n$use-rollIn\t\t\t\t: \t$use-special !default;\n$use-rollOut \t\t\t:\t$use-special !default;\n\n\n// Zoom In\n$use-zoom-in            :   $use-zoom !default;\n$use-zoomIn \t\t\t:\t$use-zoom-in !default;\n$use-zoomInDown \t\t:\t$use-zoom-in !default;\n$use-zoomInLeft \t\t:\t$use-zoom-in !default;\n$use-zoomInRight \t\t:\t$use-zoom-in !default;\n$use-zoomInUp \t\t\t:\t$use-zoom-in !default;\n\n\n// Zoom Out\n$use-zoom-out           :   $use-zoom !default;\n$use-zoomOut\t\t\t:\t$use-zoom-out !default;\n$use-zoomOutDown\t\t:\t$use-zoom-out !default;\n$use-zoomOutLeft\t\t:\t$use-zoom-out !default;\n$use-zoomOutRight\t\t:\t$use-zoom-out !default;\n$use-zoomOutUp\t\t\t:\t$use-zoom-out !default;\n","@if $use-fadeIn == true {\n\n\t@include animate-keyframe(fadeIn) {\n\t\t0% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\n\t.fadeIn {\n\t\t@include animate-prefixer(animation-name, fadeIn);\n\t}\n\n}\n","@if $use-fadeInDown == true {\n\n\t@-webkit-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInDown {\n\t\t@include animate-prefixer(animation-name, fadeInDown);\n\t}\n\n}\n","@if $use-fadeInUp == true {\n\n\t@-webkit-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInUp {\n\t\t@include animate-prefixer(animation-name, fadeInUp);\n\t}\n\n}\n","@if $use-fadeOut == true {\n\n\t@include animate-keyframe(fadeOut) {\n\t\t0% {opacity: 1;}\n\t\t100% {opacity: 0;}\n\t}\n\n\t.fadeOut {\n\t\t@include animate-prefixer(animation-name, fadeOut);\n\t}\n\n}\n","@if $use-lightSpeedIn == true {\n\n\t@-webkit-keyframes lightSpeedIn {\n\t\t0% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { -webkit-transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { -webkit-transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t@keyframes lightSpeedIn {\n\t\t0% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t.lightSpeedIn {\n\t\t@include animate-prefixer(animation-name, lightSpeedIn);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-out);\n\t}\n\n}\n","@if $use-lightSpeedOut == true {\n\n\t@-webkit-keyframes lightSpeedOut {\n\t\t0% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t@keyframes lightSpeedOut {\n\t\t0% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t.lightSpeedOut {\n\t\t@include animate-prefixer(animation-name, lightSpeedOut);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-in);\n\t}\n}\n","// Common Comps Animations\r\n\r\n\r\n$base-duration\t\t\t\t\t: .2s;\r\n$base-distance                  : 10px;\r\n$base-fill-mode\t\t\t\t\t: both;\r\n\r\n// Dropdown Animation\r\n\r\n.dropdown-menu {\r\n  &.show {\r\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n  }\r\n}\r\n\r\n.popover {\r\n  &.show {\r\n    display: block;\r\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  &[data-placement^=\"top\"].show {\r\n    animation: fade-in3 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n    bottom: auto !important;\r\n    top: auto !important;\r\n  }\r\n}\r\n\r\n@keyframes fade-in2 {\r\n  0% {\r\n    margin-top: -50px;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    margin-top: 0px;\r\n    visibility: visible;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.form-control {\r\n  transition: all .2s;\r\n}\r\n","@use \"sass:math\";\r\n@use \"sass:map\";\r\n@use \"sass:list\";\r\n\r\n// Buttons\r\n\r\n// 2x Outline Border\r\n$btn-block-spacing-y:         .5rem !default;\r\n\r\n.btn-outline-2x {\r\n  border-width: 2px;\r\n}\r\n\r\n.btn-group {\r\n  .btn {\r\n    font-size: 0.8rem;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .btn-outline-2x + .btn-outline-2x {\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .btn-square {\r\n    @include border-radius(0);\r\n  }\r\n}\r\n\r\n.btn {\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n\r\n  // Pills Buttons\r\n\r\n  &.btn-pill.btn-wide,\r\n  &.btn-pill {\r\n    @include border-start-radius(50px);\r\n    @include border-end-radius(50px);\r\n  }\r\n\r\n}\r\n\r\n// Dashed Border\r\n\r\n.btn-dashed {\r\n  border-style: dashed;\r\n}\r\n\r\n// Icon Buttons\r\n\r\n.btn-icon {\r\n  vertical-align: bottom;\r\n\r\n  &.btn-icon-right {\r\n    .btn-icon-wrapper {\r\n      margin-left: math.div($spacer, 2);\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .btn-icon-wrapper {\r\n    margin-right: math.div($spacer, 2);\r\n    margin-left: 0;\r\n    margin-top: 0;\r\n    font-size: 17px;\r\n    vertical-align: middle;\r\n    transition: color .1s;\r\n    display: inline-block;\r\n  }\r\n\r\n  &.btn-link {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.btn-lg:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 25px;\r\n    }\r\n  }\r\n\r\n  &.btn-sm:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n.btn-icon-only {\r\n  .btn-icon-wrapper {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n// Hover Shine {\r\n\r\n.btn-hover-shine {\r\n  position: relative;\r\n\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 0;\r\n    height: 100%;\r\n    background-color: rgba(255, 255, 255, 0.4);\r\n    -webkit-transition: none;\r\n    -moz-transition: none;\r\n    transition: none;\r\n  }\r\n\r\n  &:hover:after {\r\n    width: 120%;\r\n    background-color: rgba(255, 255, 255, 0);\r\n    transition: all 0.4s ease-in-out;\r\n  }\r\n\r\n  &.btn-pill {\r\n    &::after {\r\n      @include border-start-radius(50px);\r\n      @include border-end-radius(50px);\r\n    }\r\n  }\r\n}\r\n\r\n// Vertical Icons {\r\n\r\n.btn-icon-vertical {\r\n  padding-top: ($btn-block-spacing-y * 2);\r\n  padding-bottom: ($btn-block-spacing-y * 2);\r\n\r\n  .btn-icon-wrapper {\r\n    display: block;\r\n    font-size: 200%;\r\n    margin: 5px 0;\r\n    opacity: .6;\r\n  }\r\n\r\n  &.btn-link {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.btn-lg:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 25px;\r\n    }\r\n  }\r\n\r\n  &.btn-sm:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n  &:active,\r\n  &.active,\r\n  &:hover {\r\n    .btn-icon-wrapper {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  &.btn-icon-bottom {\r\n    .btn-icon-wrapper {\r\n      margin: math.div($spacer, 5) 0 5px;\r\n    }\r\n  }\r\n\r\n  &.btn-transition-text {\r\n    .btn-icon-wrapper {\r\n      transition: all .2s !important;\r\n    }\r\n\r\n    &:hover {\r\n      .btn-icon-wrapper {\r\n        transform: scale(1.3);\r\n      }\r\n    }\r\n\r\n    &.btn-transition-alt {\r\n\r\n      &:hover {\r\n        .btn-icon-wrapper {\r\n          color: $white !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn-icon-lg {\r\n  font-size: $h1-font-size !important;\r\n}\r\n\r\n// Buttons Transitions\r\n\r\n.btn-transition {\r\n  color: $gray-600;\r\n  border-color: $gray-200;\r\n  background-color: none;\r\n\r\n  &.btn-outline-link {\r\n    border-color: transparent;\r\n    background-color: transparent;\r\n\r\n    &:hover {\r\n      color: $primary;\r\n      background: $gray-100;\r\n    }\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $gray-600;\r\n    border-color: $gray-200;\r\n  }\r\n\r\n  &:hover {\r\n    .btn-icon-wrapper {\r\n      transition: none;\r\n    }\r\n  }\r\n}\r\n\r\n.btn-transition-alt {\r\n  &:hover {\r\n    .icon-gradient {\r\n      -webkit-background-clip: initial;\r\n      -webkit-text-fill-color: initial;\r\n      background-clip: initial;\r\n      text-fill-color: initial;\r\n      background: none !important;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n// Square Buttons\r\n\r\n.btn-square {\r\n  @include border-radius(0 !important);\r\n}\r\n\r\n// Wide buttons\r\n\r\n.btn {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y, ($btn-padding-x * 2), $font-size-xs, $btn-border-radius);\r\n  }\r\n}\r\n\r\n.btn-lg {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y-lg, ($btn-padding-x-lg * 2), $font-size-lg,  $btn-border-radius-lg);\r\n  }\r\n}\r\n\r\n.btn-sm {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y-sm, ($btn-padding-x-sm * 2), $font-size-xs, $btn-border-radius-sm);\r\n  }\r\n}\r\n\r\n// Dropdown toggle\r\n\r\n.dropdown-toggle {\r\n  &::after {\r\n    position: relative;\r\n    top: 2px;\r\n    opacity: .8;\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-toggle {\r\n    &::after {\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  border-left: rgba(255, 255, 255, .1) solid 1px;\r\n}\r\n\r\n// Buttons Gradients\r\n\r\n$btn-gradients: ();\r\n\r\n$gradient-primary: $brand;\r\n$gradient-secondary: $gray-600;\r\n$gradient-success: $green;\r\n$gradient-info: $cyan;\r\n$gradient-warning: $yellow;\r\n$gradient-danger: $red;\r\n$gradient-light: $blue-light;\r\n$gradient-dark: $gray-800;\r\n$gradient-focus: $indigo;\r\n$gradient-alt: $purple;\r\n\r\n$gradinet-percent: 15%;\r\n\r\n$btn-gradients: map.merge(\r\n                (\r\n                        \"primary\": (\r\n                                shade-color($gradient-primary, $gradinet-percent), // color-start\r\n                                $gradient-primary, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"secondary\": (\r\n                                shade-color($gradient-secondary, $gradinet-percent), // color-start\r\n                                $gradient-secondary, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"success\": (\r\n                                shade-color($gradient-success, $gradinet-percent), // color-start\r\n                                $gradient-success, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"info\": (\r\n                                shade-color($gradient-info, $gradinet-percent), // color-start\r\n                                $gradient-info, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"warning\": (\r\n                                shade-color($gradient-warning, $gradinet-percent), // color-start\r\n                                $gradient-warning, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"danger\": (\r\n                                shade-color($gradient-danger, $gradinet-percent), // color-start\r\n                                $gradient-danger, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"focus\": (\r\n                                shade-color($gradient-focus, $gradinet-percent), // color-start\r\n                                $gradient-focus, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"alternate\": (\r\n                                shade-color($gradient-alt, $gradinet-percent), // color-start\r\n                                $gradient-alt, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"light\": (\r\n                                shade-color($gradient-light, $gradinet-percent), // color-start\r\n                                $gradient-light, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"dark\": (\r\n                                shade-color($gradient-dark, $gradinet-percent), // color-start\r\n                                $gradient-dark, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                ),\r\n                $btn-gradients\r\n);\r\n\r\n@mixin btn-grad-variant($color-start, $color-end, $gr-start) {\r\n  background-image: linear-gradient(140deg, $color-start -30%, $color-end 90%);\r\n  background-color: $color-start;\r\n  border-color: $color-start;\r\n  color: color-contrast(shade-color($color-start, 10%));\r\n\r\n  &.active,\r\n  &:active,\r\n  &:not(:disabled):not(.disabled):hover {\r\n    background-image: linear-gradient(120deg, shade-color($color-start, 3%) 0%, shade-color($color-end, 3%) 100%);\r\n    color: color-contrast(shade-color($color-start, 10%));\r\n    border-color: shade-color($color-start, 10%);\r\n  }\r\n\r\n  &:focus,\r\n  &.focus,\r\n  &:active,\r\n  &.active {\r\n    color: color-contrast(shade-color($color-start, 10%)) !important;\r\n    border-color: shade-color($color-end, 20%) !important;\r\n  }\r\n\r\n}\r\n\r\n@each $grad, $colors in $btn-gradients {\r\n  $color: list.nth($colors, 1);\r\n  $color1: list.nth($colors, 2);\r\n  $color2: list.nth($colors, 3);\r\n\r\n  .btn-gradient-#{$grad} {\r\n    @include btn-grad-variant($color, $color1, $color2);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($color1, .4), 0 0.0625rem 0.125rem rgba($color1, .5);\r\n\r\n      &:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($color1, .5), 0 0.0625rem 0.125rem rgba($color1, .6);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn-shadow {\r\n  &.active {\r\n    box-shadow: 0 0 0 0 transparent !important;\r\n  }\r\n}\r\n\r\n// Links\r\n\r\n$link-color: $primary;\r\n$link-hover-color: shade-color($link-color, 15%);\r\n\r\n// Generate Buttons\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n\r\n      &:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-shadow-#{$color} {\r\n    &:hover {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n\r\n      &.active:hover,\r\n      &.disabled:hover,\r\n      &:active:hover,\r\n      &:disabled:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: (0px 5px 15px 2px rgba($value, 0.19));\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn {\r\n  position: relative;\r\n  @include transition($btn-transition);\r\n}\r\n\r\n.btn-light {\r\n  border-color: shade-color(#f5f5f5, 10%);\r\n}\r\n\r\n.btn-outline-light {\r\n  color: shade-color(#f5f5f5, 40%);\r\n}","// Dropdown\r\n\r\n@use \"sass:math\";\r\n\r\n.dropdown-menu {\r\n  box-shadow: 0 0.46875rem 2.1875rem rgba(shade-color($primary, 50%), .03),\r\n  0 0.9375rem 1.40625rem rgba(shade-color($primary, 50%), .03),\r\n  0 0.25rem 0.53125rem rgba(shade-color($primary, 50%), .05),\r\n  0 0.125rem 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n  font-size: $font-size-base;\r\n\r\n  margin: $dropdown-spacer;\r\n\r\n  &.dropdown-menu-right {\r\n    right: 0 !important;\r\n  }\r\n\r\n  .dropdown-header {\r\n    text-transform: uppercase;\r\n    font-size: math.div($font-size-base, 1.2);\r\n    color: $primary;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .dropdown-item {\r\n    font-size: $font-size-base;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n    cursor: pointer;\r\n    z-index: 6;\r\n    position: relative;\r\n\r\n    .dropdown-icon {\r\n      font-size: 1rem;\r\n      margin-right: math.div($dropdown-padding-y, 2);\r\n      width: 30px;\r\n      text-align: center;\r\n      opacity: .3;\r\n      margin-left: -10px;\r\n    }\r\n\r\n    &:hover {\r\n      .dropdown-icon {\r\n        opacity: .7;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.dropdown-menu-shadow {\r\n    box-shadow: 0 0.66875rem 2.3875rem rgba(shade-color($primary, 50%), .03),\r\n    0 1.1375rem 1.60625rem rgba(shade-color($primary, 50%), .03),\r\n    0 0.45rem 0.73125rem rgba(shade-color($primary, 50%), .05),\r\n    0 0.325rem 0.3875rem rgba(shade-color($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.dropdown-menu-rounded {\r\n  @include border-radius(10px);\r\n  padding: $dropdown-padding-y;\r\n\r\n  .dropdown-item {\r\n    @include border-radius(30px);\r\n  }\r\n\r\n  .dropdown-divider {\r\n    margin-left: -$dropdown-padding-y;\r\n    margin-right: -$dropdown-padding-y;\r\n  }\r\n\r\n  .dropdown-menu-header {\r\n    margin-left: -$dropdown-padding-y;\r\n    margin-right: -$dropdown-padding-y;\r\n    @include border-top-radius(10px);\r\n  }\r\n\r\n  .menu-header-image,\r\n  .dropdown-menu-header-inner {\r\n    @include border-top-radius(10px);\r\n  }\r\n}\r\n\r\n.dropdown-menu-hover-link {\r\n  .dropdown-item {\r\n    &:hover {\r\n      background: none;\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu-hover-primary {\r\n  .dropdown-item {\r\n    &:hover {\r\n      background: $primary;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  &.dropdown-menu-lg {\r\n    min-width: 22rem;\r\n  }\r\n\r\n  &.dropdown-menu-xl {\r\n    min-width: 25rem;\r\n  }\r\n}\r\n\r\n// Dropdown header\r\n\r\n.dropdown-menu {\r\n  .dropdown-menu-header,\r\n  .menu-header-image,\r\n  .dropdown-menu-header-inner {\r\n    @include border-top-radius($dropdown-border-radius);\r\n  }\r\n}\r\n\r\n.dropdown-menu-header {\r\n  color: $white;\r\n  margin-top: -$dropdown-padding-y;\r\n  margin-bottom: $dropdown-padding-y;\r\n  position: relative;\r\n  z-index: 6;\r\n\r\n  .dropdown-menu-header-inner {\r\n    margin: -1px -1px 0;\r\n    padding: ($spacer * 1.5) math.div($spacer, 2);\r\n    position: relative;\r\n  }\r\n\r\n  .menu-header-image {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 8;\r\n    opacity: .25;\r\n    filter: grayscale(80%);\r\n    background-size: cover;\r\n  }\r\n\r\n  .menu-header-content {\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 10;\r\n\r\n    &.text-start {\r\n      padding-left: math.div($spacer, 2);\r\n    }\r\n\r\n    &.btn-pane-right {\r\n      padding-left: math.div($spacer, 2);\r\n      padding-right: math.div($spacer, 2);\r\n      display: flex;\r\n      align-content: center;\r\n      align-items: center;\r\n      text-align: left;\r\n\r\n      .menu-header-btn-pane {\r\n        margin: 0 0 0 auto;\r\n      }\r\n    }\r\n\r\n    .menu-header-btn-pane {\r\n      margin-top: 10px;\r\n      margin-bottom: 3px;\r\n    }\r\n  }\r\n\r\n  & + .grid-menu {\r\n    margin-top: -$dropdown-padding-y;\r\n  }\r\n}\r\n\r\n.menu-header-title {\r\n  font-weight: 500;\r\n  font-size: $h5-font-size;\r\n  margin: 0;\r\n}\r\n\r\n.menu-header-subtitle {\r\n  font-size: $font-family-base;\r\n  margin: 5px 0 0;\r\n  opacity: .8;\r\n}\r\n\r\n.dropdown-menu {\r\n  .grid-menu {\r\n    margin-bottom: -$dropdown-padding-y;\r\n    padding: 1px;\r\n\r\n    [class*=\"col-\"] {\r\n      padding: $dropdown-padding-y;\r\n    }\r\n  }\r\n\r\n  .grid-menu-xl {\r\n    margin-bottom: -(math.div($dropdown-padding-y, 1.35));\r\n\r\n    [class*=\"col-\"] {\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Dropdown toggle\r\n\r\n.dropdown-toggle {\r\n  &::after {\r\n    position: relative;\r\n    top: 2px;\r\n    opacity: .8;\r\n    margin-left: 5px;\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-toggle {\r\n    &::after {\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  border-left: rgba(255, 255, 255, .1) solid 2px;\r\n}\r\n\r\n// Dropdown Indicators\r\n\r\n.dropdown-menu {\r\n\r\n  &::before,\r\n  &::after {\r\n    position: absolute;\r\n    width: 14px;\r\n    height: 14px;\r\n    left: 5px;\r\n    top: -5px;\r\n    transform: rotate(45deg);\r\n    border-radius: 4px;\r\n    content: '';\r\n    display: block;\r\n    z-index: 5;\r\n  }\r\n\r\n  &::before {\r\n    background: $dropdown-bg;\r\n    z-index: 5;\r\n  }\r\n\r\n  &::after {\r\n    top: -6px;\r\n    background: $dropdown-border-color;\r\n    z-index: 4;\r\n  }\r\n\r\n  &[data-placement=\"top-start\"] {\r\n    &::before,\r\n    &::after {\r\n      top: auto;\r\n      bottom: -5px;\r\n    }\r\n\r\n    &::after {\r\n      bottom: -6px;\r\n    }\r\n  }\r\n\r\n  &[data-placement=\"left-start\"] {\r\n    &::before,\r\n    &::after {\r\n      left: auto;\r\n      right: -5px;\r\n      top: 5px;\r\n    }\r\n\r\n    &::after {\r\n      top: 5px;\r\n      right: -6px;\r\n    }\r\n  }\r\n\r\n  &[data-placement=\"right-start\"] {\r\n    &::before,\r\n    &::after {\r\n      right: auto;\r\n      left: -5px;\r\n      top: 5px;\r\n    }\r\n\r\n    &::after {\r\n      top: 5px;\r\n      left: -6px;\r\n    }\r\n  }\r\n\r\n  &.dropdown-menu-right {\r\n    &::before,\r\n    &::after {\r\n      left: auto;\r\n      right: 6px;\r\n    }\r\n\r\n    &::after {\r\n      right: 6px;\r\n    }\r\n  }\r\n\r\n  &.rm-pointers {\r\n    &::before,\r\n    &::after {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Dropdown Mega Menu\r\n\r\n.dropdown-mega-menu {\r\n  width: 56rem;\r\n  padding: $spacer;\r\n\r\n  .nav-item.nav-item-header {\r\n    text-transform: none;\r\n    font-size: $h6-font-size;\r\n    padding-top: 0;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .grid-menu {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.dropdown-mega-menu-sm {\r\n  width: 40rem;\r\n}\r\n\r\n// Dropdown Inline\r\n\r\nbody .dropdown-menu.dropdown-menu-inline {\r\n  border: 0;\r\n  position: static !important;\r\n  box-shadow: 0 0 0 transparent;\r\n  background: transparent;\r\n  @include border-radius(0);\r\n  display: inline-block;\r\n  float: none;\r\n  left: 0 !important;\r\n  top: 0 !important;\r\n  width: 100% !important;\r\n  transform: translateY(0) !important;\r\n\r\n  &::before,\r\n  &::after {\r\n    display: none;\r\n  }\r\n}\r\n","// NAVS\r\n\r\n@use \"sass:math\";\r\n\r\n.nav-item {\r\n  .nav-link {\r\n    font-weight: normal;\r\n  }\r\n}\r\n\r\n.nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  cursor: pointer;\r\n\r\n  .nav-link-icon {\r\n    color: $primary;\r\n    font-size: 1rem;\r\n    width: 30px;\r\n    text-align: center;\r\n    opacity: .45;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  &:hover {\r\n    color: $gray-700;\r\n\r\n    .nav-link-icon {\r\n      opacity: .9;\r\n      color: $primary;\r\n    }\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    .nav-link-icon {\r\n      opacity: .3;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-item {\r\n  &.nav-item-header {\r\n    text-transform: uppercase;\r\n    font-size: math.div($font-size-base, 1.2);\r\n    color: $gray-600;\r\n    font-weight: bold;\r\n    padding: $nav-link-padding-y $nav-link-padding-x;\r\n  }\r\n\r\n  &.nav-item-btn {\r\n    padding: $nav-link-padding-y $nav-link-padding-x;\r\n  }\r\n\r\n  &.nav-item-divider {\r\n    margin: $nav-link-padding-y 0;\r\n    height: 1px;\r\n    overflow: hidden;\r\n    background: $gray-300;\r\n  }\r\n}\r\n\r\n.nav {\r\n  .badge {\r\n    margin-left: 8px;\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n\r\n    &.active,\r\n    &.active:hover {\r\n      color: $white;\r\n\r\n      .nav-link-icon {\r\n        color: $white;\r\n        opacity: .8;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      color: $gray-700 !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Grid Menus\r\n\r\n.grid-menu {\r\n\r\n  [class*=\"col-\"] {\r\n    border-right: $border-color solid 0;\r\n    border-bottom: $border-color solid 1px;\r\n\r\n    &:hover {\r\n      z-index: 5;\r\n    }\r\n  }\r\n\r\n  // @include media-breakpoint-between(sm, xl) {\r\n\r\n    [class*=\"col-\"]:nth-last-child(-n+2) {\r\n      border-bottom-width: 0;\r\n    }\r\n\r\n    [class*=\"col-\"]:nth-child(1n) {\r\n      border-right-width: 1px;\r\n    }\r\n\r\n    [class*=\"col-\"]:nth-child(2n) {\r\n      border-right-width: 0;\r\n    }\r\n  // }\r\n\r\n  [class*=\"col-\"]:nth-last-child(-n+1) {\r\n    border-bottom-width: 0;\r\n  }\r\n\r\n  &.grid-menu-3col {\r\n\r\n    // @include media-breakpoint-up(xl) {\r\n\r\n      [class*=\"col-\"]:nth-last-child(-n+3) {\r\n        border-bottom-width: 0;\r\n      }\r\n\r\n      [class*=\"col-\"]:nth-child(2n) {\r\n        border-right-width: 1px;\r\n      }\r\n\r\n      [class*=\"col-\"]:nth-child(3n) {\r\n        border-right-width: 0;\r\n      }\r\n    // }\r\n  }\r\n\r\n  .btn {\r\n    display: block;\r\n    border: 0;\r\n    min-width: 100%;\r\n  }\r\n}\r\n\r\n","// Badges\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   .badge-#{$color} {\r\n//     @include badge-variant($value);\r\n//   }\r\n// }\r\n\r\n.badge {\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  padding: 5px 10px;\r\n  min-width: 19px;\r\n}\r\n\r\n.badge-light {\r\n  background: $white;\r\n}\r\n\r\n.badge-dot {\r\n  text-indent: -999em;\r\n  padding: 0;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: transparent solid 1px;\r\n  @include border-radius(30px);\r\n  min-width: 2px;\r\n}\r\n\r\n.badge-dot-lg {\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n.badge-dot-xl {\r\n  width: 18px;\r\n  height: 18px;\r\n  position: relative;\r\n\r\n  &::before {\r\n    content: '';\r\n    width: 10px;\r\n    height: 10px;\r\n    @include border-radius($border-radius);\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -5px 0 0 -5px;\r\n    background: $white;\r\n  }\r\n}\r\n\r\n.badge-dot-sm {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n.btn {\r\n  .badge {\r\n    margin-left: 8px;\r\n  }\r\n\r\n  .badge-dot {\r\n    position: absolute;\r\n    border: $white solid 2px;\r\n    top: -5px;\r\n    right: -5px;\r\n    width: 11px;\r\n    height: 11px;\r\n\r\n    &.badge-dot-lg {\r\n      width: 14px;\r\n      height: 14px;\r\n    }\r\n\r\n    &.badge-dot-sm {\r\n      width: 8px;\r\n      height: 8px;\r\n      border-width: 1px;\r\n    }\r\n  }\r\n\r\n  .badge-dot-inside {\r\n    top: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n\r\n.btn-sm {\r\n  .badge-dot-sm {\r\n    top: 1px;\r\n    right: 4px;\r\n  }\r\n\r\n  .badge-dot {\r\n    top: 0px;\r\n    right: 2px;\r\n  }\r\n\r\n  .badge-dot-lg {\r\n    top: -3px;\r\n    right: -2px;\r\n  }\r\n\r\n  .rounded-pill {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -4px;\r\n  }\r\n}\r\n\r\n.badge-abs {\r\n  position: absolute;\r\n  right: -3px;\r\n  top: -3px;\r\n}\r\n\r\n// Avatars\r\n\r\n.avatar-icon-wrapper {\r\n  display: inline-block;\r\n  margin-right: .1rem;\r\n  position: relative;\r\n\r\n  .badge {\r\n    position: absolute;\r\n    right: -2px;\r\n    top: -2px;\r\n\r\n    &:empty {\r\n      display: block;\r\n    }\r\n\r\n    &.badge-bottom {\r\n      top: auto;\r\n      right: -2px;\r\n      bottom: -2px;\r\n    }\r\n  }\r\n\r\n  .badge-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border: $white solid 2px;\r\n\r\n    &.badge-dot-lg {\r\n      width: 14px;\r\n      height: 14px;\r\n      border: $white solid 2px;\r\n      top: 0;\r\n      right: 0;\r\n\r\n      &.badge-bottom {\r\n        top: auto;\r\n        right: 0;\r\n        bottom: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-add {\r\n\r\n  .avatar-icon {\r\n    background: $dropdown-link-hover-bg;\r\n    border: tint-color($primary, 15%) dashed 1px;\r\n    color: $primary;\r\n    text-align: center;\r\n    opacity: .6;\r\n\r\n    i {\r\n      font-style: normal;\r\n      vertical-align: middle;\r\n      font-size: $h4-font-size;\r\n      display: block;\r\n      height: 100%;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n\r\n    .avatar-icon {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n\r\na.avatar-icon-wrapper {\r\n  &:hover {\r\n\r\n    .avatar-icon {\r\n      opacity: .8;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon {\r\n  display: block;\r\n  width: 44px;\r\n  height: 44px;\r\n  transition: all .2s;\r\n  opacity: 1;\r\n  @include border-radius(50px);\r\n\r\n  &.rounded {\r\n    @include border-radius(($border-radius-lg * 1.3) !important);\r\n  }\r\n}\r\n\r\n.avatar-icon-xl {\r\n  .avatar-icon {\r\n    width: 64px;\r\n    height: 64px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $h2-font-size;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-lg {\r\n  .avatar-icon {\r\n    width: 54px;\r\n    height: 54px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $h3-font-size;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-sm {\r\n  .avatar-icon {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $font-size-lg;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-xs {\r\n  .avatar-icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    transition: transform .2s;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      line-height: 26px;\r\n      font-size: $font-size-base;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    .avatar-icon {\r\n      transform: scale(2);\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon {\r\n  border: $white solid 3px;\r\n  overflow: hidden;\r\n\r\n  img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.avatar-wrapper-overlap {\r\n  .avatar-icon-wrapper {\r\n    z-index: 5;\r\n    margin-left: -18px;\r\n\r\n    &:hover {\r\n      z-index: 7;\r\n    }\r\n\r\n    &.avatar-icon-xl {\r\n      margin-left: -30px;\r\n    }\r\n    &.avatar-icon-lg {\r\n      margin-left: -24px;\r\n    }\r\n    &.avatar-icon-sm {\r\n      margin-left: -14px;\r\n    }\r\n    &.avatar-icon-xs {\r\n      margin-left: -10px;\r\n    }\r\n\r\n    &.avatar-icon-add,\r\n    &:first-child {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Badge Pulse\r\n\r\n@-webkit-keyframes sploosh {\r\n  0% {\r\n    box-shadow: 0 0 0 0px rgba(#333, .2);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 8px rgba(#333, 0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    -webkit-transform: scale(1);\r\n  }\r\n  16.5% {\r\n    -webkit-transform: scale(1.2);\r\n  }\r\n  33% {\r\n    -webkit-transform: scale(1.1);\r\n  }\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n  }\r\n}\r\n\r\n.badge-pulse {\r\n  -webkit-animation: pulse 2s ease-out;\r\n  -webkit-animation-iteration-count: infinite;\r\n  position: relative;\r\n\r\n  &::before,\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border: 0;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n\r\n    -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n    -webkit-animation-iteration-count: infinite;\r\n  }\r\n\r\n  &::after {\r\n    -webkit-animation-delay: .33s;\r\n    -webkit-animation-duration: 2.2s;\r\n  }\r\n}","// CARDS\r\n\r\n@use \"sass:math\";\r\n\r\n.card {\r\n  box-shadow: $box-shadow-default;\r\n  border-width: 0;\r\n  transition: all .2s;\r\n\r\n  & > .dropdown-menu-header {\r\n    margin: 0;\r\n\r\n    .dropdown-menu-header-inner {\r\n      @include border-top-radius($card-border-radius);\r\n    }\r\n  }\r\n\r\n  &.text-dark.text-white,\r\n  &.text-white {\r\n    .card-footer,\r\n    .card-header {\r\n      background: rgba(255, 255, 255, .1);\r\n      color: rgba(255, 255, 255, .9);\r\n    }\r\n  }\r\n\r\n  &.text-dark.text-white {\r\n    .card-footer,\r\n    .card-header {\r\n      color: rgba(0, 0, 0, .9);\r\n    }\r\n  }\r\n\r\n  .card-footer {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.btn-actions-pane-right {\r\n  margin-left: auto;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn-actions-pane-left {\r\n  margin-right: auto;\r\n}\r\n\r\n.actions-icon-btn {\r\n  .btn-icon-only {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n\r\n    .btn-icon-wrapper {\r\n      font-size: 1.3rem;\r\n      width: 30px;\r\n      text-align: center;\r\n    }\r\n\r\n    color: $gray-700;\r\n\r\n    &:hover {\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.card-header,\r\n.card-title {\r\n  text-transform: uppercase;\r\n  color: rgba(shade-color($primary, 40%), .7);\r\n  font-weight: bold;\r\n  font-size: $font-size-base;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  border-bottom-width: 1px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  padding-right: math.div($card-spacer-x, 2);\r\n  height: 3.5rem;\r\n\r\n  &.no-border {\r\n    border: 0;\r\n    padding: 0;\r\n    height: auto;\r\n  }\r\n\r\n  .menu-header-subtitle {\r\n    display: block;\r\n  }\r\n\r\n  &.card-header-tab {\r\n    .nav {\r\n      width: auto;\r\n      margin-left: auto;\r\n    }\r\n\r\n    .card-header-title {\r\n      display: flex;\r\n      align-items: center;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n\r\n  .header-icon {\r\n    font-size: ($font-size-lg * 1.5);\r\n    margin-right: math.div($card-spacer-x, 2);\r\n  }\r\n\r\n  & > .nav {\r\n    margin-left: -(math.div($card-spacer-x, 2));\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    .nav-item {\r\n      position: relative;\r\n      height: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .nav-link {\r\n      text-transform: none;\r\n      width: 100%;\r\n      display: block;\r\n      color: $gray-700;\r\n\r\n      &::before {\r\n        content: '';\r\n        @include border-radius(15px);\r\n        background: $primary;\r\n        transition: all .2s;\r\n        height: 4px;\r\n        width: 100%;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -2px;\r\n        opacity: 0;\r\n      }\r\n\r\n      &:hover {\r\n        color: $primary;\r\n      }\r\n\r\n      &.active {\r\n        color: $primary;\r\n\r\n        &::before {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.card-header-tab-animation {\r\n    .nav .nav-link {\r\n      &::before {\r\n        transform: scale(0);\r\n        opacity: 1;\r\n        width: 90%;\r\n        left: 5%;\r\n      }\r\n\r\n      &.active,\r\n      &:hover {\r\n        &::before {\r\n          transform: scale(1);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.card-border {\r\n  box-shadow: 0 0 0 transparent;\r\n  border-width: 1px;\r\n}\r\n\r\n.card-hover-shadow {\r\n  &:hover {\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba(shade-color($primary, 50%), .03),\r\n    0 0.9375rem 1.40625rem rgba(shade-color($primary, 50%), .03),\r\n    0 0.25rem 0.53125rem rgba(shade-color($primary, 50%), .05),\r\n    0 0.125rem 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.card-hover-shadow-2x {\r\n  &:hover {\r\n    box-shadow: 0 0.66875rem 2.3875rem rgba(shade-color($primary, 50%), .03),\r\n    0 1.1375rem 1.60625rem rgba(shade-color($primary, 50%), .03),\r\n    0 0.45rem 0.73125rem rgba(shade-color($primary, 50%), .05),\r\n    0 0.325rem 0.3875rem rgba(shade-color($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.card-subtitle {\r\n  margin-bottom: $card-spacer-y;\r\n  font-size: $font-size-sm;\r\n  color: rgba(shade-color($primary, 40%), .55);\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .card-shadow-#{$color} {\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba($value, .03),\r\n    0 0.9375rem 1.40625rem rgba($value, .03),\r\n    0 0.25rem 0.53125rem rgba($value, .05),\r\n    0 0.125rem 0.1875rem rgba($value, .03);\r\n  }\r\n}\r\n\r\n// Large Card Header\r\n\r\n.card-header-lg {\r\n  padding: ($card-spacer-y * 2) ($card-spacer-x * 2);\r\n  height: auto;\r\n}\r\n\r\n.sticky-active-class {\r\n  .sticky-inner-wrapper {\r\n    & > div {\r\n      box-shadow: $box-shadow-default;\r\n    }\r\n  }\r\n}","// TABS\r\n\r\n@use \"sass:math\";\r\n\r\n.nav-pills,\r\n.nav-tabs {\r\n  margin-bottom: $spacer;\r\n}\r\n\r\n.nav-link {\r\n  font-weight: bold;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.nav-tabs {\r\n  .nav-link {\r\n\r\n    &:hover {\r\n      color: $primary !important;\r\n    }\r\n\r\n    &.active {\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n\r\n    &:hover {\r\n      color: $primary !important;\r\n    }\r\n\r\n    &.active {\r\n      background: $primary;\r\n\r\n      &:hover {\r\n        color: $white !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Fancy Tabs\r\n\r\n.RRT__container {\r\n  position: relative;\r\n}\r\n\r\n.RRT__tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n.RRT__accordion {\r\n  flex-direction: column;\r\n}\r\n\r\n.RRT__tab {\r\n  cursor: pointer;\r\n  z-index: 1;\r\n  white-space: nowrap;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    color: $primary;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n.RRT__tab--selected {\r\n  color: $primary;\r\n}\r\n\r\n.RRT__tab--disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.RRT__tab:focus {\r\n  z-index: 2;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable {\r\n  position: relative;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable-text {\r\n  margin-right: 10px;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable-icon {\r\n  position: absolute;\r\n  font-size: 18px;\r\n  right: 0.5em;\r\n  top: 0.2em;\r\n}\r\n\r\n// Alternate Style\r\n\r\n.body-tabs.body-tabs-layout {\r\n  &.body-tabs-big {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: stretch;\r\n    @extend .container;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    @include border-radius(50px);\r\n    border: $gray-200 solid 1px;\r\n    z-index: 7;\r\n\r\n    .RRT__tab {\r\n      margin: 0;\r\n      font-size: 1rem;\r\n      font-weight: 300;\r\n      padding: 0;\r\n      height: 50px;\r\n      line-height: 50px;\r\n      flex: 1;\r\n      text-align: center;\r\n      position: relative;\r\n      color: $primary;\r\n\r\n      &:hover {\r\n        color: $gray-900;\r\n      }\r\n\r\n      &.RRT__tab--selected {\r\n        color: $white;\r\n\r\n        &:hover {\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n\r\n    & + .RRT__inkbar-wrapper {\r\n      height: 70px !important;\r\n      top: -70px !important;\r\n      @extend .container;\r\n      margin: 0 auto -3.4rem;\r\n      position: relative;\r\n      padding: 0 10px;\r\n\r\n      &::before {\r\n        position: absolute;\r\n        content: '';\r\n        background: $white;\r\n        width: 100%;\r\n        height: 100%;\r\n        left: 0;\r\n        top: -11px;\r\n        @include border-radius(50px);\r\n      }\r\n\r\n      .RRT__inkbar {\r\n        height: 50px !important;\r\n        margin-top: 10px;\r\n        @include border-radius(50px);\r\n        box-shadow: 0 0 0 transparent;\r\n      }\r\n\r\n      & + .RRT__panel {\r\n        margin-top: -1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Panels\r\n\r\n.RRT__panel {\r\n  margin-top: $spacer;\r\n}\r\n\r\n.RRT__accordion .RRT__panel {\r\n}\r\n\r\n// Show More\r\n\r\n.RRT__showmore {\r\n  @include border-radius($border-radius);\r\n  background: $primary;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n  white-space: nowrap;\r\n  font-weight: bold;\r\n  width: 36px;\r\n  text-align: center;\r\n  height: 36px;\r\n  display: block;\r\n  margin-left: 15px;\r\n  position: absolute;\r\n  right: $grid-gutter-width;\r\n  top: 50%;\r\n  margin-top: -18px;\r\n  font-size: 1.4rem;\r\n\r\n  &:focus {\r\n    outline: none;\r\n\r\n  }\r\n}\r\n\r\n.RRT__showmore-label {\r\n  position: relative;\r\n  z-index: 1;\r\n  color: $white;\r\n  width: 36px;\r\n  text-align: center;\r\n  height: 36px;\r\n  line-height: 24px;\r\n}\r\n\r\n.RRT__showmore--selected {\r\n  box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\r\n  0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n  0 8px 10px -5px rgba($primary, 0.2);\r\n}\r\n\r\n.RRT__showmore-list {\r\n  position: absolute;\r\n  right: -1px;\r\n  top: 100%;\r\n  display: none;\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y 0;\r\n  margin: $dropdown-spacer 0 0; // override default ul\r\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\r\n  color: $body-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  box-shadow: $box-shadow-default;\r\n\r\n  .RRT__tab {\r\n    display: block;\r\n    width: 100%; // For `<button>`s\r\n    padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n    clear: both;\r\n    font-weight: $font-weight-normal;\r\n    color: $dropdown-link-color;\r\n    text-align: inherit; // For `<button>`s\r\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n    background-color: transparent; // For `<button>`s\r\n    border: 0; // For `<button>`s\r\n    margin: 0;\r\n\r\n    &:hover,\r\n    &.RRT__tab--selected {\r\n      color: $dropdown-link-hover-color !important;\r\n      text-decoration: none;\r\n      background: $dropdown-link-hover-bg;\r\n    }\r\n  }\r\n}\r\n\r\n.RRT__showmore-list--opened {\r\n  display: block;\r\n\r\n  .RRT__tab--selected {\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n// Inkbar\r\n\r\n.RRT__inkbar-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.RRT__inkbar {\r\n  position: relative;\r\n  bottom: 0;\r\n  height: 3px;\r\n  margin-top: -3px;\r\n  background-color: $primary;\r\n  @include border-radius(15px);\r\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\r\n  z-index: 2;\r\n}\r\n\r\n.card-tabs {\r\n  .card-header {\r\n    padding: 0 1.25rem;\r\n\r\n    &.RRT__tabs {\r\n      cursor: pointer;\r\n      font-weight: normal;\r\n\r\n      .RRT__tab {\r\n        text-transform: none;\r\n        line-height: 1.3;\r\n      }\r\n    }\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    width: calc(100% - 1.5rem) !important;\r\n    margin-left: 1.25rem;\r\n  }\r\n\r\n  .RRT__panel {\r\n    padding: $spacer;\r\n    margin: 0;\r\n  }\r\n\r\n  &.text-white {\r\n\r\n    .RRT__tab {\r\n      color: rgba(255, 255, 255, .6);\r\n\r\n      &:hover {\r\n        color: $white;\r\n      }\r\n    }\r\n\r\n    .RRT__tab--selected {\r\n      color: $white;\r\n    }\r\n\r\n    .RRT__inkbar {\r\n      background: tint-color($primary, 40%);\r\n    }\r\n  }\r\n}\r\n\r\n.card-tabs-animated {\r\n  .RRT__container > .RRT__tabs {\r\n    background: transparent;\r\n    position: relative;\r\n    z-index: 7;\r\n\r\n    &.card-header {\r\n      border-bottom: 0;\r\n      height: auto;\r\n      padding: $layout-spacer-x $layout-spacer-x math.div($layout-spacer-x, 3);\r\n    }\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    position: absolute;\r\n    top: $layout-spacer-x;\r\n    z-index: 5;\r\n  }\r\n\r\n  .RRT__tab {\r\n    padding: $nav-link-padding-y ($nav-link-padding-x * 1.2);\r\n  }\r\n\r\n  .RRT__tab--selected {\r\n    color: $white;\r\n  }\r\n\r\n  .RRT__inkbar {\r\n    height: 35px;\r\n    margin-top: 0;\r\n    @include border-radius($border-radius);\r\n    box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\r\n    0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n    0 8px 10px -5px rgba($primary, 0.2);\r\n  }\r\n}\r\n\r\n.card-tabs-animated-inner {\r\n  .RRT__tabs {\r\n    padding: 0 5%;\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    left: 5%;\r\n    width: 90%;\r\n    height: 36px;\r\n    top: 14px;\r\n  }\r\n\r\n  .RRT__inkbar {\r\n    height: 36px;\r\n  }\r\n}\r\n\r\n.body-tabs {\r\n  border-bottom: $gray-300 solid 2px;\r\n\r\n  & > .RRT__tab {\r\n    padding: math.div($layout-spacer-x, 1.5) math.div($layout-spacer-x, 1.2);\r\n    font-weight: normal;\r\n    font-size: $font-size-base;\r\n  }\r\n\r\n  &.body-tabs-alt {\r\n    & > .RRT__tab {\r\n      padding: math.div($layout-spacer-x, 1.1) math.div($layout-spacer-x, 3);\r\n      font-weight: normal;\r\n      font-size: 0.86rem;\r\n      width: 33%;\r\n      text-align: center;\r\n    }\r\n\r\n    .RRT__inkbar {\r\n      height: 2px;\r\n      margin-top: -2px;\r\n    }\r\n  }\r\n}\r\n\r\n.popover,\r\n.dropdown-menu {\r\n  .RRT__panel {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n\r\n    &::after,\r\n    &::before {\r\n      width: 100%;\r\n      bottom: auto;\r\n      top: 0;\r\n      left: 0;\r\n      height: 20px;\r\n      position: absolute;\r\n      z-index: 10;\r\n      content: '';\r\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\r\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\r\n    }\r\n\r\n    &::after {\r\n      bottom: 0;\r\n      top: auto;\r\n\r\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\r\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\r\n    }\r\n  }\r\n}\r\n\r\n// Tabs alternate\r\n\r\n.tabs-lg-alternate {\r\n  &.card-header {\r\n    padding: 0;\r\n    height: auto;\r\n\r\n    .widget-number {\r\n      font-size: $h2-font-size;\r\n      font-weight: 300;\r\n    }\r\n\r\n    .tab-subheading {\r\n      padding: 5px 0 0;\r\n      opacity: .6;\r\n      transition: all .2s;\r\n    }\r\n\r\n    & > .nav {\r\n      margin: 0;\r\n\r\n      .nav-link {\r\n        padding: $layout-spacer-x 0;\r\n        border-right: $gray-200 solid 1px;\r\n        background: $gray-100;\r\n\r\n        &:hover {\r\n          background: $white;\r\n          .tab-subheading {\r\n            color: $black;\r\n            opacity: .9;\r\n          }\r\n        }\r\n\r\n        &::before {\r\n          background: $white;\r\n          border-radius: 0;\r\n        }\r\n\r\n        &.active {\r\n          background: $white;\r\n\r\n          .tab-subheading {\r\n            color: $black;\r\n            opacity: .9;\r\n          }\r\n        }\r\n      }\r\n\r\n      .nav-item:last-child {\r\n        .nav-link {\r\n          border-right: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Accordions\r\n\r\n.accordion-wrapper {\r\n  @include border-radius($border-radius);\r\n  border: $gray-200 solid 1px;\r\n\r\n  & > .card {\r\n    box-shadow: 0 0 0 0 transparent;\r\n\r\n    & > .card-header {\r\n      padding: 1rem;\r\n      height: auto;\r\n\r\n      .btn:active,\r\n      .btn:focus,\r\n      .btn:hover {\r\n        text-decoration: none;\r\n      }\r\n\r\n      .form-heading {\r\n        p {\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .collapse {\r\n      border-bottom: transparent solid 1px;\r\n\r\n      &.show {\r\n        border-bottom-color: $gray-200;\r\n      }\r\n    }\r\n  }\r\n}","// Modals\r\n\r\n.modal-header,\r\n.modal-footer {\r\n  background: $gray-100;\r\n}\r\n\r\n.modal-footer {\r\n  @include border-bottom-radius($border-radius);\r\n}\r\n\r\n.modal-dialog {\r\n  box-shadow: $box-shadow-lg-default;\r\n  @include border-radius($border-radius);\r\n}","/* NOTE: loaders.css/ is loaded from node_modules/ using sass-loader */\r\n\r\n$primary-color: $primary !default;\r\n$ball-size: 15px !default;\r\n$margin: 2px !default;\r\n$line-height: 35px !default;\r\n$line-width: 4px !default;\r\n\r\n\r\n@mixin global-bg() {\r\n  background-color: $primary-color;\r\n}\r\n\r\n@mixin global-animation() {\r\n  animation-fill-mode: both;\r\n}\r\n\r\n@mixin balls() {\r\n  @include global-bg();\r\n\r\n  width: $ball-size;\r\n  height: $ball-size;\r\n  border-radius: 100%;\r\n  margin: $margin;\r\n}\r\n\r\n@mixin lines() {\r\n  @include global-bg();\r\n\r\n  width: $line-width;\r\n  height: $line-height;\r\n  border-radius: 2px;\r\n  margin: $margin;\r\n}\r\n\r\n\r\n/**\r\n * Dots\r\n */\r\n@import 'loaders.css/src/animations/ball-pulse';\r\n@import 'loaders.css/src/animations/ball-pulse-sync';\r\n@import 'loaders.css/src/animations/ball-scale';\r\n@import 'loaders.css/src/animations/ball-rotate';\r\n@import 'loaders.css/src/animations/ball-clip-rotate';\r\n@import 'loaders.css/src/animations/ball-clip-rotate-pulse';\r\n@import 'loaders.css/src/animations/ball-clip-rotate-multiple';\r\n@import 'loaders.css/src/animations/ball-scale-ripple';\r\n@import 'loaders.css/src/animations/ball-scale-ripple-multiple';\r\n@import 'loaders.css/src/animations/ball-beat';\r\n@import 'loaders.css/src/animations/ball-scale-multiple';\r\n@import 'loaders.css/src/animations/ball-triangle-trace';\r\n@import 'loaders.css/src/animations/ball-pulse-rise';\r\n@import 'loaders.css/src/animations/ball-grid-beat';\r\n@import 'loaders.css/src/animations/ball-grid-pulse';\r\n@import 'loaders.css/src/animations/ball-spin-fade-loader';\r\n@import 'loaders.css/src/animations/ball-spin-loader';\r\n@import 'loaders.css/src/animations/ball-zig-zag';\r\n@import 'loaders.css/src/animations/ball-zig-zag-deflect';\r\n\r\n/**\r\n * Lines\r\n */\r\n@import 'loaders.css/src/animations/line-scale';\r\n@import 'loaders.css/src/animations/line-scale-random';\r\n@import 'loaders.css/src/animations/line-scale-pulse-out';\r\n@import 'loaders.css/src/animations/line-scale-pulse-out-rapid';\r\n@import 'loaders.css/src/animations/line-spin-fade-loader';\r\n\r\n/**\r\n * Misc\r\n */\r\n@import 'loaders.css/src/animations/triangle-skew-spin';\r\n@import 'loaders.css/src/animations/square-spin';\r\n@import 'loaders.css/src/animations/pacman';\r\n@import 'loaders.css/src/animations/cube-transition';\r\n@import 'loaders.css/src/animations/semi-circle-spin';\r\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// mixins should be separated out\n@mixin ball-pulse($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: scale 0.75s delay(0.12s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.ball-pulse {\n  @include ball-pulse();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$amount: 10px;\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY($amount);\n  }\n  66% {\n    transform: translateY(-$amount);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@mixin ball-pulse-sync($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: ball-pulse-sync 0.6s delay(0.07s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.ball-pulse-sync {\n  @include ball-pulse-sync();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0.0);\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n.ball-scale {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    height: 60px;\n    width: 60px;\n    animation: ball-scale 1s 0s ease-in-out infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.ball-rotate {\n  position: relative;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: relative;\n\n    &:first-child {\n      animation: rotate 1s 0s cubic-bezier(.7,-.13,.22,.86) infinite;\n    }\n\n    &:before, &:after {\n      @include balls();\n\n      content: \"\";\n      position: absolute;\n      opacity: 0.8;\n    }\n\n    &:before {\n      top: 0px;\n      left: -28px;\n    }\n\n    &:after {\n      top: 0px;\n      left: 25px;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    height: 25px;\n    width: 25px;\n    background: transparent !important;\n    display: inline-block;\n    animation: rotate 0.75s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%;\n\n    &:first-child {\n      background: $primary-color;\n      height: 16px;\n      width: 16px;\n      top: 7px;\n      left: -7px;\n      animation: scale 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n    }\n\n    &:last-child {\n      position: absolute;\n      border: 2px solid $primary-color;\n      width: 30px;\n      height: 30px;  \n      left: -16px;\n      top: -2px;\n      background: transparent;\n      border: 2px solid;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation: rotate 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n      animation-duration: 1s;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate-multiple {\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    left: -20px;\n    top: -20px;\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    border-top-color: transparent;\n    border-radius: 100%;\n    height: 35px;\n    width: 35px;\n    animation: rotate 1s 0s ease-in-out infinite;\n\n    &:last-child {\n      display: inline-block;\n      top: -10px;\n      left: -10px;\n      width: 15px;\n      height: 15px;\n      animation-duration: 0.5s;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation-direction: reverse;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n.ball-scale-ripple {\n\n  > div {\n    @include global-animation();\n\n    height: 50px;\n    width: 50px;\n    border-radius: 100%;\n    border: 2px solid $primary-color;;\n    animation: ball-scale-ripple 1s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 50px;\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n@mixin ball-scale-ripple-multiple ($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-ripple-multiple {\n  @include ball-scale-ripple-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: $size;\n    height: $size;\n    border-radius: 100%;\n    border: 2px solid $primary-color;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.ball-beat {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation: ball-beat 0.7s 0s infinite linear;\n\n    &:nth-child(2n-1) {\n      animation-delay: -0.35s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 60px;\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0.0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n@mixin ball-scale-multiple ($n:3, $start:0) {\n  @for $i from 2 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-multiple {\n  @include ball-scale-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    left: -30px;\n    top: 0px;\n    opacity: 0;\n    margin: 0;\n    width: $size;\n    height: $size;\n    animation: ball-scale-multiple 1s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate($amount / 2, -$amount);\n  }\n  66% {\n    transform: translate($amount, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate($amount / 2, $amount);\n  }\n  66% {\n    transform: translate(- $amount / 2, $amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-$amount, 0px);\n  }\n  66% {\n    transform: translate(- $amount / 2, -$amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@mixin ball-triangle-path($n:3) {\n  $animations: ball-triangle-path-1 ball-triangle-path-2 ball-triangle-path-3;\n\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-name: nth($animations, $i);\n      animation-delay: 0;\n      animation-duration: 2s;\n      animation-timing-function: ease-in-out;\n      animation-iteration-count: infinite;\n    }\n  }\n}\n\n.ball-triangle-path {\n  position: relative;\n  @include ball-triangle-path();\n  transform: translate(-$amount / 1.667, -$amount / 1.333);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    border: 1px solid $primary-color;\n\n    &:nth-of-type(1) {\n      top: $amount;\n    }\n\n    &:nth-of-type(2) {\n      left: $amount / 2;\n    }\n\n    &:nth-of-type(3) {\n      top: $amount;\n      left: $amount;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$rise-amount: 30px;\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-$rise-amount);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY($rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1.0);\n  }\n}\n\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY($rise-amount);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-$rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n\n.ball-pulse-rise {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation-duration: 1s;\n    animation-timing-function: cubic-bezier(.15,.46,.9,.6);\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n\n    &:nth-child(2n) {\n      animation-name: ball-pulse-rise-even;\n    }\n\n    &:nth-child(2n-1) {\n      animation-name: ball-pulse-rise-odd;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-beat($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-beat {\n  @include ball-grid-beat();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-beat;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-pulse($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-pulse {\n  @include ball-grid-pulse();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-pulse;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 25px;\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin ball-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-fade-loader 1s delay(0.12s, $n, $i - 1) infinite linear;\n    }\n  }\n}\n\n.ball-spin-fade-loader {\n  @include ball-spin-fade-loader();\n\n  position: relative;\n  top: -10px;\n  left: -10px;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$radius: 45px;\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-spin-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > span:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-loader 2s ($i * 0.9s) infinite linear;\n    }\n  }\n}\n\n.ball-spin-loader {\n  @include ball-spin-loader();\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: green;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  66% {\n    transform: translate($amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag {\n  33% {\n    transform: translate($amount/2, $amount);\n  }\n  66% {\n    transform: translate(-$amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig 0.7s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag 0.7s 0s infinite linear;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  34% {\n    transform: translate($amount/2, -$amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate($amount/2, -$amount);\n  }\n  84% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate($amount/2, $amount);\n  }\n  34% {\n    transform: translate(-$amount/2, $amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-$amount/2, $amount);\n  }\n  84% {\n    transform: translate($amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig-deflect 1.5s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag-deflect 1.5s 0s infinite linear;\n    }\n  }\n}\n\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n@mixin line-scale($n:5) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation: line-scale 1s delay(0.1s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.line-scale {\n  @include line-scale();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    $random: 0.5;\n    transform: scale($random);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@mixin line-scale-party($n:4) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.3) + s;\n    }\n  }\n}\n\n.line-scale-party {\n  @include line-scale-party();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation-name: line-scale-party;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation: line-scale-pulse-out 0.9s delay(0.2s, 3, 0) infinite cubic-bezier(.85,.25,.37,.85);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: delay(0.2s, 3, 1) !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: delay(0.2s, 3, 2) !important;\n    }\n\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1.0);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out-rapid {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    vertical-align: middle;\n    animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(.11,.49,.38,.78);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: -0.25s !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: 0s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 20px;\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin line-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n        transform: rotate(90deg);\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n        transform: rotate(45deg);\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n        transform: rotate(90deg);\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n        transform: rotate(45deg);\n      }\n\n      animation: line-spin-fade-loader 1.2s delay(0.12s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.line-spin-fade-loader {\n  @include line-spin-fade-loader();\n  position: relative;\n  top: -10px;\n  left: -4px;\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    position: absolute;\n    width: 5px;\n    height: 15px;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 20px;\n\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.triangle-skew-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 0;\n    height: 0;\n    border-left: $size solid transparent;\n    border-right: $size solid transparent;\n    border-bottom: $size solid $primary-color;\n    animation: triangle-skew-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.square-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 50px;\n    height: 50px;\n    background: $primary-color;\n    animation: square-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 25px;\n\n@keyframes rotate_pacman_half_up  {\n    0% {\n         transform:rotate(270deg);\n    }\n    50% {\n         transform:rotate(360deg);\n    }\n    100% {\n         transform:rotate(270deg);\n    }\n}\n\n@keyframes rotate_pacman_half_down  {\n    0% {\n         transform:rotate(90deg);\n    }\n    50% {\n         transform:rotate(0deg);\n    }\n    100% {\n         transform:rotate(90deg);\n    }\n}\n\n@mixin pacman_design(){\n    width: 0px;\n    height: 0px;\n    border-right: $size solid transparent;\n    border-top: $size solid $primary-color;\n    border-left: $size solid $primary-color;\n    border-bottom: $size solid $primary-color;\n    border-radius: $size;\n}\n\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-4 * $size, -$size / 4);\n  }\n}\n\n@mixin ball-placement($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i + 2}) {\n      animation: pacman-balls 1s delay(.33s, $n, $i) infinite linear;\n    }\n  }\n}\n\n.pacman {\n  @include ball-placement();\n\n  position: relative;\n\n  > div:first-of-type {\n    @include pacman_design();\n    animation: rotate_pacman_half_up 0.5s 0s infinite;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(2) {\n    @include pacman_design();\n    animation: rotate_pacman_half_down 0.5s 0s infinite;\n    margin-top: -2 * $size;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(3),\n  > div:nth-child(4),\n  > div:nth-child(5),\n  > div:nth-child(6) {\n    @include balls();\n\n    width: 10px;\n    height: 10px;\n\n    position: absolute;\n    transform: translate(0, -$size / 4);\n    top: 25px;\n    left: 70px;\n  }\n}","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n$size: 10px;\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX($amount) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate($amount, $amount) rotate(-180deg);\n  }\n  75% {\n    transform: translateY($amount) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n.cube-transition {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include global-animation();\n\n    width: $size;\n    height: $size;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    background-color: $primary-color;\n    animation: cube-transition 1.6s 0s infinite ease-in-out;\n\n    &:last-child {\n      animation-delay: -0.8s\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 35px;\n$pos: 30%;\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.semi-circle-spin {\n  position: relative;\n  width: $size;\n  height: $size;\n  overflow: hidden;\n\n  > div {\n    position: absolute;\n    border-width: 0px;\n    border-radius: 100%;\n    animation: spin-rotate 0.6s 0s infinite linear;\n    background-image: linear-gradient(transparent 0%, transparent (100% - $pos), $primary-color $pos, $primary-color 100%);\n    width: 100%;\n    height: 100%;\n  }\n}","// Progress Bar\r\n\r\n.progress {\r\n\r\n  .progress-bar {\r\n    &:last-child {\r\n      @include border-end-radius($progress-border-radius);\r\n    }\r\n  }\r\n\r\n  &.progress-bar-sm {\r\n    height: .5rem;\r\n  }\r\n\r\n  &.progress-bar-xs {\r\n    height: .3rem;\r\n  }\r\n\r\n  &.progress-bar-rounded {\r\n    @include border-radius(30px);\r\n  }\r\n\r\n}\r\n\r\n.progress-bar-animated-alt {\r\n  &.progress-bar,\r\n  .progress-bar {\r\n    position: relative;\r\n\r\n    &::after {\r\n      content: '';\r\n      opacity: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      background: $white;\r\n      animation: progress-active 2s ease infinite;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes progress-active {\r\n  0% {\r\n    opacity: .4;\r\n    width: 0\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    width: 100%\r\n  }\r\n}","@use \"sass:math\";\r\n\r\n.vertical-timeline {\r\n  width: 100%;\r\n  position: relative;\r\n  padding: ($spacer * 1.5) 0 ($spacer);\r\n\r\n  &::after {\r\n    content: '';\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 67px;\r\n    height: 100%;\r\n    width: 4px;\r\n    background: $gray-200;\r\n    @include border-radius($border-radius);\r\n  }\r\n}\r\n\r\n.vertical-timeline-element {\r\n  position: relative;\r\n  margin: 0 0 ($spacer);\r\n\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0\r\n  }\r\n}\r\n\r\n.vertical-timeline-element-content {\r\n  position: relative;\r\n  margin-left: 90px;\r\n  font-size: $font-size-xs;\r\n\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  .timeline-title {\r\n    font-size: $font-size-xs;\r\n    text-transform: uppercase;\r\n    margin: 0 0 math.div($spacer, 2);\r\n    padding: 2px 0 0;\r\n    font-weight: bold;\r\n  }\r\n\r\n  p {\r\n    color: $gray-600;\r\n    margin: 0 0 math.div($spacer, 2);\r\n  }\r\n\r\n  .vertical-timeline-element-date {\r\n    display: block;\r\n    position: absolute;\r\n    left: -90px;\r\n    top: 0;\r\n    padding-right: 10px;\r\n    text-align: right;\r\n    color: $gray-500;\r\n    font-size: math.div($font-size-xs, 1.05);\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.vertical-timeline-element-icon {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 60px;\r\n\r\n  .badge-dot-xl {\r\n    box-shadow: 0 0 0 5px $white;\r\n  }\r\n}\r\n\r\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\r\n  background: 0 0;\r\n  box-shadow: none;\r\n\r\n  &::before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.vertical-without-time {\r\n  &::before {\r\n    left: 11px;\r\n  }\r\n\r\n  .vertical-timeline-element-content {\r\n    margin-left: 36px;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    left: 4px;\r\n  }\r\n}\r\n\r\n.vertical-time-icons {\r\n  padding: ($spacer * 2) 0 0;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 14px;\r\n    height: 100%;\r\n    width: 6px;\r\n    background: $gray-200;\r\n    @include border-radius($border-radius);\r\n  }\r\n\r\n  .vertical-timeline-element {\r\n    margin-bottom: $spacer;\r\n  }\r\n\r\n  .vertical-timeline-element-content {\r\n    margin-left: 50px;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    width: 34px;\r\n    height: 34px;\r\n    left: 0;\r\n    top: -7px;\r\n\r\n    .timeline-icon {\r\n      width: 34px;\r\n      height: 34px;\r\n      background: $white;\r\n      @include border-radius(50px);\r\n      border-width: 2px;\r\n      border-style: solid;\r\n      box-shadow: 0 0 0 5px $white;\r\n      text-align: center;\r\n      display: flex;\r\n      align-items: center;\r\n      align-content: center;\r\n\r\n      i {\r\n        display: block;\r\n        font-size: 1.1rem;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      svg {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Simple Dots Timeline\r\n\r\n.vertical-time-simple {\r\n  padding: math.div($spacer, 2) 0;\r\n\r\n  .vertical-timeline-element {\r\n    margin: 0 0 math.div($spacer, 2);\r\n  }\r\n\r\n  .timeline-title {\r\n    font-weight: normal;\r\n    font-size: math.div($font-size-lg, 1.2);\r\n    padding: 0;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    height: 14px;\r\n    width: 14px;\r\n    background: $gray-200;\r\n    position: absolute;\r\n    left: 6px;\r\n    top: 2px;\r\n    display: block;\r\n    @include border-radius(20px);\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      background: $white;\r\n      left: 50%;\r\n      top: 50%;\r\n      margin: -4px 0 0 -4px;\r\n      display: block;\r\n      width: 8px;\r\n      height: 8px;\r\n      @include border-radius(20px);\r\n    }\r\n  }\r\n\r\n  .timeline-title {\r\n    text-transform: none;\r\n  }\r\n}\r\n\r\n@mixin timeline-variant($parent, $color) {\r\n  #{$parent} {\r\n    .vertical-timeline-element-icon {\r\n      background: $color;\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include timeline-variant(\".dot-#{$color}\", $value);\r\n}\r\n\r\n\r\n// Animations\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\r\n  visibility: hidden\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\r\n  visibility: visible;\r\n  animation: cd-bounce-1 .8s\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(.5);\r\n    -moz-transform: scale(.5);\r\n    -ms-transform: scale(.5);\r\n    -o-transform: scale(.5);\r\n    transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2);\r\n    -moz-transform: scale(1.2);\r\n    -ms-transform: scale(1.2);\r\n    -o-transform: scale(1.2);\r\n    transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n    -moz-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -o-transform: scale(1);\r\n    transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\r\n  visibility: hidden\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\r\n  visibility: visible;\r\n  -webkit-animation: cd-bounce-2 .6s;\r\n  -moz-animation: cd-bounce-2 .6s;\r\n  animation: cd-bounce-2 .6s\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\r\n    -webkit-animation: cd-bounce-2-inverse .6s;\r\n    -moz-animation: cd-bounce-2-inverse .6s;\r\n    animation: cd-bounce-2-inverse .6s\r\n  }\r\n\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\r\n    visibility: visible;\r\n    -webkit-animation: cd-bounce-2-inverse .6s;\r\n    -moz-animation: cd-bounce-2-inverse .6s;\r\n    animation: cd-bounce-2-inverse .6s\r\n  }\r\n\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px);\r\n    -moz-transform: translateX(-100px);\r\n    -ms-transform: translateX(-100px);\r\n    -o-transform: translateX(-100px);\r\n    transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px);\r\n    -moz-transform: translateX(20px);\r\n    -ms-transform: translateX(20px);\r\n    -o-transform: translateX(20px);\r\n    transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    -moz-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    -o-transform: translateX(0);\r\n    transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px);\r\n    -moz-transform: translateX(100px);\r\n    -ms-transform: translateX(100px);\r\n    -o-transform: translateX(100px);\r\n    transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px);\r\n    -moz-transform: translateX(-20px);\r\n    -ms-transform: translateX(-20px);\r\n    -o-transform: translateX(-20px);\r\n    transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    -moz-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    -o-transform: translateX(0);\r\n    transform: translateX(0)\r\n  }\r\n\r\n}","// List Group\r\n\r\n@use \"sass:math\";\r\n\r\n.todo-list-wrapper {\r\n  .todo-indicator {\r\n    position: absolute;\r\n    width: 4px;\r\n    height: 60%;\r\n    @include border-radius($border-radius-lg);\r\n    left: math.div($card-spacer-x, 2);\r\n    top: 20%;\r\n    opacity: .6;\r\n    transition: opacity .2s;\r\n  }\r\n\r\n  .list-group-item {\r\n    &:hover {\r\n      .todo-indicator {\r\n        opacity: .9;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control,\r\n  input[checkbox] {\r\n    margin-left: math.div($card-spacer-x, 2);\r\n  }\r\n}\r\n\r\n.list-group-flush + .card-footer {\r\n  border-top: 0;\r\n}\r\n\r\n.rm-list-borders {\r\n  .list-group-item {\r\n    border: 0;\r\n    padding: math.div($card-spacer-y, 1.5) 0;\r\n  }\r\n}\r\n\r\n.rm-list-borders-scroll {\r\n  .list-group-item {\r\n    border: 0;\r\n    padding-right: ($card-spacer-y * 1.5);\r\n  }\r\n}","// Input groups\r\n\r\n.input-group {\r\n  .input-group-prepend {\r\n    div:not([class]) .react-datepicker__input-container,\r\n    & + div .react-datepicker__input-container {\r\n      .form-control {\r\n        @include border-start-radius(0);\r\n        @include border-end-radius($input-border-radius !important);\r\n      }\r\n    }\r\n  }\r\n\r\n  & > div:not([class]) {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n\r\n    & .react-datepicker__input-container {\r\n      .form-control {\r\n        @include border-end-radius(0);\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n.input-group {\r\n  .input-group-prepend {\r\n    & + div {\r\n      position: relative;\r\n      flex: 1 1 auto;\r\n      width: 1%;\r\n    }\r\n  }\r\n\r\n  & > .react-datepicker-wrapper {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n\r\n    & > .react-datepicker__input-container > .form-control {\r\n      @include border-start-radius(0);\r\n    }\r\n  }\r\n}\r\n\r\n// Forms Legend\r\n\r\nlegend {\r\n  font-size: $font-size-base;\r\n  font-weight: bold;\r\n}\r\n\r\n// Headings\r\n\r\n.form-heading {\r\n  font-size: $font-size-lg;\r\n  margin: 0;\r\n  color: $primary;\r\n\r\n  p {\r\n    color: $gray-600;\r\n    padding: 0.3rem 0 0;\r\n    font-size: $font-size-base;\r\n  }\r\n}\r\n\r\n.custom-select {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n}","// Pagination\r\n\r\n@use \"sass:math\";\r\n\r\n.pagination {\r\n  .page-number {\r\n    @extend .page-item;\r\n  }\r\n\r\n  li {\r\n    a {\r\n      position: relative;\r\n      display: block;\r\n      padding: $pagination-padding-y $pagination-padding-x;\r\n      margin-left: -$pagination-border-width;\r\n      // line-height: $pagination-line-height;\r\n      color: $pagination-color;\r\n      background-color: $pagination-bg;\r\n      border: $pagination-border-width solid $pagination-border-color;\r\n\r\n      &:hover {\r\n        z-index: 2;\r\n        color: $pagination-hover-color;\r\n        text-decoration: none;\r\n        background-color: $pagination-hover-bg;\r\n        border-color: $pagination-hover-border-color;\r\n      }\r\n\r\n      &:focus {\r\n        z-index: 2;\r\n        outline: $pagination-focus-outline;\r\n        box-shadow: $pagination-focus-box-shadow;\r\n      }\r\n\r\n      // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\r\n      &:not(:disabled):not(.disabled) {\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    &:first-child {\r\n      a {\r\n        margin-left: 0;\r\n        @include border-start-radius($border-radius);\r\n      }\r\n    }\r\n    &:last-child {\r\n      a {\r\n        @include border-end-radius($border-radius);\r\n      }\r\n    }\r\n\r\n    &.active a {\r\n      z-index: 1;\r\n      color: $pagination-active-color;\r\n      background-color: $pagination-active-bg;\r\n      border-color: $pagination-active-border-color;\r\n\r\n      &:hover {\r\n        color: $pagination-active-color;\r\n      }\r\n    }\r\n\r\n    &.disabled a {\r\n      color: $pagination-disabled-color;\r\n      pointer-events: none;\r\n      // Opinionated: remove the \"hand\" cursor set previously for .page-link\r\n      cursor: auto;\r\n      background-color: $pagination-disabled-bg;\r\n      border-color: $pagination-disabled-border-color;\r\n    }\r\n  }\r\n}\r\n\r\n// Pagination Rounded\r\n\r\n.pagination-rounded {\r\n  li a {\r\n    @include border-radius(50px !important);\r\n    margin: 0 math.div($layout-spacer-x, 5);\r\n  }\r\n}","// Chat\r\n\r\n@use \"sass:math\";\r\n\r\n.chat-box-wrapper {\r\n  display: flex;\r\n  clear: both;\r\n  padding: math.div($layout-spacer-x, 2);\r\n\r\n  & + .chat-box-wrapper {\r\n    padding-top: 0;\r\n  }\r\n\r\n  .chat-box {\r\n    box-shadow: 0 0 0 transparent;\r\n    position: relative;\r\n    opacity: 1;\r\n    background: $dropdown-link-hover-bg;\r\n    border: 0;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    @include border-radius(30px);\r\n    border-top-left-radius: $border-radius;\r\n    flex: 1;\r\n    display: flex;\r\n    max-width: 50%;\r\n    min-width: 100%;\r\n    text-align: left;\r\n\r\n    & + small {\r\n      text-align: left;\r\n      padding: math.div($layout-spacer-x, 3) 0 0;\r\n      margin-left: $layout-spacer-x;\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  &.chat-box-wrapper-right {\r\n    text-align: right;\r\n\r\n    .chat-box {\r\n      @include border-radius(30px);\r\n      border-top-left-radius: 30px;\r\n      border-top-right-radius: $border-radius;\r\n      margin-left: auto;\r\n\r\n      & + small {\r\n        text-align: right;\r\n        margin-right: $layout-spacer-x;\r\n        margin-left: 0;\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n","// Wizard Multi Step\r\n\r\n@use \"sass:math\";\r\n\r\n.forms-wizard {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n  width: 100%;\r\n  display: table;\r\n  table-layout: fixed;\r\n  @include border-radius($border-radius);\r\n\r\n  li {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-size: math.div($font-size-lg, 1.1);\r\n    padding: math.div($layout-spacer-x, 1.5) 0;\r\n    color: $gray-500;\r\n    position: relative;\r\n\r\n    &::after,\r\n    &::before {\r\n      position: absolute;\r\n      height: 4px;\r\n      top: 50%;\r\n      margin-top: -(math.div($layout-spacer-x, 1.5));\r\n      width: 50%;\r\n      content: '';\r\n      background: $gray-300;\r\n      z-index: 5;\r\n      transition: all .2s;\r\n    }\r\n\r\n    &::after {\r\n      left: 50%;\r\n    }\r\n\r\n    &::before {\r\n      left: 0;\r\n    }\r\n\r\n    &:first-child {\r\n      &::before {\r\n        @include border-start-radius(20px);\r\n      }\r\n    }\r\n\r\n    &:last-child {\r\n      &::after {\r\n        @include border-end-radius(20px);\r\n      }\r\n    }\r\n\r\n    em {\r\n      font-style: normal;\r\n      font-size: $h4-font-size;\r\n      background: $gray-400;\r\n      color: $white;\r\n      text-align: center;\r\n      padding: 0;\r\n      width: 40px;\r\n      height: 40px;\r\n      line-height: 40px;\r\n      @include border-radius(50px);\r\n      display: block;\r\n      margin: 0 auto 0.5rem;\r\n      position: relative;\r\n      z-index: 7;\r\n      transition: all .2s;\r\n    }\r\n\r\n    &.form-wizard-step-doing {\r\n      color: $gray-700;\r\n      em {\r\n        background: $primary;\r\n      }\r\n\r\n      &::before {\r\n        background: $primary;\r\n      }\r\n    }\r\n\r\n    &.form-wizard-step-done {\r\n      em {\r\n        font-family: 'Linearicons-Free';\r\n        @extend .lnr-checkmark-circle !optional;\r\n        background: $success;\r\n        overflow: hidden;\r\n        &::before {\r\n          width: 42px;\r\n          height: 42px;\r\n          font-size: 1.2rem;\r\n          line-height: 40px;\r\n          text-align: center;\r\n          display: block;\r\n        }\r\n      }\r\n\r\n      &::after,\r\n      &::before {\r\n        background: $success;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      color: $gray-600;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Form Wizard Alternate\r\n\r\n.forms-wizard-alt {\r\n  .forms-wizard {\r\n    li {\r\n      font-size: $font-size-base;\r\n\r\n      em {\r\n        width: 14px;\r\n        height: 14px;\r\n        line-height: 14px;\r\n        text-indent: -999rem;\r\n        border: $white solid 2px;\r\n        margin: -7px auto 0;\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.forms-wizard-vertical {\r\n  .forms-wizard {\r\n    display: block;\r\n    width: 30%;\r\n    float: left;\r\n    padding: 0 $layout-spacer-x $layout-spacer-x 0;\r\n\r\n    li {\r\n      text-align: left;\r\n      display: flex;\r\n      align-items: center;\r\n      align-content: flex-start;\r\n      padding: math.div($layout-spacer-x, 2);\r\n      margin-bottom: math.div($layout-spacer-x, 3);\r\n      @include border-radius($border-radius-lg);\r\n      transition: all .2s;\r\n\r\n      &::before,\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      em {\r\n        margin: 0 math.div($layout-spacer-x, 2) 0 0;\r\n      }\r\n\r\n      &:hover {\r\n        background: $gray-200;\r\n      }\r\n\r\n      &.form-wizard-step-doing {\r\n        background: $primary;\r\n        color: $white;\r\n\r\n        em {\r\n          background: rgba(255,255,255,.2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-wizard-content {\r\n    width: 70%;\r\n    overflow: auto;\r\n  }\r\n}\r\n@media screen and (min-width: 360px) and (max-width: 812px) {\r\n  .forms-wizard-vertical {\r\n    .forms-wizard {\r\n      display: block;\r\n      width: 50%;\r\n      float: left;\r\n      padding: 0 $layout-spacer-x $layout-spacer-x 0;\r\n  \r\n      li {\r\n        text-align: left;\r\n        display: flex;\r\n        align-items: center;\r\n        align-content: flex-start;\r\n        padding: math.div($layout-spacer-x, 2);\r\n        margin-bottom: math.div($layout-spacer-x, 3);\r\n        @include border-radius($border-radius-lg);\r\n        transition: all .2s;\r\n  \r\n        &::before,\r\n        &::after {\r\n          display: none;\r\n        }\r\n  \r\n        em {\r\n          margin: 0 math.div($layout-spacer-x, 2) 0 0;\r\n        }\r\n  \r\n        &:hover {\r\n          background: $gray-200;\r\n        }\r\n  \r\n        &.form-wizard-step-doing {\r\n          background: $primary;\r\n          color: $white;\r\n  \r\n          em {\r\n            background: rgba(255,255,255,.2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .form-wizard-content {\r\n      width: 50%;\r\n      overflow: auto;\r\n    }\r\n  }\r\n}","// Chart boxes\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$widget-spacer: $spacer;\r\n\r\n%center-elem {\r\n  display: flex;\r\n  align-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.widget-chart {\r\n  text-align: center;\r\n  padding: $widget-spacer;\r\n  position: relative;\r\n\r\n  .progress-sub-label {\r\n    opacity: .8;\r\n    padding: 5px 0 0;\r\n  }\r\n\r\n  .progress-circle-wrapper {\r\n    min-width: 68px;\r\n    margin-right: $widget-spacer;\r\n\r\n    .react-sweet-progress-symbol {\r\n      font-size: $font-size-xs;\r\n    }\r\n  }\r\n\r\n  .widget-chart-content {\r\n    position: relative;\r\n    z-index: 5;\r\n  }\r\n\r\n  .widget-chart-content-lg {\r\n    padding: ($widget-spacer * 2) 0 $widget-spacer  ($widget-spacer * 2);\r\n\r\n    .widget-numbers {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .widget-chart-wrapper {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    opacity: .25;\r\n    z-index: 6;\r\n    @include border-bottom-radius($card-border-radius);\r\n    overflow: hidden;\r\n  }\r\n\r\n  .widget-numbers {\r\n    font-weight: bold;\r\n    font-size: 2.5rem;\r\n    display: block;\r\n    line-height: 1;\r\n    margin: $widget-spacer auto;\r\n\r\n    & + .widget-chart-flex,\r\n    & + .widget-description,\r\n    & + .widget-subheading {\r\n      margin-top: -(math.div($widget-spacer, 2));\r\n    }\r\n  }\r\n\r\n  .widget-subheading {\r\n    margin: -0.5rem 0 0;\r\n    display: block;\r\n    opacity: .6;\r\n\r\n    &:first-child {\r\n      margin-top: 0;\r\n    }\r\n\r\n    & + .widget-numbers {\r\n      margin-top: math.div($widget-spacer, 2);\r\n    }\r\n  }\r\n\r\n  .widget-description {\r\n    margin: $widget-spacer 0 0;\r\n  }\r\n\r\n  &.widget-chart-hover {\r\n    transition: all .2s;\r\n\r\n    &:hover {\r\n      z-index: 15;\r\n      transform: scale(1.15);\r\n      box-shadow: 0 0.46875rem 4.1875rem rgba(shade-color($primary, 50%), .05),\r\n      0 0.9375rem 2.40625rem rgba(shade-color($primary, 50%), .05),\r\n      0 0.25rem 1.3125rem rgba(shade-color($primary, 50%), .06),\r\n      0 0.125rem 1.1875rem rgba(shade-color($primary, 50%), .06);\r\n      cursor: pointer;\r\n      background: $white;\r\n    }\r\n  }\r\n\r\n  .widget-chart-actions {\r\n    position: absolute;\r\n    right: math.div($widget-spacer, 2);\r\n    top: math.div($widget-spacer, 2);\r\n    z-index: 12;\r\n\r\n    .btn-link {\r\n      font-size: 1.1rem;\r\n      padding-top: 0;\r\n      padding-bottom: 0;\r\n      opacity: .6;\r\n    }\r\n  }\r\n\r\n  .widget-progress-wrapper {\r\n    margin-top: $widget-spacer;\r\n\r\n    &.progress-wrapper-bottom {\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 100%;\r\n\r\n      .progress {\r\n        margin: 0 -1px -1px;\r\n      }\r\n\r\n      .progress {\r\n        @include border-top-radius(0);\r\n        @include border-bottom-radius($card-border-radius);\r\n\r\n        .progress-bar {\r\n          border-bottom-left-radius: $card-border-radius;\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  .widget-chart-flex {\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    margin-bottom: $widget-spacer;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    .widget-subheading {\r\n      margin: 0;\r\n    }\r\n\r\n    .widget-description {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  &.text-start {\r\n    flex-direction: row;\r\n    align-items: center;\r\n\r\n    .icon-wrapper {\r\n      min-width: 54px;\r\n      margin: 0 ($widget-spacer) 0 0;\r\n    }\r\n\r\n    .widget-numbers {\r\n      margin-left: 0;\r\n    }\r\n\r\n    .widget-chart-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-content: center;\r\n      flex: 1;\r\n      position: relative;\r\n\r\n      & > .widget-numbers:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      .widget-description {\r\n        align-self: flex-start;\r\n      }\r\n    }\r\n\r\n    .widget-chart-wrapper {\r\n      height: 35%;\r\n    }\r\n  }\r\n\r\n  &.widget-chart-left {\r\n    padding-bottom: 15%;\r\n  }\r\n\r\n  .chart-wrapper-relative {\r\n    position: relative;\r\n    opacity: 1;\r\n    margin-top: ($widget-spacer);\r\n  }\r\n}\r\n\r\n.widget-chart-actions {\r\n  position: absolute;\r\n  right: $widget-spacer;\r\n  top: $widget-spacer;\r\n  z-index: 12;\r\n\r\n  .btn-link {\r\n    font-size: 1.1rem;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    opacity: .6;\r\n  }\r\n}\r\n\r\n.widget-chart,\r\n.widget-content {\r\n  &:hover {\r\n    .widget-chart-actions {\r\n      .btn-link {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.grid-menu {\r\n  .widget-chart {\r\n    &.widget-chart-hover {\r\n      &:hover {\r\n        background: $card-bg;\r\n        @include border-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 54px;\r\n  height: 54px;\r\n  margin: 0 auto;\r\n  @extend %center-elem;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  &[class*=\"border-\"] {\r\n    border-width: 1px;\r\n    border-style: solid;\r\n  }\r\n\r\n  .icon-wrapper-bg {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 3;\r\n    opacity: .2;\r\n\r\n    &.bg-light {\r\n      opacity: .08;\r\n    }\r\n\r\n  }\r\n\r\n  i {\r\n    margin: 0 auto;\r\n    font-size: 1.7rem;\r\n    position: relative;\r\n    z-index: 5;\r\n\r\n    &:before {\r\n      margin-top: -3px;\r\n    }\r\n  }\r\n\r\n  .progress-circle-wrapper {\r\n    width: 100%;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.widget-chart2 {\r\n  .widget-chart-flex {\r\n    display: flex;\r\n    align-items: baseline;\r\n    align-content: center;\r\n    margin-bottom: 0;\r\n\r\n    .widget-subtitle,\r\n    .widget-title {\r\n    }\r\n\r\n    .widget-subtitle {\r\n      margin-left: auto;\r\n    }\r\n\r\n    .widget-numbers {\r\n      font-weight: normal;\r\n    }\r\n\r\n    & + .widget-chart-flex {\r\n      .widget-numbers {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .widget-chat-wrapper-outer {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    max-width: 100%;\r\n\r\n    .widget-chart-wrapper {\r\n      height: 70px;\r\n      opacity: .8;\r\n      position: relative;\r\n      margin: $widget-spacer auto (-(math.div($widget-spacer, 2)));\r\n    }\r\n\r\n    .widget-chart-wrapper-lg {\r\n      height: 130px;\r\n    }\r\n  }\r\n}\r\n\r\n// Widgets with bottom border\r\n\r\n.card-btm-border {\r\n  border-bottom: transparent solid 4px;\r\n}\r\n\r\n// Progress Box\r\n\r\n.progress-box {\r\n  text-align: center;\r\n\r\n  h4 {\r\n    font-size: $font-size-base;\r\n    font-weight: bold;\r\n    opacity: .6;\r\n    text-transform: uppercase;\r\n    padding-bottom: math.div($widget-spacer, 3)\r\n  }\r\n\r\n  svg {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.svg-bg {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: .1;\r\n\r\n  svg {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.widget-numbers-sm {\r\n  font-size: 1.5rem;\r\n}","// Content Boxes\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$widget-spacer: $spacer;\r\n\r\n.widget-content {\r\n  padding: $widget-spacer;\r\n  flex-direction: row;\r\n  align-items: center;\r\n\r\n  .widget-content-wrapper {\r\n    display: flex;\r\n    flex: 1;\r\n    position: relative;\r\n    align-items: center;\r\n  }\r\n\r\n  .widget-content-left {\r\n\r\n    .widget-heading {\r\n      opacity: .8;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .widget-subheading {\r\n      opacity: .5;\r\n    }\r\n  }\r\n\r\n  .widget-content-right {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .widget-numbers {\r\n    font-weight: bold;\r\n    font-size: 1.8rem;\r\n    display: block;\r\n  }\r\n\r\n  .widget-content-outer {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .widget-progress-wrapper {\r\n    margin-top: $widget-spacer;\r\n\r\n    .progress-sub-label {\r\n      margin-top: math.div($widget-spacer, 3);\r\n      opacity: .5;\r\n      display: flex;\r\n      align-content: center;\r\n      align-items: center;\r\n\r\n      .sub-label-left {\r\n\r\n      }\r\n\r\n      .sub-label-right {\r\n        margin-left: auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  .widget-content-right {\r\n    &.widget-content-actions {\r\n      visibility: hidden;\r\n      opacity: 0;\r\n      transition: opacity .2s;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    .widget-content-right {\r\n      &.widget-content-actions {\r\n        visibility: visible;\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Profile Boxes\r\n\r\n@use \"sass:math\";\r\n\r\n.profile-block {\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  .profile-blur {\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(5px);\r\n    transform: scale(1.8);\r\n    position: absolute;\r\n    left: -25%;\r\n    top: -25%;\r\n  }\r\n\r\n  .profile-inner {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: .5;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .dropdown-menu-header {\r\n\r\n    .menu-header-content {\r\n      padding: $layout-spacer-lg;\r\n\r\n      .menu-header-title {\r\n        margin: math.div($layout-spacer-x, 2) 0 0;\r\n      }\r\n\r\n      .menu-header-subtitle {\r\n        margin: math.div($layout-spacer-x, 3) 0 0;\r\n      }\r\n    }\r\n\r\n    .menu-header-btn-pane {\r\n      margin: math.div($layout-spacer-x, 3) 0 0;\r\n\r\n      .btn-icon {\r\n        color: $white;\r\n        padding: 0;\r\n        width: 44px;\r\n        height: 44px;\r\n        line-height: 37px;\r\n        font-size: $font-size-lg;\r\n\r\n        &:hover {\r\n          background: rgba(255, 255, 255, .2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n}","// User Pages\r\n\r\n.app-logo {\r\n  height: $logo-height;\r\n  width: $logo-width;\r\n  background: url('../../assets/utils/images/logo-inverse.png');\r\n}\r\n\r\n.app-logo-inverse {\r\n  height: $logo-height;\r\n  width: $logo-width;\r\n  background: url('../../assets/utils/images/logo.png');\r\n}\r\n\r\n.app-login-box {\r\n  .app-logo {\r\n    margin-bottom: $layout-spacer-lg;\r\n  }\r\n\r\n  h4 {\r\n    margin-bottom: $layout-spacer-x;\r\n    font-weight: normal;\r\n\r\n    div {\r\n      opacity: .6;\r\n    }\r\n\r\n    span {\r\n      font-size: $font-size-lg;\r\n    }\r\n  }\r\n}","// Applications\r\n\r\n@use \"sass:math\";\r\n\r\n$app-layout-sidebar-width         : 270px;\r\n$app-layout-aside-width           : 60px;\r\n$app-layout-header-height         : 50px;\r\n\r\n\r\n\r\n.app-inner-layout {\r\n\r\n  &.rm-sidebar {\r\n    .app-inner-layout__wrapper {\r\n      .app-inner-layout__content {\r\n        width: auto;\r\n        float: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__header {\r\n    width: 100%;\r\n    padding: $layout-spacer-x;\r\n    text-align: left;\r\n\r\n    .app-page-title {\r\n      margin: 0;\r\n      padding: 0;\r\n      background: transparent;\r\n    }\r\n\r\n    border-bottom: $gray-200 solid 1px;\r\n  }\r\n\r\n  .app-inner-layout__header-boxed {\r\n    padding: $layout-spacer-x;\r\n\r\n    .app-inner-layout__header {\r\n      @include border-radius($border-radius-lg);\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    min-height: 100vh;\r\n\r\n    .app-inner-layout__content {\r\n      flex: 1;\r\n      display: flex;\r\n\r\n      &.card {\r\n        box-shadow: 0 0 0 0 transparent;\r\n        border-radius: 0;\r\n        border: 0;\r\n      }\r\n\r\n      .app-inner-layout__top-pane {\r\n        display: flex;\r\n        align-content: center;\r\n        align-items: center;\r\n        text-align: left;\r\n        padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n      }\r\n\r\n      .pane-left {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n\r\n      .pane-right {\r\n        display: flex;\r\n        align-items: center;\r\n        margin-left: auto;\r\n      }\r\n\r\n      .app-inner-layout__bottom-pane {\r\n        padding: $layout-spacer-x;\r\n        border-top: $gray-200 solid 1px;\r\n      }\r\n    }\r\n\r\n    .app-inner-layout__sidebar {\r\n      width: $app-layout-sidebar-width;\r\n      list-style: none;\r\n      text-align: left;\r\n      order: -1;\r\n      flex: 0 0 $app-layout-sidebar-width;\r\n      display: flex;\r\n      margin: 0;\r\n      position: relative;\r\n\r\n      .dropdown-item {\r\n        white-space: normal;\r\n      }\r\n\r\n      &.card {\r\n        box-shadow: 0 0 0 0 transparent;\r\n        border-radius: 0;\r\n        background: $gray-100;\r\n        border: 0;\r\n        border-right: $gray-200 solid 1px;\r\n        border-left: $gray-200 solid 1px;\r\n      }\r\n\r\n      .app-inner-layout__sidebar-footer,\r\n      .app-inner-layout__sidebar-header {\r\n        background: $gray-100;\r\n      }\r\n    }\r\n\r\n    .app-inner-layout__aside {\r\n      width: $app-layout-aside-width;\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__footer {\r\n    width: 100%;\r\n    height: $app-layout-header-height;\r\n  }\r\n}\r\n\r\n.app-wrapper-footer {\r\n  .app-footer {\r\n    border-top: $gray-200 solid 1px;\r\n\r\n    .app-footer__inner {\r\n      border-left: $gray-200 solid 1px;\r\n    }\r\n  }\r\n}\r\n\r\n// Components\r\n\r\n@import \"chat\";\r\n\r\n// Responsive\r\n\r\n.mobile-app-menu-btn {\r\n  display: none;\r\n  margin: 3px $layout-spacer-x 0 0;\r\n}\r\n\r\n@import \"responsive\";","// Chat\r\n$app-layout-chat-sidebar-width: 360px;\r\n\r\n.chat-layout {\r\n  &.app-inner-layout {\r\n    .app-inner-layout__sidebar {\r\n      width: $app-layout-chat-sidebar-width;\r\n      flex: 0 0 $app-layout-chat-sidebar-width;\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__top-pane h4 {\r\n    font-size: $h5-font-size;\r\n\r\n    div {\r\n      font-size: $font-size-base;\r\n    }\r\n  }\r\n\r\n  .chat-box-wrapper {\r\n    padding: $layout-spacer-x;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n  .chat-layout {\r\n    &.app-inner-layout {\r\n      .app-inner-layout__sidebar {\r\n        .widget-content .widget-content-left .widget-subheading {\r\n          white-space: normal;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","// Responsive Applications\r\n\r\n@include media-breakpoint-down(md) {\r\n  .app-inner-layout__sidebar {\r\n    display: none !important;\r\n  }\r\n\r\n  .mobile-app-menu-btn {\r\n    display: block;\r\n  }\r\n\r\n  .open-mobile-menu {\r\n\r\n    .app-inner-layout__sidebar {\r\n      display: block !important;\r\n    }\r\n  }\r\n}","/*\r\n * Container style\r\n */\r\n.ps {\r\n  overflow: hidden !important;\r\n  overflow-anchor: none;\r\n  touch-action: auto;\r\n}\r\n\r\n/*\r\n * Scrollbar rail styles\r\n */\r\n.ps__rail-x {\r\n  display: none !important;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  height: 15px;\r\n  /* there must be 'bottom' or 'top' for ps__rail-x */\r\n  bottom: 0;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n  z-index: 7;\r\n}\r\n\r\n.ps__rail-y {\r\n  display: none;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  width: 15px;\r\n  /* there must be 'right' or 'left' for ps__rail-y */\r\n  right: 0;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n  @include border-radius(50px);\r\n  z-index: 7;\r\n}\r\n\r\n.ps--active-x > .ps__rail-x,\r\n.ps--active-y > .ps__rail-y {\r\n  display: block;\r\n  background-color: transparent;\r\n}\r\n\r\n.ps:hover > .ps__rail-x,\r\n.ps:hover > .ps__rail-y,\r\n.ps--focus > .ps__rail-x,\r\n.ps--focus > .ps__rail-y,\r\n.ps--scrolling-x > .ps__rail-x,\r\n.ps--scrolling-y > .ps__rail-y {\r\n  opacity: 0.6;\r\n}\r\n\r\n.ps__rail-x:hover,\r\n.ps__rail-y:hover,\r\n.ps__rail-x:focus,\r\n.ps__rail-y:focus {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  opacity: 0.9;\r\n}\r\n\r\n/*\r\n * Scrollbar thumb styles\r\n */\r\n.ps__thumb-x {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, height .2s ease-in-out;\r\n  height: 6px;\r\n  /* there must be 'bottom' for ps__thumb-x */\r\n  bottom: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__thumb-y {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, width .2s ease-in-out;\r\n  width: 6px;\r\n  /* there must be 'right' for ps__thumb-y */\r\n  right: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__rail-x:hover > .ps__thumb-x,\r\n.ps__rail-x:focus > .ps__thumb-x {\r\n  background-color: rgba(0, 0, 0, .12);\r\n  height: 11px;\r\n}\r\n\r\n.ps__rail-y:hover > .ps__thumb-y,\r\n.ps__rail-y:focus > .ps__thumb-y {\r\n  background-color: rgba(0, 0, 0, .12);\r\n  width: 11px;\r\n}\r\n\r\n/* MS supports */\r\n@supports (-ms-overflow-style: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n\r\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n\r\n.scrollbar-container {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n// Scroll Areas\r\n\r\n.scroll-area {\r\n  overflow-x: hidden;\r\n  height: 400px;\r\n}\r\n\r\n.scroll-area-xs {\r\n  height: 150px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-sm {\r\n  height: 200px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-md {\r\n  height: 300px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-lg {\r\n  height: 400px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-x {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.shadow-overflow {\r\n  position: relative;\r\n\r\n  &::after,\r\n  &::before {\r\n    width: 100%;\r\n    bottom: auto;\r\n    top: 0;\r\n    left: 0;\r\n    height: $layout-spacer-x;\r\n    position: absolute;\r\n    z-index: 10;\r\n    content: '';\r\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\r\n  }\r\n\r\n  &::after {\r\n    bottom: 0;\r\n    top: auto;\r\n\r\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\r\n  }\r\n\r\n}","\r\n@use \"sass:math\";\r\n\r\n.rc-tabs {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-bar,\r\n.rc-tabs-nav-container {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  position: relative;\r\n  white-space: nowrap;\r\n  outline: none;\r\n  zoom: 1;\r\n  transition: padding .45s;\r\n}\r\n\r\n.rc-tabs-ink-bar {\r\n  margin-top: 0;\r\n  @include border-radius($border-radius);\r\n  box-shadow:\r\n          0 16px 26px -10px rgba($primary, 0.56),\r\n          0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n          0 8px 10px -5px rgba($primary, 0.2);\r\n}\r\n\r\n.rc-tabs-ink-bar-animated {\r\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\r\n}\r\n\r\n.rc-tabs-tab-prev,\r\n.rc-tabs-tab-next {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  z-index: 1;\r\n  line-height: 36px;\r\n  cursor: pointer;\r\n  border: none;\r\n  background-color: transparent;\r\n  position: absolute;\r\n}\r\n\r\n.rc-tabs-tab-prev-icon,\r\n.rc-tabs-tab-next-icon {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  line-height: inherit;\r\n  vertical-align: baseline;\r\n  text-align: center;\r\n  text-transform: none;\r\n  font-smoothing: antialiased;\r\n  text-stroke-width: 0;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.rc-tabs-tab-prev-icon:before,\r\n.rc-tabs-tab-next-icon:before {\r\n  display: block;\r\n}\r\n\r\n.rc-tabs-tab-btn-disabled {\r\n  cursor: default;\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-nav-wrap {\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-nav {\r\n  box-sizing: border-box;\r\n  padding-left: 0;\r\n  position: relative;\r\n  margin: 0;\r\n  float: left;\r\n  list-style: none;\r\n  display: inline-block;\r\n  transform-origin: 0 0;\r\n\r\n  & > div:first-child {\r\n    z-index: 5;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.rc-tabs-nav-animated {\r\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\r\n}\r\n\r\n.rc-tabs-nav:before,\r\n.rc-tabs-nav:after {\r\n  display: table;\r\n  content: \" \";\r\n}\r\n\r\n.rc-tabs-nav:after {\r\n  clear: both;\r\n}\r\n\r\n.rc-tabs-tab {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: block;\r\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\r\n  padding: 8px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.rc-tabs-tab:hover {\r\n  color: $primary;\r\n}\r\n\r\n.rc-tabs-tab-active,\r\n.rc-tabs-tab-active:hover {\r\n  color: $white;\r\n  cursor: default;\r\n  transform: translateZ(0);\r\n}\r\n\r\n.rc-tabs-tab-disabled {\r\n  cursor: default;\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-tab-disabled:hover {\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-content {\r\n  zoom: 1;\r\n}\r\n\r\n.rc-tabs-content .rc-tabs-tabpane {\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-content-animated {\r\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  will-change: transform;\r\n}\r\n\r\n.rc-tabs-content-animated .rc-tabs-tabpane {\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.no-flexbox .rc-tabs-content {\r\n  transform: none !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.no-csstransitions .rc-tabs-tabpane-inactive,\r\n.no-flexbox .rc-tabs-tabpane-inactive,\r\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\r\n  display: none;\r\n}\r\n\r\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 35px;\r\n}\r\n\r\n\r\n.rc-tabs-top .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 35px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content {\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\r\n  padding-left: 35px;\r\n  padding-right: 35px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-scroll {\r\n  width: 99999px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe {\r\n  position: relative;\r\n  left: 0;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n  margin-right: 0;\r\n  padding: 8px 0;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-wrap {\r\n  width: 100%;\r\n  padding: $layout-spacer-x math.div($grid-gutter-width, 2);\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content-animated {\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-next {\r\n  right: 2px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\r\n  content: \">\";\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev {\r\n  left: 0;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\r\n  content: \"<\";\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev,\r\n.rc-tabs-top .rc-tabs-tab-next {\r\n  margin-right: -2px;\r\n  width: 0;\r\n  height: 0;\r\n  top: 0;\r\n  text-align: center;\r\n  opacity: 0;\r\n  transition: width .3s, height .3s, opacity .3s;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 35px;\r\n  height: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-ink-bar {\r\n  height: 35px;\r\n  bottom: 0;\r\n  left: 0;\r\n  background: $primary;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab {\r\n  float: left;\r\n  height: 100%;\r\n  line-height: 1.3;\r\n  margin-right: math.div($layout-spacer-x, 2);\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tabpane-inactive {\r\n  height: 0;\r\n  overflow: visible;\r\n}\r\n","/*!\r\n * Ladda\r\n * http://lab.hakim.se/ladda\r\n * MIT licensed\r\n *\r\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\r\n */\r\n\r\n\r\n/*************************************\r\n * CONFIG\r\n */\r\n\r\n@use \"sass:math\";\r\n\r\n$spinnerSize: 32px !default;\r\n\r\n\r\n/*************************************\r\n * MIXINS\r\n */\r\n\r\n@mixin transition( $value ) {\r\n  transition: $value !important;\r\n}\r\n\r\n@mixin transform( $value ) {\r\n  transform: $value;\r\n}\r\n\r\n/*************************************\r\n * Opacity animation for spin.js\r\n */\r\n\r\n@keyframes ladda-spinner-line-fade {\r\n  0%, 100% {\r\n    opacity: 0.22; /* minimum opacity */\r\n  }\r\n  1% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * BUTTON BASE\r\n */\r\n\r\n.ladda-button {\r\n  position: relative;\r\n}\r\n\r\n\r\n/* Spinner animation */\r\n.ladda-button .ladda-spinner {\r\n  position: absolute;\r\n  z-index: 2;\r\n  display: inline-block;\r\n  width: $spinnerSize;\r\n  top: 50%;\r\n  margin-top: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Button label */\r\n.ladda-button .ladda-label {\r\n  position: relative;\r\n  z-index: 3;\r\n}\r\n\r\n[class*=\"btn-outline-\"] {\r\n  .ladda-spinner div div div {\r\n    background: $black !important;\r\n  }\r\n\r\n  &.ladda-button .ladda-label {\r\n    transition: none !important;\r\n  }\r\n}\r\n\r\n/* Progress bar */\r\n.ladda-button .ladda-progress {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  background: rgba( 0, 0, 0, 0.2 );\r\n  display: none;\r\n\r\n  @include transition( 0.1s linear all );\r\n}\r\n.ladda-button[data-loading] .ladda-progress {\r\n  display: block;\r\n}\r\n\r\n\r\n/*************************************\r\n * EASING\r\n */\r\n\r\n.ladda-button,\r\n.ladda-button .ladda-spinner,\r\n.ladda-button .ladda-label {\r\n  @include transition( 0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275) all );\r\n}\r\n\r\n.ladda-button[data-style=zoom-in],\r\n.ladda-button[data-style=zoom-in] .ladda-spinner,\r\n.ladda-button[data-style=zoom-in] .ladda-label,\r\n.ladda-button[data-style=zoom-out],\r\n.ladda-button[data-style=zoom-out] .ladda-spinner,\r\n.ladda-button[data-style=zoom-out] .ladda-label {\r\n  @include transition( 0.3s ease all );\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND RIGHT\r\n */\r\n\r\n.ladda-button[data-style=expand-right] {\r\n  .ladda-spinner {\r\n    right: math.div($spinnerSize, -2) + 10;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    right: math.div($spinnerSize, -2) + 4;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-right: 56px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-right: 40px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND LEFT\r\n */\r\n\r\n.ladda-button[data-style=expand-left] {\r\n  .ladda-spinner {\r\n    left: math.div($spinnerSize, 2) + 10;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    left: 4px;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-left: 56px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-left: 40px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND UP\r\n */\r\n\r\n.ladda-button[data-style=expand-up] {\r\n  overflow: hidden;\r\n\r\n  .ladda-spinner {\r\n    top: -$spinnerSize;\r\n    left: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-top: 54px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      top: math.div($spinnerSize, 2) + 10;\r\n      margin-top: 0;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-top: 32px;\r\n\r\n      .ladda-spinner {\r\n        top: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND DOWN\r\n */\r\n\r\n.ladda-button[data-style=expand-down] {\r\n  overflow: hidden;\r\n\r\n  .ladda-spinner {\r\n    top: 52px;\r\n    left: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    top: 40px;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-bottom: 54px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-bottom: 32px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE LEFT\r\n */\r\n.ladda-button[data-style=slide-left] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      left: -100%;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      left: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE RIGHT\r\n */\r\n.ladda-button[data-style=slide-right] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    right: 100%;\r\n    margin-left: 0;\r\n    left: math.div($spinnerSize, 2);\r\n\r\n    [dir=\"rtl\"] & {\r\n      right: auto;\r\n    }\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      left: 100%;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      left: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE UP\r\n */\r\n.ladda-button[data-style=slide-up] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 50%;\r\n    margin-left: 0;\r\n    margin-top: 1em;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      top: -1em;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE DOWN\r\n */\r\n.ladda-button[data-style=slide-down] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 50%;\r\n    margin-left: 0;\r\n    margin-top: -2em;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      top: 1em;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * ZOOM-OUT\r\n */\r\n\r\n.ladda-button[data-style=zoom-out] {\r\n  overflow: hidden;\r\n}\r\n.ladda-button[data-style=zoom-out] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: $spinnerSize;\r\n\r\n  @include transform( scale( 2.5 ) );\r\n}\r\n.ladda-button[data-style=zoom-out] .ladda-label {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\r\n  opacity: 0;\r\n\r\n  @include transform( scale( 0.5 ) );\r\n}\r\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n  margin-left: 0;\r\n\r\n  @include transform( none );\r\n}\r\n\r\n\r\n/*************************************\r\n * ZOOM-IN\r\n */\r\n\r\n.ladda-button[data-style=zoom-in] {\r\n  overflow: hidden;\r\n}\r\n.ladda-button[data-style=zoom-in] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: math.div($spinnerSize, -2);\r\n\r\n  @include transform( scale( 0.2 ) );\r\n}\r\n.ladda-button[data-style=zoom-in] .ladda-label {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\r\n  opacity: 0;\r\n\r\n  @include transform( scale( 2.2 ) );\r\n}\r\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n  margin-left: 0;\r\n\r\n  @include transform( none );\r\n}\r\n\r\n\r\n/*************************************\r\n * CONTRACT\r\n */\r\n\r\n.ladda-button[data-style=contract] {\r\n  overflow: hidden;\r\n  width: 100px;\r\n}\r\n.ladda-button[data-style=contract] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: 0;\r\n}\r\n\r\n.ladda-button[data-style=contract][data-loading] {\r\n  border-radius: 50%;\r\n  width: 52px;\r\n}\r\n.ladda-button[data-style=contract][data-loading] .ladda-label {\r\n  opacity: 0;\r\n}\r\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n\r\n/*************************************\r\n * OVERLAY\r\n */\r\n\r\n.ladda-button[data-style=contract-overlay] {\r\n  overflow: hidden;\r\n  width: 100px;\r\n\r\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0);\r\n}\r\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: 0;\r\n}\r\n\r\n.ladda-button[data-style=contract-overlay][data-loading] {\r\n  border-radius: 50%;\r\n  width: 52px;\r\n\r\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\r\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0.8);\r\n}\r\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\r\n  opacity: 0;\r\n}\r\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n[dir=\"rtl\"] .ladda-spinner > div {\r\n  left: 25% !important;\r\n}","@charset \"UTF-8\";\r\n/*!\r\n * Hamburgers\r\n * @description Tasty CSS-animated hamburgers\r\n * @author Jonathan Suh @jonsuh\r\n * @site https://jonsuh.com/hamburgers\r\n * @link https://github.com/jonsuh/hamburgers\r\n */\r\n\r\n// Settings\r\n// ==================================================\r\n$hamburger-padding-x           : 0px !default;\r\n$hamburger-padding-y           : 0px !default;\r\n$hamburger-layer-width         : 24px !default;\r\n$hamburger-layer-height        : 2px !default;\r\n$hamburger-layer-spacing       : 4px !default;\r\n$hamburger-layer-color         : $primary !default;\r\n$hamburger-layer-border-radius : 10px !default;\r\n$hamburger-hover-opacity       : 0.7 !default;\r\n$hamburger-active-layer-color  : $hamburger-layer-color !default;\r\n$hamburger-active-hover-opacity: $hamburger-hover-opacity !default;\r\n\r\n// To use CSS filters as the hover effect instead of opacity,\r\n// set $hamburger-hover-use-filter as true and\r\n// change the value of $hamburger-hover-filter accordingly.\r\n$hamburger-hover-use-filter   : false !default;\r\n$hamburger-hover-filter       : opacity(50%) !default;\r\n$hamburger-active-hover-filter: $hamburger-hover-filter !default;\r\n\r\n// Types (Remove or comment out what you don’t need)\r\n// ==================================================\r\n$hamburger-types: (\r\n  //3dx,\r\n  //3dx-r,\r\n  //3dy,\r\n  //3dy-r,\r\n  //3dxy,\r\n  //3dxy-r,\r\n  //arrow,\r\n  //arrow-r,\r\n  //arrowalt,\r\n  //arrowalt-r,\r\n  //arrowturn,\r\n  //arrowturn-r,\r\n  //boring,\r\n  //collapse,\r\n  //collapse-r,\r\n  elastic,\r\n  //elastic-r,\r\n  //emphatic,\r\n  //emphatic-r,\r\n  //minus,\r\n  //slider,\r\n  //slider-r,\r\n  //spin,\r\n  //spin-r,\r\n  //spring,\r\n  //spring-r,\r\n  //stand,\r\n  //stand-r,\r\n  //squeeze,\r\n  //vortex,\r\n  //vortex-r\r\n) !default;\r\n\r\n// Base Hamburger (We need this)\r\n// ==================================================\r\n@import \"base\";\r\n\r\n// Hamburger types\r\n// ==================================================\r\n@import \"types/3dx\";\r\n@import \"types/3dx-r\";\r\n@import \"types/3dy\";\r\n@import \"types/3dy-r\";\r\n@import \"types/3dxy\";\r\n@import \"types/3dxy-r\";\r\n@import \"types/arrow\";\r\n@import \"types/arrow-r\";\r\n@import \"types/arrowalt\";\r\n@import \"types/arrowalt-r\";\r\n@import \"types/arrowturn\";\r\n@import \"types/arrowturn-r\";\r\n@import \"types/boring\";\r\n@import \"types/collapse\";\r\n@import \"types/collapse-r\";\r\n@import \"types/elastic\";\r\n@import \"types/elastic-r\";\r\n@import \"types/emphatic\";\r\n@import \"types/emphatic-r\";\r\n@import \"types/minus\";\r\n@import \"types/slider\";\r\n@import \"types/slider-r\";\r\n@import \"types/spin\";\r\n@import \"types/spin-r\";\r\n@import \"types/spring\";\r\n@import \"types/spring-r\";\r\n@import \"types/stand\";\r\n@import \"types/stand-r\";\r\n@import \"types/squeeze\";\r\n@import \"types/vortex\";\r\n@import \"types/vortex-r\";\r\n\r\n// ==================================================\r\n// Cooking up additional types:\r\n//\r\n// The Sass for each hamburger type should be nested\r\n// inside an @if directive to check whether or not\r\n// it exists in $hamburger-types so only the CSS for\r\n// included types are generated.\r\n//\r\n// e.g. hamburgers/types/_new-type.scss\r\n//\r\n// @if index($hamburger-types, new-type) {\r\n//   .hamburger--new-type {\r\n//     ...\r\n//   }\r\n// }\r\n","// Hamburger\r\n// ==================================================\r\n@use \"sass:math\";\r\n\r\n.hamburger {\r\n  padding: $hamburger-padding-y $hamburger-padding-x;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n\r\n  transition-property: opacity, filter;\r\n  transition-duration: 0.15s;\r\n  transition-timing-function: linear;\r\n\r\n  // Normalize (<button>)\r\n  font: inherit;\r\n  color: inherit;\r\n  text-transform: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n  margin: 0;\r\n  overflow: visible;\r\n\r\n  &:hover {\r\n    @if $hamburger-hover-use-filter == true {\r\n      filter: $hamburger-hover-filter;\r\n    }\r\n    @else {\r\n      opacity: $hamburger-hover-opacity;\r\n    }\r\n  }\r\n\r\n  &.is-active {\r\n    &:hover {\r\n      @if $hamburger-hover-use-filter == true {\r\n        filter: $hamburger-active-hover-filter;\r\n      }\r\n      @else {\r\n        opacity: $hamburger-active-hover-opacity;\r\n      }\r\n    }\r\n\r\n    .hamburger-inner,\r\n    .hamburger-inner::before,\r\n    .hamburger-inner::after {\r\n      background-color: $hamburger-active-layer-color;\r\n    }\r\n  }\r\n}\r\n\r\n.hamburger-box {\r\n  width: $hamburger-layer-width;\r\n  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.hamburger-inner {\r\n  display: block;\r\n  top: 50%;\r\n  margin-top: math.div($hamburger-layer-height, -2);\r\n\r\n  &,\r\n  &::before,\r\n  &::after {\r\n    width: $hamburger-layer-width;\r\n    height: $hamburger-layer-height;\r\n    background-color: $hamburger-layer-color;\r\n    border-radius: $hamburger-layer-border-radius;\r\n    position: absolute;\r\n    transition-property: transform;\r\n    transition-duration: 0.15s;\r\n    transition-timing-function: ease;\r\n  }\r\n\r\n  &::before,\r\n  &::after {\r\n    content: \"\";\r\n    display: block;\r\n  }\r\n\r\n  &::before {\r\n    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\r\n  }\r\n\r\n  &::after {\r\n    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\r\n  }\r\n}\r\n","@use \"sass:math\";\r\n\r\n@if index($hamburger-types, elastic) {\r\n  /*\r\n   * Elastic\r\n   */\r\n  .hamburger--elastic {\r\n    .hamburger-inner {\r\n      top: math.div($hamburger-layer-height, 2);\r\n      transition-duration: 0.275s;\r\n      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n\r\n      &::before {\r\n        top: $hamburger-layer-height + $hamburger-layer-spacing;\r\n        transition: opacity 0.125s 0.275s ease;\r\n      }\r\n\r\n      &::after {\r\n        top: ($hamburger-layer-height * 2) + ($hamburger-layer-spacing * 2);\r\n        transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n      }\r\n    }\r\n\r\n    &.is-active {\r\n      .hamburger-inner {\r\n        $y-offset: $hamburger-layer-spacing + $hamburger-layer-height;\r\n\r\n        transform: translate3d(0, $y-offset, 0) rotate(135deg);\r\n        transition-delay: 0.075s;\r\n\r\n        &::before {\r\n          transition-delay: 0s;\r\n          opacity: 0;\r\n        }\r\n\r\n        &::after {\r\n          transform: translate3d(0, $y-offset * -2, 0) rotate(-270deg);\r\n          transition-delay: 0.075s;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Drawers\r\n\r\n@use \"sass:math\";\r\n\r\n.drawer-content-wrapper {\r\n  background: $white;\r\n  position: relative;\r\n  padding: $layout-spacer-x;\r\n\r\n  .drawer-heading {\r\n    font-size: $font-size-sm;\r\n    color: $body-color;\r\n    margin: 0;\r\n    background: $gray-100;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    border-bottom: $gray-300 solid 1px;\r\n    border-top: $gray-300 solid 1px;\r\n\r\n    &:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  .drawer-section {\r\n    padding: $layout-spacer-x;\r\n  }\r\n\r\n  & > .app-sidebar__heading:first-child {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.drawer-nav-btn {\r\n  @include border-radius(30px);\r\n  background: $white;\r\n  position: fixed;\r\n  right: math.div($layout-spacer-x, 2);\r\n  top: math.div($layout-spacer-x, 2);\r\n  padding: math.div($layout-spacer-x, 3);\r\n  box-shadow: $box-shadow-sm;\r\n  z-index: 20;\r\n\r\n  .hamburger {\r\n    margin-top: 4px;\r\n  }\r\n}","// @use \"sass:math\";\r\n\r\n// body.stop-scrolling {\r\n//   height: 100%;\r\n//   overflow: hidden;\r\n// }\r\n\r\n// .sweet-overlay {\r\n//   position: fixed;\r\n//   top: 0;\r\n//   right: 0;\r\n//   bottom: 0;\r\n//   left: 0;\r\n//   z-index: $zindex-modal-backdrop;\r\n//   background-color: $modal-backdrop-bg;\r\n//   opacity: $modal-backdrop-opacity !important;\r\n// }\r\n\r\n// .sweet-alert {\r\n//   background-color: $white;\r\n//   width: 30%;\r\n//   padding: $spacer;\r\n//   @include border-radius($border-radius);\r\n//   text-align: center;\r\n//   position: fixed;\r\n//   left: 50%;\r\n//   top: 50%;\r\n//   margin-left: -15%;\r\n//   margin-top: -15%;\r\n//   overflow: hidden;\r\n//   display: none;\r\n//   z-index: 99999;\r\n//   box-shadow: $box-shadow-lg-default;\r\n\r\n//   h2 {\r\n//     color: $gray-700;\r\n//     text-align: center;\r\n//     text-transform: none;\r\n//     position: relative;\r\n//     margin: math.div($spacer-sm, 2) 0;\r\n//     padding: 0;\r\n//     display: block;\r\n//   }\r\n\r\n//   p {\r\n//     color: $gray-500;\r\n//     text-align: center;\r\n//     position: relative;\r\n//     float: none;\r\n//     margin: 0;\r\n//     padding: 0;\r\n//   }\r\n\r\n//   fieldset {\r\n//     border: none;\r\n//     position: relative;\r\n//   }\r\n\r\n//   .sa-error-container {\r\n//     background-color: $gray-100;\r\n//     margin-left: -17px;\r\n//     margin-right: -17px;\r\n//     overflow: hidden;\r\n//     padding: 0 10px;\r\n//     max-height: 0;\r\n//     transition: padding 0.15s, max-height 0.15s;\r\n\r\n//     &.show {\r\n//       padding: 10px 0;\r\n//       max-height: 100px;\r\n//       transition: padding 0.25s, max-height 0.25s;\r\n//     }\r\n\r\n//     .icon {\r\n//       display: inline-block;\r\n//       width: 24px;\r\n//       height: 24px;\r\n//       border-radius: 50%;\r\n//       background-color: $danger;\r\n//       color: $white;\r\n//       line-height: 24px;\r\n//       text-align: center;\r\n//       margin-right: 3px;\r\n//     }\r\n\r\n//     p {\r\n//       display: inline-block;\r\n//     }\r\n//   }\r\n\r\n//   .sa-input-error {\r\n//     position: absolute;\r\n//     top: 29px;\r\n//     right: 26px;\r\n//     width: 20px;\r\n//     height: 20px;\r\n//     opacity: 0;\r\n//     -webkit-transform: scale(0.5);\r\n//     transform: scale(0.5);\r\n//     -webkit-transform-origin: 50% 50%;\r\n//     transform-origin: 50% 50%;\r\n//     -webkit-transition: all 0.1s;\r\n//     transition: all 0.1s;\r\n\r\n//     &::before, &::after {\r\n//       content: \"\";\r\n//       width: 20px;\r\n//       height: 6px;\r\n//       background-color: $danger;\r\n//       border-radius: 3px;\r\n//       position: absolute;\r\n//       top: 50%;\r\n//       margin-top: -4px;\r\n//       left: 50%;\r\n//       margin-left: -9px;\r\n//     }\r\n\r\n//     &::before {\r\n//       -webkit-transform: rotate(-45deg);\r\n//       transform: rotate(-45deg);\r\n//     }\r\n\r\n//     &::after {\r\n//       -webkit-transform: rotate(45deg);\r\n//       transform: rotate(45deg);\r\n//     }\r\n\r\n//     &.show {\r\n//       opacity: 1;\r\n//       -webkit-transform: scale(1);\r\n//       transform: scale(1);\r\n//     }\r\n//   }\r\n\r\n//   input {\r\n//     width: 100%;\r\n//     box-sizing: border-box;\r\n//     border-radius: 3px;\r\n//     border: 1px solid #d7d7d7;\r\n//     height: 43px;\r\n//     margin-top: 10px;\r\n//     margin-bottom: 17px;\r\n//     font-size: 18px;\r\n//     box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\r\n//     padding: 0 12px;\r\n//     display: none;\r\n//     -webkit-transition: all 0.3s;\r\n//     transition: all 0.3s;\r\n//   }\r\n\r\n//   input:focus {\r\n//     outline: none;\r\n//     box-shadow: 0 0 3px #c4e6f5;\r\n//     border: 1px solid #b4dbed;\r\n//   }\r\n\r\n//   .sweet-alert.show-input input {\r\n//     display: block;\r\n//   }\r\n\r\n//   .sa-confirm-button-container {\r\n//     display: inline-block;\r\n//     position: relative;\r\n//   }\r\n\r\n//   .la-ball-fall {\r\n//     position: absolute;\r\n//     left: 50%;\r\n//     top: 50%;\r\n//     margin-left: -27px;\r\n//     margin-top: 4px;\r\n//     opacity: 0;\r\n//     visibility: hidden;\r\n//   }\r\n\r\n//   button {\r\n//     display: inline-block;\r\n//     font-weight: $btn-font-weight;\r\n//     text-align: center;\r\n//     white-space: nowrap;\r\n//     font-size: $font-size-base;\r\n//     vertical-align: middle;\r\n//     user-select: none;\r\n//     border: $btn-border-width solid transparent;\r\n//     @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-border-radius);\r\n//     @include transition($btn-transition);\r\n//     @include button-variant($primary, $primary);\r\n\r\n//     // Share hover and focus styles\r\n//     // @include hover-focus {\r\n//     //   text-decoration: none;\r\n//     // }\r\n\r\n//     &:focus,\r\n//     &.focus {\r\n//       outline: 0;\r\n//       box-shadow: $btn-focus-box-shadow;\r\n//     }\r\n\r\n//     // Disabled comes first so active can properly restyle\r\n//     &.disabled,\r\n//     &:disabled {\r\n//       opacity: $btn-disabled-opacity;\r\n//       @include box-shadow(none);\r\n//     }\r\n//   }\r\n\r\n//   button.cancel {\r\n//     font-weight: $font-weight-normal;\r\n//     color: $link-color;\r\n//     background-color: transparent;\r\n//     border-color: transparent;\r\n//     margin-right: 0.5rem;\r\n\r\n//     // @include hover {\r\n//     //   color: $link-hover-color;\r\n//     //   text-decoration: $link-hover-decoration;\r\n//     //   background-color: transparent;\r\n//     //   border-color: transparent;\r\n//     // }\r\n\r\n//     &:active,\r\n//     &.active,\r\n//     &:focus,\r\n//     &.focus {\r\n//       text-decoration: none;\r\n//       border-color: transparent;\r\n//       box-shadow: none;\r\n//       background-color: transparent;\r\n//     }\r\n\r\n//     &:disabled,\r\n//     &.disabled {\r\n//       color: $btn-link-disabled-color;\r\n//       pointer-events: none;\r\n//     }\r\n//   }\r\n\r\n//   button.confirm[disabled] ~ .la-ball-fall {\r\n//     opacity: 1;\r\n//     visibility: visible;\r\n//     transition-delay: 0s;\r\n//   }\r\n\r\n//   &[data-has-cancel-button=false] button {\r\n//     box-shadow: none !important;\r\n//   }\r\n\r\n//   &[data-has-confirm-button=false][data-has-cancel-button=false] {\r\n//     padding-bottom: 40px;\r\n//   }\r\n\r\n//   .sa-button-container {\r\n//     padding: $spacer 0 0;\r\n//   }\r\n\r\n// }\r\n\r\n.sa-icon {\r\n  width: 80px;\r\n  height: 80px;\r\n  border: 4px solid $gray-300;\r\n  -webkit-border-radius: 40px;\r\n  border-radius: 50%;\r\n  margin: 20px auto;\r\n  padding: 0;\r\n  position: relative;\r\n  box-sizing: content-box;\r\n\r\n  &.sa-error {\r\n    border-color: $danger;\r\n\r\n    .sa-x-mark {\r\n      position: relative;\r\n      display: block;\r\n    }\r\n\r\n    .sa-line {\r\n      position: absolute;\r\n      height: 5px;\r\n      width: 47px;\r\n      background-color: $danger;\r\n      display: block;\r\n      top: 37px;\r\n      border-radius: 2px;\r\n\r\n      &.sa-left {\r\n        -webkit-transform: rotate(45deg);\r\n        transform: rotate(45deg);\r\n        left: 17px;\r\n      }\r\n\r\n      &.sa-right {\r\n        -webkit-transform: rotate(-45deg);\r\n        transform: rotate(-45deg);\r\n        right: 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.sa-warning {\r\n    border-color: $warning;\r\n\r\n    .sa-body {\r\n      position: absolute;\r\n      width: 5px;\r\n      height: 47px;\r\n      left: 50%;\r\n      top: 10px;\r\n      -webkit-border-radius: 2px;\r\n      border-radius: 2px;\r\n      margin-left: -2px;\r\n      background-color: $warning;\r\n    }\r\n\r\n    .sa-dot {\r\n      position: absolute;\r\n      width: 7px;\r\n      height: 7px;\r\n      -webkit-border-radius: 50%;\r\n      border-radius: 50%;\r\n      margin-left: -3px;\r\n      left: 50%;\r\n      bottom: 10px;\r\n      background-color: $warning;\r\n    }\r\n  }\r\n\r\n  &.sa-info {\r\n    border-color: $info;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 5px;\r\n      height: 29px;\r\n      left: 50%;\r\n      bottom: 17px;\r\n      border-radius: 2px;\r\n      margin-left: -2px;\r\n      background-color: $info;\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 7px;\r\n      height: 7px;\r\n      border-radius: 50%;\r\n      margin-left: -3px;\r\n      top: 19px;\r\n      background-color: $info;\r\n    }\r\n  }\r\n\r\n  &.sa-success {\r\n    border-color: $success;\r\n\r\n    &::before,\r\n    &::after {\r\n      content: '';\r\n      -webkit-border-radius: 40px;\r\n      border-radius: 50%;\r\n      position: absolute;\r\n      width: 60px;\r\n      height: 120px;\r\n      background: $white;\r\n      -webkit-transform: rotate(45deg);\r\n      transform: rotate(45deg);\r\n    }\r\n\r\n    &::before {\r\n      -webkit-border-radius: 120px 0 0 120px;\r\n      border-radius: 120px 0 0 120px;\r\n      top: -7px;\r\n      left: -33px;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n      -webkit-transform-origin: 60px 60px;\r\n      transform-origin: 60px 60px;\r\n    }\r\n\r\n    &::after {\r\n      -webkit-border-radius: 0 120px 120px 0;\r\n      border-radius: 0 120px 120px 0;\r\n      top: -11px;\r\n      left: 30px;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n      -webkit-transform-origin: 0 60px;\r\n      transform-origin: 0 60px;\r\n    }\r\n\r\n    .sa-placeholder {\r\n      width: 80px;\r\n      height: 80px;\r\n      border: 4px solid rgba(165, 220, 134, 0.2);\r\n      -webkit-border-radius: 40px;\r\n      border-radius: 40px;\r\n      border-radius: 50%;\r\n      box-sizing: content-box;\r\n      position: absolute;\r\n      left: -4px;\r\n      top: -4px;\r\n      z-index: 2;\r\n    }\r\n\r\n    .sa-fix {\r\n      width: 5px;\r\n      height: 90px;\r\n      background-color: $white;\r\n      position: absolute;\r\n      left: 28px;\r\n      top: 8px;\r\n      z-index: 1;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n    }\r\n\r\n    .sa-line {\r\n      height: 5px;\r\n      background-color: $success;\r\n      display: block;\r\n      border-radius: 2px;\r\n      position: absolute;\r\n      z-index: 2;\r\n\r\n      &.sa-tip {\r\n        width: 25px;\r\n        left: 14px;\r\n        top: 46px;\r\n        -webkit-transform: rotate(45deg);\r\n        transform: rotate(45deg);\r\n      }\r\n\r\n      &.sa-long {\r\n        width: 47px;\r\n        right: 8px;\r\n        top: 38px;\r\n        -webkit-transform: rotate(-45deg);\r\n        transform: rotate(-45deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.sa-custom {\r\n    background-size: contain;\r\n    border-radius: 0;\r\n    border: none;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n  }\r\n}\r\n\r\n// @media all and (max-width: 540px) {\r\n//   .sweet-alert {\r\n//     width: auto;\r\n//     margin-left: 0;\r\n//     margin-right: 0;\r\n//     left: 15px;\r\n//     right: 15px;\r\n//   }\r\n// }\r\n\r\n// /*\r\n//  * Animations\r\n//  */\r\n// @-webkit-keyframes showSweetAlert {\r\n//   0% {\r\n//     transform: scale(0.7);\r\n//     -webkit-transform: scale(0.7);\r\n//   }\r\n//   45% {\r\n//     transform: scale(1.05);\r\n//     -webkit-transform: scale(1.05);\r\n//   }\r\n//   80% {\r\n//     transform: scale(0.95);\r\n//     -webkit-transform: scale(0.95);\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n// }\r\n\r\n// @keyframes showSweetAlert {\r\n//   0% {\r\n//     transform: scale(0.7);\r\n//     -webkit-transform: scale(0.7);\r\n//   }\r\n//   45% {\r\n//     transform: scale(1.05);\r\n//     -webkit-transform: scale(1.05);\r\n//   }\r\n//   80% {\r\n//     transform: scale(0.95);\r\n//     -webkit-transform: scale(0.95);\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes hideSweetAlert {\r\n//   0% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n//   100% {\r\n//     transform: scale(0.5);\r\n//     -webkit-transform: scale(0.5);\r\n//   }\r\n// }\r\n\r\n// @keyframes hideSweetAlert {\r\n//   0% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n//   100% {\r\n//     transform: scale(0.5);\r\n//     -webkit-transform: scale(0.5);\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideFromTop {\r\n//   0% {\r\n//     top: 0%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideFromTop {\r\n//   0% {\r\n//     top: 0%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideToTop {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 0%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideToTop {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 0%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideFromBottom {\r\n//   0% {\r\n//     top: 70%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideFromBottom {\r\n//   0% {\r\n//     top: 70%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideToBottom {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 70%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideToBottom {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 70%;\r\n//   }\r\n// }\r\n\r\n// .showSweetAlert[data-animation=pop] {\r\n//   -webkit-animation: showSweetAlert 0.3s;\r\n//   animation: showSweetAlert 0.3s;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=none] {\r\n//   -webkit-animation: none;\r\n//   animation: none;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=slide-from-top] {\r\n//   -webkit-animation: slideFromTop 0.3s;\r\n//   animation: slideFromTop 0.3s;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=slide-from-bottom] {\r\n//   -webkit-animation: slideFromBottom 0.3s;\r\n//   animation: slideFromBottom 0.3s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=pop] {\r\n//   -webkit-animation: hideSweetAlert 0.2s;\r\n//   animation: hideSweetAlert 0.2s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=none] {\r\n//   -webkit-animation: none;\r\n//   animation: none;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=slide-from-top] {\r\n//   -webkit-animation: slideToTop 0.4s;\r\n//   animation: slideToTop 0.4s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=slide-from-bottom] {\r\n//   -webkit-animation: slideToBottom 0.3s;\r\n//   animation: slideToBottom 0.3s;\r\n// }\r\n\r\n@-webkit-keyframes animateSuccessTip {\r\n  0% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  54% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  70% {\r\n    width: 50px;\r\n    left: -8px;\r\n    top: 37px;\r\n  }\r\n  84% {\r\n    width: 17px;\r\n    left: 21px;\r\n    top: 48px;\r\n  }\r\n  100% {\r\n    width: 25px;\r\n    left: 14px;\r\n    top: 45px;\r\n  }\r\n}\r\n\r\n@keyframes animateSuccessTip {\r\n  0% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  54% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  70% {\r\n    width: 50px;\r\n    left: -8px;\r\n    top: 37px;\r\n  }\r\n  84% {\r\n    width: 17px;\r\n    left: 21px;\r\n    top: 48px;\r\n  }\r\n  100% {\r\n    width: 25px;\r\n    left: 14px;\r\n    top: 45px;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes animateSuccessLong {\r\n  0% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  65% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  84% {\r\n    width: 55px;\r\n    right: 0;\r\n    top: 35px;\r\n  }\r\n  100% {\r\n    width: 47px;\r\n    right: 8px;\r\n    top: 38px;\r\n  }\r\n}\r\n\r\n@keyframes animateSuccessLong {\r\n  0% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  65% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  84% {\r\n    width: 55px;\r\n    right: 0;\r\n    top: 35px;\r\n  }\r\n  100% {\r\n    width: 47px;\r\n    right: 8px;\r\n    top: 38px;\r\n  }\r\n}\r\n\r\n// @-webkit-keyframes rotatePlaceholder {\r\n//   0% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   5% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   12% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n// }\r\n\r\n// @keyframes rotatePlaceholder {\r\n//   0% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   5% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   12% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n// }\r\n\r\n.animateSuccessTip {\r\n  -webkit-animation: animateSuccessTip 0.75s;\r\n  animation: animateSuccessTip 0.75s;\r\n}\r\n\r\n.animateSuccessLong {\r\n  -webkit-animation: animateSuccessLong 0.75s;\r\n  animation: animateSuccessLong 0.75s;\r\n}\r\n\r\n.sa-icon.sa-success.animate::after {\r\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\r\n  animation: rotatePlaceholder 4.25s ease-in;\r\n}\r\n\r\n// @-webkit-keyframes animateErrorIcon {\r\n//   0% {\r\n//     transform: rotateX(100deg);\r\n//     -webkit-transform: rotateX(100deg);\r\n//     opacity: 0;\r\n//   }\r\n//   100% {\r\n//     transform: rotateX(0deg);\r\n//     -webkit-transform: rotateX(0deg);\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// @keyframes animateErrorIcon {\r\n//   0% {\r\n//     transform: rotateX(100deg);\r\n//     -webkit-transform: rotateX(100deg);\r\n//     opacity: 0;\r\n//   }\r\n//   100% {\r\n//     transform: rotateX(0deg);\r\n//     -webkit-transform: rotateX(0deg);\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// .animateErrorIcon {\r\n//   -webkit-animation: animateErrorIcon 0.5s;\r\n//   animation: animateErrorIcon 0.5s;\r\n// }\r\n\r\n// @-webkit-keyframes animateXMark {\r\n//   0% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   50% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   80% {\r\n//     transform: scale(1.15);\r\n//     -webkit-transform: scale(1.15);\r\n//     margin-top: -6px;\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//     margin-top: 0;\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// @keyframes animateXMark {\r\n//   0% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   50% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   80% {\r\n//     transform: scale(1.15);\r\n//     -webkit-transform: scale(1.15);\r\n//     margin-top: -6px;\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//     margin-top: 0;\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// .animateXMark {\r\n//   -webkit-animation: animateXMark 0.5s;\r\n//   animation: animateXMark 0.5s;\r\n// }\r\n\r\n// @-webkit-keyframes pulseWarning {\r\n//   0% {\r\n//     border-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     border-color: $warning;\r\n//   }\r\n// }\r\n\r\n// @keyframes pulseWarning {\r\n//   0% {\r\n//     border-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     border-color: $warning;\r\n//   }\r\n// }\r\n\r\n// .pulseWarning {\r\n//   -webkit-animation: pulseWarning 0.75s infinite alternate;\r\n//   animation: pulseWarning 0.75s infinite alternate;\r\n// }\r\n\r\n// @-webkit-keyframes pulseWarningIns {\r\n//   0% {\r\n//     background-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     background-color: $warning;\r\n//   }\r\n// }\r\n\r\n// @keyframes pulseWarningIns {\r\n//   0% {\r\n//     background-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     background-color: $warning;\r\n//   }\r\n// }\r\n\r\n// .pulseWarningIns {\r\n//   -webkit-animation: pulseWarningIns 0.75s infinite alternate;\r\n//   animation: pulseWarningIns 0.75s infinite alternate;\r\n// }\r\n\r\n// @-webkit-keyframes rotate-loading {\r\n//   0% {\r\n//     transform: rotate(0deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(360deg);\r\n//   }\r\n// }\r\n\r\n// @keyframes rotate-loading {\r\n//   0% {\r\n//     transform: rotate(0deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(360deg);\r\n//   }\r\n// }\r\n\r\n// /* Internet Explorer 9 has some special quirks that are fixed here */\r\n// /* The icons are not animated. */\r\n// /* This file is automatically merged into sweet-alert.min.js through Gulp */\r\n// /* Error icon */\r\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-left {\r\n//   -ms-transform: rotate(45deg) \\9\r\n// ;\r\n// }\r\n\r\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-right {\r\n//   -ms-transform: rotate(-45deg) \\9\r\n// ;\r\n// }\r\n\r\n/* Success icon */\r\n.sweet-alert .sa-icon.sa-success {\r\n  border-color: transparent \\9\r\n;\r\n}\r\n\r\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\r\n  -ms-transform: rotate(45deg) \\9\r\n;\r\n}\r\n\r\n.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {\r\n  -ms-transform: rotate(-45deg) \\9\r\n;\r\n}\r\n\r\n// /*!\r\n//  * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\r\n//  * Copyright 2015 Daniel Cardoso <@DanielCardoso>\r\n//  * Licensed under MIT\r\n//  */\r\n// .la-ball-fall,\r\n// .la-ball-fall > div {\r\n//   position: relative;\r\n//   -webkit-box-sizing: border-box;\r\n//   -moz-box-sizing: border-box;\r\n//   box-sizing: border-box;\r\n// }\r\n\r\n// .la-ball-fall {\r\n//   display: block;\r\n//   font-size: 0;\r\n//   color: #fff;\r\n// }\r\n\r\n// .la-ball-fall.la-dark {\r\n//   color: #333;\r\n// }\r\n\r\n// .la-ball-fall > div {\r\n//   display: inline-block;\r\n//   float: none;\r\n//   background-color: currentColor;\r\n//   border: 0 solid currentColor;\r\n// }\r\n\r\n// .la-ball-fall {\r\n//   width: 54px;\r\n//   height: 18px;\r\n// }\r\n\r\n// .la-ball-fall > div {\r\n//   width: 10px;\r\n//   height: 10px;\r\n//   margin: 4px;\r\n//   border-radius: 100%;\r\n//   opacity: 0;\r\n//   -webkit-animation: ball-fall 1s ease-in-out infinite;\r\n//   -moz-animation: ball-fall 1s ease-in-out infinite;\r\n//   -o-animation: ball-fall 1s ease-in-out infinite;\r\n//   animation: ball-fall 1s ease-in-out infinite;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(1) {\r\n//   -webkit-animation-delay: -200ms;\r\n//   -moz-animation-delay: -200ms;\r\n//   -o-animation-delay: -200ms;\r\n//   animation-delay: -200ms;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(2) {\r\n//   -webkit-animation-delay: -100ms;\r\n//   -moz-animation-delay: -100ms;\r\n//   -o-animation-delay: -100ms;\r\n//   animation-delay: -100ms;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(3) {\r\n//   -webkit-animation-delay: 0ms;\r\n//   -moz-animation-delay: 0ms;\r\n//   -o-animation-delay: 0ms;\r\n//   animation-delay: 0ms;\r\n// }\r\n\r\n// .la-ball-fall.la-sm {\r\n//   width: 26px;\r\n//   height: 8px;\r\n// }\r\n\r\n// .la-ball-fall.la-sm > div {\r\n//   width: 4px;\r\n//   height: 4px;\r\n//   margin: 2px;\r\n// }\r\n\r\n// .la-ball-fall.la-2x {\r\n//   width: 108px;\r\n//   height: 36px;\r\n// }\r\n\r\n// .la-ball-fall.la-2x > div {\r\n//   width: 20px;\r\n//   height: 20px;\r\n//   margin: 8px;\r\n// }\r\n\r\n// .la-ball-fall.la-3x {\r\n//   width: 162px;\r\n//   height: 54px;\r\n// }\r\n\r\n// .la-ball-fall.la-3x > div {\r\n//   width: 30px;\r\n//   height: 30px;\r\n//   margin: 12px;\r\n// }\r\n\r\n// /*\r\n//  * Animation\r\n//  */\r\n// @-webkit-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @-moz-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -moz-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -moz-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -moz-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -moz-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @-o-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -o-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -o-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(-145%);\r\n//     -moz-transform: translateY(-145%);\r\n//     -o-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     -moz-transform: translateY(0);\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     -moz-transform: translateY(0);\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(145%);\r\n//     -moz-transform: translateY(145%);\r\n//     -o-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n","@use \"sass:math\";\r\n\r\n.#{$rt-namespace}__toast-container {\r\n    z-index: $rt-z-index;\r\n    position: fixed;\r\n    padding: 0;\r\n    width: $rt-toast-width;\r\n    box-sizing: border-box;\r\n    color: $white;\r\n    &--top-left {\r\n        top: $spacer;\r\n        left: $spacer;\r\n    }\r\n    &--top-center {\r\n        top: $spacer;\r\n        left: 50%;\r\n        margin-left: -(math.div($rt-toast-width, 2));\r\n    }\r\n    &--top-right {\r\n        top: $spacer;\r\n        right: $spacer;\r\n    }\r\n    &--bottom-left {\r\n        bottom: $spacer;\r\n        left: $spacer;\r\n    }\r\n    &--bottom-center {\r\n        bottom: $spacer;\r\n        left: 50%;\r\n        margin-left: -(math.div($rt-toast-width, 2));\r\n    }\r\n    &--bottom-right {\r\n        bottom: $spacer;\r\n        right: $spacer;\r\n    }\r\n}\r\n\r\n@media #{$rt-mobile} {\r\n    .#{$rt-namespace}__toast-container {\r\n        width: 100vw;\r\n        padding: 0;\r\n        left: 0;\r\n        margin: 0;\r\n        &--top-left,\r\n        &--top-center,\r\n        &--top-right {\r\n            top: 0;\r\n        }\r\n        &--bottom-left,\r\n        &--bottom-center,\r\n        &--bottom-right {\r\n            bottom: 0;\r\n        }\r\n        &--rtl{\r\n          right: 0;\r\n          left: initial;\r\n        }\r\n    }\r\n}\r\n","$rt-namespace: 'Toastify';\r\n$rt-toast-width: 320px !default;\r\n$rt-toast-background: #ffffff !default;\r\n$rt-toast-min-height: 54px !default;\r\n$rt-toast-max-height: 800px !default;\r\n\r\n\r\n$rt-color-default: #fff !default;\r\n$rt-color-info: $info !default;\r\n$rt-color-success: $success !default;\r\n$rt-color-warning: $warning !default;\r\n$rt-color-error: $danger !default;\r\n\r\n$rt-color-progress-default: $primary !default;\r\n\r\n$rt-mobile: \"only screen and (max-width : 480px)\" !default;\r\n$rt-font-family: sans-serif !default;\r\n$rt-z-index: 2147483647 !default;\r\n\r\n","@use \"sass:math\";\r\n\r\n.#{$rt-namespace}__toast {\r\n    position: relative;\r\n    min-height: $rt-toast-min-height;\r\n    box-sizing: border-box;\r\n    margin-bottom: 1rem;\r\n    padding: $spacer;\r\n    @include border-radius($border-radius);\r\n    box-shadow: $box-shadow-default;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    max-height: $rt-toast-max-height;\r\n    overflow: hidden;\r\n    font-family: $rt-font-family;\r\n    cursor: pointer;\r\n    direction: ltr;\r\n    &--rtl {\r\n        direction: rtl;\r\n    }\r\n    &--default {\r\n        background: $rt-color-default;\r\n        color: $gray-700;\r\n        @include box-shadow-architect($primary);\r\n    }\r\n    &--info {\r\n        background: $rt-color-info;\r\n        @include box-shadow-architect($info);\r\n    }\r\n    &--success {\r\n        background: $rt-color-success;\r\n        @include box-shadow-architect($success);\r\n    }\r\n    &--warning {\r\n        background: $rt-color-warning;\r\n        @include box-shadow-architect($warning);\r\n    }\r\n    &--error {\r\n        background: $rt-color-error;\r\n        @include box-shadow-architect($danger);\r\n    }\r\n    &-body {\r\n        margin: auto 0;\r\n        padding: 0 0 math.div($spacer, 2.5);\r\n    }\r\n}\r\n\r\n@media #{$rt-mobile} {\r\n  .#{$rt-namespace}__toast{\r\n    margin-bottom: 0;  \r\n  }\r\n}",".#{$rt-namespace}__close-button {\r\n  color: $white;\r\n  font-size: 14px;\r\n  background: transparent;\r\n  outline: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  opacity: 0.7;\r\n  transition: 0.3s ease;\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 9px;\r\n  &--default {\r\n    color: #000;\r\n    opacity: 0.3;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    opacity: 1;\r\n  }\r\n}\r\n","@keyframes #{$rt-namespace}__trackProgress {\r\n  0%{\r\n    width: 96%;\r\n  }\r\n  100%{\r\n    width: 0;\r\n  }\r\n}\r\n\r\n.#{$rt-namespace}__progress-bar {\r\n  position: absolute;\r\n  bottom: 9%;\r\n  left: 2%;\r\n  width: 0;\r\n  height: 5px;\r\n  z-index: $rt-z-index;\r\n  animation: #{$rt-namespace}__trackProgress linear 1;\r\n  background-color: rgba(255,255,255,.3);\r\n  @include border-radius($border-radius);\r\n\r\n  &--rtl {\r\n    right: 0;\r\n    left: initial;\r\n  }\r\n  &--default{\r\n    background: $rt-color-progress-default;\r\n  }\r\n\r\n  &--info{}\r\n  &--success{}\r\n  &--warning{}\r\n  &--error{}\r\n}\r\n","@mixin timing-function {\r\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInRight {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(3000px, 0, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(-25px, 0, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(10px, 0, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(-5px, 0, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutRight {\r\n    20% {\r\n        opacity: 1;\r\n        transform: translate3d(-20px, 0, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInLeft {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate3d(-3000px, 0, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(25px, 0, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(-10px, 0, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(5px, 0, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutLeft {\r\n    20% {\r\n        opacity: 1;\r\n        transform: translate3d(20px, 0, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInUp {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(0, 3000px, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(0, -5px, 0);\r\n    }\r\n    to {\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutUp {\r\n    20% {\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        transform: translate3d(0, 20px, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInDown {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate3d(0, -3000px, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(0, 25px, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(0, 5px, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutDown {\r\n    20% {\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__bounce-enter {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__bounceInLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__bounceInRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__bounceInDown;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__bounceInUp;\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__bounce-exit {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__bounceOutLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__bounceOutRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__bounceOutUp;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__bounceOutDown;\r\n    }\r\n}","@keyframes #{$rt-namespace}__zoomIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__zoomOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n    50% {\r\n        opacity: 0;\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n    to {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__zoom-enter {\r\n    animation-name: #{$rt-namespace}__zoomIn;\r\n}\r\n\r\n.#{$rt-namespace}__zoom-exit {\r\n    animation-name: #{$rt-namespace}__zoomOut;\r\n}\r\n","@keyframes #{$rt-namespace}__flipIn {\r\n    from {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n    40% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        animation-timing-function: ease-in;\r\n    }\r\n    60% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1\r\n    }\r\n    80% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n    to {\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__flipOut {\r\n    from {\r\n        transform: perspective(400px);\r\n    }\r\n    30% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        opacity: 1\r\n    }\r\n    to {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__flip-enter {\r\n    animation-name: #{$rt-namespace}__flipIn;\r\n}\r\n\r\n.#{$rt-namespace}__flip-exit {\r\n    animation-name: #{$rt-namespace}__flipOut;\r\n}\r\n","@mixin transform {\r\n    transform: translate3d(0, 0, 0);\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInRight {\r\n    from {\r\n        transform: translate3d(110%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInLeft {\r\n    from {\r\n        transform: translate3d(-110%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInUp {\r\n    from {\r\n        transform: translate3d(0, 110%, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInDown {\r\n    from {\r\n        transform: translate3d(0, -110%, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutRight {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(110%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutLeft {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(-110%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutDown {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(0, 500px, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutUp {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(0, -500px, 0);\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__slide-enter {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__slideInLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__slideInRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__slideInDown;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__slideInUp;\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__slide-exit {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__slideOutLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__slideOutRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__slideOutUp;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__slideOutDown;\r\n    }\r\n}","/* -- container -- */\r\n.rodal,\r\n.rodal-mask {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n}\r\n\r\n.rodal {\r\n  position: fixed;\r\n}\r\n\r\n/* -- mask -- */\r\n.rodal-mask {\r\n  position: absolute;\r\n  background-color: $modal-backdrop-bg;\r\n  opacity: $modal-backdrop-opacity;\r\n}\r\n\r\n/* -- dialog -- */\r\n.rodal-dialog {\r\n  position: absolute;\r\n  top: 10%;\r\n  left: 0;\r\n  right: 0;\r\n  margin: auto;\r\n  z-index: 101;\r\n  background: $white;\r\n  box-shadow: $box-shadow-lg-default;\r\n  @include border-radius($border-radius);\r\n  height: auto !important;\r\n}\r\n\r\n.rodal-dialog:focus {\r\n  outline: none;\r\n}\r\n\r\n/* -- close button -- */\r\n.rodal-close {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 16px;\r\n  right: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.rodal-close:before,\r\n.rodal-close:after {\r\n  position: absolute;\r\n  content: '';\r\n  height: 2px;\r\n  width: 100%;\r\n  top: 50%;\r\n  left: 0;\r\n  margin-top: -1px;\r\n  background: $gray-500;\r\n  border-radius: 100%;\r\n  transition: background .2s;\r\n}\r\n\r\n.rodal-close:before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.rodal-close:after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.rodal-close:hover:before,\r\n.rodal-close:hover:after {\r\n  background: $gray-800;\r\n}\r\n\r\n/* -- fade -- */\r\n\r\n@keyframes rodal-fade-enter {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.rodal-fade-enter {\r\n  animation: rodal-fade-enter both ease-in;\r\n}\r\n\r\n@keyframes rodal-fade-leave {\r\n  to {\r\n    opacity: 0\r\n  }\r\n}\r\n\r\n.rodal-fade-leave {\r\n  animation: rodal-fade-leave both ease-out;\r\n}\r\n\r\n@keyframes rodal-zoom-enter {\r\n  from {\r\n    transform: scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-zoom-enter {\r\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-zoom-leave {\r\n  to {\r\n    transform: scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-zoom-leave {\r\n  animation: rodal-zoom-leave both;\r\n}\r\n\r\n@keyframes rodal-slideDown-enter {\r\n  from {\r\n    transform: translate3d(0, -100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideDown-enter {\r\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideDown-leave {\r\n  to {\r\n    transform: translate3d(0, -100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideDown-leave {\r\n  animation: rodal-slideDown-leave both;\r\n}\r\n\r\n/* -- slideLeft -- */\r\n\r\n@keyframes rodal-slideLeft-enter {\r\n  from {\r\n    transform: translate3d(-150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideLeft-enter {\r\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideLeft-leave {\r\n  to {\r\n    transform: translate3d(-150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideLeft-leave {\r\n  animation: rodal-slideLeft-leave both;\r\n}\r\n\r\n/* -- slideRight -- */\r\n\r\n@keyframes rodal-slideRight-enter {\r\n  from {\r\n    transform: translate3d(150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideRight-enter {\r\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideRight-leave {\r\n  to {\r\n    transform: translate3d(150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideRight-leave {\r\n  animation: rodal-slideRight-leave both;\r\n}\r\n\r\n/* -- slideUp -- */\r\n\r\n@keyframes rodal-slideUp-enter {\r\n  from {\r\n    transform: translate3d(0, 100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideUp-enter {\r\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideUp-leave {\r\n  to {\r\n    transform: translate3d(0, 100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideUp-leave {\r\n  animation: rodal-slideUp-leave both;\r\n}\r\n\r\n/* -- flip -- */\r\n\r\n@keyframes rodal-flip-enter {\r\n  from {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\r\n  }\r\n  70% {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\r\n  }\r\n  to {\r\n    transform: perspective(400px);\r\n  }\r\n}\r\n\r\n.rodal-flip-enter {\r\n  animation: rodal-flip-enter both ease-in;\r\n  backface-visibility: visible !important;\r\n}\r\n\r\n@keyframes rodal-flip-leave {\r\n  from {\r\n    transform: perspective(400px);\r\n  }\r\n  30% {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\r\n  }\r\n  to {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\r\n  }\r\n}\r\n\r\n.rodal-flip-leave {\r\n  animation: rodal-flip-leave both;\r\n  backface-visibility: visible !important;\r\n}\r\n\r\n/* -- rotate -- */\r\n\r\n@keyframes rodal-rotate-enter {\r\n  from {\r\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-rotate-enter {\r\n  animation: rodal-rotate-enter both;\r\n  transform-origin: center;\r\n}\r\n\r\n@keyframes rodal-rotate-leave {\r\n  to {\r\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-rotate-leave {\r\n  animation: rodal-rotate-leave both;\r\n  transform-origin: center;\r\n}\r\n\r\n/* -- door -- */\r\n\r\n@keyframes rodal-door-enter {\r\n  from {\r\n    transform: scale3d(0, 1, 1);\r\n  }\r\n}\r\n\r\n.rodal-door-enter {\r\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-door-leave {\r\n  60% {\r\n    transform: scale3d(.01, 1, 1);\r\n  }\r\n  to {\r\n    transform: scale3d(0, 1, .1);\r\n  }\r\n}\r\n\r\n.rodal-door-leave {\r\n  animation: rodal-door-leave both;\r\n}",".react-sweet-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.react-sweet-progress-symbol {\r\n  display: flex;\r\n  align-items: center;\r\n  -ms-flex-pack: start;\r\n  justify-content: flex-start;\r\n  width: 35px;\r\n  height: 20px;\r\n  padding-left: 10px;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  font-weight: 200;\r\n}\r\n\r\n.react-sweet-progress-symbol-absolute {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  transform: translate3d(-50%, -50%, 0);\r\n}\r\n\r\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.react-sweet-progress-circle-outer {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.react-sweet-progress-line {\r\n  width: 100%;\r\n  border-radius: 100px;\r\n  background-color: #efefef;\r\n  vertical-align: middle;\r\n}\r\n\r\n.react-sweet-progress-line-inner {\r\n  position: relative;\r\n  min-height: 10px;\r\n  border-radius: 100px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.react-sweet-progress-line-inner-status-active:before {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\r\n  content: \"\";\r\n  opacity: 0;\r\n}\r\n\r\n@keyframes active-anim {\r\n  0% {\r\n    width: 0;\r\n    opacity: .1;\r\n  }\r\n  20% {\r\n    width: 0;\r\n    opacity: .5;\r\n  }\r\n  to {\r\n    width: 100%;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.react-sweet-progress-circle path {\r\n  stroke-linecap: round;\r\n}\r\n","/* Slider */\r\n\r\n.slick-slider {\r\n  position: relative;\r\n  display: block;\r\n  box-sizing: border-box;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -ms-touch-action: pan-y;\r\n  touch-action: pan-y;\r\n  -webkit-tap-highlight-color: transparent;\r\n  max-width: 1400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.slick-slider-sm {\r\n  .slick-slider {\r\n    max-width: 450px;\r\n\r\n    .slick-prev {\r\n      left: -20px;\r\n    }\r\n\r\n    .slick-next {\r\n      right: -20px;\r\n    }\r\n  }\r\n}\r\n\r\n.slick-slider-md {\r\n  .slick-slider {\r\n    max-width: 650px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.slick-slider-hover {\r\n  .slick-arrow {\r\n    opacity: 0;\r\n    background: $primary-color;\r\n    color: $white !important;\r\n  }\r\n\r\n  .slick-prev {\r\n    left: -30px;\r\n\r\n  }\r\n\r\n  .slick-next {\r\n    right: -30px;\r\n  }\r\n\r\n\r\n  &:hover {\r\n    .slick-arrow {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n\r\n.slick-list {\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: block;\r\n  margin: 0;\r\n  padding: 0;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n\r\n  &.dragging {\r\n    cursor: pointer;\r\n    cursor: hand;\r\n  }\r\n}\r\n\r\n.slick-slider .slick-track,\r\n.slick-slider .slick-list {\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  -moz-transform: translate3d(0, 0, 0);\r\n  -ms-transform: translate3d(0, 0, 0);\r\n  -o-transform: translate3d(0, 0, 0);\r\n  transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.slick-track {\r\n  position: relative;\r\n  left: 0;\r\n  top: 0;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  &:before,\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n  }\r\n\r\n  &:after {\r\n    clear: both;\r\n  }\r\n\r\n  .slick-loading & {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n.slick-slide {\r\n  float: left;\r\n  height: 100%;\r\n  min-height: 1px;\r\n  [dir=\"rtl\"] & {\r\n    float: right;\r\n  }\r\n  img {\r\n    display: block;\r\n  }\r\n  &.slick-loading img {\r\n    display: none;\r\n  }\r\n\r\n  display: none;\r\n\r\n  &.dragging img {\r\n    pointer-events: none;\r\n  }\r\n\r\n  .slick-initialized & {\r\n    display: block;\r\n  }\r\n\r\n  .slick-loading & {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .slick-vertical & {\r\n    display: block;\r\n    height: auto;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n\r\n.slick-arrow.slick-hidden {\r\n  display: none;\r\n}\r\n\r\n@import \"slick-theme\";","// Default Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$slick-font-path: \"./fonts/\" !default;\r\n$slick-font-family: \"slick\" !default;\r\n$slick-loader-path: \"./\" !default;\r\n$slick-arrow-color: $primary !default;\r\n$slick-next-character: \"\\E684\" !default;\r\n$slick-prev-character: \"\\E686\" !default;\r\n$slick-dot-size: 6px !default;\r\n$slick-opacity-default: 0.75 !default;\r\n$slick-opacity-on-hover: 1 !default;\r\n$slick-opacity-not-active: 0.25 !default;\r\n\r\n/* Arrows */\r\n\r\n.slick-prev,\r\n.slick-next {\r\n  position: absolute;\r\n  display: block;\r\n  height: 40px;\r\n  width: 40px;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n  top: 50%;\r\n  transform: translate(0, -80%);\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: $box-shadow-default;\r\n  transition: all .2s;\r\n  font-family: 'Pe-icon-7-stroke';\r\n  @include border-radius(50px);\r\n  background: $white;\r\n  z-index: 6;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    font-size: 35px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    width: 40px;\r\n  }\r\n\r\n  &:hover, &:focus {\r\n    outline: none;\r\n    box-shadow: $box-shadow-lg;\r\n    color: $primary;\r\n  }\r\n\r\n  &.slick-disabled:before {\r\n    opacity: $slick-opacity-not-active;\r\n  }\r\n}\r\n\r\n.slick-prev {\r\n  left: 0;\r\n  &:before {\r\n    content: $slick-prev-character;\r\n\r\n  }\r\n}\r\n\r\n.slick-next {\r\n  right: 0;\r\n  &:before {\r\n    content: $slick-next-character;\r\n  }\r\n}\r\n\r\n/* Dots */\r\n\r\n.slick-dots {\r\n  list-style: none;\r\n  display: block;\r\n  text-align: center;\r\n  padding: 0;\r\n  margin: math.div($layout-spacer-x, 2) 0 0;\r\n  width: 100%;\r\n  li {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 0;\r\n    margin: 0 5px;\r\n    cursor: pointer;\r\n    transform: scale(.8);\r\n    transition: all .2s;\r\n\r\n    button {\r\n      border: 0;\r\n      background: transparent;\r\n      display: block;\r\n      height: 14px;\r\n      width: 14px;\r\n      background: $primary;\r\n      cursor: pointer;\r\n      position: relative;\r\n      @include border-radius(20px);\r\n      color: transparent;\r\n\r\n      &::before {\r\n        content: '';\r\n        position: absolute;\r\n        background: $white;\r\n        left: 50%;\r\n        top: 50%;\r\n        margin: -4px 0 0 -4px;\r\n        display: block;\r\n        width: 8px;\r\n        height: 8px;\r\n        @include border-radius(20px);\r\n      }\r\n\r\n    }\r\n    &.slick-active {\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n}\r\n\r\n.slick-center {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.slick-slider {\r\n  .slide-img-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: cover;\r\n    opacity: .4;\r\n    z-index: 10;\r\n  }\r\n\r\n  .slider-content {\r\n    position: relative;\r\n    z-index: 15;\r\n    text-align: center;\r\n    margin: 0 ($spacer-lg * 2);\r\n\r\n    h3 {\r\n      font-size: $h3-font-size;\r\n      font-weight: normal;\r\n      margin-bottom: $spacer-sm;\r\n    }\r\n\r\n    p {\r\n      font-size: $h6-font-size;\r\n      opacity: .7;\r\n    }\r\n  }\r\n}\r\n\r\n// slider-light\r\n\r\n.slider-light {\r\n  .slick-dots {\r\n    position: absolute;\r\n    bottom: 10px;\r\n\r\n    li button {\r\n      background: rgba(255, 255, 255, 0.25);\r\n    }\r\n  }\r\n\r\n  .slick-prev,\r\n  .slick-next {\r\n    background: transparent;\r\n    color: $white;\r\n    box-shadow: 0 0 0 0 transparent;\r\n\r\n    &:hover {\r\n      background: rgba(255,255,255,.15);\r\n    }\r\n  }\r\n\r\n  .slick-next {\r\n    right: 15px;\r\n  }\r\n\r\n  .slick-prev {\r\n    left: 15px;\r\n  }\r\n\r\n  .slider-content {\r\n    color: $white;\r\n  }\r\n}\r\n",".loading-indicator {\r\n  text-align: center;\r\n}\r\n\r\n.loading-bullet {\r\n  display: inline-block;\r\n  opacity: 0;\r\n  font-size: 2em;\r\n  color: #02a17c;\r\n}\r\n\r\n.block-ui {\r\n  position: relative;\r\n  min-height: 3em;\r\n}\r\n\r\n.block-ui-container {\r\n  position: absolute;\r\n  z-index: 1010;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  min-height: 2em;\r\n  cursor: wait;\r\n  overflow: hidden;\r\n}\r\n\r\n.block-ui-container:focus {\r\n  outline: none;\r\n}\r\n\r\n.block-ui-overlay {\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  background-color: white;\r\n}\r\n\r\n.block-ui-message-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  width: 100%;\r\n  right: 0;\r\n  text-align: center;\r\n  transform: translateY(-50%);\r\n  z-index: 10001;\r\n}\r\n\r\n.block-ui-message {\r\n  color: #333;\r\n  background: none;\r\n  z-index: 1011;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.block-overlay-dark {\r\n  .block-ui-overlay {\r\n    background: rgba(0,0,0,1);\r\n  }\r\n}","// Tooltips & Popovers\r\n\r\n// Popover\r\n\r\n@use \"sass:math\";\r\n\r\n.popover {\r\n  box-shadow: $box-shadow-default;\r\n\r\n  .grid-menu {\r\n    margin-bottom: -$popover-body-padding-y;\r\n    padding: 1px;\r\n\r\n    [class*=\"col-\"] {\r\n      padding: $popover-body-padding-y;\r\n    }\r\n\r\n    & + .nav {\r\n      .nav-item-btn {\r\n        margin-bottom: $popover-body-padding-y;\r\n      }\r\n    }\r\n  }\r\n\r\n  .grid-menu-xl {\r\n    margin-bottom: -(math.div($popover-body-padding-y, 1.35));\r\n\r\n    [class*=\"col-\"] {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .popover-inner {\r\n    .dropdown-menu-header {\r\n      @include border-top-radius($popover-border-radius);\r\n      overflow: hidden;\r\n      margin-top: -1px;\r\n      margin-left: -1px;\r\n      margin-right: -1px;\r\n    }\r\n  }\r\n}\r\n\r\n.rm-max-width {\r\n  & > .popover {\r\n    max-width: initial;\r\n  }\r\n}\r\n\r\n.rm-pointers {\r\n  & > .popover {\r\n    .arrow {\r\n      display: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin bg-popover($parent, $color) {\r\n  #{$parent} {\r\n    background-color: $color !important;\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include bg-popover(\".popover-#{$color}\", $value);\r\n}\r\n\r\n.popover-custom {\r\n  .popover-body {\r\n    padding-top: 0;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n\r\n    .dropdown-menu-header {\r\n      margin-top: 0;\r\n      @include border-top-radius($popover-border-radius);\r\n      overflow: hidden;\r\n\r\n      .menu-header-content {\r\n        padding: 0 $layout-spacer-x;\r\n      }\r\n\r\n      .dropdown-menu-header-inner.bg-light {\r\n        color: rgba(0, 0, 0, .8);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.popover-custom-lg {\r\n    min-width: 22rem;\r\n  }\r\n\r\n  &.popover-custom-xl {\r\n    min-width: 25rem;\r\n  }\r\n\r\n  &.popover-custom-sm {\r\n    min-width: 15rem;\r\n  }\r\n}\r\n\r\n.popover-bg {\r\n  border: 0;\r\n\r\n  .arrow {\r\n    display: none;\r\n  }\r\n\r\n  .popover-header {\r\n    background: rgba(255, 255, 255, .1);\r\n    border-bottom: 0;\r\n    color: rgba(255, 255, 255, 1);\r\n\r\n    &::before {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .popover-body {\r\n    color: rgba(255, 255, 255, .7);\r\n  }\r\n\r\n  &.text-dark {\r\n    .popover-header {\r\n      color: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .popover-body {\r\n      color: rgba(0, 0, 0, .7);\r\n    }\r\n  }\r\n}\r\n\r\n// Tooltip\r\n\r\n.tooltip-light {\r\n  & > .tooltip {\r\n    .tooltip-inner {\r\n      background: $white;\r\n      color: $gray-800;\r\n      box-shadow: $box-shadow-default;\r\n      border: $popover-border-color solid 1px;\r\n    }\r\n\r\n    .arrow {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n","// Sticky Elements\r\n\r\n.scrollable-block {\r\n  margin-bottom: 50px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  .sticky {\r\n    z-index: 2;\r\n  }\r\n}",".rbc-btn {\r\n  color: inherit;\r\n  font: inherit;\r\n  margin: 0;\r\n}\r\n\r\nbutton.rbc-btn {\r\n  overflow: visible;\r\n  text-transform: none;\r\n  -webkit-appearance: button;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton[disabled].rbc-btn {\r\n  cursor: not-allowed;\r\n}\r\n\r\nbutton.rbc-input::-moz-focus-inner {\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n","@import 'scss/variables';\r\n@import 'scss/reset';\r\n\r\n\r\n.rbc-calendar {\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n    flex: 1 1;\r\n    min-height: 580px;\r\n}\r\n\r\n.rbc-calendar *,\r\n.rbc-calendar *:before,\r\n.rbc-calendar *:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n.rbc-abs-full {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.rbc-ellipsis {\r\n  display: block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rbc-rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.rbc-off-range {\r\n  color: $out-of-range-color;\r\n}\r\n\r\n.rbc-header {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  padding: 0 3px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-weight: bold;\r\n  font-size: 90%;\r\n  min-height: 0;\r\n  flex: 1 0;\r\n  flex-basis: auto !important;\r\n\r\n  > a {\r\n    &, &:active, &:visited {\r\n      color: inherit;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-row-content {\r\n  position: relative;\r\n  user-select: none;\r\n  z-index: 4;\r\n}\r\n\r\n.rbc-today {\r\n  background-color: $today-highlight-bg;\r\n}\r\n\r\n\r\n@import 'scss/toolbar';\r\n@import 'scss/event';\r\n@import 'scss/month';\r\n@import 'scss/agenda';\r\n@import 'scss/time-grid';\r\n","\r\n@use \"sass:math\";\r\n\r\n$out-of-range-color: tint-color(#333, 50%);\r\n\r\n$calendar-border: $gray-200;\r\n$cell-border: $gray-200;\r\n\r\n$border-color: $gray-300;\r\n\r\n$segment-width: percentage(math.div(1, 7));\r\n\r\n$time-selection-color: #white;\r\n$time-selection-bg-color: rgba(0,0,0, .50);\r\n$date-selection-bg-color: rgba(0,0,0, .10);\r\n\r\n\r\n$event-bg: $primary;\r\n$event-border: shade-color($event-bg, 10%);\r\n$event-color: $white;\r\n$event-border-radius: $border-radius;\r\n$event-padding: $dropdown-spacer;\r\n$event-zindex: 4;\r\n\r\n$btn-color: $white;\r\n$btn-bg: $primary;\r\n$btn-border: $primary;\r\n\r\n$current-time-color: $success;\r\n\r\n$rbc-css-prefix: rbc-i;\r\n\r\n$today-highlight-bg: $dropdown-link-hover-bg;\r\n","@use \"sass:math\";\r\n\r\n@import 'variables';\r\n\r\n$active-background: shade-color($btn-bg, 10%);\r\n$active-border: shade-color($btn-border, 12%);\r\n\r\n.rbc-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n\r\n  .rbc-toolbar-label {\r\n    width: 100%;\r\n    padding: 0 10px;\r\n    text-align: center;\r\n  }\r\n\r\n  & button {\r\n    color: $btn-color;\r\n    display: inline-block;\r\n    margin: 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    background: $primary;\r\n    border: 1px solid $btn-border;\r\n    padding: .375rem 1rem;\r\n    border-radius: $border-radius;\r\n    line-height: normal;\r\n    white-space: nowrap;\r\n    font-weight: bold;\r\n    text-transform: capitalize;\r\n    font-size: math.div($font-size-sm, 1.1);\r\n\r\n    &:active,\r\n    &.rbc-active {\r\n      background-image: none;\r\n      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $btn-color;\r\n        background-color: shade-color($btn-bg, 17%);\r\n        border-color: shade-color($btn-border, 25%);\r\n      }\r\n    }\r\n\r\n    &:focus {\r\n      color: $btn-color;\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n    }\r\n\r\n    &:hover {\r\n      color: $btn-color;\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-btn-group {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n\r\n  > button:first-child:not(:last-child) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  > button:last-child:not(:first-child) {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .rbc-rtl & > button:first-child:not(:last-child) {\r\n    border-radius: 4px;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .rbc-rtl & > button:last-child:not(:first-child) {\r\n    border-radius: 4px;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  > button:not(:first-child):not(:last-child) {\r\n    border-radius: 0;\r\n  }\r\n\r\n  button + button {\r\n    margin-left: -1px;\r\n  }\r\n\r\n  .rbc-rtl & button + button {\r\n    margin-left: 0;\r\n    margin-right: -1px;\r\n  }\r\n\r\n  & + &,\r\n  & + button {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n","@import 'variables';\r\n\r\n.rbc-event {\r\n  cursor: pointer;\r\n  padding: $event-padding;\r\n  background-color: $event-bg;\r\n  border-radius: $event-border-radius;\r\n  color: $event-color;\r\n\r\n  &.rbc-selected {\r\n    background-color: shade-color($event-bg, 10%);\r\n  }\r\n}\r\n\r\n.rbc-event-label {\r\n  @extend .rbc-ellipsis;\r\n  font-size: 80%;\r\n}\r\n\r\n.rbc-event-overlaps {\r\n  box-shadow: -1px 1px 5px 0px rgba(51,51,51,.5);\r\n}\r\n\r\n.rbc-event-continues-prior {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n.rbc-event-continues-after {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n\r\n.rbc-event-continues-earlier {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n.rbc-event-continues-later {\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n","@import 'variables';\r\n\r\n\r\n.rbc-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.rbc-row-segment {\r\n  padding: 0 1px 1px 1px;\r\n\r\n  .rbc-event-content {\r\n    @extend .rbc-ellipsis;\r\n  }\r\n}\r\n\r\n.rbc-selected-cell {\r\n  background-color: $date-selection-bg-color;\r\n}\r\n\r\n\r\n.rbc-show-more {\r\n  @extend .rbc-ellipsis;\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n  z-index: $event-zindex;\r\n  font-weight: bold;\r\n  font-size: 85%;\r\n  height: auto;\r\n  line-height: normal;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rbc-month-view {\r\n  position: relative;\r\n  border: 1px solid $calendar-border;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  width: 100%;\r\n  user-select: none;\r\n\r\n  height: 100%; // ie-fix\r\n\r\n  .rbc-header {\r\n    border-bottom: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-header + .rbc-header {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & .rbc-header + .rbc-header {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-month-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.rbc-month-row {\r\n  display: flex;\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  overflow: hidden;\r\n\r\n  height: 100%; // ie-fix\r\n\r\n  & + & {\r\n    border-top: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-date-cell {\r\n  padding-right: 5px;\r\n  text-align: right;\r\n  flex: 1 1;\r\n\r\n  &.rbc-now {\r\n    font-weight: bold;\r\n  }\r\n\r\n  > a {\r\n    &, &:active, &:visited {\r\n      color: inherit;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-row-bg {\r\n  @extend .rbc-abs-full;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1 0 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.rbc-day-bg {\r\nflex: 1 0;\r\n  & + & {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & + & {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-off-range-bg {\r\n    background: $gray-100;\r\n}\r\n\r\n.rbc-overlay {\r\n  position: absolute;\r\n  z-index: $event-zindex + 1;\r\n  border: 1px solid #e5e5e5;\r\n  background-color: #fff;\r\n  box-shadow: 0 5px 15px rgba(0,0,0,.25);\r\n  padding: 10px;\r\n\r\n  > * + * {\r\n    margin-top: 1px;\r\n  }\r\n}\r\n\r\n.rbc-overlay-header {\r\n  border-bottom: 1px solid #e5e5e5;\r\n  margin: -10px -10px 5px -10px ;\r\n  padding: 2px 10px;\r\n}\r\n","\r\n.rbc-agenda-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  overflow: auto;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid $cell-border;\r\n\r\n    tbody > tr > td {\r\n      padding: 5px 10px;\r\n      vertical-align: top;\r\n\r\n    }\r\n\r\n    .rbc-agenda-time-cell {\r\n      padding-left: 15px;\r\n      padding-right: 15px;\r\n      text-transform: lowercase;\r\n    }\r\n\r\n    tbody > tr > td + td {\r\n      border-left: 1px solid $cell-border;\r\n    }\r\n\r\n    .rbc-rtl & {\r\n      tbody > tr > td + td {\r\n        border-left-width: 0;\r\n        border-right: 1px solid $cell-border;\r\n      }\r\n    }\r\n\r\n    tbody > tr + tr {\r\n      border-top: 1px solid $cell-border;\r\n    }\r\n\r\n    thead > tr > th {\r\n      padding: 3px 5px;\r\n      text-align: left;\r\n      border-bottom: 1px solid $cell-border;\r\n\r\n      .rbc-rtl & {\r\n        text-align: right;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-agenda-time-cell {\r\n  text-transform: lowercase;\r\n\r\n  .rbc-continues-after:after {\r\n    content: ' »'\r\n  }\r\n  .rbc-continues-prior:before {\r\n    content: '« '\r\n  }\r\n}\r\n\r\n.rbc-agenda-date-cell,\r\n.rbc-agenda-time-cell {\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n.rbc-agenda-event-cell {\r\n  width: 100%\r\n}\r\n","@import 'variables';\r\n\r\n\r\n.rbc-time-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100%;\r\n\r\n  .rbc-timeslot-group {\r\n    flex: 1;\r\n  }\r\n}\r\n\r\n\r\n.rbc-timeslot-group {\r\n  border-bottom: 1px solid $cell-border;\r\n  min-height: 40px;\r\n  display: flex;\r\n  flex-flow: column nowrap;\r\n}\r\n\r\n.rbc-time-gutter,\r\n.rbc-header-gutter {\r\n  flex: none;\r\n}\r\n\r\n.rbc-label {\r\n  padding: 0 5px;\r\n}\r\n\r\n.rbc-day-slot {\r\n  position: relative;\r\n\r\n  .rbc-event {\r\n    border: 1px solid $event-border;\r\n    display: flex;\r\n    max-height: 100%;\r\n    flex-flow: column wrap;\r\n    align-items: flex-start;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .rbc-event-label {\r\n    flex: none;\r\n    padding-right: 5px;\r\n    width: auto;\r\n  }\r\n\r\n  .rbc-event-content {\r\n    width: 100%;\r\n    flex: 1 1 0;\r\n    word-wrap: break-word;\r\n    line-height: 1;\r\n    height: 100%;\r\n    min-height: 1em;\r\n  }\r\n\r\n  .rbc-time-slot {\r\n    border-top: 1px solid tint-color($cell-border, 10%);\r\n  }\r\n}\r\n\r\n.rbc-time-slot {\r\n  flex: 1 0 0;\r\n\r\n  &.rbc-now {\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.rbc-day-header {\r\n  text-align: center;\r\n}\r\n\r\n.rbc-day-slot .rbc-event {\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n","@import 'variables';\r\n@import 'time-column';\r\n\r\n.rbc-slot-selection {\r\n  z-index: 10;\r\n  position: absolute;\r\n  cursor: default;\r\n  background-color: $time-selection-bg-color;\r\n  color: $time-selection-color;\r\n  font-size: 75%;\r\n  padding: 3px;\r\n}\r\n\r\n.rbc-time-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  width: 100%;\r\n  border: 1px solid $calendar-border;\r\n  min-height: 0;\r\n\r\n  .rbc-time-gutter {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .rbc-allday-cell {\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n\r\n  .rbc-allday-events {\r\n    position: relative;\r\n    z-index: 4;\r\n  }\r\n\r\n  .rbc-row {\r\n    min-height: 20px;\r\n  }\r\n}\r\n\r\n\r\n.rbc-time-header {\r\n  display: flex;\r\n  flex: 0 0 auto; // should not shrink below height\r\n  flex-direction: column;\r\n\r\n  &.rbc-overflowing {\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl &.rbc-overflowing {\r\n    border-right-width: 0;\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-row > * + * {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & > .rbc-row > * + * {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-row:first-child {\r\n    border-bottom: 1px solid  $cell-border;\r\n  }\r\n\r\n  .rbc-gutter-cell {\r\n    flex: none;\r\n  }\r\n\r\n  > .rbc-gutter-cell + * {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.rbc-time-content {\r\n  display: flex;\r\n  flex: 1 0 0%;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n  border-top: 2px solid $calendar-border;\r\n  overflow-y: auto;\r\n  position: relative;\r\n\r\n  > .rbc-time-gutter {\r\n    flex: none;\r\n  }\r\n\r\n  > * + * > * {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & > * + * > * {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-day-slot {\r\n    width: 100%;\r\n    user-select: none;\r\n  }\r\n}\r\n\r\n.rbc-current-time-indicator {\r\n  position: absolute;\r\n  z-index: 1;\r\n  left: 0;\r\n  height: 1px;\r\n\r\n  background-color: $current-time-color;\r\n  pointer-events: none;\r\n\r\n  &::before {\r\n    display: block;\r\n\r\n    position: absolute;\r\n    left: -3px;\r\n    top: -3px;\r\n\r\n    content: ' ';\r\n    background-color: $current-time-color;\r\n\r\n    border-radius: 50%;\r\n    width: 8px;\r\n    height: 8px;\r\n  }\r\n\r\n  .rbc-rtl &::before {\r\n    left: 0;\r\n    right: -3px;\r\n  }\r\n}\r\n","// Layout Splitter\r\n\r\n.handle-bar {\r\n  background: transparent !important;\r\n  @include border-radius(30px);\r\n\r\n  &:active,\r\n  &:hover,\r\n  &.handle-bar_clone {\r\n    background-color: $gray-200 !important;\r\n  }\r\n\r\n  &.resize-not-allowed:hover {\r\n    background-color: $gray-200;\r\n  }\r\n\r\n  .handle-bar_drag {\r\n    border-color: $primary !important;\r\n  }\r\n}","/**\r\n * Extra class applied to VirtualScroll through className prop\r\n */\r\n.rst__virtualScrollOverride {\r\n  overflow: auto !important;\r\n}\r\n\r\n.ReactVirtualized__Grid__innerScrollContainer {\r\n  overflow: visible !important;\r\n}\r\n\r\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\r\n  direction: rtl;\r\n}\r\n\r\n.ReactVirtualized__Grid {\r\n  outline: none;\r\n}\r\n\r\n.rst__node {\r\n  min-width: 100%;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  text-align: left;\r\n}\r\n\r\n.rst__node.rst__rtl {\r\n  text-align: right;\r\n}\r\n\r\n.rst__nodeContent {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n}\r\n\r\n/* ==========================================================================\r\n   Scaffold\r\n\r\n    Line-overlaid blocks used for showing the tree structure\r\n   ========================================================================== */\r\n.rst__lineBlock,\r\n.rst__absoluteLineBlock {\r\n  height: 100%;\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.rst__absoluteLineBlock {\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.rst__lineHalfHorizontalRight::before,\r\n.rst__lineFullVertical::after,\r\n.rst__lineHalfVerticalTop::after,\r\n.rst__lineHalfVerticalBottom::after {\r\n  position: absolute;\r\n  content: '';\r\n  background-color: black;\r\n}\r\n\r\n/**\r\n * +-----+\r\n * |     |\r\n * |  +--+\r\n * |     |\r\n * +-----+\r\n */\r\n.rst__lineHalfHorizontalRight::before {\r\n  height: 1px;\r\n  top: 50%;\r\n  right: 0;\r\n  width: 50%;\r\n}\r\n\r\n.rst__rtl.rst__lineHalfHorizontalRight::before {\r\n  left: 0;\r\n  right: initial;\r\n}\r\n\r\n.rst__lineFullVertical::after,\r\n.rst__lineHalfVerticalTop::after,\r\n.rst__lineHalfVerticalBottom::after {\r\n  width: 1px;\r\n  left: 50%;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n.rst__rtl.rst__lineFullVertical::after,\r\n.rst__rtl.rst__lineHalfVerticalTop::after,\r\n.rst__rtl.rst__lineHalfVerticalBottom::after {\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n.rst__lineHalfVerticalTop::after {\r\n  height: 50%;\r\n}\r\n\r\n.rst__lineHalfVerticalBottom::after {\r\n  top: auto;\r\n  bottom: 0;\r\n  height: 50%;\r\n}\r\n\r\n/* Highlight line for pointing to dragged row destination\r\n   ========================================================================== */\r\n.rst__highlightLineVertical {\r\n  z-index: 3;\r\n}\r\n.rst__highlightLineVertical::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-color: $primary;\r\n  width: 8px;\r\n  margin-left: -4px;\r\n  left: 50%;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n.rst__rtl.rst__highlightLineVertical::before {\r\n  margin-left: initial;\r\n  margin-right: -4px;\r\n  left: initial;\r\n  right: 50%;\r\n}\r\n\r\n@keyframes arrow-pulse {\r\n  0% {\r\n    transform: translate(0, 0);\r\n    opacity: 0;\r\n  }\r\n  30% {\r\n    transform: translate(0, 300%);\r\n    opacity: 1;\r\n  }\r\n  70% {\r\n    transform: translate(0, 700%);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: translate(0, 1000%);\r\n    opacity: 0;\r\n  }\r\n}\r\n.rst__highlightLineVertical::after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 0;\r\n  margin-left: -4px;\r\n  left: 50%;\r\n  top: 0;\r\n  border-left: 4px solid transparent;\r\n  border-right: 4px solid transparent;\r\n  border-top: 4px solid white;\r\n  animation: arrow-pulse 1s infinite linear both;\r\n}\r\n\r\n.rst__rtl.rst__highlightLineVertical::after {\r\n  margin-left: initial;\r\n  margin-right: -4px;\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n/**\r\n * +-----+\r\n * |     |\r\n * |  +--+\r\n * |  |  |\r\n * +--+--+\r\n */\r\n.rst__highlightTopLeftCorner::before {\r\n  z-index: 3;\r\n  content: '';\r\n  position: absolute;\r\n  border-top: solid 8px $primary;\r\n  border-left: solid 8px $primary;\r\n  box-sizing: border-box;\r\n  height: calc(50% + 4px);\r\n  top: 50%;\r\n  margin-top: -4px;\r\n  right: 0;\r\n  width: calc(50% + 4px);\r\n}\r\n\r\n.rst__rtl.rst__highlightTopLeftCorner::before {\r\n  border-right: solid 8px $primary;\r\n  border-left: none;\r\n  left: 0;\r\n  right: initial;\r\n}\r\n\r\n/**\r\n * +--+--+\r\n * |  |  |\r\n * |  |  |\r\n * |  +->|\r\n * +-----+\r\n */\r\n.rst__highlightBottomLeftCorner {\r\n  z-index: 3;\r\n}\r\n.rst__highlightBottomLeftCorner::before {\r\n  content: '';\r\n  position: absolute;\r\n  border-bottom: solid 8px $primary;\r\n  border-left: solid 8px $primary;\r\n  box-sizing: border-box;\r\n  height: calc(100% + 4px);\r\n  top: 0;\r\n  right: 12px;\r\n  width: calc(50% - 8px);\r\n}\r\n\r\n.rst__rtl.rst__highlightBottomLeftCorner::before {\r\n  border-right: solid 8px $primary;\r\n  border-left: none;\r\n  left: 12px;\r\n  right: initial;\r\n}\r\n\r\n.rst__highlightBottomLeftCorner::after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 0;\r\n  right: 0;\r\n  top: 100%;\r\n  margin-top: -12px;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n  border-left: 12px solid $primary;\r\n}\r\n\r\n.rst__rtl.rst__highlightBottomLeftCorner::after {\r\n  left: 0;\r\n  right: initial;\r\n  border-right: 12px solid $primary;\r\n  border-left: none;\r\n}\r\n\r\n.rst__rowWrapper {\r\n  padding: 10px 10px 10px 0;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rst__rtl.rst__rowWrapper {\r\n  padding: 10px 0 10px 10px;\r\n}\r\n\r\n.rst__row {\r\n  height: 100%;\r\n  white-space: nowrap;\r\n  display: flex;\r\n}\r\n.rst__row > * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/**\r\n * The outline of where the element will go if dropped, displayed while dragging\r\n */\r\n.rst__rowLandingPad,\r\n.rst__rowCancelPad {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n}\r\n.rst__rowLandingPad > *,\r\n.rst__rowCancelPad > * {\r\n  opacity: 0 !important;\r\n}\r\n.rst__rowLandingPad::before,\r\n.rst__rowCancelPad::before {\r\n  background-color: lightblue;\r\n  border: 1px dashed $white;\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n}\r\n\r\n/**\r\n * Alternate appearance of the landing pad when the dragged location is invalid\r\n */\r\n.rst__rowCancelPad::before {\r\n  background-color: #e6a8ad;\r\n}\r\n\r\n/**\r\n * Nodes matching the search conditions are highlighted\r\n */\r\n.rst__rowSearchMatch {\r\n  outline: solid 3px #0080ff;\r\n}\r\n\r\n/**\r\n * The node that matches the search conditions and is currently focused\r\n */\r\n.rst__rowSearchFocus {\r\n  outline: solid 3px #fc6421;\r\n}\r\n\r\n.rst__rowContents,\r\n.rst__rowLabel,\r\n.rst__rowToolbar,\r\n.rst__moveHandle,\r\n.rst__toolbarButton {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rst__rowContents {\r\n  position: relative;\r\n  height: 100%;\r\n  border: solid $gray-300 1px;\r\n  border-left: none;\r\n  padding: 0 5px 0 10px;\r\n  border-radius: 2px;\r\n  min-width: 230px;\r\n  flex: 1 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: white;\r\n}\r\n\r\n.rst__rtl.rst__rowContents {\r\n  border-right: none;\r\n  border-left: solid $gray-300 1px;\r\n  padding: 0 10px 0 5px;\r\n}\r\n\r\n.rst__rowContentsDragDisabled {\r\n  border-left: solid $gray-300 1px;\r\n}\r\n\r\n.rst__rtl.rst__rowContentsDragDisabled {\r\n  border-right: solid $gray-300 1px;\r\n  border-left: solid $gray-300 1px;\r\n}\r\n\r\n.rst__rowLabel {\r\n  flex: 0 1 auto;\r\n  padding-right: 20px;\r\n}\r\n.rst__rtl.rst__rowLabel {\r\n  padding-left: 20px;\r\n  padding-right: inherit;\r\n}\r\n\r\n.rst__rowToolbar {\r\n  flex: 0 1 auto;\r\n  display: flex;\r\n}\r\n\r\n.rst__moveHandle,\r\n.rst__loadingHandle {\r\n  height: 100%;\r\n  width: 44px;\r\n  background: $gray-200\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')\r\n  no-repeat center;\r\n  border: solid #aaa 1px;\r\n  cursor: move;\r\n  border-radius: 1px;\r\n  z-index: 1;\r\n}\r\n\r\n.rst__loadingHandle {\r\n  cursor: default;\r\n  background: $gray-200;\r\n}\r\n\r\n@keyframes pointFade {\r\n  0%,\r\n  19.999%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  20% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.rst__loadingCircle {\r\n  width: 80%;\r\n  height: 80%;\r\n  margin: 10%;\r\n  position: relative;\r\n}\r\n\r\n.rst__loadingCirclePoint {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.rst__rtl.rst__loadingCirclePoint {\r\n  right: 0;\r\n  left: initial;\r\n}\r\n\r\n.rst__loadingCirclePoint::before {\r\n  content: '';\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 11%;\r\n  height: 30%;\r\n  background-color: $white;\r\n  border-radius: 30%;\r\n  animation: pointFade 800ms infinite ease-in-out both;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(1) {\r\n  transform: rotate(0deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7) {\r\n  transform: rotate(180deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(1)::before,\r\n.rst__loadingCirclePoint:nth-of-type(7)::before {\r\n  animation-delay: -800ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(2) {\r\n  transform: rotate(30deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(8) {\r\n  transform: rotate(210deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(2)::before,\r\n.rst__loadingCirclePoint:nth-of-type(8)::before {\r\n  animation-delay: -666ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(3) {\r\n  transform: rotate(60deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(9) {\r\n  transform: rotate(240deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(3)::before,\r\n.rst__loadingCirclePoint:nth-of-type(9)::before {\r\n  animation-delay: -533ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(4) {\r\n  transform: rotate(90deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(10) {\r\n  transform: rotate(270deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(4)::before,\r\n.rst__loadingCirclePoint:nth-of-type(10)::before {\r\n  animation-delay: -400ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(5) {\r\n  transform: rotate(120deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(11) {\r\n  transform: rotate(300deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(5)::before,\r\n.rst__loadingCirclePoint:nth-of-type(11)::before {\r\n  animation-delay: -266ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(6) {\r\n  transform: rotate(150deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(12) {\r\n  transform: rotate(330deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(6)::before,\r\n.rst__loadingCirclePoint:nth-of-type(12)::before {\r\n  animation-delay: -133ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7) {\r\n  transform: rotate(180deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(13) {\r\n  transform: rotate(360deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7)::before,\r\n.rst__loadingCirclePoint:nth-of-type(13)::before {\r\n  animation-delay: 0ms;\r\n}\r\n\r\n.rst__rowTitle {\r\n  font-weight: bold;\r\n}\r\n\r\n.rst__rowTitleWithSubtitle {\r\n  font-size: 85%;\r\n  display: block;\r\n  height: 0.8rem;\r\n}\r\n\r\n.rst__rowSubtitle {\r\n  font-size: 70%;\r\n  line-height: 1;\r\n}\r\n\r\n.rst__collapseButton,\r\n.rst__expandButton {\r\n  appearance: none;\r\n  border: none;\r\n  position: absolute;\r\n  border-radius: 100%;\r\n  box-shadow: 0 0 0 1px #000;\r\n  width: 16px;\r\n  height: 16px;\r\n  padding: 0;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  cursor: pointer;\r\n}\r\n.rst__rtl.rst__collapseButton,\r\n.rst__rtl.rst__expandButton {\r\n  transform: translate(50%, -50%);\r\n}\r\n.rst__collapseButton:focus,\r\n.rst__expandButton:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\r\n}\r\n.rst__collapseButton:hover:not(:active),\r\n.rst__expandButton:hover:not(:active) {\r\n  background-size: 24px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.rst__collapseButton {\r\n  background: $white\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')\r\n  no-repeat center;\r\n}\r\n\r\n.rst__expandButton {\r\n  background: $white\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')\r\n  no-repeat center;\r\n}\r\n\r\n/**\r\n * Line for under a node with children\r\n */\r\n.rst__lineChildren {\r\n  height: 100%;\r\n  display: inline-block;\r\n  position: absolute;\r\n}\r\n.rst__lineChildren::after {\r\n  content: '';\r\n  position: absolute;\r\n  background-color: black;\r\n  width: 1px;\r\n  left: 50%;\r\n  bottom: 0;\r\n  height: 10px;\r\n}\r\n\r\n.rst__rtl.rst__lineChildren::after {\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n.rst__placeholder {\r\n  position: relative;\r\n  height: 68px;\r\n  max-width: 300px;\r\n  padding: 10px;\r\n}\r\n.rst__placeholder,\r\n.rst__placeholder > * {\r\n  box-sizing: border-box;\r\n}\r\n.rst__placeholder::before {\r\n  border: 3px dashed $gray-200;\r\n  content: '';\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  bottom: 5px;\r\n  left: 5px;\r\n  z-index: -1;\r\n}\r\n\r\n/**\r\n * The outline of where the element will go if dropped, displayed while dragging\r\n */\r\n.rst__placeholderLandingPad,\r\n.rst__placeholderCancelPad {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n}\r\n.rst__placeholderLandingPad *,\r\n.rst__placeholderCancelPad * {\r\n  opacity: 0 !important;\r\n}\r\n.rst__placeholderLandingPad::before,\r\n.rst__placeholderCancelPad::before {\r\n  background-color: lightblue;\r\n  border-color: white;\r\n}\r\n\r\n/**\r\n * Alternate appearance of the landing pad when the dragged location is invalid\r\n */\r\n.rst__placeholderCancelPad::before {\r\n  background-color: #e6a8ad;\r\n}\r\n\r\n/* Collection default theme */\r\n\r\n.ReactVirtualized__Collection {\r\n}\r\n\r\n.ReactVirtualized__Collection__innerScrollContainer {\r\n}\r\n\r\n/* Grid default theme */\r\n\r\n.ReactVirtualized__Grid {\r\n}\r\n\r\n.ReactVirtualized__Grid__innerScrollContainer {\r\n}\r\n\r\n/* Table default theme */\r\n\r\n.ReactVirtualized__Table {\r\n}\r\n\r\n.ReactVirtualized__Table__Grid {\r\n}\r\n\r\n.ReactVirtualized__Table__headerRow {\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.ReactVirtualized__Table__row {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.ReactVirtualized__Table__headerTruncatedText {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn,\r\n.ReactVirtualized__Table__rowColumn {\r\n  margin-right: 10px;\r\n  min-width: 0px;\r\n}\r\n.ReactVirtualized__Table__rowColumn {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn:first-of-type,\r\n.ReactVirtualized__Table__rowColumn:first-of-type {\r\n  margin-left: 10px;\r\n}\r\n.ReactVirtualized__Table__sortableHeaderColumn {\r\n  cursor: pointer;\r\n}\r\n\r\n.ReactVirtualized__Table__sortableHeaderIconContainer {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.ReactVirtualized__Table__sortableHeaderIcon {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 24px;\r\n  flex: 0 0 24px;\r\n  height: 1em;\r\n  width: 1em;\r\n  fill: currentColor;\r\n}\r\n\r\n/* List default theme */\r\n\r\n.ReactVirtualized__List {\r\n}","@use \"sass:math\";\r\n\r\n.ReactTable {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n\r\n  .rt-table {\r\n    flex: auto 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    overflow: auto\r\n  }\r\n\r\n  .-pagination input,\r\n  .-pagination select,\r\n  .rt-thead.-filters input,\r\n  .rt-thead.-filters select {\r\n    display: block;\r\n    width: 100%;\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n    background-clip: padding-box;\r\n    border: $input-border-width solid $input-border-color;\r\n\r\n    height: $input-height-sm;\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    // line-height: $input-line-height-sm;\r\n    @include border-radius($input-border-radius-sm);\r\n\r\n    @if $enable-rounded {\r\n      border-radius: $input-border-radius;\r\n    } @else {\r\n      border-radius: 0;\r\n    }\r\n\r\n    @include box-shadow($input-box-shadow);\r\n    @include transition($input-transition);\r\n\r\n    &::-ms-expand {\r\n      background-color: transparent;\r\n      border: 0;\r\n    }\r\n\r\n    // @include form-control-focus();\r\n\r\n    // Placeholder\r\n    &::placeholder {\r\n      color: $input-placeholder-color;\r\n      opacity: 1;\r\n    }\r\n\r\n    &:disabled,\r\n    &[readonly] {\r\n      background-color: $input-disabled-bg;\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  .rt-thead {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    user-select: none;\r\n\r\n    &.-headerGroups {\r\n      background: rgba(0, 0, 0, 0.03);\r\n      border-bottom: 1px solid $table-border-color;\r\n\r\n      .rt-th,\r\n      .rt-td {\r\n        padding: $table-cell-padding-sm;\r\n        color: $table-head-color;\r\n\r\n        &:hover {\r\n          color: $table-head-color;\r\n        }\r\n\r\n        &:empty {\r\n          padding: 0;\r\n        }\r\n      }\r\n\r\n    }\r\n\r\n    &.-filters {\r\n      border-bottom: 1px solid $table-border-color;\r\n      background: $gray-100;\r\n\r\n      .rt-th {\r\n        border-right: 1px solid $table-border-color\r\n      }\r\n\r\n      &.-header {\r\n        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15)\r\n      }\r\n    }\r\n\r\n    .rt-tr {\r\n      text-align: center\r\n    }\r\n\r\n    .rt-th,\r\n    .rt-td {\r\n      padding: $table-cell-padding;\r\n      line-height: normal;\r\n      position: relative;\r\n      font-weight: bold;\r\n      border-right: 1px solid $table-border-color;\r\n      border-bottom: 1px solid $table-border-color;\r\n      transition: box-shadow .3s cubic-bezier(.175, .885, .32, 1.275);\r\n      box-shadow: inset 0 0 0 0 transparent;\r\n      color: $primary;\r\n\r\n      &:hover {\r\n        color: shade-color($primary, 15%);\r\n      }\r\n    }\r\n\r\n    .rt-th.-sort-asc,\r\n    .rt-td.-sort-asc {\r\n      box-shadow: inset 0 3px 0 0 $primary\r\n    }\r\n\r\n    .rt-th.-sort-desc,\r\n    .rt-td.-sort-desc {\r\n      box-shadow: inset 0 -3px 0 0 $primary\r\n    }\r\n\r\n    .rt-th.-cursor-pointer,\r\n    .rt-td.-cursor-pointer {\r\n      cursor: pointer\r\n    }\r\n\r\n    .rt-th:last-child,\r\n    .rt-td:last-child {\r\n      border-right: 0\r\n    }\r\n\r\n    .rt-resizable-header {\r\n      overflow: visible;\r\n    }\r\n\r\n    .rt-resizable-header:last-child {\r\n      overflow: hidden\r\n    }\r\n\r\n    .rt-resizable-header-content {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis\r\n    }\r\n\r\n    .rt-header-pivot {\r\n      border-right-color: #f7f7f7\r\n    }\r\n\r\n    .rt-header-pivot:after,\r\n    .rt-header-pivot:before {\r\n      left: 100%;\r\n      top: 50%;\r\n      border: solid transparent;\r\n      content: \" \";\r\n      height: 0;\r\n      width: 0;\r\n      position: absolute;\r\n      pointer-events: none\r\n    }\r\n\r\n    .rt-header-pivot:after {\r\n      border-color: rgba(255, 255, 255, 0);\r\n      border-left-color: $white;\r\n      border-width: 8px;\r\n      margin-top: -8px\r\n    }\r\n\r\n    .rt-header-pivot:before {\r\n      border-color: rgba(102, 102, 102, 0);\r\n      border-left-color: #f7f7f7;\r\n      border-width: 10px;\r\n      margin-top: -10px\r\n    }\r\n  }\r\n\r\n  .rt-tbody {\r\n    flex: 99999 1 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n\r\n    .rt-tr-group {\r\n      border-bottom: solid 1px $table-border-color;\r\n    }\r\n\r\n    .rt-tr-group:last-child {\r\n      border-bottom: 0\r\n    }\r\n\r\n    .rt-td {\r\n      border-right: 1px solid $table-border-color;\r\n      align-items: center;\r\n      align-content: center;\r\n      display: flex;\r\n\r\n      [contenteditable=\"true\"] {\r\n        width: 100%;\r\n        border: 1px solid transparent;\r\n        background: $white !important;\r\n        @include border-radius($input-border-radius-sm);\r\n\r\n        &:focus {\r\n          padding: 3px 5px;\r\n          border-color: $input-focus-border-color;\r\n          outline: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .rt-td:last-child {\r\n      border-right: 0\r\n    }\r\n\r\n    .rt-expandable {\r\n      cursor: pointer;\r\n      text-overflow: clip\r\n    }\r\n  }\r\n\r\n  .rt-tr-group {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch\r\n  }\r\n\r\n  .rt-tr {\r\n    flex: 1 0 auto;\r\n    display: inline-flex\r\n  }\r\n\r\n  .rt-th,\r\n  .rt-td {\r\n    flex: 1 0 0;\r\n    text-overflow: ellipsis;\r\n    padding: $table-cell-padding;\r\n    //overflow: hidden;\r\n    transition: .3s ease;\r\n    transition-property: width, min-width, padding, opacity;\r\n\r\n    &.-hidden {\r\n      width: 0 !important;\r\n      min-width: 0 !important;\r\n      padding: 0 !important;\r\n      border: 0 !important;\r\n      opacity: 0 !important\r\n    }\r\n  }\r\n\r\n  .rt-expander {\r\n    display: inline-block;\r\n    position: relative;\r\n    color: transparent;\r\n    margin: 0 10px 0 0;\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%) rotate(-90deg);\r\n      border-left: 5.04px solid transparent;\r\n      border-right: 5.04px solid transparent;\r\n      border-top: 7px solid rgba(0, 0, 0, 0.8);\r\n      transition: all .3s cubic-bezier(.175, .885, .32, 1.275);\r\n      cursor: pointer\r\n    }\r\n    &.-open:after {\r\n      transform: translate(-50%, -50%) rotate(0)\r\n    }\r\n  }\r\n\r\n  .rt-resizer {\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 36px;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: -18px;\r\n    cursor: col-resize;\r\n    z-index: 10\r\n  }\r\n\r\n  .rt-tfoot {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\r\n\r\n    .rt-td {\r\n      border-right: 1px solid $table-border-color;\r\n      &:last-child {\r\n        border-right: 0\r\n      }\r\n    }\r\n  }\r\n\r\n  &.-striped .rt-tr.-odd {\r\n    background: rgba(0, 0, 0, 0.03)\r\n  }\r\n\r\n  &.-fixed {\r\n    .-header {\r\n      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\r\n    }\r\n\r\n    .pagination-bottom {\r\n      box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\r\n    }\r\n  }\r\n\r\n  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\r\n    background: $dropdown-link-hover-bg\r\n  }\r\n\r\n  .-pagination {\r\n    z-index: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: stretch;\r\n    flex-wrap: wrap;\r\n    padding: 3px;\r\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\r\n\r\n    .-btn {\r\n      appearance: none;\r\n      display: block;\r\n      width: 100%;\r\n      height: 100%;\r\n      border: 0;\r\n      border-radius: $border-radius;\r\n      padding: 6px;\r\n      font-size: 1em;\r\n      color: $primary;\r\n      background: $gray-100;\r\n      transition: all .2s ease;\r\n      cursor: pointer;\r\n      outline: none;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .-btn[disabled] {\r\n      opacity: .5;\r\n      cursor: default\r\n    }\r\n\r\n    .-btn:not([disabled]):hover {\r\n      background: $primary;\r\n      color: $white\r\n    }\r\n\r\n    .-previous,\r\n    .-next {\r\n      flex: 1;\r\n      text-align: center\r\n    }\r\n\r\n    .-center {\r\n      text-align: center;\r\n      margin-bottom: 0;\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n      justify-content: space-around\r\n    }\r\n\r\n    .-totalPages {\r\n      padding-left: 5px;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .-pageInfo {\r\n      display: inherit;\r\n      margin: 3px 0 3px 10px;\r\n      white-space: nowrap;\r\n      height: 30px;\r\n      line-height: 30px;\r\n    }\r\n\r\n    .-pageJump {\r\n      display: inline-block;\r\n      margin: 0 5px;\r\n    }\r\n\r\n    .-pageJump input {\r\n      width: 70px;\r\n      text-align: center\r\n    }\r\n\r\n    .-pageSizeOptions {\r\n      margin: 3px 10px\r\n    }\r\n  }\r\n\r\n  .rt-noData {\r\n    display: block;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all .3s ease;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n    padding: 20px;\r\n    color: rgba(0, 0, 0, 0.5)\r\n  }\r\n\r\n  .-loading {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all .3s ease;\r\n    z-index: -1;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .-loading > div {\r\n    position: absolute;\r\n    display: block;\r\n    text-align: center;\r\n    width: 100%;\r\n    top: 50%;\r\n    left: 0;\r\n    font-size: 15px;\r\n    color: $primary;\r\n    transform: translateY(-52%);\r\n    transition: all .3s cubic-bezier(.25, .46, .45, .94)\r\n  }\r\n\r\n  .-loading.-active {\r\n    opacity: 1;\r\n    z-index: 2;\r\n    pointer-events: all;\r\n  }\r\n\r\n  .-loading.-active > div {\r\n    transform: translateY(50%)\r\n  }\r\n\r\n  .rt-resizing .rt-th,\r\n  .rt-resizing .rt-td {\r\n    transition: none !important;\r\n    cursor: col-resize;\r\n    user-select: none\r\n  }\r\n\r\n}\r\n\r\n.table thead th,\r\n.table td {\r\n  vertical-align: middle;\r\n}\r\n\r\n.table {\r\n  th .filter {\r\n    margin-top: math.div($layout-spacer-x, 4);\r\n    height: auto;\r\n    padding: 0.3rem 0.5rem;\r\n  }\r\n}\r\n\r\n.caret-4-asc,\r\n.caret-4-desc {\r\n  font-family: 'Linearicons-Free';\r\n  speak: none;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n  margin-left: math.div($layout-spacer-x, 4);\r\n}\r\n\r\n.table .sortable:hover {\r\n  .caret-4-asc,\r\n  .caret-4-desc {\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n.caret-4-asc {\r\n  @extend .lnr-chevron-up !optional;\r\n}\r\n\r\n.caret-4-desc {\r\n  @extend .lnr-chevron-down !optional;\r\n}\r\n\r\n// Table sizing\r\n\r\n.table-lg {\r\n  th,\r\n  td {\r\n    padding: ($table-cell-padding * 2) ($table-cell-padding * 1.5);\r\n  }\r\n}\r\n\r\n//react-data-table-component  css\r\n\r\n.rdt_Table {\r\n  border: 1px solid rgba(0,0,0,.1);\r\n}\r\n\r\n.rdt_TableCol {\r\n  padding: 0.55rem;\r\n  line-height: normal;\r\n  position: relative;\r\n  font-weight: 700;\r\n  border-right: 1px solid #e9ecef;\r\n  border-bottom: 1px solid #e9ecef;\r\n  transition: box-shadow .3s cubic-bezier(.175,.885,.32,1.275);\r\n  box-shadow: inset 0 0 0 0 transparent;\r\n  color: #545cd8;\r\n}\r\n\r\n.rdt_TableCell {\r\n  border-right: 1px solid #e9ecef;\r\n}\r\n\r\n.rdt_TableRow:nth-child(odd) {\r\n  background-color: #FFFFFF;\r\n}\r\n.rdt_TableRow:nth-child(even) {\r\n  background-color: #f7f7f7;\r\n}\r\n\r\n.rdt_TableRow:hover {\r\n  background-color: $dropdown-link-hover-bg;\r\n}","// Linear Icons\r\n$linearicons-font-path: \"linearicons\";\r\n\r\n\r\n@font-face {\r\n  font-family: 'Linearicons-Free';\r\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?w118d');\r\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?#iefixw118d') format('embedded-opentype'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.woff2?w118d') format('woff2'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.woff?w118d') format('woff'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.ttf?w118d') format('truetype'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.svg?w118d#Linearicons-Free') format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n[class^=\"lnr-\"],\r\n[class*=\" lnr-\"] {\r\n  font-family: 'Linearicons-Free';\r\n  speak: none;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n\r\n  /* Better Font Rendering =========== */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.lnr-home:before {\r\n  content: \"\\e800\";\r\n}\r\n.lnr-apartment:before {\r\n  content: \"\\e801\";\r\n}\r\n.lnr-pencil:before {\r\n  content: \"\\e802\";\r\n}\r\n.lnr-magic-wand:before {\r\n  content: \"\\e803\";\r\n}\r\n.lnr-drop:before {\r\n  content: \"\\e804\";\r\n}\r\n.lnr-lighter:before {\r\n  content: \"\\e805\";\r\n}\r\n.lnr-poop:before {\r\n  content: \"\\e806\";\r\n}\r\n.lnr-sun:before {\r\n  content: \"\\e807\";\r\n}\r\n.lnr-moon:before {\r\n  content: \"\\e808\";\r\n}\r\n.lnr-cloud:before {\r\n  content: \"\\e809\";\r\n}\r\n.lnr-cloud-upload:before {\r\n  content: \"\\e80a\";\r\n}\r\n.lnr-cloud-download:before {\r\n  content: \"\\e80b\";\r\n}\r\n.lnr-cloud-sync:before {\r\n  content: \"\\e80c\";\r\n}\r\n.lnr-cloud-check:before {\r\n  content: \"\\e80d\";\r\n}\r\n.lnr-database:before {\r\n  content: \"\\e80e\";\r\n}\r\n.lnr-lock:before {\r\n  content: \"\\e80f\";\r\n}\r\n.lnr-cog:before {\r\n  content: \"\\e810\";\r\n}\r\n.lnr-trash:before {\r\n  content: \"\\e811\";\r\n}\r\n.lnr-dice:before {\r\n  content: \"\\e812\";\r\n}\r\n.lnr-heart:before {\r\n  content: \"\\e813\";\r\n}\r\n.lnr-star:before {\r\n  content: \"\\e814\";\r\n}\r\n.lnr-star-half:before {\r\n  content: \"\\e815\";\r\n}\r\n.lnr-star-empty:before {\r\n  content: \"\\e816\";\r\n}\r\n.lnr-flag:before {\r\n  content: \"\\e817\";\r\n}\r\n.lnr-envelope:before {\r\n  content: \"\\e818\";\r\n}\r\n.lnr-paperclip:before {\r\n  content: \"\\e819\";\r\n}\r\n.lnr-inbox:before {\r\n  content: \"\\e81a\";\r\n}\r\n.lnr-eye:before {\r\n  content: \"\\e81b\";\r\n}\r\n.lnr-printer:before {\r\n  content: \"\\e81c\";\r\n}\r\n.lnr-file-empty:before {\r\n  content: \"\\e81d\";\r\n}\r\n.lnr-file-add:before {\r\n  content: \"\\e81e\";\r\n}\r\n.lnr-enter:before {\r\n  content: \"\\e81f\";\r\n}\r\n.lnr-exit:before {\r\n  content: \"\\e820\";\r\n}\r\n.lnr-graduation-hat:before {\r\n  content: \"\\e821\";\r\n}\r\n.lnr-license:before {\r\n  content: \"\\e822\";\r\n}\r\n.lnr-music-note:before {\r\n  content: \"\\e823\";\r\n}\r\n.lnr-film-play:before {\r\n  content: \"\\e824\";\r\n}\r\n.lnr-camera-video:before {\r\n  content: \"\\e825\";\r\n}\r\n.lnr-camera:before {\r\n  content: \"\\e826\";\r\n}\r\n.lnr-picture:before {\r\n  content: \"\\e827\";\r\n}\r\n.lnr-book:before {\r\n  content: \"\\e828\";\r\n}\r\n.lnr-bookmark:before {\r\n  content: \"\\e829\";\r\n}\r\n.lnr-user:before {\r\n  content: \"\\e82a\";\r\n}\r\n.lnr-users:before {\r\n  content: \"\\e82b\";\r\n}\r\n.lnr-shirt:before {\r\n  content: \"\\e82c\";\r\n}\r\n.lnr-store:before {\r\n  content: \"\\e82d\";\r\n}\r\n.lnr-cart:before {\r\n  content: \"\\e82e\";\r\n}\r\n.lnr-tag:before {\r\n  content: \"\\e82f\";\r\n}\r\n.lnr-phone-handset:before {\r\n  content: \"\\e830\";\r\n}\r\n.lnr-phone:before {\r\n  content: \"\\e831\";\r\n}\r\n.lnr-pushpin:before {\r\n  content: \"\\e832\";\r\n}\r\n.lnr-map-marker:before {\r\n  content: \"\\e833\";\r\n}\r\n.lnr-map:before {\r\n  content: \"\\e834\";\r\n}\r\n.lnr-location:before {\r\n  content: \"\\e835\";\r\n}\r\n.lnr-calendar-full:before {\r\n  content: \"\\e836\";\r\n}\r\n.lnr-keyboard:before {\r\n  content: \"\\e837\";\r\n}\r\n.lnr-spell-check:before {\r\n  content: \"\\e838\";\r\n}\r\n.lnr-screen:before {\r\n  content: \"\\e839\";\r\n}\r\n.lnr-smartphone:before {\r\n  content: \"\\e83a\";\r\n}\r\n.lnr-tablet:before {\r\n  content: \"\\e83b\";\r\n}\r\n.lnr-laptop:before {\r\n  content: \"\\e83c\";\r\n}\r\n.lnr-laptop-phone:before {\r\n  content: \"\\e83d\";\r\n}\r\n.lnr-power-switch:before {\r\n  content: \"\\e83e\";\r\n}\r\n.lnr-bubble:before {\r\n  content: \"\\e83f\";\r\n}\r\n.lnr-heart-pulse:before {\r\n  content: \"\\e840\";\r\n}\r\n.lnr-construction:before {\r\n  content: \"\\e841\";\r\n}\r\n.lnr-pie-chart:before {\r\n  content: \"\\e842\";\r\n}\r\n.lnr-chart-bars:before {\r\n  content: \"\\e843\";\r\n}\r\n.lnr-gift:before {\r\n  content: \"\\e844\";\r\n}\r\n.lnr-diamond:before {\r\n  content: \"\\e845\";\r\n}\r\n.lnr-linearicons:before {\r\n  content: \"\\e846\";\r\n}\r\n.lnr-dinner:before {\r\n  content: \"\\e847\";\r\n}\r\n.lnr-coffee-cup:before {\r\n  content: \"\\e848\";\r\n}\r\n.lnr-leaf:before {\r\n  content: \"\\e849\";\r\n}\r\n.lnr-paw:before {\r\n  content: \"\\e84a\";\r\n}\r\n.lnr-rocket:before {\r\n  content: \"\\e84b\";\r\n}\r\n.lnr-briefcase:before {\r\n  content: \"\\e84c\";\r\n}\r\n.lnr-bus:before {\r\n  content: \"\\e84d\";\r\n}\r\n.lnr-car:before {\r\n  content: \"\\e84e\";\r\n}\r\n.lnr-train:before {\r\n  content: \"\\e84f\";\r\n}\r\n.lnr-bicycle:before {\r\n  content: \"\\e850\";\r\n}\r\n.lnr-wheelchair:before {\r\n  content: \"\\e851\";\r\n}\r\n.lnr-select:before {\r\n  content: \"\\e852\";\r\n}\r\n.lnr-earth:before {\r\n  content: \"\\e853\";\r\n}\r\n.lnr-smile:before {\r\n  content: \"\\e854\";\r\n}\r\n.lnr-sad:before {\r\n  content: \"\\e855\";\r\n}\r\n.lnr-neutral:before {\r\n  content: \"\\e856\";\r\n}\r\n.lnr-mustache:before {\r\n  content: \"\\e857\";\r\n}\r\n.lnr-alarm:before {\r\n  content: \"\\e858\";\r\n}\r\n.lnr-bullhorn:before {\r\n  content: \"\\e859\";\r\n}\r\n.lnr-volume-high:before {\r\n  content: \"\\e85a\";\r\n}\r\n.lnr-volume-medium:before {\r\n  content: \"\\e85b\";\r\n}\r\n.lnr-volume-low:before {\r\n  content: \"\\e85c\";\r\n}\r\n.lnr-volume:before {\r\n  content: \"\\e85d\";\r\n}\r\n.lnr-mic:before {\r\n  content: \"\\e85e\";\r\n}\r\n.lnr-hourglass:before {\r\n  content: \"\\e85f\";\r\n}\r\n.lnr-undo:before {\r\n  content: \"\\e860\";\r\n}\r\n.lnr-redo:before {\r\n  content: \"\\e861\";\r\n}\r\n.lnr-sync:before {\r\n  content: \"\\e862\";\r\n}\r\n.lnr-history:before {\r\n  content: \"\\e863\";\r\n}\r\n.lnr-clock:before {\r\n  content: \"\\e864\";\r\n}\r\n.lnr-download:before {\r\n  content: \"\\e865\";\r\n}\r\n.lnr-upload:before {\r\n  content: \"\\e866\";\r\n}\r\n.lnr-enter-down:before {\r\n  content: \"\\e867\";\r\n}\r\n.lnr-exit-up:before {\r\n  content: \"\\e868\";\r\n}\r\n.lnr-bug:before {\r\n  content: \"\\e869\";\r\n}\r\n.lnr-code:before {\r\n  content: \"\\e86a\";\r\n}\r\n.lnr-link:before {\r\n  content: \"\\e86b\";\r\n}\r\n.lnr-unlink:before {\r\n  content: \"\\e86c\";\r\n}\r\n.lnr-thumbs-up:before {\r\n  content: \"\\e86d\";\r\n}\r\n.lnr-thumbs-down:before {\r\n  content: \"\\e86e\";\r\n}\r\n.lnr-magnifier:before {\r\n  content: \"\\e86f\";\r\n}\r\n.lnr-cross:before {\r\n  content: \"\\e870\";\r\n}\r\n.lnr-menu:before {\r\n  content: \"\\e871\";\r\n}\r\n.lnr-list:before {\r\n  content: \"\\e872\";\r\n}\r\n.lnr-chevron-up:before {\r\n  content: \"\\e873\";\r\n}\r\n.lnr-chevron-down:before {\r\n  content: \"\\e874\";\r\n}\r\n.lnr-chevron-left:before {\r\n  content: \"\\e875\";\r\n}\r\n.lnr-chevron-right:before {\r\n  content: \"\\e876\";\r\n}\r\n.lnr-arrow-up:before {\r\n  content: \"\\e877\";\r\n}\r\n.lnr-arrow-down:before {\r\n  content: \"\\e878\";\r\n}\r\n.lnr-arrow-left:before {\r\n  content: \"\\e879\";\r\n}\r\n.lnr-arrow-right:before {\r\n  content: \"\\e87a\";\r\n}\r\n.lnr-move:before {\r\n  content: \"\\e87b\";\r\n}\r\n.lnr-warning:before {\r\n  content: \"\\e87c\";\r\n}\r\n.lnr-question-circle:before {\r\n  content: \"\\e87d\";\r\n}\r\n.lnr-menu-circle:before {\r\n  content: \"\\e87e\";\r\n}\r\n.lnr-checkmark-circle:before {\r\n  content: \"\\e87f\";\r\n}\r\n.lnr-cross-circle:before {\r\n  content: \"\\e880\";\r\n}\r\n.lnr-plus-circle:before {\r\n  content: \"\\e881\";\r\n}\r\n.lnr-circle-minus:before {\r\n  content: \"\\e882\";\r\n}\r\n.lnr-arrow-up-circle:before {\r\n  content: \"\\e883\";\r\n}\r\n.lnr-arrow-down-circle:before {\r\n  content: \"\\e884\";\r\n}\r\n.lnr-arrow-left-circle:before {\r\n  content: \"\\e885\";\r\n}\r\n.lnr-arrow-right-circle:before {\r\n  content: \"\\e886\";\r\n}\r\n.lnr-chevron-up-circle:before {\r\n  content: \"\\e887\";\r\n}\r\n.lnr-chevron-down-circle:before {\r\n  content: \"\\e888\";\r\n}\r\n.lnr-chevron-left-circle:before {\r\n  content: \"\\e889\";\r\n}\r\n.lnr-chevron-right-circle:before {\r\n  content: \"\\e88a\";\r\n}\r\n.lnr-crop:before {\r\n  content: \"\\e88b\";\r\n}\r\n.lnr-frame-expand:before {\r\n  content: \"\\e88c\";\r\n}\r\n.lnr-frame-contract:before {\r\n  content: \"\\e88d\";\r\n}\r\n.lnr-layers:before {\r\n  content: \"\\e88e\";\r\n}\r\n.lnr-funnel:before {\r\n  content: \"\\e88f\";\r\n}\r\n.lnr-text-format:before {\r\n  content: \"\\e890\";\r\n}\r\n.lnr-text-format-remove:before {\r\n  content: \"\\e891\";\r\n}\r\n.lnr-text-size:before {\r\n  content: \"\\e892\";\r\n}\r\n.lnr-bold:before {\r\n  content: \"\\e893\";\r\n}\r\n.lnr-italic:before {\r\n  content: \"\\e894\";\r\n}\r\n.lnr-underline:before {\r\n  content: \"\\e895\";\r\n}\r\n.lnr-strikethrough:before {\r\n  content: \"\\e896\";\r\n}\r\n.lnr-highlight:before {\r\n  content: \"\\e897\";\r\n}\r\n.lnr-text-align-left:before {\r\n  content: \"\\e898\";\r\n}\r\n.lnr-text-align-center:before {\r\n  content: \"\\e899\";\r\n}\r\n.lnr-text-align-right:before {\r\n  content: \"\\e89a\";\r\n}\r\n.lnr-text-align-justify:before {\r\n  content: \"\\e89b\";\r\n}\r\n.lnr-line-spacing:before {\r\n  content: \"\\e89c\";\r\n}\r\n.lnr-indent-increase:before {\r\n  content: \"\\e89d\";\r\n}\r\n.lnr-indent-decrease:before {\r\n  content: \"\\e89e\";\r\n}\r\n.lnr-pilcrow:before {\r\n  content: \"\\e89f\";\r\n}\r\n.lnr-direction-ltr:before {\r\n  content: \"\\e8a0\";\r\n}\r\n.lnr-direction-rtl:before {\r\n  content: \"\\e8a1\";\r\n}\r\n.lnr-page-break:before {\r\n  content: \"\\e8a2\";\r\n}\r\n.lnr-sort-alpha-asc:before {\r\n  content: \"\\e8a3\";\r\n}\r\n.lnr-sort-amount-asc:before {\r\n  content: \"\\e8a4\";\r\n}\r\n.lnr-hand:before {\r\n  content: \"\\e8a5\";\r\n}\r\n.lnr-pointer-up:before {\r\n  content: \"\\e8a6\";\r\n}\r\n.lnr-pointer-right:before {\r\n  content: \"\\e8a7\";\r\n}\r\n.lnr-pointer-down:before {\r\n  content: \"\\e8a8\";\r\n}\r\n.lnr-pointer-left:before {\r\n  content: \"\\e8a9\";\r\n}\r\n","/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n\n@import \"variables\";\n@import \"path\";\n@import \"core\";\n@import \"helper\";\n@import \"icons\";\n","@font-face {\n\tfont-family: 'Pe-icon-7-stroke';\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?d7yf1v');\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?#iefixd7yf1v') format('embedded-opentype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.woff?d7yf1v') format('woff'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.ttf?d7yf1v') format('truetype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke') format('svg');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n","[class^=\"#{$font-prefix}-\"], [class*=\" #{$font-prefix}-\"] {\n\tdisplay: inline-block;\n\tfont-family: 'Pe-icon-7-stroke';\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n","\n/* HELPER CLASS\n * -------------------------- */\n\n/* FA based classes */\n\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: $font-size-base * 1.33;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 2 * $font-size-base;\n}\n\n.pe-3x {\n  font-size: 3 * $font-size-base;\n}\n\n.pe-4x {\n  font-size: 4 * $font-size-base;\n}\n\n.pe-5x {\n  font-size: 5 * $font-size-base;\n}\n\n.pe-fw {\n  width: 1.2857142857142858em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.142857142857143em;\n  list-style-type: none;\n  \n  & > li {\n    position: relative;\n  }\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.142857142857143em;\n  width: 2.142857142857143em;\n  top: 0.14285714285714285em;\n  text-align: center;\n\n  &.pe-lg {\n    left: -1.8571428571428572em;\n  }\n}\n\n.pe-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: .1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe {\n  &.pull-left {\n    float: left;\n    margin-right: .3em;\n    margin-left: .3em;\n  }\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n",".#{$font-prefix}-album:before {\n  content: $font-var-album;\n}\n\n.#{$font-prefix}-arc:before {\n  content: $font-var-arc;\n}\n.#{$font-prefix}-back-2:before {\n  content: $font-var-back-2;\n}\n.#{$font-prefix}-bandaid:before {\n  content: $font-var-bandaid;\n}\n.#{$font-prefix}-car:before {\n  content: $font-var-car;\n}\n.#{$font-prefix}-diamond:before {\n  content: $font-var-diamond;\n}\n.#{$font-prefix}-door-lock:before {\n  content: $font-var-door-lock;\n}\n.#{$font-prefix}-eyedropper:before {\n  content: $font-var-eyedropper;\n}\n.#{$font-prefix}-female:before {\n  content: $font-var-female;\n}\n.#{$font-prefix}-gym:before {\n  content: $font-var-gym;\n}\n.#{$font-prefix}-hammer:before {\n  content: $font-var-hammer;\n}\n.#{$font-prefix}-headphones:before {\n  content: $font-var-headphones;\n}\n.#{$font-prefix}-helm:before {\n  content: $font-var-helm;\n}\n.#{$font-prefix}-hourglass:before {\n  content: $font-var-hourglass;\n}\n.#{$font-prefix}-leaf:before {\n  content: $font-var-leaf;\n}\n.#{$font-prefix}-magic-wand:before {\n  content: $font-var-magic-wand;\n}\n.#{$font-prefix}-male:before {\n  content: $font-var-male;\n}\n.#{$font-prefix}-map-2:before {\n  content: $font-var-map-2;\n}\n.#{$font-prefix}-next-2:before {\n  content: $font-var-next-2;\n}\n.#{$font-prefix}-paint-bucket:before {\n  content: $font-var-paint-bucket;\n}\n.#{$font-prefix}-pendrive:before {\n  content: $font-var-pendrive;\n}\n.#{$font-prefix}-photo:before {\n  content: $font-var-photo;\n}\n.#{$font-prefix}-piggy:before {\n  content: $font-var-piggy;\n}\n.#{$font-prefix}-plugin:before {\n  content: $font-var-plugin;\n}\n.#{$font-prefix}-refresh-2:before {\n  content: $font-var-refresh-2;\n}\n.#{$font-prefix}-rocket:before {\n  content: $font-var-rocket;\n}\n.#{$font-prefix}-settings:before {\n  content: $font-var-settings;\n}\n.#{$font-prefix}-shield:before {\n  content: $font-var-shield;\n}\n.#{$font-prefix}-smile:before {\n  content: $font-var-smile;\n}\n.#{$font-prefix}-usb:before {\n  content: $font-var-usb;\n}\n.#{$font-prefix}-vector:before {\n  content: $font-var-vector;\n}\n.#{$font-prefix}-wine:before {\n  content: $font-var-wine;\n}\n.#{$font-prefix}-cloud-upload:before {\n  content: $font-var-cloud-upload;\n}\n.#{$font-prefix}-cash:before {\n  content: $font-var-cash;\n}\n.#{$font-prefix}-close:before {\n  content: $font-var-close;\n}\n.#{$font-prefix}-bluetooth:before {\n  content: $font-var-bluetooth;\n}\n.#{$font-prefix}-cloud-download:before {\n  content: $font-var-cloud-download;\n}\n.#{$font-prefix}-way:before {\n  content: $font-var-way;\n}\n.#{$font-prefix}-close-circle:before {\n  content: $font-var-close-circle;\n}\n.#{$font-prefix}-id:before {\n  content: $font-var-id;\n}\n.#{$font-prefix}-angle-up:before {\n  content: $font-var-angle-up;\n}\n.#{$font-prefix}-wristwatch:before {\n  content: $font-var-wristwatch;\n}\n.#{$font-prefix}-angle-up-circle:before {\n  content: $font-var-angle-up-circle;\n}\n.#{$font-prefix}-world:before {\n  content: $font-var-world;\n}\n.#{$font-prefix}-angle-right:before {\n  content: $font-var-angle-right;\n}\n.#{$font-prefix}-volume:before {\n  content: $font-var-volume;\n}\n.#{$font-prefix}-angle-right-circle:before {\n  content: $font-var-angle-right-circle;\n}\n.#{$font-prefix}-users:before {\n  content: $font-var-users;\n}\n.#{$font-prefix}-angle-left:before {\n  content: $font-var-angle-left;\n}\n.#{$font-prefix}-user-female:before {\n  content: $font-var-user-female;\n}\n.#{$font-prefix}-angle-left-circle:before {\n  content: $font-var-angle-left-circle;\n}\n.#{$font-prefix}-up-arrow:before {\n  content: $font-var-up-arrow;\n}\n.#{$font-prefix}-angle-down:before {\n  content: $font-var-angle-down;\n}\n.#{$font-prefix}-switch:before {\n  content: $font-var-switch;\n}\n.#{$font-prefix}-angle-down-circle:before {\n  content: $font-var-angle-down-circle;\n}\n.#{$font-prefix}-scissors:before {\n  content: $font-var-scissors;\n}\n.#{$font-prefix}-wallet:before {\n  content: $font-var-wallet;\n}\n.#{$font-prefix}-safe:before {\n  content: $font-var-safe;\n}\n.#{$font-prefix}-volume2:before {\n  content: $font-var-volume2;\n}\n.#{$font-prefix}-volume1:before {\n  content: $font-var-volume1;\n}\n.#{$font-prefix}-voicemail:before {\n  content: $font-var-voicemail;\n}\n.#{$font-prefix}-video:before {\n  content: $font-var-video;\n}\n.#{$font-prefix}-user:before {\n  content: $font-var-user;\n}\n.#{$font-prefix}-upload:before {\n  content: $font-var-upload;\n}\n.#{$font-prefix}-unlock:before {\n  content: $font-var-unlock;\n}\n.#{$font-prefix}-umbrella:before {\n  content: $font-var-umbrella;\n}\n.#{$font-prefix}-trash:before {\n  content: $font-var-trash;\n}\n.#{$font-prefix}-tools:before {\n  content: $font-var-tools;\n}\n.#{$font-prefix}-timer:before {\n  content: $font-var-timer;\n}\n.#{$font-prefix}-ticket:before {\n  content: $font-var-ticket;\n}\n.#{$font-prefix}-target:before {\n  content: $font-var-target;\n}\n.#{$font-prefix}-sun:before {\n  content: $font-var-sun;\n}\n.#{$font-prefix}-study:before {\n  content: $font-var-study;\n}\n.#{$font-prefix}-stopwatch:before {\n  content: $font-var-stopwatch;\n}\n.#{$font-prefix}-star:before {\n  content: $font-var-star;\n}\n.#{$font-prefix}-speaker:before {\n  content: $font-var-speaker;\n}\n.#{$font-prefix}-signal:before {\n  content: $font-var-signal;\n}\n.#{$font-prefix}-shuffle:before {\n  content: $font-var-shuffle;\n}\n.#{$font-prefix}-shopbag:before {\n  content: $font-var-shopbag;\n}\n.#{$font-prefix}-share:before {\n  content: $font-var-share;\n}\n.#{$font-prefix}-server:before {\n  content: $font-var-server;\n}\n.#{$font-prefix}-search:before {\n  content: $font-var-search;\n}\n.#{$font-prefix}-film:before {\n  content: $font-var-film;\n}\n.#{$font-prefix}-science:before {\n  content: $font-var-science;\n}\n.#{$font-prefix}-disk:before {\n  content: $font-var-disk;\n}\n.#{$font-prefix}-ribbon:before {\n  content: $font-var-ribbon;\n}\n.#{$font-prefix}-repeat:before {\n  content: $font-var-repeat;\n}\n.#{$font-prefix}-refresh:before {\n  content: $font-var-refresh;\n}\n.#{$font-prefix}-add-user:before {\n  content: $font-var-add-user;\n}\n.#{$font-prefix}-refresh-cloud:before {\n  content: $font-var-refresh-cloud;\n}\n.#{$font-prefix}-paperclip:before {\n  content: $font-var-paperclip;\n}\n.#{$font-prefix}-radio:before {\n  content: $font-var-radio;\n}\n.#{$font-prefix}-note2:before {\n  content: $font-var-note2;\n}\n.#{$font-prefix}-print:before {\n  content: $font-var-print;\n}\n.#{$font-prefix}-network:before {\n  content: $font-var-network;\n}\n.#{$font-prefix}-prev:before {\n  content: $font-var-prev;\n}\n.#{$font-prefix}-mute:before {\n  content: $font-var-mute;\n}\n.#{$font-prefix}-power:before {\n  content: $font-var-power;\n}\n.#{$font-prefix}-medal:before {\n  content: $font-var-medal;\n}\n.#{$font-prefix}-portfolio:before {\n  content: $font-var-portfolio;\n}\n.#{$font-prefix}-like2:before {\n  content: $font-var-like2;\n}\n.#{$font-prefix}-plus:before {\n  content: $font-var-plus;\n}\n.#{$font-prefix}-left-arrow:before {\n  content: $font-var-left-arrow;\n}\n.#{$font-prefix}-play:before {\n  content: $font-var-play;\n}\n.#{$font-prefix}-key:before {\n  content: $font-var-key;\n}\n.#{$font-prefix}-plane:before {\n  content: $font-var-plane;\n}\n.#{$font-prefix}-joy:before {\n  content: $font-var-joy;\n}\n.#{$font-prefix}-photo-gallery:before {\n  content: $font-var-photo-gallery;\n}\n.#{$font-prefix}-pin:before {\n  content: $font-var-pin;\n}\n.#{$font-prefix}-phone:before {\n  content: $font-var-phone;\n}\n.#{$font-prefix}-plug:before {\n  content: $font-var-plug;\n}\n.#{$font-prefix}-pen:before {\n  content: $font-var-pen;\n}\n.#{$font-prefix}-right-arrow:before {\n  content: $font-var-right-arrow;\n}\n.#{$font-prefix}-paper-plane:before {\n  content: $font-var-paper-plane;\n}\n.#{$font-prefix}-delete-user:before {\n  content: $font-var-delete-user;\n}\n.#{$font-prefix}-paint:before {\n  content: $font-var-paint;\n}\n.#{$font-prefix}-bottom-arrow:before {\n  content: $font-var-bottom-arrow;\n}\n.#{$font-prefix}-notebook:before {\n  content: $font-var-notebook;\n}\n.#{$font-prefix}-note:before {\n  content: $font-var-note;\n}\n.#{$font-prefix}-next:before {\n  content: $font-var-next;\n}\n.#{$font-prefix}-news-paper:before {\n  content: $font-var-news-paper;\n}\n.#{$font-prefix}-musiclist:before {\n  content: $font-var-musiclist;\n}\n.#{$font-prefix}-music:before {\n  content: $font-var-music;\n}\n.#{$font-prefix}-mouse:before {\n  content: $font-var-mouse;\n}\n.#{$font-prefix}-more:before {\n  content: $font-var-more;\n}\n.#{$font-prefix}-moon:before {\n  content: $font-var-moon;\n}\n.#{$font-prefix}-monitor:before {\n  content: $font-var-monitor;\n}\n.#{$font-prefix}-micro:before {\n  content: $font-var-micro;\n}\n.#{$font-prefix}-menu:before {\n  content: $font-var-menu;\n}\n.#{$font-prefix}-map:before {\n  content: $font-var-map;\n}\n.#{$font-prefix}-map-marker:before {\n  content: $font-var-map-marker;\n}\n.#{$font-prefix}-mail:before {\n  content: $font-var-mail;\n}\n.#{$font-prefix}-mail-open:before {\n  content: $font-var-mail-open;\n}\n.#{$font-prefix}-mail-open-file:before {\n  content: $font-var-mail-open-file;\n}\n.#{$font-prefix}-magnet:before {\n  content: $font-var-magnet;\n}\n.#{$font-prefix}-loop:before {\n  content: $font-var-loop;\n}\n.#{$font-prefix}-look:before {\n  content: $font-var-look;\n}\n.#{$font-prefix}-lock:before {\n  content: $font-var-lock;\n}\n.#{$font-prefix}-lintern:before {\n  content: $font-var-lintern;\n}\n.#{$font-prefix}-link:before {\n  content: $font-var-link;\n}\n.#{$font-prefix}-like:before {\n  content: $font-var-like;\n}\n.#{$font-prefix}-light:before {\n  content: $font-var-light;\n}\n.#{$font-prefix}-less:before {\n  content: $font-var-less;\n}\n.#{$font-prefix}-keypad:before {\n  content: $font-var-keypad;\n}\n.#{$font-prefix}-junk:before {\n  content: $font-var-junk;\n}\n.#{$font-prefix}-info:before {\n  content: $font-var-info;\n}\n.#{$font-prefix}-home:before {\n  content: $font-var-home;\n}\n.#{$font-prefix}-help2:before {\n  content: $font-var-help2;\n}\n.#{$font-prefix}-help1:before {\n  content: $font-var-help1;\n}\n.#{$font-prefix}-graph3:before {\n  content: $font-var-graph3;\n}\n.#{$font-prefix}-graph2:before {\n  content: $font-var-graph2;\n}\n.#{$font-prefix}-graph1:before {\n  content: $font-var-graph1;\n}\n.#{$font-prefix}-graph:before {\n  content: $font-var-graph;\n}\n.#{$font-prefix}-global:before {\n  content: $font-var-global;\n}\n.#{$font-prefix}-gleam:before {\n  content: $font-var-gleam;\n}\n.#{$font-prefix}-glasses:before {\n  content: $font-var-glasses;\n}\n.#{$font-prefix}-gift:before {\n  content: $font-var-gift;\n}\n.#{$font-prefix}-folder:before {\n  content: $font-var-folder;\n}\n.#{$font-prefix}-flag:before {\n  content: $font-var-flag;\n}\n.#{$font-prefix}-filter:before {\n  content: $font-var-filter;\n}\n.#{$font-prefix}-file:before {\n  content: $font-var-file;\n}\n.#{$font-prefix}-expand1:before {\n  content: $font-var-expand1;\n}\n.#{$font-prefix}-exapnd2:before {\n  content: $font-var-exapnd2;\n}\n.#{$font-prefix}-edit:before {\n  content: $font-var-edit;\n}\n.#{$font-prefix}-drop:before {\n  content: $font-var-drop;\n}\n.#{$font-prefix}-drawer:before {\n  content: $font-var-drawer;\n}\n.#{$font-prefix}-download:before {\n  content: $font-var-download;\n}\n.#{$font-prefix}-display2:before {\n  content: $font-var-display2;\n}\n.#{$font-prefix}-display1:before {\n  content: $font-var-display1;\n}\n.#{$font-prefix}-diskette:before {\n  content: $font-var-diskette;\n}\n.#{$font-prefix}-date:before {\n  content: $font-var-date;\n}\n.#{$font-prefix}-cup:before {\n  content: $font-var-cup;\n}\n.#{$font-prefix}-culture:before {\n  content: $font-var-culture;\n}\n.#{$font-prefix}-crop:before {\n  content: $font-var-crop;\n}\n.#{$font-prefix}-credit:before {\n  content: $font-var-credit;\n}\n.#{$font-prefix}-copy-file:before {\n  content: $font-var-copy-file;\n}\n.#{$font-prefix}-config:before {\n  content: $font-var-config;\n}\n.#{$font-prefix}-compass:before {\n  content: $font-var-compass;\n}\n.#{$font-prefix}-comment:before {\n  content: $font-var-comment;\n}\n.#{$font-prefix}-coffee:before {\n  content: $font-var-coffee;\n}\n.#{$font-prefix}-cloud:before {\n  content: $font-var-cloud;\n}\n.#{$font-prefix}-clock:before {\n  content: $font-var-clock;\n}\n.#{$font-prefix}-check:before {\n  content: $font-var-check;\n}\n.#{$font-prefix}-chat:before {\n  content: $font-var-chat;\n}\n.#{$font-prefix}-cart:before {\n  content: $font-var-cart;\n}\n.#{$font-prefix}-camera:before {\n  content: $font-var-camera;\n}\n.#{$font-prefix}-call:before {\n  content: $font-var-call;\n}\n.#{$font-prefix}-calculator:before {\n  content: $font-var-calculator;\n}\n.#{$font-prefix}-browser:before {\n  content: $font-var-browser;\n}\n.#{$font-prefix}-box2:before {\n  content: $font-var-box2;\n}\n.#{$font-prefix}-box1:before {\n  content: $font-var-box1;\n}\n.#{$font-prefix}-bookmarks:before {\n  content: $font-var-bookmarks;\n}\n.#{$font-prefix}-bicycle:before {\n  content: $font-var-bicycle;\n}\n.#{$font-prefix}-bell:before {\n  content: $font-var-bell;\n}\n.#{$font-prefix}-battery:before {\n  content: $font-var-battery;\n}\n.#{$font-prefix}-ball:before {\n  content: $font-var-ball;\n}\n.#{$font-prefix}-back:before {\n  content: $font-var-back;\n}\n.#{$font-prefix}-attention:before {\n  content: $font-var-attention;\n}\n.#{$font-prefix}-anchor:before {\n  content: $font-var-anchor;\n}\n.#{$font-prefix}-albums:before {\n  content: $font-var-albums;\n}\n.#{$font-prefix}-alarm:before {\n  content: $font-var-alarm;\n}\n.#{$font-prefix}-airplay:before {\n  content: $font-var-airplay;\n}\n","$pe-7s-font-path: \"../fonts\" !default;\n$font-size-base: 1em !default;\n$font-prefix: \"pe-7s\" !default;\n\n$font-var-album: \"\\e6aa\";\n$font-var-arc: \"\\e6ab\";\n$font-var-back-2: \"\\e6ac\";\n$font-var-bandaid: \"\\e6ad\";\n$font-var-car: \"\\e6ae\";\n$font-var-diamond: \"\\e6af\";\n$font-var-door-lock: \"\\e6b0\";\n$font-var-eyedropper: \"\\e6b1\";\n$font-var-female: \"\\e6b2\";\n$font-var-gym: \"\\e6b3\";\n$font-var-hammer: \"\\e6b4\";\n$font-var-headphones: \"\\e6b5\";\n$font-var-helm: \"\\e6b6\";\n$font-var-hourglass: \"\\e6b7\";\n$font-var-leaf: \"\\e6b8\";\n$font-var-magic-wand: \"\\e6b9\";\n$font-var-male: \"\\e6ba\";\n$font-var-map-2: \"\\e6bb\";\n$font-var-next-2: \"\\e6bc\";\n$font-var-paint-bucket: \"\\e6bd\";\n$font-var-pendrive: \"\\e6be\";\n$font-var-photo: \"\\e6bf\";\n$font-var-piggy: \"\\e6c0\";\n$font-var-plugin: \"\\e6c1\";\n$font-var-refresh-2: \"\\e6c2\";\n$font-var-rocket: \"\\e6c3\";\n$font-var-settings: \"\\e6c4\";\n$font-var-shield: \"\\e6c5\";\n$font-var-smile: \"\\e6c6\";\n$font-var-usb: \"\\e6c7\";\n$font-var-vector: \"\\e6c8\";\n$font-var-wine: \"\\e6c9\";\n$font-var-cloud-upload: \"\\e68a\";\n$font-var-cash: \"\\e68c\";\n$font-var-close: \"\\e680\";\n$font-var-bluetooth: \"\\e68d\";\n$font-var-cloud-download: \"\\e68b\";\n$font-var-way: \"\\e68e\";\n$font-var-close-circle: \"\\e681\";\n$font-var-id: \"\\e68f\";\n$font-var-angle-up: \"\\e682\";\n$font-var-wristwatch: \"\\e690\";\n$font-var-angle-up-circle: \"\\e683\";\n$font-var-world: \"\\e691\";\n$font-var-angle-right: \"\\e684\";\n$font-var-volume: \"\\e692\";\n$font-var-angle-right-circle: \"\\e685\";\n$font-var-users: \"\\e693\";\n$font-var-angle-left: \"\\e686\";\n$font-var-user-female: \"\\e694\";\n$font-var-angle-left-circle: \"\\e687\";\n$font-var-up-arrow: \"\\e695\";\n$font-var-angle-down: \"\\e688\";\n$font-var-switch: \"\\e696\";\n$font-var-angle-down-circle: \"\\e689\";\n$font-var-scissors: \"\\e697\";\n$font-var-wallet: \"\\e600\";\n$font-var-safe: \"\\e698\";\n$font-var-volume2: \"\\e601\";\n$font-var-volume1: \"\\e602\";\n$font-var-voicemail: \"\\e603\";\n$font-var-video: \"\\e604\";\n$font-var-user: \"\\e605\";\n$font-var-upload: \"\\e606\";\n$font-var-unlock: \"\\e607\";\n$font-var-umbrella: \"\\e608\";\n$font-var-trash: \"\\e609\";\n$font-var-tools: \"\\e60a\";\n$font-var-timer: \"\\e60b\";\n$font-var-ticket: \"\\e60c\";\n$font-var-target: \"\\e60d\";\n$font-var-sun: \"\\e60e\";\n$font-var-study: \"\\e60f\";\n$font-var-stopwatch: \"\\e610\";\n$font-var-star: \"\\e611\";\n$font-var-speaker: \"\\e612\";\n$font-var-signal: \"\\e613\";\n$font-var-shuffle: \"\\e614\";\n$font-var-shopbag: \"\\e615\";\n$font-var-share: \"\\e616\";\n$font-var-server: \"\\e617\";\n$font-var-search: \"\\e618\";\n$font-var-film: \"\\e6a5\";\n$font-var-science: \"\\e619\";\n$font-var-disk: \"\\e6a6\";\n$font-var-ribbon: \"\\e61a\";\n$font-var-repeat: \"\\e61b\";\n$font-var-refresh: \"\\e61c\";\n$font-var-add-user: \"\\e6a9\";\n$font-var-refresh-cloud: \"\\e61d\";\n$font-var-paperclip: \"\\e69c\";\n$font-var-radio: \"\\e61e\";\n$font-var-note2: \"\\e69d\";\n$font-var-print: \"\\e61f\";\n$font-var-network: \"\\e69e\";\n$font-var-prev: \"\\e620\";\n$font-var-mute: \"\\e69f\";\n$font-var-power: \"\\e621\";\n$font-var-medal: \"\\e6a0\";\n$font-var-portfolio: \"\\e622\";\n$font-var-like2: \"\\e6a1\";\n$font-var-plus: \"\\e623\";\n$font-var-left-arrow: \"\\e6a2\";\n$font-var-play: \"\\e624\";\n$font-var-key: \"\\e6a3\";\n$font-var-plane: \"\\e625\";\n$font-var-joy: \"\\e6a4\";\n$font-var-photo-gallery: \"\\e626\";\n$font-var-pin: \"\\e69b\";\n$font-var-phone: \"\\e627\";\n$font-var-plug: \"\\e69a\";\n$font-var-pen: \"\\e628\";\n$font-var-right-arrow: \"\\e699\";\n$font-var-paper-plane: \"\\e629\";\n$font-var-delete-user: \"\\e6a7\";\n$font-var-paint: \"\\e62a\";\n$font-var-bottom-arrow: \"\\e6a8\";\n$font-var-notebook: \"\\e62b\";\n$font-var-note: \"\\e62c\";\n$font-var-next: \"\\e62d\";\n$font-var-news-paper: \"\\e62e\";\n$font-var-musiclist: \"\\e62f\";\n$font-var-music: \"\\e630\";\n$font-var-mouse: \"\\e631\";\n$font-var-more: \"\\e632\";\n$font-var-moon: \"\\e633\";\n$font-var-monitor: \"\\e634\";\n$font-var-micro: \"\\e635\";\n$font-var-menu: \"\\e636\";\n$font-var-map: \"\\e637\";\n$font-var-map-marker: \"\\e638\";\n$font-var-mail: \"\\e639\";\n$font-var-mail-open: \"\\e63a\";\n$font-var-mail-open-file: \"\\e63b\";\n$font-var-magnet: \"\\e63c\";\n$font-var-loop: \"\\e63d\";\n$font-var-look: \"\\e63e\";\n$font-var-lock: \"\\e63f\";\n$font-var-lintern: \"\\e640\";\n$font-var-link: \"\\e641\";\n$font-var-like: \"\\e642\";\n$font-var-light: \"\\e643\";\n$font-var-less: \"\\e644\";\n$font-var-keypad: \"\\e645\";\n$font-var-junk: \"\\e646\";\n$font-var-info: \"\\e647\";\n$font-var-home: \"\\e648\";\n$font-var-help2: \"\\e649\";\n$font-var-help1: \"\\e64a\";\n$font-var-graph3: \"\\e64b\";\n$font-var-graph2: \"\\e64c\";\n$font-var-graph1: \"\\e64d\";\n$font-var-graph: \"\\e64e\";\n$font-var-global: \"\\e64f\";\n$font-var-gleam: \"\\e650\";\n$font-var-glasses: \"\\e651\";\n$font-var-gift: \"\\e652\";\n$font-var-folder: \"\\e653\";\n$font-var-flag: \"\\e654\";\n$font-var-filter: \"\\e655\";\n$font-var-file: \"\\e656\";\n$font-var-expand1: \"\\e657\";\n$font-var-exapnd2: \"\\e658\";\n$font-var-edit: \"\\e659\";\n$font-var-drop: \"\\e65a\";\n$font-var-drawer: \"\\e65b\";\n$font-var-download: \"\\e65c\";\n$font-var-display2: \"\\e65d\";\n$font-var-display1: \"\\e65e\";\n$font-var-diskette: \"\\e65f\";\n$font-var-date: \"\\e660\";\n$font-var-cup: \"\\e661\";\n$font-var-culture: \"\\e662\";\n$font-var-crop: \"\\e663\";\n$font-var-credit: \"\\e664\";\n$font-var-copy-file: \"\\e665\";\n$font-var-config: \"\\e666\";\n$font-var-compass: \"\\e667\";\n$font-var-comment: \"\\e668\";\n$font-var-coffee: \"\\e669\";\n$font-var-cloud: \"\\e66a\";\n$font-var-clock: \"\\e66b\";\n$font-var-check: \"\\e66c\";\n$font-var-chat: \"\\e66d\";\n$font-var-cart: \"\\e66e\";\n$font-var-camera: \"\\e66f\";\n$font-var-call: \"\\e670\";\n$font-var-calculator: \"\\e671\";\n$font-var-browser: \"\\e672\";\n$font-var-box2: \"\\e673\";\n$font-var-box1: \"\\e674\";\n$font-var-bookmarks: \"\\e675\";\n$font-var-bicycle: \"\\e676\";\n$font-var-bell: \"\\e677\";\n$font-var-battery: \"\\e678\";\n$font-var-ball: \"\\e679\";\n$font-var-back: \"\\e67a\";\n$font-var-attention: \"\\e67b\";\n$font-var-anchor: \"\\e67c\";\n$font-var-albums: \"\\e67d\";\n$font-var-alarm: \"\\e67e\";\n$font-var-airplay: \"\\e67f\";\n","%triangle-arrow {\r\n  margin-left: -$datepicker__triangle-size;\r\n  position: absolute;\r\n\r\n  &,\r\n  &::before {\r\n    box-sizing: content-box;\r\n    position: absolute;\r\n    border: $datepicker__triangle-size solid transparent;\r\n\r\n    height: 0;\r\n    width: 1px;\r\n  }\r\n\r\n  &::before {\r\n    content: \"\";\r\n    z-index: -1;\r\n    border-width: $datepicker__triangle-size;\r\n\r\n    left: -$datepicker__triangle-size;\r\n    border-bottom-color: $datepicker__border-color;\r\n  }\r\n}\r\n\r\n%triangle-arrow-up {\r\n  @extend %triangle-arrow;\r\n\r\n  top: 0;\r\n  margin-top: -$datepicker__triangle-size;\r\n\r\n  &,\r\n  &::before {\r\n    border-top: none;\r\n    border-bottom-color: $datepicker__background-color;\r\n  }\r\n\r\n  &::before {\r\n    top: -1px;\r\n    border-bottom-color: $datepicker__border-color;\r\n  }\r\n}\r\n\r\n%triangle-arrow-down {\r\n  @extend %triangle-arrow;\r\n\r\n  bottom: 0;\r\n  margin-bottom: -$datepicker__triangle-size;\r\n\r\n  &,\r\n  &::before {\r\n    border-bottom: none;\r\n    border-top-color: #fff;\r\n  }\r\n\r\n  &::before {\r\n    bottom: -1px;\r\n    border-top-color: $datepicker__border-color;\r\n  }\r\n}\r\n","// Datepicker\r\n\r\n$datepicker__background-color: $white;\r\n$datepicker__border-color: $gray-300;\r\n$datepicker__highlighted-color: map-get($theme-colors, 'primary');\r\n$datepicker__holidays-color: $orange;\r\n$datepicker__muted-color: $gray-400;\r\n$datepicker__selected-color: map-get($theme-colors, 'primary');\r\n$datepicker__text-color: $gray-700;\r\n$datepicker__header-color: $gray-800;\r\n$datepicker__navigation-disabled-color: shade-color($datepicker__muted-color, 5%)\r\n;\r\n\r\n$datepicker__border-radius: $border-radius;\r\n$datepicker__day-margin: 0.166rem;\r\n$datepicker__font-size: $font-size-base;\r\n$datepicker__font-family: $font-family-base;\r\n$datepicker__item-size: 2rem;\r\n$datepicker__margin: 0.5rem;\r\n$datepicker__navigation-size: 0.35rem;\r\n$datepicker__triangle-size: 6px;","@import \"variables\";\r\n@import \"mixins\";\r\n\r\n.react-datepicker-wrapper {\r\n  display: block;\r\n  z-index: 10;\r\n}\r\n\r\n.react-datepicker {\r\n  background-color: $white;\r\n  color: $datepicker__text-color;\r\n  border: 1px solid $datepicker__border-color;\r\n  border-radius: $datepicker__border-radius;\r\n  display: inline-block;\r\n  position: relative;\r\n\r\n  box-shadow: $box-shadow-default;\r\n}\r\n\r\n.react-datepicker--time-only {\r\n  .react-datepicker__triangle {\r\n    left: 35px;\r\n  }\r\n\r\n  .react-datepicker__time-container {\r\n    border-left: 0;\r\n  }\r\n\r\n  .react-datepicker__time {\r\n    border-radius: 0.3rem;\r\n  }\r\n\r\n  .react-datepicker__time-box {\r\n    border-radius: 0.3rem;\r\n  }\r\n}\r\n\r\n.react-datepicker__triangle {\r\n  position: absolute;\r\n  left: 50px;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 102;\r\n\r\n  &[data-placement^=\"bottom\"] {\r\n    margin-top: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-up;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"top\"] {\r\n    margin-bottom: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-down;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"right\"] {\r\n    margin-left: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: auto;\r\n      right: 42px;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"left\"] {\r\n    margin-right: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: 42px;\r\n      right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__header {\r\n  text-align: center;\r\n  background-color: $datepicker__background-color;\r\n  border-bottom: 1px solid $datepicker__border-color;\r\n  border-top-left-radius: $datepicker__border-radius;\r\n  border-top-right-radius: $datepicker__border-radius;\r\n  padding-top: 10px;\r\n  position: relative;\r\n\r\n  &--time {\r\n    padding-bottom: 8px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown-container--select,\r\n.react-datepicker__month-dropdown-container--select,\r\n.react-datepicker__month-year-dropdown-container--select,\r\n.react-datepicker__year-dropdown-container--scroll,\r\n.react-datepicker__month-dropdown-container--scroll,\r\n.react-datepicker__month-year-dropdown-container--scroll {\r\n  display: inline-block;\r\n  margin: 0 2px;\r\n}\r\n\r\n.react-datepicker__current-month,\r\n.react-datepicker-time__header {\r\n  margin-top: 0;\r\n  color: $datepicker__header-color;\r\n  font-weight: bold;\r\n  font-size: $datepicker__font-size * 1.1;\r\n}\r\n\r\n.react-datepicker-time__header {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-datepicker__navigation {\r\n  background: none;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 15px;\r\n  padding: 0;\r\n  border: $datepicker__navigation-size solid transparent;\r\n  z-index: 1;\r\n  height: 10px;\r\n  width: 10px;\r\n  text-indent: -999em;\r\n  overflow: hidden;\r\n\r\n  &--previous {\r\n    left: 10px;\r\n    border-right-color: $datepicker__muted-color;\r\n\r\n    &:hover {\r\n      border-right-color: shade-color($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-right-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  &--next {\r\n    right: 10px;\r\n    border-left-color: $datepicker__muted-color;\r\n    &--with-time:not(&--with-today-button) {\r\n      right: 80px;\r\n    }\r\n\r\n    &:hover {\r\n      border-left-color: shade-color($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-left-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  &--years {\r\n    position: relative;\r\n    top: 0;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    &-previous {\r\n      top: 4px;\r\n      border-top-color: $datepicker__muted-color;\r\n\r\n      &:hover {\r\n        border-top-color: shade-color($datepicker__muted-color, 10%);\r\n      }\r\n    }\r\n\r\n    &-upcoming {\r\n      top: -4px;\r\n      border-bottom-color: $datepicker__muted-color;\r\n\r\n      &:hover {\r\n        border-bottom-color: shade-color($datepicker__muted-color, 10%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__month-container {\r\n  float: left;\r\n}\r\n\r\n.react-datepicker__month {\r\n  margin: $datepicker__margin;\r\n  text-align: center;\r\n}\r\n\r\n.react-datepicker__time-container {\r\n  float: right;\r\n  border-left: 1px solid $datepicker__border-color;\r\n  width: 120px;\r\n\r\n  &--with-today-button {\r\n    display: inline;\r\n    border: 1px solid #aeaeae;\r\n    border-radius: 0.3rem;\r\n    position: absolute;\r\n    right: -122px;\r\n    top: 0;\r\n  }\r\n\r\n  .react-datepicker__time {\r\n    position: relative;\r\n    background: white;\r\n\r\n    .react-datepicker__time-box {\r\n      width: 120px;\r\n      overflow-x: hidden;\r\n      margin: 0 auto;\r\n      text-align: center;\r\n      ul.react-datepicker__time-list {\r\n        list-style: none;\r\n        margin: 0;\r\n        padding: 0;\r\n        height: calc(195px + (#{$datepicker__item-size} / 2));\r\n        overflow-y: scroll;\r\n        width: 100%;\r\n        box-sizing: content-box;\r\n\r\n        li.react-datepicker__time-list-item {\r\n          padding: 5px 10px;\r\n          &:hover {\r\n            cursor: pointer;\r\n            background-color: $dropdown-link-hover-bg;\r\n          }\r\n          &--selected {\r\n            background-color: $datepicker__selected-color;\r\n            color: $white;\r\n            font-weight: bold;\r\n            &:hover {\r\n              background-color: $datepicker__selected-color;\r\n            }\r\n          }\r\n          &--disabled {\r\n            color: $datepicker__muted-color;\r\n\r\n            &:hover {\r\n              cursor: default;\r\n              background-color: transparent;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__week-number {\r\n  color: $datepicker__muted-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n  &.react-datepicker__week-number--clickable {\r\n    cursor: pointer;\r\n    &:hover {\r\n      border-radius: $datepicker__border-radius;\r\n      background-color: $datepicker__background-color;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  background: $gray-100;\r\n  border-top: $gray-300 solid 1px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.react-datepicker__day-names,\r\n.react-datepicker__week {\r\n  white-space: nowrap;\r\n}\r\n\r\n.react-datepicker__day-name,\r\n.react-datepicker__day,\r\n.react-datepicker__time-name {\r\n  color: $datepicker__text-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n}\r\n\r\n.react-datepicker__day {\r\n  cursor: pointer;\r\n  @include border-radius($datepicker__border-radius);\r\n\r\n  &:hover {\r\n    background-color: $primary;\r\n    color: $white;\r\n  }\r\n\r\n  &--today {\r\n    font-weight: bold;\r\n  }\r\n\r\n  &--highlighted {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__highlighted-color;\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: shade-color($datepicker__highlighted-color, 5%);\r\n    }\r\n\r\n    &-custom-1 {\r\n      color: $warning;\r\n    }\r\n\r\n    &-custom-2 {\r\n      color: $focus;\r\n    }\r\n  }\r\n\r\n  &--selected {\r\n    background-color: map-get($theme-colors, 'primary');\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: map-get($theme-colors, 'primary');\r\n      color: $white;\r\n    }\r\n  }\r\n\r\n  &--in-selecting-range,\r\n  &--in-range {\r\n    background-color: $dropdown-link-hover-bg;\r\n    color: $dropdown-link-hover-color;\r\n\r\n    &:hover {\r\n      background-color: $dropdown-link-hover-bg;\r\n      color: $dropdown-link-hover-color;\r\n    }\r\n\r\n  }\r\n\r\n  &--keyboard-selected {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: tint-color(map-get($theme-colors, 'primary'), 10%);\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: shade-color(map-get($theme-colors, 'primary'), 5%);\r\n    }\r\n  }\r\n\r\n  &--in-selecting-range:not(&--in-range) {\r\n    background-color: $dropdown-link-hover-bg;\r\n  }\r\n\r\n  &--in-range:not(&--in-selecting-range) {\r\n    .react-datepicker__month--selecting-range & {\r\n      background-color: map-get($theme-colors, 'primary');\r\n      color: $white;\r\n    }\r\n  }\r\n\r\n  &--disabled {\r\n    cursor: default;\r\n    color: $datepicker__muted-color;\r\n\r\n    &:hover {\r\n      background-color: transparent;\r\n      color: $datepicker__muted-color;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.react-datepicker__day--selecting-range-start,\r\n.react-datepicker__day--selecting-range-end {\r\n  background-color: map-get($theme-colors, 'primary')  !important;\r\n  color: $white !important;\r\n}\r\n\r\n.react-datepicker__year-read-view,\r\n.react-datepicker__month-read-view,\r\n.react-datepicker__month-year-read-view {\r\n  border: 1px solid transparent;\r\n  border-radius: $datepicker__border-radius;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n\r\n    .react-datepicker__year-read-view--down-arrow,\r\n    .react-datepicker__month-read-view--down-arrow {\r\n      border-top-color: shade-color($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--down-arrow {\r\n    @extend %triangle-arrow-down;\r\n    border-top-color: $datepicker__muted-color;\r\n    float: right;\r\n    margin-left: 20px;\r\n    top: 8px;\r\n    position: relative;\r\n    border-width: $datepicker__navigation-size;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown,\r\n.react-datepicker__month-dropdown,\r\n.react-datepicker__month-year-dropdown {\r\n  background-color: $datepicker__background-color;\r\n  position: absolute;\r\n  width: 50%;\r\n  left: 25%;\r\n  top: 30px;\r\n  z-index: 1;\r\n  text-align: center;\r\n  border-radius: $datepicker__border-radius;\r\n  border: 1px solid $datepicker__border-color;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &--scrollable {\r\n    height: 150px;\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-option,\r\n.react-datepicker__month-option,\r\n.react-datepicker__month-year-option {\r\n  line-height: 20px;\r\n  width: 100%;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  &:first-of-type {\r\n    border-top-left-radius: $datepicker__border-radius;\r\n    border-top-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:last-of-type {\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    border-bottom-left-radius: $datepicker__border-radius;\r\n    border-bottom-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: $datepicker__muted-color;\r\n\r\n    .react-datepicker__navigation--years-upcoming {\r\n      border-bottom-color: shade-color($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    .react-datepicker__navigation--years-previous {\r\n      border-top-color: shade-color($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--selected {\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n}\r\n\r\n.react-datepicker__close-icon {\r\n  background-color: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n  outline: 0;\r\n  padding: 0;\r\n  vertical-align: middle;\r\n  position: absolute;\r\n  height: 16px;\r\n  width: 16px;\r\n  top: 25%;\r\n  right: 7px;\r\n\r\n  &::after {\r\n    background-color: $datepicker__selected-color;\r\n    border-radius: 50%;\r\n    bottom: 0;\r\n    box-sizing: border-box;\r\n    color: $white;\r\n    content: \"\\00d7\";\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 1;\r\n    margin: -8px auto 0;\r\n    padding: 2px;\r\n    position: absolute;\r\n    right: 0px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.react-datepicker__today-button {\r\n  background: $datepicker__background-color;\r\n  border-top: 1px solid $datepicker__border-color;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  padding: 5px 0;\r\n  clear: left;\r\n}\r\n\r\n.react-datepicker__portal {\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: $zindex-modal-backdrop;\r\n  background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);\r\n  left: 0;\r\n  top: 0;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n\r\n  .react-datepicker__day-name,\r\n  .react-datepicker__day,\r\n  .react-datepicker__time-name {\r\n    width: 3rem;\r\n    line-height: 3rem;\r\n  }\r\n\r\n  // Resize for small screens\r\n  @media (max-width: 400px), (max-height: 550px) {\r\n    .react-datepicker__day-name,\r\n    .react-datepicker__day,\r\n    .react-datepicker__time-name {\r\n      width: 2rem;\r\n      line-height: 2rem;\r\n    }\r\n  }\r\n\r\n  .react-datepicker__current-month,\r\n  .react-datepicker-time__header {\r\n    font-size: $datepicker__font-size * 1.8;\r\n  }\r\n\r\n  .react-datepicker__navigation {\r\n    border: 1.8 * $datepicker__navigation-size solid transparent;\r\n    margin-top: 3px;\r\n  }\r\n\r\n  .react-datepicker__navigation--previous {\r\n    border-right-color: $primary;\r\n\r\n    &:hover {\r\n      border-right-color: shade-color($primary, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-right-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  .react-datepicker__navigation--next {\r\n    border-left-color: $primary;\r\n\r\n    &:hover {\r\n      border-left-color: shade-color($primary, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-left-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n}\r\n\r\n.rangeButtonSelectedStyle {\r\n  background: $primary !important;\r\n}\r\n\r\n.rangebuttonstyle {\r\n  outline: none !important;\r\n  color: $primary !important;\r\n}",".rc-slider-tooltip {\r\n  z-index: 555;\r\n}\r\n\r\n.rc-tooltip.rc-tooltip-zoom-enter,\r\n.rc-tooltip.rc-tooltip-zoom-leave {\r\n  display: block;\r\n}\r\n\r\n.rc-tooltip-zoom-enter,\r\n.rc-tooltip-zoom-appear {\r\n  opacity: 0;\r\n  animation-duration: 0.3s;\r\n  animation-fill-mode: both;\r\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-tooltip-zoom-leave {\r\n  animation-duration: 0.3s;\r\n  animation-fill-mode: both;\r\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\r\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\r\n  animation-name: rcToolTipZoomIn;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\r\n  animation-name: rcToolTipZoomOut;\r\n  animation-play-state: running;\r\n}\r\n\r\n@keyframes rcToolTipZoomIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(0, 0);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes rcToolTipZoomOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(0, 0);\r\n  }\r\n}\r\n\r\n.rc-tooltip {\r\n  position: absolute;\r\n  z-index: 1070;\r\n  display: block;\r\n  visibility: visible;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  opacity: 0.9;\r\n}\r\n\r\n.rc-tooltip-hidden {\r\n  display: none;\r\n}\r\n\r\n.rc-tooltip-placement-top,\r\n.rc-tooltip-placement-topLeft,\r\n.rc-tooltip-placement-topRight {\r\n  padding: 5px 0 9px 0;\r\n}\r\n\r\n.rc-tooltip-placement-right,\r\n.rc-tooltip-placement-rightTop,\r\n.rc-tooltip-placement-rightBottom {\r\n  padding: 0 5px 0 9px;\r\n}\r\n\r\n.rc-tooltip-placement-bottom,\r\n.rc-tooltip-placement-bottomLeft,\r\n.rc-tooltip-placement-bottomRight {\r\n  padding: 9px 0 5px 0;\r\n}\r\n\r\n.rc-tooltip-placement-left,\r\n.rc-tooltip-placement-leftTop,\r\n.rc-tooltip-placement-leftBottom {\r\n  padding: 0 9px 0 5px;\r\n}\r\n\r\n.rc-tooltip-inner {\r\n  padding: 12px 14px;\r\n  color: $white;\r\n  text-align: left;\r\n  text-decoration: none;\r\n  background-color: $gray-800;\r\n  border-radius: 6px;\r\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\r\n  min-height: 34px;\r\n  font-weight: bold;\r\n}\r\n\r\n.rc-tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.rc-tooltip-placement-top .rc-tooltip-arrow,\r\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\r\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\r\n  bottom: 4px;\r\n  margin-left: -5px;\r\n  border-width: 5px 5px 0;\r\n  border-top-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-top .rc-tooltip-arrow {\r\n  left: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\r\n  left: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\r\n  right: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-right .rc-tooltip-arrow,\r\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\r\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\r\n  left: 4px;\r\n  margin-top: -5px;\r\n  border-width: 5px 5px 5px 0;\r\n  border-right-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-right .rc-tooltip-arrow {\r\n  top: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\r\n  top: 15%;\r\n  margin-top: 0;\r\n}\r\n\r\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\r\n  bottom: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-left .rc-tooltip-arrow,\r\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\r\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\r\n  right: 4px;\r\n  margin-top: -5px;\r\n  border-width: 5px 0 5px 5px;\r\n  border-left-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-left .rc-tooltip-arrow {\r\n  top: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\r\n  top: 15%;\r\n  margin-top: 0;\r\n}\r\n\r\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\r\n  bottom: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\r\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\r\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\r\n  top: 4px;\r\n  margin-left: -5px;\r\n  border-width: 0 5px 5px;\r\n  border-bottom-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\r\n  left: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\r\n  left: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\r\n  right: 15%;\r\n}\r\n","@import 'tooltip';\r\n\r\n.rc-slider {\r\n  position: relative;\r\n  height: 20px;\r\n  padding: 8px 0 0;\r\n  width: 100%;\r\n  @include border-radius($border-radius);\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.rc-slider-rail {\r\n  position: absolute;\r\n  width: 100%;\r\n  background-color: $gray-200;\r\n  height: 4px;\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n.rc-slider-track {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 4px;\r\n  @include border-radius($border-radius);\r\n  background-color: $primary;\r\n}\r\n\r\n.rc-slider-handle {\r\n  position: absolute;\r\n  margin-left: -8px;\r\n  margin-top: -6px;\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  cursor: -webkit-grab;\r\n  cursor: grab;\r\n  border-radius: 50%;\r\n  border: solid 2px $primary;\r\n  background-color: $white;\r\n  -ms-touch-action: pan-x;\r\n  touch-action: pan-x;\r\n  transition: box-shadow 200ms;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n\r\n  &:focus,\r\n  &:active,\r\n  &:hover {\r\n    border-color: shade-color($primary, 15%);\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba($primary, .8),\r\n    0 0.125rem 0.5875rem rgba($primary, .9);\r\n  }\r\n\r\n  &:active {\r\n    cursor: -webkit-grabbing;\r\n    cursor: grabbing;\r\n  }\r\n}\r\n\r\n.rc-slider-mark {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 0;\r\n  width: 100%;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-slider-mark-text {\r\n  position: absolute;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n}\r\n\r\n.rc-slider-mark-text-active {\r\n  color: $gray-800;\r\n}\r\n\r\n.rc-slider-step {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 4px;\r\n  background: transparent;\r\n}\r\n\r\n.rc-slider-dot {\r\n  position: absolute;\r\n  bottom: -2px;\r\n  margin-left: -4px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: 2px solid $gray-300;\r\n  background-color: $white;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rc-slider-dot-active {\r\n  border-color: $primary;\r\n}\r\n\r\n.rc-slider-disabled {\r\n  background-color: $gray-200;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-track {\r\n  background-color: $gray-400;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-handle,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  border-color: $gray-400;\r\n  box-shadow: none;\r\n  background-color: $white;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-mark-text,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.rc-slider-vertical {\r\n  width: 14px;\r\n  height: 100%;\r\n  padding: 0 5px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-rail {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-track {\r\n  left: 5px;\r\n  bottom: 0;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-handle {\r\n  margin-left: -6px;\r\n  margin-bottom: -7px;\r\n  -ms-touch-action: pan-y;\r\n  touch-action: pan-y;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-mark {\r\n  top: 0;\r\n  left: 18px;\r\n  height: 100%;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-step {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot {\r\n  left: 2px;\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot:first-child {\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot:last-child {\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\r\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\r\n  animation-name: rcSliderTooltipZoomDownIn;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\r\n  animation-name: rcSliderTooltipZoomDownOut;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  transform: scale(0, 0);\r\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n}\r\n\r\n@keyframes rcSliderTooltipZoomDownIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n  100% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes rcSliderTooltipZoomDownOut {\r\n  0% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n}\r\n\r\n.rc-slider-tooltip {\r\n  position: absolute;\r\n  left: -9999px;\r\n  top: -9999px;\r\n  visibility: visible;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.rc-slider-tooltip-hidden {\r\n  display: none;\r\n}\r\n\r\n.rc-slider-tooltip-placement-top {\r\n  padding: 4px 0 8px 0;\r\n}\r\n\r\n.rc-slider-tooltip-inner {\r\n  padding: 0 8px;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  line-height: 28px;\r\n  color: $white;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  background-color: $gray-900;\r\n  @include border-radius($border-radius);\r\n  box-shadow: $box-shadow-default;\r\n  font-weight: bold;\r\n}\r\n\r\n.rc-slider-tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\r\n  bottom: 4px;\r\n  left: 50%;\r\n  margin-left: -4px;\r\n  border-width: 4px 4px 0;\r\n  border-top-color: $gray-900;\r\n}\r\n\r\n// Colors\r\n\r\n@each $color, $value in $theme-colors {\r\n  .rc-slider-#{$color} {\r\n    .rc-slider-track {\r\n      background-color: $value;\r\n    }\r\n\r\n    .rc-slider-handle {\r\n      border-color: $value;\r\n      background-color: $white;\r\n\r\n      &:focus,\r\n      &:active,\r\n      &:hover {\r\n        border-color: shade-color($value, 15%);\r\n        box-shadow: 0 0.46875rem 2.1875rem rgba($value, .8),\r\n        0 0.125rem 0.5875rem rgba($value, .9);\r\n      }\r\n    }\r\n\r\n    .rc-slider-dot-active {\r\n      border-color: $value;\r\n    }\r\n  }\r\n}\r\n\r\n// Alternate Styles\r\n\r\n.rc-slider-line {\r\n  .rc-slider-handle {\r\n    @include border-radius(0);\r\n    border-width: 0 3px 0 0;\r\n    margin-left: -8px;\r\n    width: 10px;\r\n    background-color: transparent;\r\n    box-shadow: 0 0 0 transparent !important;\r\n  }\r\n}\r\n\r\n.rc-slider-square {\r\n  .rc-slider-handle {\r\n    @include border-radius(3px);\r\n    border-widtH: 1px;\r\n\r\n    &:before {\r\n      position: absolute;\r\n      height: 8px;\r\n      width: 4px;\r\n      border: $gray-500 solid 1px;\r\n      border-width: 0 1px;\r\n      display: block;\r\n      content: '';\r\n      top: 50%;\r\n      left: 50%;\r\n      margin: -4px -2px;\r\n    }\r\n  }\r\n}\r\n\r\n// Sizing\r\n\r\n.rc-slider-lg {\r\n  &.rc-slider {\r\n    height: 20px;\r\n    padding: 8px 0 0;\r\n  }\r\n\r\n  .rc-slider-rail {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-track {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-handle {\r\n    margin-left: -10px;\r\n    margin-top: -8px;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  &.rc-slider-line {\r\n    .rc-slider-handle {\r\n      margin-left: -8px;\r\n      width: 10px;\r\n    }\r\n  }\r\n\r\n  &.rc-slider-square {\r\n    .rc-slider-handle {\r\n      &:before {\r\n        height: 10px;\r\n        width: 6px;\r\n        margin: -5px -3px;\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.rc-slider-sm {\r\n  &.rc-slider {\r\n    height: 20px;\r\n    padding: 8px 0 0;\r\n  }\r\n\r\n  .rc-slider-rail {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-track {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-handle {\r\n    margin-left: -6px;\r\n    margin-top: -4px;\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n\r\n  &.rc-slider-line {\r\n    .rc-slider-handle {\r\n      margin-left: -8px;\r\n      width: 10px;\r\n    }\r\n  }\r\n\r\n  &.rc-slider-square {\r\n    .rc-slider-handle {\r\n      &:before {\r\n        height: 6px;\r\n        margin: -3px 0 0 -1px;\r\n        border: 0;\r\n        width: 2px;\r\n        background: $gray-500;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n",".rdw-option-wrapper {\r\n  border: 1px solid #F1F1F1;\r\n  padding: 5px;\r\n  min-width: 25px;\r\n  height: 20px;\r\n  border-radius: 2px;\r\n  margin: 0 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-option-wrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-option-wrapper:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-option-active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-option-disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.rdw-dropdown-wrapper {\r\n  height: 30px;\r\n  background: white;\r\n  cursor: pointer;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  margin: 0 3px;\r\n  text-transform: capitalize;\r\n  background: white;\r\n}\r\n.rdw-dropdown-wrapper:focus {\r\n  outline: none;\r\n}\r\n.rdw-dropdown-wrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n  background-color: #FFFFFF;\r\n}\r\n.rdw-dropdown-wrapper:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-dropdown-carettoopen {\r\n  height: 0px;\r\n  width: 0px;\r\n  position: absolute;\r\n  top: 35%;\r\n  right: 10%;\r\n  border-top: 6px solid black;\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n}\r\n.rdw-dropdown-carettoclose {\r\n  height: 0px;\r\n  width: 0px;\r\n  position: absolute;\r\n  top: 35%;\r\n  right: 10%;\r\n  border-bottom: 6px solid black;\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n}\r\n.rdw-dropdown-selectedtext {\r\n  display: flex;\r\n  position: relative;\r\n  height: 100%;\r\n  align-items: center;\r\n  padding: 0 5px;\r\n}\r\n.rdw-dropdown-optionwrapper {\r\n  z-index: 100;\r\n  position: relative;\r\n  border: 1px solid #F1F1F1;\r\n  width: 98%;\r\n  background: white;\r\n  border-radius: 2px;\r\n  margin: 0;\r\n  padding: 0;\r\n  max-height: 250px;\r\n  overflow-y: scroll;\r\n}\r\n.rdw-dropdown-optionwrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n  background-color: #FFFFFF;\r\n}\r\n.rdw-dropdownoption-default {\r\n  min-height: 25px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 5px;\r\n}\r\n.rdw-dropdownoption-highlighted {\r\n  background: #F1F1F1;\r\n}\r\n.rdw-dropdownoption-active {\r\n  background: #f5f5f5;\r\n}\r\n.rdw-dropdownoption-disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.rdw-inline-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-inline-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-inline-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-block-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-block-dropdown {\r\n  width: 110px;\r\n}\r\n.rdw-fontsize-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-fontsize-dropdown {\r\n  min-width: 40px;\r\n}\r\n.rdw-fontsize-option {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-fontfamily-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-fontfamily-dropdown {\r\n  width: 115px;\r\n}\r\n.rdw-fontfamily-placeholder {\r\n  white-space: nowrap;\r\n  max-width: 90px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.rdw-fontfamily-optionwrapper {\r\n  width: 140px;\r\n}\r\n.rdw-list-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-list-dropdown {\r\n  width: 50px;\r\n  z-index: 90;\r\n}\r\n.rdw-list-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-text-align-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-text-align-dropdown {\r\n  width: 50px;\r\n  z-index: 90;\r\n}\r\n.rdw-text-align-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-right-aligned-block {\r\n  text-align: right;\r\n}\r\n.rdw-left-aligned-block {\r\n  text-align: left !important;\r\n}\r\n.rdw-center-aligned-block {\r\n  text-align: center !important;\r\n}\r\n.rdw-justify-aligned-block {\r\n  text-align: justify !important;\r\n}\r\n.rdw-right-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-left-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-center-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-justify-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-colorpicker-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-colorpicker-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 175px;\r\n  height: 175px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-colorpicker-modal-header {\r\n  display: flex;\r\n  padding-bottom: 5px;\r\n}\r\n.rdw-colorpicker-modal-style-label {\r\n  font-size: 15px;\r\n  width: 50%;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  padding: 0 10px 5px;\r\n}\r\n.rdw-colorpicker-modal-style-label-active {\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-colorpicker-modal-options {\r\n  margin: 5px auto;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  flex-wrap: wrap;\r\n  overflow: scroll;\r\n}\r\n.rdw-colorpicker-cube {\r\n  width: 22px;\r\n  height: 22px;\r\n  border: 1px solid #F1F1F1;\r\n}\r\n.rdw-colorpicker-option {\r\n  margin: 3px;\r\n  padding: 0;\r\n  min-height: 20px;\r\n  border: none;\r\n  width: 22px;\r\n  height: 22px;\r\n  min-width: 22px;\r\n  box-shadow: 1px 2px 1px #BFBDBD inset;\r\n}\r\n.rdw-colorpicker-option:hover {\r\n  box-shadow: 1px 2px 1px #BFBDBD;\r\n}\r\n.rdw-colorpicker-option:active {\r\n  box-shadow: -1px -2px 1px #BFBDBD;\r\n}\r\n.rdw-colorpicker-option-active {\r\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\r\n}\r\n.rdw-link-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-link-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-link-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-link-dropdownPlaceholder {\r\n  margin-left: 8px;\r\n}\r\n.rdw-link-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  height: 205px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-link-modal-label {\r\n  font-size: 15px;\r\n}\r\n.rdw-link-modal-input {\r\n  margin-top: 5px;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  height: 25px;\r\n  margin-bottom: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-link-modal-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-link-modal-buttonsection {\r\n  margin: 0 auto;\r\n}\r\n.rdw-link-modal-target-option {\r\n  margin-bottom: 20px;\r\n}\r\n.rdw-link-modal-target-option > span {\r\n  margin-left: 5px;\r\n}\r\n.rdw-link-modal-btn {\r\n  margin-left: 10px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-link-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-link-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-link-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-link-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-link-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-history-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-embedded-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-embedded-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  height: 180px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  justify-content: space-between;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-embedded-modal-header {\r\n  font-size: 15px;\r\n  display: flex;\r\n}\r\n.rdw-embedded-modal-header-option {\r\n  width: 50%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.rdw-embedded-modal-header-label {\r\n  width: 95px;\r\n  border: 1px solid #f1f1f1;\r\n  margin-top: 5px;\r\n  background: #6EB8D4;\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-embedded-modal-link-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.rdw-embedded-modal-link-input {\r\n  width: 88%;\r\n  height: 35px;\r\n  margin: 10px 0;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-embedded-modal-link-input-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.rdw-embedded-modal-link-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-embedded-modal-btn-section {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-embedded-modal-btn {\r\n  margin: 0 3px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-embedded-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-embedded-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-embedded-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-embedded-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-embedded-modal-size {\r\n  align-items: center;\r\n  display: flex;\r\n  margin: 8px 0;\r\n  justify-content: space-between;\r\n}\r\n.rdw-embedded-modal-size-input {\r\n  width: 80%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n}\r\n.rdw-embedded-modal-size-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-emoji-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-emoji-modal {\r\n  overflow: auto;\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 235px;\r\n  height: 180px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-emoji-icon {\r\n  margin: 2.5px;\r\n  height: 24px;\r\n  width: 24px;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.rdw-spinner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.rdw-spinner > div {\r\n  width: 12px;\r\n  height: 12px;\r\n  background-color: #333;\r\n\r\n  border-radius: 100%;\r\n  display: inline-block;\r\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n}\r\n.rdw-spinner .rdw-bounce1 {\r\n  -webkit-animation-delay: -0.32s;\r\n  animation-delay: -0.32s;\r\n}\r\n.rdw-spinner .rdw-bounce2 {\r\n  -webkit-animation-delay: -0.16s;\r\n  animation-delay: -0.16s;\r\n}\r\n@-webkit-keyframes sk-bouncedelay {\r\n  0%, 80%, 100% { -webkit-transform: scale(0) }\r\n  40% { -webkit-transform: scale(1.0) }\r\n}\r\n@keyframes sk-bouncedelay {\r\n  0%, 80%, 100% {\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n  } 40% {\r\n    -webkit-transform: scale(1.0);\r\n    transform: scale(1.0);\r\n  }\r\n}\r\n.rdw-image-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-image-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-image-modal-header {\r\n  font-size: 15px;\r\n  margin: 10px 0;\r\n  display: flex;\r\n}\r\n.rdw-image-modal-header-option {\r\n  width: 50%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.rdw-image-modal-header-label {\r\n  width: 80px;\r\n  background: #f1f1f1;\r\n  border: 1px solid #f1f1f1;\r\n  margin-top: 5px;\r\n}\r\n.rdw-image-modal-header-label-highlighted {\r\n  background: #6EB8D4;\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-image-modal-upload-option {\r\n  width: 100%;\r\n  color: gray;\r\n  cursor: pointer;\r\n  display: flex;\r\n  border: none;\r\n  font-size: 15px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #f1f1f1;\r\n  outline: 2px dashed gray;\r\n  outline-offset: -10px;\r\n  margin: 10px 0;\r\n  padding: 9px 0;\r\n}\r\n.rdw-image-modal-upload-option-highlighted {\r\n  outline: 2px dashed #0a66b7;\r\n}\r\n.rdw-image-modal-upload-option-label {\r\n  cursor: pointer;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 15px;\r\n}\r\n.rdw-image-modal-upload-option-label span{\r\n  padding: 0 20px;\r\n}\r\n.rdw-image-modal-upload-option-image-preview {\r\n  max-width: 100%;\r\n  max-height: 200px;\r\n}\r\n.rdw-image-modal-upload-option-input {\r\n\twidth: 0.1px;\r\n\theight: 0.1px;\r\n\topacity: 0;\r\n\toverflow: hidden;\r\n\tposition: absolute;\r\n\tz-index: -1;\r\n}\r\n.rdw-image-modal-url-section {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.rdw-image-modal-url-input {\r\n  width: 90%;\r\n  height: 35px;\r\n  margin: 15px 0 12px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-image-modal-btn-section {\r\n  margin: 10px auto 0;\r\n}\r\n.rdw-image-modal-url-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-modal-btn {\r\n  margin: 0 5px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-image-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-image-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-image-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-image-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-image-modal-spinner {\r\n  position: absolute;\r\n  top: -3px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.5;\r\n}\r\n.rdw-image-modal-alt-input {\r\n  width: 70%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n  margin-left: 5px;\r\n}\r\n.rdw-image-modal-alt-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-modal-alt-lbl {\r\n  font-size: 12px;\r\n}\r\n.rdw-image-modal-size {\r\n  align-items: center;\r\n  display: flex;\r\n  margin: 8px 0;\r\n  justify-content: space-between;\r\n}\r\n.rdw-image-modal-size-input {\r\n  width: 40%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n}\r\n.rdw-image-modal-size-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-mandatory-sign {\r\n  color: red;\r\n  margin-left: 3px;\r\n  margin-right: 3px;\r\n}\r\n.rdw-remove-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-history-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-history-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-history-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-link-decorator-wrapper {\r\n  position: relative;\r\n}\r\n.rdw-link-decorator-icon {\r\n  position: absolute;\r\n  left: 40%;\r\n  top: 0;\r\n  cursor: pointer;\r\n  background-color: white;\r\n}\r\n.rdw-mention-link {\r\n  text-decoration: none;\r\n  color: #1236ff;\r\n  background-color: #f0fbff;\r\n  padding: 1px 2px;\r\n  border-radius: 2px;\r\n}\r\n.rdw-suggestion-wrapper {\r\n  position: relative;\r\n}\r\n.rdw-suggestion-dropdown {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #F1F1F1;\r\n  min-width: 100px;\r\n  max-height: 150px;\r\n  overflow: auto;\r\n  background: white;\r\n  z-index: 100;\r\n}\r\n.rdw-suggestion-option {\r\n  padding: 7px 5px;\r\n  border-bottom: 1px solid #f1f1f1;\r\n}\r\n.rdw-suggestion-option-active {\r\n  background-color: #F1F1F1;\r\n}\r\n.rdw-hashtag-link {\r\n  text-decoration: none;\r\n  color: #1236ff;\r\n  background-color: #f0fbff;\r\n  padding: 1px 2px;\r\n  border-radius: 2px;\r\n}\r\n.rdw-image-alignment-options-popup {\r\n  position: absolute;;\r\n  background: white;\r\n  display: flex;\r\n  padding: 5px 2px;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  width: 105px;\r\n  cursor: pointer;\r\n  z-index: 100;\r\n}\r\n.rdw-alignment-option-left {\r\n  justify-content: flex-start;\r\n}\r\n.rdw-image-alignment-option {\r\n  height: 15px;\r\n  width: 15px;\r\n  min-width: 15px;\r\n}\r\n.rdw-image-alignment {\r\n  position: relative;\r\n}\r\n.rdw-image-imagewrapper {\r\n  position: relative;\r\n}\r\n.rdw-image-center {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-image-left {\r\n  display: flex;\r\n}\r\n.rdw-image-right {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.rdw-image-alignment-options-popup-right {\r\n  right: 0;\r\n}\r\n.rdw-editor-main {\r\n  height: 100%;\r\n  overflow: auto;\r\n  box-sizing: border-box;\r\n}\r\n.rdw-editor-toolbar {\r\n  padding: 6px 5px 0;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  background: white;\r\n  flex-wrap: wrap;\r\n  font-size: 15px;\r\n  margin-bottom: 5px;\r\n  user-select: none;\r\n}\r\n.public-DraftStyleDefault-block {\r\n  margin: 1em 0;\r\n}\r\n.rdw-editor-wrapper:focus {\r\n  outline: none;\r\n}\r\n.rdw-editor-wrapper {\r\n  box-sizing: content-box;\r\n}\r\n.rdw-editor-main blockquote {\r\n  border-left: 5px solid #f1f1f1;\r\n  padding-left: 5px;\r\n}\r\n.rdw-editor-main pre {\r\n  background: #f1f1f1;\r\n  border-radius: 3px;\r\n  padding: 1px 10px;\r\n}/**\r\n * Draft v0.9.1\r\n *\r\n * Copyright (c) 2013-present, Facebook, Inc.\r\n * All rights reserved.\r\n *\r\n * This source code is licensed under the BSD-style license found in the\r\n * LICENSE file in the root directory of this source tree. An additional grant\r\n * of patent rights can be found in the PATENTS file in the same directory.\r\n */\r\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:rgba(255,255,255,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:0}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}\r\n\r\n.demo-editor {\r\n  height: 275px !important;\r\n  border: 1px solid #F1F1F1 !important;\r\n  padding: 5px !important;\r\n  border-radius: 2px !important;\r\n}","\r\n/// switch\r\n\r\n.has-switch {\r\n  border-radius: 30px;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  line-height: 1.72222;\r\n  overflow: hidden;\r\n  position: relative;\r\n  text-align: left;\r\n  width: 60px;\r\n  user-select: none;\r\n\r\n}\r\n.has-switch.deactivate {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  cursor: default !important;\r\n}\r\n.has-switch.deactivate label,\r\n.has-switch.deactivate span {\r\n  cursor: default !important;\r\n}\r\n.has-switch > div {\r\n  position: relative;\r\n  top: 0;\r\n  width: 100px;\r\n}\r\n.has-switch > div.switch-animate {\r\n  transition: left 0.25s ease-out;\r\n}\r\n.has-switch > div.switch-off {\r\n  left: -35px;\r\n}\r\n\r\n.has-switch > div.switch-on {\r\n  left: 0;\r\n}\r\n\r\n@mixin icon-gradient ($top-color, $bottom-color){\r\n  background: $top-color;\r\n  background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\r\n  background-size: 150% 150%;\r\n}\r\n\r\n.has-switch > div label {\r\n  background-color: #FFFFFF;\r\n  @include icon-gradient (rgba(255,255,255,1), rgba(241,241,242,1));\r\n\r\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\r\n  cursor: pointer;\r\n}\r\n.has-switch input[type=checkbox] {\r\n  display: none;\r\n}\r\n.has-switch span {\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  height: 24px;\r\n  line-height: 15px;\r\n  margin: 0;\r\n  padding-bottom: 6px;\r\n  padding-top: 5px;\r\n  position: relative;\r\n  text-align: center;\r\n  text-indent: -10px;\r\n  width: 50%;\r\n  z-index: 1;\r\n  transition: 0.25s ease-out;\r\n}\r\n.has-switch span.switch-left {\r\n  background-color: $primary;\r\n  border-left: 1px solid rgba(0, 0, 0, 0);\r\n  border-radius: 30px 0 0 30px;\r\n  color: #FFFFFF;\r\n}\r\n.has-switch .switch-off span.switch-left{\r\n  background-color: $gray-400 !important;\r\n}\r\n.has-switch span.switch-right {\r\n  border-radius: 0 30px 30px 0;\r\n  background-color: $primary;\r\n  color: #ffffff;\r\n  text-indent: 1px;\r\n}\r\n.has-switch .switch-off span.switch-right{\r\n  background-color: $gray-400 !important;\r\n}\r\n\r\n.has-switch label {\r\n  border-radius: 12px;\r\n  float: left;\r\n  height: 22px;\r\n  margin: 1px -13px;\r\n  padding: 0;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 22px;\r\n  z-index: 10;\r\n  -webkit-transition: 0.25s ease-out;\r\n  transition: 0.25s ease-out;\r\n}\r\n.has-switch .switch-on .fa-check:before{\r\n  margin-left: 10px;\r\n}\r\n.has-switch:hover .switch-on label{\r\n  margin: 1px -17px;\r\n  width: 26px;\r\n}\r\n.has-switch:hover .switch-off label{\r\n  margin: 1px -13px;\r\n  width: 26px;\r\n}\r\n\r\n// Sizing\r\n\r\n.has-switch-sm {\r\n  &.has-switch {\r\n    span {\r\n      height: 18px;\r\n      line-height: 18px;\r\n      padding: 0;\r\n    }\r\n    label {\r\n      height: 16px;\r\n      width: 16px;\r\n      margin: 1px -8px;\r\n    }\r\n\r\n    .switch-off {\r\n      label {\r\n        margin: 1px -13px;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      .switch-on label {\r\n        margin: 1px -11px;\r\n        width: 20px;\r\n      }\r\n\r\n      .switch-off label {\r\n        margin: 1px -13px;\r\n        width: 20px;\r\n      }\r\n    }\r\n  }\r\n}","// Dropzone\r\n\r\n.dropzone-wrapper {\r\n  width: 100%;\r\n  border: $gray-400 dashed 2px;\r\n  @include border-radius($border-radius-lg);\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  text-align: center;\r\n  height: 230px;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    border-color: $primary;\r\n  }\r\n\r\n  & > div {\r\n    width: 100%;\r\n    height: 100%;\r\n    outline: none !important;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  &.dropzone-wrapper-lg {\r\n    height: 300px;\r\n  }\r\n\r\n  &.dropzone-wrapper-sm {\r\n    height: 150px;\r\n  }\r\n\r\n  input {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .dropzone-content {\r\n    margin: 0 auto;\r\n    color: $gray-600;\r\n  }\r\n\r\n  &[aria-disabled=\"true\"] {\r\n    border-color: $gray-300;\r\n\r\n    .dropzone-content {\r\n      color: $gray-400;\r\n    }\r\n  }\r\n}","@import '_mixins';\r\n\r\n.rbt {\r\n  outline: none;\r\n\r\n  &-menu {\r\n    margin-bottom: 2px;\r\n\r\n    & > li a {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n    }\r\n\r\n    &-pagination-option {\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  // Hide IE's native \"clear\" button\r\n  & .rbt-input-main::-ms-clear {\r\n    display: none;\r\n  }\r\n\r\n  &-input-multi {\r\n    cursor: text;\r\n    overflow: hidden;\r\n    position: relative;\r\n\r\n    // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.\r\n    &.form-control[disabled] {\r\n      background-color: #e9ecef;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      @include placeholder(#6c757d);\r\n    }\r\n\r\n    .rbt-input-wrapper {\r\n      margin-top: 2px;\r\n      overflow: hidden;\r\n    }\r\n\r\n    .rbt-input-main {\r\n      height: auto;\r\n    }\r\n\r\n    .rbt-input-hint-container {\r\n      display: inline-block;\r\n    }\r\n\r\n    &.input,\r\n    &.form-control {\r\n      &-lg {\r\n        .rbt-input-main {\r\n          height: auto;\r\n        }\r\n      }\r\n\r\n      &-sm {\r\n        .rbt-input-main {\r\n          height: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &-close {\r\n    z-index: 1;\r\n\r\n    &-lg {\r\n      font-size: 24px;\r\n    }\r\n  }\r\n\r\n  &-token {\r\n    background-color: $dropdown-link-hover-bg;\r\n    border: 0;\r\n    @include border-radius($border-radius);\r\n    color: $primary;\r\n    display: inline-block;\r\n    line-height: 1em;\r\n    margin: 0 3px 3px 0;\r\n    padding: 4px 7px;\r\n    position: relative;\r\n\r\n    &-disabled {\r\n      background-color: $gray-100;\r\n      color: $gray-500;\r\n      pointer-events: none;\r\n    }\r\n\r\n    &-removeable {\r\n      cursor: pointer;\r\n      padding-right: 21px;\r\n    }\r\n\r\n    &-active {\r\n      background-color: $primary;\r\n      color: $white;\r\n      outline: none;\r\n      text-decoration: none;\r\n    }\r\n\r\n    & &-remove-button {\r\n      bottom: 0;\r\n      color: $gray-700;\r\n      font-size: inherit;\r\n      font-weight: normal;\r\n      opacity: 1;\r\n      outline: none;\r\n      padding: 3px 7px;\r\n      position: absolute;\r\n      right: 0;\r\n      text-shadow: none;\r\n      top: -1px;\r\n    }\r\n  }\r\n\r\n  &-loader {\r\n    @include animation(loader-animation 600ms infinite linear);\r\n    border: 1px solid $dropdown-link-hover-bg;\r\n    border-radius: 50%;\r\n    border-top-color: shade-color($dropdown-link-hover-bg, 10%);\r\n    display: block;\r\n    height: 16px;\r\n    width: 16px;\r\n\r\n    &-lg {\r\n      height: 20px;\r\n      width: 20px;\r\n    }\r\n  }\r\n\r\n  &-aux {\r\n    @include display-flex();\r\n    align-items: center;\r\n    bottom: 0;\r\n    justify-content: center;\r\n    pointer-events: none; /* Don't block clicks on the input */\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 34px;\r\n\r\n    &-lg {\r\n      width: 46px;\r\n    }\r\n\r\n    & .rbt-close {\r\n      margin-top: -1px;\r\n      pointer-events: auto; /* Override pointer-events: none; above */\r\n      background-color: transparent;\r\n      border: none;\r\n    }\r\n  }\r\n\r\n  .has-aux &-input {\r\n    padding-right: 34px;\r\n  }\r\n\r\n  &-highlight-text {\r\n    background-color: inherit;\r\n    color: inherit;\r\n    font-weight: bold;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n/* Input Groups */\r\n.input-group > .rbt {\r\n  @include flex(1);\r\n\r\n  & .rbt-input-hint-container {\r\n    @include display-flex();\r\n  }\r\n\r\n  & .rbt-input-hint {\r\n    // Form-controls within input-groups have a higher z-index.\r\n    z-index: 5;\r\n  }\r\n\r\n  & .rbt-aux {\r\n    // Form-controls within input-groups have a higher z-index.\r\n    z-index: 5;\r\n  }\r\n\r\n  &:not(:first-child) .form-control {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  &:not(:last-child) .form-control {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n}\r\n\r\n@keyframes loader-animation {\r\n  to {\r\n    transform: rotate(1turn);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes loader-animation {\r\n  to {\r\n    -webkit-transform: rotate(1turn);\r\n  }\r\n}\r\n\r\n.input-group > .rbt {\r\n  & .rbt-input-hint-container {\r\n    @include flex(1);\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.rbt-token-remove-button {\r\n  background-color: transparent;\r\n  border: none;\r\n}","\r\n@mixin animation($animation) {\r\n  -webkit-animation: $animation;\r\n  -o-animation: $animation;\r\n  animation: $animation;\r\n}\r\n\r\n@mixin box-shadow($shadow, $inset: false) {\r\n  @if $inset {\r\n    -webkit-box-shadow: $inset, $shadow;\r\n    -moz-box-shadow: $inset, $shadow;\r\n    box-shadow: $inset, $shadow;\r\n  } @else {\r\n    -webkit-box-shadow: $shadow;\r\n    -moz-box-shadow: $shadow;\r\n    box-shadow: $shadow;\r\n  }\r\n}\r\n\r\n@mixin display-flex()  {\r\n  display: -webkit-box;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n}\r\n\r\n@mixin flex($value) {\r\n  -webkit-box-flex: $value;\r\n  -moz-box-flex: $value;\r\n  -webkit-flex: $value;\r\n  -ms-flex: $value;\r\n  flex: $value;\r\n}\r\n\r\n@mixin placeholder($placeholder-color) {\r\n  // Firefox\r\n  &::-moz-placeholder {\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n\r\n  // Internet Explorer 10+\r\n  &:-ms-input-placeholder {\r\n    color: $placeholder-color;\r\n  }\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-input-placeholder  {\r\n    color: $placeholder-color;\r\n  }\r\n}","// Theme Options\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$theme-options-width: 500px;\r\n\r\n.ui-theme-settings {\r\n  position: fixed;\r\n  z-index: 155;\r\n  right: -30px;\r\n  top: 0;\r\n  height: 100vh;\r\n  transform: translate($theme-options-width);\r\n  transition: all .2s;\r\n  box-shadow: -0.46875rem 0 2.1875rem rgba(shade-color($primary, 50%), .03),\r\n  -0.9375rem 0 1.40625rem rgba(shade-color($primary, 50%), .03),\r\n  -0.25rem 0 0.53125rem rgba(shade-color($primary, 50%), .05),\r\n  -0.125rem 0 0.1875rem rgba(shade-color($primary, 50%), .03);\r\n\r\n  .btn-open-options {\r\n    @include border-radius(50px);\r\n    position: absolute;\r\n    left: -114px;\r\n    bottom: 80px;\r\n    padding: 0;\r\n    height: 54px;\r\n    line-height: 54px;\r\n    width: 54px;\r\n    text-align: center;\r\n    display: block;\r\n    box-shadow: $box-shadow-default;\r\n    margin-top: -27px;\r\n\r\n    svg {\r\n      top: 50%;\r\n      left: 50%;\r\n      position: absolute;\r\n      margin: -0.5em 0 0 -0.5em;\r\n    }\r\n  }\r\n\r\n  .theme-settings__inner {\r\n    background: $white;\r\n    width: $theme-options-width;\r\n    height: 100vh;\r\n    padding: 0;\r\n  }\r\n\r\n  &.settings-open {\r\n    transform: translate(0);\r\n    right: 0;\r\n  }\r\n\r\n  .theme-settings-swatches {\r\n    text-align: center;\r\n\r\n    .swatch-holder-img {\r\n      width: 72px;\r\n      height: auto;\r\n      @include border-radius(3px);\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  .themeoptions-heading {\r\n    font-size: $font-size-lg;\r\n    color: $body-color;\r\n    margin: 0;\r\n    background: $gray-100;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    border-bottom: $gray-300 solid 1px;\r\n    border-top: $gray-300 solid 1px;\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n\r\n    &:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  .list-group-item {\r\n    h5 {\r\n      color: $primary;\r\n      font-size: $font-size-sm;\r\n      text-transform: uppercase;\r\n      margin: 0;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n.swatch-holder {\r\n  width: 24px;\r\n  height: 24px;\r\n  line-height: 24px;\r\n  margin: 5px 5px 0;\r\n  transition: all .2s;\r\n  opacity: .7;\r\n  display: inline-block;\r\n  @include border-radius(30px);\r\n\r\n  &.active {\r\n    border: $white solid 2px;\r\n    box-shadow: 0 0 0 5px $primary;\r\n    opacity: 1;\r\n  }\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.swatch-holder-lg {\r\n  width: 48px;\r\n  height: 48px;\r\n  line-height: 48px;\r\n}","// DEMO\r\n\r\n@use \"sass:math\";\r\n\r\n@import \"elements/theme-options\";\r\n\r\n// Icons demo\r\n\r\n.font-icon-wrapper {\r\n  text-align: center;\r\n  border: $gray-200 solid 1px;\r\n  @include border-radius($border-radius);\r\n  margin: 0 0 10px;\r\n  padding: 5px;\r\n\r\n  &.font-icon-lg {\r\n    float: left;\r\n    padding: 10px;\r\n    text-align: center;\r\n    margin-right: 15px;\r\n    min-width: 64px;\r\n\r\n    i {\r\n      font-size: $h1-font-size;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    background: $gray-100;\r\n    color: $primary;\r\n\r\n    p {\r\n      color: $gray-600;\r\n    }\r\n  }\r\n\r\n  i {\r\n    font-size: ($font-size-lg * 1.5);\r\n  }\r\n\r\n  p {\r\n    color: $gray-500;\r\n    font-size: math.div($font-size-sm, 1.2);\r\n    margin: 5px 0 0;\r\n  }\r\n}\r\n\r\n.btn-icon-vertical {\r\n  min-width: 100px;\r\n}\r\n\r\n.card.mb-3 {\r\n  margin-bottom: $grid-gutter-width !important;\r\n}\r\n\r\n// Image BG\r\n\r\n.demo-image-bg {\r\n  height: 350px;\r\n  margin-bottom: $grid-gutter-width;\r\n}\r\n\r\n// Loaders wrapper\r\n\r\n.loader-wrapper {\r\n  width: 150px;\r\n  height: 100px;\r\n  float: left;\r\n}\r\n\r\n// Slick slider\r\n\r\n.slider-item {\r\n  background: $gray-300;\r\n  @include border-radius($border-radius);\r\n  color: $gray-600;\r\n  font-size: 36px;\r\n  padding: 0;\r\n  position: relative;\r\n  height: 150px;\r\n  line-height: 150px;\r\n  text-align: center;\r\n  margin: 0 $layout-spacer-x;\r\n  transition: all .2s;\r\n}\r\n\r\n.slick-center {\r\n  .slider-item {\r\n    background: $gray-500;\r\n    color: $gray-700;\r\n  }\r\n}\r\n\r\n// Image Crop\r\n\r\n.after-img {\r\n  max-width: 100%;\r\n}\r\n","// Responsive\r\n\r\n@use \"sass:math\";\r\n\r\n@media only screen and (max-width: 1320px) {\r\n  .header-user-info {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(md) {\r\n\r\n  .app-main {\r\n    display: block;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    &::before,\r\n    &::after {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .app-sidebar {\r\n    flex: 0 0 $app-sidebar-width !important;\r\n    width: $app-sidebar-width !important;\r\n    transform: translateX(-$app-sidebar-width);\r\n\r\n    .app-header__logo {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .sidebar-mobile-open {\r\n\r\n    .app-sidebar {\r\n\r\n      transform: translateX(0);\r\n\r\n      .app-sidebar__inner {\r\n\r\n        .app-sidebar__heading {\r\n          text-indent: initial;\r\n\r\n          &::before {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        .metismenu-link {\r\n          text-indent: initial;\r\n          padding: 0 $layout-spacer-x 0 45px;\r\n        }\r\n\r\n        .metismenu-icon {\r\n          text-indent: initial;\r\n          left: 5px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        .metismenu-state-icon {\r\n          visibility: visible;\r\n        }\r\n\r\n        .metismenu-container {\r\n          &.visible {\r\n            padding: .5em 0 0 2rem;\r\n\r\n            & > .metismenu-item > .metismenu-link {\r\n              height: 2.3em;\r\n            }\r\n          }\r\n\r\n          .metismenu-container {\r\n            .metismenu-link {\r\n              padding-left: 1em;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .app-header__logo {\r\n        width: auto !important;\r\n\r\n        .logo-src {\r\n          width: $logo-width !important;\r\n          margin-left: auto;\r\n          margin-right: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .fixed-sidebar .app-sidebar {\r\n      height: 100%;\r\n    }\r\n\r\n    .sidebar-mobile-overlay {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .app-main {\r\n\r\n    .app-main__outer {\r\n      padding-left: 0 !important;\r\n      width: auto;\r\n    }\r\n  }\r\n\r\n  .app-header {\r\n    justify-content: space-between;\r\n\r\n    .app-header__logo {\r\n      display: none;\r\n      order: 2;\r\n      background: transparent !important;\r\n      border: 0 !important;\r\n    }\r\n\r\n    .app-header__content {\r\n      visibility: hidden;\r\n      opacity: 0;\r\n      box-shadow: $box-shadow-default;\r\n      position: absolute;\r\n      left: 5%;\r\n      width: 90%;\r\n      top: 0;\r\n      transition: all .2s;\r\n      background: $white;\r\n      @include border-radius(50px);\r\n      padding: 0 10px;\r\n      overflow: hidden;\r\n\r\n      .header-btn-lg {\r\n        margin-left: .5rem;\r\n        padding: 0 .5rem;\r\n\r\n        .hamburger-box {\r\n          margin-top: 5px;\r\n        }\r\n\r\n        & + .header-btn-lg {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      .app-header-left {\r\n        .nav {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &.header-mobile-open {\r\n        visibility: visible;\r\n        opacity: 1;\r\n        top: $app-header-height + 20;\r\n      }\r\n    }\r\n\r\n    .app-header__mobile-menu {\r\n      display: flex;\r\n      order: 1;\r\n    }\r\n\r\n    .app-header__menu {\r\n      display: flex;\r\n      order: 3;\r\n    }\r\n\r\n    &.header-text-light {\r\n      .app-header__menu {\r\n        & > span .btn,\r\n        & > .btn {\r\n          background: rgba(255, 255, 255, .1);\r\n          border-color: rgba(255, 255, 255, .1);\r\n        }\r\n      }\r\n\r\n      .header-mobile-open {\r\n        background: $gray-800;\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  .popover,\r\n  .dropdown-menu {\r\n    position: fixed !important;\r\n    z-index: 50;\r\n    left: 5% !important;\r\n    top: 50% !important;\r\n    width: 90% !important;\r\n    transform: translateY(-50%) !important;\r\n    min-width: 10px !important;\r\n\r\n    .btn-icon-vertical .btn-icon-wrapper {\r\n      display: none;\r\n    }\r\n\r\n  }\r\n\r\n  .popover {\r\n    max-width: initial;\r\n\r\n    .arrow {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  .app-page-title {\r\n    text-align: center;\r\n\r\n    .page-title-heading,\r\n    .page-title-wrapper {\r\n      margin: 0 auto;\r\n      display: block;\r\n    }\r\n\r\n    .page-title-actions {\r\n      margin: math.div($grid-gutter-width, 2) auto 0;\r\n    }\r\n\r\n    .page-title-actions,\r\n    .page-title-subheading {\r\n      .breadcrumb-item,\r\n      .breadcrumb {\r\n        display: inline-block;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Footer\r\n\r\n  .app-footer .app-footer__inner {\r\n    .app-footer-right {\r\n      display: none;\r\n    }\r\n\r\n    .app-footer-left {\r\n      width: 100%;\r\n\r\n      .footer-dots {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fixed-footer {\r\n    &.closed-sidebar {\r\n      .app-footer {\r\n        .app-footer__inner {\r\n          margin-left: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Components\r\n\r\n  .widget-content {\r\n    .widget-numbers {\r\n      font-size: 1.6rem;\r\n      line-height: 1;\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 650px !important;\r\n    }\r\n  }\r\n\r\n  .body-tabs.body-tabs-layout {\r\n    &.body-tabs-big {\r\n      display: block !important;\r\n\r\n      .RRT__tab {\r\n        display: inline-block !important;\r\n        padding: 0 $layout-spacer-x !important;\r\n      }\r\n\r\n      .RRT__showmore {\r\n        margin-top: -20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ReactTable .-pagination {\r\n    .-center {\r\n      display: none;\r\n    }\r\n\r\n    .-previous {\r\n      padding-right: 3px;\r\n    }\r\n  }\r\n\r\n  .bg-transparent.list-group-item {\r\n    border-color: transparent;\r\n  }\r\n\r\n  .tabs-lg-alternate.card-header {\r\n\r\n    & > .nav .nav-item {\r\n      .widget-number {\r\n        font-size: 1.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .page-title-head {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-between(xs, md) {\r\n\r\n  .app-page-title .page-title-icon,\r\n  .ui-theme-settings {\r\n    display: none;\r\n  }\r\n\r\n  .card-header {\r\n    &.responsive-center {\r\n      display: block;\r\n      text-align: center;\r\n      height: auto;\r\n      padding: $layout-spacer-x;\r\n\r\n      .nav,\r\n      .btn-actions-pane-right {\r\n        margin: math.div($layout-spacer-x, 2) 0 0;\r\n\r\n        .d-inline-block.ml-2 {\r\n          width: 100% !important;\r\n          text-align: left;\r\n          margin: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 650px !important;\r\n    }\r\n  }\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 850px !important;\r\n    }\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n\r\n  .-hide-paging .-pagination .-center {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n  .app-main .app-main__inner {\r\n    padding: 15px 15px 0;\r\n  }\r\n\r\n  .mbg-3,\r\n  body .card.mb-3 {\r\n    margin-bottom: math.div($grid-gutter-width, 2) !important;\r\n  }\r\n\r\n  .app-page-title {\r\n    padding: math.div($grid-gutter-width, 2);\r\n    margin: (-(math.div($grid-gutter-width, 2))) (-(math.div($grid-gutter-width, 2))) $grid-gutter-width;\r\n  }\r\n\r\n  .body-tabs.body-tabs-layout {\r\n    margin-left: (-(math.div($grid-gutter-width, 2)));\r\n    margin-right: (-(math.div($grid-gutter-width, 2)));\r\n    padding: 0 math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\r\n    margin-top: math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .popover,\r\n  .dropdown-menu {\r\n    width: 80%;\r\n    left: 10%;\r\n  }\r\n\r\n  body .card-header {\r\n    height: auto;\r\n    display: block;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    text-align: center;\r\n\r\n    .btn-actions-pane-right {\r\n      padding: math.div($layout-spacer-x, 2) 0 0;\r\n    }\r\n\r\n    .actions-icon-btn {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .card-header {\r\n    &.card-header-tab {\r\n      .card-header-title {\r\n        display: inline-flex !important;\r\n        line-height: 1;\r\n      }\r\n\r\n      & > .nav {\r\n        margin: math.div($layout-spacer-x, 2) 0 (-(math.div($layout-spacer-x, 2)));\r\n        display: table !important;\r\n        width: 100%;\r\n\r\n        .nav-item {\r\n          display: table-cell;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .header-icon {\r\n    display: none;\r\n  }\r\n\r\n  .profile-responsive-sm,\r\n  .profile-responsive {\r\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\r\n      display: block;\r\n      text-align: center;\r\n\r\n      .avatar-icon-wrapper {\r\n        margin-right: 0 !important;\r\n      }\r\n\r\n      .menu-header-btn-pane {\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm .slick-slider .slick-prev {\r\n    left: math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .slick-slider-sm .slick-slider .slick-next {\r\n    right: math.div($grid-gutter-width, 2);\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\r\n  .profile-responsive {\r\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\r\n      display: block;\r\n      text-align: center;\r\n\r\n      .avatar-icon-wrapper {\r\n        margin-right: 0 !important;\r\n      }\r\n\r\n      .menu-header-btn-pane {\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
